
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4jplB", function(module, exports) {
/**
 * @generated SignedSource<<c0556b57221609bd9cab7615e29b73cc>>
 * @relayHash 0e5febadf148cca119a3a0d78cb36fef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81fd6afd89e473aab00d07efa1a7ca5e6dc192c9fac1e00f986fb5eef38e2d47
const $6a4b6bfe2e3e4030$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resultCount"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timestamp"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        },
                        {
                            "kind": "Variable",
                            "name": "resultCount",
                            "variableName": "resultCount"
                        },
                        {
                            "kind": "Variable",
                            "name": "timestamp",
                            "variableName": "timestamp"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceGenerateSearchPerformedEventPayload",
            "kind": "LinkedField",
            "name": "confluence_generateSearchPerformedEvent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "QuickFindSearchPerformedEventMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "QuickFindSearchPerformedEventMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0e5febadf148cca119a3a0d78cb36fef",
            "id": "81fd6afd89e473aab00d07efa1a7ca5e6dc192c9fac1e00f986fb5eef38e2d47",
            "metadata": {},
            "name": "QuickFindSearchPerformedEventMutation",
            "operationKind": "mutation",
            "text": "mutation QuickFindSearchPerformedEventMutation($cloudId:ID!,$resultCount:Int!,$query:String!,$timestamp:String!){confluence_generateSearchPerformedEvent(cloudId:$cloudId,input:{resultCount:$resultCount,query:$query,timestamp:$timestamp}){success}}"
        }
    };
}();
$6a4b6bfe2e3e4030$var$node.hash = "3d3d464aa097e75cea744ba09799dccd";
var $6a4b6bfe2e3e4030$export$2e2bcd8739ae039 = $6a4b6bfe2e3e4030$var$node;



var $42omo = parcelRequire("42omo");


var $b1Jpy = parcelRequire("b1Jpy");


var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");





var $aXWIB = parcelRequire("aXWIB");


var $dpPtd = parcelRequire("dpPtd");


var $if5rb = parcelRequire("if5rb");


var $8zs3p = parcelRequire("8zs3p");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $bWLcG = parcelRequire("bWLcG");

var $ecnYn = parcelRequire("ecnYn");


var $hnvzE = parcelRequire("hnvzE");


var $gWF6I = parcelRequire("gWF6I");


var $icqFF = parcelRequire("icqFF");


var $4OGlb = parcelRequire("4OGlb");


var $1yEFx = parcelRequire("1yEFx");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $a9fb8805b1f49851$export$7640e1e223f51f1a = 'referrer';



var $9rRKJ = parcelRequire("9rRKJ");


var $7WbA8 = parcelRequire("7WbA8");


var $2lmJQ = parcelRequire("2lmJQ");


var $2ok43 = parcelRequire("2ok43");


var $86ob4 = parcelRequire("86ob4");


var $2OtFZ = parcelRequire("2OtFZ");


var $26jni = parcelRequire("26jni");


var $RWXHe = parcelRequire("RWXHe");


var $aN48i = parcelRequire("aN48i");





function $0cd41d31d45cf5ea$export$2811a6cefe42670b(generateSearchUrl = (0, $aN48i.defaultGenerateSearchUrl)) {
    try {
        const searchPath = new URL(generateSearchUrl({})).pathname;
        const currentPath = new URL(window.location.href).pathname;
        return searchPath === currentPath;
    } catch  {
        return undefined;
    }
}
function $0cd41d31d45cf5ea$export$98262e13018313b(destinationUrl, generateSearchUrl = (0, $aN48i.defaultGenerateSearchUrl)) {
    try {
        const searchPath = new URL(generateSearchUrl({})).pathname;
        const destinationPath = new URL(destinationUrl, window.location.href).pathname;
        return searchPath === destinationPath;
    } catch  {
        return undefined;
    }
}






var $jTxSS = parcelRequire("jTxSS");














var $gdv5Z = parcelRequire("gdv5Z");











var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");


var $def8z = parcelRequire("def8z");

// Code taken from: platform/packages/ai-mate/conversation-assistant-utils/src/common/hooks/usePostOfficePlacement.ts




const $3b40788e1fe81951$export$b9e056b3d42aef4 = ()=>{
    const [PostOfficePlacement, setPostOfficePlacement] = (0, $42omo.useState)(null);
    const [isMounted, setIsMounted] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            let isComponentMounted = true;
            // Check for mock in test environments (set by VR test)
            const mockModule = window.__mockPostOfficePlacement__;
            if (mockModule) {
                setPostOfficePlacement(()=>mockModule);
                setIsMounted(true);
                return;
            }
            (parcelRequire("2fSa3")).then((module)=>{
                if (isComponentMounted) {
                    setPostOfficePlacement(()=>module.Placement);
                    setIsMounted(true);
                }
            }).catch(()=>{
                // Silently fail if import fails - PostOfficePlacement will remain null
                // This prevents the component from being stuck in a loading state
                if (isComponentMounted) setIsMounted(true);
            });
            return ()=>{
                isComponentMounted = false;
            };
        }
    }, []);
    return {
        PostOfficePlacement: PostOfficePlacement,
        isMounted: isMounted
    };
};


const $9eb6b8b0a2d39d01$export$d6ffb4087f856769 = (configs, availableProductsOrder)=>{
    const ordered = {};
    for (const productKey of availableProductsOrder){
        const config = configs[productKey];
        if (config) ordered[productKey] = config;
    }
    return ordered;
};
const $9eb6b8b0a2d39d01$export$9c15322f536ac91d = (configs)=>{
    const entries = Object.entries(configs).filter((entry)=>{
        const [productKey, config] = entry;
        return (0, $b4tvS.is3pProductKey)(productKey) && config != null && config.outboundAuthUrl != null;
    });
    return entries.map(([productKey, config], index)=>{
        const isSmartlink = (0, $def8z.isProductSmartlink)({
            productKey: productKey,
            thirdPartyConfigs: configs
        });
        const connectorName = typeof config.displayName === 'string' ? config.displayName : '';
        return {
            connectorId: config.id,
            connectorIndex: index,
            connectorMode: isSmartlink ? (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE) : (0, $9d9t8.FULL_CONNECTOR_SOURCE),
            connectorName: connectorName,
            connectorProductKey: productKey,
            icon: config.icon,
            oAuthUrl: config.outboundAuthUrl,
            userNeedsOAuth: config.userNeedsOAuth ?? false
        };
    });
};
const $9eb6b8b0a2d39d01$export$a26b2af93a17c1d9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { placementId: placementId, thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, onMessageViewed: onMessageViewed } = t0;
    const { PostOfficePlacement: PostOfficePlacement, isMounted: isMounted } = (0, $3b40788e1fe81951$export$b9e056b3d42aef4)();
    let t1;
    if ($[0] !== availableProductsOrder || $[1] !== thirdPartyConfigs) {
        t1 = $9eb6b8b0a2d39d01$export$d6ffb4087f856769(thirdPartyConfigs, availableProductsOrder);
        $[0] = availableProductsOrder;
        $[1] = thirdPartyConfigs;
        $[2] = t1;
    } else t1 = $[2];
    const orderedConfigs = t1;
    let t2;
    if ($[3] !== orderedConfigs) {
        t2 = $9eb6b8b0a2d39d01$export$9c15322f536ac91d(orderedConfigs);
        $[3] = orderedConfigs;
        $[4] = t2;
    } else t2 = $[4];
    const availableConnectors = t2;
    let t3;
    if ($[5] !== availableConnectors || $[6] !== onMessageViewed || $[7] !== useOAuthHandlers) {
        t3 = {
            availableConnectors: availableConnectors,
            useOAuthHandlers: useOAuthHandlers,
            onMessageViewed: onMessageViewed
        };
        $[5] = availableConnectors;
        $[6] = onMessageViewed;
        $[7] = useOAuthHandlers;
        $[8] = t3;
    } else t3 = $[8];
    const placementProps = t3;
    if (!isMounted || !PostOfficePlacement) return null;
    let t4;
    if ($[9] !== PostOfficePlacement || $[10] !== placementId || $[11] !== placementProps) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PostOfficePlacement, {
            placementId: placementId,
            placementProps: placementProps
        });
        $[9] = PostOfficePlacement;
        $[10] = placementId;
        $[11] = placementProps;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ placementId: placementId, thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, onMessageViewed: onMessageViewed })=>{
    const { PostOfficePlacement: PostOfficePlacement, isMounted: isMounted } = (0, $3b40788e1fe81951$export$b9e056b3d42aef4)();
    const orderedConfigs = (0, $42omo.useMemo)(()=>$9eb6b8b0a2d39d01$export$d6ffb4087f856769(thirdPartyConfigs, availableProductsOrder), [
        thirdPartyConfigs,
        availableProductsOrder
    ]);
    const availableConnectors = (0, $42omo.useMemo)(()=>$9eb6b8b0a2d39d01$export$9c15322f536ac91d(orderedConfigs), [
        orderedConfigs
    ]);
    // the props passed into the placement
    const placementProps = {
        availableConnectors: availableConnectors,
        useOAuthHandlers: useOAuthHandlers,
        onMessageViewed: onMessageViewed
    };
    if (!isMounted || !PostOfficePlacement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PostOfficePlacement, {
        placementId: placementId,
        placementProps: placementProps
    });
};


const $96ab4c87f539b225$export$da42c48b16873c83 = 'search-page-results-quick-find';


const $46d65c685f7374c2$var$styles = {
    container: "_n3td12x7 _19bvu2gc _u5f3u2gc"
};
const $46d65c685f7374c2$export$f7ad73a4588a04e6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, onMessageViewed: onMessageViewed } = t0;
    let t1;
    if ($[0] !== availableProductsOrder || $[1] !== onMessageViewed || $[2] !== thirdPartyConfigs || $[3] !== useOAuthHandlers) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $46d65c685f7374c2$var$styles.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9eb6b8b0a2d39d01$export$a26b2af93a17c1d9), {
            placementId: (0, $96ab4c87f539b225$export$da42c48b16873c83),
            thirdPartyConfigs: thirdPartyConfigs,
            availableProductsOrder: availableProductsOrder,
            useOAuthHandlers: useOAuthHandlers,
            onMessageViewed: onMessageViewed
        }));
        $[0] = availableProductsOrder;
        $[1] = onMessageViewed;
        $[2] = thirdPartyConfigs;
        $[3] = useOAuthHandlers;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, onMessageViewed: onMessageViewed })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $46d65c685f7374c2$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9eb6b8b0a2d39d01$export$a26b2af93a17c1d9), {
        placementId: (0, $96ab4c87f539b225$export$da42c48b16873c83),
        thirdPartyConfigs: thirdPartyConfigs,
        availableProductsOrder: availableProductsOrder,
        useOAuthHandlers: useOAuthHandlers,
        onMessageViewed: onMessageViewed
    }));
};



var $gGFxq = parcelRequire("gGFxq");











var $6RGiC = parcelRequire("6RGiC");


var $eO6NY = parcelRequire("eO6NY");


var $j4ply = parcelRequire("j4ply");

const $4738a89b77564390$export$88d19ca4a35e5eb5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (isInteracted)=>{
    const $ = (0, $frIzR.c)(7);
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isJira = primaryProduct === (0, $1yEFx.ProductKeys).Jira;
    let t0;
    if ($[0] !== availableProducts || $[1] !== thirdPartyConfigs) {
        t0 = {
            isOnSearchDialog: true,
            thirdPartyConfigs: thirdPartyConfigs,
            availableProducts: availableProducts
        };
        $[0] = availableProducts;
        $[1] = thirdPartyConfigs;
        $[2] = t0;
    } else t0 = $[2];
    const bannerEligibleProductsOrder = (0, $eO6NY.useBannerEligibleProductsOrder)(t0);
    const suppressBanner = (0, $6RGiC.useShouldSuppressBannerForAnimation)();
    const hasBannerEligibleProducts = bannerEligibleProductsOrder.length > 0;
    const shouldMountPlacement = hasBannerEligibleProducts && (isInteracted || isJira) && !suppressBanner;
    let t1;
    if ($[3] !== bannerEligibleProductsOrder || $[4] !== shouldMountPlacement || $[5] !== thirdPartyConfigs) {
        t1 = {
            thirdPartyConfigs: thirdPartyConfigs,
            bannerEligibleProductsOrder: bannerEligibleProductsOrder,
            shouldMountPlacement: shouldMountPlacement
        };
        $[3] = bannerEligibleProductsOrder;
        $[4] = shouldMountPlacement;
        $[5] = thirdPartyConfigs;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : (isInteracted)=>{
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    // In Jira, the quick find component is already rendered on hover, so isInteracted is not needed.
    const isJira = primaryProduct === (0, $1yEFx.ProductKeys).Jira;
    const bannerEligibleProductsOrder = (0, $eO6NY.useBannerEligibleProductsOrder)({
        isOnSearchDialog: true,
        thirdPartyConfigs: thirdPartyConfigs,
        availableProducts: availableProducts
    });
    const suppressBanner = (0, $6RGiC.useShouldSuppressBannerForAnimation)();
    const hasBannerEligibleProducts = bannerEligibleProductsOrder.length > 0;
    const shouldMountPlacement = hasBannerEligibleProducts && (isInteracted || isJira) && !suppressBanner;
    return {
        thirdPartyConfigs: thirdPartyConfigs,
        bannerEligibleProductsOrder: bannerEligibleProductsOrder,
        shouldMountPlacement: shouldMountPlacement
    };
};


const $9e8ae9dcabcd78a5$export$eb1f26e9ffd464b = /*#__PURE__*/ (0, $42omo.memo)(({ onBannerMessageViewed: onBannerMessageViewed, isInteracted: isInteracted })=>{
    const portalContainer = (0, $RWXHe.usePlacementPortalContainer)();
    const { thirdPartyConfigs: thirdPartyConfigs, bannerEligibleProductsOrder: bannerEligibleProductsOrder, shouldMountPlacement: shouldMountPlacement } = (0, $4738a89b77564390$export$88d19ca4a35e5eb5)(isInteracted);
    if (!shouldMountPlacement || !portalContainer) return null;
    // Render the Quick Find banner placement into the dialog's portal container so the
    // placement is mounted when results are shown, without changing the main results DOM.
    return /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $46d65c685f7374c2$export$f7ad73a4588a04e6), {
        thirdPartyConfigs: thirdPartyConfigs,
        availableProductsOrder: bannerEligibleProductsOrder,
        useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
        onMessageViewed: onBannerMessageViewed
    }), portalContainer);
});



















var $9Wtw1 = parcelRequire("9Wtw1");


const $a295deffd24a91d3$export$5b496c438700a088 = 'rovo-search-page-quick-find-3p-connector-pre-auth-nudge';



const $4fb011b1c09bb25d$var$loadQuickFindHeadlessRenderer = ()=>(parcelRequire("6bBtb"));
const $4fb011b1c09bb25d$var$QuickFindHeadlessMessageRenderer = Object.assign(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>$4fb011b1c09bb25d$var$loadQuickFindHeadlessRenderer().then((module)=>({
            default: module.QuickFindHeadlessMessageRenderer
        }))), {
    displayName: 'lazy(QuickFindHeadlessMessageRenderer)'
});
const $4fb011b1c09bb25d$var$QuickFindHeadlessPlacementContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $4fb011b1c09bb25d$export$f021c2a95c252193 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { placementId: placementId, thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, children: children } = t0;
    let t1;
    if ($[0] !== placementId) {
        t1 = {
            placementId: placementId,
            messageTemplateId: (0, $a295deffd24a91d3$export$5b496c438700a088)
        };
        $[0] = placementId;
        $[1] = t1;
    } else t1 = $[1];
    const { messages: messages, dismissMessage: dismissMessage, PostOfficeMessageInstance: PostOfficeMessageInstance } = (0, $9Wtw1.useMessageInstances)(t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[2] = t2;
    } else t2 = $[2];
    (0, $42omo.useEffect)($4fb011b1c09bb25d$var$_temp, t2);
    let t3;
    if ($[3] !== availableProductsOrder || $[4] !== thirdPartyConfigs) {
        t3 = (0, $9eb6b8b0a2d39d01$export$d6ffb4087f856769)(thirdPartyConfigs, availableProductsOrder);
        $[3] = availableProductsOrder;
        $[4] = thirdPartyConfigs;
        $[5] = t3;
    } else t3 = $[5];
    const orderedConfigs = t3;
    let t4;
    if ($[6] !== orderedConfigs) {
        t4 = (0, $9eb6b8b0a2d39d01$export$9c15322f536ac91d)(orderedConfigs);
        $[6] = orderedConfigs;
        $[7] = t4;
    } else t4 = $[7];
    const availableConnectors = t4;
    let t5;
    if ($[8] !== PostOfficeMessageInstance || $[9] !== availableConnectors || $[10] !== dismissMessage || $[11] !== messages || $[12] !== useOAuthHandlers) {
        t5 = {
            messages: messages,
            availableConnectors: availableConnectors,
            useOAuthHandlers: useOAuthHandlers,
            dismissMessage: dismissMessage,
            PostOfficeMessageInstance: PostOfficeMessageInstance
        };
        $[8] = PostOfficeMessageInstance;
        $[9] = availableConnectors;
        $[10] = dismissMessage;
        $[11] = messages;
        $[12] = useOAuthHandlers;
        $[13] = t5;
    } else t5 = $[13];
    const value = t5;
    let t6;
    if ($[14] !== children || $[15] !== value) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fb011b1c09bb25d$var$QuickFindHeadlessPlacementContext.Provider, {
            value: value
        }, children);
        $[14] = children;
        $[15] = value;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ placementId: placementId, thirdPartyConfigs: thirdPartyConfigs, availableProductsOrder: availableProductsOrder, useOAuthHandlers: useOAuthHandlers, children: children })=>{
    const { messages: messages, dismissMessage: dismissMessage, PostOfficeMessageInstance: PostOfficeMessageInstance } = (0, $9Wtw1.useMessageInstances)({
        placementId: placementId,
        messageTemplateId: (0, $a295deffd24a91d3$export$5b496c438700a088)
    });
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('post-office_enable_search-quick-find-headless')) return;
        $4fb011b1c09bb25d$var$loadQuickFindHeadlessRenderer();
    }, []);
    const orderedConfigs = (0, $42omo.useMemo)(()=>(0, $9eb6b8b0a2d39d01$export$d6ffb4087f856769)(thirdPartyConfigs, availableProductsOrder), [
        thirdPartyConfigs,
        availableProductsOrder
    ]);
    const availableConnectors = (0, $42omo.useMemo)(()=>(0, $9eb6b8b0a2d39d01$export$9c15322f536ac91d)(orderedConfigs), [
        orderedConfigs
    ]);
    const value = (0, $42omo.useMemo)(()=>({
            messages: messages,
            availableConnectors: availableConnectors,
            useOAuthHandlers: useOAuthHandlers,
            dismissMessage: dismissMessage,
            PostOfficeMessageInstance: PostOfficeMessageInstance
        }), [
        messages,
        availableConnectors,
        useOAuthHandlers,
        dismissMessage,
        PostOfficeMessageInstance
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fb011b1c09bb25d$var$QuickFindHeadlessPlacementContext.Provider, {
        value: value
    }, children);
};
const $4fb011b1c09bb25d$export$10bc17e539691718 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(13);
    const placement = (0, $42omo.useContext)($4fb011b1c09bb25d$var$QuickFindHeadlessPlacementContext);
    if (!placement) return null;
    const { messages: messages, availableConnectors: availableConnectors, useOAuthHandlers: useOAuthHandlers, dismissMessage: dismissMessage, PostOfficeMessageInstance: PostOfficeMessageInstance } = placement;
    let t0;
    if ($[0] !== PostOfficeMessageInstance || $[1] !== availableConnectors || $[2] !== dismissMessage || $[3] !== messages || $[4] !== useOAuthHandlers) {
        let t1;
        if ($[6] !== PostOfficeMessageInstance || $[7] !== availableConnectors || $[8] !== dismissMessage || $[9] !== useOAuthHandlers) {
            t1 = (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fb011b1c09bb25d$var$QuickFindHeadlessMessageRenderer, {
                    key: message.messageInstanceId,
                    message: message,
                    availableConnectors: availableConnectors,
                    useOAuthHandlers: useOAuthHandlers,
                    dismissMessage: dismissMessage,
                    PostOfficeMessageInstance: PostOfficeMessageInstance
                });
            $[6] = PostOfficeMessageInstance;
            $[7] = availableConnectors;
            $[8] = dismissMessage;
            $[9] = useOAuthHandlers;
            $[10] = t1;
        } else t1 = $[10];
        t0 = messages.map(t1);
        $[0] = PostOfficeMessageInstance;
        $[1] = availableConnectors;
        $[2] = dismissMessage;
        $[3] = messages;
        $[4] = useOAuthHandlers;
        $[5] = t0;
    } else t0 = $[5];
    let t1;
    if ($[11] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, t0);
        $[11] = t0;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : ()=>{
    const placement = (0, $42omo.useContext)($4fb011b1c09bb25d$var$QuickFindHeadlessPlacementContext);
    if (!placement) return null;
    const { messages: messages, availableConnectors: availableConnectors, useOAuthHandlers: useOAuthHandlers, dismissMessage: dismissMessage, PostOfficeMessageInstance: PostOfficeMessageInstance } = placement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, messages.map((message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fb011b1c09bb25d$var$QuickFindHeadlessMessageRenderer, {
            key: message.messageInstanceId,
            message: message,
            availableConnectors: availableConnectors,
            useOAuthHandlers: useOAuthHandlers,
            dismissMessage: dismissMessage,
            PostOfficeMessageInstance: PostOfficeMessageInstance
        })));
};
function $4fb011b1c09bb25d$var$_temp() {
    if (!(0, $dh538.fg)("post-office_enable_search-quick-find-headless")) return;
    $4fb011b1c09bb25d$var$loadQuickFindHeadlessRenderer();
}






const $3d288faa8cd311c0$export$6f38235f6fa1e5b1 = ({ children: children, isInteracted: isInteracted })=>{
    const { thirdPartyConfigs: thirdPartyConfigs, bannerEligibleProductsOrder: bannerEligibleProductsOrder, shouldMountPlacement: shouldMountPlacement } = (0, $4738a89b77564390$export$88d19ca4a35e5eb5)(isInteracted);
    if (!shouldMountPlacement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4fb011b1c09bb25d$export$f021c2a95c252193), {
        placementId: (0, $96ab4c87f539b225$export$da42c48b16873c83),
        thirdPartyConfigs: thirdPartyConfigs,
        availableProductsOrder: bannerEligibleProductsOrder,
        useOAuthHandlers: (0, $gGFxq.useOAuthHandlers)
    }, children);
};












var $6a9Hv = parcelRequire("6a9Hv");





var $c6GJD = parcelRequire("c6GJD");





var $59vy4 = parcelRequire("59vy4");


var $jwO5V = parcelRequire("jwO5V");


var $czt8s = parcelRequire("czt8s");





var $iA4lt = parcelRequire("iA4lt");


var $hdfeV = parcelRequire("hdfeV");


var $6yNqK = parcelRequire("6yNqK");


var $3fAff = parcelRequire("3fAff");


var $fuGkE = parcelRequire("fuGkE");




var $6Gsan = parcelRequire("6Gsan");





var $dmTG5 = parcelRequire("dmTG5");


var $cFN1h = parcelRequire("cFN1h");


var $PVo4u = parcelRequire("PVo4u");


var $3htW4 = parcelRequire("3htW4");


var $5qcsY = parcelRequire("5qcsY");


var $31eSD = parcelRequire("31eSD");


var $bQSQw = parcelRequire("bQSQw");










const $b46a7e00048d637e$export$777e9d6bae4c913e = ()=>{
    const cohort = (0, $c6GJD.default).getExperimentValue('enable_github_links_hydration_in_quickfind_recent', 'cohort', 'control', {
        fireExperimentExposure: false
    });
    return cohort === 'test';
};



var $jjjIy = parcelRequire("jjjIy");


var $4tgkZ = parcelRequire("4tgkZ");

// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

async function $cf5ef1e7c875b308$export$45bde04e7d1842b0(asyncFunction) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const markName = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
    performance.mark(`${markName}-start`);
    const result = await asyncFunction();
    performance.mark(`${markName}-end`);
    performance.measure(markName, `${markName}-start`, `${markName}-end`);
    const measure = performance.getEntriesByName(markName)[0];
    const duration = measure.duration;
    // Clear the marks and measure to avoid memory leaks
    performance.clearMarks(`${markName}-start`);
    performance.clearMarks(`${markName}-end`);
    performance.clearMeasures(markName);
    return {
        result: result,
        duration: duration
    };
}



var $9wmQG = parcelRequire("9wmQG");

const $3746cfd8500fe3df$export$932440ee05101c0d = ({ success: success, attributes: attributes, resultsType: resultsType })=>({
        eventType: 'operational',
        action: success ? 'taskSuccess' : 'taskFail',
        actionSubject: 'ui',
        attributes: {
            ...attributes,
            // This edition is not exact matching the need for the AutoHots
            // A follow up is to find the current primary product edition and log that.
            // Currently we only have confluence edition in the productEdition object, so logging the entire object for now.
            edition: attributes.productEdition,
            task: 'unifiedSearch',
            capability: `quickFind_${resultsType}`,
            // Confirmed with AutoHots team this is mandatory
            // and base on "Can I log this" doc, we can log this.
            // https://hello.atlassian.net/wiki/spaces/Monitoring/pages/5816497997/Vitalstats+Onboarding+contract?focusedCommentId=5864073069
            // https://hello.atlassian.net/wiki/spaces/SECURITY/pages/236070634/Can+I+Log+This
            hostname: window.location.hostname
        }
    });


const $e1a1aba41a097938$export$2d1da932f40a427e = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, resultsType: resultsType })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'searchResults',
        actionSubjectId: resultsType,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $4b1cc554b296ee78$export$9698f7c8e7c9a2f7 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'suggestedQueries',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });



var $aE5mL = parcelRequire("aE5mL");


var $6FG5J = parcelRequire("6FG5J");

const $1d2671f5d43d8750$var$ZeroQueryTypesV0 = [
    (0, $6FG5J.ZeroQueryType).RECENT_WORK,
    (0, $6FG5J.ZeroQueryType).RELATED_QUESTION,
    (0, $6FG5J.ZeroQueryType).WHO_IS
];
const $1d2671f5d43d8750$var$ZeroQueryTypesV1 = [
    (0, $6FG5J.ZeroQueryType).COLLABORATOR_PROFILE,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_30_DAYS,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_7_DAYS,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS,
    (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS,
    (0, $6FG5J.ZeroQueryType).JIRA_MY_WORK_ITEMS,
    (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
    (0, $6FG5J.ZeroQueryType).JIRA_NLQ_COLLABORATOR,
    (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_ASSIGNED,
    (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_ASSIGNED_COLLABORATOR,
    (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_CREATED,
    (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_CREATED_COLLABORATOR,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_MY_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_MY_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_MY_MESSAGES
];
const $1d2671f5d43d8750$var$ZeroQueryTypes3P = [
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_MY_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_MY_DOCS,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES,
    (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_MY_MESSAGES
];
const $1d2671f5d43d8750$export$2378e9e94d0e91e3 = (zeroQueryType)=>{
    if ($1d2671f5d43d8750$var$ZeroQueryTypesV0.includes(zeroQueryType)) return 0;
    else if ($1d2671f5d43d8750$var$ZeroQueryTypesV1.includes(zeroQueryType)) return 1;
    return null;
};
const $1d2671f5d43d8750$export$6da79ec281e5bbf3 = (zeroQueryType)=>$1d2671f5d43d8750$var$ZeroQueryTypes3P.includes(zeroQueryType);



var $kQT7c = parcelRequire("kQT7c");


var $JQd0k = parcelRequire("JQd0k");














var $5nBzc = parcelRequire("5nBzc");







var $dcJ7R = parcelRequire("dcJ7R");




var $5TXU5 = parcelRequire("5TXU5");


var $gzcCN = parcelRequire("gzcCN");


var $hWR4v = parcelRequire("hWR4v");


var $icWhS = parcelRequire("icWhS");


var $bloXB = parcelRequire("bloXB");











var $bbJes = parcelRequire("bbJes");





var $i7jPX = parcelRequire("i7jPX");

const $dbff52abefb1bfa8$var$styles = {
    base: "_syazazsu"
};
const $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { size: t1, label: t2 } = t0;
    const size = t1 === undefined ? "small" : t1;
    const label = t2 === undefined ? "" : t2;
    let t3;
    if ($[0] !== label) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bbJes))), {
            label: label
        });
        $[0] = label;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== size || $[3] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $dbff52abefb1bfa8$var$styles.base
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            size: size
        }, t3));
        $[2] = size;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : ({ size: size = 'small', label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $dbff52abefb1bfa8$var$styles.base
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: "",
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bbJes))), {
        label: label
    })));











var $9kYXz = parcelRequire("9kYXz");


var $3E8x9 = parcelRequire("3E8x9");


var $i6Ooe = parcelRequire("i6Ooe");


var $2waBy = parcelRequire("2waBy");


var $aRSt4 = parcelRequire("aRSt4");










const $c778002e02670657$export$6500cdbd153f3497 = (item)=>{
    return item.type === 'error';
};
const $c778002e02670657$export$6dc914a1cb2e7113 = (item)=>{
    return item.type === 'landing';
};
const $c778002e02670657$export$993e95eb6704a94c = (item)=>{
    return item.type === 'no-results';
};
const $c778002e02670657$export$9050e45a166250f = (item)=>{
    return item.type === 'heading';
};
const $c778002e02670657$export$d680994c1f15882e = (item)=>{
    return item.type === 'skeleton';
};
const $c778002e02670657$export$871ba967042323cb = (item)=>{
    return item.type === 'recent-query';
};
const $c778002e02670657$export$57fb632bdb82e6e6 = (item)=>{
    return item.type === 'autocomplete-suggestion';
};
const $c778002e02670657$export$99edcb23f38a2d86 = (item)=>{
    return item.type === 'zero-query';
};
const $c778002e02670657$export$329ac1434313f6b2 = (item)=>{
    return item.type === 'recent-activity';
};
const $c778002e02670657$export$579664463eebdcd8 = (item)=>{
    return item.type === 'recommended-document';
};
const $c778002e02670657$export$746233dd1618793c = (item)=>{
    return item.type === 'search-result';
};
const $c778002e02670657$export$bc8d42212d76a15c = (item)=>{
    return item.type === 'people-and-teams';
};
const $c778002e02670657$export$35bb43147cd35a68 = (item)=>{
    return item.type === 'filter-suggestion';
};


const $39181c35e6b4cafd$var$ItemsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $39181c35e6b4cafd$var$isItemCountable = (item)=>(0, $c778002e02670657$export$746233dd1618793c)(item) || (0, $c778002e02670657$export$579664463eebdcd8)(item) || (0, $c778002e02670657$export$329ac1434313f6b2)(item) || (0, $c778002e02670657$export$bc8d42212d76a15c)(item);
const $39181c35e6b4cafd$var$isHeading = (item)=>(0, $c778002e02670657$export$9050e45a166250f)(item);
const $39181c35e6b4cafd$var$getItemsAndSectionsCount = (allItems)=>allItems.reduce(({ resultCount: resultCount, sectionCount: sectionCount }, item, currentIndex)=>{
        if ($39181c35e6b4cafd$var$isItemCountable(item)) resultCount++;
        if (currentIndex === 0 && !$39181c35e6b4cafd$var$isHeading(item)) // if the first item is not heading, we consider it in a section
        sectionCount++;
        if ($39181c35e6b4cafd$var$isHeading(item)) sectionCount++;
        return {
            resultCount: resultCount,
            sectionCount: sectionCount
        };
    }, {
        resultCount: 0,
        sectionCount: 0
    });
const $39181c35e6b4cafd$export$a511f36416966245 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const ctx = (0, $42omo.useContext)($39181c35e6b4cafd$var$ItemsContext);
    if (!ctx) throw new Error("useItemsAnalyticsContext must be used within ItemsAnalyticsProvider");
    return ctx;
} : ()=>{
    const ctx = (0, $42omo.useContext)($39181c35e6b4cafd$var$ItemsContext);
    if (!ctx) // We throw an error here to make sure the hook is used within the provider,
    // otherwise it would return undefined and cause runtime errors and is hard to debug
    throw new Error('useItemsAnalyticsContext must be used within ItemsAnalyticsProvider');
    return ctx;
};
const $39181c35e6b4cafd$export$5643dbed0288c870 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { allItems: allItems, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Set();
        $[0] = t1;
    } else t1 = $[0];
    const invalidatedIdsRef = (0, $42omo.useRef)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            invalidatedIdsRef.current.clear();
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== allItems) {
        t3 = [
            allItems
        ];
        $[2] = allItems;
        $[3] = t3;
    } else t3 = $[3];
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (id)=>{
            invalidatedIdsRef.current.add(id);
        };
        $[4] = t4;
    } else t4 = $[4];
    const invalidateItem = t4;
    let t5;
    if ($[5] !== allItems) {
        t5 = $39181c35e6b4cafd$var$getItemsAndSectionsCount(allItems);
        $[5] = allItems;
        $[6] = t5;
    } else t5 = $[6];
    const { resultCount: resultCount, sectionCount: sectionCount } = t5;
    let t6;
    if ($[7] !== allItems || $[8] !== resultCount || $[9] !== sectionCount) {
        t6 = (id_0)=>{
            const item_0 = id_0 && !invalidatedIdsRef.current.has(id_0) ? allItems.find((item)=>item.id === id_0) : undefined;
            if (!item_0 || !$39181c35e6b4cafd$var$isItemCountable(item_0)) return;
            let globalIndex = -1;
            let sectionIndex = -1;
            let indexWithinSection = -1;
            let sectionId = "";
            const activeItems = allItems.filter((item_1)=>!invalidatedIdsRef.current.has(item_1.id));
            for(let i = 0; i < activeItems.length; i++)if ($39181c35e6b4cafd$var$isHeading(activeItems[i])) {
                sectionIndex++;
                indexWithinSection = -1;
                sectionId = activeItems[i].id;
            } else {
                if (i === 0) sectionIndex++;
                if ($39181c35e6b4cafd$var$isItemCountable(activeItems[i])) {
                    indexWithinSection++;
                    globalIndex++;
                }
                if (activeItems[i].id === id_0) return {
                    globalIndex: globalIndex,
                    sectionIndex: sectionIndex,
                    indexWithinSection: indexWithinSection,
                    resultCount: resultCount,
                    sectionCount: sectionCount,
                    sectionId: sectionId
                };
            }
        };
        $[7] = allItems;
        $[8] = resultCount;
        $[9] = sectionCount;
        $[10] = t6;
    } else t6 = $[10];
    const getItemIndexes = t6;
    let t7;
    if ($[11] !== getItemIndexes) {
        t7 = {
            invalidateItem: invalidateItem,
            getItemIndexes: getItemIndexes
        };
        $[11] = getItemIndexes;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== children || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($39181c35e6b4cafd$var$ItemsContext.Provider, {
            value: t7
        }, children);
        $[13] = children;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ({ allItems: allItems, children: children })=>{
    const invalidatedIdsRef = (0, $42omo.useRef)(new Set());
    (0, $42omo.useEffect)(()=>{
        // Reset invalidated IDs when allItems change, the items would call invalidateItem again if needed
        invalidatedIdsRef.current.clear();
    }, [
        allItems
    ]);
    const invalidateItem = (id)=>{
        invalidatedIdsRef.current.add(id);
    };
    const { resultCount: resultCount, sectionCount: sectionCount } = (0, $42omo.useMemo)(()=>$39181c35e6b4cafd$var$getItemsAndSectionsCount(allItems), [
        allItems
    ]);
    const getItemIndexes = (0, $42omo.useCallback)((id_0)=>{
        const item_0 = id_0 && !invalidatedIdsRef.current.has(id_0) ? allItems.find((item)=>item.id === id_0) : undefined;
        if (!item_0 || !$39181c35e6b4cafd$var$isItemCountable(item_0)) return undefined;
        let globalIndex = -1;
        let sectionIndex = -1;
        let indexWithinSection = -1;
        let sectionId = '';
        const activeItems = allItems.filter((item_1)=>!invalidatedIdsRef.current.has(item_1.id));
        for(let i = 0; i < activeItems.length; i++)if ($39181c35e6b4cafd$var$isHeading(activeItems[i])) {
            sectionIndex++;
            indexWithinSection = -1;
            sectionId = activeItems[i].id;
        } else {
            if (i === 0) // if the first item is not heading, we consider it in a section
            sectionIndex++;
            if ($39181c35e6b4cafd$var$isItemCountable(activeItems[i])) {
                indexWithinSection++;
                globalIndex++;
            }
            if (activeItems[i].id === id_0) return {
                globalIndex: globalIndex,
                sectionIndex: sectionIndex,
                indexWithinSection: indexWithinSection,
                resultCount: resultCount,
                sectionCount: sectionCount,
                sectionId: sectionId
            };
        }
        // if there is no match, return undefined
        return undefined;
    }, [
        allItems,
        resultCount,
        sectionCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($39181c35e6b4cafd$var$ItemsContext.Provider, {
        value: {
            invalidateItem: invalidateItem,
            getItemIndexes: getItemIndexes
        }
    }, children);
};

















var $2W0qg = parcelRequire("2W0qg");




var $26eSY = parcelRequire("26eSY");


var $9lW6K = parcelRequire("9lW6K");




const $161b4e5c9ce588f2$export$7cc7cea0c5a977c4 = 'intent-router-matching-work-item';



var $1VHLw = parcelRequire("1VHLw");





var $46mBC = parcelRequire("46mBC");


var $jAenQ = parcelRequire("jAenQ");


var $a7nUd = parcelRequire("a7nUd");


const $2944de3e13791145$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $2944de3e13791145$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'radius.large',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
});
const $2944de3e13791145$var$resultHoveredStlyes = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $2944de3e13791145$var$keyboardHighlightedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $2944de3e13791145$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $2944de3e13791145$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $2944de3e13791145$var$titleStyles = (0, $ecnYn.xcss)({
    overflow: 'clip',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $2944de3e13791145$var$metadataStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    font: 'font.body.small',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '13px',
    display: 'flex',
    alignItems: 'center',
    minWidth: '0'
});
const $2944de3e13791145$var$textOverflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $2944de3e13791145$var$rightSectionStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'space.150'
});
const $2944de3e13791145$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
    borderRadius: 'radius.large',
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':focus': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $2944de3e13791145$var$headingStyle = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    gap: 'space.075',
    alignItems: 'center',
    maxWidth: '100%',
    // Fix height to match titleStyles lineHeight so that inline
    // children with built-in margins (e.g. Tag) do not cause the row to grow taller.
    height: "var(--ds-space-200, 16px)"
});
const $2944de3e13791145$export$a2def421b23768aa = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(91);
    const { icon: icon, title: title, resultType: resultType, product: product, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, metadata: t1, rightMetadata: rightMetadata, hoveredRightMetadata: hoveredRightMetadata, highlightedRightMetadata: highlightedRightMetadata, url: url, isThirdParty: t2, highlightedTitle: highlightedTitle, includeInAnalytics: t3, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onResultHighlighted: onResultHighlighted, titleMetadataParts: titleMetadataParts, id: id, minutesSinceActivityTimestamp: minutesSinceActivityTimestamp, recentActivityEventType: recentActivityEventType, connectorType: connectorType, zeroQueryType: zeroQueryType } = t0;
    let t4;
    if ($[0] !== t1) {
        t4 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t4;
    } else t4 = $[1];
    const metadata = t4;
    const isThirdParty = t2 === undefined ? false : t2;
    const includeInAnalytics = t3 === undefined ? true : t3;
    const wrapperRef = (0, $42omo.useRef)(null);
    const ref = (0, $42omo.useRef)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { getItemIndexes: getItemIndexes } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    let t5;
    bb0: {
        if (resultType === "intentRouterWorkItem") {
            t5 = `${resultType}:${0, $161b4e5c9ce588f2$export$7cc7cea0c5a977c4}`;
            break bb0;
        }
        t5 = id ? `${resultType}:${id}` : null;
    }
    const navigationTrackingId = t5;
    let t6;
    if ($[2] !== primaryProduct || $[3] !== primarySubProduct) {
        t6 = {
            bridge: "quickFind",
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct
        };
        $[2] = primaryProduct;
        $[3] = primarySubProduct;
        $[4] = t6;
    } else t6 = $[4];
    const wrapCrossProductUrl = (0, $46mBC.useSearchCrossProductUrlWrapper)(t6);
    let t7;
    if ($[5] !== product || $[6] !== url || $[7] !== wrapCrossProductUrl) {
        t7 = wrapCrossProductUrl(url, product);
        $[5] = product;
        $[6] = url;
        $[7] = wrapCrossProductUrl;
        $[8] = t7;
    } else t7 = $[8];
    const wrappedUrl = t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (e)=>{
            requestAnimationFrame(()=>{
                if (e.key === "Enter") ref.current?.click();
            });
        };
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== getItemIndexes || $[11] !== id || $[12] !== onResultHighlighted || $[13] !== resultType) {
        t9 = ()=>onResultHighlighted?.({
                ...getItemIndexes(id) ?? {},
                resultType: resultType
            });
        $[10] = getItemIndexes;
        $[11] = id;
        $[12] = onResultHighlighted;
        $[13] = resultType;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== navigationTrackingId || $[16] !== t9) {
        t10 = {
            onKeydownCallback: t8,
            navigationTrackingId: navigationTrackingId,
            onHighlightedCallback: t9
        };
        $[15] = navigationTrackingId;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)(t10);
    let t11;
    if ($[18] !== getItemIndexes || $[19] !== id || $[20] !== onResultClicked || $[21] !== resultType) {
        t11 = (event, t12)=>{
            const { isAuxClick: t13 } = t12 === undefined ? {} : t12;
            const isAuxClick$0 = t13 === undefined ? false : t13;
            return onResultClicked?.(event, {
                ...getItemIndexes(id) ?? {},
                isAuxClick: isAuxClick$0,
                resultType: resultType
            });
        };
        $[18] = getItemIndexes;
        $[19] = id;
        $[20] = onResultClicked;
        $[21] = resultType;
        $[22] = t11;
    } else t11 = $[22];
    const onClick = t11;
    let t12;
    if ($[23] !== getItemIndexes || $[24] !== id || $[25] !== onResultContextMenu || $[26] !== resultType) {
        t12 = (event_0)=>onResultContextMenu?.(event_0, {
                ...getItemIndexes(id) ?? {},
                resultType: resultType
            });
        $[23] = getItemIndexes;
        $[24] = id;
        $[25] = onResultContextMenu;
        $[26] = resultType;
        $[27] = t12;
    } else t12 = $[27];
    const onContextMenu = t12;
    let t13;
    if ($[28] !== metadata) {
        let t14;
        if ($[30] !== metadata.length) {
            t14 = (part, i)=>i === metadata.length - 1 && typeof part === "string" ? [
                    part,
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: $2944de3e13791145$var$textOverflowStyles,
                        as: "span"
                    }, part)
                ] : part;
            $[30] = metadata.length;
            $[31] = t14;
        } else t14 = $[31];
        t13 = metadata.map(t14);
        $[28] = metadata;
        $[29] = t13;
    } else t13 = $[29];
    const metadataPartsWithTextOverflow = t13;
    let t14;
    if ($[32] !== setRef) {
        t14 = (node)=>{
            ref.current = node;
            setRef(node);
        };
        $[32] = setRef;
        $[33] = t14;
    } else t14 = $[33];
    const t15 = isHovered && $2944de3e13791145$var$resultHoveredStlyes;
    const t16 = isKeyboardHighlighted && $2944de3e13791145$var$keyboardHighlightedStyles;
    let t17;
    if ($[34] !== t15 || $[35] !== t16) {
        t17 = [
            $2944de3e13791145$var$resultStyles,
            t15,
            t16
        ];
        $[34] = t15;
        $[35] = t16;
        $[36] = t17;
    } else t17 = $[36];
    let t18;
    let t19;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = ()=>setIsHovered(true);
        t19 = ()=>setIsHovered(false);
        $[37] = t18;
        $[38] = t19;
    } else {
        t18 = $[37];
        t19 = $[38];
    }
    let t20;
    if ($[39] !== icon) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2944de3e13791145$var$iconAreaStyles
        }, icon);
        $[39] = icon;
        $[40] = t20;
    } else t20 = $[40];
    let t21;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = [
            $2944de3e13791145$var$titleStyles,
            $2944de3e13791145$var$textOverflowStyles
        ];
        $[41] = t21;
    } else t21 = $[41];
    let t22;
    if ($[42] !== highlightedTitle || $[43] !== title) {
        t22 = highlightedTitle ? (0, $9lW6K.enrichResultTitle)(highlightedTitle) : title;
        $[42] = highlightedTitle;
        $[43] = title;
        $[44] = t22;
    } else t22 = $[44];
    let t23;
    if ($[45] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t21
        }, t22);
        $[45] = t22;
        $[46] = t23;
    } else t23 = $[46];
    let t24;
    if ($[47] !== titleMetadataParts) {
        t24 = titleMetadataParts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts
        }));
        $[47] = titleMetadataParts;
        $[48] = t24;
    } else t24 = $[48];
    let t25;
    if ($[49] !== t23 || $[50] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2944de3e13791145$var$headingStyle
        }, t23, t24);
        $[49] = t23;
        $[50] = t24;
        $[51] = t25;
    } else t25 = $[51];
    let t26;
    if ($[52] !== metadata.length || $[53] !== metadataPartsWithTextOverflow) {
        t26 = metadata.length >= 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $2944de3e13791145$var$metadataStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7nUd.SearchMetadata), {
            parts: metadataPartsWithTextOverflow
        }));
        $[52] = metadata.length;
        $[53] = metadataPartsWithTextOverflow;
        $[54] = t26;
    } else t26 = $[54];
    let t27;
    if ($[55] !== t25 || $[56] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2944de3e13791145$var$middleAreaStyles
        }, t25, t26);
        $[55] = t25;
        $[56] = t26;
        $[57] = t27;
    } else t27 = $[57];
    let t28;
    if ($[58] !== highlightedRightMetadata || $[59] !== hoveredRightMetadata || $[60] !== isHovered || $[61] !== isKeyboardHighlighted || $[62] !== rightMetadata) {
        t28 = hoveredRightMetadata && isHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2944de3e13791145$var$rightSectionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26eSY.Show), {
            above: "xs"
        }, hoveredRightMetadata)) : highlightedRightMetadata && isKeyboardHighlighted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2944de3e13791145$var$rightSectionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26eSY.Show), {
            above: "xs"
        }, highlightedRightMetadata)) : rightMetadata ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2944de3e13791145$var$rightSectionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26eSY.Show), {
            above: "xs"
        }, rightMetadata)) : null;
        $[58] = highlightedRightMetadata;
        $[59] = hoveredRightMetadata;
        $[60] = isHovered;
        $[61] = isKeyboardHighlighted;
        $[62] = rightMetadata;
        $[63] = t28;
    } else t28 = $[63];
    let t29;
    if ($[64] !== t14 || $[65] !== t17 || $[66] !== t20 || $[67] !== t27 || $[68] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            ref: t14,
            xcss: t17,
            onMouseEnter: t18,
            onMouseLeave: t19
        }, t20, t27, t28);
        $[64] = t14;
        $[65] = t17;
        $[66] = t20;
        $[67] = t27;
        $[68] = t28;
        $[69] = t29;
    } else t29 = $[69];
    const content = t29;
    const t30 = navigationTrackingId || undefined;
    let t31;
    if ($[70] !== isKeyboardHighlighted || $[71] !== t30) {
        t31 = {
            role: "option",
            id: t30,
            "aria-selected": isKeyboardHighlighted
        };
        $[70] = isKeyboardHighlighted;
        $[71] = t30;
        $[72] = t31;
    } else t31 = $[72];
    const ariaProps = t31;
    let t32;
    if ($[73] !== ariaProps || $[74] !== content || $[75] !== isThirdParty || $[76] !== onClick || $[77] !== onContextMenu || $[78] !== url || $[79] !== wrappedUrl) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2944de3e13791145$var$containerStyles
        }, (0, $dh538.fg)("custom-interactive-elements-not-keyboard-focusable") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            ...!url && ariaProps,
            padding: "space.0",
            backgroundColor: "color.background.neutral.subtle",
            onClick: (e_0)=>onClick(e_0),
            onAuxClick: (e_1)=>{
                if ((0, $1VHLw.isAuxClick)(e_1)) return onClick(e_1, {
                    isAuxClick: true
                });
            },
            onContextMenu: onContextMenu
        }, wrappedUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
            ...ariaProps,
            xcss: [
                $2944de3e13791145$var$linkStyles
            ],
            rel: isThirdParty ? "noreferrer" : "",
            target: isThirdParty ? "_blank" : undefined,
            href: wrappedUrl,
            testId: "search-dialog-result-link"
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, content)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            ...!url && ariaProps,
            onClick: (e_2)=>onClick(e_2),
            onAuxClick: (e_3)=>{
                if ((0, $1VHLw.isAuxClick)(e_3)) return onClick(e_3, {
                    isAuxClick: true
                });
            },
            onContextMenu: onContextMenu
        }, wrappedUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
            ...ariaProps,
            xcss: $2944de3e13791145$var$linkStyles,
            rel: isThirdParty ? "noreferrer" : "",
            target: isThirdParty ? "_blank" : undefined,
            href: wrappedUrl,
            testId: "search-dialog-result-link"
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, content)));
        $[73] = ariaProps;
        $[74] = content;
        $[75] = isThirdParty;
        $[76] = onClick;
        $[77] = onContextMenu;
        $[78] = url;
        $[79] = wrappedUrl;
        $[80] = t32;
    } else t32 = $[80];
    const resultWithoutAnalyticsWrapper = t32;
    let t33;
    if ($[81] !== connectorType || $[82] !== id || $[83] !== includeInAnalytics || $[84] !== minutesSinceActivityTimestamp || $[85] !== product || $[86] !== recentActivityEventType || $[87] !== resultType || $[88] !== resultWithoutAnalyticsWrapper || $[89] !== zeroQueryType) {
        t33 = includeInAnalytics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9wmQG.SearchDialogResultAnalyticsWrapper), {
            "data-testid": "search-dialog-result",
            ref: wrapperRef,
            resultType: resultType,
            product: product,
            id: id,
            connectorType: connectorType,
            minutesSinceActivityTimestamp: minutesSinceActivityTimestamp,
            recentActivityEventType: recentActivityEventType,
            zeroQueryType: zeroQueryType
        }, resultWithoutAnalyticsWrapper) : resultWithoutAnalyticsWrapper;
        $[81] = connectorType;
        $[82] = id;
        $[83] = includeInAnalytics;
        $[84] = minutesSinceActivityTimestamp;
        $[85] = product;
        $[86] = recentActivityEventType;
        $[87] = resultType;
        $[88] = resultWithoutAnalyticsWrapper;
        $[89] = zeroQueryType;
        $[90] = t33;
    } else t33 = $[90];
    return t33;
} : ({ icon: icon, title: title, resultType: resultType, product: product, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, metadata: metadata = [], rightMetadata: rightMetadata, hoveredRightMetadata: hoveredRightMetadata, highlightedRightMetadata: highlightedRightMetadata, url: url, isThirdParty: isThirdParty = false, highlightedTitle: highlightedTitle, includeInAnalytics: includeInAnalytics = true, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onResultHighlighted: onResultHighlighted, titleMetadataParts: titleMetadataParts, id: id, minutesSinceActivityTimestamp: minutesSinceActivityTimestamp, recentActivityEventType: recentActivityEventType, connectorType: connectorType, zeroQueryType: zeroQueryType })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    const ref = (0, $42omo.useRef)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { getItemIndexes: getItemIndexes } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const navigationTrackingId = (0, $42omo.useMemo)(()=>{
        if (resultType === 'intentRouterWorkItem') return `${resultType}:${0, $161b4e5c9ce588f2$export$7cc7cea0c5a977c4}`;
        return id ? `${resultType}:${id}` : null;
    }, [
        id,
        resultType
    ]);
    const wrapCrossProductUrl = (0, $46mBC.useSearchCrossProductUrlWrapper)({
        bridge: 'quickFind',
        primaryProduct: primaryProduct,
        primarySubProduct: primarySubProduct
    });
    const wrappedUrl = wrapCrossProductUrl(url, product);
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: (e)=>{
            /**
       * Two different event listeners are used to handle enter key presses
       * when the input is focused:
       * - the onKeyDown callback on the Textfield component which uses
       *   React's synthetic event listeners (onKeyDown)
       * - the keyboard highlight provider's onKeydownCallback which
       *   uses native event listeners (window.addEventListener). This one
       *   will only be called if a search result is highlighted.
       * Ideally there should be only one event listener however, it isn't
       * worth the effort to refactor the keyboard highlight provider right now.
       *
       * Given that the keyboard highlight provider's callback uses native
       * event listeners, it will always be called first. This is a problem
       * because there is no way for the keyboard highlight provider to
       * communicate that the event has been handled, resulting in a bug
       * where we try to handle the event twice if a search result was
       * highlighted. It must be noted that it cannot be guaranteed that
       * the search results are still highlighted after the native event
       * listener has executed as it could close the search dialog.
       *
       * To fix this, a somewhat hacky solution has been added to delay
       * the click event in the keyboard highlight provdier by one frame
       * in search-dialog-result/index. This allows the React synthetic
       * event to decide if it should handle the event by checking if a
       * search result is highlighted, otherwise it will do nothing and
       * let the keyboard highlight provider handle the event.
       */ requestAnimationFrame(()=>{
                if (e.key === 'Enter') ref.current?.click();
            });
        },
        navigationTrackingId: // Used by KeyboardHighlightProvider to keep highlighting stable across re-orders.
        // Also enables imperative highlighting by a stable tracking id.
        //
        // NOTE: `id` alone can collide across sections (e.g. suggestion + recent query),
        // so we namespace it by `resultType`.
        // we need a fixed tracking ID for work item in intent detection to highlight it automatically
        navigationTrackingId,
        onHighlightedCallback: ()=>onResultHighlighted?.({
                ...getItemIndexes(id) ?? {},
                resultType: resultType
            })
    });
    const onClick = (0, $42omo.useCallback)((event, { isAuxClick: isAuxClick = false } = {})=>onResultClicked?.(event, {
            ...getItemIndexes(id) ?? {},
            isAuxClick: isAuxClick,
            resultType: resultType
        }), [
        onResultClicked,
        getItemIndexes,
        id,
        resultType
    ]);
    const onContextMenu = (0, $42omo.useCallback)((event_0)=>onResultContextMenu?.(event_0, {
            ...getItemIndexes(id) ?? {},
            resultType: resultType
        }), [
        onResultContextMenu,
        getItemIndexes,
        id,
        resultType
    ]);
    const metadataPartsWithTextOverflow = metadata.map((part, i)=>i === metadata.length - 1 && typeof part === 'string' ? [
            part,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$textOverflowStyles,
                as: "span"
            }, part)
        ] : part);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ref: (node)=>{
            ref.current = node;
            setRef(node);
        },
        xcss: [
            $2944de3e13791145$var$resultStyles,
            isHovered && $2944de3e13791145$var$resultHoveredStlyes,
            isKeyboardHighlighted && $2944de3e13791145$var$keyboardHighlightedStyles
        ],
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2944de3e13791145$var$iconAreaStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2944de3e13791145$var$middleAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2944de3e13791145$var$headingStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $2944de3e13791145$var$titleStyles,
            $2944de3e13791145$var$textOverflowStyles
        ]
    }, highlightedTitle ? (0, $9lW6K.enrichResultTitle)(highlightedTitle) : title), titleMetadataParts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7nUd.SearchMetadata), {
        parts: titleMetadataParts
    }))), metadata.length >= 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $2944de3e13791145$var$metadataStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7nUd.SearchMetadata), {
        parts: metadataPartsWithTextOverflow
    }))), hoveredRightMetadata && isHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2944de3e13791145$var$rightSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26eSY.Show), {
        above: "xs"
    }, hoveredRightMetadata)) : highlightedRightMetadata && isKeyboardHighlighted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2944de3e13791145$var$rightSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26eSY.Show), {
        above: "xs"
    }, highlightedRightMetadata)) : rightMetadata ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2944de3e13791145$var$rightSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26eSY.Show), {
        above: "xs"
    }, rightMetadata)) : null);
    // There should not be any focusable descendant to an 'option' element
    const ariaProps = {
        role: 'option',
        id: navigationTrackingId || undefined,
        'aria-selected': isKeyboardHighlighted
    };
    const resultWithoutAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2944de3e13791145$var$containerStyles
    }, (0, $dh538.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        ...!url && ariaProps,
        // Pressable renders a native <button>, which only resets
        // box-sizing/appearance/border — NOT padding. Without this the
        // browser's default button padding is added on top of the row's
        // own padding, so the row inset differs from the <Box> (div)
        // variant. Reset it so both gate states render identically.
        padding: "space.0",
        backgroundColor: "color.background.neutral.subtle",
        onClick: (e_0)=>onClick(e_0),
        onAuxClick: (e_1)=>{
            if ((0, $1VHLw.isAuxClick)(e_1)) return onClick(e_1, {
                isAuxClick: true
            });
        },
        onContextMenu: onContextMenu
    }, wrappedUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
        ...ariaProps,
        xcss: [
            $2944de3e13791145$var$linkStyles
        ],
        rel: isThirdParty ? 'noreferrer' : '',
        target: isThirdParty ? '_blank' : undefined,
        href: wrappedUrl,
        testId: "search-dialog-result-link"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, content)) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ...!url && ariaProps,
        onClick: (e_2)=>onClick(e_2),
        onAuxClick: (e_3)=>{
            if ((0, $1VHLw.isAuxClick)(e_3)) return onClick(e_3, {
                isAuxClick: true
            });
        },
        onContextMenu: onContextMenu
    }, wrappedUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
        ...ariaProps,
        xcss: $2944de3e13791145$var$linkStyles,
        rel: isThirdParty ? 'noreferrer' : '',
        target: isThirdParty ? '_blank' : undefined,
        href: wrappedUrl,
        testId: "search-dialog-result-link"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, content)));
    return includeInAnalytics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9wmQG.SearchDialogResultAnalyticsWrapper), {
        "data-testid": "search-dialog-result",
        ref: wrapperRef,
        resultType: resultType,
        product: product,
        id: id,
        connectorType: connectorType,
        minutesSinceActivityTimestamp: minutesSinceActivityTimestamp,
        recentActivityEventType: recentActivityEventType,
        zeroQueryType: zeroQueryType
    }, resultWithoutAnalyticsWrapper) : resultWithoutAnalyticsWrapper;
};



var $kXlQy = parcelRequire("kXlQy");





var $c49EN = parcelRequire("c49EN");


var $4Chrd = parcelRequire("4Chrd");


var $6QzpZ = parcelRequire("6QzpZ");


var $gRvZB = parcelRequire("gRvZB");


var $2vU0F = parcelRequire("2vU0F");








var $1nJM3 = parcelRequire("1nJM3");





var $4VmlX = parcelRequire("4VmlX");




const $3a985a01f765cd1f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    workItem: {
        id: "work_item",
        defaultMessage: "Work item"
    },
    draftLabel: {
        id: "draft_label",
        defaultMessage: "Draft"
    }
});



const $bfef7c7cb8b104c2$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("i71YS")).then((mod)=>({
            default: mod.HoverCard
        })));
const $bfef7c7cb8b104c2$var$labelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $bfef7c7cb8b104c2$var$DraftBadge = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { message: message } = t0;
    let t1;
    if ($[0] !== message) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "neutral"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), message)));
        $[0] = message;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ message: message })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "neutral"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), message)));
};
const $bfef7c7cb8b104c2$export$934ec3855ad17df5 = (data)=>{
    if ((data?.pageStatus === 'DRAFT' || data?.blogStatus === 'DRAFT') && data?.subtype !== 'LIVE') return [
        [
            'confluence-draft',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bfef7c7cb8b104c2$var$DraftBadge, {
                message: (0, $3a985a01f765cd1f$export$defe85febe8b728c).draftLabel
            })
        ]
    ];
};
const $bfef7c7cb8b104c2$var$mapConfluenceActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { title: title, space: space, links: links } = activity.object.data;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const titleMetadataParts = $bfef7c7cb8b104c2$export$934ec3855ad17df5(activity.object.data);
    const isLiveDoc = activity.object.data?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    const icon = (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: activity.object.data.iconData,
        type: activity.object.type,
        isLiveDoc: isLiveDoc
    });
    const resultType = isLiveDoc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $3a985a01f765cd1f$export$defe85febe8b728c).liveDoc) : activity.object.type;
    const type = [
        'confluence-type',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
            type: activity.object.type,
            defaultMessage: resultType,
            subtype: activity.object.data?.subtype
        }))
    ];
    const spaceName = space?.name || '';
    const metadata = [
        type,
        spaceName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const urlBase = links?.base;
    const urlWebUi = links?.webUi;
    const url = urlBase && urlWebUi && `${urlBase}${urlWebUi}`;
    const spaceId = space?.id;
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `${(0, $1yEFx.ProductKeys).Confluence} ${activity.object.type}`,
        product: (0, $1yEFx.ProductKeys).Confluence,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    if (!title || !url) return undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata,
        titleMetadataParts: titleMetadataParts
    };
};
const $bfef7c7cb8b104c2$export$d1c859566522d367 = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { key: key, fieldsById: fieldsById, webUrl: webUrl } = activity.object.data;
    const isIssue = activity.object.type === 'issue';
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: activity.object.data?.issueType?.avatar?.small,
        type: activity.object.type,
        isIssue: isIssue
    });
    const summary = fieldsById?.edges?.[0]?.node?.text;
    const title = key && summary && `${key}: ${summary}`;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const productMetadata = 'Jira';
    const projectName = activity?.object?.data?.fieldsById?.edges?.[0]?.node?.issue?.projectField?.project?.name ?? null;
    const issueTypeName = activity?.object?.data?.fieldsById?.edges?.[0]?.node?.issue?.issueTypeField?.issueType?.name ?? null;
    const metadata = [
        productMetadata,
        issueTypeName,
        projectName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${(0, $1yEFx.ProductKeys).Jira} ${activity.object.type}`,
        product: (0, $1yEFx.ProductKeys).Jira,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    if (!title || !webUrl) return undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: webUrl,
        analyticsMetadata: analyticsMetadata,
        isJiraIssue: isIssue
    };
};
const $bfef7c7cb8b104c2$export$38a5a0823b95c5be = (activity, query)=>{
    if (!activity.object.data) return undefined;
    const id = activity.object.id;
    const data = activity.object.data;
    const { assetsLabel: title, displayTypename: displayTypename, links: links, assetsIcon: assetsIcon, schema: schema, objectType: objectType } = data;
    const url = links?.web || null;
    if (!title || !url) return undefined;
    const icon = (0, $2waBy.getAssetsEntityIcon)({
        iconUrl: assetsIcon?.url48,
        type: activity.object.type,
        size: 'small'
    });
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    // Create metadata with object type and schema information
    const schemaName = schema?.name || objectType?.schema?.name || null;
    const productMetadata = 'Assets';
    const metadata = [
        productMetadata,
        [
            activity.object.type,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $bfef7c7cb8b104c2$var$labelContainer
            }, displayTypename)
        ],
        schemaName
    ];
    // Add event type information
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `assets ${activity.object.type}`,
        // Normalise to the canonical 1P key ('cmdb') so analytics pipelines
        // see a single identifier regardless of whether the activity API
        // returns 'assets' or the ARI resource-owner is 'assets'.
        product: (0, $1yEFx.ProductKeys).Assets,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapTownsquareActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { name: name, key: key, url: url } = activity.object.data;
    const icon = (0, $2waBy.getAtlasEntityIcon)({
        iconUrl: activity.object.data.iconData,
        type: activity.object.type
    });
    const highlightedTitle = name && query ? (0, $bloXB.highlightMatchedText)(name, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'type',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
            type: activity.object.type,
            defaultMessage: activity.object.type
        }))
    ];
    const metadata = [
        type,
        key ?? null
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    let product = (0, $1yEFx.ProductKeys).Atlas;
    if ((0, $dh538.fg)('rovo_search_cross_product_url_wrapping')) {
        if (activity.object.type === 'goal') product = (0, $b4tvS.ProductKeys1PForAnalytics).AtlasGoals;
        else if (activity.object.type === 'project') product = (0, $b4tvS.ProductKeys1PForAnalytics).AtlasProjects;
    }
    const analyticsMetadata = {
        contentId: id,
        contentType: `${(0, $1yEFx.ProductKeys).Atlas} ${activity.object.type}`,
        product: product,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    if (!name || !url) return undefined;
    return {
        id: id,
        icon: icon,
        title: name,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphDocumentActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return;
    const { type: type, displayName: displayName, parent: parent, url: url, provider: provider } = activity.object.data;
    const id = activity.object.id;
    const providerId = provider?.providerId;
    const product = (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $6QzpZ.getProductFromThirdPartyId)({
        thirdPartyId: id
    });
    if (!product) return;
    const subtype = type?.category?.toLowerCase();
    const label = (0, $9kYXz.getDocumentSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const title = displayName;
    if (!title || !url) return undefined;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label)) : subtype ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()) : null
    ];
    const parentName = parent?.displayName ?? null;
    const metadata = [
        typeLabel,
        parentName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphRemoteLinkActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return;
    const { category: category, displayName: displayName, url: url, provider: provider } = activity.object.data;
    const id = activity.object.id;
    const providerId = provider?.providerId;
    let product;
    let productDisplayName = '';
    if (providerId) {
        product = (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $6QzpZ.getProductFromThirdPartyId)({
            thirdPartyId: id
        });
        productDisplayName = (0, $c49EN.getProductDisplayNameFromProviderId)(thirdPartyConfigs, providerId) || '';
    }
    if (!product) return;
    const subtype = category?.toLowerCase();
    const label = (0, $9kYXz.getRemoteLinkSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const title = displayName;
    if (!title || !url) return undefined;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const productLabel = [
        'productLabel',
        productDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, productDisplayName) : null
    ];
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label)) : null
    ];
    const metadata = [
        productLabel,
        typeLabel
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if ((0, $hWR4v.isDocumentActivity)(activity.object)) return $bfef7c7cb8b104c2$var$mapGraphDocumentActivityToSearchResult(activity, query, thirdPartyConfigs);
    if ((0, $hWR4v.isRemoteLinkActivity)(activity.object)) return $bfef7c7cb8b104c2$var$mapGraphRemoteLinkActivityToSearchResult(activity, query, thirdPartyConfigs);
    return undefined;
};
const $bfef7c7cb8b104c2$var$mapGraphWorkItemActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return undefined;
    const id = activity.object.id;
    // `workItemStatus` is a GraphQL alias for `status` (see ExternalWorkItemFragment) to
    // avoid an AGG FieldsConflict with ExternalPullRequest.status (enum vs String).
    const { displayName: displayName, url: url, provider: provider, workItemStatus: status } = activity.object.data;
    const providerId = provider?.providerId;
    let product;
    let productDisplayName = '';
    if (providerId) {
        product = (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $6QzpZ.getProductFromThirdPartyId)({
            thirdPartyId: id
        });
        productDisplayName = product && thirdPartyConfigs?.[product]?.displayName;
    }
    if (!product || !displayName || !url) return undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const highlightedTitle = query ? (0, $bloXB.highlightMatchedText)(displayName, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'work-item-type',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
            type: activity.object.type,
            defaultMessage: activity.object.type
        }))
    ];
    const productLabel = [
        'productLabel',
        productDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, productDisplayName) : null
    ];
    const metadata = [
        productLabel,
        type
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${activity.object.type}`,
        product: product
    };
    const titleMetadataParts = [];
    if (status) titleMetadataParts.push([
        'status',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i6Ooe.GraphWorkItemStatusLozenge), {
            status: status
        })
    ]);
    return {
        id: id,
        icon: icon,
        title: displayName,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata,
        ...titleMetadataParts.length > 0 ? {
            titleMetadataParts: titleMetadataParts
        } : {}
    };
};
const $bfef7c7cb8b104c2$var$mapGraphPullRequestActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return undefined;
    const id = activity.object.id;
    const { displayName: displayName, url: url, provider: provider, status: prStatus } = activity.object.data;
    const providerId = provider?.providerId;
    let product;
    let productDisplayName = '';
    if (providerId) {
        product = (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $6QzpZ.getProductFromThirdPartyId)({
            thirdPartyId: id
        });
        productDisplayName = product && thirdPartyConfigs?.[product]?.displayName;
    }
    if (!product || !displayName || !url) return undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const highlightedTitle = query ? (0, $bloXB.highlightMatchedText)(displayName, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'pull-request-type',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
            type: activity.object.type,
            defaultMessage: activity.object.type
        }))
    ];
    const productLabel = [
        'productLabel',
        productDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, productDisplayName) : null
    ];
    const metadata = [
        productLabel,
        type
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${activity.object.type}`,
        product: product
    };
    const titleMetadataParts = [];
    if (prStatus) titleMetadataParts.push([
        'status',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: (0, $2vU0F.getPullRequestStatusAppearance)(prStatus),
            testId: "pull-request-status-lozenge"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2vU0F.getPullRequestStatusMessage)(prStatus)))
    ]);
    return {
        id: id,
        icon: icon,
        title: displayName,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata,
        ...titleMetadataParts.length > 0 ? {
            titleMetadataParts: titleMetadataParts
        } : {}
    };
};
const $bfef7c7cb8b104c2$var$mapGithubActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { displayName: displayName, url: url } = activity.object.data;
    if (!displayName || !url) return undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small",
        product: 'github'
    });
    const highlightedTitle = displayName && query ? (0, $bloXB.highlightMatchedText)(displayName, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'github-type',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
            type: activity.object.type,
            defaultMessage: activity.object.type
        }))
    ];
    const metadata = [
        type,
        'GitHub'
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${(0, $1yEFx.ProductKeys).Github} ${activity.object.type}`,
        product: (0, $1yEFx.ProductKeys).Github
    };
    return {
        id: id,
        icon: icon,
        title: displayName,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapLoomActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return undefined;
    const id = activity.object.id;
    const { name: name, loomUrl: loomUrl } = activity.object.data;
    if (!name || !loomUrl) return undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Loom
    });
    const highlightedTitle = query ? (0, $bloXB.highlightMatchedText)(name, query.split(' ')).highlightedTitle : undefined;
    const metadata = [
        'Loom',
        'Video'
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const analyticsMetadata = {
        contentId: id,
        contentType: `${activity.object.product} ${activity.object.type}`,
        product: activity.object.product,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
    return {
        id: id,
        icon: icon,
        title: name,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: loomUrl,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$export$1d02b83d52558ed = (edge, query, searchSessionId, thirdPartyConfigs, serveGithubLinksHydrationCohort)=>{
    const activity = edge.node;
    const product = activity.object.product;
    const timestamp = activity.event.timestamp;
    let result;
    if ((0, $hWR4v.isGraphPullRequestActivity)(activity.object) && ((0, $2OtFZ.serveGithubRecentsExperiment)() || (0, $dh538.fg)('github-3lo-recent-pull-request-fg'))) result = $bfef7c7cb8b104c2$var$mapGraphPullRequestActivityToSearchResult(activity, query, thirdPartyConfigs);
    else if ((0, $hWR4v.isGraphWorkItemActivity)(activity.object) && (0, $2OtFZ.serveGithubWorkItemsRecentsExperiment)()) result = $bfef7c7cb8b104c2$var$mapGraphWorkItemActivityToSearchResult(activity, query, thirdPartyConfigs);
    else if ((0, $hWR4v.isGraphActivity)(activity.object)) result = $bfef7c7cb8b104c2$var$mapGraphActivityToSearchResult(activity, query, thirdPartyConfigs);
    else if (product === 'confluence') result = $bfef7c7cb8b104c2$var$mapConfluenceActivityToSearchResult(activity, query);
    else if (product === 'jira') result = $bfef7c7cb8b104c2$export$d1c859566522d367(activity, query);
    else if (product === 'townsquare') result = $bfef7c7cb8b104c2$var$mapTownsquareActivityToSearchResult(activity, query);
    else if (product === 'github' && serveGithubLinksHydrationCohort) result = $bfef7c7cb8b104c2$var$mapGithubActivityToSearchResult(activity, query);
    else if (product === 'assets' && (0, $dh538.fg)('assets_rovo_search_all')) result = $bfef7c7cb8b104c2$export$38a5a0823b95c5be(activity, query);
    else if ((0, $hWR4v.isLoomActivity)(activity.object)) result = $bfef7c7cb8b104c2$var$mapLoomActivityToSearchResult(activity, query);
    else result = undefined;
    if (!result) return undefined;
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        ...result,
        url: urlWithAnalyticsQueryParams,
        minutesSinceActivityTimestamp: (0, $9wmQG.calculateMinuteDifference)(timestamp)
    };
};
const $bfef7c7cb8b104c2$export$8d9137fcb112aeab = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(64);
    const { result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted, serveGithubLinksHydration: t1, resultType: t2 } = t0;
    const serveGithubLinksHydration = t1 === undefined ? false : t1;
    const resultType = t2 === undefined ? "recentActivities" : t2;
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { setHoverCardOpen: setHoverCardOpen } = (0, $4VmlX.useQuickFindActions)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [primarySubProduct] = (0, $j4ply.usePrimarySubProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [t3] = (0, $j4ply.useBootstrap)();
    const { thirdPartyConfigs: thirdPartyConfigs } = t3;
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    let mappedResult;
    let t4;
    if ($[0] !== quickFindQuery || $[1] !== result || $[2] !== searchSessionId || $[3] !== serveGithubLinksHydration || $[4] !== thirdPartyConfigs) {
        mappedResult = $bfef7c7cb8b104c2$export$1d02b83d52558ed(result, quickFindQuery, searchSessionId, thirdPartyConfigs, serveGithubLinksHydration);
        t4 = (0, $gRvZB.isProductImpersonated)(mappedResult?.analyticsMetadata.product, thirdPartyConfigs);
        $[0] = quickFindQuery;
        $[1] = result;
        $[2] = searchSessionId;
        $[3] = serveGithubLinksHydration;
        $[4] = thirdPartyConfigs;
        $[5] = mappedResult;
        $[6] = t4;
    } else {
        mappedResult = $[5];
        t4 = $[6];
    }
    const isImpersonated = t4;
    const t5 = mappedResult?.analyticsMetadata;
    const t6 = mappedResult?.analyticsMetadata.product;
    let t7;
    if ($[7] !== result.node.event.eventType || $[8] !== result.node.object.id || $[9] !== t6 || $[10] !== thirdPartyConfigs) {
        t7 = (0, $kQT7c.getResultConnectorSource)({
            resultNodeId: result.node.object.id,
            thirdPartyConfigs: thirdPartyConfigs,
            productKey: t6,
            eventType: result.node.event.eventType
        });
        $[7] = result.node.event.eventType;
        $[8] = result.node.object.id;
        $[9] = t6;
        $[10] = thirdPartyConfigs;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== result.node.event.eventType || $[13] !== t5 || $[14] !== t7) {
        t8 = {
            ...t5,
            connectorType: t7,
            recentActivityEventType: result.node.event.eventType
        };
        $[12] = result.node.event.eventType;
        $[13] = t5;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    const t9 = mappedResult?.analyticsMetadata.product;
    let t10;
    if ($[16] !== t9) {
        t10 = (0, $fuGkE.is3pProductKeyForAnalytics)(t9);
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    const t11 = mappedResult?.analyticsMetadata.product;
    let t12;
    if ($[18] !== result.node.event.eventType || $[19] !== result.node.object.id || $[20] !== t11 || $[21] !== thirdPartyConfigs) {
        t12 = (0, $kQT7c.isResultSmartLink)({
            resultAri: result.node.object.id,
            thirdPartyConfigs: thirdPartyConfigs,
            productKey: t11,
            eventType: result.node.event.eventType
        });
        $[18] = result.node.event.eventType;
        $[19] = result.node.object.id;
        $[20] = t11;
        $[21] = thirdPartyConfigs;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== t10 || $[24] !== t12 || $[25] !== t8) {
        t13 = {
            isCached: true,
            metadata: t8,
            is3pLink: t10,
            is3pSmartLink: t12
        };
        $[23] = t10;
        $[24] = t12;
        $[25] = t8;
        $[26] = t13;
    } else t13 = $[26];
    const additionalAnalyticsAttributes = t13;
    let t14;
    if ($[27] !== result.node.object.id || $[28] !== setHoverCardOpen) {
        t14 = (isOpen)=>{
            setHoverCardOpen(result.node.object.id, isOpen);
        };
        $[27] = result.node.object.id;
        $[28] = setHoverCardOpen;
        $[29] = t14;
    } else t14 = $[29];
    const onHoverCardVisibilityChange = t14;
    let t15;
    if ($[30] !== additionalAnalyticsAttributes || $[31] !== isImpersonated || $[32] !== onClick || $[33] !== onHoverCardVisibilityChange || $[34] !== state) {
        t15 = (event, data)=>{
            onClick?.({
                event: event,
                data: data,
                state: state,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                isImpersonated: isImpersonated
            });
            onHoverCardVisibilityChange(false);
        };
        $[30] = additionalAnalyticsAttributes;
        $[31] = isImpersonated;
        $[32] = onClick;
        $[33] = onHoverCardVisibilityChange;
        $[34] = state;
        $[35] = t15;
    } else t15 = $[35];
    const onResultClicked = t15;
    let t16;
    if ($[36] !== additionalAnalyticsAttributes || $[37] !== isImpersonated || $[38] !== onContextMenu || $[39] !== state) {
        t16 = (event_0, data_0)=>{
            onContextMenu?.({
                event: event_0,
                data: data_0,
                state: state,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                isImpersonated: isImpersonated
            });
        };
        $[36] = additionalAnalyticsAttributes;
        $[37] = isImpersonated;
        $[38] = onContextMenu;
        $[39] = state;
        $[40] = t16;
    } else t16 = $[40];
    const onResultContextMenu = t16;
    let t17;
    if ($[41] !== additionalAnalyticsAttributes || $[42] !== onHighlighted || $[43] !== state) {
        t17 = (data_1)=>{
            onHighlighted?.({
                data: data_1,
                state: state,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes
            });
        };
        $[41] = additionalAnalyticsAttributes;
        $[42] = onHighlighted;
        $[43] = state;
        $[44] = t17;
    } else t17 = $[44];
    const onResultHighlighted = t17;
    if (!mappedResult) {
        invalidateItem(result.node.object.id);
        return null;
    }
    let t18;
    if ($[45] !== mappedResult.isJiraIssue || $[46] !== primaryProduct) {
        t18 = mappedResult.isJiraIssue && primaryProduct === (0, $1yEFx.ProductKeys).Jira && (0, $dh538.fg)("enable_hover_card_jira_issues_quick_find");
        $[45] = mappedResult.isJiraIssue;
        $[46] = primaryProduct;
        $[47] = t18;
    } else t18 = $[47];
    const enableJiraIssueHoverCard = t18;
    let t19;
    if ($[48] !== additionalAnalyticsAttributes.metadata.connectorType || $[49] !== mappedResult || $[50] !== onResultClicked || $[51] !== onResultContextMenu || $[52] !== onResultHighlighted || $[53] !== primaryProduct || $[54] !== primarySubProduct || $[55] !== result.node.event.eventType || $[56] !== resultType) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            ...mappedResult,
            resultType: resultType,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            product: mappedResult.analyticsMetadata.product,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultContextMenu,
            onResultHighlighted: onResultHighlighted,
            minutesSinceActivityTimestamp: mappedResult.minutesSinceActivityTimestamp,
            recentActivityEventType: result.node.event.eventType,
            connectorType: additionalAnalyticsAttributes.metadata.connectorType
        });
        $[48] = additionalAnalyticsAttributes.metadata.connectorType;
        $[49] = mappedResult;
        $[50] = onResultClicked;
        $[51] = onResultContextMenu;
        $[52] = onResultHighlighted;
        $[53] = primaryProduct;
        $[54] = primarySubProduct;
        $[55] = result.node.event.eventType;
        $[56] = resultType;
        $[57] = t19;
    } else t19 = $[57];
    const content = t19;
    let t20;
    if ($[58] !== content || $[59] !== enableJiraIssueHoverCard || $[60] !== mappedResult.title || $[61] !== mappedResult.url || $[62] !== onHoverCardVisibilityChange) {
        t20 = enableJiraIssueHoverCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1nJM3.ErrorBoundary), {
            fallback: content,
            section: "recent-activity-hover-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: content
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bfef7c7cb8b104c2$var$HoverCard, {
            onVisibilityChange: onHoverCardVisibilityChange,
            allowEventPropagation: true,
            url: mappedResult.url,
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $5TXU5.CardAction).PreviewAction
                ]
            },
            role: "dialog",
            titleId: mappedResult.title,
            label: "quick-find-smart-hover-card",
            shouldRenderToParent: true
        }, content))) : content;
        $[58] = content;
        $[59] = enableJiraIssueHoverCard;
        $[60] = mappedResult.title;
        $[61] = mappedResult.url;
        $[62] = onHoverCardVisibilityChange;
        $[63] = t20;
    } else t20 = $[63];
    return t20;
} : ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted, serveGithubLinksHydration: serveGithubLinksHydration = false, resultType: resultType = 'recentActivities' })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { setHoverCardOpen: setHoverCardOpen } = (0, $4VmlX.useQuickFindActions)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [primarySubProduct] = (0, $j4ply.usePrimarySubProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const mappedResult = $bfef7c7cb8b104c2$export$1d02b83d52558ed(result, quickFindQuery, searchSessionId, thirdPartyConfigs, serveGithubLinksHydration);
    const isImpersonated = (0, $gRvZB.isProductImpersonated)(mappedResult?.analyticsMetadata.product, thirdPartyConfigs);
    const additionalAnalyticsAttributes = (0, $42omo.useMemo)(()=>({
            isCached: true,
            metadata: {
                ...mappedResult?.analyticsMetadata,
                connectorType: (0, $kQT7c.getResultConnectorSource)({
                    resultNodeId: result.node.object.id,
                    thirdPartyConfigs: thirdPartyConfigs,
                    productKey: mappedResult?.analyticsMetadata.product,
                    eventType: result.node.event.eventType
                }),
                recentActivityEventType: result.node.event.eventType
            },
            is3pLink: (0, $fuGkE.is3pProductKeyForAnalytics)(mappedResult?.analyticsMetadata.product),
            is3pSmartLink: (0, $kQT7c.isResultSmartLink)({
                resultAri: result.node.object.id,
                thirdPartyConfigs: thirdPartyConfigs,
                productKey: mappedResult?.analyticsMetadata.product,
                eventType: result.node.event.eventType
            })
        }), [
        mappedResult,
        result.node.object.id,
        thirdPartyConfigs,
        result.node.event.eventType
    ]);
    const onHoverCardVisibilityChange = (0, $42omo.useCallback)((isOpen)=>{
        setHoverCardOpen(result.node.object.id, isOpen);
    }, [
        setHoverCardOpen,
        result.node.object.id
    ]);
    const onResultClicked = (0, $42omo.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes,
            isImpersonated: isImpersonated
        });
        onHoverCardVisibilityChange(false);
    }, [
        additionalAnalyticsAttributes,
        isImpersonated,
        onClick,
        state,
        onHoverCardVisibilityChange
    ]);
    const onResultContextMenu = (0, $42omo.useCallback)((event_0, data_0)=>{
        onContextMenu?.({
            event: event_0,
            data: data_0,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes,
            isImpersonated: isImpersonated
        });
    }, [
        additionalAnalyticsAttributes,
        isImpersonated,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $42omo.useCallback)((data_1)=>{
        onHighlighted?.({
            data: data_1,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) {
        invalidateItem(result.node.object.id);
        return null;
    }
    const enableJiraIssueHoverCard = mappedResult.isJiraIssue && primaryProduct === (0, $1yEFx.ProductKeys).Jira && (0, $dh538.fg)('enable_hover_card_jira_issues_quick_find');
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
        ...mappedResult,
        resultType: resultType,
        primaryProduct: primaryProduct,
        primarySubProduct: primarySubProduct,
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted,
        minutesSinceActivityTimestamp: mappedResult.minutesSinceActivityTimestamp,
        recentActivityEventType: result.node.event.eventType,
        connectorType: additionalAnalyticsAttributes.metadata.connectorType
    });
    return enableJiraIssueHoverCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1nJM3.ErrorBoundary), {
        fallback: content,
        section: "recent-activity-hover-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bfef7c7cb8b104c2$var$HoverCard, {
        onVisibilityChange: onHoverCardVisibilityChange,
        allowEventPropagation: true,
        url: mappedResult.url,
        actionOptions: {
            hide: false,
            exclude: [
                (0, $5TXU5.CardAction).PreviewAction
            ]
        },
        role: "dialog",
        titleId: mappedResult.title,
        label: "quick-find-smart-hover-card",
        shouldRenderToParent: true
    }, content))) : content;
};



var $f8oYd = parcelRequire("f8oYd");


var $4VkIo = parcelRequire("4VkIo");








var $djVCD = parcelRequire("djVCD");


var $inrbX = parcelRequire("inrbX");


var $idEgG = parcelRequire("idEgG");














var $lGfXC = parcelRequire("lGfXC");


var $3CshZ = parcelRequire("3CshZ");




const $d4ba038bc3c9327c$export$c24470e080406156 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $dh538.fg)("rovo-search-vitalstats-quickfind-postquery-network");
        $[0] = t0;
    } else t0 = $[0];
    const isEnabled = t0;
    let t1;
    if ($[1] !== commonAttributes.searchSessionId || $[2] !== fireAnalyticsEvent) {
        t1 = (options)=>{
            if (!isEnabled) return;
            const taskId = crypto.randomUUID();
            const searchSessionId = commonAttributes.searchSessionId || "";
            const taskStartAt = performance.now();
            return (0, $lGfXC.createVitalStatsNetworkCallbacks)(taskId, options.taskName, searchSessionId, fireAnalyticsEvent, taskStartAt, {
                uxTaskId: options.uxTaskId,
                isPreQuery: options.isPreQuery
            });
        };
        $[1] = commonAttributes.searchSessionId;
        $[2] = fireAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const createNetworkCallbacks = t1;
    let t2;
    if ($[4] !== createNetworkCallbacks) {
        t2 = {
            createNetworkCallbacks: createNetworkCallbacks,
            isEnabled: isEnabled
        };
        $[4] = createNetworkCallbacks;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const isEnabled = (0, $dh538.fg)('rovo-search-vitalstats-quickfind-postquery-network');
    const createNetworkCallbacks = (0, $42omo.useCallback)((options)=>{
        if (!isEnabled) return undefined;
        const taskId = crypto.randomUUID();
        const searchSessionId = commonAttributes.searchSessionId || '';
        const taskStartAt = performance.now();
        return (0, $lGfXC.createVitalStatsNetworkCallbacks)(taskId, options.taskName, searchSessionId, fireAnalyticsEvent, taskStartAt, {
            uxTaskId: options.uxTaskId,
            isPreQuery: options.isPreQuery
        });
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent
    ]);
    return (0, $42omo.useMemo)(()=>({
            createNetworkCallbacks: createNetworkCallbacks,
            isEnabled: isEnabled
        }), [
        createNetworkCallbacks,
        isEnabled
    ]);
};









var $6h3V2 = parcelRequire("6h3V2");


var $ja8yA = parcelRequire("ja8yA");












var $cORSX = parcelRequire("cORSX");





var $731W9 = parcelRequire("731W9");




/**
 * Returns whether the Loom recents experiment is enabled.
 * We do NOT trigger the exposure event here since it would be too wide.
 * Instead, we're doing that in src/ui/quick-find/dialog/index.tsx.
 *
 * Only users with Loom access (determined by availableProducts containing Loom)
 * are eligible for the experiment.
 *
 * Jira is intentionally excluded: qf_loom_recents was shipped to non-Jira
 * primaries only via Statsig targeting. Encoding the exclusion here keeps the
 * behaviour correct after experiment cleanup.
 *
 * https://switcheroo.atlassian.com/ui/gates/GATE_ID/key/qf_loom_recents
 */ const $198609fd26633f18$var$isLoomRecentsEnabled = (availableProducts, primaryProduct)=>{
    // Jira is excluded from the qf_loom_recents target audience in Statsig.
    // This reflects the decision made when concluding the experiment:
    // https://hello.atlassian.net/wiki/spaces/CentAI/pages/6574370556/Add+Loom+recent+in+QuickFind#Decision
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) return false;
    // Only target users who have Loom access
    if (!availableProducts?.includes((0, $1yEFx.ProductKeys).Loom)) return false;
    return (0, $c6GJD.default).getExperimentValue('qf_loom_recents', 'cohort', 'not-enrolled', {
        fireExperimentExposure: false
    }) === 'experiment';
};
const $198609fd26633f18$var$hasGithubConnectorAccess = (thirdPartyConfigs)=>{
    const githubConfig = thirdPartyConfigs?.[(0, $b4tvS.ProductKeys3P).Github];
    return !!(githubConfig && !githubConfig.userNeedsOAuth);
};
const $198609fd26633f18$var$hasGithubImpersonationAccess = (thirdPartyConfigs)=>{
    const githubConfig = thirdPartyConfigs?.[(0, $b4tvS.ProductKeys3P).Github];
    return !!(githubConfig?.userNeedsOAuth && githubConfig.impersonationEnabled && (0, $dh538.fg)('weaklink-github-fg'));
};
const $198609fd26633f18$var$hasGithubConnectorOrImpersonationAccess = (thirdPartyConfigs)=>$198609fd26633f18$var$hasGithubConnectorAccess(thirdPartyConfigs) || $198609fd26633f18$var$hasGithubImpersonationAccess(thirdPartyConfigs);
/**
 * GitHub work-item recents are isolated behind a separate gate so the work-item entity type can be
 * rolled out independently from the rest of the GitHub weak-link impersonation feature.
 */ const $198609fd26633f18$var$hasGithubWorkItemImpersonationAccess = (thirdPartyConfigs)=>{
    const githubConfig = thirdPartyConfigs?.[(0, $b4tvS.ProductKeys3P).Github];
    return !!(githubConfig?.userNeedsOAuth && githubConfig.impersonationEnabled && (0, $dh538.fg)('weaklink-github-work-item-fg'));
};
const $198609fd26633f18$export$48de245659972a87 = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
const $198609fd26633f18$export$742b5ce6018da1f4 = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
/**
 * Event types to be included in the recent activities query.
 * Based upon the AVI actions for each product: https://bitbucket.org/atlassian/flight-deck/src/7bab054550927c3c023f2eb783ce9d2ca6279bfc/packages/integrations/worklens/contrib/
 */ const $198609fd26633f18$var$INCLUDED_EVENT_TYPES = [
    'assigned',
    'unassigned',
    'viewed',
    'updated',
    'created',
    'liked',
    'transitioned',
    'published',
    'edited',
    'commented',
    'sl-viewed',
    'sl-clicked',
    'shared',
    'exported',
    'deleted',
    'started',
    'snapshotted',
    'trashed',
    'reaction'
];
const $198609fd26633f18$var$ORS_BATCH_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $198609fd26633f18$var$GRANTED = 'granted';
const $198609fd26633f18$var$RECENT_ACTIVITIES_LIMIT = 200;
const $198609fd26633f18$var$OK_STATUS = 200;
/**
 * Returns the list of products to be included in the recent activities query based on the experiment.
 */ const $198609fd26633f18$var$getIncludedProductsBasedOnCohort = (availableProducts, primaryProduct)=>{
    return [
        ...$198609fd26633f18$export$48de245659972a87,
        ...(0, $dh538.fg)('assets_rovo_search_all') ? [
            'assets'
        ] : [],
        ...$198609fd26633f18$var$isLoomRecentsEnabled(availableProducts, primaryProduct) ? [
            (0, $1yEFx.ProductKeys).Loom
        ] : []
    ];
};
const $198609fd26633f18$var$getIncludedProductsBasedOnProduct = (includedProducts, product)=>{
    /**
   * Decision on Experiment (https://hello.atlassian.net/wiki/spaces/CentAI/pages/5652280226)
   * Remove Jira from QF Recents to have better relevance and CTR.
   */ if (product === (0, $6Gsan.PrimaryProductKeys).Confluence) return includedProducts.filter((product)=>product !== (0, $6Gsan.PrimaryProductKeys).Jira);
    if (product === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $2OtFZ.serveJiraRecentsExcludeConfluenceWithoutExposure)()) return includedProducts.filter((p)=>p !== (0, $6Gsan.PrimaryProductKeys).Confluence);
    return includedProducts;
};
const $198609fd26633f18$var$getFilteredEventTypes = (thirdPartyConfigs)=>{
    // Only consult the sl-clicked-only experiment for users with an authorised
    // smart-link connector — others can't produce `sl-*` recents either way.
    const baseEventTypes = (0, $def8z.hasAuthorisedSmartLinkConnector)(thirdPartyConfigs) && (0, $2OtFZ.serveSlClickedOnlyInRecentsExperiment)({
        fireExperimentExposure: false
    }) ? $198609fd26633f18$var$INCLUDED_EVENT_TYPES.filter((eventType)=>eventType !== 'sl-viewed') : $198609fd26633f18$var$INCLUDED_EVENT_TYPES;
    if (thirdPartyConfigs && (0, $2OtFZ.serve3PClickIngestionExperiment)(thirdPartyConfigs, {
        fireExperimentExposure: false
    })) return [
        ...baseEventTypes,
        'clicked'
    ];
    return baseEventTypes;
};
const $198609fd26633f18$var$getFilteredProducts = (primaryProduct, availableProducts)=>{
    // Get included products based on cohort
    const includedProductsBasedOnCohort = $198609fd26633f18$var$getIncludedProductsBasedOnCohort(availableProducts, primaryProduct);
    // Further filter products based on primary product
    const filteredProductsBasedOnProduct = $198609fd26633f18$var$getIncludedProductsBasedOnProduct(includedProductsBasedOnCohort, primaryProduct);
    return filteredProductsBasedOnProduct;
};
const $198609fd26633f18$export$ae65634d024c5427 = async (cloudId, aggAbsoluteUrl, after = '', thirdPartyConfigs, headers, primaryProduct, networkCallbacks, availableProducts)=>{
    const filteredProducts = $198609fd26633f18$var$getFilteredProducts(primaryProduct, availableProducts);
    const variables = {
        filteredProducts: Array.from(new Set(filteredProducts)),
        filteredObjectTypes: Array.from(new Set([
            ...$198609fd26633f18$export$742b5ce6018da1f4,
            ...(0, $dh538.fg)('assets_rovo_search_all') ? [
                'object',
                'object_type',
                'schema'
            ] : [],
            ...$198609fd26633f18$var$isLoomRecentsEnabled(availableProducts, primaryProduct) ? [
                'video'
            ] : [],
            // Include the `pull-request` object type when EITHER:
            // - the user has GitHub connector/impersonation access and is in the experiment, OR
            // - the user has no GitHub connector and the `github-3lo-recent-pull-request-fg` gate is
            //   ON (the 3LO all-user rollout path for non-connected users, QS-10243).
            ...$198609fd26633f18$var$hasGithubConnectorOrImpersonationAccess(thirdPartyConfigs) && (0, $2OtFZ.serveGithubRecentsExperiment)() || !$198609fd26633f18$var$hasGithubConnectorAccess(thirdPartyConfigs) && (0, $dh538.fg)('github-3lo-recent-pull-request-fg') ? [
                'pull-request'
            ] : [],
            ...$198609fd26633f18$var$hasGithubWorkItemImpersonationAccess(thirdPartyConfigs) || $198609fd26633f18$var$hasGithubConnectorAccess(thirdPartyConfigs) && (0, $2OtFZ.serveGithubWorkItemsRecentsExperiment)() ? [
                'work-item'
            ] : []
        ])),
        filteredRootContainerIds: [
            `ari:cloud:platform::site/${cloudId}`,
            `ari:cloud:townsquare::site/${cloudId}`,
            ...$198609fd26633f18$var$isLoomRecentsEnabled(availableProducts, primaryProduct) ? [
                `ari:cloud:loom::site/${cloudId}`
            ] : []
        ],
        itemsLimit: 200,
        after: after,
        includeJiraIssueMetadata: true,
        filteredEventTypes: $198609fd26633f18$var$getFilteredEventTypes(thirdPartyConfigs)
    };
    const response = await (0, $ja8yA.cachedRecentActivitiesQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        headers: headers,
        onlyRefreshIfExpired: true,
        returnExpired: false,
        networkCallbacks: networkCallbacks
    });
    const edges = response.data?.activity?.myActivity?.all?.edges || [];
    return edges.map($198609fd26633f18$export$cf1f13813d90479a);
};
const $198609fd26633f18$export$9bda9a715c3ed911 = async (recentActivities, aggAbsoluteUrl, logException, headers)=>{
    const edges = $198609fd26633f18$var$sortEdgesByTimestamp(recentActivities.result.map((item)=>item.data));
    const aris = $198609fd26633f18$export$23b00b851b111052(edges);
    const jiraIssues = await $198609fd26633f18$export$c8536bbc7f06d58d(aris, aggAbsoluteUrl, logException, headers);
    const githubLinkTimestampMap = $198609fd26633f18$export$d3d43bed3553e945(edges, jiraIssues);
    const githubLinks = Array.from(githubLinkTimestampMap.keys());
    const githubResolvedResponse = await $198609fd26633f18$export$15cc24473e11647c(githubLinks, logException);
    const githubEdges = $198609fd26633f18$export$71147d03c75fd54e(githubResolvedResponse, githubLinkTimestampMap);
    return githubEdges.map($198609fd26633f18$export$cf1f13813d90479a);
};
const $198609fd26633f18$export$eeae5e9fadfd96ed = 'QuickFindRecentActivitiesJiraIssuesQuery';
const $198609fd26633f18$export$2dff6186c7d49e51 = `
    query ${$198609fd26633f18$export$eeae5e9fadfd96ed}($jira_ids: [ID!]!) {
			jira_issuesByIds(ids: $jira_ids) {
				id,
				summary,
				descriptionField {
					description,
					richText {
						adfValue {
							convertedPlainText {
								plainText
							}
						}
					}
				}
			}
		}
  `;
class $198609fd26633f18$export$7111514ace00cfa2 extends Error {
    constructor(message){
        super(message);
        this.name = 'JiraBackendApiError';
    }
}
const $198609fd26633f18$export$c8536bbc7f06d58d = async (aris, aggAbsoluteUrl, logException, headers)=>{
    const jiraIssueAris = aris.filter((ari)=>{
        try {
            const [resourceOwner, , resourceType] = (0, $6h3V2.getProductAndIDFromARI)(ari);
            return resourceOwner === (0, $hWR4v.ActivityProduct).JIRA && resourceType === 'issue';
        } catch  {
            return false;
        }
    });
    if (jiraIssueAris.length === 0) return [];
    // From https://bitbucket.org/atlassian/graphql-central-schema/src/d0613f3cd3a46e91b2e91ad919ecc4c5a47140f0/schema/jira/gira/IssueView.nadel#lines-17
    // Only fetch first 100 items for experiment
    const limitedJiraIssueAris = jiraIssueAris.slice(0, 100);
    try {
        const result = await (0, $ja8yA.fetchJiraIssuesQuery)({
            variables: {
                jira_ids: limitedJiraIssueAris
            },
            graphQuery: $198609fd26633f18$export$2dff6186c7d49e51,
            aggAbsoluteUrl: aggAbsoluteUrl,
            operationName: $198609fd26633f18$export$eeae5e9fadfd96ed,
            headers: headers
        });
        return result?.data?.jira_issuesByIds || [];
    } catch (error) {
        logException(new $198609fd26633f18$export$7111514ace00cfa2(`Failed to fetch jira issues: ${error}`));
        return [];
    }
};
const $198609fd26633f18$export$cf1f13813d90479a = (result)=>{
    const product = result.node.object.product;
    let title = '';
    const timestamp = result.node?.event?.timestamp;
    if ((0, $hWR4v.is1PActivity)(result.node.object)) {
        if (product === 'confluence') title = result.node.object.data?.title || '';
        else if (product === 'jira') {
            const key = result.node.object.data?.key;
            const summary = result.node.object.data?.fieldsById?.edges?.[0]?.node?.text;
            title = key && summary ? `${key}: ${summary}` : '';
        } else if (product === 'townsquare') title = result.node.object.data?.name || '';
    } else if ((0, $hWR4v.isGraphActivity)(result.node.object) && ((0, $hWR4v.isDocumentActivity)(result.node.object) || (0, $hWR4v.isRemoteLinkActivity)(result.node.object) || (0, $hWR4v.isGraphPullRequestActivity)(result.node.object) || (0, $hWR4v.isGraphWorkItemActivity)(result.node.object)) || (0, $hWR4v.isGithubActivity)(result.node.object)) title = result.node.object.data?.displayName || '';
    else if ((0, $hWR4v.isLoomActivity)(result.node.object)) title = result.node.object.data?.name || '';
    else if ((0, $hWR4v.isAssetsActivity)(result.node.object)) title = result.node.object.data?.assetsLabel || '';
    else title = '';
    return {
        id: result.node.object.id,
        title: title,
        data: result,
        type: 'recent-activity',
        activityTimestamp: timestamp
    };
};
const $198609fd26633f18$export$23b00b851b111052 = (edges)=>{
    let aris = [];
    edges.forEach((item)=>{
        const ari = item.node.object.id;
        if (ari && ($198609fd26633f18$var$isConfluenceResult(ari) || $198609fd26633f18$var$isJiraResult(ari))) aris.push(ari);
    });
    return aris;
};
const $198609fd26633f18$export$d3d43bed3553e945 = (edges, jiraIssuesById)=>{
    const githubLinkTimestampMap = new Map();
    jiraIssuesById.forEach((jiraIssue)=>{
        if (jiraIssue?.id) {
            const correspondingEdge = edges.find((edge)=>edge.node.object.id === jiraIssue.id);
            if (correspondingEdge) {
                const timestamp = correspondingEdge.node.event.timestamp;
                const githubLinks = $198609fd26633f18$export$4b717fa15645fa84(jiraIssue);
                githubLinks.forEach((link)=>{
                    githubLinkTimestampMap.set(link, timestamp);
                });
            }
        }
    });
    return githubLinkTimestampMap;
};
const $198609fd26633f18$export$4b717fa15645fa84 = (jiraIssue)=>{
    const githubLinks = new Set();
    const githubRegex = /https:\/\/github\.com\/[\w\-\.]+\/[\w\-\.]+(?:\/(?:issues\/\d+|pull\/\d+|commit\/[a-f0-9]+|blob\/[\w\-\.\/]+|tree\/[\w\-\.\/]+))?(?=\s|$|[^\w\-\/\.])/gi;
    const scanText = (text)=>{
        if (!text) return;
        const matches = text.match(githubRegex);
        if (matches) matches.forEach((link)=>githubLinks.add(link));
    };
    scanText(jiraIssue.summary);
    scanText(jiraIssue.descriptionField?.description);
    scanText(jiraIssue.descriptionField?.richText?.adfValue?.convertedPlainText?.plainText);
    return Array.from(githubLinks);
};
class $198609fd26633f18$export$527d28eac40c15a9 extends Error {
    constructor(message){
        super(message);
        this.name = 'OrsApiError';
    }
}
const $198609fd26633f18$export$15cc24473e11647c = async (githubLinks, logException)=>{
    if (githubLinks.length === 0) return [];
    // https://bitbucket.org/atlassian/object-resolver-service/src/178ab83b4d54575d9ff2cd1246eb83a892b4fd6a/openapi.yaml#lines-335
    // Batch requests in chunks of 50 for experiment, with a maximum of 2 batches
    const BATCH_SIZE = 50;
    const MAX_BATCHES = 2;
    const allResults = [];
    const maxLinks = BATCH_SIZE * MAX_BATCHES;
    const linksToProcess = githubLinks.slice(0, maxLinks);
    for(let i = 0; i < linksToProcess.length; i += BATCH_SIZE){
        const batch = linksToProcess.slice(i, i + BATCH_SIZE);
        const orsRequestData = batch.map((link)=>({
                resourceUrl: link
            }));
        try {
            const response = await fetch($198609fd26633f18$var$ORS_BATCH_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-product': 'JiraQuickFindRecentsForGithub' // For tracking RPM in ORS API
                },
                body: JSON.stringify(orsRequestData)
            });
            if (response === null || !response.ok) logException(new $198609fd26633f18$export$527d28eac40c15a9(`ORS API call failed: ${response.status} ${response.statusText}`));
            else {
                const batchResults = await response.json();
                allResults.push(...batchResults);
            }
        } catch (error) {
            logException(new $198609fd26633f18$export$527d28eac40c15a9(`ORS API call error: ${error}`));
        }
    }
    return allResults;
};
const $198609fd26633f18$export$71147d03c75fd54e = (githubResolvedResponse, githubLinkTimestampMap)=>{
    const edges = [];
    githubResolvedResponse.forEach((resolvedResponse)=>{
        if (resolvedResponse.status === $198609fd26633f18$var$OK_STATUS && resolvedResponse.body.meta.access === $198609fd26633f18$var$GRANTED && edges.length < $198609fd26633f18$var$RECENT_ACTIVITIES_LIMIT) {
            const originalTimestamp = githubLinkTimestampMap.get(resolvedResponse.body.data.url);
            const currentTimestamp = new Date().toISOString();
            const kebabCaseResourceType = $198609fd26633f18$var$camelToKebab(resolvedResponse.body.meta.resourceType);
            const typeMessage = kebabCaseResourceType && kebabCaseResourceType in (0, $cORSX.messages) ? (0, $cORSX.messages)[kebabCaseResourceType] : (0, $cORSX.messages).unrecognised;
            const githubEdge = {
                node: {
                    object: {
                        data: {
                            displayName: resolvedResponse.body.data.name || resolvedResponse.body.data.title,
                            url: resolvedResponse.body.data.url
                        },
                        id: (0, $731W9.sha256Hash)(resolvedResponse.body.data['@id']),
                        // Must hash id as it's ugc
                        type: typeMessage.defaultMessage,
                        product: 'github'
                    },
                    event: {
                        eventType: 'viewed',
                        timestamp: originalTimestamp || currentTimestamp
                    }
                },
                cursor: ''
            };
            edges.push(githubEdge);
        }
    });
    return $198609fd26633f18$var$limitToMostRecentActivities($198609fd26633f18$var$sortEdgesByTimestamp(edges), $198609fd26633f18$var$RECENT_ACTIVITIES_LIMIT);
};
const $198609fd26633f18$var$sortEdgesByTimestamp = (edges)=>{
    return edges.sort((a, b)=>{
        const timeA = new Date(a.node.event.timestamp).getTime();
        const timeB = new Date(b.node.event.timestamp).getTime();
        return timeB - timeA; // Descending order
    });
};
const $198609fd26633f18$var$limitToMostRecentActivities = (edges, limit = 200)=>{
    return edges.slice(0, limit);
};
const $198609fd26633f18$var$isJiraResult = (ari)=>{
    return ari.includes(':jira:');
};
const $198609fd26633f18$var$isConfluenceResult = (ari)=>{
    return ari.includes(':confluence:');
};
/**
 * Converts camelCase string to kebab-case
 * e.g., 'pullRequest' -> 'pull-request'
 */ const $198609fd26633f18$var$camelToKebab = (str)=>{
    return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};



var $abk4V = parcelRequire("abk4V");


var $7ULiR = parcelRequire("7ULiR");


var $joFH5 = parcelRequire("joFH5");

const $a3b72b1c5f32a0f4$var$GITHUB_CONTAINER_ID_PROD = 'c364f950-69f5-4812-9716-ed71a8d3d408_a57ca83d-597f-4de9-8dca-f9d3cd18d3a7';
const $a3b72b1c5f32a0f4$var$GITHUB_CONTAINER_ID_STAGING = '9bb160f8-1abb-4dc8-9780-ca5327e7ccc8_91300e36-3710-4f7b-aba2-95f43be1ac6f';
/**
 * Checks if a service has available GitHub accounts
 * @param services - Array of services to check
 * @returns boolean - true if GitHub service has available or refreshNeeded accounts
 */ const $a3b72b1c5f32a0f4$var$hasAvailableGithubAccount = (services)=>{
    return !!services?.find((s)=>s?.service?.serviceKey === 'github')?.accounts?.some((a)=>a?.status === 'available' || a?.status === 'refreshNeeded');
};
const $a3b72b1c5f32a0f4$export$950899af45fc526 = async ({ aaid: aaid, strategy: strategy, degradationCallback: degradationCallback, cacheAnalyticsCallback: cacheAnalyticsCallback })=>{
    if (strategy === 'container-specific') {
        const targetContainerId = (0, $joFH5.getEnvironment)() === 'production' ? $a3b72b1c5f32a0f4$var$GITHUB_CONTAINER_ID_PROD : $a3b72b1c5f32a0f4$var$GITHUB_CONTAINER_ID_STAGING;
        const data = await (0, $7ULiR.fetchOutboundAuthData)({
            aaid: aaid,
            containerId: targetContainerId,
            serviceKey: 'github',
            degradationCallback: degradationCallback,
            cacheAnalyticsCallback: cacheAnalyticsCallback
        });
        return $a3b72b1c5f32a0f4$var$hasAvailableGithubAccount(data?.services);
    } else if (strategy === 'all-containers') {
        const data = await (0, $abk4V.fetchAccountsByAaId)({
            aaid: aaid,
            degradationCallback: degradationCallback,
            cacheAnalyticsCallback: cacheAnalyticsCallback
        });
        return !!data?.containers?.some((container)=>$a3b72b1c5f32a0f4$var$hasAvailableGithubAccount(container.services));
    }
    return false;
};





const $914d54e8bd9a1675$export$f7b7f83c551ecf0b = (existingItems, newItems)=>{
    const deduplicatedResults = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))([
        ...existingItems,
        ...newItems
    ], (item)=>item.id);
    // We sort to show the most recent autorefreshed results in pre-query state.
    try {
        deduplicatedResults.sort((a, b)=>new Date(b.data.node.event.timestamp).getTime() - new Date(a.data.node.event.timestamp).getTime());
    } catch  {
    // If we have an error, the results simply won't be sorted.
    }
    return deduplicatedResults;
};









var $kJsRi = parcelRequire("kJsRi");


var $4TXTZ = parcelRequire("4TXTZ");


var $3R0ts = parcelRequire("3R0ts");

/**
 * Builds the `ml_lens` envelope for the Quick Find post-query `taskSuccess`
 * event, attaching per-product result counts in an ML-Lens-compatible shape.
 *
 * See: https://hello.atlassian.net/wiki/spaces/~93171358/pages/6820686403/
 *   GASv3+Events+Transformation+for+ML+Lens+Metrics+Schema
 *
 * Used by the `quick-find/postquery-search-results-ux` `taskSuccess` event.
 *
 * For `POSTQUERY_NO_RESULTS`, callers pass an empty `productCounts` object and
 * the envelope is still emitted with `metrics: []` so downstream consumers can
 * distinguish "post-query succeeded with zero results" from "ml_lens was not
 * attached at all".
 *
 * This is a thin, surface-specific wrapper around the generic
 * {@link buildMlLensEnvelope}.
 */ 
var $lHqdD = parcelRequire("lHqdD");

const $85a150055fc58773$export$f88d0928235f96eb = 'rovo.quick_find';
const $85a150055fc58773$export$9942b5a88584e08d = {
    page: 'quick_find',
    task: 'postquery_search_results_ux'
};
const $85a150055fc58773$export$490db5b6f5dc980c = 'results_per_connector';
const $85a150055fc58773$export$addc105232081b06 = (productCounts, userId)=>{
    const metrics = Object.entries(productCounts)// Stable ordering for deterministic payloads / easier diffing in QA.
    .sort(([a], [b])=>a.localeCompare(b)).map(([connector, value])=>({
            key: $85a150055fc58773$export$490db5b6f5dc980c,
            type: 'number',
            value: value,
            tags: {
                connector: connector
            }
        }));
    return (0, $lHqdD.buildMlLensEnvelope)({
        namespace: $85a150055fc58773$export$f88d0928235f96eb,
        baseTags: {
            ...$85a150055fc58773$export$9942b5a88584e08d
        },
        userId: userId,
        metrics: metrics
    });
};











const $33a13590dc77f914$export$caa45abe6a87e5b5 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'completed',
        actionSubject: 'searchRequest',
        actionSubjectId: 'postQuerySearchResults',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


























// Default value hoisted outside to prevent recreation on every render
const $785f0e86c2e88315$var$DEFAULT_TASK_STATE = {
    id: null,
    started: false,
    completed: false,
    error: null
};
const $785f0e86c2e88315$var$VitalStatsTaskContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $785f0e86c2e88315$export$40a6847b10816750 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    const taskStateRef = (0, $42omo.useRef)($785f0e86c2e88315$var$DEFAULT_TASK_STATE);
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($785f0e86c2e88315$var$VitalStatsTaskContext.Provider, {
            value: taskStateRef
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    // Use hoisted default to prevent object recreation on every render
    const taskStateRef = (0, $42omo.useRef)($785f0e86c2e88315$var$DEFAULT_TASK_STATE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($785f0e86c2e88315$var$VitalStatsTaskContext.Provider, {
        value: taskStateRef
    }, children);
};
const $785f0e86c2e88315$export$85fd2191723185b5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const taskStateRef = (0, $42omo.useContext)($785f0e86c2e88315$var$VitalStatsTaskContext);
    if (!taskStateRef) throw new Error("useVitalStatsTaskState must be used within QuickFindPostQueryVitalStatsProvider");
    return taskStateRef;
} : ()=>{
    const taskStateRef = (0, $42omo.useContext)($785f0e86c2e88315$var$VitalStatsTaskContext);
    if (!taskStateRef) throw new Error('useVitalStatsTaskState must be used within QuickFindPostQueryVitalStatsProvider');
    return taskStateRef;
};


const $a755cc866a3495f8$export$3b18f7e3dc975b4 = 250;
const $a755cc866a3495f8$export$7ebf6620acc135ab = $a755cc866a3495f8$export$3b18f7e3dc975b4;
const $a755cc866a3495f8$export$9e8b58cc1c8bacd2 = ()=>$a755cc866a3495f8$export$3b18f7e3dc975b4;
const $a755cc866a3495f8$export$483ef80309da5ade = ()=>{
    const { incrementQueryVersion: incrementQueryVersion } = (0, $djVCD.useSearchActions)();
    const onSearchCompleted = (0, $j4ply.useOnSearchCompleted)();
    const { fireAnalyticsEvent: fireQuickFindAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { fireAnalyticsEvent: fireVitalStatsEvent } = (0, $3CshZ.useAnalytics)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const userId = (0, $j4ply.useCurrentUserId)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const content = (0, $4VmlX.useContent)();
    const debounceTimeout = $a755cc866a3495f8$export$9e8b58cc1c8bacd2();
    // Store stable references for functions/values used in useEffect and useCallback
    // This avoids effects/callbacks re-running when analytics callbacks change,
    // while ensuring we always call the latest version via .current
    const fireVitalStatsEventRef = (0, $42omo.useRef)(fireVitalStatsEvent);
    const searchSessionIdRef = (0, $42omo.useRef)(searchSessionId);
    const userIdRef = (0, $42omo.useRef)(userId);
    // State tracking for pre-query VitalStats events
    const preQueryTaskIdRef = (0, $42omo.useRef)(null);
    const preQueryTaskStartedRef = (0, $42omo.useRef)(false);
    const preQueryTaskCompletedRef = (0, $42omo.useRef)(false);
    const preQueryErrorRef = (0, $42omo.useRef)(null);
    // State tracking for post-query VitalStats events using shared context
    const postQueryTaskState = (0, $785f0e86c2e88315$export$85fd2191723185b5)();
    // Store stable reference to postQueryTaskState to avoid adding it to dependency arrays
    const postQueryTaskStateRef = (0, $42omo.useRef)(postQueryTaskState);
    // Track if we've handled cached state for this dialog session (postquery only)
    const handledCachedPostQueryStateRef = (0, $42omo.useRef)(false);
    // Track if we've handled cached state for prequery (when transitioning back from postquery)
    const handledCachedPreQueryStateRef = (0, $42omo.useRef)(false);
    // Track if we've handled initial dialog open with cached preQuery
    const handledInitialCachedPreQueryRef = (0, $42omo.useRef)(false);
    // Keep refs updated with latest values
    (0, $42omo.useEffect)(()=>{
        fireVitalStatsEventRef.current = fireVitalStatsEvent;
        searchSessionIdRef.current = searchSessionId;
        userIdRef.current = userId;
        postQueryTaskStateRef.current = postQueryTaskState;
    }, [
        fireVitalStatsEvent,
        searchSessionId,
        userId,
        postQueryTaskState
    ]);
    // Handle initial dialog open with cached preQuery results
    // This fires VitalStats events when dialog opens with existing preQuery data
    (0, $42omo.useEffect)(()=>{
        // Reset flag when dialog closes
        if (!quickFindOpen) {
            handledInitialCachedPreQueryRef.current = false;
            return;
        }
        // Only fire once per dialog open session
        if (handledInitialCachedPreQueryRef.current) return;
        const state = content?.state;
        // Only fire if we have preQuery results showing but no task has started yet
        // This handles the case where dialog opens with cached preQuery results
        // Skip if we came from postQuery (that case is handled by the transition-back useEffect)
        if (state === 'PREQUERY_RESULTS' && !preQueryTaskStartedRef.current && !postQueryTaskStateRef.current.current.started) {
            handledInitialCachedPreQueryRef.current = true;
            // Use existing taskId if already set (e.g., by warmup request), otherwise generate new one
            if (!preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            const taskId = preQueryTaskIdRef.current;
            preQueryTaskStartedRef.current = true;
            // Fire both taskStart and taskSuccess immediately (results are cached)
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            preQueryTaskCompletedRef.current = true;
        }
    }, [
        quickFindOpen,
        content?.state
    ]);
    // Reset VitalStats state when dialog closes
    (0, $42omo.useEffect)(()=>{
        if (!quickFindOpen) {
            // Fire taskAbort if postQuery task is in progress
            if (postQueryTaskState.current.started && !postQueryTaskState.current.completed) (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskAbort)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: postQueryTaskState.current.id,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: {
                        abortReason: 'dialog_closed_during_network'
                    }
                }));
            });
            preQueryTaskStartedRef.current = false;
            preQueryTaskIdRef.current = null;
            preQueryTaskCompletedRef.current = false;
            preQueryErrorRef.current = null;
            postQueryTaskState.current.started = false;
            postQueryTaskState.current.id = null;
            postQueryTaskState.current.completed = false;
            // NOTE: We intentionally DO NOT clear postQueryTaskState.current.error here
            // so that when the dialog reopens with cached POSTQUERY_ERROR state,
            // we can still include error details in the taskFail event
            handledCachedPostQueryStateRef.current = false; // Reset for next open
            handledCachedPreQueryStateRef.current = false; // Reset for next open
            handledInitialCachedPreQueryRef.current = false; // Reset for next open
        }
    }, [
        quickFindOpen,
        postQueryTaskState
    ]);
    // Fire taskSuccess/taskFail when content state changes
    (0, $42omo.useEffect)(()=>{
        if (!preQueryTaskStartedRef.current || preQueryTaskCompletedRef.current) // Don't fire if task hasn't started or already completed
        return;
        if (content?.state === 'PREQUERY_RESULTS') {
            // Task succeeds when PRE_QUERY results are shown
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: preQueryTaskIdRef.current,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            preQueryTaskCompletedRef.current = true;
        } else if (content?.state === 'PREQUERY_ERROR') {
            // Include error information if available (errorName and errorMessage for debugging)
            const moreContext = preQueryErrorRef.current ? {
                errorName: preQueryErrorRef.current.name,
                errorMessage: preQueryErrorRef.current.message
            } : undefined;
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskFail)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: preQueryTaskIdRef.current,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS,
                    moreContext: moreContext
                }));
            });
            preQueryTaskCompletedRef.current = true;
        }
    }, [
        content?.state
    ]);
    // Reset preQuery tracking when transitioning back from POSTQUERY to PREQUERY
    (0, $42omo.useEffect)(()=>{
        const state_0 = content?.state;
        // If we're back in PREQUERY state after being in POSTQUERY, reset preQuery tracking
        // so that new preQuery VitalStats events can fire
        if (state_0 === 'PREQUERY_RESULTS' || state_0 === 'PREQUERY_ERROR' || state_0 === 'PREQUERY_LOADING') // Check if we previously had a postQuery task (indicates we're transitioning back)
        {
            if (postQueryTaskStateRef.current.current.started) {
                // Abort the postQuery task if it's still active (not completed)
                // This handles the case where user backspaces/clears text before postQuery results arrive
                if (!postQueryTaskStateRef.current.current.completed) {
                    (0, $42omo.startTransition)(()=>{
                        fireVitalStatsEventRef.current((0, $bQSQw.onTaskAbort)({
                            searchSessionId: searchSessionIdRef.current,
                            taskId: postQueryTaskStateRef.current.current.id,
                            task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                            moreContext: {
                                abortReason: 'text_cleared'
                            }
                        }));
                    });
                    postQueryTaskStateRef.current.current.completed = true;
                }
                // Reset preQuery tracking flags to allow new preQuery task to start
                preQueryTaskStartedRef.current = false;
                preQueryTaskCompletedRef.current = false;
                preQueryTaskIdRef.current = null;
            }
        }
    }, [
        content?.state
    ]);
    // Fire taskSuccess/taskFail for post-query when content state changes
    (0, $42omo.useEffect)(()=>{
        if (!postQueryTaskState.current.started || postQueryTaskState.current.completed) // Don't fire if task hasn't started or already completed
        return;
        const state_1 = content?.state;
        if (state_1 === 'POSTQUERY_RESULTS' || state_1 === 'POSTQUERY_NO_RESULTS') {
            // Snapshot per-product counts before `startTransition` defers the fire;
            // reads the DOM at the moment we commit the success transition.
            const mlLensMoreContext = (0, $dh538.fg)('rovo-search-ml-lens') ? {
                ml_lens: (0, $85a150055fc58773$export$addc105232081b06)((0, $9wmQG.getProductResultCounts)(), userIdRef.current)
            } : undefined;
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: postQueryTaskState.current.id,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: mlLensMoreContext
                }));
            });
            postQueryTaskState.current.completed = true;
        } else if (state_1 === 'POSTQUERY_ERROR') {
            // Include error information if available (errorName and errorMessage for debugging)
            const moreContext_0 = postQueryTaskState.current.error ? {
                errorName: postQueryTaskState.current.error.name,
                errorMessage: postQueryTaskState.current.error.message
            } : undefined;
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskFail)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: postQueryTaskState.current.id,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: moreContext_0
                }));
            });
            postQueryTaskState.current.completed = true;
        }
    }, [
        content?.state,
        postQueryTaskState
    ]);
    // Handle cached terminal states when dialog reopens
    // This fires VitalStats events for cached POSTQUERY_RESULTS/NO_RESULTS/ERROR states
    // when the dialog opens but no new fetch happens (e.g., same query as before)
    (0, $42omo.useEffect)(()=>{
        if (!quickFindOpen) return;
        // Only fire if task hasn't been started yet (dialog just opened)
        if (postQueryTaskState.current.started) return;
        // Only fire once per dialog open session
        if (handledCachedPostQueryStateRef.current) return;
        const state_2 = content?.state;
        // Check if we have cached terminal postquery states
        if (state_2 === 'POSTQUERY_RESULTS' || state_2 === 'POSTQUERY_NO_RESULTS' || state_2 === 'POSTQUERY_ERROR') {
            // Mark as handled to prevent duplicate events
            handledCachedPostQueryStateRef.current = true;
            // Start and immediately complete the task for the cached state
            const taskId_0 = crypto.randomUUID();
            postQueryTaskState.current.id = taskId_0;
            postQueryTaskState.current.started = true;
            postQueryTaskState.current.completed = true;
            // Fire taskStart and completion events (defer to not block rendering)
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId_0,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
                }));
                // Immediately fire completion event based on cached state
                if (state_2 === 'POSTQUERY_RESULTS' || state_2 === 'POSTQUERY_NO_RESULTS') {
                    const mlLensMoreContext_0 = (0, $dh538.fg)('rovo-search-ml-lens') ? {
                        ml_lens: (0, $85a150055fc58773$export$addc105232081b06)((0, $9wmQG.getProductResultCounts)(), userIdRef.current)
                    } : undefined;
                    fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                        searchSessionId: searchSessionIdRef.current,
                        taskId: taskId_0,
                        task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                        moreContext: mlLensMoreContext_0
                    }));
                } else if (state_2 === 'POSTQUERY_ERROR') {
                    // Note: error might be null since it was cleared on dialog close
                    const moreContext_1 = postQueryTaskState.current.error ? {
                        errorName: postQueryTaskState.current.error.name,
                        errorMessage: postQueryTaskState.current.error.message
                    } : undefined;
                    fireVitalStatsEventRef.current((0, $bQSQw.onTaskFail)({
                        searchSessionId: searchSessionIdRef.current,
                        taskId: taskId_0,
                        task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                        moreContext: moreContext_1
                    }));
                }
            });
            // Clear error after it's been used to prevent memory accumulation
            if (state_2 === 'POSTQUERY_ERROR') postQueryTaskState.current.error = null;
        }
    }, [
        quickFindOpen,
        content?.state,
        postQueryTaskState
    ]);
    // Handle transition back to PREQUERY_RESULTS from postquery states
    // This fires VitalStats events when user clears the search text and returns to prequery
    (0, $42omo.useEffect)(()=>{
        const state_3 = content?.state;
        // Reset the flag when entering postquery states so we can track the next transition back
        if (state_3 === 'POSTQUERY_LOADING' || state_3 === 'POSTQUERY_RESULTS' || state_3 === 'POSTQUERY_NO_RESULTS' || state_3 === 'POSTQUERY_ERROR') {
            handledCachedPreQueryStateRef.current = false;
            return;
        }
        // Only handle PREQUERY_RESULTS state
        if (state_3 !== 'PREQUERY_RESULTS') return;
        // Don't fire if we've already handled this transition
        if (handledCachedPreQueryStateRef.current) return;
        // Only fire if we previously had a postquery task (meaning we're transitioning back from postquery)
        // We fire events even if preQueryCompleted is false because the results might be cached
        // (i.e., dialog opened with existing cached results, so onPreQueryStart was never called)
        if (postQueryTaskStateRef.current.current.started) {
            // Mark as handled to prevent duplicate events
            handledCachedPreQueryStateRef.current = true;
            // Reset prequery flags and start a new prequery task for the cached results
            // Use existing taskId if already set (e.g., by warmup request), otherwise generate new one
            if (!preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            const taskId_1 = preQueryTaskIdRef.current;
            preQueryTaskStartedRef.current = true;
            preQueryTaskCompletedRef.current = false; // Set to false first so the state-watching useEffect doesn't interfere
            // Fire taskStart and taskSuccess (defer to not block rendering)
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId_1,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
                // Immediately fire taskSuccess for cached prequery results
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId_1,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            // Now mark as completed
            preQueryTaskCompletedRef.current = true;
        }
    }, [
        content?.state
    ]);
    /**
   * Called when pre-query search starts.
   * Fires VitalStats taskStart event to track the beginning of the pre-query operation.
   * Only fires when Quick Find is actually open (not during background preloading).
   * Ensures taskStart is only fired once per session.
   */ const onPreQueryStart = (0, $42omo.useCallback)(()=>{
        // Fire VitalStats taskStart event only if Quick Find is open and not already started
        // Skip if cached POSTQUERY results are showing (postQuery events will handle that case)
        if (quickFindOpen && !preQueryTaskStartedRef.current) {
            // Check if we have cached postQuery results - if so, don't fire preQuery events
            const state_4 = content?.state;
            if (state_4 === 'POSTQUERY_RESULTS' || state_4 === 'POSTQUERY_NO_RESULTS' || state_4 === 'POSTQUERY_ERROR') // Cached postQuery state detected - skip preQuery tracking
            // The cached postQuery useEffect will handle firing postQuery events
            return;
            // Generate a consistent taskId for this pre-query task
            if (!preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: preQueryTaskIdRef.current,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                }));
            });
            preQueryTaskStartedRef.current = true;
            // If cached preQuery data is already showing,
            // immediately fire taskSuccess since the useEffect won't trigger (no state change)
            if (content?.state === 'PREQUERY_RESULTS') {
                (0, $42omo.startTransition)(()=>{
                    fireVitalStatsEventRef.current((0, $bQSQw.onTaskSuccess)({
                        searchSessionId: searchSessionIdRef.current,
                        taskId: preQueryTaskIdRef.current,
                        task: (0, $31eSD.TASK_NAMES).QUICK_FIND_PRE_QUERY_RESULTS
                    }));
                });
                preQueryTaskCompletedRef.current = true;
            }
        }
    }, [
        quickFindOpen,
        content?.state
    ]);
    /**
   * Called when pre-query search completes successfully.
   * VitalStats taskSuccess event is automatically fired by useEffect when content.state changes to PREQUERY_RESULTS.
   */ const onPreQuerySuccess = (0, $42omo.useCallback)(()=>{
    // VitalStats success event is handled by useEffect watching content.state
    }, []);
    /**
   * Called when pre-query search fails with an error.
   * Stores error details (name, message) which will be included in the VitalStats taskFail event.
   * VitalStats taskFail event is automatically fired by useEffect when content.state changes to PREQUERY_ERROR.
   *
   * @param error - Optional Error object containing failure details. Error messages should not contain PII.
   */ const onPreQueryFailure = (0, $42omo.useCallback)((error)=>{
        // Store error for useEffect to access
        if (error) preQueryErrorRef.current = error;
    // VitalStats fail event is handled by useEffect watching content.state
    }, []);
    const onPostQueryStart = (0, $42omo.useCallback)(()=>{
        // If dialog is closed, fire taskStart + immediate taskAbort to track background cache request
        // Network request still fires for caching, but user isn't waiting for it
        if (!quickFindOpen) {
            // Generate taskId for the background cache request
            const taskId_2 = crypto.randomUUID();
            postQueryTaskState.current.id = taskId_2;
            postQueryTaskState.current.started = true;
            postQueryTaskState.current.completed = true; // Mark as completed immediately
            (0, $42omo.startTransition)(()=>{
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId_2,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
                }));
                fireVitalStatsEventRef.current((0, $bQSQw.onTaskAbort)({
                    searchSessionId: searchSessionIdRef.current,
                    taskId: taskId_2,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: {
                        abortReason: 'dialog_closed_before_debounce_fired'
                    }
                }));
            });
            return;
        }
        // Abort previous task if still active
        if (postQueryTaskState.current.started && !postQueryTaskState.current.completed) (0, $42omo.startTransition)(()=>{
            fireVitalStatsEventRef.current((0, $bQSQw.onTaskAbort)({
                searchSessionId: searchSessionIdRef.current,
                taskId: postQueryTaskState.current.id,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                moreContext: {
                    abortReason: 'superseded_by_new_query'
                }
            }));
        });
        // Start new task - use existing taskId if already set (e.g., by fetchQuickFindPostQuery)
        // Only generate a new one if not already set or if we just aborted a previous task
        if (!postQueryTaskState.current.id || postQueryTaskState.current.started) postQueryTaskState.current.id = crypto.randomUUID();
        const taskId_3 = postQueryTaskState.current.id;
        postQueryTaskState.current.started = true;
        postQueryTaskState.current.completed = false;
        (0, $42omo.startTransition)(()=>{
            fireVitalStatsEventRef.current((0, $bQSQw.onTaskStart)({
                searchSessionId: searchSessionIdRef.current,
                taskId: taskId_3,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
            }));
        });
        /**
     * QS-7380 (LDR: https://hello.atlassian.net/wiki/x/QVo8QwE)
     * Aborting on keypress fires a lot of dirty data volume to ufo. Instead we only instrument on query (inside the debounce), offsetting the start time by the debounce window because the keypress that trigger the debounce is the start of the interaction.
     */ const startTimestamp = performance.now() - debounceTimeout;
        // Only begin the interaction if QF is still open
        // If QF is closed, we still make the network request, so the next open of the same text is instant
        // However, we must not start the interaction, as if QF is closed during the debounce window, this interaction can abort other intreractions, like FPS search results shown!
        if (quickFindOpen) (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_POST_QUERY_INTERACTION), startTimestamp);
    }, [
        quickFindOpen,
        debounceTimeout,
        postQueryTaskState
    ]);
    const onPostQuerySuccess = (0, $42omo.useCallback)((duration, hasThirdPartyResults, resultCount)=>{
        incrementQueryVersion();
        onSearchCompleted?.(resultCount, quickFindQuery);
        fireQuickFindAnalyticsEvent((0, $33a13590dc77f914$export$caa45abe6a87e5b5)({
            attributes: {
                ...commonAttributes,
                postQueryRequestDurationMs: duration,
                hasThirdPartyResults: hasThirdPartyResults
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireQuickFindAnalyticsEvent,
        incrementQueryVersion,
        nonPrivacySafeAttributes,
        onSearchCompleted,
        quickFindQuery
    ]);
    const onPostQueryFailure = (0, $42omo.useCallback)((error_0)=>{
        (0, $kJsRi.setInteractionError)((0, $3R0ts.QUICK_FIND_POST_QUERY_INTERACTION), {
            errorMessage: error_0?.message || 'request failed',
            name: error_0?.name || 'request failed'
        });
        // Store error for useEffect to access when state changes to POSTQUERY_ERROR
        if (error_0) postQueryTaskState.current.error = error_0;
    }, [
        postQueryTaskState
    ]);
    const onPostQueryCancel = (0, $42omo.useCallback)(()=>{}, []);
    return (0, $42omo.useMemo)(()=>({
            onPreQueryStart: onPreQueryStart,
            onPreQuerySuccess: onPreQuerySuccess,
            onPreQueryFailure: onPreQueryFailure,
            onPostQueryStart: onPostQueryStart,
            onPostQuerySuccess: onPostQuerySuccess,
            onPostQueryFailure: onPostQueryFailure,
            onPostQueryCancel: onPostQueryCancel,
            postQueryTaskState: postQueryTaskState,
            preQueryTaskIdRef: preQueryTaskIdRef
        }), [
        onPostQueryCancel,
        onPostQueryFailure,
        onPostQueryStart,
        onPostQuerySuccess,
        onPreQueryFailure,
        onPreQueryStart,
        onPreQuerySuccess,
        postQueryTaskState
    ]);
};



var $3paC4 = parcelRequire("3paC4");


var $iUYhn = parcelRequire("iUYhn");




const $ef123373d1331d42$export$15543ec9771a9a65 = async (user, cloudId)=>{
    const searchClient = (0, $3paC4.createClient)({
        cloudId: cloudId || ''
    });
    const searchProjectsResponse = await searchClient.search({
        query: '',
        resultLimit: 1,
        scopes: [
            (0, $iUYhn.Scope).JiraProject
        ],
        analytics: {
            identifier: 'quick-find'
        }
    });
    const firstProject = searchProjectsResponse?.response.rawData.scopes?.[0]?.results?.[0];
    return [
        {
            id: 'product-filter',
            title: 'Suggested product filter',
            type: 'filter-suggestion',
            data: {
                product: {
                    filterName: 'app',
                    option: {
                        value: (0, $6Gsan.PrimaryProductKeys).Jira,
                        label: 'Jira'
                    }
                },
                ...firstProject && {
                    jProject: {
                        filterName: 'project',
                        option: {
                            value: firstProject.id,
                            label: firstProject.name
                        }
                    }
                },
                ...user?.id && {
                    jAssignee: {
                        filterName: 'assignee',
                        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                        option: {
                            value: user.id,
                            label: user.name || 'me'
                        }
                    }
                }
            }
        }
    ];
};


const $eb3355f5ff6969a5$export$fad190a164f62f75 = ()=>{
    return 'all-containers';
};



var $1L3gY = parcelRequire("1L3gY");

const $6e53edd4c7804f3e$export$290039782fc4e47 = async (query, organizationId, primaryProduct, principalId, siteId)=>{
    // Override townsquare with watermelon as URS does not support townsquare as a primary product
    const productKey = primaryProduct === 'townsquare' ? 'watermelon' : primaryProduct;
    const response = await (0, $1L3gY.default)({
        query: query,
        context: {
            contextType: 'quick_find',
            siteId: siteId,
            productKey: productKey,
            principalId: principalId,
            organizationId: organizationId
        },
        includeUsers: true,
        includeTeams: true,
        includeGroups: false,
        maxNumberOfResults: 2,
        performSearchQueryOnly: false,
        searchQuery: {
            filter: 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)'
        }
    });
    return response.map($6e53edd4c7804f3e$export$cf1f13813d90479a);
};
const $6e53edd4c7804f3e$export$cf1f13813d90479a = (result)=>({
        id: result.id,
        title: result.name || result.displayName || '',
        data: result,
        type: 'people-and-teams'
    });









var $efKMM = parcelRequire("efKMM");





var $6jKOp = parcelRequire("6jKOp");


var $johDC = parcelRequire("johDC");


var $chwej = parcelRequire("chwej");


var $hm6w9 = parcelRequire("hm6w9");


var $i6s7M = parcelRequire("i6s7M");


var $7YJRT = parcelRequire("7YJRT");


var $idpYy = parcelRequire("idpYy");





var $dOOW1 = parcelRequire("dOOW1");


var $5XpfZ = parcelRequire("5XpfZ");

const $d781446cbf339237$var$createValidationError = (message)=>{
    return {
        success: false,
        error: {
            name: 'ValidationError',
            message: message
        }
    };
};
const $d781446cbf339237$var$validateBaseSearchResultsResponse = (response)=>{
    if (!response) return $d781446cbf339237$var$createValidationError('Response is null or undefined');
    // GraphQL response should always include a `data` key (it can be null)
    if (!('data' in response)) return $d781446cbf339237$var$createValidationError('Response missing "data" field');
    if (!response.data) return {
        success: true
    };
    const data = response.data;
    if (!data.search) return $d781446cbf339237$var$createValidationError('Response missing "data.search" field');
    if (!data.search.results) return $d781446cbf339237$var$createValidationError('Response missing "data.search.results" field');
    if (!('edges' in data.search.results)) return $d781446cbf339237$var$createValidationError('Response missing "data.search.results.edges" field');
    if (!Array.isArray(data.search.results.edges)) return $d781446cbf339237$var$createValidationError('Expected "data.search.results.edges" to be an array');
    if (response.extensions !== undefined && response.extensions !== null) {
        if (typeof response.extensions !== 'object') return $d781446cbf339237$var$createValidationError('Expected "extensions" to be an object');
    }
    if (response.errors !== undefined && response.errors !== null) {
        if (!Array.isArray(response.errors)) return $d781446cbf339237$var$createValidationError('Expected "errors" to be an array');
    }
    return {
        success: true
    };
};
const $d781446cbf339237$var$validateEdgesHaveRenderableNodes = (response, productName)=>{
    const baseResult = $d781446cbf339237$var$validateBaseSearchResultsResponse(response);
    if (!baseResult.success) return baseResult;
    if (!response.data) return {
        success: true
    };
    const edges = response.data.search?.results?.edges;
    if (!edges || edges.length === 0) return {
        success: true
    };
    for(let i = 0; i < edges.length; i++){
        const node = edges[i]?.node;
        if (!node) return $d781446cbf339237$var$createValidationError(`${productName} response has null/undefined node at index ${i}`);
        if (!node.id || typeof node.id !== 'string' || node.id.length === 0) return $d781446cbf339237$var$createValidationError(`${productName} response node at index ${i} missing valid 'id'`);
        // title can be empty string but not null/undefined
        if (node.title === null || node.title === undefined) return $d781446cbf339237$var$createValidationError(`${productName} response node at index ${i} missing 'title'`);
    }
    return {
        success: true
    };
};
const $d781446cbf339237$export$20b56250dbe571a6 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Confluence entities');
};
const $d781446cbf339237$export$8a51174b28efed00 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Confluence spaces');
};
const $d781446cbf339237$export$bced2ae2552eb202 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Jira issues');
};
const $d781446cbf339237$export$543d873e6345fc5d = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Jira entities');
};
const $d781446cbf339237$export$e4f72abe33981720 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Atlas');
};
const $d781446cbf339237$export$871e055bca75b7a7 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Mercury');
};
const $d781446cbf339237$export$ed329220155db920 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Talent');
};
const $d781446cbf339237$export$e72eeeb1dc40af20 = (response)=>{
    return $d781446cbf339237$var$validateEdgesHaveRenderableNodes(response, 'Assets');
};


const $d482bbe0b8132b8c$var$experience = 'quick-find';
/**
 * Builds merged headers combining atl-attribution and region steering headers.
 * Feature flag check for atl-attribution is handled internally by buildAtlAttributionHeaders.
 */ const $d482bbe0b8132b8c$var$buildMergedHeaders = (cloudId, activationId, sourceProduct, productDataRegions)=>{
    // Feature flag check is handled internally by buildAtlAttributionHeaders
    const atlAttributionHeaders = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: sourceProduct
    });
    const regionSteeringHeaders = sourceProduct && productDataRegions ? {
        'atl-edge-region-hint': (0, $chwej.getEdgeRegionHint)(sourceProduct, productDataRegions)
    } : undefined;
    if (!atlAttributionHeaders && !regionSteeringHeaders) return undefined;
    return {
        ...regionSteeringHeaders,
        ...atlAttributionHeaders
    };
};
const $d482bbe0b8132b8c$export$263a3384b7ce18b1 = (thirdPartyConfigs)=>{
    const excluded3PProducts = [
        (0, $b4tvS.ProductKeys3P).Slack,
        (0, $b4tvS.ProductKeys3P).Teams,
        (0, $b4tvS.ProductKeys3P).Gmail,
        (0, $b4tvS.ProductKeys3P).OutlookMail
    ];
    // Adding additional 3P products not included in thirdPartyConfigs
    const additional3PProducts = [
        (0, $b4tvS.ProductKeys3P).Loom // Loom is 1P product but treated as 3P in API filters
    ];
    const thirdPartyKeys = Object.keys(thirdPartyConfigs);
    const quickFind3PProducts = additional3PProducts.concat(thirdPartyKeys).filter((productKey)=>!excluded3PProducts.includes(productKey));
    return (0, $dOOW1.getThirdPartyFilters)(quickFind3PProducts, false, // titleMatchOnly value
    [], // it will search all subtypes if no entities are provided
    thirdPartyConfigs);
};
// Experiment cohorts explained here: https://hello.atlassian.net/wiki/spaces/CentAI/pages/6112212590/Experiment+Milestones+for+Adding+3Ps+to+Search+Results
const $d482bbe0b8132b8c$var$serve3PinQuickFindTest1 = (prerequisiteConditions)=>{
    return prerequisiteConditions && (0, $c6GJD.default).getExperimentValue('quick_find_3p_search_results_experiment', 'cohort', 'control') === 'test-1';
};
// Experiment cohorts explained here: https://hello.atlassian.net/wiki/spaces/CentAI/pages/6112212590/Experiment+Milestones+for+Adding+3Ps+to+Search+Results
const $d482bbe0b8132b8c$var$serve3PinQuickFindTest2 = (prerequisiteConditions)=>{
    return prerequisiteConditions && (0, $c6GJD.default).getExperimentValue('quick_find_3p_search_results_experiment', 'cohort', 'control') === 'test-2';
};
const $d482bbe0b8132b8c$export$3c29f91d40cd1d3f = (thirdPartyConfigs)=>{
    // Prerequisite: We should not request 3P in Quick Find if the user does not have any 3P authenticated
    const isEligible3PUser = Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
    const prerequisiteConditions = isEligible3PUser;
    const serveTest1 = $d482bbe0b8132b8c$var$serve3PinQuickFindTest1(prerequisiteConditions);
    const serveTest2 = $d482bbe0b8132b8c$var$serve3PinQuickFindTest2(prerequisiteConditions);
    return {
        serveThirdPartyFilters: serveTest1 || serveTest2,
        serveGraphDocument: serveTest1 || serveTest2,
        serveGraphSmartlinks: serveTest1 || serveTest2,
        skip3pHydration: serveTest1 || serveTest2,
        serveAdditionalGraphEntities: serveTest1
    };
};
/**
 * Returns a copy of `filters` with `entity` added to the GitHub `thirdPartyProducts` entry's
 * `entities` array. Scopes the requested entity to GitHub only (vs the top-level `entities`
 * field which fans the request out to every connected 3P provider). No-op if no GitHub entry
 * exists.
 */ const $d482bbe0b8132b8c$var$addEntityToGitHubProduct = (filters, entity)=>({
        ...filters,
        thirdPartyProducts: filters?.thirdPartyProducts?.map((product)=>{
            if (product.product !== 'github') return product;
            const entities = new Set([
                ...product.entities ?? [],
                entity
            ]);
            return {
                ...product,
                entities: [
                    ...entities
                ]
            };
        })
    });
const $d482bbe0b8132b8c$var$GITHUB_PRODUCT_KEYS = [
    (0, $b4tvS.ProductKeys3P).Github,
    (0, $b4tvS.ProductKeys3P).ForgePioGithubDev,
    (0, $b4tvS.ProductKeys3P).ForgePioGithubProd
];
const $d482bbe0b8132b8c$var$hasGitHubConnected = (thirdPartyConfigs)=>$d482bbe0b8132b8c$var$GITHUB_PRODUCT_KEYS.some((key)=>thirdPartyConfigs[key]?.userNeedsOAuth === false);
const $d482bbe0b8132b8c$var$hasGitHubImpersonationEnabled = (thirdPartyConfigs)=>!!(thirdPartyConfigs[(0, $b4tvS.ProductKeys3P).Github]?.userNeedsOAuth && thirdPartyConfigs[(0, $b4tvS.ProductKeys3P).Github]?.impersonationEnabled && (0, $dh538.fg)('weaklink-github-fg'));
const $d482bbe0b8132b8c$export$f1b35c234241f2ba = (thirdPartyConfigs)=>{
    return {
        serveGitHub3P: $d482bbe0b8132b8c$var$hasGitHubConnected(thirdPartyConfigs) || $d482bbe0b8132b8c$var$hasGitHubImpersonationEnabled(thirdPartyConfigs)
    };
};
const $d482bbe0b8132b8c$export$a850af7b2e4494bd = (thirdPartyConfigs)=>{
    const gitHubThirdPartyConfigs = {};
    for (const key of $d482bbe0b8132b8c$var$GITHUB_PRODUCT_KEYS)if (thirdPartyConfigs[key]) gitHubThirdPartyConfigs[key] = thirdPartyConfigs[key];
    return (0, $dOOW1.getThirdPartyFilters)($d482bbe0b8132b8c$var$GITHUB_PRODUCT_KEYS, false, // titleMatchOnly value
    [], // search all subtypes
    gitHubThirdPartyConfigs);
};
const $d482bbe0b8132b8c$export$9605a5c4a68b2654 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, filteredEntities, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const quickFind3PExperiment = $d482bbe0b8132b8c$export$3c29f91d40cd1d3f(thirdPartyConfigs);
    let thirdPartyFilters = quickFind3PExperiment.serveThirdPartyFilters ? $d482bbe0b8132b8c$export$263a3384b7ce18b1(thirdPartyConfigs) : {
        titleMatchOnly: true,
        subtypes: []
    };
    const supportedEntities = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost',
        'ati:cloud:confluence:attachment',
        'ati:cloud:confluence:whiteboard',
        ...(0, $efKMM.isContentTypeEnabledInCurrentEnv)('slide') && (0, $c6GJD.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false, {
            fireExperimentExposure: true
        }) === true ? [
            'ati:cloud:confluence:slide'
        ] : [],
        'ati:cloud:confluence:database',
        'ati:cloud:confluence:embed',
        'ati:cloud:confluence:folder',
        ...quickFind3PExperiment.serveGraphDocument ? [
            'ati:cloud:graph:document'
        ] : [],
        ...(0, $dh538.fg)('quickfind-smartlinks') || quickFind3PExperiment.serveGraphSmartlinks ? [
            'ati:cloud:graph:remote-link'
        ] : [],
        ...quickFind3PExperiment.serveAdditionalGraphEntities ? [
            'ati:cloud:graph:branch',
            'ati:cloud:graph:calendar-event',
            'ati:cloud:graph:design',
            'ati:cloud:graph:pull-request',
            'ati:cloud:graph:repository',
            'ati:cloud:graph:video',
            'ati:cloud:graph:work-item'
        ] : []
    ];
    const entities = supportedEntities.filter((supportedEntity)=>filteredEntities.includes(supportedEntity));
    // GitHub code search is independently gated: any user with GitHub connected and the gate
    // on gets code results, regardless of which other 3P experiment cohort they're in.
    // Scope the document entity to the GitHub thirdPartyProducts entry (not the top-level
    // entities array) so we don't fan the request out to every other 3P provider.
    const isGitHubConnectedForConfluence = $d482bbe0b8132b8c$var$GITHUB_PRODUCT_KEYS.some((key)=>thirdPartyConfigs[key]?.userNeedsOAuth === false);
    if (isGitHubConnectedForConfluence && (0, $dh538.fg)('rovo_github_code_search')) thirdPartyFilters = $d482bbe0b8132b8c$var$addEntityToGitHubProduct(thirdPartyFilters, 'ati:cloud:graph:document');
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId,
        thirdPartyFilters: thirdPartyFilters
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    // Default behaviour currently is to include the confluenceEntity hydration,
    // hence the control is to include it. But we check that the cohort is explicitly
    // 'test' to ensure that this user is actually in the experiment.
    const excludeConfluenceEntity = (0, $c6GJD.default).getExperimentValue('remove_confluence_entity_hydration_experiment', 'cohort', 'control') === 'test';
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 7,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId ?? undefined,
        shadowExperimentId: shadowExperimentId ?? undefined,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeUserSignals: false,
        includeSpaceSubtype: false,
        includeConfluenceEntity: !excludeConfluenceEntity,
        skipFieldsFor3pInQuickFind: quickFind3PExperiment.skip3pHydration,
        includeGithubEntityHydration: false,
        includeAutocompleteSuggestions: (0, $dh538.fg)('fe_quickfind_autocomplete_suggestions')
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$20b56250dbe571a6)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        const autocompleteSuggestions = response.data?.search?.results.autocompleteSuggestions;
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || [],
            autocompleteSuggestions: autocompleteSuggestions
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined,
            autocompleteSuggestions: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$919c2c6ec09a9e2 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:confluence:space'
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 1,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId ?? undefined,
        shadowExperimentId: shadowExperimentId ?? undefined,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$8a51174b28efed00)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchSpacesRequestId: response.extensions?.gateway?.request_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchSpacesRequestId: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$65df7212bf163b08 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const quickFind3PExperiment = $d482bbe0b8132b8c$export$3c29f91d40cd1d3f(thirdPartyConfigs);
    const thirdPartyFilters = quickFind3PExperiment.serveThirdPartyFilters ? $d482bbe0b8132b8c$export$263a3384b7ce18b1(thirdPartyConfigs) : {
        titleMatchOnly: false,
        subtypes: []
    };
    const entities = [
        'ati:cloud:townsquare:project',
        'ati:cloud:townsquare:goal',
        'ati:cloud:townsquare:tag',
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost',
        (0, $idpYy.JIRA_ISSUE_ENTITY_ATI),
        ...quickFind3PExperiment.serveGraphDocument ? [
            'ati:cloud:graph:document'
        ] : [],
        ...quickFind3PExperiment.serveGraphSmartlinks ? [
            'ati:cloud:graph:remote-link'
        ] : [],
        ...quickFind3PExperiment.serveAdditionalGraphEntities ? [
            'ati:cloud:graph:branch',
            'ati:cloud:graph:calendar-event',
            'ati:cloud:graph:design',
            'ati:cloud:graph:pull-request',
            'ati:cloud:graph:repository',
            'ati:cloud:graph:video',
            'ati:cloud:graph:work-item'
        ] : []
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        assetsFilters: assetsFilters,
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: [],
            titleMatchOnly: true,
            contentStatuses: [],
            containerStatus: []
        },
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false,
        skipFieldsFor3pInQuickFind: quickFind3PExperiment.skip3pHydration,
        includeGithubEntityHydration: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$e4f72abe33981720)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$60162ce0dfbba9f8 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters, thirdPartyFilters: selectedThirdPartyFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    // Respect explicit user-selected 3P filters if provided; otherwise fall back to the empty default.
    const thirdPartyFilters = selectedFilters?.thirdPartyFilters ?? selectedThirdPartyFilters;
    const passionfruitAskEntity = 'ati:cloud:passionfruit:ask';
    const organizationEntity = 'ati:cloud:mercury:organization';
    const organizationStatusUpdateEntity = 'ati:cloud:mercury:organization-status-update';
    const entities = [
        'ati:cloud:mercury:focus-area',
        'ati:cloud:mercury:focus-area-status-update',
        ...(0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled') ? [
            passionfruitAskEntity
        ] : [],
        ...(0, $dh538.fg)('platform_organization_search_onboarding_enabled') ? [
            organizationEntity,
            organizationStatusUpdateEntity
        ] : []
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false,
        includeGithubEntityHydration: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$871e055bca75b7a7)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$39ffd40a0e828404 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters, talentFilters: talentFilters, thirdPartyFilters: selectedThirdPartyFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    // Respect explicit user-selected 3P filters if provided; otherwise fall back to the empty default.
    const thirdPartyFilters = selectedFilters?.thirdPartyFilters ?? selectedThirdPartyFilters;
    const entities = [
        'ati:cloud:radar:position'
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        talentFilters: talentFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false,
        includeGithubEntityHydration: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$ed329220155db920)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$7e4a42258e6edc26 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, thirdPartyConfigs, sessionId, networkCallbacks, activationId)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, assetsFilters: assetsFilters, thirdPartyFilters: selectedThirdPartyFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    // Respect explicit user-selected 3P filters if provided; otherwise fall back to the empty default.
    const thirdPartyFilters = selectedFilters?.thirdPartyFilters ?? selectedThirdPartyFilters;
    const entities = [
        'ati:cloud:cmdb:object',
        'ati:cloud:cmdb:schema',
        'ati:cloud:cmdb:type'
    ];
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        assetsFilters: assetsFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeSpaceSubtype: false,
        includeGithubEntityHydration: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$e72eeeb1dc40af20)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || []
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined
        };
    }
};
/**
 * The experiment layers are mapped to ensure permitted attributes are sent into search requests.
 */ const $d482bbe0b8132b8c$var$mapExperimentLayers = (experimentLayers)=>experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
            name: name,
            layerId: layerId,
            shadowId: shadowId,
            definitions: definitions
        }));
const $d482bbe0b8132b8c$export$eaafe46561fa4ee5 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, isJiraIssueIndexed, thirdPartyConfigs, typeFilterEntities, sessionId, hasEditOrViewPlanPermission, networkCallbacks, activationId)=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, jiraFilters: jiraFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery } = typeFilterEntities;
    const gitHub3PExperiment = $d482bbe0b8132b8c$export$f1b35c234241f2ba(thirdPartyConfigs);
    const supportedEntities = [
        (0, $idpYy.JIRA_ISSUE_ENTITY_ATI),
        (0, $idpYy.JIRA_PROJECT_ENTITY_ATI),
        (0, $idpYy.JIRA_BOARD_ENTITY_ATI),
        (0, $idpYy.JIRA_FILTER_ENTITY_ATI),
        (0, $idpYy.JIRA_DASHBOARD_ENTITY_ATI)
    ];
    if (hasEditOrViewPlanPermission) supportedEntities.push((0, $idpYy.JIRA_PLAN_ENTITY_ATI));
    const entities = selectedEntities.length ? supportedEntities.filter((supportedEntity)=>entitiesForQuery.includes(supportedEntity)) : [
        (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
    ];
    const isCodeSearchEnabled = (0, $dh538.fg)('rovo_github_code_search');
    // GitHub entities are appended directly to the final entities array because they are
    // not part of Jira's type mapping in useTypeEntities, so they would be lost if included
    // in supportedEntities (filtered out on the type-filter path, absent on the default path).
    if (gitHub3PExperiment.serveGitHub3P) entities.push(...(0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI), ...(0, $i6s7M.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI));
    let gitHubThirdPartyFilters = gitHub3PExperiment.serveGitHub3P ? $d482bbe0b8132b8c$export$a850af7b2e4494bd(thirdPartyConfigs) : thirdPartyFilters;
    // Scope the document entity to GitHub only via thirdPartyProducts[github].entities.
    if (gitHub3PExperiment.serveGitHub3P && isCodeSearchEnabled) gitHubThirdPartyFilters = $d482bbe0b8132b8c$var$addEntityToGitHubProduct(gitHubThirdPartyFilters, 'ati:cloud:graph:document');
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        thirdPartyFilters: gitHubThirdPartyFilters
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:jira::site/${cloudId}`,
        tenantId: cloudId,
        limit: 12,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: gitHubThirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeJiraIssueType: true,
        includeSpaceSubtype: false,
        assetsFilters: assetsFilters,
        skipFieldsFor3pInQuickFind: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$bced2ae2552eb202)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        const autocompleteSuggestions = response.data?.search?.results.autocompleteSuggestions;
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            fetchEntitiesRequestId: response.extensions?.gateway?.request_id,
            fetchEntitiesTraceId: response.extensions?.gateway?.trace_id,
            errors: response.errors || [],
            autocompleteSuggestions: autocompleteSuggestions
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            fetchEntitiesRequestId: undefined,
            fetchEntitiesTraceId: undefined,
            autocompleteSuggestions: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$cfa5e5437133749b = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, isJiraIssueIndexed, thirdPartyConfigs, sessionId, hasEditOrViewPlanPermission, networkCallbacks, activationId)=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, jiraFilters: jiraFilters, assetsFilters: assetsFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        (0, $idpYy.JIRA_BOARD_ENTITY_ATI),
        (0, $idpYy.JIRA_FILTER_ENTITY_ATI),
        (0, $idpYy.JIRA_PROJECT_ENTITY_ATI),
        (0, $idpYy.JIRA_DASHBOARD_ENTITY_ATI)
    ];
    if (hasEditOrViewPlanPermission) entities.push((0, $idpYy.JIRA_PLAN_ENTITY_ATI));
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId,
        isJiraIssueIndexed: isJiraIssueIndexed
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:jira::site/${cloudId}`,
        tenantId: cloudId,
        limit: 5,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        compassFilters: compassFilters,
        thirdPartyFilters: thirdPartyFilters,
        assetsFilters: assetsFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sessionId: sessionId,
        sourceProduct: sourceProduct,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers),
        includeSocialSignals: false,
        includeJiraBoardContainer: true,
        includeSpaceSubtype: false
    };
    const headers = $d482bbe0b8132b8c$var$buildMergedHeaders(cloudId, activationId, sourceProduct, productDataRegions);
    networkCallbacks?.onStart();
    try {
        const response = await (0, $johDC.searchDialogQuery)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.extractTraceInfoFromResponse)(response) : undefined;
        if (networkCallbacks) {
            const validationResult = (0, $d781446cbf339237$export$543d873e6345fc5d)(response);
            if (!validationResult.success) networkCallbacks.onError(validationResult.error.name, validationResult.error.message, traceInfo);
            else networkCallbacks.onSuccess(traceInfo);
        }
        const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
        const autocompleteSuggestions = response.data?.search?.results.autocompleteSuggestions;
        return {
            fetchResults: $d482bbe0b8132b8c$var$processAndValidateNodes(nodes),
            errors: response.errors || [],
            autocompleteSuggestions: autocompleteSuggestions
        };
    } catch (error) {
        // Network failure caught here
        if (networkCallbacks) networkCallbacks.onError(error.name || 'NetworkError', error.message || 'Failed to fetch search results');
        // Return empty results to allow graceful degradation
        return {
            fetchResults: [],
            errors: [],
            autocompleteSuggestions: undefined
        };
    }
};
const $d482bbe0b8132b8c$export$cf1f13813d90479a = (result)=>{
    // Detect and filter out invalid/empty nodes from API
    // Allow empty strings but not null/undefined
    if (!result || !result.id || result.title == null) return null;
    return {
        id: result.id,
        title: result.title,
        data: result,
        type: 'search-result'
    };
};
/**
 * Processes nodes and filters out invalid ones.
 */ const $d482bbe0b8132b8c$var$processAndValidateNodes = (nodes)=>{
    const mappedNodes = nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a);
    const validNodes = mappedNodes.filter((node)=>node !== null);
    return validNodes;
};



var $1SV4e = parcelRequire("1SV4e");

const $1435b53be5ab4d50$export$d6415f081f333b17 = (primaryProduct, userId)=>{
    const recentSearches = (0, $1SV4e.getRecentSearches)({
        userId: userId,
        productId: primaryProduct,
        key: (0, $1SV4e.RECENT_SEARCH_KEY)
    });
    return recentSearches.map($1435b53be5ab4d50$export$cf1f13813d90479a);
};
const $1435b53be5ab4d50$export$cf1f13813d90479a = (value)=>{
    const data = (0, $1SV4e.getRecentQueryObject)(value);
    return {
        id: data.query,
        title: data.query,
        data: data,
        type: 'recent-query'
    };
};



var $e2CiB = parcelRequire("e2CiB");

const $24aba19999dc15f9$export$5e799f849d8e922b = 20;
const $24aba19999dc15f9$export$4858b654778bd2b4 = async (cloudId, userId, aggAbsoluteUrl, headers, featureServiceModel)=>{
    const response = await (0, $e2CiB.cachedRecommendedDocumentsQuery)({
        variables: {
            userId: userId,
            tenantId: cloudId,
            caller: 'quick-find',
            maxNumberOfResults: $24aba19999dc15f9$export$5e799f849d8e922b,
            // Only sent when the user is in the
            // `quick_find_recs_calibrated_3p_interleaver_exp` test cohort.
            // When omitted, AGG falls back to the control model.
            ...featureServiceModel ? {
                featureServiceModel: featureServiceModel
            } : {}
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        onlyRefreshIfExpired: true,
        returnExpired: false,
        headers: headers
    });
    const recommendations = response.data?.contextService?.quickfindUserRecommendations || [];
    return recommendations.filter((r)=>Boolean(r.object)).map($24aba19999dc15f9$export$cf1f13813d90479a);
};
const $24aba19999dc15f9$export$cf1f13813d90479a = (result)=>{
    const object = result.object;
    const title = object?.__typename === 'ConfluencePage' ? object.title || '' : object?.__typename === 'ExternalDocument' ? object.displayName || '' : '';
    return {
        id: result.id,
        title: title,
        data: result,
        type: 'recommended-document'
    };
};





const $2bb736a7e62c9305$export$6e4070116bdfa183 = ({ query: query, hasFiltersSelected: hasFiltersSelected })=>{
    return Boolean(query || hasFiltersSelected);
};
const $2bb736a7e62c9305$var$preQueryErrorHandler = ({ hasQueryOrFilters: hasQueryOrFilters, preQueryError: preQueryError, postQueryDisabled: postQueryDisabled })=>{
    if ((!hasQueryOrFilters || postQueryDisabled) && preQueryError) return {
        state: 'PREQUERY_ERROR',
        query: ''
    };
};
const $2bb736a7e62c9305$var$preQueryLoadingHandler = ({ hasQueryOrFilters: hasQueryOrFilters, preQueryLoading: preQueryLoading, filteredRecentQueries: filteredRecentQueries, postQueryDisabled: postQueryDisabled })=>{
    if ((!hasQueryOrFilters || postQueryDisabled) && preQueryLoading) return {
        state: 'PREQUERY_LOADING',
        query: '',
        recentQueries: filteredRecentQueries
    };
};
const $2bb736a7e62c9305$var$preQueryNoResultsHandler = ({ hasQueryOrFilters: hasQueryOrFilters, filteredRecentActivities: filteredRecentActivities, filteredUserDocuments: filteredUserDocuments, filteredRecommendedDocuments: filteredRecommendedDocuments, filteredZeroQueries: filteredZeroQueries, postQueryDisabled: postQueryDisabled })=>{
    const totalResults = filteredRecentActivities.result.length + filteredUserDocuments.result.length + filteredRecommendedDocuments.result.length + filteredZeroQueries.length;
    if ((!hasQueryOrFilters || postQueryDisabled) && totalResults === 0) return {
        state: 'PREQUERY_NO_RESULTS',
        query: ''
    };
};
const $2bb736a7e62c9305$var$preQueryResultsHandler = ({ hasQueryOrFilters: hasQueryOrFilters, filteredRecentQueries: filteredRecentQueries, filteredRecentActivities: filteredRecentActivities, filteredUserDocuments: filteredUserDocuments, filteredRecommendedDocuments: filteredRecommendedDocuments, filteredZeroQueries: filteredZeroQueries, postQueryDisabled: postQueryDisabled, filterSuggestions: filterSuggestions })=>{
    const totalResults = filteredRecentActivities.result.length + filteredUserDocuments.result.length + filteredRecommendedDocuments.result.length + filteredZeroQueries.length;
    if ((!hasQueryOrFilters || postQueryDisabled) && totalResults > 0) return {
        state: 'PREQUERY_RESULTS',
        query: '',
        recentQueries: filteredRecentQueries,
        recentActivities: filteredRecentActivities.result,
        userDocuments: filteredUserDocuments.result,
        recommendedDocuments: filteredRecommendedDocuments.result,
        zeroQueries: filteredZeroQueries,
        filterSuggestions: filterSuggestions.result
    };
};
const $2bb736a7e62c9305$var$postQueryErrorHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, postQueryError: postQueryError, postQueryDisabled: postQueryDisabled })=>{
    if (hasQueryOrFilters && !postQueryDisabled && postQueryError) return {
        state: 'POSTQUERY_ERROR',
        query: query || ''
    };
};
const $2bb736a7e62c9305$var$postQueryLoadingHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, postQueryLoading: postQueryLoading, filteredRecentActivities: filteredRecentActivities, filteredUserDocuments: filteredUserDocuments, filteredRecommendedDocuments: filteredRecommendedDocuments, filteredRecentQueries: filteredRecentQueries, filteredZeroQueries: filteredZeroQueries, postQueryDisabled: postQueryDisabled, primaryProduct: primaryProduct, autocompleteSuggestions: autocompleteSuggestions })=>{
    if (hasQueryOrFilters && !postQueryDisabled && postQueryLoading) {
        // zero queries are only relevant for Jira in post query loading state
        const zeroQueries = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira ? filteredZeroQueries : [];
        return {
            state: 'POSTQUERY_LOADING',
            query: query || '',
            recentActivities: filteredRecentActivities.result,
            userDocuments: filteredUserDocuments.result,
            recommendedDocuments: filteredRecommendedDocuments.result,
            recentQueries: filteredRecentQueries,
            zeroQueries: zeroQueries,
            autocompleteSuggestions: autocompleteSuggestions?.map((suggestion, index)=>({
                    id: `autocomplete-suggestion-${index}`,
                    title: suggestion,
                    data: suggestion,
                    type: 'autocomplete-suggestion'
                }))
        };
    }
};
const $2bb736a7e62c9305$var$postQueryNoResultsHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, filteredRecentActivities: filteredRecentActivities, filteredUserDocuments: filteredUserDocuments, filteredRecommendedDocuments: filteredRecommendedDocuments, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled })=>{
    const totalResults = filteredRecentActivities.result.length + filteredUserDocuments.result.length + filteredRecommendedDocuments.result.length + searchResults.result.length + peopleAndTeams.result.length;
    if (hasQueryOrFilters && !postQueryDisabled && totalResults === 0) return {
        state: 'POSTQUERY_NO_RESULTS',
        query: query || ''
    };
};
const $2bb736a7e62c9305$var$postQueryResultsHandler = ({ query: query, hasQueryOrFilters: hasQueryOrFilters, filteredRecentQueries: filteredRecentQueries, filteredRecentActivities: filteredRecentActivities, filteredUserDocuments: filteredUserDocuments, filteredRecommendedDocuments: filteredRecommendedDocuments, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled, filteredZeroQueries: filteredZeroQueries, primaryProduct: primaryProduct, autocompleteSuggestions: autocompleteSuggestions })=>{
    // zero queries are only relevant for Jira in post query results state
    const zeroQueries = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira ? filteredZeroQueries : [];
    const totalResults = filteredRecentActivities.result.length + filteredUserDocuments.result.length + filteredRecommendedDocuments.result.length + searchResults.result.length + peopleAndTeams.result.length + zeroQueries.length;
    if (hasQueryOrFilters && !postQueryDisabled && totalResults > 0) return {
        state: 'POSTQUERY_RESULTS',
        query: query || '',
        recentQueries: filteredRecentQueries,
        recentActivities: filteredRecentActivities.result,
        userDocuments: filteredUserDocuments.result,
        recommendedDocuments: filteredRecommendedDocuments.result,
        searchResults: searchResults.result,
        peopleAndTeams: peopleAndTeams.result,
        zeroQueries: zeroQueries,
        autocompleteSuggestions: autocompleteSuggestions?.map((suggestion, index)=>({
                id: `autocomplete-suggestion-${index}`,
                title: suggestion,
                data: suggestion,
                type: 'autocomplete-suggestion'
            }))
    };
};
const $2bb736a7e62c9305$export$35ead133d529e85e = (args)=>{
    if (!args.quickFindOpen) return;
    const hasProductSelected = args.hasProductSelected ?? false;
    const hasQueryOrFilters = $2bb736a7e62c9305$export$6e4070116bdfa183({
        query: args.query,
        hasFiltersSelected: args.hasFiltersSelected || hasProductSelected
    });
    const handlers = [
        $2bb736a7e62c9305$var$preQueryErrorHandler,
        $2bb736a7e62c9305$var$preQueryLoadingHandler,
        $2bb736a7e62c9305$var$preQueryNoResultsHandler,
        $2bb736a7e62c9305$var$preQueryResultsHandler,
        $2bb736a7e62c9305$var$postQueryErrorHandler,
        $2bb736a7e62c9305$var$postQueryLoadingHandler,
        $2bb736a7e62c9305$var$postQueryNoResultsHandler,
        $2bb736a7e62c9305$var$postQueryResultsHandler
    ];
    for (const handler of handlers){
        const result = handler({
            ...args,
            hasQueryOrFilters: hasQueryOrFilters
        });
        if (result) return result;
    }
    // This should never happen, but default to error state
    if (!args.query) return {
        state: 'PREQUERY_ERROR',
        query: ''
    };
    else return {
        state: 'POSTQUERY_ERROR',
        query: args.query
    };
};



var $2Kn8h = parcelRequire("2Kn8h");

const $cc3e7a06b2b7df3f$export$eb4e7dba9a53c2c6 = async (cloudId, userId, aggAbsoluteUrl, headers)=>{
    const response = await (0, $2Kn8h.cachedUserDocumentsQuery)({
        variables: {
            userId: userId,
            tenantId: cloudId,
            caller: 'quick-find',
            maxNumberOfResults: 6
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        onlyRefreshIfExpired: true,
        returnExpired: false,
        headers: headers
    });
    const recommendedObjects = response.data?.smarts?.recommendedObject || [];
    return recommendedObjects.filter((r)=>Boolean(r.object)).map($cc3e7a06b2b7df3f$export$cf1f13813d90479a);
};
const $cc3e7a06b2b7df3f$export$cf1f13813d90479a = (result)=>{
    return {
        id: result.id,
        title: result?.object?.title || '',
        data: result,
        type: 'recommended-document'
    };
};



var $bz34M = parcelRequire("bz34M");

const $3e8764e0c86280c1$export$90241958e8ec24d5 = async (variables, headers)=>await (0, $bz34M.zeroQueriesQuery)({
        variables: variables,
        headers: headers
    }).then((response)=>{
        const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueries.zeroQueries || [];
        const shuffledZeroQueries = [
            ...zeroQueries
        ].sort(()=>Math.random() - 0.5);
        return shuffledZeroQueries.map($3e8764e0c86280c1$export$cf1f13813d90479a);
    });
const $3e8764e0c86280c1$export$e4c44fb2ea08e0f2 = async (variables, headers)=>await (0, $bz34M.zeroQueriesQueryV1)({
        variables: variables,
        headers: headers
    }).then((response)=>{
        const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueriesV1.zeroQueries || [];
        const shuffledZeroQueries = [
            ...zeroQueries
        ].sort(()=>Math.random() - 0.5);
        return shuffledZeroQueries.map($3e8764e0c86280c1$export$cf1f13813d90479a);
    });
const $3e8764e0c86280c1$export$cf1f13813d90479a = (zeroQuery)=>({
        id: zeroQuery.query,
        title: zeroQuery.query,
        data: zeroQuery.query,
        product: zeroQuery.product,
        accountId: zeroQuery.accountId,
        avatarUrl: zeroQuery.avatarUrl,
        dateRange: zeroQuery.dateRange,
        type: 'zero-query',
        zeroQueryType: zeroQuery.type
    });
const $3e8764e0c86280c1$export$123c86f509cbd0ab = async (variables, headers)=>await (0, $bz34M.zeroQueriesMutation)({
        variables: variables,
        headers: headers
    }).then((response)=>response.data?.knowledgeDiscovery.markZeroQueryInteracted.success ?? false);
const $3e8764e0c86280c1$export$5ceed206e02a9ef = async (variables, headers)=>await (0, $bz34M.zeroQueriesMutationV1)({
        variables: variables,
        headers: headers
    }).then((response)=>response.data?.knowledgeDiscovery.markZeroQueryInteractedV1.success ?? false);


const $0c35e478cf8dbc82$var$EMPTY_RESULTS = {
    result: [],
    duration: 0
};
const $0c35e478cf8dbc82$export$ab15aae48c593ecc = ({ postQueryDisabled: postQueryDisabled, onPreQueryStart: onPreQueryStart, onPreQuerySuccess: onPreQuerySuccess, onPreQueryFailure: onPreQueryFailure, onPostQueryStart: onPostQueryStart, onPostQuerySuccess: onPostQuerySuccess, onPostQueryFailure: onPostQueryFailure, onPostQueryCancel: onPostQueryCancel, postQueryTaskState: postQueryTaskState, preQueryTaskIdRef: preQueryTaskIdRef })=>{
    const [bootstrap] = (0, $j4ply.useBootstrap)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const isSearchReady = (0, $djVCD.useIsSearchReady)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const sessionId = (0, $PVo4u.getSessionIdFromLocalStorage)();
    const logException = (0, $f8oYd.useLogException)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [retryCount] = (0, $djVCD.useRetryCount)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const { setRequestedBackendExperiments: setRequestedBackendExperiments } = (0, $djVCD.useSearchActions)();
    const { selectedFilters: selectedFilters, entities: entities, hasFiltersSelected: hasFiltersSelected } = (0, $4VkIo.useSelectedFilters)({
        experience: (0, $9rRKJ.SearchExperience).QUICK_FIND
    });
    const useTypeEntitiesArgs = (0, $42omo.useMemo)(()=>({
            thirdPartyConfigs: bootstrap.thirdPartyConfigs
        }), [
        bootstrap.thirdPartyConfigs
    ]);
    const typeFilterEntities = (0, $djVCD.useTypeEntities)(useTypeEntitiesArgs);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const debounceTimeout = (0, $a755cc866a3495f8$export$9e8b58cc1c8bacd2)();
    const { createNetworkCallbacks: createNetworkCallbacks } = (0, $d4ba038bc3c9327c$export$c24470e080406156)();
    /**
   * Unfortunately, we need to reintroduce this to avoid unnecessarily
   * fetching results for the same query and filters.
   *
   * In order to understand why this is needed, we must first understand that
   * the filters object is one gigantic object - whenver any kind of updates
   * happens to the filters, the object reference changes, as it should. This
   * includes when the loaded options in the filters change, e.g. when opening
   * the space filter or typing into the lookup query for the filter. These
   * user interactions cause the filters object to change, which in turn causes
   * the references of selectedFilters and entities to change, regardless of
   * whether or not search parameters (query, filters and entities) have changed.
   *
   * In the past, we were able to get away wih reacting on references changes
   * of selectedFilters and entities as it was impossible for filters to change
   * in Quick Find without actually changing the search parameters. Now that
   * there are UI elements in Quick Find (e.g. space filter), this is no longer
   * true.
   *
   * This is temporary until we move to search requests being triggered on user
   * interactions, rather than state updates, which will happen as part of Relay
   * migration.
   */ const selectedFiltersEquality = JSON.stringify(selectedFilters);
    const entitiesEquality = JSON.stringify(entities);
    const prevQueryRef = (0, $42omo.useRef)();
    const prevQuickFindOpenRef = (0, $42omo.useRef)(quickFindOpen);
    const onPreQuerySuccessWasFired = (0, $42omo.useRef)(false);
    const prevSelectedFiltersEquality = (0, $42omo.useRef)();
    const prevEntitiesEquality = (0, $42omo.useRef)();
    const prevHasFiltersSelected = (0, $42omo.useRef)(hasFiltersSelected);
    const fetchRecentActivitiesPromiseRef = (0, $42omo.useRef)();
    const fetchUserDocumentsPromiseRef = (0, $42omo.useRef)();
    const fetchRecommendedDocumentsPromiseRef = (0, $42omo.useRef)();
    const fetchGithubActivitiesPromiseRef = (0, $42omo.useRef)();
    const githubActivitiesResultRef = (0, $42omo.useRef)();
    const preQueryPromiseRef = (0, $42omo.useRef)();
    const postQueryPromiseRef = (0, $42omo.useRef)();
    const prevSelectedProduct = (0, $42omo.useRef)(selectedProduct);
    const hasGithubSmartLinkAccessRef = (0, $42omo.useRef)();
    const { setUpdateRecentQueries: setUpdateRecentQueries, setFetchEntitiesRequestId: setFetchEntitiesRequestId, setFetchEntitiesTraceId: setFetchEntitiesTraceId, setUpdateZeroQueries: setUpdateZeroQueries, setFetchSpacesRequestId: setFetchSpacesRequestId, setSearchErrors: setSearchErrors } = (0, $4VmlX.useQuickFindActions)();
    const [preQueryLoading, setPreQueryLoading] = (0, $42omo.useState)(true);
    const [preQueryError, setPreQueryError] = (0, $42omo.useState)();
    const [postQueryLoading, setPostQueryLoading] = (0, $42omo.useState)(false);
    const [postQueryError, setPostQueryError] = (0, $42omo.useState)();
    const [recentQueries, setRecentQueries] = (0, $42omo.useState)([]);
    const [filteredRecentQueries, setFilteredRecentQueries] = (0, $42omo.useState)([]);
    const [filteredRecentActivities, setFilteredRecentActivities] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [filteredUserDocuments, setFilteredUserDocuments] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [filteredRecommendedDocuments, setFilteredRecommendedDocuments] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [filteredZeroQueries, setFilteredZeroQueries] = (0, $42omo.useState)([]);
    const [zeroQueries, setZeroQueries] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [searchResults, setSearchResults] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [peopleAndTeams, setPeopleAndTeams] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [filterSuggestions, setFilterSuggestions] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [visibleFilterSuggestions, setVisibleFilterSuggestions] = (0, $42omo.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [autocompleteSuggestions, setAutocompleteSuggestions] = (0, $42omo.useState)(undefined);
    const serveFilterSuggestion = (0, $2OtFZ.serveQFFilterSuggestionExperiment)(bootstrap.primaryProduct, {
        fireLayerExposure: false
    });
    const serveZeroQuery3PRecs = (0, $2OtFZ.serveQFZeroQuery3PRecsExperiment)({
        fireExperimentExposure: false
    });
    const isConfluence = bootstrap.primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence;
    (0, $42omo.useEffect)(()=>{
        if (isConfluence) (0, $2OtFZ.serveQFZeroQuery3PRecsExperiment)({
            fireExperimentExposure: true
        });
    }, [
        isConfluence
    ]);
    const serveZeroQuery = (bootstrap.primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence || bootstrap.primaryProduct === (0, $6Gsan.PrimaryProductKeys).Atlas || bootstrap.primaryProduct === (0, $6Gsan.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension')) && (0, $dh538.fg)('kd_zero_query_in_qf_fg') || bootstrap.primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira;
    const workspaceId = bootstrap.primaryProduct && bootstrap.cloudId && bootstrap.analyticsAttributes?.activationId ? `ari:cloud:${bootstrap.primaryProduct}:${bootstrap.cloudId}:workspace/${bootstrap.analyticsAttributes.activationId}` : '';
    const useKdZeroQueryAtlHeader = (0, $dh538.fg)('kd_zero_query_agg_atl_attribution_header');
    const atlAttributionHeaderValue = (0, $42omo.useMemo)(()=>(0, $jwO5V.createAtlAttributionHeaderValue)({
            atlWorkspaceId: workspaceId,
            tenantId: bootstrap.cloudId || '',
            product: bootstrap.primaryProduct || ''
        }), [
        bootstrap.cloudId,
        bootstrap.primaryProduct,
        workspaceId
    ]);
    /**
   * Callback to update recent queries for the current product and user
   */ const fetchRecentQueries = (0, $42omo.useCallback)(()=>{
        if (!bootstrap.primaryProduct || !bootstrap.user?.id) return;
        const recentQueries_0 = (0, $1435b53be5ab4d50$export$d6415f081f333b17)(bootstrap.primaryProduct, bootstrap.user.id);
        setRecentQueries(recentQueries_0);
    }, [
        bootstrap.primaryProduct,
        bootstrap.user?.id,
        setRecentQueries
    ]);
    /**
   * Store the callback to update recent queries in the store. This is used to refresh recent queries
   * when they are updated, e.g. when a search request is made or when a recent query is removed.
   */ (0, $42omo.useEffect)(()=>{
        fetchRecentQueries();
        setUpdateRecentQueries(fetchRecentQueries);
    }, [
        fetchRecentQueries,
        setUpdateRecentQueries
    ]);
    /**
   * Callback to fetch recent activities
   */ const fetchRecentActivitiesCallback = (0, $42omo.useCallback)(async (cursor)=>{
        if (!bootstrap.cloudId) return [];
        const headers = {
            'atl-attribution': atlAttributionHeaderValue
        };
        const taskId = crypto.randomUUID();
        const taskStartAt = performance.now();
        const baseVitalStatsParams = {
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $31eSD.TASK_NAMES).QUICK_FIND_RECENT_ACTIVITIES_UX
        };
        fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskStart)(baseVitalStatsParams)));
        const networkCallbacks = (0, $dh538.fg)('rovo-search-vitalstats-quickfind-recents-network') ? createNetworkCallbacks({
            taskName: (0, $31eSD.TASK_NAMES).QUICK_FIND_RECENT_ACTIVITIES_NETWORK,
            uxTaskId: taskId,
            isPreQuery: true
        }) : undefined;
        try {
            const recentActivities = await (0, $198609fd26633f18$export$ae65634d024c5427)(bootstrap.cloudId, bootstrap.aggAbsoluteUrl, cursor, bootstrap.thirdPartyConfigs, headers, bootstrap.primaryProduct, networkCallbacks, bootstrap.products);
            // It doesn't distinguish between a network call and fetching from cache.
            // We can consolidate that once quick_find_autorefresh_experiment_v3 is shipped.
            fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskSuccess)({
                ...baseVitalStatsParams,
                moreContext: {
                    timeTaken: performance.now() - taskStartAt,
                    resultsLoaded: recentActivities.length,
                    resultsWithFailedHydration: recentActivities.filter((activity)=>activity.data?.node?.object?.data === null).map((activity_0)=>activity_0.id)
                }
            })));
            return recentActivities;
        } catch (error) {
            fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskFail)({
                ...baseVitalStatsParams,
                moreContext: {
                    error: error instanceof Error ? error.message : String(error),
                    timeTaken: performance.now() - taskStartAt
                }
            })));
            throw error;
        }
    }, [
        bootstrap.cloudId,
        bootstrap.aggAbsoluteUrl,
        bootstrap.thirdPartyConfigs,
        bootstrap.products,
        searchSessionId,
        fireAnalyticsEvent,
        atlAttributionHeaderValue,
        bootstrap.primaryProduct,
        createNetworkCallbacks
    ]);
    const fetchUserDocumentsCallback = (0, $42omo.useCallback)(async ()=>{
        if (bootstrap.cloudId && bootstrap.user?.id && (bootstrap.primaryProduct === 'confluence' || bootstrap.primaryProduct === 'rovo-extension' && (0, $dh538.fg)('quickfind-rovo-extension'))) {
            const headers_0 = {
                'atl-attribution': atlAttributionHeaderValue
            };
            return (0, $cc3e7a06b2b7df3f$export$eb4e7dba9a53c2c6)(bootstrap.cloudId, bootstrap.user.id, bootstrap.aggAbsoluteUrl, headers_0);
        } else return [];
    }, [
        bootstrap.cloudId,
        bootstrap.user?.id,
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        atlAttributionHeaderValue
    ]);
    const fetchRecommendedDocumentsCallback = (0, $42omo.useCallback)(async ()=>{
        if (!serveZeroQuery3PRecs) return [];
        if (bootstrap.cloudId && bootstrap.user?.id && (isConfluence || bootstrap.primaryProduct === 'rovo-extension' && (0, $dh538.fg)('quickfind-rovo-extension'))) {
            const headers_1 = {
                'atl-attribution': atlAttributionHeaderValue
            };
            // Fire `quick_find_recs_calibrated_3p_interleaver_exp` exposure at the
            // exact point we're about to fetch recommended documents — i.e. for
            // users who would actually receive the treatment (or control). This
            // keeps the exposure population aligned with where the model is
            // delivered (`serveZeroQuery3PRecs`, Confluence/rovo-extension,
            // authenticated user, with at least one Google Drive or SharePoint
            // connector). `FeatureGates.getExperimentValue` dedupes repeated
            // exposures for the same user/experiment, so calling this on every
            // fetch is safe.
            //
            // Only forward the 5th arg when the user is in the test cohort. For
            // control / un-allocated users we omit the arg entirely so the
            // GraphQL variable is never serialised.
            if ((0, $2OtFZ.serveQuickFindRecommendationChallenger)(bootstrap.thirdPartyConfigs, {
                fireExperimentExposure: true
            })) return (0, $24aba19999dc15f9$export$4858b654778bd2b4)(bootstrap.cloudId, bootstrap.user.id, bootstrap.aggAbsoluteUrl, headers_1, (0, $2OtFZ.QUICK_FIND_RECS_CHALLENGER_FEATURE_SERVICE_MODEL));
            return (0, $24aba19999dc15f9$export$4858b654778bd2b4)(bootstrap.cloudId, bootstrap.user.id, bootstrap.aggAbsoluteUrl, headers_1);
        } else return [];
    }, [
        bootstrap.cloudId,
        bootstrap.user?.id,
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.thirdPartyConfigs,
        atlAttributionHeaderValue,
        serveZeroQuery3PRecs,
        isConfluence
    ]);
    const fetchFilterSuggestionsCallback = (0, $42omo.useCallback)(async ()=>(0, $ef123373d1331d42$export$15543ec9771a9a65)(bootstrap.user, bootstrap.cloudId), [
        bootstrap.user,
        bootstrap.cloudId
    ]);
    /*
   * Call filter suggestions as an independent call to avoid delays to the critical path */ (0, $42omo.useEffect)(()=>{
        // Only load the filter suggestions if it's Jira
        if (bootstrap.primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && serveFilterSuggestion) (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchFilterSuggestionsCallback).then((result)=>{
            setFilterSuggestions(result ?? $0c35e478cf8dbc82$var$EMPTY_RESULTS);
        }).catch((error_0)=>{
            logException(error_0);
            setFilterSuggestions($0c35e478cf8dbc82$var$EMPTY_RESULTS);
        });
    }, [
        fetchFilterSuggestionsCallback,
        logException,
        bootstrap.primaryProduct,
        serveFilterSuggestion
    ]);
    /**
   * Callback to fetch zero queries
   */ const fetchZeroQueriesCallback = (0, $42omo.useCallback)(()=>{
        if (!bootstrap.cloudId) return;
        const fetchFn = (0, $59vy4.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(bootstrap.primaryProduct) ? (0, $3e8764e0c86280c1$export$e4c44fb2ea08e0f2) : (0, $3e8764e0c86280c1$export$90241958e8ec24d5);
        (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(()=>fetchFn({
                cloudId: bootstrap.cloudId,
                product: (0, $3fAff.getUppercasePrimaryProductKey)(bootstrap.primaryProduct)
            }, useKdZeroQueryAtlHeader && atlAttributionHeaderValue ? {
                'atl-attribution': atlAttributionHeaderValue
            } : {})).then((result_0)=>{
            setZeroQueries(result_0 ?? $0c35e478cf8dbc82$var$EMPTY_RESULTS);
        }).catch((error_1)=>{
            logException(error_1);
            setZeroQueries($0c35e478cf8dbc82$var$EMPTY_RESULTS);
        });
    }, [
        bootstrap.cloudId,
        logException,
        bootstrap.primaryProduct,
        atlAttributionHeaderValue,
        useKdZeroQueryAtlHeader
    ]);
    /**
   * Store the callback to update zero queries in the store. This is used to refresh zero queries
   * when they are updated, e.g. when a zero query is clicked.
   */ (0, $42omo.useEffect)(()=>{
        if (serveZeroQuery) fetchZeroQueriesCallback();
        setUpdateZeroQueries(fetchZeroQueriesCallback);
    }, [
        fetchZeroQueriesCallback,
        setUpdateZeroQueries,
        serveZeroQuery
    ]);
    const serveGithubLinksHydrationCohort = (0, $42omo.useMemo)(()=>{
        const cohort = (0, $c6GJD.default).getExperimentValue('enable_github_links_hydration_in_quickfind_recent', 'cohort', 'control', {
            fireExperimentExposure: false
        });
        return cohort === 'test';
    }, []);
    const githubFullConnectorAuthorised = (0, $42omo.useMemo)(()=>{
        const githubConfig = bootstrap.thirdPartyConfigs?.[(0, $hdfeV.ProductKeys3P).Github];
        return !!(githubConfig && !githubConfig.userNeedsOAuth);
    }, [
        bootstrap.thirdPartyConfigs
    ]);
    const checkGithubSmartLinkAccess = (0, $42omo.useCallback)(async ()=>{
        const aaid = bootstrap.user?.id;
        if (!aaid) return false;
        return (async ()=>{
            try {
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $dmTG5.onDegradedDependency)({
                        dependency: `outbound-auth-github`,
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE)
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $3htW4.onRequestCacheAccess)({
                        requestName: 'outbound-auth-github',
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE)
                    }));
                };
                return await (0, $a3b72b1c5f32a0f4$export$950899af45fc526)({
                    aaid: aaid,
                    strategy: (0, $eb3355f5ff6969a5$export$fad190a164f62f75)(),
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback
                });
            } catch (error_2) {
                fireAnalyticsEvent((0, $cFN1h.onFailedDependency)({
                    dependency: 'outbound-auth-github',
                    searchSessionId: searchSessionId,
                    source: (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE)
                }));
                logException(error_2 instanceof Error ? error_2 : new Error(String(error_2)));
                return false;
            }
        })();
    }, [
        bootstrap.user?.id,
        logException,
        fireAnalyticsEvent,
        searchSessionId
    ]);
    hasGithubSmartLinkAccessRef.current = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('enable_github_quickfind_experiment')) {
            if (githubFullConnectorAuthorised) return Promise.resolve(true);
            else return checkGithubSmartLinkAccess();
        }
        return Promise.resolve(false);
    }, [
        checkGithubSmartLinkAccess,
        githubFullConnectorAuthorised
    ]);
    const fetchGithubActivitiesCallback = (0, $42omo.useCallback)(async (recentActivities_0)=>{
        if (!serveGithubLinksHydrationCohort || fetchGithubActivitiesPromiseRef.current) return;
        const headers_2 = {
            'atl-attribution': atlAttributionHeaderValue
        };
        fetchGithubActivitiesPromiseRef.current = (async ()=>{
            if (githubFullConnectorAuthorised || await hasGithubSmartLinkAccessRef.current) (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(()=>(0, $198609fd26633f18$export$9bda9a715c3ed911)(recentActivities_0, bootstrap.aggAbsoluteUrl, logException, headers_2)).then(({ result: githubEdges, duration: duration })=>{
                githubActivitiesResultRef.current = {
                    result: githubEdges,
                    duration: duration
                };
            }).catch((error_3)=>{
                logException(error_3);
                githubActivitiesResultRef.current = $0c35e478cf8dbc82$var$EMPTY_RESULTS;
            });
            else githubActivitiesResultRef.current = $0c35e478cf8dbc82$var$EMPTY_RESULTS;
        })();
    }, [
        bootstrap.aggAbsoluteUrl,
        logException,
        serveGithubLinksHydrationCohort,
        githubFullConnectorAuthorised,
        atlAttributionHeaderValue
    ]);
    /**
   * Callback to fetch pre-query results and updates the store with the results
   */ const fetchQuickFindPreQuery = (0, $42omo.useCallback)((query, hideFilteredPreQueryResults, shouldRefetchPreQueryResults)=>{
        if (hideFilteredPreQueryResults) {
            setFilteredRecentQueries([]);
            setFilteredRecentActivities($0c35e478cf8dbc82$var$EMPTY_RESULTS);
            setFilteredZeroQueries([]);
            isConfluence && setFilteredUserDocuments($0c35e478cf8dbc82$var$EMPTY_RESULTS);
            isConfluence && setFilteredRecommendedDocuments($0c35e478cf8dbc82$var$EMPTY_RESULTS);
        }
        if (!fetchRecentActivitiesPromiseRef.current || !(serveZeroQuery3PRecs ? fetchRecommendedDocumentsPromiseRef.current : fetchUserDocumentsPromiseRef.current)) {
            setPreQueryError(undefined);
            setPreQueryLoading(true);
            onPreQueryStart?.();
        }
        if (!fetchRecentActivitiesPromiseRef.current) {
            const fetchRecentActivitiesPromise = (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchRecentActivitiesCallback).catch((error_4)=>{
                logException(error_4);
                setPreQueryError(error_4);
                onPreQueryFailure?.(error_4);
                fetchRecentActivitiesPromiseRef.current = undefined;
                return $0c35e478cf8dbc82$var$EMPTY_RESULTS;
            });
            fetchRecentActivitiesPromiseRef.current = fetchRecentActivitiesPromise;
        }
        if (!fetchRecommendedDocumentsPromiseRef.current) {
            if (isConfluence && serveZeroQuery3PRecs) {
                const fetchRecommendedDocumentsPromise = (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchRecommendedDocumentsCallback).catch((error_5)=>{
                    logException(error_5);
                    onPreQueryFailure?.(error_5);
                    fetchRecommendedDocumentsPromiseRef.current = undefined;
                    return $0c35e478cf8dbc82$var$EMPTY_RESULTS;
                });
                fetchRecommendedDocumentsPromiseRef.current = fetchRecommendedDocumentsPromise;
            } else fetchRecommendedDocumentsPromiseRef.current = Promise.resolve($0c35e478cf8dbc82$var$EMPTY_RESULTS);
        }
        if (!fetchUserDocumentsPromiseRef.current) {
            if (isConfluence && !serveZeroQuery3PRecs) {
                const fetchUserDocumentsPromise = (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchUserDocumentsCallback).catch((error_6)=>{
                    logException(error_6);
                    onPreQueryFailure?.(error_6);
                    fetchUserDocumentsPromiseRef.current = undefined;
                    return $0c35e478cf8dbc82$var$EMPTY_RESULTS;
                });
                fetchUserDocumentsPromiseRef.current = fetchUserDocumentsPromise;
            } else fetchUserDocumentsPromiseRef.current = Promise.resolve($0c35e478cf8dbc82$var$EMPTY_RESULTS);
        }
        if (shouldRefetchPreQueryResults) {
            // mutual exclusivity with postQuery tasks
            (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(()=>fetchRecentActivitiesCallback()).then((results)=>{
                setPreQueryError(undefined);
                fetchRecentActivitiesPromiseRef.current = Promise.all([
                    fetchRecentActivitiesPromiseRef.current,
                    Promise.resolve(results)
                ]).then(([existingResults, newResults])=>{
                    const deduplicatedResults = (0, $914d54e8bd9a1675$export$f7b7f83c551ecf0b)(existingResults?.result ?? [], newResults?.result ?? []);
                    return {
                        result: deduplicatedResults,
                        duration: newResults.duration
                    };
                });
            }).catch((error_7)=>{
                logException(error_7);
                onPreQueryFailure?.(error_7);
            });
            if (isConfluence) {
                if (serveZeroQuery3PRecs) (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(()=>fetchRecommendedDocumentsCallback()).then((results_0)=>{
                    fetchRecommendedDocumentsPromiseRef.current = Promise.all([
                        fetchRecommendedDocumentsPromiseRef.current,
                        Promise.resolve(results_0)
                    ]).then(([existingResults_0, newResults_0])=>{
                        const result_1 = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))([
                            ...newResults_0?.result ?? [],
                            ...existingResults_0?.result ?? []
                        ], (item)=>item.id);
                        return {
                            result: result_1,
                            duration: newResults_0.duration
                        };
                    });
                }).catch((error_8)=>{
                    logException(error_8);
                    onPreQueryFailure?.(error_8);
                });
                else (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(()=>fetchUserDocumentsCallback()).then((results_1)=>{
                    fetchUserDocumentsPromiseRef.current = Promise.all([
                        fetchUserDocumentsPromiseRef.current,
                        Promise.resolve(results_1)
                    ]).then(([existingResults_1, newResults_1])=>{
                        const result_2 = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))([
                            ...newResults_1?.result ?? [],
                            ...existingResults_1?.result ?? []
                        ], (item_0)=>item_0.id);
                        return {
                            result: result_2,
                            duration: newResults_1.duration
                        };
                    });
                }).catch((error_9)=>{
                    logException(error_9);
                    onPreQueryFailure?.(error_9);
                });
            }
        }
        const preQueryPromise = new (0, $czt8s.CancellablePromise)(Promise.all([
            fetchRecentActivitiesPromiseRef.current,
            fetchUserDocumentsPromiseRef.current,
            fetchRecommendedDocumentsPromiseRef.current
        ]));
        preQueryPromiseRef.current = preQueryPromise;
        preQueryPromise.promise().then(([recentActivities_1, userDocuments, recommendedDocuments])=>{
            if (!onPreQuerySuccessWasFired.current) {
                onPreQuerySuccess?.();
                onPreQuerySuccessWasFired.current = true;
            }
            setPreQueryLoading(false);
            if (hideFilteredPreQueryResults) return;
            const filteredRecentQueries_0 = (0, $jjjIy.filterSearchResults)(recentQueries, query);
            setFilteredRecentQueries(filteredRecentQueries_0);
            if (bootstrap.primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) {
                // We only filter zero queries for Jira as it's needed in post-query state
                const filteredZeroQueries_0 = (0, $jjjIy.filterSearchResults)(zeroQueries.result, query);
                setFilteredZeroQueries(filteredZeroQueries_0);
            } else setFilteredZeroQueries(zeroQueries.result);
            fetchGithubActivitiesCallback(recentActivities_1);
            const filterRecentActivitiesCallback = (0, $jjjIy.filterRecentActivities);
            if (serveGithubLinksHydrationCohort && githubActivitiesResultRef.current) {
                const filteredRecentActivities_0 = filterRecentActivitiesCallback((0, $914d54e8bd9a1675$export$f7b7f83c551ecf0b)(recentActivities_1.result, githubActivitiesResultRef.current.result), query);
                setFilteredRecentActivities({
                    result: filteredRecentActivities_0,
                    duration: recentActivities_1.duration + githubActivitiesResultRef.current.duration
                });
            } else {
                const filteredRecentActivities_1 = filterRecentActivitiesCallback(recentActivities_1.result, query);
                setFilteredRecentActivities({
                    result: filteredRecentActivities_1,
                    duration: recentActivities_1.duration
                });
            }
            if (bootstrap.primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) setVisibleFilterSuggestions(filterSuggestions);
            if (isConfluence) {
                const filteredUserDocuments_0 = (0, $jjjIy.filterSearchResults)(userDocuments.result, query);
                setFilteredUserDocuments({
                    result: filteredUserDocuments_0,
                    duration: userDocuments.duration
                });
                const filteredRecommendedDocuments_0 = (0, $jjjIy.filterSearchResults)(recommendedDocuments.result, query);
                setFilteredRecommendedDocuments({
                    result: filteredRecommendedDocuments_0,
                    duration: recommendedDocuments.duration
                });
            }
        }).catch(()=>{
        // no-op on cancel
        }).finally(()=>{
            preQueryPromiseRef.current = undefined;
        });
    }, [
        fetchRecentActivitiesCallback,
        fetchGithubActivitiesCallback,
        fetchUserDocumentsCallback,
        fetchRecommendedDocumentsCallback,
        logException,
        onPreQueryFailure,
        onPreQueryStart,
        onPreQuerySuccess,
        recentQueries,
        zeroQueries,
        isConfluence,
        bootstrap.primaryProduct,
        serveGithubLinksHydrationCohort,
        filterSuggestions,
        serveZeroQuery3PRecs
    ]);
    /**
   * Callback to fetch confluence entities
   * @param uxTaskId - The UX task ID to associate with the network requests
   * @param isPreQuery - Whether this is a pre-query (warmup) request. Defaults to false.
   */ const fetchConfluenceEntitiesCallback = (0, $42omo.useCallback)(async (uxTaskId, isPreQuery = false)=>{
        return Promise.all([
            (0, $d482bbe0b8132b8c$export$9605a5c4a68b2654)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, entities, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
                taskName: (0, $31eSD.TASK_NAMES).QUICK_FIND_CONFLUENCE_ENTITIES_NETWORK,
                uxTaskId: uxTaskId,
                isPreQuery: isPreQuery
            }), bootstrap.analyticsAttributes?.activationId),
            (0, $d482bbe0b8132b8c$export$919c2c6ec09a9e2)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
                taskName: (0, $31eSD.TASK_NAMES).QUICK_FIND_CONFLUENCE_SPACES_NETWORK,
                uxTaskId: uxTaskId,
                isPreQuery: isPreQuery
            }), bootstrap.analyticsAttributes?.activationId)
        ]).then((results_2)=>{
            const [entities_0, spaces] = results_2;
            return {
                results: [
                    ...entities_0.fetchResults,
                    ...spaces.fetchResults
                ],
                fetchEntitiesRequestId: entities_0.fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: entities_0.fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: spaces.fetchSpacesRequestId ?? undefined,
                errors: [
                    ...entities_0.errors || [],
                    ...spaces.errors || []
                ],
                autocompleteSuggestions: entities_0.autocompleteSuggestions
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        entities,
        sessionId,
        createNetworkCallbacks
    ]);
    /**
   * Callback to fetch atlas entities
   */ const fetchAtlasEntitiesCallback = (0, $42omo.useCallback)(async (uxTaskId_0, isPreQuery_0 = false)=>{
        return (0, $d482bbe0b8132b8c$export$65df7212bf163b08)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $31eSD.TASK_NAMES).QUICK_FIND_ATLAS_ENTITIES_NETWORK,
            uxTaskId: uxTaskId_0,
            isPreQuery: isPreQuery_0
        }), bootstrap.analyticsAttributes?.activationId).then((results_3)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId, fetchEntitiesTraceId: fetchEntitiesTraceId, errors: errors } = results_3;
            return {
                results: fetchResults,
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchAssetsEntitiesCallback = (0, $42omo.useCallback)(async (uxTaskId_1, isPreQuery_1 = false)=>{
        return (0, $d482bbe0b8132b8c$export$7e4a42258e6edc26)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $31eSD.TASK_NAMES).QUICK_FIND_ASSETS_ENTITIES_NETWORK,
            uxTaskId: uxTaskId_1,
            isPreQuery: isPreQuery_1
        }), bootstrap.analyticsAttributes?.activationId).then((results_4)=>{
            const { fetchResults: fetchResults_0, fetchEntitiesRequestId: fetchEntitiesRequestId_0, fetchEntitiesTraceId: fetchEntitiesTraceId_0, errors: errors_0 } = results_4;
            return {
                results: fetchResults_0,
                fetchEntitiesRequestId: fetchEntitiesRequestId_0 ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId_0 ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors_0,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchMercuryEntitiesCallback = (0, $42omo.useCallback)(async (uxTaskId_2, isPreQuery_2 = false)=>{
        return (0, $d482bbe0b8132b8c$export$60162ce0dfbba9f8)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $31eSD.TASK_NAMES).QUICK_FIND_MERCURY_ENTITIES_NETWORK,
            uxTaskId: uxTaskId_2,
            isPreQuery: isPreQuery_2
        }), bootstrap.analyticsAttributes?.activationId).then((results_5)=>{
            const { fetchResults: fetchResults_1, fetchEntitiesRequestId: fetchEntitiesRequestId_1, fetchEntitiesTraceId: fetchEntitiesTraceId_1, errors: errors_1 } = results_5;
            return {
                results: [
                    ...fetchResults_1
                ],
                fetchEntitiesRequestId: fetchEntitiesRequestId_1 ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId_1 ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors_1,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchTalentEntitiesCallback = (0, $42omo.useCallback)(async (uxTaskId_3, isPreQuery_3 = false)=>{
        return (0, $d482bbe0b8132b8c$export$39ffd40a0e828404)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.thirdPartyConfigs, sessionId, createNetworkCallbacks({
            taskName: (0, $31eSD.TASK_NAMES).QUICK_FIND_TALENT_ENTITIES_NETWORK,
            uxTaskId: uxTaskId_3,
            isPreQuery: isPreQuery_3
        }), bootstrap.analyticsAttributes?.activationId).then((results_6)=>{
            const { fetchResults: fetchResults_2, fetchEntitiesRequestId: fetchEntitiesRequestId_2, fetchEntitiesTraceId: fetchEntitiesTraceId_2, errors: errors_2 } = results_6;
            return {
                results: [
                    ...fetchResults_2
                ],
                fetchEntitiesRequestId: fetchEntitiesRequestId_2 ?? undefined,
                fetchEntitiesTraceId: fetchEntitiesTraceId_2 ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: errors_2,
                autocompleteSuggestions: undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        sessionId,
        createNetworkCallbacks
    ]);
    const fetchJiraIssuesCallback = (0, $42omo.useCallback)(async (uxTaskId_4, isPreQuery_4 = false)=>{
        const issuesAndTypesCallbacks = createNetworkCallbacks({
            taskName: (0, $31eSD.TASK_NAMES).QUICK_FIND_JIRA_ISSUES_AND_TYPES_NETWORK,
            uxTaskId: uxTaskId_4,
            isPreQuery: isPreQuery_4
        });
        const entitiesCallbacks = !hasFiltersSelected ? createNetworkCallbacks({
            taskName: (0, $31eSD.TASK_NAMES).QUICK_FIND_JIRA_ENTITIES_NETWORK,
            uxTaskId: uxTaskId_4,
            isPreQuery: isPreQuery_4
        }) : undefined;
        return Promise.all([
            (0, $d482bbe0b8132b8c$export$eaafe46561fa4ee5)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.isJiraIssueIndexed, bootstrap.thirdPartyConfigs, typeFilterEntities, sessionId, bootstrap.hasEditOrViewPlanPermission, issuesAndTypesCallbacks, bootstrap.analyticsAttributes?.activationId),
            !hasFiltersSelected ? (0, $d482bbe0b8132b8c$export$cfa5e5437133749b)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, bootstrap.isJiraIssueIndexed, bootstrap.thirdPartyConfigs, sessionId, bootstrap.hasEditOrViewPlanPermission, entitiesCallbacks, bootstrap.analyticsAttributes?.activationId) : Promise.resolve({
                fetchResults: [],
                errors: [],
                autocompleteSuggestions: undefined
            })
        ]).then((results_7)=>{
            const [issuesResult, entitiesResult] = results_7;
            return {
                results: [
                    ...issuesResult.fetchResults,
                    ...entitiesResult.fetchResults
                ],
                fetchEntitiesRequestId: issuesResult.fetchEntitiesRequestId ?? undefined,
                fetchEntitiesTraceId: issuesResult.fetchEntitiesTraceId ?? undefined,
                fetchSpacesRequestId: undefined,
                errors: [
                    ...issuesResult.errors || [],
                    ...entitiesResult.errors || []
                ],
                autocompleteSuggestions: issuesResult.autocompleteSuggestions
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.isJiraIssueIndexed,
        bootstrap.thirdPartyConfigs,
        bootstrap.hasEditOrViewPlanPermission,
        bootstrap.analyticsAttributes?.activationId,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        typeFilterEntities,
        hasFiltersSelected,
        sessionId,
        createNetworkCallbacks
    ]);
    /**
   * Callback to fetch people and teams results
   */ const fetchPeopleAndTeamsCallback = (0, $42omo.useCallback)(async ()=>{
        const { orgId: orgId, primaryProduct: primaryProduct, user: user, cloudId: cloudId } = bootstrap;
        if (orgId && primaryProduct && user?.id && cloudId) {
            // When a single query filter is selected and it is a contributor filter,
            // get people and teams results using the contributor name
            if (selectedQueryFilters.length === 1 && selectedQueryFilters[0].filterId === 'contributor') return (0, $6e53edd4c7804f3e$export$290039782fc4e47)(selectedQueryFilters[0].displayText, orgId, primaryProduct, user.id, cloudId);
            // Only fetch people and teams results if there are no filters selected
            if (!hasFiltersSelected) return (0, $6e53edd4c7804f3e$export$290039782fc4e47)(quickFindQuery, orgId, primaryProduct, user.id, cloudId);
        }
        return [];
    }, [
        bootstrap,
        quickFindQuery,
        selectedQueryFilters,
        hasFiltersSelected
    ]);
    /**
   * Function which fetches search results. This consists of a call to get
   * product search results and a call to get people and teams. Given that Promise.allSettled
   * is used, the slowest request will determine the time it takes to resolve.
   *
   * @param isWarmupRequest - Whether this is a warmup request (controls success/failure callbacks and which UX event to fire)
   */ const fetchQuickFindPostQuery = (0, $42omo.useCallback)((isWarmupRequest = false)=>{
        // Determine if this is a pre-query state based on whether there's actual text in the query
        // isPreQuery = true when there's no text query (even if filters are selected)
        // isPreQuery = false when there's actual text in the query
        const isPreQuery_5 = !quickFindQuery || quickFindQuery.length === 0;
        // Generate and store uxTaskId so network events use the same taskId as UX events.
        // For pre-query: use preQueryTaskIdRef, for post-query: use postQueryTaskState.
        let uxTaskId_5;
        if (isPreQuery_5) {
            if (preQueryTaskIdRef && !preQueryTaskIdRef.current) preQueryTaskIdRef.current = crypto.randomUUID();
            uxTaskId_5 = preQueryTaskIdRef?.current || crypto.randomUUID();
        } else {
            // Reset state if previous query completed
            if (postQueryTaskState?.current?.completed) postQueryTaskState.current = {
                id: null,
                started: false,
                completed: false,
                error: null
            };
            if (postQueryTaskState && !postQueryTaskState.current.id) postQueryTaskState.current.id = crypto.randomUUID();
            uxTaskId_5 = postQueryTaskState?.current?.id || crypto.randomUUID();
        }
        let fetchProductEntities;
        if (bootstrap.primaryProduct === 'confluence' || bootstrap.primaryProduct === 'rovo-extension' && (0, $dh538.fg)('quickfind-rovo-extension')) fetchProductEntities = ()=>fetchConfluenceEntitiesCallback(uxTaskId_5, isPreQuery_5);
        else if (bootstrap.primaryProduct === 'townsquare') fetchProductEntities = ()=>fetchAtlasEntitiesCallback(uxTaskId_5, isPreQuery_5);
        else if (bootstrap.primaryProduct === 'mercury') fetchProductEntities = ()=>fetchMercuryEntitiesCallback(uxTaskId_5, isPreQuery_5);
        else if (bootstrap.primaryProduct === 'radar' && (0, $dh538.fg)('talent_global_search')) fetchProductEntities = ()=>fetchTalentEntitiesCallback(uxTaskId_5, isPreQuery_5);
        else if (bootstrap.primaryProduct === 'jira') fetchProductEntities = ()=>fetchJiraIssuesCallback(uxTaskId_5, isPreQuery_5);
        else if (bootstrap.primaryProduct === 'cmdb' && (0, $dh538.fg)('assets_rovo_search_all')) fetchProductEntities = ()=>fetchAssetsEntitiesCallback(uxTaskId_5, isPreQuery_5);
        else fetchProductEntities = ()=>Promise.resolve({
                results: [],
                fetchEntitiesRequestId: undefined,
                fetchEntitiesTraceId: undefined,
                fetchSpacesRequestId: undefined,
                errors: [],
                autocompleteSuggestions: undefined
            });
        const fetchPeopleAndTeams = bootstrap.primaryProduct !== 'jira' && bootstrap.primaryProduct !== 'mercury' && !selectedProduct ? fetchPeopleAndTeamsCallback : ()=>Promise.resolve([]);
        const postQueryPromise = new (0, $czt8s.CancellablePromise)(Promise.allSettled([
            (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchProductEntities),
            (0, $cf5ef1e7c875b308$export$45bde04e7d1842b0)(fetchPeopleAndTeams)
        ]));
        postQueryPromiseRef.current = postQueryPromise;
        // Only fire postquery events for actual queries, not warmup requests
        if (!isWarmupRequest) onPostQueryStart?.();
        postQueryPromise.promise().then((results_8)=>{
            const productEntitiesStatus = results_8[0].status;
            const peopleAndTeamsStatus = results_8[1].status;
            // Post-query success is determined by product entities request, errors
            // from people and teams are ignored
            if (productEntitiesStatus === 'fulfilled') {
                const fetchedResults = results_8[0].value.result.results;
                setSearchResults({
                    result: fetchedResults,
                    duration: results_8[0].value.duration
                });
                const errors_3 = results_8[0].value.result.errors || [];
                setSearchErrors(errors_3);
                const hasThirdPartyResults = fetchedResults.some((result_3)=>result_3.id.startsWith('ari:cloud:graph::document') || result_3.id.startsWith('ari:cloud:graph::remote-link'));
                setFetchEntitiesRequestId(results_8[0].value.result.fetchEntitiesRequestId);
                setFetchEntitiesTraceId(results_8[0].value.result.fetchEntitiesTraceId);
                setFetchSpacesRequestId(results_8[0].value.result.fetchSpacesRequestId);
                setAutocompleteSuggestions(results_8[0].value.result.autocompleteSuggestions);
                const peopleAndTeams_0 = peopleAndTeamsStatus === 'fulfilled' ? {
                    result: results_8[1].value.result,
                    duration: results_8[1].value.duration
                } : $0c35e478cf8dbc82$var$EMPTY_RESULTS;
                setPeopleAndTeams(peopleAndTeams_0);
                const allDurations = results_8.map((result_4)=>result_4.status === 'fulfilled' ? result_4.value.duration : 0);
                const maxDuration = Math.max(...allDurations);
                const resultCount = fetchedResults.length;
                // Only fire postquery events for actual queries, not warmup requests
                if (!isWarmupRequest) onPostQuerySuccess?.(maxDuration, hasThirdPartyResults, resultCount);
            } else {
                const error_10 = new Error('Failed to fetch post query results');
                setPostQueryError(error_10);
                // Only fire postquery events for actual queries, not warmup requests
                if (!isWarmupRequest) onPostQueryFailure?.(error_10);
            }
            setPostQueryLoading(false);
            return results_8;
        }).catch((error_11)=>{
            if (!(error_11 instanceof (0, $czt8s.CancelError))) logException(error_11);
        });
    }, [
        bootstrap,
        fetchAssetsEntitiesCallback,
        fetchAtlasEntitiesCallback,
        fetchConfluenceEntitiesCallback,
        fetchJiraIssuesCallback,
        fetchMercuryEntitiesCallback,
        fetchTalentEntitiesCallback,
        fetchPeopleAndTeamsCallback,
        onPostQueryFailure,
        onPostQueryStart,
        onPostQuerySuccess,
        selectedProduct,
        setFetchEntitiesRequestId,
        setFetchEntitiesTraceId,
        setFetchSpacesRequestId,
        setSearchErrors,
        logException,
        preQueryTaskIdRef,
        postQueryTaskState,
        quickFindQuery
    ]);
    /**
   * Debounced fetch function for quick find results. This callback should never mutate
   * as the only dependency is the timeout value, hence it can be safely used in dependency array.
   */ const debouncedFetchQuickFindPostQuery = (0, $JQd0k.useDebouncedCallback)(fetchQuickFindPostQuery, debounceTimeout);
    (0, $42omo.useEffect)(()=>{
        if (quickFindOpen) {
            (async ()=>{
                if ((0, $dh538.fg)('enable_github_quickfind_experiment')) {
                    if (githubFullConnectorAuthorised || await hasGithubSmartLinkAccessRef.current) (0, $c6GJD.default).manuallyLogExperimentExposure('enable_github_links_hydration_in_quickfind_recent');
                }
            })();
            // If the user is allocated to this mutually exclusive experiment,
            // We fire an exposure by accessing a parameter within the layer.
            (0, $iA4lt.getMutuallyExclusiveUIExperiment)('quick_find_user_relevant_documents_experiment', (0, $4OGlb.STATSIG_QUICK_FIND_LAYER))?.get('cohort', undefined);
            (0, $2OtFZ.serveQFFilterSuggestionExperiment)(bootstrap.primaryProduct);
            (0, $2OtFZ.serve3PClickIngestionExperiment)(bootstrap.thirdPartyConfigs);
        }
    }, [
        quickFindOpen,
        bootstrap.thirdPartyConfigs,
        bootstrap.primaryProduct,
        githubFullConnectorAuthorised
    ]);
    /**
   * Updates results when various Quick Find states change, this includes:
   * - when search is ready
   * - when the dialog opens
   * - when the query changes
   * - when recent queries or activities change
   * - when selected entities or filters change
   */ (0, $42omo.useEffect)(()=>{
        if (!isSearchReady) return;
        if (preQueryPromiseRef.current) preQueryPromiseRef.current.cancel();
        const hideFilteredPreQueryResults_0 = !!(hasFiltersSelected || selectedProduct);
        const shouldRefetchPreQueryResults_0 = prevQuickFindOpenRef.current === false && quickFindOpen === true;
        fetchQuickFindPreQuery(quickFindQuery, hideFilteredPreQueryResults_0, shouldRefetchPreQueryResults_0);
        prevQuickFindOpenRef.current = quickFindOpen;
        /**
     * Skip fetching post-query results if:
     * - Quick Find is closed
     * - Post-query is disabled
     * - There is a current query filter selected
     */ if (!quickFindOpen || postQueryDisabled || currentQueryFilter) return;
        // Check if search parameters have changed, if not, skip fetching post-query results
        if (quickFindQuery === prevQueryRef.current && selectedFiltersEquality === prevSelectedFiltersEquality.current && entitiesEquality === prevEntitiesEquality.current && prevHasFiltersSelected.current === hasFiltersSelected && selectedProduct === prevSelectedProduct.current) return;
        prevQueryRef.current = quickFindQuery;
        prevSelectedFiltersEquality.current = selectedFiltersEquality;
        prevEntitiesEquality.current = entitiesEquality;
        prevHasFiltersSelected.current = hasFiltersSelected;
        prevSelectedProduct.current = selectedProduct;
        // Reset post-query results as search parameters have changed
        setSearchResults({
            result: [],
            duration: 0
        });
        setPeopleAndTeams({
            result: [],
            duration: 0
        });
        setPostQueryLoading(true);
        setPostQueryError(undefined);
        // Cancel the inflight request as search parameters have changed
        if (postQueryPromiseRef.current) {
            postQueryPromiseRef.current.cancel();
            onPostQueryCancel?.();
            postQueryPromiseRef.current = undefined;
        }
        const hasProductSelected = Boolean(selectedProduct) ?? false;
        const hasQuery = (0, $2bb736a7e62c9305$export$6e4070116bdfa183)({
            query: quickFindQuery,
            hasFiltersSelected: hasFiltersSelected || hasProductSelected
        });
        if (hasQuery) {
            setPostQueryLoading(true);
            debouncedFetchQuickFindPostQuery();
        }
    }, [
        fetchQuickFindPreQuery,
        debouncedFetchQuickFindPostQuery,
        quickFindQuery,
        retryCount,
        isSearchReady,
        quickFindOpen,
        selectedFilters,
        entities,
        onPostQueryCancel,
        postQueryDisabled,
        currentQueryFilter,
        selectedProduct,
        hasFiltersSelected,
        selectedFiltersEquality,
        entitiesEquality,
        isConfluence
    ]);
    return (0, $42omo.useMemo)(()=>(0, $2bb736a7e62c9305$export$35ead133d529e85e)({
            // Using refs here to ensure new results state is returned only
            // when the various result variables in the dependency array change
            query: prevQueryRef.current,
            hasFiltersSelected: prevHasFiltersSelected.current,
            quickFindOpen: prevQuickFindOpenRef.current,
            preQueryError: preQueryError,
            preQueryLoading: preQueryLoading,
            postQueryError: postQueryError,
            postQueryLoading: postQueryLoading,
            filteredRecentQueries: filteredRecentQueries,
            filteredRecentActivities: filteredRecentActivities,
            filteredUserDocuments: filteredUserDocuments,
            filteredRecommendedDocuments: filteredRecommendedDocuments,
            filteredZeroQueries: filteredZeroQueries,
            searchResults: searchResults,
            peopleAndTeams: peopleAndTeams,
            postQueryDisabled: postQueryDisabled,
            primaryProduct: bootstrap.primaryProduct,
            hasProductSelected: !!prevSelectedProduct.current,
            autocompleteSuggestions: autocompleteSuggestions,
            filterSuggestions: visibleFilterSuggestions
        }), [
        filteredRecentActivities,
        filteredUserDocuments,
        filteredRecommendedDocuments,
        filteredRecentQueries,
        filteredZeroQueries,
        peopleAndTeams,
        postQueryDisabled,
        postQueryError,
        postQueryLoading,
        preQueryError,
        preQueryLoading,
        searchResults,
        bootstrap.primaryProduct,
        autocompleteSuggestions,
        visibleFilterSuggestions
    ]);
};
const $0c35e478cf8dbc82$export$4f32340729fb620b = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(33);
    const previousStateRef = (0, $42omo.useRef)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const [t0] = (0, $j4ply.useBootstrap)();
    const { thirdPartyConfigs: thirdPartyConfigs } = t0;
    const searchErrors = (0, $4VmlX.useSearchErrors)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [requestedBackendExperiments] = (0, $djVCD.useRequestedBackendExperiments)();
    const intl = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    let t1;
    if ($[0] !== intl.locale || $[1] !== primaryProduct) {
        t1 = (0, $26jni.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false,
            locale: intl.locale
        });
        $[0] = intl.locale;
        $[1] = primaryProduct;
        $[2] = t1;
    } else t1 = $[2];
    const intentDetectionExperiment = t1;
    const intentRouterEnabled = intentDetectionExperiment?.cohort === "test";
    const intentDetectionCohort = intentDetectionExperiment?.cohort;
    let t2;
    if ($[3] !== searchErrors) {
        const errors = searchErrors || [];
        t2 = errors.filter($0c35e478cf8dbc82$var$_temp).map($0c35e478cf8dbc82$var$_temp2).flatMap($0c35e478cf8dbc82$var$_temp3);
        $[3] = searchErrors;
        $[4] = t2;
    } else t2 = $[4];
    const productsWithTimeoutsFromErrors = t2;
    let t3;
    bb0: {
        if (!content) {
            t3 = false;
            break bb0;
        }
        let t4;
        if ($[5] !== content || $[6] !== thirdPartyConfigs) {
            const serveGithubLinksHydration = (0, $b46a7e00048d637e$export$777e9d6bae4c913e)();
            const checkIsSmartLink = (result)=>{
                if (!result.data?.node?.object?.id || !result.data?.node?.event?.eventType) return false;
                const mappedResult = (0, $bfef7c7cb8b104c2$export$1d02b83d52558ed)(result.data, "", "", thirdPartyConfigs, serveGithubLinksHydration);
                return (0, $kQT7c.isResultSmartLink)({
                    resultAri: result.data.node.object.id,
                    thirdPartyConfigs: thirdPartyConfigs,
                    productKey: mappedResult?.analyticsMetadata.product,
                    eventType: result.data.node.event.eventType,
                    connectorType: result.data.connectorType
                });
            };
            t4 = ("recentActivities" in content ? content.recentActivities : []).some(checkIsSmartLink) || ("searchResults" in content ? content.searchResults : []).some(checkIsSmartLink);
            $[5] = content;
            $[6] = thirdPartyConfigs;
            $[7] = t4;
        } else t4 = $[7];
        t3 = t4;
    }
    const are3PSmartLinksInResults = t3;
    let t4;
    if ($[8] !== are3PSmartLinksInResults || $[9] !== commonAttributes || $[10] !== content || $[11] !== fireAnalyticsEvent || $[12] !== intentDetectionCohort || $[13] !== intl.locale || $[14] !== primaryProduct || $[15] !== productsWithTimeoutsFromErrors || $[16] !== quickFindOpen || $[17] !== requestedBackendExperiments || $[18] !== thirdPartyConfigs) {
        t4 = ()=>{
            const previousState = previousStateRef.current;
            previousStateRef.current = content ? content.state : undefined;
            if (!quickFindOpen || !content) return;
            if (content.state === previousState) return;
            if (content.state === (0, $aE5mL.State).PREQUERY_LOADING || content.state === (0, $aE5mL.State).PREQUERY_ERROR || content.state === (0, $aE5mL.State).POSTQUERY_ERROR) {
                if (content.state === (0, $aE5mL.State).PREQUERY_ERROR) fireAnalyticsEvent((0, $3746cfd8500fe3df$export$932440ee05101c0d)({
                    success: false,
                    attributes: commonAttributes,
                    resultsType: "preQuerySearchResults"
                }));
                if (content.state === (0, $aE5mL.State).POSTQUERY_ERROR) fireAnalyticsEvent((0, $3746cfd8500fe3df$export$932440ee05101c0d)({
                    success: false,
                    attributes: commonAttributes,
                    resultsType: "postQuerySearchResults"
                }));
                return;
            }
            if (content.state === (0, $aE5mL.State).POSTQUERY_RESULTS && previousState === undefined) return;
            const resultsTypeMap = {
                PREQUERY_RESULTS: "preQuerySearchResults",
                PREQUERY_NO_RESULTS: "preQuerySearchResults",
                POSTQUERY_LOADING: "cachedResults",
                POSTQUERY_RESULTS: "postQuerySearchResults",
                POSTQUERY_NO_RESULTS: "postQuerySearchResults"
            };
            const resultsType = resultsTypeMap[content.state];
            const { sectionCount: sectionCount, resultCount: resultCount } = (0, $9wmQG.getSectionsAndResultsCount)();
            const resultTypeCounts = (0, $9wmQG.getResultTypeCounts)();
            const productsInResults = (0, $9wmQG.getProductsInResults)();
            const isBulkConnectBannerShown = (0, $9wmQG.getIsBulkConnectBannerShown)();
            const resultsShown = (0, $9wmQG.getResultsShown)();
            const noResultsFetched = content.state === (0, $aE5mL.State).PREQUERY_NO_RESULTS || content.state === (0, $aE5mL.State).POSTQUERY_NO_RESULTS || resultCount === 0;
            if (noResultsFetched && resultsType === "cachedResults") return;
            const are3pResultsShown = productsInResults.some((0, $fuGkE.is3pProductKeyForAnalytics));
            const are3PInRecommendations = (0, $dh538.fg)("qf_are_3p_in_recommendations") ? (0, $9wmQG.getProductsInRecommendations)().some((0, $fuGkE.is3pProductKeyForAnalytics)) : undefined;
            const authorized3PProducts = Object.keys(thirdPartyConfigs || {}).filter((product)=>!thirdPartyConfigs?.[product]?.userNeedsOAuth);
            fireAnalyticsEvent((0, $e1a1aba41a097938$export$2d1da932f40a427e)({
                attributes: {
                    ...commonAttributes,
                    sectionCount: sectionCount,
                    resultCount: resultCount,
                    resultTypeCounts: resultTypeCounts,
                    productsInResults: productsInResults,
                    are3pResultsShown: are3pResultsShown,
                    searchAndResult: {
                        authorized3PProducts: authorized3PProducts
                    },
                    resultsShown: resultsShown,
                    isBulkConnectBannerShown: isBulkConnectBannerShown,
                    are3PSmartLinksInResults: are3PSmartLinksInResults,
                    noResultsFetched: noResultsFetched,
                    ...(0, $inrbX.getCommonQueryAttributes)(content.query),
                    ...requestedBackendExperiments,
                    ...resultsType === "postQuerySearchResults" ? {
                        productsWithTimeout: productsWithTimeoutsFromErrors || []
                    } : {},
                    ...are3PInRecommendations !== undefined ? {
                        are3PInRecommendations: are3PInRecommendations
                    } : {},
                    intentDetectionTriggered: (0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale),
                    queryClassification: (0, $4tgkZ.INTENT_DETECTION).value()?.mode,
                    modelId: (0, $4tgkZ.INTENT_DETECTION).value()?.modelId,
                    cohort: intentDetectionCohort,
                    patternType: (0, $4tgkZ.INTENT_DETECTION).value()?.patternType
                },
                nonPrivacySafeAttributes: {
                    query: content.query
                },
                resultsType: resultsType
            }));
            fireAnalyticsEvent((0, $3746cfd8500fe3df$export$932440ee05101c0d)({
                success: true,
                attributes: commonAttributes,
                resultsType: resultsType
            }));
        };
        $[8] = are3PSmartLinksInResults;
        $[9] = commonAttributes;
        $[10] = content;
        $[11] = fireAnalyticsEvent;
        $[12] = intentDetectionCohort;
        $[13] = intl.locale;
        $[14] = primaryProduct;
        $[15] = productsWithTimeoutsFromErrors;
        $[16] = quickFindOpen;
        $[17] = requestedBackendExperiments;
        $[18] = thirdPartyConfigs;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] !== are3PSmartLinksInResults || $[21] !== commonAttributes || $[22] !== content || $[23] !== fireAnalyticsEvent || $[24] !== intentDetectionCohort || $[25] !== intentRouterEnabled || $[26] !== intl.locale || $[27] !== primaryProduct || $[28] !== productsWithTimeoutsFromErrors || $[29] !== quickFindOpen || $[30] !== requestedBackendExperiments || $[31] !== thirdPartyConfigs) {
        t5 = [
            commonAttributes,
            content,
            fireAnalyticsEvent,
            quickFindOpen,
            requestedBackendExperiments,
            are3PSmartLinksInResults,
            thirdPartyConfigs,
            productsWithTimeoutsFromErrors,
            intentRouterEnabled,
            primaryProduct,
            intl.locale,
            intentDetectionCohort
        ];
        $[20] = are3PSmartLinksInResults;
        $[21] = commonAttributes;
        $[22] = content;
        $[23] = fireAnalyticsEvent;
        $[24] = intentDetectionCohort;
        $[25] = intentRouterEnabled;
        $[26] = intl.locale;
        $[27] = primaryProduct;
        $[28] = productsWithTimeoutsFromErrors;
        $[29] = quickFindOpen;
        $[30] = requestedBackendExperiments;
        $[31] = thirdPartyConfigs;
        $[32] = t5;
    } else t5 = $[32];
    (0, $42omo.useEffect)(t4, t5);
} : ()=>{
    const previousStateRef = (0, $42omo.useRef)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const searchErrors = (0, $4VmlX.useSearchErrors)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestedBackendExperiments] = (0, $djVCD.useRequestedBackendExperiments)();
    const intl = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const intentDetectionExperiment = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        // Exposure is fired when a user calls the intent detection API
        locale: intl.locale
    });
    const intentRouterEnabled = intentDetectionExperiment?.cohort === 'test';
    const intentDetectionCohort = intentDetectionExperiment?.cohort;
    const productsWithTimeoutsFromErrors = (0, $42omo.useMemo)(()=>{
        const errors = searchErrors || [];
        return errors.filter((error)=>error.extensions?.statusCode === 408).map((error_0)=>error_0.extensions?.integration ?? error_0.extensions?.product).flatMap((s)=>s && (0, $b4tvS.isProductKey)(s) ? [
                s
            ] : []);
    }, [
        searchErrors
    ]);
    const are3PSmartLinksInResults = (0, $42omo.useMemo)(()=>{
        if (!content) return false;
        const serveGithubLinksHydration = (0, $b46a7e00048d637e$export$777e9d6bae4c913e)();
        const checkIsSmartLink = (result)=>{
            if (!result.data?.node?.object?.id || !result.data?.node?.event?.eventType) return false;
            const mappedResult = (0, $bfef7c7cb8b104c2$export$1d02b83d52558ed)(result.data, '', // query not needed to obtain the `product` value
            '', // searchSessionId not needed to obtain the `product` value
            thirdPartyConfigs, serveGithubLinksHydration);
            return (0, $kQT7c.isResultSmartLink)({
                resultAri: result.data.node.object.id,
                thirdPartyConfigs: thirdPartyConfigs,
                productKey: mappedResult?.analyticsMetadata.product,
                eventType: result.data.node.event.eventType,
                connectorType: result.data.connectorType
            });
        };
        return ('recentActivities' in content ? content.recentActivities : []).some(checkIsSmartLink) || ('searchResults' in content ? content.searchResults : []).some(checkIsSmartLink);
    }, [
        content,
        thirdPartyConfigs
    ]);
    (0, $42omo.useEffect)(()=>{
        // Store a copy of previous state before updating the ref
        const previousState = previousStateRef.current;
        previousStateRef.current = content ? content.state : undefined;
        // Don't fire analytics event if the dialog is closed
        if (!quickFindOpen || !content) return;
        // Don't fire analytics event if the state hasn't changed
        if (content.state === previousState) return;
        // Ignore states that do not have search results
        if (content.state === (0, $aE5mL.State).PREQUERY_LOADING || content.state === (0, $aE5mL.State).PREQUERY_ERROR || content.state === (0, $aE5mL.State).POSTQUERY_ERROR) {
            if (content.state === (0, $aE5mL.State).PREQUERY_ERROR) fireAnalyticsEvent((0, $3746cfd8500fe3df$export$932440ee05101c0d)({
                success: false,
                attributes: commonAttributes,
                resultsType: 'preQuerySearchResults'
            }));
            if (content.state === (0, $aE5mL.State).POSTQUERY_ERROR) fireAnalyticsEvent((0, $3746cfd8500fe3df$export$932440ee05101c0d)({
                success: false,
                attributes: commonAttributes,
                resultsType: 'postQuerySearchResults'
            }));
            return;
        }
        /**
     * Do not fire analytics event when the dialog is opened and post-query
     * results are already returned. This is to have parity with the old
     * quick find component.
     *
     * Whilst this may not be correct, this is here to ensure changes in metrics
     * such as QSR and CTR are intentional.
     *
     * TODO: Discuss with DS/DE if this correct behaviour
     */ if (content.state === (0, $aE5mL.State).POSTQUERY_RESULTS && previousState === undefined) return;
        const resultsTypeMap = {
            PREQUERY_RESULTS: 'preQuerySearchResults',
            PREQUERY_NO_RESULTS: 'preQuerySearchResults',
            POSTQUERY_LOADING: 'cachedResults',
            POSTQUERY_RESULTS: 'postQuerySearchResults',
            POSTQUERY_NO_RESULTS: 'postQuerySearchResults'
        };
        const resultsType = resultsTypeMap[content.state];
        const { sectionCount: sectionCount, resultCount: resultCount } = (0, $9wmQG.getSectionsAndResultsCount)();
        const resultTypeCounts = (0, $9wmQG.getResultTypeCounts)();
        const productsInResults = (0, $9wmQG.getProductsInResults)();
        const isBulkConnectBannerShown = (0, $9wmQG.getIsBulkConnectBannerShown)();
        const resultsShown = (0, $9wmQG.getResultsShown)();
        const noResultsFetched = content.state === (0, $aE5mL.State).PREQUERY_NO_RESULTS || content.state === (0, $aE5mL.State).POSTQUERY_NO_RESULTS || resultCount === 0;
        // Don't fire cachedResults event if there are no results
        if (noResultsFetched && resultsType === 'cachedResults') return;
        const are3pResultsShown = productsInResults.some((0, $fuGkE.is3pProductKeyForAnalytics));
        const are3PInRecommendations = (0, $dh538.fg)('qf_are_3p_in_recommendations') ? (0, $9wmQG.getProductsInRecommendations)().some((0, $fuGkE.is3pProductKeyForAnalytics)) : undefined;
        const authorized3PProducts = Object.keys(thirdPartyConfigs || {}).filter((product)=>!thirdPartyConfigs?.[product]?.userNeedsOAuth);
        fireAnalyticsEvent((0, $e1a1aba41a097938$export$2d1da932f40a427e)({
            attributes: {
                ...commonAttributes,
                sectionCount: sectionCount,
                resultCount: resultCount,
                resultTypeCounts: resultTypeCounts,
                productsInResults: productsInResults,
                are3pResultsShown: are3pResultsShown,
                // Use `searchAndResult` to keep the schema consistent with FPS, but we don't need other attributes yet.
                searchAndResult: {
                    authorized3PProducts: authorized3PProducts
                },
                resultsShown: resultsShown,
                isBulkConnectBannerShown: isBulkConnectBannerShown,
                are3PSmartLinksInResults: are3PSmartLinksInResults,
                noResultsFetched: noResultsFetched,
                ...(0, $inrbX.getCommonQueryAttributes)(content.query),
                ...requestedBackendExperiments,
                ...resultsType === 'postQuerySearchResults' ? {
                    productsWithTimeout: productsWithTimeoutsFromErrors || []
                } : {},
                // `are3PInRecommendations` is `undefined` when the
                // `qf_are_3p_in_recommendations` gate is off (see computation above),
                // so this `undefined` check also functions as the gate guard and
                // avoids a second `fg()` evaluation per event.
                ...are3PInRecommendations !== undefined ? {
                    are3PInRecommendations: are3PInRecommendations
                } : {},
                intentDetectionTriggered: (0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale),
                queryClassification: (0, $4tgkZ.INTENT_DETECTION).value()?.mode,
                modelId: (0, $4tgkZ.INTENT_DETECTION).value()?.modelId,
                cohort: intentDetectionCohort,
                patternType: (0, $4tgkZ.INTENT_DETECTION).value()?.patternType
            },
            nonPrivacySafeAttributes: {
                query: content.query
            },
            resultsType: resultsType
        }));
        fireAnalyticsEvent((0, $3746cfd8500fe3df$export$932440ee05101c0d)({
            success: true,
            attributes: commonAttributes,
            resultsType: resultsType
        }));
    }, [
        commonAttributes,
        content,
        fireAnalyticsEvent,
        quickFindOpen,
        requestedBackendExperiments,
        are3PSmartLinksInResults,
        thirdPartyConfigs,
        productsWithTimeoutsFromErrors,
        intentRouterEnabled,
        primaryProduct,
        intl.locale,
        intentDetectionCohort
    ]);
};
const $0c35e478cf8dbc82$export$6a204b1a019f0cc8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const previousStateRef = (0, $42omo.useRef)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const intl = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    let t0;
    if ($[0] !== intl.locale || $[1] !== primaryProduct) {
        t0 = (0, $26jni.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false,
            locale: intl.locale
        })?.cohort;
        $[0] = intl.locale;
        $[1] = primaryProduct;
        $[2] = t0;
    } else t0 = $[2];
    const intentRouterEnabled = t0 === "test";
    let t1;
    let t2;
    if ($[3] !== commonAttributes || $[4] !== content || $[5] !== fireAnalyticsEvent || $[6] !== intentRouterEnabled || $[7] !== nonPrivacySafeAttributes || $[8] !== quickFindOpen) {
        t1 = ()=>{
            const previousState = previousStateRef.current;
            previousStateRef.current = content ? content.state : undefined;
            if (!quickFindOpen || !content) return;
            if (content.state === previousState) return;
            const shownZeroQueries = (0, $9wmQG.getShownZeroQueries)();
            if (shownZeroQueries.length > 0) fireAnalyticsEvent((0, $4b1cc554b296ee78$export$9698f7c8e7c9a2f7)({
                actionSubjectId: (0, $idEgG.getActionSubjectId)(content.state),
                attributes: {
                    ...commonAttributes,
                    ...intentRouterEnabled ? {
                        queryClassification: (0, $4tgkZ.INTENT_DETECTION).value()?.mode,
                        modelId: (0, $4tgkZ.INTENT_DETECTION).value()?.modelId,
                        patternType: (0, $4tgkZ.INTENT_DETECTION).value()?.patternType
                    } : {},
                    suggestedQueriesShown: shownZeroQueries.map($0c35e478cf8dbc82$var$_temp4)
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        t2 = [
            commonAttributes,
            nonPrivacySafeAttributes,
            content,
            fireAnalyticsEvent,
            quickFindOpen,
            intentRouterEnabled
        ];
        $[3] = commonAttributes;
        $[4] = content;
        $[5] = fireAnalyticsEvent;
        $[6] = intentRouterEnabled;
        $[7] = nonPrivacySafeAttributes;
        $[8] = quickFindOpen;
        $[9] = t1;
        $[10] = t2;
    } else {
        t1 = $[9];
        t2 = $[10];
    }
    (0, $42omo.useEffect)(t1, t2);
} : ()=>{
    const previousStateRef = (0, $42omo.useRef)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const intl = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const intentRouterEnabled = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        // Exposure is fired when a user calls the intent detection API
        locale: intl.locale
    })?.cohort === 'test';
    (0, $42omo.useEffect)(()=>{
        // Store a copy of previous state before updating the ref
        const previousState = previousStateRef.current;
        previousStateRef.current = content ? content.state : undefined;
        // Don't fire analytics event if the dialog is closed
        if (!quickFindOpen || !content) return;
        // Don't fire analytics event if the state hasn't changed
        if (content.state === previousState) return;
        // Fire a single consolidated event with all suggested queries when Quick Find opens.
        // This complements (but does not replace) the existing per-item suggestedQuery shown events.
        // Read actually-rendered zero query nodes from the DOM (mirrors getResultsShown approach),
        // so the event only reflects what was visible to the user.
        const shownZeroQueries = (0, $9wmQG.getShownZeroQueries)();
        if (shownZeroQueries.length > 0) fireAnalyticsEvent((0, $4b1cc554b296ee78$export$9698f7c8e7c9a2f7)({
            actionSubjectId: (0, $idEgG.getActionSubjectId)(content.state),
            attributes: {
                // All existing commonAttributes — same as what each per-item suggestedQuery shown event sends
                ...commonAttributes,
                // Intent router attributes (same gate as existing per-item event)
                ...intentRouterEnabled ? {
                    queryClassification: (0, $4tgkZ.INTENT_DETECTION).value()?.mode,
                    modelId: (0, $4tgkZ.INTENT_DETECTION).value()?.modelId,
                    patternType: (0, $4tgkZ.INTENT_DETECTION).value()?.patternType
                } : {},
                // Per-item fields consolidated into one array, derived from DOM
                suggestedQueriesShown: shownZeroQueries.map(({ zeroQueryType: zeroQueryType, zeroQueryPosition: zeroQueryPosition })=>({
                        zeroQueryType: zeroQueryType,
                        zeroQueryPosition: zeroQueryPosition,
                        zeroQueryVersion: (0, $1d2671f5d43d8750$export$2378e9e94d0e91e3)(zeroQueryType),
                        is3PZeroQuery: (0, $1d2671f5d43d8750$export$6da79ec281e5bbf3)(zeroQueryType)
                    }))
            },
            nonPrivacySafeAttributes: // Same nonPrivacySafeAttributes as the existing per-item event
            nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        nonPrivacySafeAttributes,
        content,
        fireAnalyticsEvent,
        quickFindOpen,
        intentRouterEnabled
    ]);
};
const $0c35e478cf8dbc82$export$da9d0159e5272189 = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? (options)=>{
    const $ = (0, $frIzR.c)(7);
    const callbacks = (0, $a755cc866a3495f8$export$483ef80309da5ade)();
    let t0;
    if ($[0] !== callbacks || $[1] !== options) {
        t0 = {
            ...options,
            ...callbacks
        };
        $[0] = callbacks;
        $[1] = options;
        $[2] = t0;
    } else t0 = $[2];
    const useQuickFindResultsArgs = t0;
    const content = $0c35e478cf8dbc82$export$ab15aae48c593ecc(useQuickFindResultsArgs);
    const { setContent: setContent } = (0, $4VmlX.useQuickFindActions)();
    let t1;
    let t2;
    if ($[3] !== content || $[4] !== setContent) {
        t1 = ()=>{
            setContent(content);
        };
        t2 = [
            content,
            setContent
        ];
        $[3] = content;
        $[4] = setContent;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $42omo.useEffect)(t1, t2);
    $0c35e478cf8dbc82$export$4f32340729fb620b();
    $0c35e478cf8dbc82$export$6a204b1a019f0cc8();
    return null;
} : (options)=>{
    const callbacks = (0, $a755cc866a3495f8$export$483ef80309da5ade)();
    const useQuickFindResultsArgs = (0, $42omo.useMemo)(()=>({
            ...options,
            ...callbacks
        }), [
        options,
        callbacks
    ]);
    const content = $0c35e478cf8dbc82$export$ab15aae48c593ecc(useQuickFindResultsArgs);
    const { setContent: setContent } = (0, $4VmlX.useQuickFindActions)();
    (0, $42omo.useEffect)(()=>{
        setContent(content);
    }, [
        content,
        setContent
    ]);
    $0c35e478cf8dbc82$export$4f32340729fb620b();
    $0c35e478cf8dbc82$export$6a204b1a019f0cc8();
    return null;
});
function $0c35e478cf8dbc82$var$_temp(error) {
    return error.extensions?.statusCode === 408;
}
function $0c35e478cf8dbc82$var$_temp2(error_0) {
    return error_0.extensions?.integration ?? error_0.extensions?.product;
}
function $0c35e478cf8dbc82$var$_temp3(s) {
    return s && (0, $b4tvS.isProductKey)(s) ? [
        s
    ] : [];
}
function $0c35e478cf8dbc82$var$_temp4(t0) {
    const { zeroQueryType: zeroQueryType, zeroQueryPosition: zeroQueryPosition } = t0;
    return {
        zeroQueryType: zeroQueryType,
        zeroQueryPosition: zeroQueryPosition,
        zeroQueryVersion: (0, $1d2671f5d43d8750$export$2378e9e94d0e91e3)(zeroQueryType),
        is3PZeroQuery: (0, $1d2671f5d43d8750$export$6da79ec281e5bbf3)(zeroQueryType)
    };
}











// Default value hoisted outside to prevent recreation on every render
const $e6c80dec8a0d452c$var$DEFAULT_TASK_STATE = {
    id: null,
    state: 'idle',
    error: null,
    queryHash: null,
    queryLength: null,
    wordCount: null
};
const $e6c80dec8a0d452c$var$IntentDetectionVitalStatsContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $e6c80dec8a0d452c$export$7d6ff8eec92df467 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    const taskStateRef = (0, $42omo.useRef)($e6c80dec8a0d452c$var$DEFAULT_TASK_STATE);
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6c80dec8a0d452c$var$IntentDetectionVitalStatsContext.Provider, {
            value: taskStateRef
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    // Use hoisted default to prevent object recreation on every render
    const taskStateRef = (0, $42omo.useRef)($e6c80dec8a0d452c$var$DEFAULT_TASK_STATE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6c80dec8a0d452c$var$IntentDetectionVitalStatsContext.Provider, {
        value: taskStateRef
    }, children);
};
const $e6c80dec8a0d452c$export$714277298f52f5c1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const taskStateRef = (0, $42omo.useContext)($e6c80dec8a0d452c$var$IntentDetectionVitalStatsContext);
    if (!taskStateRef) throw new Error("useIntentDetectionVitalStatsTaskState must be used within IntentDetectionVitalStatsProvider");
    return taskStateRef;
} : ()=>{
    const taskStateRef = (0, $42omo.useContext)($e6c80dec8a0d452c$var$IntentDetectionVitalStatsContext);
    if (!taskStateRef) throw new Error('useIntentDetectionVitalStatsTaskState must be used within IntentDetectionVitalStatsProvider');
    return taskStateRef;
};







var $8aC7e = parcelRequire("8aC7e");
















const $f58c1f7467c49dec$export$5f60ff1bbe7f1a37 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4VmlX.QuickFindStoreContainer), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4VmlX.QuickFindStoreContainer), null, children);
};



var $bHLTK = parcelRequire("bHLTK");






















var $bUlM5 = parcelRequire("bUlM5");







var $fwDOR = parcelRequire("fwDOR");


var $6CITI = parcelRequire("6CITI");


var $4TTdD = parcelRequire("4TTdD");


var $8LSUr = parcelRequire("8LSUr");








var $9vOy1 = parcelRequire("9vOy1");































const $5cfb43da7e344c6a$var$containerStyles = (0, $ecnYn.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100'
});
const $5cfb43da7e344c6a$var$headingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    fontWeight: 'font.weight.semibold',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    width: '100%',
    padding: 'space.100',
    userSelect: 'none'
});
const $5cfb43da7e344c6a$export$a8a3e93435678ff9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { id: id, children: children, includeInAnalytics: t1 } = t0;
    const includeInAnalytics = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $5cfb43da7e344c6a$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "h2",
            xcss: $5cfb43da7e344c6a$var$headingStyles
        }, children));
        $[0] = children;
        $[1] = t2;
    } else t2 = $[1];
    const headingWithoutAnalyticsWrapper = t2;
    let t3;
    if ($[2] !== headingWithoutAnalyticsWrapper || $[3] !== id || $[4] !== includeInAnalytics) {
        t3 = includeInAnalytics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9wmQG.SearchDialogHeaderAnalyticsWrapper), {
            id: id
        }, headingWithoutAnalyticsWrapper) : headingWithoutAnalyticsWrapper;
        $[2] = headingWithoutAnalyticsWrapper;
        $[3] = id;
        $[4] = includeInAnalytics;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ id: id, children: children, includeInAnalytics: includeInAnalytics = true })=>{
    const headingWithoutAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5cfb43da7e344c6a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "h2",
        xcss: $5cfb43da7e344c6a$var$headingStyles
    }, children));
    return includeInAnalytics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9wmQG.SearchDialogHeaderAnalyticsWrapper), {
        id: id
    }, headingWithoutAnalyticsWrapper) : headingWithoutAnalyticsWrapper;
};

















const $addf1cb001f831f5$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $addf1cb001f831f5$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'radius.large',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none'
});
const $addf1cb001f831f5$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $addf1cb001f831f5$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small'
});
const $addf1cb001f831f5$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $addf1cb001f831f5$var$titleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small',
    height: '16px',
    width: '40%'
});
const $addf1cb001f831f5$var$metadataStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'color.skeleton',
    width: '20%',
    borderRadius: 'radius.small',
    height: '13px'
});
const $addf1cb001f831f5$export$dd3282b157ef6f7a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            $addf1cb001f831f5$var$resultStyles
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $addf1cb001f831f5$var$iconAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $addf1cb001f831f5$var$iconStyles
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $addf1cb001f831f5$var$titleStyles
            ]
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $addf1cb001f831f5$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t0
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $addf1cb001f831f5$var$middleAreaStyles
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $addf1cb001f831f5$var$metadataStyles
            ]
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $addf1cb001f831f5$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $addf1cb001f831f5$var$resultStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $addf1cb001f831f5$var$iconAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $addf1cb001f831f5$var$iconStyles
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $addf1cb001f831f5$var$middleAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $addf1cb001f831f5$var$titleStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $addf1cb001f831f5$var$metadataStyles
        ]
    }))));
};























const $78f71f4d1dd2450a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    availableOptions: {
        id: "search-page.common.ui.quick-find.search-dialog-announcer.availableOptions",
        defaultMessage: "{count} options available"
    }
});


const $7186c8e2b9110674$var$styles = {
    hiddenTitle: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _19itglyw _kqswstnw _1bsbidpf _4t3iidpf _o5721q9c"
};
const $7186c8e2b9110674$export$41f905bcc65a859f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { isLoading: isLoading } = t0;
    const dialogAnnouncerRef = (0, $42omo.useRef)(null);
    const keyboardNavComponents = (0, $icqFF.useKeyboardHighlightProvider)()?.keyboardNavComponents;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== isLoading || $[2] !== keyboardNavComponents) {
        t1 = ()=>{
            if (dialogAnnouncerRef.current && !isLoading) {
                dialogAnnouncerRef.current.textContent = "";
                const rafId = requestAnimationFrame(()=>{
                    if (dialogAnnouncerRef.current && keyboardNavComponents?.length) dialogAnnouncerRef.current.textContent = formatMessage((0, $78f71f4d1dd2450a$export$defe85febe8b728c).availableOptions, {
                        count: keyboardNavComponents.length
                    });
                });
                return ()=>cancelAnimationFrame(rafId);
            }
        };
        $[0] = formatMessage;
        $[1] = isLoading;
        $[2] = keyboardNavComponents;
        $[3] = t1;
    } else t1 = $[3];
    const t2 = keyboardNavComponents?.length;
    let t3;
    if ($[4] !== formatMessage || $[5] !== isLoading || $[6] !== t2) {
        t3 = [
            t2,
            isLoading,
            formatMessage
        ];
        $[4] = formatMessage;
        $[5] = isLoading;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    (0, $42omo.useEffect)(t1, t3);
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $7186c8e2b9110674$var$styles.hiddenTitle,
            "aria-live": "polite",
            "aria-atomic": true,
            ref: dialogAnnouncerRef
        });
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ isLoading: isLoading })=>{
    const dialogAnnouncerRef = (0, $42omo.useRef)(null);
    const keyboardNavComponents = (0, $icqFF.useKeyboardHighlightProvider)()?.keyboardNavComponents;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        if (dialogAnnouncerRef.current && !isLoading) {
            // Clear then re-set in the next frame so screen readers treat it
            // as a new announcement, even when the text is identical.
            dialogAnnouncerRef.current.textContent = '';
            const rafId = requestAnimationFrame(()=>{
                if (dialogAnnouncerRef.current && keyboardNavComponents?.length) dialogAnnouncerRef.current.textContent = formatMessage((0, $78f71f4d1dd2450a$export$defe85febe8b728c).availableOptions, {
                    count: keyboardNavComponents.length
                });
            });
            return ()=>cancelAnimationFrame(rafId);
        }
    }, [
        keyboardNavComponents?.length,
        isLoading,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $7186c8e2b9110674$var$styles.hiddenTitle,
        "aria-live": "polite",
        "aria-atomic": true,
        ref: dialogAnnouncerRef
    });
};
















const $3a090af578c3c72f$export$1a414fdf8e9c6492 = ()=>{
    return window.location.pathname.includes('/jira/rovo-search');
};



var $kIdP4 = parcelRequire("kIdP4");


var $a5OFf = parcelRequire("a5OFf");





const $2d65b64d3d4cb16d$export$dca164322a50872a = (activities, remainingSlots, topN = 7)=>{
    const topRecentActivities = activities.slice(0, topN);
    const thirdPartyActivities = topRecentActivities.filter((activity)=>(0, $hWR4v.isGraphActivity)(activity.data.node.object));
    const nonThirdPartyActivities = topRecentActivities.filter((activity)=>!(0, $hWR4v.isGraphActivity)(activity.data.node.object));
    return [
        ...thirdPartyActivities,
        ...nonThirdPartyActivities
    ].slice(0, remainingSlots);
};


const $da0a8f0656f9d4ba$export$d20fe15ea6549dcc = ({ attributes: attributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'exposed',
        actionSubject: 'intentRouterExperiment',
        actionSubjectId: 'intentRouterExperimentExposed',
        attributes: attributes
    });


const $57230a101297e6c3$export$bcff6baaecbbc96 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'dismissed',
        actionSubject: `searchDialog`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $de62c0fb6467b42a$export$39e1d377a6a3de5d = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `searchDialog`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });




















/**
 * A component to control rendering of Rovo/Unified Search components.
 * To be used when a component/experience is only available in a specific application mode.
 *
 * Example usage:
 * <ShowIfEligible requiredMode={ApplicationModes.Rovo}>
 *   <SomeCoolRovoFeature />
 * </ShowIfEligible>
 */ const $c33ab075ce0a02db$var$ShowIfEligible = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { requiredMode: requiredMode, children: children } = t0;
    const currentMode = (0, $j4ply.useApplicationMode)();
    if (currentMode === requiredMode) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    return null;
} : ({ requiredMode: requiredMode, children: children })=>{
    const currentMode = (0, $j4ply.useApplicationMode)();
    if (currentMode === requiredMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return null;
};
var $c33ab075ce0a02db$export$2e2bcd8739ae039 = $c33ab075ce0a02db$var$ShowIfEligible;











































const $269ee6c4b9937e56$export$5b6291bff520e069 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(26);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const taskStateRef = (0, $785f0e86c2e88315$export$85fd2191723185b5)();
    const userId = (0, $j4ply.useCurrentUserId)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $dh538.fg)("rovo-search-vitalstats-quickfind-postquery-ux");
        $[0] = t0;
    } else t0 = $[0];
    const isEnabled = t0;
    let t1;
    if ($[1] !== commonAttributes.searchSessionId || $[2] !== fireAnalyticsEvent || $[3] !== taskStateRef) {
        t1 = ()=>{
            if (!isEnabled) return;
            const taskId = crypto.randomUUID();
            const searchSessionId = commonAttributes.searchSessionId || "";
            if (taskStateRef.current) {
                taskStateRef.current.id = taskId;
                taskStateRef.current.started = true;
                taskStateRef.current.completed = false;
            }
            fireAnalyticsEvent((0, $bQSQw.onTaskStart)({
                searchSessionId: searchSessionId,
                taskId: taskId,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
            }));
        };
        $[1] = commonAttributes.searchSessionId;
        $[2] = fireAnalyticsEvent;
        $[3] = taskStateRef;
        $[4] = t1;
    } else t1 = $[4];
    const startTask = t1;
    let t2;
    if ($[5] !== commonAttributes.searchSessionId || $[6] !== fireAnalyticsEvent || $[7] !== taskStateRef || $[8] !== userId) {
        t2 = ()=>{
            if (!isEnabled || !taskStateRef.current?.started || taskStateRef.current?.completed) return;
            const { id: taskId_0 } = taskStateRef.current;
            const searchSessionId_0 = commonAttributes.searchSessionId || "";
            if (!taskId_0) return;
            const moreContext = (0, $dh538.fg)("rovo-search-ml-lens") ? {
                ml_lens: (0, $85a150055fc58773$export$addc105232081b06)((0, $9wmQG.getProductResultCounts)(), userId)
            } : undefined;
            fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                searchSessionId: searchSessionId_0,
                taskId: taskId_0,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                moreContext: moreContext
            }));
            if (taskStateRef.current) taskStateRef.current.completed = true;
        };
        $[5] = commonAttributes.searchSessionId;
        $[6] = fireAnalyticsEvent;
        $[7] = taskStateRef;
        $[8] = userId;
        $[9] = t2;
    } else t2 = $[9];
    const completeTaskSuccess = t2;
    let t3;
    if ($[10] !== commonAttributes.searchSessionId || $[11] !== fireAnalyticsEvent || $[12] !== taskStateRef) {
        t3 = (error)=>{
            if (!isEnabled || !taskStateRef.current?.started || taskStateRef.current?.completed) return;
            const { id: taskId_1 } = taskStateRef.current;
            const searchSessionId_1 = commonAttributes.searchSessionId || "";
            if (!taskId_1) return;
            fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
                searchSessionId: searchSessionId_1,
                taskId: taskId_1,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                moreContext: {
                    errorName: error?.name,
                    errorMessage: error?.message
                }
            }));
            taskStateRef.current.completed = true;
        };
        $[10] = commonAttributes.searchSessionId;
        $[11] = fireAnalyticsEvent;
        $[12] = taskStateRef;
        $[13] = t3;
    } else t3 = $[13];
    const completeTaskFail = t3;
    let t4;
    if ($[14] !== commonAttributes.searchSessionId || $[15] !== fireAnalyticsEvent || $[16] !== taskStateRef) {
        t4 = (abortReason)=>{
            if (!isEnabled || !taskStateRef.current?.started || taskStateRef.current?.completed) return;
            const { id: taskId_2 } = taskStateRef.current;
            const searchSessionId_2 = commonAttributes.searchSessionId || "";
            if (!taskId_2) return;
            taskStateRef.current.completed = true;
            (0, $42omo.startTransition)(()=>{
                fireAnalyticsEvent((0, $bQSQw.onTaskAbort)({
                    searchSessionId: searchSessionId_2,
                    taskId: taskId_2,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                    moreContext: {
                        abortReason: abortReason
                    }
                }));
            });
        };
        $[14] = commonAttributes.searchSessionId;
        $[15] = fireAnalyticsEvent;
        $[16] = taskStateRef;
        $[17] = t4;
    } else t4 = $[17];
    const abortTask = t4;
    let t5;
    if ($[18] !== taskStateRef) {
        t5 = ()=>taskStateRef.current?.started && !taskStateRef.current?.completed;
        $[18] = taskStateRef;
        $[19] = t5;
    } else t5 = $[19];
    const isTaskActive = t5;
    let t6;
    if ($[20] !== abortTask || $[21] !== completeTaskFail || $[22] !== completeTaskSuccess || $[23] !== isTaskActive || $[24] !== startTask) {
        t6 = {
            startTask: startTask,
            completeTaskSuccess: completeTaskSuccess,
            completeTaskFail: completeTaskFail,
            abortTask: abortTask,
            isTaskActive: isTaskActive
        };
        $[20] = abortTask;
        $[21] = completeTaskFail;
        $[22] = completeTaskSuccess;
        $[23] = isTaskActive;
        $[24] = startTask;
        $[25] = t6;
    } else t6 = $[25];
    return t6;
} : ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const taskStateRef = (0, $785f0e86c2e88315$export$85fd2191723185b5)();
    const userId = (0, $j4ply.useCurrentUserId)();
    const isEnabled = (0, $dh538.fg)('rovo-search-vitalstats-quickfind-postquery-ux');
    const startTask = (0, $42omo.useCallback)(()=>{
        if (!isEnabled) return;
        const taskId = crypto.randomUUID();
        const searchSessionId = commonAttributes.searchSessionId || '';
        // Set the shared context state
        if (taskStateRef.current) {
            taskStateRef.current.id = taskId;
            taskStateRef.current.started = true;
            taskStateRef.current.completed = false;
        }
        fireAnalyticsEvent((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX
        }));
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const completeTaskSuccess = (0, $42omo.useCallback)(()=>{
        // Check if task is active using the shared context state
        if (!isEnabled || !taskStateRef.current?.started || taskStateRef.current?.completed) return;
        const { id: taskId_0 } = taskStateRef.current;
        const searchSessionId_0 = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when started is true
        if (!taskId_0) return;
        // Additive `ml_lens` envelope so the ML Lens transformer can split this
        // taskSuccess into per-connector `results_per_connector` metrics.
        // Gated independently of the parent VitalStats FG; on `POSTQUERY_NO_RESULTS`
        // `getProductResultCounts` returns `{}` and the envelope is emitted with
        // `metrics: []`.
        const moreContext = (0, $dh538.fg)('rovo-search-ml-lens') ? {
            ml_lens: (0, $85a150055fc58773$export$addc105232081b06)((0, $9wmQG.getProductResultCounts)(), userId)
        } : undefined;
        fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
            searchSessionId: searchSessionId_0,
            taskId: taskId_0,
            task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
            moreContext: moreContext
        }));
        // Mark task as completed
        if (taskStateRef.current) taskStateRef.current.completed = true;
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef,
        userId
    ]);
    const completeTaskFail = (0, $42omo.useCallback)((error)=>{
        // Check if task is active using the shared context state
        if (!isEnabled || !taskStateRef.current?.started || taskStateRef.current?.completed) return;
        const { id: taskId_1 } = taskStateRef.current;
        const searchSessionId_1 = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when started is true
        if (!taskId_1) return;
        fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
            searchSessionId: searchSessionId_1,
            taskId: taskId_1,
            task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
            moreContext: {
                errorName: error?.name,
                errorMessage: error?.message
            }
        }));
        // Mark task as completed
        taskStateRef.current.completed = true;
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const abortTask = (0, $42omo.useCallback)((abortReason)=>{
        // Check if task is active using the shared context state
        if (!isEnabled || !taskStateRef.current?.started || taskStateRef.current?.completed) return;
        const { id: taskId_2 } = taskStateRef.current;
        const searchSessionId_2 = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when started is true
        if (!taskId_2) return;
        // Mark task as completed FIRST (synchronously) to prevent race conditions
        taskStateRef.current.completed = true;
        // Then defer the analytics event to not block rendering
        (0, $42omo.startTransition)(()=>{
            fireAnalyticsEvent((0, $bQSQw.onTaskAbort)({
                searchSessionId: searchSessionId_2,
                taskId: taskId_2,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_POST_QUERY_UX,
                moreContext: {
                    abortReason: abortReason
                }
            }));
        });
    }, [
        isEnabled,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const isTaskActive = (0, $42omo.useCallback)(()=>{
        // Check if task has started but not yet completed
        return taskStateRef.current?.started && !taskStateRef.current?.completed;
    }, [
        taskStateRef
    ]);
    return {
        startTask: startTask,
        completeTaskSuccess: completeTaskSuccess,
        completeTaskFail: completeTaskFail,
        abortTask: abortTask,
        isTaskActive: isTaskActive
    };
};






var $lvsjl = parcelRequire("lvsjl");













const $c897146cb2304f97$var$transformSearchPageNode = (node)=>({
        subtype: 'confluenceEntity' in node ? node.confluenceEntity?.subtype : undefined,
        id: node.id,
        type: node.type,
        status: node.status,
        productKey: 'confluence'
    });
function $c897146cb2304f97$export$ec1be4f4e7673923(filteredRecentActivities) {
    return filteredRecentActivities.filter((activity)=>activity.data.node.object.product === 'confluence').map((confluenceActivity)=>{
        const activity = confluenceActivity.data.node;
        return {
            subtype: activity.object.data?.subtype,
            id: activity.object.id,
            type: activity.object.type,
            status: activity.object.data?.pageStatus,
            productKey: 'confluence'
        };
    });
}
function $c897146cb2304f97$export$ec6afea36ef7998a(fetchedResults) {
    return fetchedResults.filter((result)=>(0, $4TTdD.isSearchConfluencePartial)(result.data)).map((confluenceResult)=>confluenceResult.data).map($c897146cb2304f97$var$transformSearchPageNode);
}
function $c897146cb2304f97$export$7c14eac746a7b267(fetchedResults) {
    return fetchedResults.filter((result)=>(0, $4TTdD.isSearchConfluencePartial)(result.node)).map((result)=>result.node).map($c897146cb2304f97$var$transformSearchPageNode);
}


const $64cc6bbe82568b51$export$dfe8038ae9bc34d2 = ()=>{
    const logException = (0, $f8oYd.useLogException)();
    const { onSearchResultsShown: onSearchResultsShownCallback } = (0, $7WbA8.useAppContext)();
    const isPrequeryRecentActivitieHandled = (0, $42omo.useRef)(false);
    /*
   * This is called only for POSTQUERY_RESULTS state
   * */ const onSearchResultsShown = (0, $42omo.useCallback)(async (searchResults)=>{
        if (onSearchResultsShownCallback && searchResults.length > 0) try {
            const confluenceSearchResults = (0, $c897146cb2304f97$export$ec6afea36ef7998a)(searchResults);
            if (confluenceSearchResults.length > 0) onSearchResultsShownCallback(confluenceSearchResults);
        } catch (e) {
            logException(e);
        }
    }, [
        onSearchResultsShownCallback,
        logException
    ]);
    /*
   * This is debounced to avoid triggering the callback if the list changes too quickly
   *
   * The recent activities are only available in PREQUERY_RESULTS, POSTQUERY_LOADING and POSTQUERY_RESULTS states.
   * Since the "Recent Activities" list remains consistent in both POSTQUERY_LOADING and POSTQUERY_RESULTS states, we only report it during the POSTQUERY_LOADING state.
   * */ const [handleRecentActivitiesCallback] = (0, $lvsjl.default)(async (state, recentActivities)=>{
        try {
            if (onSearchResultsShownCallback && recentActivities.length > 0) {
                /*
         * The “Recent Activities” in PREQUERY_RESULTS state are reported just once, as they always show the same list after loading.
         * */ if (state === (0, $aE5mL.State).PREQUERY_RESULTS && !isPrequeryRecentActivitieHandled.current) {
                    isPrequeryRecentActivitieHandled.current = true;
                    const confluenceRecentActivities = (0, $c897146cb2304f97$export$ec1be4f4e7673923)(recentActivities);
                    if (confluenceRecentActivities.length > 0) onSearchResultsShownCallback(confluenceRecentActivities);
                }
                if (state === (0, $aE5mL.State).POSTQUERY_LOADING) {
                    const confluenceRecentActivities_0 = (0, $c897146cb2304f97$export$ec1be4f4e7673923)(recentActivities);
                    if (confluenceRecentActivities_0.length > 0) onSearchResultsShownCallback(confluenceRecentActivities_0);
                }
            }
        } catch (e_0) {
            logException(e_0);
        }
    }, 500);
    // returning async callbacks to avoid blocking other operations
    return {
        onSearchResultsShown: onSearchResultsShown,
        handleRecentActivitiesCallback: handleRecentActivitiesCallback
    };
};























const $b2e1078ac279219a$export$50f1b1860bee88e0 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, actionSubjectId: actionSubjectId })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $bb6e90fe17bdbf50$export$4d9e9e3a052b2865 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'contextMenu opened',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $a6985f2e364fb5e8$export$d17f8c02a91cd2a5 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'highlighted',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $dd727cd9033cfd92$export$1d3be7f4bb8882c3 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


















var $8wHiG = parcelRequire("8wHiG");



































const $531c3f35638ca54a$export$8edca358485a7f22 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(35);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const intl = (0, $aXWIB.useIntl)();
    const taskStateRef = (0, $e6c80dec8a0d452c$export$714277298f52f5c1)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    let t0;
    if ($[0] !== intl.locale || $[1] !== primaryProduct) {
        t0 = (0, $26jni.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false,
            locale: intl.locale
        });
        $[0] = intl.locale;
        $[1] = primaryProduct;
        $[2] = t0;
    } else t0 = $[2];
    const intentDetectionExperiment = t0;
    const isEnabled = intentDetectionExperiment?.cohort === "test";
    const cohort = intentDetectionExperiment?.cohort;
    let t1;
    if ($[3] !== cohort || $[4] !== commonAttributes.searchSessionId || $[5] !== fireAnalyticsEvent || $[6] !== isEnabled || $[7] !== taskStateRef) {
        t1 = (query)=>{
            if (!isEnabled) return;
            const taskId = crypto.randomUUID();
            const searchSessionId = commonAttributes.searchSessionId || "";
            const queryHash = (0, $731W9.sha256Hash)(query);
            const queryLength = query.length;
            const wordCount = (0, $inrbX.getWordCount)(query);
            if (taskStateRef.current) {
                taskStateRef.current.id = taskId;
                taskStateRef.current.state = "started";
                taskStateRef.current.queryHash = queryHash;
                taskStateRef.current.queryLength = queryLength;
                taskStateRef.current.wordCount = wordCount;
            }
            fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskStart)({
                searchSessionId: searchSessionId,
                taskId: taskId,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
                moreContext: {
                    queryHash: queryHash,
                    queryLength: queryLength,
                    wordCount: wordCount,
                    cohort: cohort
                }
            })));
        };
        $[3] = cohort;
        $[4] = commonAttributes.searchSessionId;
        $[5] = fireAnalyticsEvent;
        $[6] = isEnabled;
        $[7] = taskStateRef;
        $[8] = t1;
    } else t1 = $[8];
    const startTask = t1;
    let t2;
    if ($[9] !== cohort || $[10] !== commonAttributes.searchSessionId || $[11] !== fireAnalyticsEvent || $[12] !== isEnabled || $[13] !== taskStateRef) {
        t2 = ()=>{
            if (!isEnabled || taskStateRef.current?.state !== "started") return;
            const { id: taskId_0, queryHash: queryHash_0, queryLength: queryLength_0, wordCount: wordCount_0 } = taskStateRef.current;
            const searchSessionId_0 = commonAttributes.searchSessionId || "";
            if (!taskId_0) return;
            fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskSuccess)({
                searchSessionId: searchSessionId_0,
                taskId: taskId_0,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
                moreContext: {
                    queryHash: queryHash_0,
                    queryLength: queryLength_0,
                    wordCount: wordCount_0,
                    cohort: cohort
                }
            })));
            taskStateRef.current.state = "completed";
        };
        $[9] = cohort;
        $[10] = commonAttributes.searchSessionId;
        $[11] = fireAnalyticsEvent;
        $[12] = isEnabled;
        $[13] = taskStateRef;
        $[14] = t2;
    } else t2 = $[14];
    const completeTaskSuccess = t2;
    let t3;
    if ($[15] !== cohort || $[16] !== commonAttributes.searchSessionId || $[17] !== fireAnalyticsEvent || $[18] !== isEnabled || $[19] !== taskStateRef) {
        t3 = (error)=>{
            if (!isEnabled || taskStateRef.current?.state !== "started") return;
            const { id: taskId_1, queryHash: queryHash_1, queryLength: queryLength_1, wordCount: wordCount_1 } = taskStateRef.current;
            const searchSessionId_1 = commonAttributes.searchSessionId || "";
            if (!taskId_1) return;
            fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskFail)({
                searchSessionId: searchSessionId_1,
                taskId: taskId_1,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
                moreContext: {
                    queryHash: queryHash_1,
                    queryLength: queryLength_1,
                    wordCount: wordCount_1,
                    cohort: cohort,
                    errorName: error?.name || "UnknownError",
                    errorMessage: error?.message || "An unknown error occurred"
                }
            })));
            taskStateRef.current.state = "failed";
        };
        $[15] = cohort;
        $[16] = commonAttributes.searchSessionId;
        $[17] = fireAnalyticsEvent;
        $[18] = isEnabled;
        $[19] = taskStateRef;
        $[20] = t3;
    } else t3 = $[20];
    const completeTaskFail = t3;
    let t4;
    if ($[21] !== cohort || $[22] !== commonAttributes.searchSessionId || $[23] !== fireAnalyticsEvent || $[24] !== isEnabled || $[25] !== taskStateRef) {
        t4 = (abortReason)=>{
            if (!isEnabled || taskStateRef.current?.state !== "started") return;
            const { id: taskId_2, queryHash: queryHash_2, queryLength: queryLength_2, wordCount: wordCount_2 } = taskStateRef.current;
            const searchSessionId_2 = commonAttributes.searchSessionId || "";
            if (!taskId_2) return;
            taskStateRef.current.state = "aborted";
            (0, $42omo.startTransition)(()=>{
                fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskAbort)({
                    searchSessionId: searchSessionId_2,
                    taskId: taskId_2,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
                    moreContext: {
                        abortReason: abortReason,
                        queryHash: queryHash_2,
                        queryLength: queryLength_2,
                        wordCount: wordCount_2,
                        cohort: cohort
                    }
                })));
            });
        };
        $[21] = cohort;
        $[22] = commonAttributes.searchSessionId;
        $[23] = fireAnalyticsEvent;
        $[24] = isEnabled;
        $[25] = taskStateRef;
        $[26] = t4;
    } else t4 = $[26];
    const abortTask = t4;
    let t5;
    if ($[27] !== taskStateRef) {
        t5 = ()=>taskStateRef.current?.state === "started";
        $[27] = taskStateRef;
        $[28] = t5;
    } else t5 = $[28];
    const isTaskActive = t5;
    let t6;
    if ($[29] !== abortTask || $[30] !== completeTaskFail || $[31] !== completeTaskSuccess || $[32] !== isTaskActive || $[33] !== startTask) {
        t6 = {
            startTask: startTask,
            completeTaskSuccess: completeTaskSuccess,
            completeTaskFail: completeTaskFail,
            abortTask: abortTask,
            isTaskActive: isTaskActive
        };
        $[29] = abortTask;
        $[30] = completeTaskFail;
        $[31] = completeTaskSuccess;
        $[32] = isTaskActive;
        $[33] = startTask;
        $[34] = t6;
    } else t6 = $[34];
    return t6;
} : ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const intl = (0, $aXWIB.useIntl)();
    const taskStateRef = (0, $e6c80dec8a0d452c$export$714277298f52f5c1)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const intentDetectionExperiment = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: intl.locale
    });
    const isEnabled = intentDetectionExperiment?.cohort === 'test';
    const cohort = intentDetectionExperiment?.cohort;
    const startTask = (0, $42omo.useCallback)((query)=>{
        if (!isEnabled) return;
        const taskId = crypto.randomUUID();
        const searchSessionId = commonAttributes.searchSessionId || '';
        const queryHash = (0, $731W9.sha256Hash)(query);
        const queryLength = query.length;
        const wordCount = (0, $inrbX.getWordCount)(query);
        // Set the shared context state
        if (taskStateRef.current) {
            taskStateRef.current.id = taskId;
            taskStateRef.current.state = 'started';
            taskStateRef.current.queryHash = queryHash;
            taskStateRef.current.queryLength = queryLength;
            taskStateRef.current.wordCount = wordCount;
        }
        fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: taskId,
            task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
            moreContext: {
                queryHash: queryHash,
                queryLength: queryLength,
                wordCount: wordCount,
                cohort: cohort
            }
        })));
    }, [
        isEnabled,
        cohort,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const completeTaskSuccess = (0, $42omo.useCallback)(()=>{
        // Check if task is active using the shared context state
        if (!isEnabled || taskStateRef.current?.state !== 'started') return;
        const { id: taskId_0, queryHash: queryHash_0, queryLength: queryLength_0, wordCount: wordCount_0 } = taskStateRef.current;
        const searchSessionId_0 = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when state is 'started'
        if (!taskId_0) return;
        fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskSuccess)({
            searchSessionId: searchSessionId_0,
            taskId: taskId_0,
            task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
            moreContext: {
                queryHash: queryHash_0,
                queryLength: queryLength_0,
                wordCount: wordCount_0,
                cohort: cohort
            }
        })));
        // Mark task as completed
        taskStateRef.current.state = 'completed';
    }, [
        isEnabled,
        cohort,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const completeTaskFail = (0, $42omo.useCallback)((error)=>{
        // Check if task is active using the shared context state
        if (!isEnabled || taskStateRef.current?.state !== 'started') return;
        const { id: taskId_1, queryHash: queryHash_1, queryLength: queryLength_1, wordCount: wordCount_1 } = taskStateRef.current;
        const searchSessionId_1 = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when state is 'started'
        if (!taskId_1) return;
        fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskFail)({
            searchSessionId: searchSessionId_1,
            taskId: taskId_1,
            task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
            moreContext: {
                queryHash: queryHash_1,
                queryLength: queryLength_1,
                wordCount: wordCount_1,
                cohort: cohort,
                errorName: error?.name || 'UnknownError',
                errorMessage: error?.message || 'An unknown error occurred'
            }
        })));
        // Mark task as failed
        taskStateRef.current.state = 'failed';
    }, [
        isEnabled,
        cohort,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const abortTask = (0, $42omo.useCallback)((abortReason)=>{
        // Check if task is active using the shared context state
        if (!isEnabled || taskStateRef.current?.state !== 'started') return;
        const { id: taskId_2, queryHash: queryHash_2, queryLength: queryLength_2, wordCount: wordCount_2 } = taskStateRef.current;
        const searchSessionId_2 = commonAttributes.searchSessionId || '';
        // taskId is guaranteed to be non-null when state is 'started'
        if (!taskId_2) return;
        // Mark task as aborted FIRST (synchronously) to prevent race conditions
        taskStateRef.current.state = 'aborted';
        // Then defer the analytics event to not block rendering
        (0, $42omo.startTransition)(()=>{
            fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskAbort)({
                searchSessionId: searchSessionId_2,
                taskId: taskId_2,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_UX,
                moreContext: {
                    abortReason: abortReason,
                    queryHash: queryHash_2,
                    queryLength: queryLength_2,
                    wordCount: wordCount_2,
                    cohort: cohort
                }
            })));
        });
    }, [
        isEnabled,
        cohort,
        commonAttributes.searchSessionId,
        fireAnalyticsEvent,
        taskStateRef
    ]);
    const isTaskActive = (0, $42omo.useCallback)(()=>{
        return taskStateRef.current?.state === 'started';
    }, [
        taskStateRef
    ]);
    return {
        startTask: startTask,
        completeTaskSuccess: completeTaskSuccess,
        completeTaskFail: completeTaskFail,
        abortTask: abortTask,
        isTaskActive: isTaskActive
    };
};


const $6926da8980239f02$export$8a7aec9b1f72e063 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(12);
    const intl = (0, $aXWIB.useIntl)();
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { abortTask: abortIntentDetectionTask, isTaskActive: isIntentDetectionTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    let t0;
    if ($[0] !== abortIntentDetectionTask || $[1] !== commonAttributes || $[2] !== fireAnalyticsEvent || $[3] !== intl.locale || $[4] !== isIntentDetectionTaskActive || $[5] !== nonPrivacySafeAttributes || $[6] !== primaryProduct || $[7] !== quickFindQuery || $[8] !== setQuickFindOpen || $[9] !== updateRecentQueries || $[10] !== user) {
        t0 = (props)=>{
            const { event: event, data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes, isImpersonated: t1, options: options } = props;
            const isImpersonated = t1 === undefined ? false : t1;
            if (isIntentDetectionTaskActive()) abortIntentDetectionTask("result_selected");
            const { addCurrentQueryAsRecentQuery: t2 } = options || {};
            const addCurrentQueryAsRecentQuery = t2 === undefined ? true : t2;
            const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event, data);
            if (!newTab) setQuickFindOpen(false);
            if (addCurrentQueryAsRecentQuery) {
                const trimmedInuptQuery = quickFindQuery.trim();
                if (trimmedInuptQuery !== "" && user && user.id && primaryProduct) {
                    (0, $1SV4e.addRecentSearch)({
                        value: trimmedInuptQuery,
                        userId: user.id,
                        productId: primaryProduct,
                        key: (0, $1SV4e.RECENT_SEARCH_KEY)
                    });
                    updateRecentQueries?.();
                }
            }
            const actionSubjectId = (0, $idEgG.getActionSubjectId)(state);
            fireAnalyticsEvent((0, $dd727cd9033cfd92$export$1d3be7f4bb8882c3)({
                actionSubjectId: actionSubjectId,
                attributes: {
                    ...commonAttributes,
                    ...additionalAnalyticsAttributes,
                    ...data,
                    isImpersonated: isImpersonated,
                    intentDetectionTriggered: (0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale)
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        $[0] = abortIntentDetectionTask;
        $[1] = commonAttributes;
        $[2] = fireAnalyticsEvent;
        $[3] = intl.locale;
        $[4] = isIntentDetectionTaskActive;
        $[5] = nonPrivacySafeAttributes;
        $[6] = primaryProduct;
        $[7] = quickFindQuery;
        $[8] = setQuickFindOpen;
        $[9] = updateRecentQueries;
        $[10] = user;
        $[11] = t0;
    } else t0 = $[11];
    return t0;
} : ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { abortTask: abortIntentDetectionTask, isTaskActive: isIntentDetectionTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    return (0, $42omo.useCallback)((props)=>{
        const { event: event, data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes, isImpersonated: isImpersonated = false, options: options } = props;
        // VitalStats: Abort intent detection UX task if user clicks on a search result
        if (isIntentDetectionTaskActive()) abortIntentDetectionTask('result_selected');
        const { addCurrentQueryAsRecentQuery: addCurrentQueryAsRecentQuery = true } = options || {};
        const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event, data);
        if (!newTab) setQuickFindOpen(false);
        if (addCurrentQueryAsRecentQuery) {
            const trimmedInuptQuery = quickFindQuery.trim();
            if (trimmedInuptQuery !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)({
                    value: trimmedInuptQuery,
                    userId: user.id,
                    productId: primaryProduct,
                    key: (0, $1SV4e.RECENT_SEARCH_KEY)
                });
                updateRecentQueries?.();
            }
        }
        const actionSubjectId = (0, $idEgG.getActionSubjectId)(state);
        fireAnalyticsEvent((0, $dd727cd9033cfd92$export$1d3be7f4bb8882c3)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data,
                isImpersonated: isImpersonated,
                intentDetectionTriggered: (0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        quickFindQuery,
        nonPrivacySafeAttributes,
        primaryProduct,
        setQuickFindOpen,
        updateRecentQueries,
        user,
        isIntentDetectionTaskActive,
        abortIntentDetectionTask,
        intl.locale
    ]);
};
const $6926da8980239f02$export$bc76edbc675e4404 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    let t0;
    if ($[0] !== commonAttributes || $[1] !== fireAnalyticsEvent || $[2] !== intl.locale || $[3] !== nonPrivacySafeAttributes || $[4] !== primaryProduct) {
        t0 = (props)=>{
            const { data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes, isImpersonated: t1 } = props;
            const isImpersonated = t1 === undefined ? false : t1;
            const actionSubjectId = (0, $idEgG.getActionSubjectId)(state);
            fireAnalyticsEvent((0, $bb6e90fe17bdbf50$export$4d9e9e3a052b2865)({
                actionSubjectId: actionSubjectId,
                attributes: {
                    ...commonAttributes,
                    ...additionalAnalyticsAttributes,
                    ...data,
                    isImpersonated: isImpersonated,
                    intentDetectionTriggered: (0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale)
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        $[0] = commonAttributes;
        $[1] = fireAnalyticsEvent;
        $[2] = intl.locale;
        $[3] = nonPrivacySafeAttributes;
        $[4] = primaryProduct;
        $[5] = t0;
    } else t0 = $[5];
    return t0;
} : ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    return (0, $42omo.useCallback)((props)=>{
        const { data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes, isImpersonated: isImpersonated = false } = props;
        const actionSubjectId = (0, $idEgG.getActionSubjectId)(state);
        fireAnalyticsEvent((0, $bb6e90fe17bdbf50$export$4d9e9e3a052b2865)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data,
                isImpersonated: isImpersonated,
                intentDetectionTriggered: (0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        primaryProduct,
        intl.locale
    ]);
};
const $6926da8980239f02$export$3f21dcaf9a5530d9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    let t0;
    if ($[0] !== commonAttributes || $[1] !== fireAnalyticsEvent || $[2] !== intl.locale || $[3] !== nonPrivacySafeAttributes || $[4] !== primaryProduct) {
        t0 = (props)=>{
            const { data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes } = props;
            const actionSubjectId = (0, $idEgG.getActionSubjectId)(state);
            fireAnalyticsEvent((0, $a6985f2e364fb5e8$export$d17f8c02a91cd2a5)({
                actionSubjectId: actionSubjectId,
                attributes: {
                    ...commonAttributes,
                    ...additionalAnalyticsAttributes,
                    ...data,
                    intentDetectionTriggered: (0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale)
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        $[0] = commonAttributes;
        $[1] = fireAnalyticsEvent;
        $[2] = intl.locale;
        $[3] = nonPrivacySafeAttributes;
        $[4] = primaryProduct;
        $[5] = t0;
    } else t0 = $[5];
    return t0;
} : ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    return (0, $42omo.useCallback)((props)=>{
        const { data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes } = props;
        const actionSubjectId = (0, $idEgG.getActionSubjectId)(state);
        fireAnalyticsEvent((0, $a6985f2e364fb5e8$export$d17f8c02a91cd2a5)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data,
                intentDetectionTriggered: (0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        primaryProduct,
        intl.locale
    ]);
};
const $6926da8980239f02$export$eb0ecd911360e8d4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(15);
    const intl = (0, $aXWIB.useIntl)();
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { abortTask: abortIntentDetectionTask, isTaskActive: isIntentDetectionTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    let t0;
    if ($[0] !== intl.locale || $[1] !== primaryProduct) {
        t0 = (0, $26jni.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false,
            locale: intl.locale
        });
        $[0] = intl.locale;
        $[1] = primaryProduct;
        $[2] = t0;
    } else t0 = $[2];
    const intentDetectionExperiment = t0;
    const intentDetectionCohort = intentDetectionExperiment?.cohort;
    let t1;
    if ($[3] !== abortIntentDetectionTask || $[4] !== commonAttributes || $[5] !== fireAnalyticsEvent || $[6] !== intentDetectionCohort || $[7] !== isIntentDetectionTaskActive || $[8] !== nonPrivacySafeAttributes || $[9] !== primaryProduct || $[10] !== quickFindQuery || $[11] !== setQuickFindOpen || $[12] !== updateRecentQueries || $[13] !== user) {
        t1 = (props)=>{
            const { event: event, state: state, options: options, actionSubjectId: actionSubjectId } = props;
            if (isIntentDetectionTaskActive()) abortIntentDetectionTask("footer_link_selected");
            const { addCurrentQueryAsRecentQuery: t2 } = options || {};
            const addCurrentQueryAsRecentQuery = t2 === undefined ? true : t2;
            const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event);
            if (!newTab) setQuickFindOpen(false);
            if (addCurrentQueryAsRecentQuery) {
                const trimmedInputQuery = quickFindQuery.trim();
                if (trimmedInputQuery !== "" && user && user.id && primaryProduct) {
                    (0, $1SV4e.addRecentSearch)({
                        value: trimmedInputQuery,
                        userId: user.id,
                        productId: primaryProduct,
                        key: (0, $1SV4e.RECENT_SEARCH_KEY)
                    });
                    updateRecentQueries?.();
                }
            }
            if (!primaryProduct) return;
            fireAnalyticsEvent((0, $b2e1078ac279219a$export$50f1b1860bee88e0)({
                actionSubjectId: actionSubjectId,
                attributes: {
                    ...commonAttributes,
                    trigger: "click",
                    newTab: newTab,
                    isLoading: state === (0, $aE5mL.State).PREQUERY_LOADING || state === (0, $aE5mL.State).POSTQUERY_LOADING,
                    queryClassification: (0, $4tgkZ.INTENT_DETECTION).value()?.mode,
                    modelId: (0, $4tgkZ.INTENT_DETECTION).value()?.modelId,
                    wordCount: (0, $inrbX.getWordCount)(quickFindQuery),
                    cohort: intentDetectionCohort,
                    patternType: (0, $4tgkZ.INTENT_DETECTION).value()?.patternType
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        $[3] = abortIntentDetectionTask;
        $[4] = commonAttributes;
        $[5] = fireAnalyticsEvent;
        $[6] = intentDetectionCohort;
        $[7] = isIntentDetectionTaskActive;
        $[8] = nonPrivacySafeAttributes;
        $[9] = primaryProduct;
        $[10] = quickFindQuery;
        $[11] = setQuickFindOpen;
        $[12] = updateRecentQueries;
        $[13] = user;
        $[14] = t1;
    } else t1 = $[14];
    return t1;
} : ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { abortTask: abortIntentDetectionTask, isTaskActive: isIntentDetectionTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    const intentDetectionExperiment = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: intl.locale
    });
    const intentDetectionCohort = intentDetectionExperiment?.cohort;
    return (0, $42omo.useCallback)((props)=>{
        const { event: event, state: state, options: options, actionSubjectId: actionSubjectId } = props;
        // VitalStats: Abort intent detection UX task if user clicks footer link
        if (isIntentDetectionTaskActive()) abortIntentDetectionTask('footer_link_selected');
        const { addCurrentQueryAsRecentQuery: addCurrentQueryAsRecentQuery = true } = options || {};
        const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event);
        if (!newTab) setQuickFindOpen(false);
        if (addCurrentQueryAsRecentQuery) {
            const trimmedInputQuery = quickFindQuery.trim();
            if (trimmedInputQuery !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)({
                    value: trimmedInputQuery,
                    userId: user.id,
                    productId: primaryProduct,
                    key: (0, $1SV4e.RECENT_SEARCH_KEY)
                });
                updateRecentQueries?.();
            }
        }
        if (!primaryProduct) return;
        fireAnalyticsEvent((0, $b2e1078ac279219a$export$50f1b1860bee88e0)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                trigger: 'click',
                newTab: newTab,
                isLoading: state === (0, $aE5mL.State).PREQUERY_LOADING || state === (0, $aE5mL.State).POSTQUERY_LOADING,
                queryClassification: (0, $4tgkZ.INTENT_DETECTION).value()?.mode,
                modelId: (0, $4tgkZ.INTENT_DETECTION).value()?.modelId,
                wordCount: (0, $inrbX.getWordCount)(quickFindQuery),
                cohort: intentDetectionCohort,
                patternType: (0, $4tgkZ.INTENT_DETECTION).value()?.patternType
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        quickFindQuery,
        nonPrivacySafeAttributes,
        primaryProduct,
        setQuickFindOpen,
        updateRecentQueries,
        user,
        isIntentDetectionTaskActive,
        abortIntentDetectionTask,
        intentDetectionCohort
    ]);
};
























var $jluld = parcelRequire("jluld");




var $u9agA = parcelRequire("u9agA");












const $4f21e88d3d74c805$export$c6fcf5d81f2dd890 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'autocompleteSuggestion',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });




















const $c2c85768bd794f41$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    autocompleteSuggestion: {
        id: "search_dialog_autocomplete_suggestion",
        defaultMessage: "Suggestion"
    }
});


const $d88ba3c49726615e$export$f919aeefffeb339a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { result: result, state: state } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const queryText = (0, $4VmlX.useQuickFindQuery)();
    let t1;
    if ($[0] !== commonAttributes || $[1] !== fireAnalyticsEvent || $[2] !== nonPrivacySafeAttributes || $[3] !== primaryProduct || $[4] !== queryText.length || $[5] !== result || $[6] !== setQuickFindOpen || $[7] !== state || $[8] !== updateRecentQueries || $[9] !== user) {
        t1 = (event, data)=>{
            const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event, data);
            if (!newTab) setQuickFindOpen(false);
            if (result && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)({
                    value: result,
                    userId: user.id,
                    productId: primaryProduct,
                    key: (0, $1SV4e.RECENT_SEARCH_KEY)
                });
                updateRecentQueries?.();
            }
            fireAnalyticsEvent((0, $4f21e88d3d74c805$export$c6fcf5d81f2dd890)({
                actionSubjectId: (0, $idEgG.getActionSubjectId)(state),
                attributes: {
                    ...commonAttributes,
                    queryLength: queryText.length
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        $[0] = commonAttributes;
        $[1] = fireAnalyticsEvent;
        $[2] = nonPrivacySafeAttributes;
        $[3] = primaryProduct;
        $[4] = queryText.length;
        $[5] = result;
        $[6] = setQuickFindOpen;
        $[7] = state;
        $[8] = updateRecentQueries;
        $[9] = user;
        $[10] = t1;
    } else t1 = $[10];
    const onResultClicked = t1;
    let t2;
    if ($[11] !== generateSearchUrl || $[12] !== intl || $[13] !== queryParams || $[14] !== searchSessionId) {
        t2 = (query)=>{
            const id = query;
            const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
                label: "",
                size: "small"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                label: intl.formatMessage((0, $c2c85768bd794f41$export$defe85febe8b728c).autocompleteSuggestion),
                color: "currentColor"
            }));
            const title = query;
            const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $c2c85768bd794f41$export$defe85febe8b728c).autocompleteSuggestion));
            const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $c2c85768bd794f41$export$defe85febe8b728c).autocompleteSuggestion)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
            const url = generateSearchUrl({
                ...queryParams,
                text: query,
                search_id: searchSessionId
            });
            return {
                id: id,
                icon: icon,
                title: title,
                url: url,
                rightMetadata: rightMetadata,
                highlightedRightMetadata: highlightedRightMetadata
            };
        };
        $[11] = generateSearchUrl;
        $[12] = intl;
        $[13] = queryParams;
        $[14] = searchSessionId;
        $[15] = t2;
    } else t2 = $[15];
    const mapAutocompleteSuggestionToSearchResult = t2;
    let t3;
    if ($[16] !== mapAutocompleteSuggestionToSearchResult || $[17] !== result) {
        t3 = mapAutocompleteSuggestionToSearchResult(result);
        $[16] = mapAutocompleteSuggestionToSearchResult;
        $[17] = result;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== onResultClicked || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            resultType: "autocompleteSuggestions",
            ...t3,
            onResultClicked: onResultClicked
        });
        $[19] = onResultClicked;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
} : ({ result: result, state: state })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const queryText = (0, $4VmlX.useQuickFindQuery)();
    const onResultClicked = (0, $42omo.useCallback)((event, data)=>{
        const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event, data);
        if (!newTab) setQuickFindOpen(false);
        if (result && user && user.id && primaryProduct) {
            (0, $1SV4e.addRecentSearch)({
                value: result,
                userId: user.id,
                productId: primaryProduct,
                key: (0, $1SV4e.RECENT_SEARCH_KEY)
            });
            updateRecentQueries?.();
        }
        fireAnalyticsEvent((0, $4f21e88d3d74c805$export$c6fcf5d81f2dd890)({
            actionSubjectId: (0, $idEgG.getActionSubjectId)(state),
            attributes: {
                // NOTE: DO NOT LOG THE QUERY TEXT HERE. The query text is UGC and will immediately be a HOT.
                ...commonAttributes,
                queryLength: queryText.length
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        primaryProduct,
        queryText.length,
        result,
        setQuickFindOpen,
        state,
        updateRecentQueries,
        user
    ]);
    const mapAutocompleteSuggestionToSearchResult = (0, $42omo.useCallback)((query)=>{
        const id = query;
        const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: intl.formatMessage((0, $c2c85768bd794f41$export$defe85febe8b728c).autocompleteSuggestion),
            color: "currentColor"
        }));
        const title = query;
        const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $c2c85768bd794f41$export$defe85febe8b728c).autocompleteSuggestion));
        const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $c2c85768bd794f41$export$defe85febe8b728c).autocompleteSuggestion)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
        const url = generateSearchUrl({
            ...queryParams,
            text: query,
            search_id: searchSessionId
        });
        return {
            id: id,
            icon: icon,
            title: title,
            url: url,
            rightMetadata: rightMetadata,
            highlightedRightMetadata: highlightedRightMetadata
        };
    }, [
        intl,
        generateSearchUrl,
        queryParams,
        searchSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
        resultType: "autocompleteSuggestions",
        ...mapAutocompleteSuggestionToSearchResult(result),
        onResultClicked: onResultClicked
    });
};















var $2Nwuj = parcelRequire("2Nwuj");




var $5dK2X = parcelRequire("5dK2X");




var $aoVih = parcelRequire("aoVih");







const $be39043139f18c46$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    assetsUnavailableMessage: {
        id: "search_dialog_assets_unavailable_message",
        defaultMessage: "<bold>Assets</bold> will be available here soon. For now, try <searchLink>Assets search</searchLink>."
    }
});


const $0028c77a13fa2c26$export$d2e895abf2051d81 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    let t0;
    if ($[0] !== setQuickFindOpen) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $0028c77a13fa2c26$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $be39043139f18c46$export$defe85febe8b728c).assetsUnavailableMessage,
            values: {
                bold: $0028c77a13fa2c26$var$_temp,
                searchLink: (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        href: "/jira/assets?showSearch=true",
                        onClick: ()=>setQuickFindOpen(false)
                    }, chunks_0)
            }
        })));
        $[0] = setQuickFindOpen;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $0028c77a13fa2c26$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $be39043139f18c46$export$defe85febe8b728c).assetsUnavailableMessage,
        values: {
            bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                    weight: 'bold'
                }, chunks),
            searchLink: (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: '/jira/assets?showSearch=true',
                    onClick: ()=>setQuickFindOpen(false)
                }, chunks_0)
        }
    })));
};
const $0028c77a13fa2c26$var$containerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
function $0028c77a13fa2c26$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "bold"
    }, chunks);
}

















var $iXCQx = parcelRequire("iXCQx");







const $46b07f4c4b23d061$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    assetsDisplayNameSearchWarning: {
        id: "search_dialog_assets_display_name_search_warning",
        defaultMessage: "<b>Search by display name is coming soon.</b> Try searching by name."
    }
});


const $fd656b8a135ccf83$var$styles = {
    container: "_85i512x7 _bozgu2gc _y4tiu2gc"
};
const $fd656b8a135ccf83$export$42247bfb32635492 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $fd656b8a135ccf83$var$styles.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            appearance: "information"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $46b07f4c4b23d061$export$defe85febe8b728c).assetsDisplayNameSearchWarning,
            values: {
                b: $fd656b8a135ccf83$var$_temp
            }
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $fd656b8a135ccf83$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "information"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $46b07f4c4b23d061$export$defe85febe8b728c).assetsDisplayNameSearchWarning,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    weight: "bold"
                }, chunks)
        }
    })));
};
function $fd656b8a135ccf83$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "bold"
    }, chunks);
}


















var $ckkm9 = parcelRequire("ckkm9");










const $00ceb101b94d7e4d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    tipBanner: {
        id: "search-page.quick-find.dialog.banners.github-tip.tipBanner",
        defaultMessage: "<b>Tip:</b> <connectLink>Connect GitHub</connectLink> to find and action on PRs, issues, and repos in your search results."
    },
    dismissBannerLabel: {
        id: "search-page.quick-find.dialog.banners.github-tip.dismissBannerLabel",
        defaultMessage: "Dismiss GitHub tip"
    },
    oauthSuccessFlagTitle: {
        id: "search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagTitle",
        defaultMessage: "GitHub connected"
    },
    oauthSuccessFlagDescription: {
        id: "search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagDescription",
        defaultMessage: "You can now find and action on PRs, commits, and repos in Rovo Search and Chat."
    },
    oauthFailFlagTitle: {
        id: "search-page.quick-find.dialog.banners.github-tip.oauthFailFlagTitle",
        defaultMessage: "Could not connect to GitHub"
    }
});









var $gMc0m = parcelRequire("gMc0m");








var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");















const $d465d6c672befb46$export$f1d7e8d930f0538e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
            fill: "#292A2E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
        fill: "white"
    }));
};



var $i2RLU = parcelRequire("i2RLU");











var $lsW5D = parcelRequire("lsW5D");




const $b7271589ed596a6f$export$2d2b3022ef6e3887 = 'jira-gnin-intent';
const $b7271589ed596a6f$export$4160a73c1c50e6b = (query, primaryProduct)=>{
    if (primaryProduct !== 'jira') return null;
    const trimmed = query.trim();
    if (!trimmed) return null;
    const isWorkItemKey = Boolean((0, $lsW5D.normalizeWorkItemKey)(trimmed));
    if (isWorkItemKey || (0, $4tgkZ.isJqlQueryDetected)(trimmed)) return $b7271589ed596a6f$export$2d2b3022ef6e3887;
    return null;
};


/**
 * Keywords that trigger the GitHub tip banner in Quick Find.
 *
 * Sourced from the experiment spec:
 * https://hello.atlassian.net/wiki/spaces/CentAI/pages/6820699210/Driving+User+connections+of+GitHub+in+Rovo
 *
 * Matching is whole-word case-insensitive, so the order in this list is
 * documentation-only and does not affect which queries match.
 */ const $c0467ffdb3d4fc50$export$343ae5ad2158fe6c = [
    // add words between git -> gihub into the list,
    // so it won't flash on and off as the user types
    'git',
    'gith',
    'githu',
    'github',
    'repo',
    'repository',
    'pr',
    'prs',
    'pull request',
    'pull requests',
    'merge request',
    'commit',
    'branch',
    'merge',
    'fork',
    'hotfix',
    // add words between deploy -> deployment into the list,
    // so it won't flash on and off as the user types
    'deploy',
    'deploym',
    'deployme',
    'deploymen',
    'deployment',
    'release',
    'code review',
    'pipeline',
    'ci',
    'cd',
    'revert'
];
/**
 * Pre-compiled word-boundary regex for each keyword, built once at module
 * load.
 */ const $c0467ffdb3d4fc50$var$KEYWORD_REGEX_MAP = new Map($c0467ffdb3d4fc50$export$343ae5ad2158fe6c.map((keyword)=>{
    const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return [
        keyword,
        new RegExp(`\\b${escaped}\\b`, 'i')
    ];
}));
const $c0467ffdb3d4fc50$export$507dbb7cd0a0951e = (query)=>{
    const normalised = query.trim().toLowerCase();
    if (!normalised) return null;
    for (const keyword of $c0467ffdb3d4fc50$export$343ae5ad2158fe6c){
        const re = $c0467ffdb3d4fc50$var$KEYWORD_REGEX_MAP.get(keyword);
        if (re && re.test(normalised)) return keyword;
    }
    return null;
};




var $5G9KX = parcelRequire("5G9KX");

const $1e4fca936d1f882c$export$ad2bccf232d0a916 = 'atlassian.unified-search.github-tip-dismiss';
const $1e4fca936d1f882c$export$4bac6b574c2c1d97 = 'anonymous-user';
const $1e4fca936d1f882c$export$2754164d61c63e3a = 86400000; // 1 day
const $1e4fca936d1f882c$var$readStore = ()=>{
    const raw = (0, $5G9KX.getLocalStorageItemAsString)($1e4fca936d1f882c$export$ad2bccf232d0a916);
    if (!raw) return {};
    try {
        const parsed = JSON.parse(raw);
        if (typeof parsed !== 'object' || parsed === null) return {};
        // Defensive: filter out any legacy-schema (flat keyword → number) entries
        // so they don't crash the typed reads below. Anything that doesn't look
        // like a UserDismissState is treated as missing.
        const out = {};
        for (const [userKey, value] of Object.entries(parsed)){
            if (typeof value !== 'object' || value === null) continue;
            const v = value;
            const next = {};
            if (Array.isArray(v.permanent) && v.permanent.every((k)=>typeof k === 'string')) next.permanent = v.permanent;
            if (typeof v.lastDismissedAt === 'number') next.lastDismissedAt = v.lastDismissedAt;
            if (next.permanent || typeof next.lastDismissedAt === 'number') out[userKey] = next;
        }
        return out;
    } catch  {
        return {};
    }
};
const $1e4fca936d1f882c$var$writeStore = (store, logException)=>{
    try {
        (0, $5G9KX.setLocalStorageItem)($1e4fca936d1f882c$export$ad2bccf232d0a916, JSON.stringify(store));
    } catch (error) {
        logException?.(error);
    }
};
const $1e4fca936d1f882c$export$4283cfb1d908f19b = (keyword, userId, now = Date.now())=>{
    const userKey = userId || $1e4fca936d1f882c$export$4bac6b574c2c1d97;
    const state = $1e4fca936d1f882c$var$readStore()[userKey];
    if (!state) return true;
    const normalized = keyword.toLowerCase();
    // Tier 1: permanent suppression for this exact keyword.
    if (state.permanent?.includes(normalized)) return false;
    // Tier 2: any other keyword is suppressed for 24h after the most-recent
    // dismissal across any keyword.
    if (typeof state.lastDismissedAt === 'number' && now - state.lastDismissedAt < $1e4fca936d1f882c$export$2754164d61c63e3a) return false;
    return true;
};
const $1e4fca936d1f882c$export$51db437c03f27d42 = (keyword, userId, logException, now = Date.now())=>{
    const userKey = userId || $1e4fca936d1f882c$export$4bac6b574c2c1d97;
    const store = $1e4fca936d1f882c$var$readStore();
    const next = {
        ...store[userKey] ?? {}
    };
    const normalized = keyword.toLowerCase();
    const permanent = new Set(next.permanent ?? []);
    permanent.add(normalized);
    next.permanent = Array.from(permanent);
    next.lastDismissedAt = now;
    store[userKey] = next;
    $1e4fca936d1f882c$var$writeStore(store, logException);
};


const $e335aa88f8ad6538$var$styles = {
    outer: "_ahbqu2gc _12l2u2gc _1pfhu2gc _6rthu2gc",
    outerNegativeTop: "_ahbqu2gc _12l2u2gc _1pfhx0bf _6rthu2gc",
    banner: "_2rko1mok _1e0c1txw _1bsb1osq _4cvr1h6o _vchhusvi _ca0q12x7 _n3td12x7 _19bvu2gc _u5f3u2gc _syazi7uo",
    iconWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb1tcg _4t3i1tcg",
    text: "_16jlkb7n _1o9zkb7n _i0dl1wug _18u0utpp _2hwxutpp",
    divider: "_1h6d1l7x _4t3iidpf _1bsb1osq _uwhke4h9 _15a5nqa1"
};
const $e335aa88f8ad6538$var$linkOverrideStyles = null;
const $e335aa88f8ad6538$export$ddd68fffd38962b = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(39);
    const { query: query, onConnect: onConnect, disableGninTrigger: t1, withTrailingDivider: t2, useNegativeMarginTop: t3 } = t0;
    const disableGninTrigger = t1 === undefined ? false : t1;
    const withTrailingDivider = t2 === undefined ? false : t2;
    const useNegativeMarginTop = t3 === undefined ? false : t3;
    const [user] = (0, $j4ply.useUser)();
    const userId = user?.id ?? undefined;
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const logException = (0, $f8oYd.useLogException)();
    let t4;
    if ($[0] !== query) {
        t4 = (0, $c0467ffdb3d4fc50$export$507dbb7cd0a0951e)(query);
        $[0] = query;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== disableGninTrigger || $[3] !== primaryProduct || $[4] !== query) {
        t5 = disableGninTrigger ? null : (0, $b7271589ed596a6f$export$4160a73c1c50e6b)(query, primaryProduct);
        $[2] = disableGninTrigger;
        $[3] = primaryProduct;
        $[4] = query;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t4 || $[7] !== t5) {
        t6 = {
            githubHit: t4,
            gninHit: t5
        };
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    const { githubHit: githubHit, gninHit: gninHit } = t6;
    const matchedKeyword = githubHit ?? gninHit;
    const [sessionDismissedKeyword, setSessionDismissedKeyword] = (0, $42omo.useState)(null);
    const [isAllowedByStorage, setIsAllowedByStorage] = (0, $42omo.useState)(false);
    let t7;
    let t8;
    if ($[9] !== matchedKeyword || $[10] !== userId) {
        t7 = ()=>{
            if (matchedKeyword === null) {
                setIsAllowedByStorage(false);
                return;
            }
            setIsAllowedByStorage((0, $1e4fca936d1f882c$export$4283cfb1d908f19b)(matchedKeyword, userId));
        };
        t8 = [
            matchedKeyword,
            userId
        ];
        $[9] = matchedKeyword;
        $[10] = userId;
        $[11] = t7;
        $[12] = t8;
    } else {
        t7 = $[11];
        t8 = $[12];
    }
    (0, $42omo.useEffect)(t7, t8);
    const isVisible = matchedKeyword !== null && sessionDismissedKeyword !== matchedKeyword && isAllowedByStorage;
    let t9;
    if ($[13] !== onConnect) {
        t9 = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            onConnect?.();
        };
        $[13] = onConnect;
        $[14] = t9;
    } else t9 = $[14];
    const handleConnect = t9;
    let t10;
    if ($[15] !== fireAnalyticsEvent || $[16] !== githubHit || $[17] !== gninHit || $[18] !== logException || $[19] !== matchedKeyword || $[20] !== userId) {
        t10 = (event_0)=>{
            event_0.preventDefault();
            event_0.stopPropagation();
            if (matchedKeyword) {
                (0, $1e4fca936d1f882c$export$51db437c03f27d42)(matchedKeyword, userId, logException);
                if (githubHit && gninHit) (0, $1e4fca936d1f882c$export$51db437c03f27d42)(gninHit, userId, logException);
                setSessionDismissedKeyword(matchedKeyword);
            }
            fireAnalyticsEvent((0, $i2RLU.onBannerDismissed)({
                isOnSearchDialog: true,
                componentName: "GithubTipBanner"
            }));
        };
        $[15] = fireAnalyticsEvent;
        $[16] = githubHit;
        $[17] = gninHit;
        $[18] = logException;
        $[19] = matchedKeyword;
        $[20] = userId;
        $[21] = t10;
    } else t10 = $[21];
    const handleDismiss = t10;
    if (!isVisible) return null;
    const t11 = useNegativeMarginTop ? $e335aa88f8ad6538$var$styles.outerNegativeTop : $e335aa88f8ad6538$var$styles.outer;
    let t12;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e335aa88f8ad6538$var$styles.iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d465d6c672befb46$export$f1d7e8d930f0538e), null));
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== handleConnect) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e335aa88f8ad6538$var$styles.text
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $00ceb101b94d7e4d$export$defe85febe8b728c).tipBanner,
            values: {
                b: $e335aa88f8ad6538$var$_temp,
                connectLink: (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                        type: "button",
                        onClick: handleConnect,
                        "data-testid": "github-tip-banner-connect-link",
                        className: (0, $gMc0m.default)([
                            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _11q7glyw _11c81kw7 _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko12b0 _r06hglyw _80omtlke _syaz13af _1a3b1r31 _4fprglyw _5goinqa1 _f8pj13af _1ygbdfik _1ah3v77o _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz"
                        ])
                    }, chunks_0)
            }
        })));
        $[23] = handleConnect;
        $[24] = t13;
    } else t13 = $[24];
    let t14;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $00ceb101b94d7e4d$export$defe85febe8b728c).dismissBannerLabel);
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== handleDismiss) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            spacing: "compact",
            onClick: handleDismiss,
            label: t14,
            appearance: "subtle",
            testId: "github-tip-banner-dismiss"
        });
        $[26] = handleDismiss;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== t13 || $[29] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e335aa88f8ad6538$var$styles.banner,
            testId: "github-tip-banner"
        }, t12, t13, t15);
        $[28] = t13;
        $[29] = t15;
        $[30] = t16;
    } else t16 = $[30];
    let t17;
    if ($[31] !== t11 || $[32] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t11
        }, t16);
        $[31] = t11;
        $[32] = t16;
        $[33] = t17;
    } else t17 = $[33];
    let t18;
    if ($[34] !== withTrailingDivider) {
        t18 = withTrailingDivider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e335aa88f8ad6538$var$styles.divider
        });
        $[34] = withTrailingDivider;
        $[35] = t18;
    } else t18 = $[35];
    let t19;
    if ($[36] !== t17 || $[37] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t17, t18);
        $[36] = t17;
        $[37] = t18;
        $[38] = t19;
    } else t19 = $[38];
    return t19;
} : ({ query: query, onConnect: onConnect, disableGninTrigger: disableGninTrigger = false, withTrailingDivider: withTrailingDivider = false, useNegativeMarginTop: useNegativeMarginTop = false })=>{
    const [user] = (0, $j4ply.useUser)();
    const userId = user?.id ?? undefined;
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const logException = (0, $f8oYd.useLogException)(); // Triggers (in precedence order): literal GitHub keyword, then Jira
    // GNIN intent (typed JQL / work-item key). Both paths feed the same
    // `matchedKeyword` into storage.
    const { githubHit: githubHit, gninHit: gninHit } = (0, $42omo.useMemo)(()=>({
            githubHit: (0, $c0467ffdb3d4fc50$export$507dbb7cd0a0951e)(query),
            gninHit: disableGninTrigger ? null : (0, $b7271589ed596a6f$export$4160a73c1c50e6b)(query, primaryProduct)
        }), [
        query,
        primaryProduct,
        disableGninTrigger
    ]);
    const matchedKeyword = githubHit ?? gninHit;
    const [sessionDismissedKeyword, setSessionDismissedKeyword] = (0, $42omo.useState)(null);
    const [isAllowedByStorage, setIsAllowedByStorage] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (matchedKeyword === null) {
            setIsAllowedByStorage(false);
            return;
        }
        setIsAllowedByStorage((0, $1e4fca936d1f882c$export$4283cfb1d908f19b)(matchedKeyword, userId));
    }, [
        matchedKeyword,
        userId
    ]);
    const isVisible = matchedKeyword !== null && sessionDismissedKeyword !== matchedKeyword && isAllowedByStorage;
    const handleConnect = (0, $42omo.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        onConnect?.();
    }, [
        onConnect
    ]);
    const handleDismiss = (0, $42omo.useCallback)((event_0)=>{
        event_0.preventDefault();
        event_0.stopPropagation();
        if (matchedKeyword) {
            (0, $1e4fca936d1f882c$export$51db437c03f27d42)(matchedKeyword, userId, logException); // When a query matches both triggers, suppress both so the
            // banner stays dismissed regardless of which path activates next.
            if (githubHit && gninHit) (0, $1e4fca936d1f882c$export$51db437c03f27d42)(gninHit, userId, logException);
            setSessionDismissedKeyword(matchedKeyword);
        }
        fireAnalyticsEvent((0, $i2RLU.onBannerDismissed)({
            isOnSearchDialog: true,
            componentName: 'GithubTipBanner'
        }));
    }, [
        matchedKeyword,
        userId,
        fireAnalyticsEvent,
        logException,
        githubHit,
        gninHit
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: useNegativeMarginTop ? $e335aa88f8ad6538$var$styles.outerNegativeTop : $e335aa88f8ad6538$var$styles.outer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e335aa88f8ad6538$var$styles.banner,
        testId: "github-tip-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e335aa88f8ad6538$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d465d6c672befb46$export$f1d7e8d930f0538e), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e335aa88f8ad6538$var$styles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $00ceb101b94d7e4d$export$defe85febe8b728c).tipBanner,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    weight: "bold"
                }, chunks),
            connectLink: (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                    type: "button",
                    onClick: handleConnect,
                    "data-testid": "github-tip-banner-connect-link",
                    className: (0, $gMc0m.default)([
                        "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _11q7glyw _11c81kw7 _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko12b0 _r06hglyw _80omtlke _syaz13af _1a3b1r31 _4fprglyw _5goinqa1 _f8pj13af _1ygbdfik _1ah3v77o _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz"
                    ])
                }, chunks_0)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        spacing: "compact",
        onClick: handleDismiss,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $00ceb101b94d7e4d$export$defe85febe8b728c).dismissBannerLabel),
        appearance: "subtle",
        testId: "github-tip-banner-dismiss"
    }))), withTrailingDivider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e335aa88f8ad6538$var$styles.divider
    }));
};
function $e335aa88f8ad6538$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "bold"
    }, chunks);
}


const $eb13c81035a309c0$export$a23697b7e0c0413b = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { query: query, disableGninTrigger: t1, withTrailingDivider: t2, useNegativeMarginTop: t3 } = t0;
    const disableGninTrigger = t1 === undefined ? false : t1;
    const withTrailingDivider = t2 === undefined ? false : t2;
    const useNegativeMarginTop = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { userNeedsOAuth: userNeedsOAuth, outboundAuthUrl: outboundAuthUrl } = (0, $gGFxq.useIsUserOAuthed)((0, $1yEFx.ProductKeys).Github);
    let t4;
    if ($[0] !== formatMessage) {
        t4 = formatMessage((0, $00ceb101b94d7e4d$export$defe85febe8b728c).oauthSuccessFlagTitle);
        $[0] = formatMessage;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== formatMessage) {
        t5 = formatMessage((0, $00ceb101b94d7e4d$export$defe85febe8b728c).oauthSuccessFlagDescription);
        $[2] = formatMessage;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== formatMessage) {
        t6 = formatMessage((0, $00ceb101b94d7e4d$export$defe85febe8b728c).oauthFailFlagTitle);
        $[4] = formatMessage;
        $[5] = t6;
    } else t6 = $[5];
    const t7 = outboundAuthUrl || "";
    let t8;
    if ($[6] !== query || $[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
        t8 = {
            product: (0, $1yEFx.ProductKeys).Github,
            successFlagTitle: t4,
            successFlagDescription: t5,
            showUnderstoodButton: true,
            failFlagTitle: t6,
            outboundAuthUrl: t7,
            isOnSearchDialog: true,
            query: query
        };
        $[6] = query;
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    const { onAuthorize: onAuthorize } = (0, $gGFxq.useOAuthHandlers)(t8);
    let t9;
    if ($[12] !== onAuthorize) {
        t9 = ()=>{
            onAuthorize((0, $ckkm9.OAuthSource).quickFindGithubTipBanner);
        };
        $[12] = onAuthorize;
        $[13] = t9;
    } else t9 = $[13];
    const handleConnect = t9;
    if (!userNeedsOAuth || !outboundAuthUrl) return null;
    let t10;
    if ($[14] !== disableGninTrigger || $[15] !== handleConnect || $[16] !== query || $[17] !== useNegativeMarginTop || $[18] !== withTrailingDivider) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1nJM3.ErrorBoundary), {
            section: "QuickFindGithubTipBanner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e335aa88f8ad6538$export$ddd68fffd38962b), {
            query: query,
            onConnect: handleConnect,
            disableGninTrigger: disableGninTrigger,
            withTrailingDivider: withTrailingDivider,
            useNegativeMarginTop: useNegativeMarginTop
        }));
        $[14] = disableGninTrigger;
        $[15] = handleConnect;
        $[16] = query;
        $[17] = useNegativeMarginTop;
        $[18] = withTrailingDivider;
        $[19] = t10;
    } else t10 = $[19];
    return t10;
} : ({ query: query, disableGninTrigger: disableGninTrigger = false, withTrailingDivider: withTrailingDivider = false, useNegativeMarginTop: useNegativeMarginTop = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { userNeedsOAuth: userNeedsOAuth, outboundAuthUrl: outboundAuthUrl } = (0, $gGFxq.useIsUserOAuthed)((0, $1yEFx.ProductKeys).Github);
    const { onAuthorize: onAuthorize } = (0, $gGFxq.useOAuthHandlers)({
        product: (0, $1yEFx.ProductKeys).Github,
        successFlagTitle: formatMessage((0, $00ceb101b94d7e4d$export$defe85febe8b728c).oauthSuccessFlagTitle),
        successFlagDescription: formatMessage((0, $00ceb101b94d7e4d$export$defe85febe8b728c).oauthSuccessFlagDescription),
        showUnderstoodButton: true,
        failFlagTitle: formatMessage((0, $00ceb101b94d7e4d$export$defe85febe8b728c).oauthFailFlagTitle),
        outboundAuthUrl: outboundAuthUrl || '',
        isOnSearchDialog: true,
        query: query
    });
    const handleConnect = (0, $42omo.useCallback)(()=>{
        onAuthorize((0, $ckkm9.OAuthSource).quickFindGithubTipBanner);
    }, [
        onAuthorize
    ]);
    if (!userNeedsOAuth || !outboundAuthUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1nJM3.ErrorBoundary), {
        section: "QuickFindGithubTipBanner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e335aa88f8ad6538$export$ddd68fffd38962b), {
        query: query,
        onConnect: handleConnect,
        disableGninTrigger: disableGninTrigger,
        withTrailingDivider: withTrailingDivider,
        useNegativeMarginTop: useNegativeMarginTop
    }));
};





















var $3HOqx = parcelRequire("3HOqx");









const $801ec4174110d9b1$export$568e0ce3cc5a9972 = 'atlassian.unified-search.quick-find-rovo-tip';
const $801ec4174110d9b1$export$4bac6b574c2c1d97 = 'anonymous-user';
const $801ec4174110d9b1$export$b9330795d9444727 = (productId, userId)=>{
    const userIdOrAnonymous = userId || $801ec4174110d9b1$export$4bac6b574c2c1d97;
    const quickFindRovoTipRaw = (0, $5G9KX.getLocalStorageItemAsString)($801ec4174110d9b1$export$568e0ce3cc5a9972);
    const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
    const rovoTipProducts = rovoTip[userIdOrAnonymous] || {};
    return rovoTipProducts[productId] === undefined ? true : rovoTipProducts[productId];
};
const $801ec4174110d9b1$export$297a6fb093b042a3 = (productId, userId)=>{
    const userIdOrAnonymous = userId || $801ec4174110d9b1$export$4bac6b574c2c1d97;
    const quickFindRovoTipRaw = (0, $5G9KX.getLocalStorageItemAsString)($801ec4174110d9b1$export$568e0ce3cc5a9972);
    const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
    if (!rovoTip[userIdOrAnonymous]) rovoTip[userIdOrAnonymous] = {};
    rovoTip[userIdOrAnonymous][productId] = false;
    (0, $5G9KX.setLocalStorageItem)($801ec4174110d9b1$export$568e0ce3cc5a9972, JSON.stringify(rovoTip));
    return rovoTip[userIdOrAnonymous][productId];
};



var $5tPRL = parcelRequire("5tPRL");













const $57957bf3159c123e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    rovoTip: {
        id: "search_dialog_rovo_tip",
        defaultMessage: "Rovo tip:"
    },
    dismissBannerLabel: {
        id: "search_dialog_dismiss_banner_label",
        defaultMessage: "Dismiss banner"
    },
    rovoBannerMessage: {
        id: "search_dialog_rovo_banner_message",
        defaultMessage: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer"
    }
});


const $238c7f3a77e6e665$var$RovoTipMessageStyle = (0, $ecnYn.xcss)({
    width: '95%',
    marginLeft: 'space.050',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.050'
});
const $238c7f3a77e6e665$var$RovoTipContainerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $238c7f3a77e6e665$var$RovoTipStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    minHeight: "var(--ds-space-500, 40px)",
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.accent.purple.subtlest',
    color: 'color.text.accent.purple'
});
const $238c7f3a77e6e665$export$4d99a070549a9300 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(16);
    const [showRovoTip, setShowRovoTip] = (0, $42omo.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [user] = (0, $j4ply.useUser)();
    let t0;
    let t1;
    if ($[0] !== primaryProduct || $[1] !== user) {
        t0 = ()=>{
            if (!primaryProduct || !user || !user.id) return;
            const rovoTipFromLocalStorage = (0, $801ec4174110d9b1$export$b9330795d9444727)(primaryProduct, user.id);
            setShowRovoTip(rovoTipFromLocalStorage);
        };
        t1 = [
            primaryProduct,
            user
        ];
        $[0] = primaryProduct;
        $[1] = user;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[4] !== primaryProduct || $[5] !== user) {
        t2 = ()=>{
            if (!primaryProduct || !user || !user.id) return;
            const rovoTipFromLocalStorage_0 = (0, $801ec4174110d9b1$export$297a6fb093b042a3)(primaryProduct, user.id);
            setShowRovoTip(rovoTipFromLocalStorage_0);
        };
        $[4] = primaryProduct;
        $[5] = user;
        $[6] = t2;
    } else t2 = $[6];
    const dismissRovoTip = t2;
    if (!showRovoTip) return null;
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
            spacing: "spacious",
            label: "blank",
            color: "var(--ds-text-accent-purple, #803FA5)"
        });
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $57957bf3159c123e$export$defe85febe8b728c).rovoTip));
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $238c7f3a77e6e665$var$RovoTipMessageStyle
        }, t4, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $57957bf3159c123e$export$defe85febe8b728c).rovoBannerMessage));
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== dismissRovoTip || $[11] !== fireAnalyticsEvent) {
        t6 = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            dismissRovoTip();
            fireAnalyticsEvent((0, $i2RLU.onBannerDismissed)({
                isOnSearchDialog: true,
                componentName: "RovoTipBanner"
            }));
        };
        $[10] = dismissRovoTip;
        $[11] = fireAnalyticsEvent;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $57957bf3159c123e$export$defe85febe8b728c).dismissBannerLabel);
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $238c7f3a77e6e665$var$RovoTipContainerStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $238c7f3a77e6e665$var$RovoTipStyle
        }, t3, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5tPRL.EnlargedReturnIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            spacing: "compact",
            onClick: t6,
            label: t7,
            appearance: "subtle"
        }))));
        $[14] = t6;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ()=>{
    const [showRovoTip, setShowRovoTip] = (0, $42omo.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [user] = (0, $j4ply.useUser)();
    (0, $42omo.useEffect)(()=>{
        if (!primaryProduct || !user || !user.id) return;
        const rovoTipFromLocalStorage = (0, $801ec4174110d9b1$export$b9330795d9444727)(primaryProduct, user.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        primaryProduct,
        user
    ]);
    const dismissRovoTip = (0, $42omo.useCallback)(()=>{
        if (!primaryProduct || !user || !user.id) return;
        const rovoTipFromLocalStorage_0 = (0, $801ec4174110d9b1$export$297a6fb093b042a3)(primaryProduct, user.id);
        setShowRovoTip(rovoTipFromLocalStorage_0);
    }, [
        primaryProduct,
        user
    ]);
    if (!showRovoTip) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $238c7f3a77e6e665$var$RovoTipContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $238c7f3a77e6e665$var$RovoTipStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
        spacing: "spacious",
        label: "blank",
        color: "var(--ds-text-accent-purple, #803FA5)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $238c7f3a77e6e665$var$RovoTipMessageStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $57957bf3159c123e$export$defe85febe8b728c).rovoTip)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $57957bf3159c123e$export$defe85febe8b728c).rovoBannerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5tPRL.EnlargedReturnIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        spacing: 'compact',
        onClick: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            dismissRovoTip();
            fireAnalyticsEvent((0, $i2RLU.onBannerDismissed)({
                isOnSearchDialog: true,
                componentName: 'RovoTipBanner'
            }));
        },
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $57957bf3159c123e$export$defe85febe8b728c).dismissBannerLabel),
        appearance: 'subtle'
    }))));
};
















const $92cb390251785e80$var$dividerStyles = (0, $ecnYn.xcss)({
    height: '0',
    width: '100%',
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    borderColor: 'color.border'
});
const $92cb390251785e80$export$2e0a83ec2e27ecbb = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $92cb390251785e80$var$dividerStyles
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $92cb390251785e80$var$dividerStyles
    });
};
















const $c81ca25909252d74$export$8657eff97a198097 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `searchDialogError`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });








const $7e87035b4b825004$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    errorSearchHeading: {
        id: "search_dialog_error_search_heading",
        defaultMessage: "We're having trouble loading your recently viewed content."
    },
    errorSearchBody: {
        id: "search_dialog_error_search_body",
        defaultMessage: "It might just be a hiccup. Please try refreshing the page or <button>try again</button>."
    }
});



const $5e4b8c366d6ef407$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("k0e2P")));
const $5e4b8c366d6ef407$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $5e4b8c366d6ef407$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $5e4b8c366d6ef407$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $5e4b8c366d6ef407$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $5e4b8c366d6ef407$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    font: 'font.body',
    color: 'color.link',
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $5e4b8c366d6ef407$export$42f84e610f279c31 = ({ onRetry: onRetry })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $c81ca25909252d74$export$8657eff97a198097)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    // Same as other analytics events, we only want this to fire when the screen displays
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5e4b8c366d6ef407$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $5e4b8c366d6ef407$var$imageFallbackStyles
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5e4b8c366d6ef407$var$Image, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5e4b8c366d6ef407$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7e87035b4b825004$export$defe85febe8b728c).errorSearchHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5e4b8c366d6ef407$var$bodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $7e87035b4b825004$export$defe85febe8b728c).errorSearchBody,
        values: {
            button: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                    xcss: $5e4b8c366d6ef407$var$pressableStyles,
                    onClick: onRetry
                }, s)
        }
    })));
};















var $8tdj3 = parcelRequire("8tdj3");





var $fpGTa = parcelRequire("fpGTa");










var $8UOsA = parcelRequire("8UOsA");





var $7Yuqm = parcelRequire("7Yuqm");













const $5514968f55e57b26$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    feedbackFooter: {
        id: "search_dialog_feedback_footer",
        defaultMessage: "Help us improve search"
    },
    searchChangeMessage: {
        id: "search_dialog_search_change_message",
        defaultMessage: "Why has search changed?"
    }
});


const $67539e0ab092f04e$var$footerContainerStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.150',
    paddingBlockEnd: 'space.150',
    paddingInlineStart: 'space.200',
    paddingInlineEnd: 'space.200',
    color: 'color.text'
});
const $67539e0ab092f04e$var$communityLinkStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline',
        color: 'color.text.subtlest'
    },
    ':visited': {
        color: 'color.text.subtlest'
    }
});
const $67539e0ab092f04e$var$footerTextStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest'
});
const $67539e0ab092f04e$export$e7b87342306a8337 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(25);
    const [feedbackIsOpen, t0] = (0, $4VmlX.useIsFeedbackModalOpen)();
    const { setIsFeedbackModalOpen: setIsFeedbackModalOpen } = t0;
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [selectedProducts] = (0, $djVCD.useSelectedProducts)();
    const [user] = (0, $j4ply.useUser)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const requestId = (0, $4VmlX.useFetchEntitiesRequestId)();
    const traceId = (0, $4VmlX.useFetchEntitiesTraceId)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $67539e0ab092f04e$var$footerTextStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5514968f55e57b26$export$defe85febe8b728c).feedbackFooter));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== setIsFeedbackModalOpen) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8UOsA.FeedbackButton), {
            size: "small",
            onClick: (e)=>{
                e.preventDefault();
                setIsFeedbackModalOpen(true);
            }
        });
        $[1] = setIsFeedbackModalOpen;
        $[2] = t2;
    } else t2 = $[2];
    const t3 = cloudId || "";
    const t4 = primaryProduct || "";
    let t5;
    if ($[3] !== selectedProducts) {
        t5 = selectedProducts.length ? selectedProducts.join(", ") : "no product filter";
        $[3] = selectedProducts;
        $[4] = t5;
    } else t5 = $[4];
    const t6 = user.id || "";
    const t7 = user.name || "";
    const t8 = requestId || "";
    const t9 = traceId || "";
    let t10;
    if ($[5] !== applicationMode || $[6] !== experimentConfig || $[7] !== feedbackIsOpen || $[8] !== setIsFeedbackModalOpen || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Yuqm.default), {
            cloudId: t3,
            experimentConfig: experimentConfig,
            isOpen: feedbackIsOpen,
            primaryProduct: t4,
            product: t5,
            setIsOpen: setIsFeedbackModalOpen,
            source: "quick-find",
            userId: t6,
            userName: t7,
            mode: applicationMode,
            requestId: t8,
            traceId: t9
        });
        $[5] = applicationMode;
        $[6] = experimentConfig;
        $[7] = feedbackIsOpen;
        $[8] = setIsFeedbackModalOpen;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== t10 || $[18] !== t2) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.150"
        }, t1, t2, t10);
        $[17] = t10;
        $[18] = t2;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== primaryProduct) {
        t12 = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)("jira_rovo_search_community_post_link") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
            xcss: $67539e0ab092f04e$var$communityLinkStyles,
            href: "https://community.atlassian.com/forums/Jira-articles/Introducing-Rovo-Search-for-Jira/ba-p/3093745",
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5514968f55e57b26$export$defe85febe8b728c).searchChangeMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            size: "small",
            label: "Link to community post"
        })));
        $[20] = primaryProduct;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== t11 || $[23] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            justifyContent: "space-between",
            xcss: $67539e0ab092f04e$var$footerContainerStyles
        }, t11, t12);
        $[22] = t11;
        $[23] = t12;
        $[24] = t13;
    } else t13 = $[24];
    return t13;
} : ()=>{
    const [feedbackIsOpen, { setIsFeedbackModalOpen: setIsFeedbackModalOpen }] = (0, $4VmlX.useIsFeedbackModalOpen)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [selectedProducts] = (0, $djVCD.useSelectedProducts)();
    const [user] = (0, $j4ply.useUser)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const requestId = (0, $4VmlX.useFetchEntitiesRequestId)();
    const traceId = (0, $4VmlX.useFetchEntitiesTraceId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "space-between",
        xcss: $67539e0ab092f04e$var$footerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $67539e0ab092f04e$var$footerTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5514968f55e57b26$export$defe85febe8b728c).feedbackFooter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8UOsA.FeedbackButton), {
        size: "small",
        onClick: (e)=>{
            e.preventDefault();
            setIsFeedbackModalOpen(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Yuqm.default), {
        cloudId: cloudId || '',
        experimentConfig: experimentConfig,
        isOpen: feedbackIsOpen,
        primaryProduct: primaryProduct || '',
        product: selectedProducts.length ? selectedProducts.join(', ') : 'no product filter',
        setIsOpen: setIsFeedbackModalOpen,
        source: "quick-find",
        userId: user.id || '',
        userName: user.name || '',
        mode: applicationMode,
        requestId: requestId || '',
        traceId: traceId || ''
    })), primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_rovo_search_community_post_link') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        xcss: $67539e0ab092f04e$var$communityLinkStyles,
        href: "https://community.atlassian.com/forums/Jira-articles/Introducing-Rovo-Search-for-Jira/ba-p/3093745",
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5514968f55e57b26$export$defe85febe8b728c).searchChangeMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        size: "small",
        label: "Link to community post"
    }))));
};















var $4AkKf = parcelRequire("4AkKf");




var $1s5hv = parcelRequire("1s5hv");








const $7ef803532b158311$export$19c4b3b0e982f1c0 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'suggestedFilter',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });














const $3573b0e30646e134$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    suggested_filter: {
        id: "searchDialog.suggested.filter",
        defaultMessage: "Suggested filter"
    },
    apply_suggested_filter: {
        id: "searchDialog.apply.suggested.filter",
        defaultMessage: "Apply filter"
    },
    suggested_filter_icon_label: {
        id: "searchDialog.suggestedFilter.icon.label",
        defaultMessage: "Suggestion search"
    },
    // filter name messages
    project: {
        id: "searchDialog.suggestedFilter.filterName.project",
        defaultMessage: "project"
    },
    assignee: {
        id: "searchDialog.suggestedFilter.filterName.assignee",
        defaultMessage: "assignee"
    },
    app: {
        id: "searchDialog.suggestedFilter.filterName.product",
        defaultMessage: "app"
    }
});


const $aac51a5e41e61c0e$var$styles = {
    filterBadge: "_2rko12b0 _bfhki8nm _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $aac51a5e41e61c0e$export$1ba589c44bc43c28 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(43);
    const { result: result, state: state } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [queryParams] = (0, $j4ply.useQueryParams)();
    const setQueryParams = (0, $j4ply.useSetQueryParams)(queryParams);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    let t1;
    if ($[0] !== commonAttributes || $[1] !== fireAnalyticsEvent || $[2] !== nonPrivacySafeAttributes || $[3] !== queryParams || $[4] !== result || $[5] !== setQueryParams || $[6] !== state) {
        t1 = ()=>{
            const params = Object.fromEntries(Object.entries(result).map($aac51a5e41e61c0e$var$_temp));
            setQueryParams({
                ...queryParams,
                ...params
            });
            fireAnalyticsEvent((0, $7ef803532b158311$export$19c4b3b0e982f1c0)({
                actionSubjectId: (0, $idEgG.getActionSubjectId)(state),
                attributes: {
                    ...commonAttributes,
                    suggestedFilters: Object.keys(params)
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        $[0] = commonAttributes;
        $[1] = fireAnalyticsEvent;
        $[2] = nonPrivacySafeAttributes;
        $[3] = queryParams;
        $[4] = result;
        $[5] = setQueryParams;
        $[6] = state;
        $[7] = t1;
    } else t1 = $[7];
    const onResultClicked = t1;
    let t2;
    if ($[8] !== formatMessage) {
        t2 = formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).suggested_filter_icon_label);
        $[8] = formatMessage;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
            label: t2,
            color: "currentColor"
        }));
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    const icon = t3;
    let t4;
    if ($[12] !== result) {
        t4 = Object.entries(result);
        $[12] = result;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            columnGap: "space.100"
        }, t4.map((t6)=>{
            const [filterId, filterSuggestion] = t6;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                key: filterId,
                xcss: $aac51a5e41e61c0e$var$styles.filterBadge
            }, formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c)[filterSuggestion.filterName]), ":", " ", filterSuggestion.option.label);
        }));
        $[14] = formatMessage;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    const title = t5;
    let t6;
    if ($[17] !== formatMessage) {
        t6 = formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).suggested_filter);
        $[17] = formatMessage;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, t6);
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    const rightMetadata = t7;
    let t8;
    if ($[21] !== formatMessage) {
        t8 = formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).apply_suggested_filter);
        $[21] = formatMessage;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, t8);
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null);
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, t9, t10);
        $[26] = t9;
        $[27] = t11;
    } else t11 = $[27];
    const highlightedRightMetadata = t11;
    let t12;
    if ($[28] !== formatMessage) {
        t12 = formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).apply_suggested_filter);
        $[28] = formatMessage;
        $[29] = t12;
    } else t12 = $[29];
    let t13;
    if ($[30] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, t12));
        $[30] = t12;
        $[31] = t13;
    } else t13 = $[31];
    const hoverRightMetadata = t13;
    let t14;
    if ($[32] !== highlightedRightMetadata || $[33] !== hoverRightMetadata || $[34] !== rightMetadata) {
        t14 = {
            rightMetadata: rightMetadata,
            highlightedRightMetadata: highlightedRightMetadata,
            hoverRightMetadata: hoverRightMetadata
        };
        $[32] = highlightedRightMetadata;
        $[33] = hoverRightMetadata;
        $[34] = rightMetadata;
        $[35] = t14;
    } else t14 = $[35];
    const { rightMetadata: rightMetadata_0, highlightedRightMetadata: highlightedRightMetadata_0, hoverRightMetadata: hoverRightMetadata_0 } = t14;
    let t15;
    if ($[36] !== highlightedRightMetadata_0 || $[37] !== hoverRightMetadata_0 || $[38] !== icon || $[39] !== onResultClicked || $[40] !== rightMetadata_0 || $[41] !== title) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            resultType: "filterSuggestions",
            id: "filter-suggestion",
            icon: icon,
            title: title,
            rightMetadata: rightMetadata_0,
            highlightedRightMetadata: highlightedRightMetadata_0,
            hoveredRightMetadata: hoverRightMetadata_0,
            onResultClicked: onResultClicked
        });
        $[36] = highlightedRightMetadata_0;
        $[37] = hoverRightMetadata_0;
        $[38] = icon;
        $[39] = onResultClicked;
        $[40] = rightMetadata_0;
        $[41] = title;
        $[42] = t15;
    } else t15 = $[42];
    return t15;
} : ({ result: result, state: state })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [queryParams] = (0, $j4ply.useQueryParams)();
    const setQueryParams = (0, $j4ply.useSetQueryParams)(queryParams);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const onResultClicked = (0, $42omo.useCallback)(()=>{
        const params = Object.fromEntries(Object.entries(result).map(([key, value])=>[
                key,
                value.option.value
            ]));
        setQueryParams({
            ...queryParams,
            ...params
        });
        fireAnalyticsEvent((0, $7ef803532b158311$export$19c4b3b0e982f1c0)({
            actionSubjectId: (0, $idEgG.getActionSubjectId)(state),
            attributes: {
                ...commonAttributes,
                suggestedFilters: Object.keys(params)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        result,
        setQueryParams,
        queryParams,
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        state
    ]);
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: "",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
        label: formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).suggested_filter_icon_label),
        color: "currentColor"
    }));
    const title = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            columnGap: "space.100"
        }, Object.entries(result).map(([filterId, filterSuggestion])=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                key: filterId,
                xcss: $aac51a5e41e61c0e$var$styles.filterBadge
            }, formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c)[filterSuggestion.filterName]), ":", ' ', filterSuggestion.option.label);
        }));
    }, [
        result,
        formatMessage
    ]);
    const { rightMetadata: rightMetadata_0, highlightedRightMetadata: highlightedRightMetadata_0, hoverRightMetadata: hoverRightMetadata_0 } = (0, $42omo.useMemo)(()=>{
        const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).suggested_filter));
        const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).apply_suggested_filter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
        const hoverRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, formatMessage((0, $3573b0e30646e134$export$defe85febe8b728c).apply_suggested_filter)));
        return {
            rightMetadata: rightMetadata,
            highlightedRightMetadata: highlightedRightMetadata,
            hoverRightMetadata: hoverRightMetadata
        };
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
        resultType: "filterSuggestions",
        id: "filter-suggestion",
        icon: icon,
        title: title,
        rightMetadata: rightMetadata_0,
        highlightedRightMetadata: highlightedRightMetadata_0,
        hoveredRightMetadata: hoverRightMetadata_0,
        onResultClicked: onResultClicked
    });
};
function $aac51a5e41e61c0e$var$_temp(t0) {
    const [key, value] = t0;
    return [
        key,
        value.option.value
    ];
}































const $b7cdee9969fa612b$export$59708e770734a297 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'moreProductFilters',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });






































var $eoZmS = parcelRequire("eoZmS");


















var $3gadb = parcelRequire("3gadb");

const $0c4269204833e8a1$var$defaultFilterButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075',
    color: 'color.text.subtle',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    // As specified on Figma
    maxWidth: '165px',
    // As specified on Figma
    backgroundColor: 'color.background.neutral.subtle',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $0c4269204833e8a1$var$compactContentFitStyles = (0, $ecnYn.xcss)({
    maxWidth: '113px' // As specified on Figma
});
const $0c4269204833e8a1$var$minWidthZeroStyles = (0, $ecnYn.xcss)({
    minWidth: '0' // Allow the button to shrink as much as possible
});
const $0c4269204833e8a1$var$filterButtonSelectedStateStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`,
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $0c4269204833e8a1$var$compactSpacingStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.050'
});
const $0c4269204833e8a1$var$comfortableGapStyles = (0, $ecnYn.xcss)({
    gap: 'space.100'
});
const $0c4269204833e8a1$var$filterButtonContentStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $0c4269204833e8a1$var$noBorderStyles = (0, $ecnYn.xcss)({
    border: 0
});
const $0c4269204833e8a1$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((0, $4pOgL.isReactCompilerActivePlatform)() ? function FilterButton(t0, ref) {
    const $ = (0, $frIzR.c)(27);
    let children;
    let iconAfter;
    let iconBefore;
    let isSelected;
    let noBorder;
    let pressableProps;
    let t1;
    let t2;
    let t3;
    let t4;
    let tooltip;
    if ($[0] !== t0) {
        ({ children: children, contentFit: t1, iconAfter: iconAfter, iconBefore: iconBefore, isSelected: isSelected, noBorder: noBorder, tooltip: tooltip, minWidthZero: t2, spacing: t3, gap: t4, ...pressableProps } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = iconAfter;
        $[3] = iconBefore;
        $[4] = isSelected;
        $[5] = noBorder;
        $[6] = pressableProps;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = tooltip;
    } else {
        children = $[1];
        iconAfter = $[2];
        iconBefore = $[3];
        isSelected = $[4];
        noBorder = $[5];
        pressableProps = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        tooltip = $[11];
    }
    const contentFit = t1 === undefined ? "default" : t1;
    const minWidthZero = t2 === undefined ? false : t2;
    const spacing = t3 === undefined ? "default" : t3;
    const gap = t4 === undefined ? "default" : t4;
    const t5 = tooltip ?? null;
    let t6;
    if ($[12] !== children || $[13] !== contentFit || $[14] !== gap || $[15] !== iconAfter || $[16] !== iconBefore || $[17] !== isSelected || $[18] !== minWidthZero || $[19] !== noBorder || $[20] !== pressableProps || $[21] !== ref || $[22] !== spacing) {
        t6 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                ...pressableProps,
                xcss: [
                    $0c4269204833e8a1$var$defaultFilterButtonStyles,
                    isSelected && $0c4269204833e8a1$var$filterButtonSelectedStateStyles,
                    spacing === "compact" && $0c4269204833e8a1$var$compactSpacingStyles,
                    contentFit === "compact" && $0c4269204833e8a1$var$compactContentFitStyles,
                    gap === "comfortable" && $0c4269204833e8a1$var$comfortableGapStyles,
                    minWidthZero && $0c4269204833e8a1$var$minWidthZeroStyles,
                    noBorder && $0c4269204833e8a1$var$noBorderStyles
                ],
                ref: ref
            }, iconBefore, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0c4269204833e8a1$var$filterButtonContentStyles
            }, children), iconAfter));
        $[12] = children;
        $[13] = contentFit;
        $[14] = gap;
        $[15] = iconAfter;
        $[16] = iconBefore;
        $[17] = isSelected;
        $[18] = minWidthZero;
        $[19] = noBorder;
        $[20] = pressableProps;
        $[21] = ref;
        $[22] = spacing;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== t5 || $[25] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t5,
            position: "bottom"
        }, t6);
        $[24] = t5;
        $[25] = t6;
        $[26] = t7;
    } else t7 = $[26];
    return t7;
} : function FilterButton({ children: children, contentFit: contentFit = 'default', iconAfter: iconAfter, iconBefore: iconBefore, isSelected: isSelected, noBorder: noBorder, tooltip: tooltip, minWidthZero: minWidthZero = false, spacing: spacing = 'default', gap: gap = 'default', ...pressableProps }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltip ?? null,
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            ...pressableProps,
            xcss: [
                $0c4269204833e8a1$var$defaultFilterButtonStyles,
                isSelected && $0c4269204833e8a1$var$filterButtonSelectedStateStyles,
                spacing === 'compact' && $0c4269204833e8a1$var$compactSpacingStyles,
                contentFit === 'compact' && $0c4269204833e8a1$var$compactContentFitStyles,
                gap === 'comfortable' && $0c4269204833e8a1$var$comfortableGapStyles,
                minWidthZero && $0c4269204833e8a1$var$minWidthZeroStyles,
                noBorder && $0c4269204833e8a1$var$noBorderStyles
            ],
            ref: ref
        }, iconBefore, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $0c4269204833e8a1$var$filterButtonContentStyles
        }, children), iconAfter)));
});









var $5xGHP = parcelRequire("5xGHP");






















const $1aa60baca70ed4d4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    appTooltipFor1Pand3PApps: {
        id: "inline-app-selector.1p-3p-app-tooltip",
        defaultMessage: "Open a full page search for this term filtered by {productName} results"
    },
    tooltipForAllApps: {
        id: "inline-app-selector.all-apps-tooltip",
        defaultMessage: "Open a full page search for this term searching all apps"
    },
    additionalProducts: {
        id: "inline-app-selector.additional-products",
        defaultMessage: "+ {count}"
    }
});






























// TODO: Render dynamic 1P products, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$supported1PApps = (primaryProduct)=>{
    if (!primaryProduct) return [];
    switch(primaryProduct){
        case (0, $6Gsan.PrimaryProductKeys).Confluence:
            return [
                {
                    productKey: (0, $1yEFx.ProductKeys).Confluence,
                    redirectToFPS: false
                }
            ];
        default:
            return [
                {
                    productKey: (0, $1yEFx.ProductKeys).Confluence,
                    redirectToFPS: true
                },
                {
                    productKey: (0, $1yEFx.ProductKeys).Jira,
                    redirectToFPS: true
                }
            ];
    }
};
// TODO: Render dynamic 1P products, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$supported3PApps = [
    (0, $1yEFx.ProductKeys).GoogleDrive,
    (0, $1yEFx.ProductKeys).Slack
];
const $9fbf3b40278c59cd$export$6b2b316097ae586c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(28);
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const dialogWidth = (0, $86ob4.useElementWidth)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID));
    const isDialogAbove400px = dialogWidth > 400;
    const isDialogAbove450px = dialogWidth > 450;
    let t0;
    if ($[0] !== availableProducts || $[1] !== productConfigs || $[2] !== selectedProduct) {
        let t1;
        if ($[4] !== availableProducts) {
            t1 = (supported3PApp)=>availableProducts.includes(supported3PApp);
            $[4] = availableProducts;
            $[5] = t1;
        } else t1 = $[5];
        let t2;
        if ($[6] !== selectedProduct) {
            t2 = (_)=>!selectedProduct;
            $[6] = selectedProduct;
            $[7] = t2;
        } else t2 = $[7];
        let t3;
        if ($[8] !== productConfigs) {
            t3 = (productKey)=>({
                    productKey: productKey,
                    productConfig: productConfigs[productKey]
                });
            $[8] = productConfigs;
            $[9] = t3;
        } else t3 = $[9];
        t0 = $9fbf3b40278c59cd$var$supported3PApps.filter(t1).filter(t2).map(t3);
        $[0] = availableProducts;
        $[1] = productConfigs;
        $[2] = selectedProduct;
        $[3] = t0;
    } else t0 = $[3];
    const apps3PToDisplay = t0;
    let t1;
    if ($[10] !== availableProducts || $[11] !== primaryProduct || $[12] !== productConfigs || $[13] !== selectedProduct) {
        let t2;
        if ($[15] !== availableProducts) {
            t2 = (supported1PApp)=>availableProducts.includes(supported1PApp.productKey);
            $[15] = availableProducts;
            $[16] = t2;
        } else t2 = $[16];
        let t3;
        if ($[17] !== selectedProduct) {
            t3 = (supported1PApp_0)=>!selectedProduct || supported1PApp_0.productKey === selectedProduct;
            $[17] = selectedProduct;
            $[18] = t3;
        } else t3 = $[18];
        let t4;
        if ($[19] !== productConfigs) {
            t4 = (supportedApp)=>({
                    ...supportedApp,
                    productConfig: productConfigs[supportedApp.productKey]
                });
            $[19] = productConfigs;
            $[20] = t4;
        } else t4 = $[20];
        t1 = $9fbf3b40278c59cd$var$supported1PApps(primaryProduct).filter(t2).filter(t3).map(t4);
        $[10] = availableProducts;
        $[11] = primaryProduct;
        $[12] = productConfigs;
        $[13] = selectedProduct;
        $[14] = t1;
    } else t1 = $[14];
    const apps1PToDisplay = t1;
    let t2;
    if ($[21] !== apps1PToDisplay || $[22] !== apps3PToDisplay || $[23] !== isDialogAbove400px || $[24] !== isDialogAbove450px || $[25] !== primaryProduct || $[26] !== selectedProduct) {
        t2 = {
            apps1PToDisplay: apps1PToDisplay,
            apps3PToDisplay: apps3PToDisplay,
            isDialogAbove400px: isDialogAbove400px,
            isDialogAbove450px: isDialogAbove450px,
            primaryProduct: primaryProduct,
            selectedProduct: selectedProduct
        };
        $[21] = apps1PToDisplay;
        $[22] = apps3PToDisplay;
        $[23] = isDialogAbove400px;
        $[24] = isDialogAbove450px;
        $[25] = primaryProduct;
        $[26] = selectedProduct;
        $[27] = t2;
    } else t2 = $[27];
    return t2;
} : ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const dialogWidth = (0, $86ob4.useElementWidth)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID));
    const isDialogAbove400px = dialogWidth > 400;
    const isDialogAbove450px = dialogWidth > 450;
    const apps3PToDisplay = (0, $42omo.useMemo)(()=>$9fbf3b40278c59cd$var$supported3PApps.filter((supported3PApp)=>availableProducts.includes(supported3PApp)).filter((_)=>!selectedProduct).map((productKey)=>({
                productKey: productKey,
                productConfig: productConfigs[productKey]
            })), [
        availableProducts,
        productConfigs,
        selectedProduct
    ]);
    const apps1PToDisplay = (0, $42omo.useMemo)(()=>$9fbf3b40278c59cd$var$supported1PApps(primaryProduct).filter((supported1PApp)=>availableProducts.includes(supported1PApp.productKey)).filter((supported1PApp_0)=>!selectedProduct || supported1PApp_0.productKey === selectedProduct).map((supportedApp)=>({
                ...supportedApp,
                productConfig: productConfigs[supportedApp.productKey]
            })), [
        availableProducts,
        primaryProduct,
        productConfigs,
        selectedProduct
    ]);
    return {
        apps1PToDisplay: apps1PToDisplay,
        apps3PToDisplay: apps3PToDisplay,
        isDialogAbove400px: isDialogAbove400px,
        isDialogAbove450px: isDialogAbove450px,
        primaryProduct: primaryProduct,
        selectedProduct: selectedProduct
    };
};
const $9fbf3b40278c59cd$var$prioritised3PApps = [
    (0, $1yEFx.ProductKeys).GoogleDrive,
    (0, $1yEFx.ProductKeys).Slack
];
const $9fbf3b40278c59cd$export$93388c571f049def = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(9);
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    let t0;
    if ($[0] !== availableProducts || $[1] !== productConfigs) {
        let t1;
        if ($[3] !== productConfigs) {
            t1 = (productKey)=>({
                    productKey: productKey,
                    productConfig: productConfigs[productKey]
                });
            $[3] = productConfigs;
            $[4] = t1;
        } else t1 = $[4];
        t0 = availableProducts.filter((0, $b4tvS.is3pProductKey)).sort($9fbf3b40278c59cd$var$_temp).map(t1).slice(0, 2);
        $[0] = availableProducts;
        $[1] = productConfigs;
        $[2] = t0;
    } else t0 = $[2];
    const apps3PToDisplay = t0;
    const numberOfAdditionalProducts = availableProducts.length - apps3PToDisplay.length;
    let t1;
    if ($[5] !== apps3PToDisplay || $[6] !== numberOfAdditionalProducts || $[7] !== primaryProduct) {
        t1 = {
            apps3PToDisplay: apps3PToDisplay,
            primaryProduct: primaryProduct,
            numberOfAdditionalProducts: numberOfAdditionalProducts
        };
        $[5] = apps3PToDisplay;
        $[6] = numberOfAdditionalProducts;
        $[7] = primaryProduct;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const apps3PToDisplay = (0, $42omo.useMemo)(()=>availableProducts.filter((0, $b4tvS.is3pProductKey)).sort((a, b)=>{
            const aPreferredPosition = $9fbf3b40278c59cd$var$prioritised3PApps.indexOf(a);
            const bPreferredPosition = $9fbf3b40278c59cd$var$prioritised3PApps.indexOf(b);
            if (aPreferredPosition !== -1 && bPreferredPosition !== -1) return aPreferredPosition - bPreferredPosition;
            else if (aPreferredPosition !== -1) return -1;
            else if (bPreferredPosition !== -1) return 1;
            else return 0;
        }).map((productKey)=>({
                productKey: productKey,
                productConfig: productConfigs[productKey]
            })).slice(0, 2), [
        availableProducts,
        productConfigs
    ]);
    const numberOfAdditionalProducts = availableProducts.length - apps3PToDisplay.length;
    return {
        apps3PToDisplay: apps3PToDisplay,
        primaryProduct: primaryProduct,
        numberOfAdditionalProducts: numberOfAdditionalProducts
    };
};
function $9fbf3b40278c59cd$var$_temp(a, b) {
    const aPreferredPosition = $9fbf3b40278c59cd$var$prioritised3PApps.indexOf(a);
    const bPreferredPosition = $9fbf3b40278c59cd$var$prioritised3PApps.indexOf(b);
    if (aPreferredPosition !== -1 && bPreferredPosition !== -1) return aPreferredPosition - bPreferredPosition;
    else {
        if (aPreferredPosition !== -1) return -1;
        else {
            if (bPreferredPosition !== -1) return 1;
            else return 0;
        }
    }
}


const $e1138a05237425a8$var$inlineFilterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $e1138a05237425a8$var$noProductFilterStyles = (0, $ecnYn.xcss)({
    marginRight: 'auto'
});
const $e1138a05237425a8$var$AppButtonFor3PApps = ({ productKey: productKey, redirectToFPSWithProductSelected: redirectToFPSWithProductSelected, trigger: trigger })=>{
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const isSmartlink = (0, $def8z.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.useIsUserOAuthed)(productKey);
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    if (userNeedsOAuth) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1nJM3.ErrorBoundary), {
        section: "QuickFindAppButtonFor3PAppsOAuthWrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eoZmS.OAuthWarningWrapper), {
        key: productKey,
        product: productKey,
        postAuthAction: ()=>{
            redirectToFPSWithProductSelected();
        },
        trigger: (triggerProps)=>trigger({
                ...triggerProps,
                userNeedsAuth: true
            }),
        isOnSearchDialog: true,
        useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
        useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
        isSmartlink: isSmartlink,
        searchQuery: quickFindQuery,
        oAuthSource: (0, $ckkm9.OAuthSource).quickFindFilter,
        thirdPartyConfigs: thirdPartyConfigs
    }));
    return trigger({
        userNeedsAuth: false
    });
};
const $e1138a05237425a8$export$863a72861bb447a2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(48);
    const { onAllFiltersClickCallback: onAllFiltersClickCallback } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { selectProductFilter: selectProductFilter, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { apps1PToDisplay: apps1PToDisplay, isDialogAbove400px: isDialogAbove400px, isDialogAbove450px: isDialogAbove450px, primaryProduct: primaryProduct, selectedProduct: selectedProduct } = (0, $9fbf3b40278c59cd$export$6b2b316097ae586c)();
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)();
    const { apps3PToDisplay: apps3PToDisplay, numberOfAdditionalProducts: numberOfAdditionalProducts } = (0, $9fbf3b40278c59cd$export$93388c571f049def)();
    let t1;
    if ($[0] !== clearAllFilters || $[1] !== commonAttributes || $[2] !== fireAnalyticsEvent || $[3] !== generateSearchUrl || $[4] !== nonPrivacySafeAttributes || $[5] !== onNavigate || $[6] !== queryParams || $[7] !== quickFindQuery || $[8] !== selectProductFilter || $[9] !== selectedProduct || $[10] !== setQuickFindOpen) {
        t1 = (productKey, options, event)=>{
            const newSelectedProduct = selectedProduct === productKey ? undefined : productKey;
            fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
                actionSubjectId: productKey,
                action: newSelectedProduct === undefined ? "unselected" : "selected",
                attributes: {
                    ...commonAttributes,
                    isPostAuthAction: options.isPostAuthAction,
                    isRedirectedToFPS: options.redirectToFPS
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            if (!options.redirectToFPS) {
                selectProductFilter(newSelectedProduct);
                return;
            }
            const onNavigateCallback = typeof onNavigate === "function" ? onNavigate : onNavigate.callback;
            onNavigateCallback(generateSearchUrl({
                ...queryParams,
                product: productKey,
                text: quickFindQuery
            }), "push", event);
            clearAllFilters();
            setQuickFindOpen(false);
        };
        $[0] = clearAllFilters;
        $[1] = commonAttributes;
        $[2] = fireAnalyticsEvent;
        $[3] = generateSearchUrl;
        $[4] = nonPrivacySafeAttributes;
        $[5] = onNavigate;
        $[6] = queryParams;
        $[7] = quickFindQuery;
        $[8] = selectProductFilter;
        $[9] = selectedProduct;
        $[10] = setQuickFindOpen;
        $[11] = t1;
    } else t1 = $[11];
    const onAppFilterSelected = t1;
    let t2;
    if ($[12] !== apps3PToDisplay || $[13] !== formatMessage || $[14] !== isDialogAbove400px || $[15] !== isDialogAbove450px || $[16] !== onAppFilterSelected) {
        let t3;
        if ($[18] !== formatMessage || $[19] !== isDialogAbove400px || $[20] !== isDialogAbove450px || $[21] !== onAppFilterSelected) {
            t3 = (t4)=>{
                const { productKey: productKey_0, productConfig: productConfig } = t4;
                const Icon = productConfig.IconBorderless ?? productConfig.Icon;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e1138a05237425a8$var$AppButtonFor3PApps, {
                    key: productKey_0,
                    productKey: productKey_0,
                    productConfig: productConfig,
                    redirectToFPSWithProductSelected: ()=>onAppFilterSelected(productKey_0, {
                            redirectToFPS: true,
                            isPostAuthAction: true
                        }),
                    trigger: (t5)=>{
                        const { triggerProps: triggerProps, userNeedsAuth: userNeedsAuth } = t5;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                            ...triggerProps,
                            contentFit: isDialogAbove450px ? "default" : "compact",
                            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                                size: "xsmall"
                            }),
                            isSelected: false,
                            onClick: (event_0)=>{
                                if (!userNeedsAuth) onAppFilterSelected(productKey_0, {
                                    redirectToFPS: true,
                                    isPostAuthAction: false
                                }, event_0);
                            },
                            spacing: !userNeedsAuth || isDialogAbove400px ? "default" : "compact",
                            tooltip: !userNeedsAuth && formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).appTooltipFor1Pand3PApps, {
                                productName: productConfig.displayName
                            })
                        }, isDialogAbove400px && productConfig.displayName);
                    }
                });
            };
            $[18] = formatMessage;
            $[19] = isDialogAbove400px;
            $[20] = isDialogAbove450px;
            $[21] = onAppFilterSelected;
            $[22] = t3;
        } else t3 = $[22];
        t2 = apps3PToDisplay.map(t3);
        $[12] = apps3PToDisplay;
        $[13] = formatMessage;
        $[14] = isDialogAbove400px;
        $[15] = isDialogAbove450px;
        $[16] = onAppFilterSelected;
        $[17] = t2;
    } else t2 = $[17];
    const apps3pComponent = t2;
    let t3;
    if ($[23] !== apps1PToDisplay || $[24] !== formatMessage || $[25] !== isDialogAbove400px || $[26] !== isDialogAbove450px || $[27] !== onAppFilterSelected || $[28] !== selectedProduct) {
        let t4;
        if ($[30] !== formatMessage || $[31] !== isDialogAbove400px || $[32] !== isDialogAbove450px || $[33] !== onAppFilterSelected || $[34] !== selectedProduct) {
            t4 = (t5)=>{
                const { productKey: productKey_1, productConfig: productConfig_0, redirectToFPS: redirectToFPS } = t5;
                const AppIcon = productConfig_0.Icon;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                    key: productKey_1,
                    "aria-current": selectedProduct === productKey_1,
                    contentFit: isDialogAbove450px ? "default" : "compact",
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AppIcon, {
                        size: "small"
                    }),
                    isSelected: selectedProduct === productKey_1,
                    onClick: (event_1)=>onAppFilterSelected(productKey_1, {
                            redirectToFPS: redirectToFPS,
                            isPostAuthAction: false
                        }, event_1),
                    tooltip: formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).appTooltipFor1Pand3PApps, {
                        productName: productConfig_0.displayName
                    }),
                    spacing: isDialogAbove400px ? "default" : "compact"
                }, isDialogAbove400px && productConfig_0.displayName);
            };
            $[30] = formatMessage;
            $[31] = isDialogAbove400px;
            $[32] = isDialogAbove450px;
            $[33] = onAppFilterSelected;
            $[34] = selectedProduct;
            $[35] = t4;
        } else t4 = $[35];
        t3 = apps1PToDisplay.map(t4);
        $[23] = apps1PToDisplay;
        $[24] = formatMessage;
        $[25] = isDialogAbove400px;
        $[26] = isDialogAbove450px;
        $[27] = onAppFilterSelected;
        $[28] = selectedProduct;
        $[29] = t3;
    } else t3 = $[29];
    const apps1PComponent = t3;
    if (!(0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct)) {
        let t4;
        if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = [
                $e1138a05237425a8$var$inlineFilterStyles,
                $e1138a05237425a8$var$noProductFilterStyles
            ];
            $[36] = t4;
        } else t4 = $[36];
        let t5;
        if ($[37] !== apps1PComponent || $[38] !== apps3pComponent) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                testId: "qf-inline-app-selector",
                xcss: t4
            }, apps3pComponent, apps1PComponent);
            $[37] = apps1PComponent;
            $[38] = apps3pComponent;
            $[39] = t5;
        } else t5 = $[39];
        return t5;
    }
    if (isAnyFilterSelected) return null;
    let t4;
    if ($[40] !== apps3PToDisplay.length || $[41] !== formatMessage || $[42] !== numberOfAdditionalProducts || $[43] !== onAllFiltersClickCallback) {
        t4 = apps3PToDisplay.length > 0 && numberOfAdditionalProducts > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
            onClick: (event_2)=>onAllFiltersClickCallback?.({
                    event: event_2,
                    action: "searchByAllApps"
                }),
            tooltip: formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).tooltipForAllApps),
            testId: "quick-find-app-filters-all-apps-button"
        }, formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).additionalProducts, {
            count: numberOfAdditionalProducts
        }));
        $[40] = apps3PToDisplay.length;
        $[41] = formatMessage;
        $[42] = numberOfAdditionalProducts;
        $[43] = onAllFiltersClickCallback;
        $[44] = t4;
    } else t4 = $[44];
    let t5;
    if ($[45] !== apps3pComponent || $[46] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "qf-inline-app-selector",
            xcss: $e1138a05237425a8$var$inlineFilterStyles
        }, apps3pComponent, t4);
        $[45] = apps3pComponent;
        $[46] = t4;
        $[47] = t5;
    } else t5 = $[47];
    return t5;
} : ({ onAllFiltersClickCallback: onAllFiltersClickCallback })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { selectProductFilter: selectProductFilter, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { apps1PToDisplay: apps1PToDisplay, isDialogAbove400px: isDialogAbove400px, isDialogAbove450px: isDialogAbove450px, primaryProduct: primaryProduct, selectedProduct: selectedProduct } = (0, $9fbf3b40278c59cd$export$6b2b316097ae586c)();
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)();
    const { apps3PToDisplay: apps3PToDisplay, numberOfAdditionalProducts: numberOfAdditionalProducts } = (0, $9fbf3b40278c59cd$export$93388c571f049def)();
    const onAppFilterSelected = (productKey, options, event)=>{
        const newSelectedProduct = selectedProduct === productKey ? undefined : productKey;
        fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
            actionSubjectId: productKey,
            action: newSelectedProduct === undefined ? 'unselected' : 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: options.isPostAuthAction,
                isRedirectedToFPS: options.redirectToFPS
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        if (!options.redirectToFPS) {
            selectProductFilter(newSelectedProduct);
            return;
        }
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push', event);
        clearAllFilters();
        setQuickFindOpen(false);
    };
    const apps3pComponent = apps3PToDisplay.map(({ productKey: productKey_0, productConfig: productConfig })=>{
        const Icon = productConfig.IconBorderless ?? productConfig.Icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e1138a05237425a8$var$AppButtonFor3PApps, {
            key: productKey_0,
            productKey: productKey_0,
            productConfig: productConfig,
            redirectToFPSWithProductSelected: ()=>onAppFilterSelected(productKey_0, {
                    redirectToFPS: true,
                    isPostAuthAction: true
                }),
            trigger: ({ triggerProps: triggerProps, userNeedsAuth: userNeedsAuth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                    ...triggerProps,
                    contentFit: isDialogAbove450px ? 'default' : 'compact',
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                        size: 'xsmall'
                    }),
                    isSelected: false,
                    onClick: (event_0)=>{
                        if (!userNeedsAuth) onAppFilterSelected(productKey_0, {
                            redirectToFPS: true,
                            isPostAuthAction: false
                        }, event_0);
                    },
                    spacing: !userNeedsAuth || isDialogAbove400px ? 'default' : 'compact',
                    tooltip: !userNeedsAuth && formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).appTooltipFor1Pand3PApps, {
                        productName: productConfig.displayName
                    })
                }, isDialogAbove400px && productConfig.displayName)
        });
    });
    const apps1PComponent = apps1PToDisplay.map(({ productKey: productKey_1, productConfig: productConfig_0, redirectToFPS: redirectToFPS })=>{
        const AppIcon = productConfig_0.Icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
            key: productKey_1,
            "aria-current": selectedProduct === productKey_1,
            contentFit: isDialogAbove450px ? 'default' : 'compact',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AppIcon, {
                size: "small"
            }),
            isSelected: selectedProduct === productKey_1,
            onClick: (event_1)=>onAppFilterSelected(productKey_1, {
                    redirectToFPS: redirectToFPS,
                    isPostAuthAction: false
                }, event_1),
            tooltip: formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).appTooltipFor1Pand3PApps, {
                productName: productConfig_0.displayName
            }),
            spacing: isDialogAbove400px ? 'default' : 'compact'
        }, isDialogAbove400px && productConfig_0.displayName);
    });
    if (!(0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "qf-inline-app-selector",
        xcss: [
            $e1138a05237425a8$var$inlineFilterStyles,
            $e1138a05237425a8$var$noProductFilterStyles
        ]
    }, apps3pComponent, apps1PComponent);
    if (isAnyFilterSelected) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "qf-inline-app-selector",
        xcss: $e1138a05237425a8$var$inlineFilterStyles
    }, apps3pComponent, apps3PToDisplay.length > 0 && numberOfAdditionalProducts > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
        onClick: (event_2)=>onAllFiltersClickCallback?.({
                event: event_2,
                action: 'searchByAllApps'
            }),
        tooltip: formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).tooltipForAllApps),
        testId: "quick-find-app-filters-all-apps-button"
    }, formatMessage((0, $1aa60baca70ed4d4$export$a7357cdd1f0b0168).additionalProducts, {
        count: numberOfAdditionalProducts
    })));
};















var $ccHMk = parcelRequire("ccHMk");




























var $gCEkV = parcelRequire("gCEkV");












var $ehGUC = parcelRequire("ehGUC");


var $kRxMN = parcelRequire("kRxMN");


var $kGrYY = parcelRequire("kGrYY");














var $c4sKh = parcelRequire("c4sKh");


var $226KS = parcelRequire("226KS");


var $ghftu = parcelRequire("ghftu");



















const $d11e9fb73f3c65ea$var$filterButtonIconContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075'
});
const $d11e9fb73f3c65ea$export$68a752ca64f3cf84 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $d11e9fb73f3c65ea$var$filterButtonIconContainerStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d11e9fb73f3c65ea$var$filterButtonIconContainerStyles
    }, children);
};












var $bbypI = parcelRequire("bbypI");

var $6Ipjn = parcelRequire("6Ipjn");





var $5eWut = parcelRequire("5eWut");


var $k5mzm = parcelRequire("k5mzm");


var $ls6iZ = parcelRequire("ls6iZ");

const $1e26310d04240baa$export$4f9a317f0153844 = (option)=>{
    const arrayOfOptions = Array.isArray(option) ? option : [
        option
    ];
    return arrayOfOptions.every((popupOption)=>popupOption?.isSelected !== undefined && popupOption?.value !== undefined && popupOption?.trackingKey !== undefined && popupOption?.value !== undefined && popupOption?.queryParamValue !== undefined && popupOption?.isSuggested !== undefined && popupOption?.isDefault !== undefined && popupOption?.label !== undefined);
};


const $40387639b8effd2d$export$381eb977a1d9bc81 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(39);
    const { defaultIsOpen: t1, isSearchable: t2, isLoading: t3, canClearFilter: t4, checkboxIndicators: t5, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, label: label, noOptionsMessage: noOptionsMessage, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, target: target, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, filterId: filterId, filterOption: filterOptionOverride } = t0;
    const defaultIsOpen = t1 === undefined ? false : t1;
    const isSearchable = t2 === undefined ? false : t2;
    const isLoading = t3 === undefined ? false : t3;
    const canClearFilter = t4 === undefined ? false : t4;
    const checkboxIndicators = t5 === undefined ? false : t5;
    const debounceTimeout = (0, $42omo.useRef)(null);
    const [currentSearchInput, setCurrentSearchInput] = (0, $42omo.useState)(searchInput);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    let t6;
    if ($[0] !== onSearchInputChange) {
        t6 = (value, action)=>{
            if (action.action !== "input-change") return;
            setCurrentSearchInput(value);
            if (!onSearchInputChange) return;
            if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
            debounceTimeout.current = setTimeout(()=>{
                onSearchInputChange(value);
            }, 300);
        };
        $[0] = onSearchInputChange;
        $[1] = t6;
    } else t6 = $[1];
    const handleInputChange = t6;
    let t7;
    if ($[2] !== commonAttributes || $[3] !== filterId || $[4] !== fireAnalyticsEvent || $[5] !== onSelectChange) {
        t7 = (value_0)=>{
            if (!(0, $1e26310d04240baa$export$4f9a317f0153844)(value_0)) throw new Error("Value should match the PopupSelectOption type");
            onSelectChange(value_0);
            const { productSelected: _productSelected, filters: _filters, filterSelections: _filterSelections, ...restAttributes } = commonAttributes;
            const selection = (Array.isArray(value_0) ? value_0 : [
                value_0
            ])[0];
            if (!selection) return;
            fireAnalyticsEvent((0, $5eWut.onFilterSelection)({
                action: selection.isSelected ? "unselected" : "selected",
                location: "inline",
                actionSubjectId: "searchDialogFilter",
                attributes: {
                    ...restAttributes,
                    filterId: filterId
                }
            }));
        };
        $[2] = commonAttributes;
        $[3] = filterId;
        $[4] = fireAnalyticsEvent;
        $[5] = onSelectChange;
        $[6] = t7;
    } else t7 = $[6];
    const handleChange = t7;
    const filterOption = filterOptionOverride !== undefined ? filterOptionOverride ?? undefined : isSearchable ? $40387639b8effd2d$var$_temp : undefined;
    const t8 = !checkboxIndicators;
    const t9 = isFiltersDiscoverability2Enabled ? (0, $ls6iZ.MenuListWithoutClearFilterOptionLabel) : (0, $ls6iZ.MenuListWithClearFilterOptionLabel);
    let t10;
    if ($[7] !== checkboxIndicators) {
        t10 = checkboxIndicators ? {
            Option: (0, $bbypI.CheckboxOption)
        } : {};
        $[7] = checkboxIndicators;
        $[8] = t10;
    } else t10 = $[8];
    let t11;
    if ($[9] !== t10 || $[10] !== t9) {
        t11 = {
            Control: $k5mzm.Control,
            MenuList: t9,
            ...t10
        };
        $[9] = t10;
        $[10] = t9;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== currentSearchInput || $[13] !== noOptionsMessage) {
        t12 = currentSearchInput ? undefined : ()=>noOptionsMessage;
        $[12] = currentSearchInput;
        $[13] = noOptionsMessage;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== onDropdownClose) {
        t13 = ()=>{
            setCurrentSearchInput("");
            onDropdownClose?.();
        };
        $[15] = onDropdownClose;
        $[16] = t13;
    } else t13 = $[16];
    let t14;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = {
            strategy: "fixed",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: false
                }
            ]
        };
        $[17] = t14;
    } else t14 = $[17];
    let t15;
    if ($[18] !== canClearFilter || $[19] !== currentSearchInput || $[20] !== defaultIsOpen || $[21] !== filterOption || $[22] !== formatOptionLabel || $[23] !== handleChange || $[24] !== handleInputChange || $[25] !== isLoading || $[26] !== isSearchable || $[27] !== label || $[28] !== minMenuWidth || $[29] !== onClearOptions || $[30] !== onDropdownOpen || $[31] !== options || $[32] !== placeholder || $[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t8 || $[37] !== target) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
            blurInputOnSelect: false,
            canClearFilter: canClearFilter,
            closeMenuOnSelect: t8,
            components: t11,
            defaultIsOpen: defaultIsOpen,
            defaultOptions: false,
            formatOptionLabel: formatOptionLabel,
            inputValue: currentSearchInput,
            isClearable: false,
            isLoading: isLoading,
            isOptionSelected: $40387639b8effd2d$var$_temp2,
            isSearchable: isSearchable,
            label: label,
            maxMenuHeight: 400,
            maxMenuWidth: "22rem",
            menuPlacement: "bottom",
            minMenuWidth: minMenuWidth,
            noOptionsMessage: t12,
            onChange: handleChange,
            onClearOptions: onClearOptions,
            onInputChange: handleInputChange,
            onMenuClose: t13,
            onMenuOpen: onDropdownOpen,
            options: options,
            placeholder: placeholder,
            popperProps: t14,
            searchThreshold: -1,
            shouldCloseMenuOnTab: false,
            target: target,
            filterOption: filterOption
        });
        $[18] = canClearFilter;
        $[19] = currentSearchInput;
        $[20] = defaultIsOpen;
        $[21] = filterOption;
        $[22] = formatOptionLabel;
        $[23] = handleChange;
        $[24] = handleInputChange;
        $[25] = isLoading;
        $[26] = isSearchable;
        $[27] = label;
        $[28] = minMenuWidth;
        $[29] = onClearOptions;
        $[30] = onDropdownOpen;
        $[31] = options;
        $[32] = placeholder;
        $[33] = t11;
        $[34] = t12;
        $[35] = t13;
        $[36] = t8;
        $[37] = target;
        $[38] = t15;
    } else t15 = $[38];
    return t15;
} : ({ defaultIsOpen: defaultIsOpen = false, isSearchable: isSearchable = false, isLoading: isLoading = false, canClearFilter: canClearFilter = false, checkboxIndicators: checkboxIndicators = false, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, label: label, noOptionsMessage: noOptionsMessage, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, target: target, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, filterId: filterId, filterOption: filterOptionOverride })=>{
    const debounceTimeout = (0, $42omo.useRef)(null);
    // TODO: this can be removed if we have debounce in the store when lookup
    const [currentSearchInput, setCurrentSearchInput] = (0, $42omo.useState)(searchInput);
    // For now, the FilterPopupSelect component is only being used in Quick Find so the following
    // analytics hooks are valid. Please extract out the analytics events when we reuse this
    // component in FPS.
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const handleInputChange = (0, $42omo.useCallback)((value, action)=>{
        if (action.action !== 'input-change') return;
        setCurrentSearchInput(value);
        if (!onSearchInputChange) return;
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(()=>{
            onSearchInputChange(value);
        }, 300);
    }, [
        onSearchInputChange
    ]);
    const handleChange = (0, $42omo.useCallback)((value_0)=>{
        if (!(0, $1e26310d04240baa$export$4f9a317f0153844)(value_0)) throw new Error('Value should match the PopupSelectOption type');
        onSelectChange(value_0);
        // Omitting these attrtibutes as there is a race condition here since the filter attributes
        // have not yet been applied in the store so it will always be one update behind.
        const { productSelected: _productSelected, filters: _filters, filterSelections: _filterSelections, ...restAttributes } = commonAttributes;
        const selection = (Array.isArray(value_0) ? value_0 : [
            value_0
        ])[0];
        if (!selection) return; // This should never be executed
        fireAnalyticsEvent((0, $5eWut.onFilterSelection)({
            action: selection.isSelected ? 'unselected' : 'selected',
            location: 'inline',
            actionSubjectId: 'searchDialogFilter',
            attributes: {
                ...restAttributes,
                filterId: filterId
            }
        }));
    }, [
        commonAttributes,
        filterId,
        fireAnalyticsEvent,
        onSelectChange
    ]);
    // Disable react-select's default client-side filtering so server results (e.g. matched by
    // project key) are not incorrectly filtered out because their label doesn't match the input.
    // Consumers can override this by passing filterOption={null} to preserve client-side filtering
    const filterOption = filterOptionOverride !== undefined ? filterOptionOverride ?? undefined : isSearchable ? ()=>true : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
        blurInputOnSelect: false,
        canClearFilter: canClearFilter,
        closeMenuOnSelect: !checkboxIndicators,
        components: {
            Control: $k5mzm.Control,
            MenuList: isFiltersDiscoverability2Enabled ? (0, $ls6iZ.MenuListWithoutClearFilterOptionLabel) : (0, $ls6iZ.MenuListWithClearFilterOptionLabel),
            ...checkboxIndicators ? {
                Option: (0, $bbypI.CheckboxOption)
            } : {}
        },
        defaultIsOpen: defaultIsOpen,
        // @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
        defaultOptions: false,
        formatOptionLabel: formatOptionLabel,
        inputValue: currentSearchInput,
        isClearable: false,
        isLoading: isLoading,
        isOptionSelected: (option)=>option.isSelected,
        isSearchable: isSearchable,
        label: label,
        maxMenuHeight: 400,
        maxMenuWidth: "22rem",
        menuPlacement: "bottom",
        minMenuWidth: minMenuWidth,
        noOptionsMessage: currentSearchInput ? undefined : ()=>noOptionsMessage,
        onChange: handleChange,
        onClearOptions: onClearOptions,
        onInputChange: handleInputChange,
        onMenuClose: ()=>{
            setCurrentSearchInput('');
            onDropdownClose?.();
        },
        onMenuOpen: onDropdownOpen,
        options: options,
        placeholder: placeholder,
        popperProps: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ]
        },
        searchThreshold: -1,
        shouldCloseMenuOnTab: false,
        target: target,
        filterOption: filterOption
    });
};
function $40387639b8effd2d$var$_temp() {
    return true;
}
function $40387639b8effd2d$var$_temp2(option) {
    return option.isSelected;
}



var $5cssW = parcelRequire("5cssW");





var $lx1ar = parcelRequire("lx1ar");




const $76c9230653325278$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    assetsSchema: {
        id: "quick-find.filters.names.assets-schema",
        defaultMessage: "Schema"
    },
    assetsFilterAssetsSchemaPlaceholder: {
        id: "quick-find.assets.filter.assets-schema.placeholder",
        defaultMessage: "Find schemas"
    },
    assetsFilterLabelSelected: {
        id: "quick-find.assets.filter.assets-schema.label.selected",
        defaultMessage: "Selected"
    },
    assetsFilterLabelUnselected: {
        id: "quick-find.assets.filter.assets-schema.label.unselected",
        defaultMessage: "Suggested"
    },
    assetsIconLabel: {
        id: "quick-find.assets.filter.assets-schema.icon.label",
        defaultMessage: "Assets schema filter"
    }
});


const $709eb420c90c9056$export$6cac819feaba71a8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(46);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $lx1ar.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [filterData, t1] = (0, $5cssW.useSelectFilter)(t0);
    const { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t1;
    const AssetsIcon = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Assets).Icon;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, firstSelectedOptionLabel: firstSelectedOptionLabel, badgeLabel: badgeLabel } = filterData;
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsFilterLabelSelected);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== selectedOptions || $[4] !== t2) {
        t3 = {
            label: t2,
            options: selectedOptions
        };
        $[3] = selectedOptions;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsFilterLabelUnselected);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== suggestedOptions || $[9] !== t4) {
        t5 = {
            label: t4,
            options: suggestedOptions
        };
        $[8] = suggestedOptions;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = [
            t3,
            t5
        ];
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const groupedOptions = t6;
    let t7;
    if ($[14] !== AssetsIcon || $[15] !== formatMessage) {
        t7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AssetsIcon, {
                size: "xxsmall"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                label: formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsIconLabel),
                size: "small"
            }));
        $[14] = AssetsIcon;
        $[15] = formatMessage;
        $[16] = t7;
    } else t7 = $[16];
    const getIconBefore = t7;
    let t8;
    if ($[17] !== badgeLabel || $[18] !== selectedOptions.length) {
        t8 = ()=>selectedOptions.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                size: "small"
            }) : badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                appearance: "information"
            }, badgeLabel);
        $[17] = badgeLabel;
        $[18] = selectedOptions.length;
        $[19] = t8;
    } else t8 = $[19];
    const getIconAfter = t8;
    const t9 = isLookupActive ? options : groupedOptions;
    let t10;
    if ($[20] !== firstSelectedOptionLabel || $[21] !== formatMessage) {
        t10 = firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsSchema);
        $[20] = firstSelectedOptionLabel;
        $[21] = formatMessage;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== formatMessage) {
        t11 = formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsFilterAssetsSchemaPlaceholder);
        $[23] = formatMessage;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== firstSelectedOptionLabel || $[26] !== formatMessage || $[27] !== getIconAfter || $[28] !== getIconBefore || $[29] !== selectedOptions.length) {
        t12 = (t13)=>{
            const { isOpen: isOpen, ...targetProps } = t13;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter()
            }, firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsSchema));
        };
        $[25] = firstSelectedOptionLabel;
        $[26] = formatMessage;
        $[27] = getIconAfter;
        $[28] = getIconBefore;
        $[29] = selectedOptions.length;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== clearLookupInput || $[32] !== clearOptions || $[33] !== isFiltersDiscoverability2Enabled || $[34] !== isLoading || $[35] !== isLookupDefined || $[36] !== loadInitialOptions || $[37] !== lookupInput || $[38] !== selectedOptions || $[39] !== setLookupInput || $[40] !== setOption || $[41] !== t10 || $[42] !== t11 || $[43] !== t12 || $[44] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
            filterId: (0, $lx1ar.filter).id,
            canClearFilter: true,
            checkboxIndicators: true,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSearchInputChange: setLookupInput,
            onSelectChange: setOption,
            options: t9,
            selectedOptions: selectedOptions,
            label: t10,
            placeholder: t11,
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            onClearOptions: clearOptions,
            isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
            target: t12
        });
        $[31] = clearLookupInput;
        $[32] = clearOptions;
        $[33] = isFiltersDiscoverability2Enabled;
        $[34] = isLoading;
        $[35] = isLookupDefined;
        $[36] = loadInitialOptions;
        $[37] = lookupInput;
        $[38] = selectedOptions;
        $[39] = setLookupInput;
        $[40] = setOption;
        $[41] = t10;
        $[42] = t11;
        $[43] = t12;
        $[44] = t9;
        $[45] = t13;
    } else t13 = $[45];
    return t13;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $lx1ar.filter).id
    });
    const AssetsIcon = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Assets).Icon;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, firstSelectedOptionLabel: firstSelectedOptionLabel, badgeLabel: badgeLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const getIconBefore = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AssetsIcon, {
            size: "xxsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
            label: formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsIconLabel),
            size: "small"
        }));
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
            appearance: "information"
        }, badgeLabel);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        filterId: (0, $lx1ar.filter).id,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsSchema),
        placeholder: formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsFilterAssetsSchemaPlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: clearOptions,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter()
            }, firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $76c9230653325278$export$a7357cdd1f0b0168).assetsSchema))
    });
};
var $709eb420c90c9056$export$2e2bcd8739ae039 = $709eb420c90c9056$export$6cac819feaba71a8;





















var $eiXsV = parcelRequire("eiXsV");








var $gj7hi = parcelRequire("gj7hi");






var $eyWa4 = parcelRequire("eyWa4");
















var $iUihD = parcelRequire("iUihD");




const $166b563a8d1db87f$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    assetsType: {
        id: "quick-find.filters.names.assets-type",
        defaultMessage: "Object type"
    },
    assetsFilterAssetsTypePlaceholder: {
        id: "quick-find.assets.filter.assets-type.placeholder",
        defaultMessage: "Find object types"
    },
    assetsFilterLabelSelected: {
        id: "quick-find.assets.filter.assets-type.label.selected",
        defaultMessage: "Selected"
    },
    assetsFilterLabelUnselected: {
        id: "quick-find.assets.filter.assets-type.label.unselected",
        defaultMessage: "Suggested"
    },
    assetsIconLabel: {
        id: "quick-find.assets.filter.assets-type.icon.label",
        defaultMessage: "Object type filter"
    }
});


const $013d36e168fbd190$var$styles = {
    imageContainer: "_1bsb7vkz _4t3i7vkz"
};
const $013d36e168fbd190$export$d7168ecc5f9ccc6f = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(46);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            filterId: (0, $iUihD.filter).id
        };
        $[0] = t0;
    } else t0 = $[0];
    const [filterData, t1] = (0, $5cssW.useSelectFilter)(t0);
    const { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t1;
    const AssetsIcon = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Assets).Icon;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, firstSelectedOptionLabel: firstSelectedOptionLabel, badgeLabel: badgeLabel } = filterData;
    let t2;
    if ($[1] !== formatMessage) {
        t2 = formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsFilterLabelSelected);
        $[1] = formatMessage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== selectedOptions || $[4] !== t2) {
        t3 = {
            label: t2,
            options: selectedOptions
        };
        $[3] = selectedOptions;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsFilterLabelUnselected);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== suggestedOptions || $[9] !== t4) {
        t5 = {
            label: t4,
            options: suggestedOptions
        };
        $[8] = suggestedOptions;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = [
            t3,
            t5
        ];
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    const groupedOptions = t6;
    const formatOptionLabel = $013d36e168fbd190$var$_temp;
    let t7;
    if ($[14] !== AssetsIcon || $[15] !== formatMessage) {
        t7 = ()=>/*#__PURE__*/ $42omo.createElement((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), null, /*#__PURE__*/ $42omo.createElement(AssetsIcon, {
                size: "xxsmall"
            }), /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eiXsV))), {
                label: formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsIconLabel),
                size: "small"
            }));
        $[14] = AssetsIcon;
        $[15] = formatMessage;
        $[16] = t7;
    } else t7 = $[16];
    const getIconBefore = t7;
    let t8;
    if ($[17] !== badgeLabel || $[18] !== selectedOptions.length) {
        t8 = ()=>selectedOptions.length === 0 ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                size: "small"
            }) : badgeLabel && /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), {
                appearance: "information"
            }, badgeLabel);
        $[17] = badgeLabel;
        $[18] = selectedOptions.length;
        $[19] = t8;
    } else t8 = $[19];
    const getIconAfter = t8;
    const t9 = isLookupActive ? options : groupedOptions;
    let t10;
    if ($[20] !== firstSelectedOptionLabel || $[21] !== formatMessage) {
        t10 = firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsType);
        $[20] = firstSelectedOptionLabel;
        $[21] = formatMessage;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== formatMessage) {
        t11 = formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsFilterAssetsTypePlaceholder);
        $[23] = formatMessage;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== firstSelectedOptionLabel || $[26] !== formatMessage || $[27] !== getIconAfter || $[28] !== getIconBefore || $[29] !== selectedOptions.length) {
        t12 = (t13)=>{
            const { isOpen: isOpen, ...targetProps } = t13;
            return /*#__PURE__*/ $42omo.createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter()
            }, firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsType));
        };
        $[25] = firstSelectedOptionLabel;
        $[26] = formatMessage;
        $[27] = getIconAfter;
        $[28] = getIconBefore;
        $[29] = selectedOptions.length;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== clearLookupInput || $[32] !== clearOptions || $[33] !== isFiltersDiscoverability2Enabled || $[34] !== isLoading || $[35] !== isLookupDefined || $[36] !== loadInitialOptions || $[37] !== lookupInput || $[38] !== selectedOptions || $[39] !== setLookupInput || $[40] !== setOption || $[41] !== t10 || $[42] !== t11 || $[43] !== t12 || $[44] !== t9) {
        t13 = /*#__PURE__*/ $42omo.createElement((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
            filterId: (0, $iUihD.filter).id,
            canClearFilter: true,
            checkboxIndicators: true,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSearchInputChange: setLookupInput,
            onSelectChange: setOption,
            options: t9,
            selectedOptions: selectedOptions,
            label: t10,
            placeholder: t11,
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            onClearOptions: clearOptions,
            formatOptionLabel: formatOptionLabel,
            isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
            target: t12
        });
        $[31] = clearLookupInput;
        $[32] = clearOptions;
        $[33] = isFiltersDiscoverability2Enabled;
        $[34] = isLoading;
        $[35] = isLookupDefined;
        $[36] = loadInitialOptions;
        $[37] = lookupInput;
        $[38] = selectedOptions;
        $[39] = setLookupInput;
        $[40] = setOption;
        $[41] = t10;
        $[42] = t11;
        $[43] = t12;
        $[44] = t9;
        $[45] = t13;
    } else t13 = $[45];
    return t13;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $iUihD.filter).id
    });
    const AssetsIcon = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Assets).Icon;
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, firstSelectedOptionLabel: firstSelectedOptionLabel, badgeLabel: badgeLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const formatOptionLabel = (data)=>{
        return /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), null, /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
            src: data.avatarUrl,
            alt: data.label,
            className: (0, $gMc0m.default)([
                $013d36e168fbd190$var$styles.imageContainer
            ])
        })), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
            space: "space.025"
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, data.label), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
            label: "",
            size: "small",
            color: "var(--ds-text-subtlest)"
        }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, data.metadata.schemaName))));
    };
    const getIconBefore = ()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), null, /*#__PURE__*/ $42omo.createElement(AssetsIcon, {
            size: "xxsmall"
        }), /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eiXsV))), {
            label: formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsIconLabel),
            size: "small"
        }));
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), {
            appearance: "information"
        }, badgeLabel);
    };
    return /*#__PURE__*/ $42omo.createElement((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        filterId: (0, $iUihD.filter).id,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsType),
        placeholder: formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsFilterAssetsTypePlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: clearOptions,
        formatOptionLabel: formatOptionLabel,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ $42omo.createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter()
            }, firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $166b563a8d1db87f$export$a7357cdd1f0b0168).assetsType))
    });
};
var $013d36e168fbd190$export$2e2bcd8739ae039 = $013d36e168fbd190$export$d7168ecc5f9ccc6f;
function $013d36e168fbd190$var$_temp(data) {
    return /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), null, /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
        src: data.avatarUrl,
        alt: data.label,
        className: (0, $gMc0m.default)([
            $013d36e168fbd190$var$styles.imageContainer
        ])
    })), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.025"
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, data.label), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
        label: "",
        size: "small",
        color: "var(--ds-text-subtlest)"
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, data.metadata.schemaName))));
}



var $fJ1R6 = parcelRequire("fJ1R6");




const $db27a10ae551c873$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    filterByIcon: {
        id: "quick-find-filters.filter-by-icon-label",
        defaultMessage: "Filter by Icon"
    },
    moreButtonTooltip: {
        id: "inline-product-filters.more-filters.tooltip",
        defaultMessage: "Open a full page search with more filter options for {product}"
    },
    clearFilters: {
        id: "quick-find.filters.clear-filters-button-label",
        defaultMessage: "Clear filters"
    }
});



var $lwHnO = parcelRequire("lwHnO");


var $fSUtG = parcelRequire("fSUtG");

const $f4dec8f243f8bf8c$var$newInlineProductFilterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    minWidth: '0',
    // Prevents the filter buttons from overflowing from its container and allow it to shrink as much as possible
    width: '100%',
    overflow: 'hidden'
});
const $f4dec8f243f8bf8c$var$dynamicInlineFilters = (0, $ecnYn.xcss)({
    flex: 1,
    minWidth: '0',
    overflow: 'hidden',
    gap: 'space.100'
});
const $f4dec8f243f8bf8c$var$appSelectorDividerStyles = (0, $ecnYn.xcss)({
    borderWidth: 'border.width',
    borderColor: 'color.border',
    borderRightStyle: 'solid',
    marginBlock: 'space.025'
});
const $f4dec8f243f8bf8c$var$invisibleStyles = (0, $ecnYn.xcss)({
    visibility: 'hidden'
});
const $f4dec8f243f8bf8c$var$prioritisedFilters = {
    [(0, $6Gsan.PrimaryProductKeys).Confluence]: [
        (0, $ehGUC.spaceFilter).id,
        (0, $ehGUC.contributorFilter).id
    ],
    [(0, $6Gsan.PrimaryProductKeys).Jira]: [
        (0, $ehGUC.projectFilter).id,
        (0, $ehGUC.assigneeFilter).id
    ],
    // Not supported
    [(0, $6Gsan.PrimaryProductKeys).Atlas]: [],
    [(0, $6Gsan.PrimaryProductKeys).Focus]: [],
    [(0, $6Gsan.PrimaryProductKeys).Assets]: [
        (0, $ehGUC.assetsSchemaFilter).id,
        (0, $ehGUC.assetsTypeFilter).id
    ],
    [(0, $6Gsan.PrimaryProductKeys).Elevate]: [],
    [(0, $6Gsan.PrimaryProductKeys).Talent]: [],
    [(0, $6Gsan.PrimaryProductKeys).RovoExtension]: []
};
const $f4dec8f243f8bf8c$var$QUICK_FIND_EXCLUDED_FILTER_IDS = [
    (0, $ehGUC.commentedByMeFilter).id,
    (0, $ehGUC.watchedFilter).id,
    (0, $ehGUC.hasAttachmentFilter).id
];
const $f4dec8f243f8bf8c$var$ClearAllButton = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { onClear: onClear } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $db27a10ae551c873$export$a7357cdd1f0b0168).clearFilters);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onClear || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            id: "clear-all-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: onClear,
            appearance: "subtle"
        }, t2));
        $[4] = onClear;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        id: "clear-all-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: onClear,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage((0, $db27a10ae551c873$export$a7357cdd1f0b0168).clearFilters))));
};
const $f4dec8f243f8bf8c$var$VisibleFilterWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $frIzR.c)(5);
    const { id: id, visibleFilters: visibleFilters, children: children } = t0;
    const elementId = `reference:${id}`;
    const isVisible = visibleFilters.includes(id);
    const t1 = isVisible ? undefined : $f4dec8f243f8bf8c$var$invisibleStyles;
    let t2;
    if ($[0] !== children || $[1] !== elementId || $[2] !== ref || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            id: elementId,
            ref: ref,
            xcss: t1
        }, children);
        $[0] = children;
        $[1] = elementId;
        $[2] = ref;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ id: id, visibleFilters: visibleFilters, children: children }, ref)=>{
    const elementId = `reference:${id}`;
    const isVisible = visibleFilters.includes(id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        id: elementId,
        ref: ref,
        xcss: isVisible ? undefined : $f4dec8f243f8bf8c$var$invisibleStyles
    }, children);
});
const $f4dec8f243f8bf8c$export$b1ad550c251413b4 = ({ onAllFiltersClickCallback: onAllFiltersClickCallback })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)();
    const filtersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const { clearAllFilters: clearAllFilters, resetSort: resetSort } = (0, $djVCD.useSearchActions)();
    const [{ filtersInLine: filtersInLine }] = (0, $djVCD.useFiltersToDisplay)({
        basedOnPrimaryProduct: true,
        primaryProduct: primaryProduct,
        prioritisedFilterIds: primaryProduct ? $f4dec8f243f8bf8c$var$prioritisedFilters[primaryProduct] : []
    });
    const filtersToRender = (0, $42omo.useMemo)(()=>filtersInLine.filter((f)=>!$f4dec8f243f8bf8c$var$QUICK_FIND_EXCLUDED_FILTER_IDS.includes(f)).slice(0, 2), // Only show 2 filters at a time
    [
        filtersInLine
    ]);
    const filterRefs = (0, $42omo.useRef)([]);
    const containerRef = (0, $42omo.useRef)();
    filterRefs.current = filtersToRender.filter((id)=>(0, $kRxMN.filters)[id]).map((_, i)=>filterRefs.current[i] ?? /*#__PURE__*/ (0, $42omo.createRef)());
    const visibleFilters = (0, $gCEkV.useOverflowObserver)({
        containerRef: containerRef,
        itemRefs: filterRefs,
        itemIds: filtersToRender
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { onFilterChange: onFilterChange, onDropdownOpenChange: onDropdownOpenChange, onFilterClearAction: onFilterClearAction } = (0, $fSUtG.useFilterAnalytics)(fireAnalyticsEvent, commonAttributes, (0, $9rRKJ.SearchExperience).QUICK_FIND);
    (0, $lwHnO.useUnselectProductFilter)({
        isEnabled: false
    });
    /**
   * Defines inline product filters to show for each primary product. Given that
   * the filters we decide to show are determined by product and design, there
   * isn't a need to make this dynamic yet.
   */ const inlineProductFilters = (0, $42omo.useMemo)(()=>{
        // rovo-extension uses Confluence's config since it's not a searchable product
        const productConfigKey = primaryProduct === (0, $6Gsan.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension') ? (0, $1yEFx.ProductKeys).Confluence : primaryProduct;
        const primaryProductDisplayName = productConfigs[productConfigKey]?.displayName ?? '';
        const moreFiltersButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
            onClick: (event)=>{
                onAllFiltersClickCallback?.({
                    ...filtersDiscoverability2Enabled && {
                        filterDropdownOpen: true
                    },
                    action: 'filterByPrimaryProduct',
                    event: event
                });
            },
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
                label: formatMessage((0, $db27a10ae551c873$export$a7357cdd1f0b0168).filterByIcon)
            }),
            noBorder: true,
            tooltip: formatMessage((0, $db27a10ae551c873$export$a7357cdd1f0b0168).moreButtonTooltip, {
                product: primaryProductDisplayName
            }),
            testId: "quick-find-inline-product-filters-more-filters-button"
        });
        if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence || primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira || primaryProduct === (0, $6Gsan.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $f4dec8f243f8bf8c$var$newInlineProductFilterStyles,
            testId: "qf-product-filters"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGrYY.default), {
            hideOnHoverOut: primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('search_qf_close_dropdown_on_hover_off'),
            experience: (0, $9rRKJ.SearchExperience).QUICK_FIND,
            onFiltersChange: onFilterChange,
            onDropdownOpenChange: onDropdownOpenChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fJ1R6.AppSelector), {
            fit: "compact"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $f4dec8f243f8bf8c$var$appSelectorDividerStyles,
                // Do not show the divider if there is no inline filters or clear button
                visibleFilters.length === 0 ? $f4dec8f243f8bf8c$var$invisibleStyles : undefined
            ]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $f4dec8f243f8bf8c$var$dynamicInlineFilters,
            ref: containerRef
        }, filtersToRender.map((id_0, index)=>{
            const Filter = (0, $kRxMN.filters)[id_0];
            if (!Filter) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f4dec8f243f8bf8c$var$VisibleFilterWrapper, {
                id: id_0,
                ref: filterRefs.current[index],
                visibleFilters: visibleFilters,
                key: id_0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
                showPrimaryProductIcon: !selectedProduct,
                fit: "compact",
                hideOnHoverOut: primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('search_qf_close_dropdown_on_hover_off'),
                onFilterChange: (change)=>onFilterChange(id_0, change, 'inline')
            }));
        })), isAnyFilterSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f4dec8f243f8bf8c$var$ClearAllButton, {
            onClear: ()=>{
                clearAllFilters();
                resetSort();
                onFilterClearAction('inline');
            }
        }));
        else if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Assets && (0, $dh538.fg)('assets_rovo_search_all')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $f4dec8f243f8bf8c$var$newInlineProductFilterStyles,
            testId: "qf-product-filters"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $709eb420c90c9056$export$6cac819feaba71a8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $013d36e168fbd190$export$d7168ecc5f9ccc6f), null), moreFiltersButton);
        else return null;
    }, [
        clearAllFilters,
        filtersDiscoverability2Enabled,
        filtersToRender,
        formatMessage,
        isAnyFilterSelected,
        onAllFiltersClickCallback,
        onDropdownOpenChange,
        onFilterChange,
        onFilterClearAction,
        primaryProduct,
        productConfigs,
        resetSort,
        selectedProduct,
        visibleFilters
    ]);
    if ((0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct)) return inlineProductFilters;
    if (selectedProduct) return null;
    return null;
};





const $77e9ec5198e0dc0e$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    filterByIcon: {
        id: "quick-find-filters.filter-by-icon-label",
        defaultMessage: "Filter by Icon"
    }
});


const $b21d47feb05d9034$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingInline: 'space.200',
    paddingBlockStart: 'space.025',
    paddingBlockEnd: 'space.075',
    width: '100%'
});
const $b21d47feb05d9034$var$containerSpaceBetweenStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});
const $b21d47feb05d9034$var$filterDropdownIconStyles = (0, $ecnYn.xcss)({
    padding: 'space.050',
    marginInlineEnd: 'space.100'
});
const $b21d47feb05d9034$export$cc5615a202a2ea8c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(26);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const dialogWidth = (0, $86ob4.useElementWidth)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID));
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const filtersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const isDialogAbove275px = dialogWidth > 275;
    const displayCustomizeIcon = isDialogAbove275px || !selectedProduct;
    let t0;
    if ($[0] !== clearAllFilters || $[1] !== commonAttributes || $[2] !== filtersDiscoverability2Enabled || $[3] !== fireAnalyticsEvent || $[4] !== generateSearchUrl || $[5] !== nonPrivacySafeAttributes || $[6] !== onNavigate || $[7] !== primaryProduct || $[8] !== queryParams || $[9] !== quickFindQuery || $[10] !== setQuickFindOpen) {
        t0 = (t1)=>{
            const { action: t2, filterDropdownOpen: t3, event: event } = t1;
            const action = t2 === undefined ? "none" : t2;
            const filterDropdownOpen = t3 === undefined ? false : t3;
            setQuickFindOpen(false);
            fireAnalyticsEvent((0, $b7cdee9969fa612b$export$59708e770734a297)({
                actionSubjectId: "more-product-filters",
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            clearAllFilters();
            let newQueryParams = {};
            if (action === "searchByAllApps") newQueryParams = {};
            else {
                if (action === "none") newQueryParams = queryParams;
                else if (action === "filterByPrimaryProduct") newQueryParams = {
                    ...queryParams,
                    product: primaryProduct
                };
            }
            const onNavigateCallback = typeof onNavigate === "function" ? onNavigate : onNavigate.callback;
            onNavigateCallback(generateSearchUrl({
                ...newQueryParams,
                ...filtersDiscoverability2Enabled ? {
                    filterDropdownOpen: filterDropdownOpen
                } : {},
                text: quickFindQuery
            }), "push", event);
        };
        $[0] = clearAllFilters;
        $[1] = commonAttributes;
        $[2] = filtersDiscoverability2Enabled;
        $[3] = fireAnalyticsEvent;
        $[4] = generateSearchUrl;
        $[5] = nonPrivacySafeAttributes;
        $[6] = onNavigate;
        $[7] = primaryProduct;
        $[8] = queryParams;
        $[9] = quickFindQuery;
        $[10] = setQuickFindOpen;
        $[11] = t0;
    } else t0 = $[11];
    const onAllFiltersClickCallback = t0;
    if (!(0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct)) {
        let t1;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = [
                $b21d47feb05d9034$var$containerStyles,
                $b21d47feb05d9034$var$containerSpaceBetweenStyles
            ];
            $[12] = t1;
        } else t1 = $[12];
        let t2;
        if ($[13] !== displayCustomizeIcon || $[14] !== formatMessage) {
            t2 = displayCustomizeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b21d47feb05d9034$var$filterDropdownIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
                label: formatMessage((0, $77e9ec5198e0dc0e$export$a7357cdd1f0b0168).filterByIcon)
            }));
            $[13] = displayCustomizeIcon;
            $[14] = formatMessage;
            $[15] = t2;
        } else t2 = $[15];
        let t3;
        let t4;
        if ($[16] !== onAllFiltersClickCallback) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1138a05237425a8$export$863a72861bb447a2), {
                onAllFiltersClickCallback: onAllFiltersClickCallback
            });
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4dec8f243f8bf8c$export$b1ad550c251413b4), {
                onAllFiltersClickCallback: onAllFiltersClickCallback
            });
            $[16] = onAllFiltersClickCallback;
            $[17] = t3;
            $[18] = t4;
        } else {
            t3 = $[17];
            t4 = $[18];
        }
        let t5;
        if ($[19] !== t2 || $[20] !== t3 || $[21] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: t1
            }, t2, t3, t4);
            $[19] = t2;
            $[20] = t3;
            $[21] = t4;
            $[22] = t5;
        } else t5 = $[22];
        return t5;
    }
    let t1;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            $b21d47feb05d9034$var$containerStyles,
            $b21d47feb05d9034$var$containerSpaceBetweenStyles
        ];
        $[23] = t1;
    } else t1 = $[23];
    let t2;
    if ($[24] !== onAllFiltersClickCallback) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4dec8f243f8bf8c$export$b1ad550c251413b4), {
            onAllFiltersClickCallback: onAllFiltersClickCallback
        }));
        $[24] = onAllFiltersClickCallback;
        $[25] = t2;
    } else t2 = $[25];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const dialogWidth = (0, $86ob4.useElementWidth)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID));
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const filtersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const isDialogAbove275px = dialogWidth > 275;
    const displayCustomizeIcon = isDialogAbove275px || !selectedProduct;
    const onAllFiltersClickCallback = (0, $42omo.useCallback)(({ action: action = 'none', filterDropdownOpen: filterDropdownOpen = false, event: event })=>{
        setQuickFindOpen(false);
        fireAnalyticsEvent((0, $b7cdee9969fa612b$export$59708e770734a297)({
            actionSubjectId: 'more-product-filters',
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        // TODO: This is a temporary measure until we do QS-6716 post Team 25 where it syncs filters with FPS.
        // For now, executing a search query on FPS search will always clear the filters in QF as FPS filters
        // is the source of truth for filter state.
        clearAllFilters();
        let newQueryParams = {};
        if (action === 'searchByAllApps') newQueryParams = {};
        else if (action === 'none') newQueryParams = queryParams;
        else if (action === 'filterByPrimaryProduct') newQueryParams = {
            ...queryParams,
            product: primaryProduct
        };
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...newQueryParams,
            ...filtersDiscoverability2Enabled ? {
                filterDropdownOpen: filterDropdownOpen
            } : {},
            text: quickFindQuery
        }), 'push', event);
    }, [
        clearAllFilters,
        commonAttributes,
        fireAnalyticsEvent,
        generateSearchUrl,
        nonPrivacySafeAttributes,
        onNavigate,
        primaryProduct,
        queryParams,
        quickFindQuery,
        setQuickFindOpen,
        filtersDiscoverability2Enabled
    ]);
    if (!(0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $b21d47feb05d9034$var$containerStyles,
            $b21d47feb05d9034$var$containerSpaceBetweenStyles
        ]
    }, displayCustomizeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b21d47feb05d9034$var$filterDropdownIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
        label: formatMessage((0, $77e9ec5198e0dc0e$export$a7357cdd1f0b0168).filterByIcon)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1138a05237425a8$export$863a72861bb447a2), {
        onAllFiltersClickCallback: onAllFiltersClickCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4dec8f243f8bf8c$export$b1ad550c251413b4), {
        onAllFiltersClickCallback: onAllFiltersClickCallback
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $b21d47feb05d9034$var$containerStyles,
            $b21d47feb05d9034$var$containerSpaceBetweenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4dec8f243f8bf8c$export$b1ad550c251413b4), {
        onAllFiltersClickCallback: onAllFiltersClickCallback
    }));
};















var $4ymXE = parcelRequire("4ymXE");


var $4ymSL = parcelRequire("4ymSL");












var $bAgd8 = parcelRequire("bAgd8");





























const $8a3a981dac797ffb$export$d316b4624d0181e6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "16",
            height: "16",
            rx: "4",
            fill: "#1868DB"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_411_4616)"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip1_411_4616)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M11.5797 9.51003C9.1108 8.31624 8.38955 8.13786 7.34929 8.13786C6.12871 8.13786 5.08845 8.64556 4.15915 10.0726L4.00658 10.3059C3.88174 10.498 3.854 10.5666 3.854 10.6489C3.854 10.7313 3.89561 10.7999 4.04819 10.8959L5.61552 11.8702C5.69874 11.9251 5.76809 11.9525 5.83744 11.9525C5.92066 11.9525 5.97614 11.9113 6.05936 11.7878L6.30903 11.4036C6.69739 10.8136 7.04415 10.6215 7.48799 10.6215C7.87636 10.6215 8.33407 10.7313 8.90275 11.0057L10.5394 11.7741C10.7059 11.8564 10.8862 11.8153 10.9694 11.6232L11.7461 9.92168C11.8294 9.72958 11.7739 9.60608 11.5797 9.51003ZM4.38107 6.50497C6.84996 7.69876 7.57121 7.87714 8.61148 7.87714C9.83205 7.87714 10.8723 7.36944 11.8016 5.94238L11.9542 5.70911C12.079 5.517 12.1068 5.4484 12.1068 5.36607C12.1068 5.28373 12.0652 5.21513 11.9126 5.11907L10.3452 4.14483C10.262 4.08994 10.1927 4.0625 10.1233 4.0625C10.0401 4.0625 9.98462 4.10367 9.9014 4.22716L9.65174 4.61137C9.26338 5.2014 8.91662 5.39351 8.47277 5.39351C8.08441 5.39351 7.62669 5.28373 7.05802 5.0093L5.42133 4.24088C5.25489 4.15855 5.07458 4.19972 4.99136 4.39182L4.21463 6.09332C4.13141 6.28542 4.18689 6.40892 4.38107 6.50497Z",
            fill: "white"
        })));
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M18 4C18 1.79086 19.7909 0 22 0H30C32.2091 0 34 1.79086 34 4V12C34 14.2091 32.2091 16 30 16H22C19.7909 16 18 14.2091 18 12V4Z",
            fill: "#292A2E"
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.9996 3.00003C23.2385 3.00003 20.9995 5.29523 20.9995 8.12662C20.9995 10.3917 22.4322 12.3133 24.4188 12.9912C24.6687 13.0387 24.7605 12.88 24.7605 12.7446C24.7605 12.6224 24.7558 12.2185 24.7537 11.7901C23.3627 12.1003 23.0691 11.1853 23.0691 11.1853C22.8417 10.5927 22.514 10.4351 22.514 10.4351C22.0603 10.117 22.5482 10.1235 22.5482 10.1235C23.0503 10.1597 23.3146 10.6518 23.3146 10.6518C23.7606 11.4355 24.4843 11.209 24.7697 11.078C24.8145 10.7466 24.9441 10.5205 25.0871 10.3924C23.9765 10.2628 22.8091 9.82323 22.8091 7.85886C22.8091 7.29915 23.0044 6.84183 23.3242 6.48281C23.2723 6.35369 23.1012 5.83227 23.3727 5.12612C23.3727 5.12612 23.7926 4.98834 24.7481 5.65161C25.1469 5.53803 25.5746 5.48106 25.9996 5.47911C26.4245 5.48106 26.8525 5.53803 27.2521 5.65161C28.2065 4.98834 28.6258 5.12612 28.6258 5.12612C28.8979 5.83227 28.7267 6.35369 28.6748 6.48281C28.9954 6.84183 29.1894 7.29915 29.1894 7.85886C29.1894 9.8279 28.0197 10.2614 26.9063 10.3884C27.0856 10.5475 27.2454 10.8594 27.2454 11.3377C27.2454 12.0237 27.2396 12.5757 27.2396 12.7446C27.2396 12.881 27.3296 13.0409 27.5831 12.9905C29.5687 12.3119 30.9995 10.3909 30.9995 8.12662C30.9995 5.29523 28.7609 3.00003 25.9996 3.00003Z",
            fill: "white"
        });
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else {
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    let t5;
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
            id: "path-5-inside-1_411_4616",
            fill: "white"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z"
        }));
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z",
            fill: "white"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M40 0V1H48V0V-1H40V0ZM52 4H51V12H52H53V4H52ZM48 16V15H40V16V17H48V16ZM36 12H37V4H36H35V12H36ZM40 16V15C38.3431 15 37 13.6569 37 12H36H35C35 14.7614 37.2386 17 40 17V16ZM52 12H51C51 13.6569 49.6569 15 48 15V16V17C50.7614 17 53 14.7614 53 12H52ZM48 0V1C49.6569 1 51 2.34315 51 4H52H53C53 1.23858 50.7614 -1 48 -1V0ZM40 0V-1C37.2386 -1 35 1.23858 35 4H36H37C37 2.34315 38.3431 1 40 1V0Z",
            fill: "#0B1228",
            fillOpacity: "0.14",
            mask: "url(#path-5-inside-1_411_4616)"
        });
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else {
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
    }
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip2_411_4616)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M39.4724 11.3855L39.9428 12.1939C40.0406 12.3641 40.1811 12.4978 40.346 12.595L42.0261 9.70197H38.666C38.666 9.89038 38.7149 10.0788 38.8126 10.249L39.4724 11.3855Z",
            fill: "#0066DA"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M43.9993 6.29837L42.3193 3.4053C42.1544 3.50255 42.0139 3.63626 41.9161 3.80644L38.8126 9.15497C38.7167 9.32148 38.6661 9.51005 38.666 9.70198H42.0261L43.9993 6.29837Z",
            fill: "#00AC47"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M47.6534 12.595C47.8184 12.4978 47.9589 12.3641 48.0566 12.1939L48.2521 11.8596L49.1868 10.249C49.2846 10.0788 49.3335 9.89038 49.3335 9.70197H45.9731L46.6882 11.0999L47.6534 12.595Z",
            fill: "#EA4335"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M43.9999 6.29846L45.6799 3.40539C45.5149 3.30814 45.3256 3.25952 45.1301 3.25952H42.8697C42.6742 3.25952 42.4848 3.31422 42.3198 3.40539L43.9999 6.29846Z",
            fill: "#00832D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M45.9723 9.70197H42.0257L40.3457 12.595C40.5107 12.6923 40.7 12.7409 40.8955 12.7409H47.1025C47.298 12.7409 47.4874 12.6862 47.6523 12.595L45.9723 9.70197Z",
            fill: "#2684FC"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M47.635 6.48071L46.0832 3.80644C45.9855 3.63626 45.845 3.50255 45.68 3.4053L44 6.29837L45.9733 9.70198H49.3272C49.3272 9.51357 49.2784 9.32515 49.1806 9.15497L47.635 6.48071Z",
            fill: "#FFBA00"
        }));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_411_4616"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "16",
            height: "16",
            fill: "white"
        }));
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip1_411_4616"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "8.25276",
            height: "7.89",
            fill: "white",
            transform: "translate(3.854 4.0625)"
        }));
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "52",
            height: "16",
            viewBox: "0 0 52 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t1, t2, t3, t4, t5, t6, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t8, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip2_411_4616"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "10",
            height: "10",
            fill: "white",
            transform: "translate(39 3)"
        }))));
        $[10] = t10;
    } else t10 = $[10];
    return t10;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "52",
        height: "16",
        viewBox: "0 0 52 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_411_4616)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        rx: "4",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_411_4616)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.5797 9.51003C9.1108 8.31624 8.38955 8.13786 7.34929 8.13786C6.12871 8.13786 5.08845 8.64556 4.15915 10.0726L4.00658 10.3059C3.88174 10.498 3.854 10.5666 3.854 10.6489C3.854 10.7313 3.89561 10.7999 4.04819 10.8959L5.61552 11.8702C5.69874 11.9251 5.76809 11.9525 5.83744 11.9525C5.92066 11.9525 5.97614 11.9113 6.05936 11.7878L6.30903 11.4036C6.69739 10.8136 7.04415 10.6215 7.48799 10.6215C7.87636 10.6215 8.33407 10.7313 8.90275 11.0057L10.5394 11.7741C10.7059 11.8564 10.8862 11.8153 10.9694 11.6232L11.7461 9.92168C11.8294 9.72958 11.7739 9.60608 11.5797 9.51003ZM4.38107 6.50497C6.84996 7.69876 7.57121 7.87714 8.61148 7.87714C9.83205 7.87714 10.8723 7.36944 11.8016 5.94238L11.9542 5.70911C12.079 5.517 12.1068 5.4484 12.1068 5.36607C12.1068 5.28373 12.0652 5.21513 11.9126 5.11907L10.3452 4.14483C10.262 4.08994 10.1927 4.0625 10.1233 4.0625C10.0401 4.0625 9.98462 4.10367 9.9014 4.22716L9.65174 4.61137C9.26338 5.2014 8.91662 5.39351 8.47277 5.39351C8.08441 5.39351 7.62669 5.28373 7.05802 5.0093L5.42133 4.24088C5.25489 4.15855 5.07458 4.19972 4.99136 4.39182L4.21463 6.09332C4.13141 6.28542 4.18689 6.40892 4.38107 6.50497Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18 4C18 1.79086 19.7909 0 22 0H30C32.2091 0 34 1.79086 34 4V12C34 14.2091 32.2091 16 30 16H22C19.7909 16 18 14.2091 18 12V4Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.9996 3.00003C23.2385 3.00003 20.9995 5.29523 20.9995 8.12662C20.9995 10.3917 22.4322 12.3133 24.4188 12.9912C24.6687 13.0387 24.7605 12.88 24.7605 12.7446C24.7605 12.6224 24.7558 12.2185 24.7537 11.7901C23.3627 12.1003 23.0691 11.1853 23.0691 11.1853C22.8417 10.5927 22.514 10.4351 22.514 10.4351C22.0603 10.117 22.5482 10.1235 22.5482 10.1235C23.0503 10.1597 23.3146 10.6518 23.3146 10.6518C23.7606 11.4355 24.4843 11.209 24.7697 11.078C24.8145 10.7466 24.9441 10.5205 25.0871 10.3924C23.9765 10.2628 22.8091 9.82323 22.8091 7.85886C22.8091 7.29915 23.0044 6.84183 23.3242 6.48281C23.2723 6.35369 23.1012 5.83227 23.3727 5.12612C23.3727 5.12612 23.7926 4.98834 24.7481 5.65161C25.1469 5.53803 25.5746 5.48106 25.9996 5.47911C26.4245 5.48106 26.8525 5.53803 27.2521 5.65161C28.2065 4.98834 28.6258 5.12612 28.6258 5.12612C28.8979 5.83227 28.7267 6.35369 28.6748 6.48281C28.9954 6.84183 29.1894 7.29915 29.1894 7.85886C29.1894 9.8279 28.0197 10.2614 26.9063 10.3884C27.0856 10.5475 27.2454 10.8594 27.2454 11.3377C27.2454 12.0237 27.2396 12.5757 27.2396 12.7446C27.2396 12.881 27.3296 13.0409 27.5831 12.9905C29.5687 12.3119 30.9995 10.3909 30.9995 8.12662C30.9995 5.29523 28.7609 3.00003 25.9996 3.00003Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "path-5-inside-1_411_4616",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M40 0V1H48V0V-1H40V0ZM52 4H51V12H52H53V4H52ZM48 16V15H40V16V17H48V16ZM36 12H37V4H36H35V12H36ZM40 16V15C38.3431 15 37 13.6569 37 12H36H35C35 14.7614 37.2386 17 40 17V16ZM52 12H51C51 13.6569 49.6569 15 48 15V16V17C50.7614 17 53 14.7614 53 12H52ZM48 0V1C49.6569 1 51 2.34315 51 4H52H53C53 1.23858 50.7614 -1 48 -1V0ZM40 0V-1C37.2386 -1 35 1.23858 35 4H36H37C37 2.34315 38.3431 1 40 1V0Z",
        fill: "#0B1228",
        fillOpacity: "0.14",
        mask: "url(#path-5-inside-1_411_4616)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_411_4616)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M39.4724 11.3855L39.9428 12.1939C40.0406 12.3641 40.1811 12.4978 40.346 12.595L42.0261 9.70197H38.666C38.666 9.89038 38.7149 10.0788 38.8126 10.249L39.4724 11.3855Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M43.9993 6.29837L42.3193 3.4053C42.1544 3.50255 42.0139 3.63626 41.9161 3.80644L38.8126 9.15497C38.7167 9.32148 38.6661 9.51005 38.666 9.70198H42.0261L43.9993 6.29837Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.6534 12.595C47.8184 12.4978 47.9589 12.3641 48.0566 12.1939L48.2521 11.8596L49.1868 10.249C49.2846 10.0788 49.3335 9.89038 49.3335 9.70197H45.9731L46.6882 11.0999L47.6534 12.595Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M43.9999 6.29846L45.6799 3.40539C45.5149 3.30814 45.3256 3.25952 45.1301 3.25952H42.8697C42.6742 3.25952 42.4848 3.31422 42.3198 3.40539L43.9999 6.29846Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M45.9723 9.70197H42.0257L40.3457 12.595C40.5107 12.6923 40.7 12.7409 40.8955 12.7409H47.1025C47.298 12.7409 47.4874 12.6862 47.6523 12.595L45.9723 9.70197Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.635 6.48071L46.0832 3.80644C45.9855 3.63626 45.845 3.50255 45.68 3.4053L44 6.29837L45.9733 9.70198H49.3272C49.3272 9.51357 49.2784 9.32515 49.1806 9.15497L47.635 6.48071Z",
        fill: "#FFBA00"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_411_4616"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_411_4616"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(3.854 4.0625)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_411_4616"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "10",
        height: "10",
        fill: "white",
        transform: "translate(39 3)"
    }))));





const $18556631decfdfd2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    more: {
        id: "search.common.icons.all-apps.more",
        defaultMessage: "+ more"
    },
    moreWithCount: {
        id: "search.common.icons.all-apps.more-with-count",
        defaultMessage: "+{appCount}"
    }
});


const $1aa88845bd0865d7$var$styles = {
    moreButtonStyles: "_2rko12b0 _4cvr1h6o _bfhki8nm _1e0c1txw _18u01b66 _19bv1b66 _u5f31b66"
};
const $1aa88845bd0865d7$export$a9ec35d044cf4cf = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { appCount: appCount, icon: icon } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== appCount || $[1] !== formatMessage) {
        t1 = appCount !== undefined && appCount > 0 ? formatMessage((0, $18556631decfdfd2$export$defe85febe8b728c).moreWithCount, {
            appCount: appCount
        }) : formatMessage((0, $18556631decfdfd2$export$defe85febe8b728c).more);
        $[0] = appCount;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    const label = t1;
    let t2;
    if ($[3] !== icon) {
        t2 = icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a3a981dac797ffb$export$d316b4624d0181e6), null);
        $[3] = icon;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== label) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $1aa88845bd0865d7$var$styles.moreButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            align: "center",
            color: "color.text.subtle"
        }, label));
        $[5] = label;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            role: "presentation",
            alignItems: "center"
        }, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ appCount: appCount, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const label = appCount !== undefined && appCount > 0 ? formatMessage((0, $18556631decfdfd2$export$defe85febe8b728c).moreWithCount, {
        appCount: appCount
    }) : formatMessage((0, $18556631decfdfd2$export$defe85febe8b728c).more);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        role: "presentation",
        alignItems: "center"
    }, icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a3a981dac797ffb$export$d316b4624d0181e6), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $1aa88845bd0865d7$var$styles.moreButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        align: "center",
        color: "color.text.subtle"
    }, label)));
};






















var $fLkRZ = parcelRequire("fLkRZ");


const $bcd769c125e18159$var$styles = {
    moreButtonStyles: "_2rko12b0 _4cvr1h6o _bfhki8nm _1e0c1txw _18u01b66 _19bv1b66 _u5f31b66"
};
const $bcd769c125e18159$export$cc2dff6cea6c5d2c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { appCount: appCount } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== appCount || $[1] !== formatMessage) {
        t1 = appCount !== undefined && appCount > 0 ? formatMessage((0, $18556631decfdfd2$export$defe85febe8b728c).moreWithCount, {
            appCount: appCount
        }) : formatMessage((0, $18556631decfdfd2$export$defe85febe8b728c).more);
        $[0] = appCount;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    const label = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLkRZ.JiraAppSelectorIconWithGithub), null);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== label) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            role: "presentation",
            alignItems: "center"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $bcd769c125e18159$var$styles.moreButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            align: "center",
            color: "color.text.subtle"
        }, label)));
        $[4] = label;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ appCount: appCount })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const label = appCount !== undefined && appCount > 0 ? formatMessage((0, $18556631decfdfd2$export$defe85febe8b728c).moreWithCount, {
        appCount: appCount
    }) : formatMessage((0, $18556631decfdfd2$export$defe85febe8b728c).more);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        role: "presentation",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLkRZ.JiraAppSelectorIconWithGithub), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $bcd769c125e18159$var$styles.moreButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        align: "center",
        color: "color.text.subtle"
    }, label)));
};









/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $67687c291cbd3032$export$f9dcc678030ab488 = (order)=>{
    const m = new Map();
    order.forEach((k, i)=>m.set(k, i));
    return m;
};


const $25fc9dd7827bae6f$export$93a5273e04316040 = (prev, next, order)=>{
    if (prev.size !== next.size) return false;
    for (const key of order){
        if (prev.get(key) !== next.get(key)) return false;
    }
    return true;
};


const $f92995bd2c05732b$export$ff7706047246b98b = ()=>{
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};


// eslint-disable-next-line no-barrel-files/no-barrel-files



const $aa12660590b769fd$export$281af962cf87c22e = (keys, refs)=>{
    const rects = new Map();
    for (const key of keys){
        const el = refs.get(key);
        if (el) rects.set(key, el.getBoundingClientRect());
    }
    return rects;
};


const $b8fd72204c218acd$var$flipListContainerStyles = null;
const $b8fd72204c218acd$var$flipListItemStyles = null;
const $b8fd72204c218acd$var$flipListItemNoTransitionStyles = null;
const $b8fd72204c218acd$var$flipListHiddenStyles = null; /**
                                    * FlipList
                                    *
                                    * Implements a FLIP animation. By default it reorders DOM nodes;
                                    * optionally it can keep DOM node order stable using CSS order.
                                    *
                                    * Expected behavior:
                                    * 1) All items mount with translate=(0,0)
                                    * 2) On reorder: measure FIRST, apply new order, measure LAST
                                    * 3) Apply inverse transform WITHOUT transition
                                    * 4) Next frame: reset transform to 0 WITH transition
                                    * 5) After transition completes: remain at translate=0 with new order
                                    */ 
const $b8fd72204c218acd$export$3d1498497a812571 = ({ order: order, renderItem: renderItem, getItemProps: getItemProps, disabled: disabled = false, durationMs: durationMs = 250, easing: easing = 'cubic-bezier(0.2, 0, 0.2, 1)', containerAs: Container = 'div', containerProps: containerProps, itemAs: Item = 'div', useCssOrder: useCssOrder = false, keepRemovedInDom: keepRemovedInDom = true, xcss: xcss })=>{
    const itemRefs = (0, $42omo.useRef)(new Map());
    const refCallbacksRef = (0, $42omo.useRef)(new Map()); // Stable DOM keys (CSS order) or DOM order that matches `order`.
    const [domKeys, setDomKeys] = (0, $42omo.useState)(()=>[
            ...order
        ]); // Current visual order index map.
    const [orderIndex, setOrderIndex] = (0, $42omo.useState)(()=>(0, $67687c291cbd3032$export$f9dcc678030ab488)(order)); // Current per-item transforms.
    const [transforms, setTransforms] = (0, $42omo.useState)(()=>new Map()); // Phase controls whether we disable transitions while applying inverse transforms.
    const [phase, setPhase] = (0, $42omo.useState)('idle');
    const firstRectsRef = (0, $42omo.useRef)(null);
    const timeoutRef = (0, $42omo.useRef)(null); // Keep domKeys stable (CSS order) or align DOM order to `order`.
    (0, $42omo.useEffect)(()=>{
        setDomKeys((prev)=>{
            if (useCssOrder) {
                let next = prev;
                for (const key of order)if (!next.includes(key)) next = next === prev ? [
                    ...prev,
                    key
                ] : [
                    ...next,
                    key
                ];
                if (!keepRemovedInDom) next = next.filter((k)=>order.includes(k));
                return next;
            }
            let next_0 = [
                ...order
            ];
            if (keepRemovedInDom) {
                for (const key_0 of prev)if (!next_0.includes(key_0)) next_0.push(key_0);
            }
            return next_0;
        });
    }, [
        keepRemovedInDom,
        order,
        useCssOrder
    ]); // Cleanup timers.
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
        };
    }, []); // Capture FIRST rects and update orderIndex when desired order changes.
    (0, $42omo.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const nextIndex = (0, $67687c291cbd3032$export$f9dcc678030ab488)(order);
        if (disabled || (0, $f92995bd2c05732b$export$ff7706047246b98b)()) {
            // Jump immediately: no transforms, just update ordering.
            setPhase((prev_0)=>prev_0 === 'idle' ? prev_0 : 'idle');
            setTransforms((prev_1)=>prev_1.size === 0 ? prev_1 : new Map());
            setOrderIndex((prev_2)=>(0, $25fc9dd7827bae6f$export$93a5273e04316040)(prev_2, nextIndex, order) ? prev_2 : nextIndex);
            firstRectsRef.current = null;
            return;
        } // Detect change.
        let changed = false;
        for (const key_1 of order)if (orderIndex.get(key_1) !== nextIndex.get(key_1)) {
            changed = true;
            break;
        }
        if (!changed) return;
         // Measure FIRST (current visual layout).
        firstRectsRef.current = (0, $aa12660590b769fd$export$281af962cf87c22e)(domKeys, itemRefs.current); // Apply new visual order (CSS order values or DOM order).
        setOrderIndex(nextIndex); // Next layout effect will measure LAST and compute transforms.
    }, [
        disabled,
        domKeys,
        order,
        orderIndex,
        useCssOrder
    ]); // After orderIndex changes commit, compute LAST rects and perform FLIP.
    (0, $42omo.useLayoutEffect)(()=>{
        if (typeof window === 'undefined') return;
        const first = firstRectsRef.current;
        if (!first) return;
        if (disabled || (0, $f92995bd2c05732b$export$ff7706047246b98b)()) {
            firstRectsRef.current = null;
            return;
        }
        const last = (0, $aa12660590b769fd$export$281af962cf87c22e)(domKeys, itemRefs.current);
        const inverse = new Map();
        for (const key_2 of domKeys){
            const a = first.get(key_2);
            const b = last.get(key_2);
            if (!a || !b) continue;
            const dx = a.left - b.left;
            const dy = a.top - b.top;
            if (dx !== 0 || dy !== 0) inverse.set(key_2, {
                x: dx,
                y: dy
            });
        } // Invert (no transition): apply inverse transforms.
        setPhase('inverting');
        setTransforms(inverse); // Play (with transition): next frame, reset transforms to 0.
        window.requestAnimationFrame(()=>{
            setPhase('playing');
            setTransforms(new Map());
            if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>{
                setPhase('idle');
            }, durationMs);
        });
        firstRectsRef.current = null;
    }, [
        disabled,
        domKeys,
        durationMs,
        orderIndex
    ]);
    const getItemRefCallback = (0, $42omo.useCallback)((key_3)=>{
        const existing = refCallbacksRef.current.get(key_3);
        if (existing) return existing;
        const cb = (el)=>{
            if (el) itemRefs.current.set(key_3, el);
            else itemRefs.current.delete(key_3);
        };
        refCallbacksRef.current.set(key_3, cb);
        return cb;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Container, {
        ...containerProps,
        // (and other observers) can wait for the list to settle before
        // asserting on row order. Values: 'idle' | 'inverting' | 'playing'.
        "data-flip-phase": phase,
        style: {
            '--animation-duration': `${durationMs}ms`,
            '--animation-easing': easing
        },
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            xcss
        ])
    }, domKeys.map((key_4)=>{
        const itemProps = getItemProps?.(key_4) ?? {};
        const idx = orderIndex.get(key_4);
        const hidden = idx === undefined;
        const t = transforms.get(key_4) ?? {
            x: 0,
            y: 0
        };
        const cssOrderIndex = idx === undefined ? undefined : idx;
        let translateX = `${t.x}px`;
        let translateY = `${t.y}px`;
        let flipOrderValue;
        if (useCssOrder && cssOrderIndex !== undefined) flipOrderValue = `${cssOrderIndex}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Item, {
            key: key_4,
            ref: getItemRefCallback(key_4),
            ...itemProps,
            style: {
                '--translate-x': translateX,
                '--translate-y': translateY,
                '--flip-order': flipOrderValue
            },
            className: (0, $gMc0m.default)([
                "_v5641tjh _1f491nh5 _t9ec1a9k _m6k41e03",
                hidden && "_1e0cglyw",
                (phase === 'inverting' || phase === 'idle') && transforms.size > 0 && "_v564glyw"
            ])
        }, renderItem(key_4));
    }));
};













const $7e10cef09d2fc3c1$export$c13db7c4cba50c39 = ({ attributes: attributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'selected',
        actionSubject: 'intentRouter',
        actionSubjectId: 'intentRouterSelected',
        attributes: attributes
    });





const $af90b002ca1d8064$var$APPS_SHOWN_IN_ICON = 3;
const $af90b002ca1d8064$export$f9fde84c1bef3da9 = (availableProducts, thirdPartyConfigs, productConfigs, isUserOAuthed)=>{
    const eligibleCount = availableProducts.filter((productKey)=>{
        if (productKey === (0, $b4tvS.ProductKeys).Atlas || productKey === (0, $b4tvS.ProductKeys).AtlassianWebCrawler) return false;
        const { userNeedsOAuth: userNeedsOAuth } = isUserOAuthed(productKey, thirdPartyConfigs);
        if (userNeedsOAuth) return false;
        return Boolean(productConfigs[productKey]);
    }).length;
    return Math.max(0, eligibleCount - $af90b002ca1d8064$var$APPS_SHOWN_IN_ICON);
};



var $3KrAM = parcelRequire("3KrAM");























const $3f03f084e86b29e6$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    searchDialogAriaLabel: {
        id: "search_dialog_aria_label",
        defaultMessage: "Search Dialog"
    },
    recentsHeading: {
        id: "search_dialog_recents_heading",
        defaultMessage: "Recent"
    },
    recommendationsHeading: {
        id: "search_dialog_recommendations_heading",
        defaultMessage: "Recommendations"
    },
    recommendedHeading: {
        id: "search_dialog_recommended_heading",
        defaultMessage: "Recommended"
    },
    searchResultsHeading: {
        id: "recents_heading",
        defaultMessage: "Search Results"
    }
});


















const $814392873146e4c1$var$styles = {
    container: "_1reo15vq _18m915vq _v5641gvb _otyrv77o"
};
const $814392873146e4c1$var$IntentRouterWorkItem = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { matchingItem: matchingItem, query: query, isLoading: isLoading } = t0;
    const contentRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [displayContent, setDisplayContent] = (0, $42omo.useState)(null);
    const [maxHeight, setMaxHeight] = (0, $42omo.useState)("0px");
    let t1;
    let t2;
    if ($[0] !== isLoading || $[1] !== matchingItem || $[2] !== query) {
        t1 = ()=>{
            const shouldShow = !!matchingItem || isLoading && !!(0, $lsW5D.normalizeWorkItemKey)(query);
            if (shouldShow) {
                setDisplayContent(matchingItem || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $addf1cb001f831f5$export$dd3282b157ef6f7a), null));
                setIsVisible(true);
            } else {
                setMaxHeight("0px");
                setIsVisible(false);
            }
        };
        t2 = [
            matchingItem,
            isLoading,
            query
        ];
        $[0] = isLoading;
        $[1] = matchingItem;
        $[2] = query;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[5] !== displayContent || $[6] !== isVisible) {
        t3 = ()=>{
            if (isVisible && displayContent) {
                const frameId = requestAnimationFrame(()=>{
                    if (contentRef.current) setMaxHeight(`${contentRef.current.scrollHeight}px`);
                });
                return ()=>cancelAnimationFrame(frameId);
            }
        };
        t4 = [
            isVisible,
            displayContent
        ];
        $[5] = displayContent;
        $[6] = isVisible;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== displayContent || $[10] !== isVisible) {
        t5 = ()=>{
            if (!isVisible && displayContent) setDisplayContent(null);
        };
        $[9] = displayContent;
        $[10] = isVisible;
        $[11] = t5;
    } else t5 = $[11];
    const handleTransitionEnd = t5;
    if (!isVisible && !displayContent) return null;
    let t6;
    if ($[12] !== maxHeight) {
        t6 = {
            maxHeight: maxHeight
        };
        $[12] = maxHeight;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== displayContent || $[15] !== handleTransitionEnd || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: contentRef,
            xcss: $814392873146e4c1$var$styles.container,
            style: t6,
            onTransitionEnd: handleTransitionEnd
        }, displayContent);
        $[14] = displayContent;
        $[15] = handleTransitionEnd;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ matchingItem: matchingItem, query: query, isLoading: isLoading })=>{
    const contentRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [displayContent, setDisplayContent] = (0, $42omo.useState)(null);
    const [maxHeight, setMaxHeight] = (0, $42omo.useState)('0px'); // Update content when it changes
    (0, $42omo.useEffect)(()=>{
        const shouldShow = !!matchingItem || isLoading && !!(0, $lsW5D.normalizeWorkItemKey)(query);
        if (shouldShow) {
            setDisplayContent(matchingItem || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $addf1cb001f831f5$export$dd3282b157ef6f7a), null));
            setIsVisible(true);
        } else {
            setMaxHeight('0px'); // Start collapsed
            setIsVisible(false);
        }
    }, [
        matchingItem,
        isLoading,
        query
    ]); // After content is mounted, measure and expand
    (0, $42omo.useEffect)(()=>{
        if (isVisible && displayContent) {
            const frameId = requestAnimationFrame(()=>{
                if (contentRef.current) setMaxHeight(`${contentRef.current.scrollHeight}px`);
            });
            return ()=>cancelAnimationFrame(frameId);
        }
    }, [
        isVisible,
        displayContent
    ]); // Unmount content after transition ends
    const handleTransitionEnd = ()=>{
        if (!isVisible && displayContent) setDisplayContent(null);
    };
    if (!isVisible && !displayContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: contentRef,
        xcss: $814392873146e4c1$var$styles.container,
        style: {
            maxHeight: maxHeight
        },
        onTransitionEnd: handleTransitionEnd
    }, displayContent);
};
var $814392873146e4c1$export$2e2bcd8739ae039 = $814392873146e4c1$var$IntentRouterWorkItem;





const $627c5d243ba159b8$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    searchForAllApps: {
        id: "search.quickFind.intentRouter.searchForAllApps",
        defaultMessage: "Search for all apps"
    },
    allApps: {
        id: "search.quickFind.intentRouter.allApps",
        defaultMessage: "All apps"
    },
    searchForJiraWorkItems: {
        id: "search.quickFind.intentRouter.searchForJiraWorkItems",
        defaultMessage: "Search for Jira work items"
    },
    jiraWorkItems: {
        id: "search.quickFind.intentRouter.jiraWorkItemsJql",
        defaultMessage: "Jira work items (JQL)"
    }
});





const $f09a3b1faa1fe617$export$9fbbf51870efdf63 = (modelId)=>{
    if (!modelId) return false;
    const intentDetectionModel = Object.values((0, $bAgd8.KnowledgeDiscoveryJiraIntentDetectionModel));
    return Boolean(intentDetectionModel.find((x)=>x === modelId));
};















var $4jvDJ = parcelRequire("4jvDJ");

var $lh6Pw = parcelRequire("lh6Pw");




var $k2lGv = parcelRequire("k2lGv");

























const $b9f84903a04d5c3b$export$92044c909bce4033 = ({ action: action, attributes: attributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: action,
        actionSubject: 'intentDetectionResponse',
        actionSubjectId: 'intentDetection',
        attributes: attributes
    });










const $4ab2bcada25ac17b$export$c5d196f0984a6b2 = ({ defaultMode: defaultMode = (0, $4tgkZ.IntentMode).GNIN } = {})=>{
    const intl = (0, $aXWIB.useIntl)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [orgId] = (0, $j4ply.useOrgId)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const sessionId = (0, $PVo4u.getSessionIdFromLocalStorage)();
    const taskStateRef = (0, $e6c80dec8a0d452c$export$714277298f52f5c1)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const intentDetectionExperiment = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: intl.locale
    });
    const intentDetectionModelId = intentDetectionExperiment?.modelId;
    const intentDetectionCohort = intentDetectionExperiment?.cohort;
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    // Memoize atl-attribution headers to avoid recreating on every render
    const atlAttributionHeaders = (0, $42omo.useMemo)(()=>(0, $jwO5V.buildAtlAttributionHeaders)({
            cloudId: cloudId,
            activationId: analyticsAttributes?.activationId,
            product: primaryProduct
        }), [
        cloudId,
        analyticsAttributes?.activationId,
        primaryProduct
    ]);
    const validatedModelId = (0, $f09a3b1faa1fe617$export$9fbbf51870efdf63)(intentDetectionModelId) ? intentDetectionModelId : (0, $bAgd8.KnowledgeDiscoveryJiraIntentDetectionModel).GNIN_HEURISTIC;
    const fireAnalytics = (0, $42omo.useCallback)((action, attributes)=>{
        fireAnalyticsEvent((0, $b9f84903a04d5c3b$export$92044c909bce4033)({
            action: action,
            attributes: {
                ...attributes,
                searchSessionId: searchSessionId,
                modelId: validatedModelId,
                cohort: intentDetectionCohort
            }
        }));
    }, [
        searchSessionId,
        fireAnalyticsEvent,
        validatedModelId,
        intentDetectionCohort
    ]);
    return (0, $42omo.useCallback)(async (query)=>{
        // create siteARI based on primary product
        const siteId = `ari:cloud:${primaryProduct}::site/${cloudId}`;
        // VitalStats: Generate task ID and record start time
        const taskId = crypto.randomUUID();
        const uxTaskId = taskStateRef.current.id;
        const startTime = performance.now();
        // Query Analytics attributes
        const queryHash = (0, $731W9.sha256Hash)(query);
        const queryLength = query.length;
        const wordCount = (0, $inrbX.getWordCount)(query);
        fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId || '',
            taskId: taskId,
            task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_NETWORK,
            moreContext: {
                uxTaskId: uxTaskId,
                queryHash: queryHash,
                queryLength: queryLength,
                wordCount: wordCount,
                cohort: intentDetectionCohort,
                modelId: validatedModelId
            }
        })));
        try {
            const response = await (0, $lh6Pw.jiraIntentDetectionQuery)({
                query: query,
                siteId: siteId,
                sessionId: sessionId,
                orgId: orgId ?? '',
                experience: (0, $k2lGv.KnowledgeDiscoveryJiraSearchExperience).QUICK_FIND,
                model: validatedModelId,
                includePatternType: true
            }, atlAttributionHeaders);
            const result = response.data?.knowledgeDiscovery.jiraIntentDetection;
            const latencyMs_0 = performance.now() - startTime;
            const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)((0, $6jKOp.extractTraceInfoFromResponse)(response)) : {};
            if (!(0, $4jvDJ.isIntentDetectionSuccess)(result)) {
                const errorName_0 = 'UnsuccessfulResponse';
                const errorMessage_0 = 'Query typename mismatch';
                fireAnalytics('fail', {
                    queryHash: queryHash,
                    errorName: errorName_0,
                    errorMessage: errorMessage_0,
                    queryLength: queryLength,
                    wordCount: wordCount,
                    queryClassification: null
                });
                fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskFail)({
                    searchSessionId: searchSessionId || '',
                    taskId: taskId,
                    task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_NETWORK,
                    moreContext: {
                        uxTaskId: uxTaskId,
                        queryHash: queryHash,
                        queryLength: queryLength,
                        wordCount: wordCount,
                        cohort: intentDetectionCohort,
                        queryClassification: null,
                        latencyMs: latencyMs_0,
                        errorName: errorName_0,
                        errorMessage: errorMessage_0,
                        modelId: validatedModelId,
                        ...traceInfo
                    }
                })));
                return {
                    mode: defaultMode
                };
            }
            const intentMode = result.searchClassification?.type || defaultMode;
            const patternType = result.searchClassification?.pattern ?? undefined;
            fireAnalytics('success', {
                queryHash: queryHash,
                queryLength: queryLength,
                wordCount: wordCount,
                queryClassification: intentMode,
                patternType: patternType
            });
            fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskSuccess)({
                searchSessionId: searchSessionId || '',
                taskId: taskId,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_NETWORK,
                moreContext: {
                    uxTaskId: uxTaskId,
                    queryHash: queryHash,
                    queryLength: queryLength,
                    wordCount: wordCount,
                    cohort: intentDetectionCohort,
                    latencyMs: latencyMs_0,
                    queryClassification: intentMode,
                    modelId: validatedModelId,
                    patternType: patternType,
                    ...traceInfo
                }
            })));
            return {
                mode: intentMode,
                modelId: validatedModelId,
                patternType: patternType
            };
        } catch (error) {
            const latencyMs = performance.now() - startTime;
            const errorName = error?.name || 'UnknownError';
            const errorMessage = error?.message ?? 'An unknown error occurred';
            fireAnalytics('fail', {
                queryHash: queryHash,
                errorName: errorName,
                errorMessage: errorMessage,
                queryLength: queryLength,
                wordCount: wordCount,
                queryClassification: null
            });
            fireAnalyticsEvent((0, $5qcsY.remapVitalStatsEventForQuickFind)((0, $bQSQw.onTaskFail)({
                searchSessionId: searchSessionId || '',
                taskId: taskId,
                task: (0, $31eSD.TASK_NAMES).QUICK_FIND_INTENT_DETECTION_NETWORK,
                moreContext: {
                    uxTaskId: uxTaskId,
                    queryHash: queryHash,
                    queryLength: queryLength,
                    wordCount: wordCount,
                    cohort: intentDetectionCohort,
                    queryClassification: null,
                    latencyMs: latencyMs,
                    errorName: error?.name,
                    errorMessage: error?.message,
                    modelId: validatedModelId,
                    ...(0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)(undefined) : {}
                }
            })));
            return {
                mode: defaultMode
            };
        }
    }, [
        cloudId,
        orgId,
        primaryProduct,
        defaultMode,
        fireAnalytics,
        searchSessionId,
        sessionId,
        fireAnalyticsEvent,
        validatedModelId,
        intentDetectionCohort,
        taskStateRef,
        atlAttributionHeaders
    ]);
};





















const $60e53d874e754083$var$INTENT_ROW_TRACKING_ID_BY_MODE = {
    [(0, $161b4e5c9ce588f2$export$7cc7cea0c5a977c4)]: `intentRouterWorkItem:${(0, $161b4e5c9ce588f2$export$7cc7cea0c5a977c4)}`,
    [(0, $4tgkZ.IntentMode).FPS]: 'intentRouter:intent-all-apps',
    [(0, $4tgkZ.IntentMode).GNIN]: 'intentRouter:intent-jira-work-items'
};
const $60e53d874e754083$export$351560332f190b8f = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { primaryMode: primaryMode, query: query, isLoadingWorkItem: isLoadingWorkItem, hasMatchingWorkItem: t1, showMatchingWorkItem: t2 } = t0;
    const hasMatchingWorkItem = t1 === undefined ? false : t1;
    const showMatchingWorkItem = t2 === undefined ? false : t2;
    const { highlightComponentAt: highlightComponentAt, unhighlightAll: unhighlightAll, keyboardNavComponents: keyboardNavComponents, getSelectedIndex: getSelectedIndex } = (0, $icqFF.useKeyboardHighlightProvider)() ?? {};
    const lastAppliedModeRef = (0, $42omo.useRef)(null);
    const prevQueryRef = (0, $42omo.useRef)(query);
    const highlightRafIdRef = (0, $42omo.useRef)(null);
    let t3;
    if ($[0] !== getSelectedIndex || $[1] !== hasMatchingWorkItem || $[2] !== highlightComponentAt || $[3] !== isLoadingWorkItem || $[4] !== keyboardNavComponents || $[5] !== primaryMode || $[6] !== query || $[7] !== showMatchingWorkItem || $[8] !== unhighlightAll) {
        t3 = ()=>{
            const currentIdx = getSelectedIndex?.() ?? -1;
            const isWorkItemSkeletonDisplayed = Boolean(showMatchingWorkItem && isLoadingWorkItem && (0, $lsW5D.normalizeWorkItemKey)(query));
            if (!hasMatchingWorkItem && isWorkItemSkeletonDisplayed) {
                if (currentIdx > -1) unhighlightAll?.();
                return;
            }
            const desiredTrackingId = $60e53d874e754083$var$INTENT_ROW_TRACKING_ID_BY_MODE[hasMatchingWorkItem ? (0, $161b4e5c9ce588f2$export$7cc7cea0c5a977c4) : primaryMode];
            const desiredIdx = (hasMatchingWorkItem ? keyboardNavComponents : keyboardNavComponents?.filter($60e53d874e754083$var$_temp))?.findIndex((c_0)=>c_0.navigationTrackingId === desiredTrackingId) ?? -1;
            if (desiredIdx < 0) return;
            if (!showMatchingWorkItem && lastAppliedModeRef.current === primaryMode) {
                const queryChanged = prevQueryRef.current !== query;
                prevQueryRef.current = query;
                if (currentIdx === desiredIdx) return;
                if (currentIdx !== undefined && !queryChanged) return;
            }
            lastAppliedModeRef.current = primaryMode;
            if (highlightRafIdRef.current !== null) cancelAnimationFrame(highlightRafIdRef.current);
            highlightRafIdRef.current = requestAnimationFrame(()=>{
                highlightRafIdRef.current = null;
                unhighlightAll?.();
                highlightComponentAt?.(desiredIdx);
                keyboardNavComponents?.[desiredIdx]?.onHighlightedCallback?.(desiredIdx);
            });
            return ()=>{
                if (highlightRafIdRef.current !== null) {
                    cancelAnimationFrame(highlightRafIdRef.current);
                    highlightRafIdRef.current = null;
                }
            };
        };
        $[0] = getSelectedIndex;
        $[1] = hasMatchingWorkItem;
        $[2] = highlightComponentAt;
        $[3] = isLoadingWorkItem;
        $[4] = keyboardNavComponents;
        $[5] = primaryMode;
        $[6] = query;
        $[7] = showMatchingWorkItem;
        $[8] = unhighlightAll;
        $[9] = t3;
    } else t3 = $[9];
    const t4 = keyboardNavComponents?.length;
    let t5;
    if ($[10] !== getSelectedIndex || $[11] !== hasMatchingWorkItem || $[12] !== highlightComponentAt || $[13] !== isLoadingWorkItem || $[14] !== keyboardNavComponents || $[15] !== primaryMode || $[16] !== query || $[17] !== showMatchingWorkItem || $[18] !== t4 || $[19] !== unhighlightAll) {
        t5 = [
            keyboardNavComponents,
            t4,
            hasMatchingWorkItem,
            isLoadingWorkItem,
            showMatchingWorkItem,
            primaryMode,
            query,
            getSelectedIndex,
            highlightComponentAt,
            unhighlightAll
        ];
        $[10] = getSelectedIndex;
        $[11] = hasMatchingWorkItem;
        $[12] = highlightComponentAt;
        $[13] = isLoadingWorkItem;
        $[14] = keyboardNavComponents;
        $[15] = primaryMode;
        $[16] = query;
        $[17] = showMatchingWorkItem;
        $[18] = t4;
        $[19] = unhighlightAll;
        $[20] = t5;
    } else t5 = $[20];
    (0, $42omo.useLayoutEffect)(t3, t5);
} : ({ primaryMode: primaryMode, query: query, isLoadingWorkItem: isLoadingWorkItem, hasMatchingWorkItem: hasMatchingWorkItem = false, showMatchingWorkItem: showMatchingWorkItem = false })=>{
    const { highlightComponentAt: highlightComponentAt, unhighlightAll: unhighlightAll, keyboardNavComponents: keyboardNavComponents, getSelectedIndex: getSelectedIndex } = (0, $icqFF.useKeyboardHighlightProvider)() ?? {};
    const lastAppliedModeRef = (0, $42omo.useRef)(null);
    const prevQueryRef = (0, $42omo.useRef)(query);
    const highlightRafIdRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        const currentIdx = getSelectedIndex?.() ?? -1;
        const isWorkItemSkeletonDisplayed = Boolean(showMatchingWorkItem && isLoadingWorkItem && (0, $lsW5D.normalizeWorkItemKey)(query));
        if (!hasMatchingWorkItem && isWorkItemSkeletonDisplayed) {
            // loading skeleton is displayed, don't highlight any intent detection option
            if (currentIdx > -1) unhighlightAll?.();
            return;
        }
        const desiredTrackingId = $60e53d874e754083$var$INTENT_ROW_TRACKING_ID_BY_MODE[hasMatchingWorkItem ? (0, $161b4e5c9ce588f2$export$7cc7cea0c5a977c4) : primaryMode];
        // We can only apply selection once the intent row is registered.
        const desiredIdx = (hasMatchingWorkItem ? keyboardNavComponents : // exclude the matching work item as it might take some time to unregister
        keyboardNavComponents?.filter((c)=>c.navigationTrackingId !== $60e53d874e754083$var$INTENT_ROW_TRACKING_ID_BY_MODE[0, $161b4e5c9ce588f2$export$7cc7cea0c5a977c4]))?.findIndex((c_0)=>c_0.navigationTrackingId === desiredTrackingId) ?? -1;
        if (desiredIdx < 0) return;
        // Mode already applied — decide whether to re-apply.
        if (!showMatchingWorkItem && lastAppliedModeRef.current === primaryMode) {
            const queryChanged = prevQueryRef.current !== query;
            prevQueryRef.current = query;
            // Row is still correctly selected — nothing to do.
            if (currentIdx === desiredIdx) return;
            // A different row is selected (user navigated with arrow keys).
            // Only re-apply if the user typed (query changed); ignore
            // keyboardNavComponents-only changes (e.g. FlipList animation).
            if (currentIdx !== undefined && !queryChanged) return;
        }
        // Mark as applied synchronously to prevent duplicate scheduling
        // on rapid re-renders before the RAF fires.
        lastAppliedModeRef.current = primaryMode;
        // Cancel any previously scheduled RAF.
        if (highlightRafIdRef.current !== null) cancelAnimationFrame(highlightRafIdRef.current);
        // Defer the visual highlight to the next animation frame for a smoother transition.
        highlightRafIdRef.current = requestAnimationFrame(()=>{
            highlightRafIdRef.current = null;
            unhighlightAll?.();
            highlightComponentAt?.(desiredIdx);
            keyboardNavComponents?.[desiredIdx]?.onHighlightedCallback?.(desiredIdx);
        });
        return ()=>{
            if (highlightRafIdRef.current !== null) {
                cancelAnimationFrame(highlightRafIdRef.current);
                highlightRafIdRef.current = null;
            }
        };
    }, [
        keyboardNavComponents,
        keyboardNavComponents?.length,
        hasMatchingWorkItem,
        isLoadingWorkItem,
        showMatchingWorkItem,
        primaryMode,
        query,
        getSelectedIndex,
        highlightComponentAt,
        unhighlightAll
    ]);
};
function $60e53d874e754083$var$_temp(c) {
    return c.navigationTrackingId !== $60e53d874e754083$var$INTENT_ROW_TRACKING_ID_BY_MODE[0, $161b4e5c9ce588f2$export$7cc7cea0c5a977c4];
}











const $88b96a73873e73ff$export$da00a8e161805bdf = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;









var $3fzmz = parcelRequire("3fzmz");





var $1tkBc = parcelRequire("1tkBc");


const $715adf53e35160a2$export$5f3589c7f067a6e4 = (a, b)=>{
    try {
        return (0, $1tkBc.getPathname)(a) === (0, $1tkBc.getPathname)(b);
    } catch  {
        return false;
    }
};


const $5b4b660e006bbec8$export$d5bb993f77e7dea0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { query: query, minQueryLength: minQueryLength } = t0;
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    let t1;
    if ($[0] !== generateSearchUrl || $[1] !== query || $[2] !== queryParams) {
        t1 = generateSearchUrl({
            ...queryParams,
            text: query
        });
        $[0] = generateSearchUrl;
        $[1] = query;
        $[2] = queryParams;
        $[3] = t1;
    } else t1 = $[3];
    const allAppsUrl = t1;
    const currentUrl = typeof window !== "undefined" ? window.location.href : "";
    let t2;
    if ($[4] !== allAppsUrl) {
        t2 = currentUrl ? (0, $715adf53e35160a2$export$5f3589c7f067a6e4)(currentUrl, allAppsUrl) : false;
        $[4] = allAppsUrl;
        $[5] = t2;
    } else t2 = $[5];
    const isAllAppsPage = t2;
    let defaultMode = isAllAppsPage ? (0, $4tgkZ.IntentMode).FPS : (0, $4tgkZ.IntentMode).GNIN;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $4tgkZ.INTENT_DETECTION).value();
        $[6] = t3;
    } else t3 = $[6];
    const intentDetectionResult = t3;
    if (intentDetectionResult) {
        const { mode: mode, query: intentDetectionQuery } = intentDetectionResult;
        if (query.length >= minQueryLength && query === intentDetectionQuery) defaultMode = mode;
    }
    let t4;
    if ($[7] !== allAppsUrl || $[8] !== defaultMode || $[9] !== isAllAppsPage) {
        t4 = {
            allAppsUrl: allAppsUrl,
            isAllAppsPage: isAllAppsPage,
            defaultMode: defaultMode
        };
        $[7] = allAppsUrl;
        $[8] = defaultMode;
        $[9] = isAllAppsPage;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ query: query, minQueryLength: minQueryLength })=>{
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const allAppsUrl = (0, $42omo.useMemo)(()=>generateSearchUrl({
            ...queryParams,
            text: query
        }), [
        generateSearchUrl,
        queryParams,
        query
    ]);
    const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
    const isAllAppsPage = (0, $42omo.useMemo)(()=>currentUrl ? (0, $715adf53e35160a2$export$5f3589c7f067a6e4)(currentUrl, allAppsUrl) : false, [
        currentUrl,
        allAppsUrl
    ]);
    let defaultMode = isAllAppsPage ? (0, $4tgkZ.IntentMode).FPS : (0, $4tgkZ.IntentMode).GNIN;
    // Hydrate the default mode from the intent detection result if available.
    const intentDetectionResult = (0, $4tgkZ.INTENT_DETECTION).value();
    if (intentDetectionResult) {
        const { mode: mode, query: intentDetectionQuery } = intentDetectionResult;
        // If the intent detection result is for the current page, use it as the default mode.
        if (query.length >= minQueryLength && query === intentDetectionQuery) defaultMode = mode;
    }
    return {
        allAppsUrl: allAppsUrl,
        isAllAppsPage: isAllAppsPage,
        defaultMode: defaultMode
    };
};
const $5b4b660e006bbec8$export$f0f4ca1fb8eb9f3e = ({ query: query, showMatchingWorkItem: showMatchingWorkItem, isLoading: isLoading, patternType: patternType })=>{
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { selectedFilters: { jiraFilters: jiraFilters } } = (0, $4VkIo.useSelectedFilters)({});
    const isQueryJql = patternType === (0, $4tgkZ.PatternType).Jql;
    const jiraWorkItemsUrl = (0, $42omo.useMemo)(()=>{
        try {
            return (0, $3fzmz.getWorkItemPageUrl)({
                query: query,
                jiraFilters: jiraFilters,
                generateSearchUrl: generateSearchUrl,
                queryParams: queryParams,
                // use smart url to check if the query is an issue key while loading
                issueKeyLookup: isLoading || !showMatchingWorkItem,
                isQueryJql: isQueryJql
            });
        } catch  {
            return 0, $88b96a73873e73ff$export$da00a8e161805bdf;
        }
    }, [
        generateSearchUrl,
        jiraFilters,
        queryParams,
        query,
        showMatchingWorkItem,
        isLoading,
        isQueryJql
    ]);
    const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
    const isJiraWorkItemsPage = (0, $42omo.useMemo)(()=>currentUrl ? (0, $715adf53e35160a2$export$5f3589c7f067a6e4)(currentUrl, jiraWorkItemsUrl) : false, [
        currentUrl,
        jiraWorkItemsUrl
    ]);
    return {
        jiraWorkItemsUrl: jiraWorkItemsUrl,
        isJiraWorkItemsPage: isJiraWorkItemsPage
    };
};












const $b995e1f2175cfd57$export$227eeed9835398d5 = ({ query: query, debounceMs: debounceMs, intentDetection: intentDetection, minQueryLength: minQueryLength, disabled: disabled = false, initialPrimaryMode: initialPrimaryMode = (0, $4tgkZ.IntentMode).GNIN })=>{
    const [primaryMode, setPrimaryMode] = (0, $42omo.useState)(initialPrimaryMode);
    const [patternType, setPatternType] = (0, $42omo.useState)(undefined);
    const [isPaused, setIsPaused] = (0, $42omo.useState)(false);
    const resumeTimeoutRef = (0, $42omo.useRef)(null);
    // Track the latest query and the query at pause time.
    const latestQueryRef = (0, $42omo.useRef)(query);
    const pausedQueryRef = (0, $42omo.useRef)(null);
    // Track the last query we triggered detection for to avoid duplicate calls.
    const lastDetectedQueryRef = (0, $42omo.useRef)(null);
    // VitalStats tracking for intent detection UX task lifecycle
    const { startTask: startTask, completeTaskSuccess: completeTaskSuccess, abortTask: abortTask, isTaskActive: isTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    // Keep latestQueryRef up to date.
    latestQueryRef.current = query;
    // Pin primary mode whenever we are disabled.
    (0, $42omo.useEffect)(()=>{
        if (disabled) setPrimaryMode(initialPrimaryMode);
    }, [
        disabled,
        initialPrimaryMode
    ]);
    const shouldRun = !disabled && query.length >= minQueryLength && !isPaused;
    const runDetection = (0, $42omo.useCallback)(async ()=>{
        if (disabled) return;
        const q = latestQueryRef.current;
        if (q.length < minQueryLength) return;
        // VitalStats: Abort previous task if still active (superseded by new query)
        if (isTaskActive()) abortTask('superseded_by_new_query');
        // VitalStats: Start new UX task
        startTask(q);
        // No error handling here as the intent detection service will handle it.
        const result = await intentDetection(q);
        setPrimaryMode(result.mode);
        setPatternType(result.patternType);
        // VitalStats: Mark UX task as successfully completed (UI updated)
        completeTaskSuccess();
    }, [
        disabled,
        intentDetection,
        minQueryLength,
        isTaskActive,
        abortTask,
        startTask,
        completeTaskSuccess
    ]);
    const debouncedDetect = (0, $JQd0k.useDebouncedCallback)(runDetection, debounceMs);
    // Trigger debounced detection when query changes (and conditions are met).
    (0, $42omo.useEffect)(()=>{
        if (!shouldRun) return;
        // Skip if we already triggered detection for this query (e.g. on resume).
        if (lastDetectedQueryRef.current === query) return;
        lastDetectedQueryRef.current = query;
        debouncedDetect();
        return ()=>{
            debouncedDetect.cancel();
        };
    }, [
        debouncedDetect,
        shouldRun,
        query
    ]);
    const pause = (0, $42omo.useCallback)(()=>{
        pausedQueryRef.current = latestQueryRef.current;
        setIsPaused(true);
        debouncedDetect.cancel();
    }, [
        debouncedDetect
    ]);
    const doResume = (0, $42omo.useCallback)(()=>{
        const queryChanged = pausedQueryRef.current !== null && pausedQueryRef.current !== latestQueryRef.current;
        pausedQueryRef.current = null;
        setIsPaused(false);
        if (queryChanged) {
            // Mark this query as detected so the effect doesn't double-trigger.
            lastDetectedQueryRef.current = latestQueryRef.current;
            // Trigger detection for the latest query that changed while paused.
            debouncedDetect();
        }
    }, [
        debouncedDetect
    ]);
    const resume = (0, $42omo.useCallback)(()=>{
        doResume();
    }, [
        doResume
    ]);
    // Pause intent detection while navigating, then resume after a short idle.
    const pauseAndResume = (0, $42omo.useCallback)((timeoutMs = 500)=>{
        pause();
        if (resumeTimeoutRef.current) window.clearTimeout(resumeTimeoutRef.current);
        // Resume after a short idle window (user stops navigating).
        resumeTimeoutRef.current = window.setTimeout(()=>{
            doResume();
        }, timeoutMs);
    }, [
        doResume,
        pause
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (resumeTimeoutRef.current) window.clearTimeout(resumeTimeoutRef.current);
            // VitalStats: Abort task if dialog is closed while intent detection is in-flight
            if (isTaskActive()) abortTask('dialog_closed');
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        primaryMode: primaryMode,
        patternType: patternType,
        isPaused: isPaused,
        pause: pause,
        resume: resume,
        pauseAndResume: pauseAndResume
    };
};


const $23cd74b8ba084de6$var$styles = {
    root: "_zulpv77o _1e0c1txw _2lx21bp4",
    intentRouterQuery: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s"
}; /**
    * Static IntentRouter rows.
    *
    * Returns two destination rows using SearchResult so they integrate
    * with @atlassian/search-dialog keyboard navigation.
    *
    */ 
const $23cd74b8ba084de6$export$86cb87a743ba47f8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(129);
    const { query: query, minQueryLength: minQueryLength, matchingItem: matchingItem, isLoading: isLoading, showMatchingWorkItem: showMatchingWorkItem } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [primarySubProduct] = (0, $j4ply.usePrimarySubProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { isTaskActive: isTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    const showGitHubIntentIcon = primaryProduct === "jira";
    let t1;
    if ($[0] !== availableProducts || $[1] !== productConfigs || $[2] !== thirdPartyConfigs) {
        t1 = (0, $af90b002ca1d8064$export$f9fde84c1bef3da9)(availableProducts, thirdPartyConfigs, productConfigs, (0, $gGFxq.isUserOAuthed));
        $[0] = availableProducts;
        $[1] = productConfigs;
        $[2] = thirdPartyConfigs;
        $[3] = t1;
    } else t1 = $[3];
    const remainingAppCount = t1;
    let intentDetectionCohort;
    let t2;
    if ($[4] !== intl.locale || $[5] !== primaryProduct) {
        const intentDetectionExperiment = (0, $26jni.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false,
            locale: intl.locale
        });
        const intentDetectionModelId = intentDetectionExperiment?.modelId;
        intentDetectionCohort = intentDetectionExperiment?.cohort;
        t2 = (0, $f09a3b1faa1fe617$export$9fbbf51870efdf63)(intentDetectionModelId) ? intentDetectionModelId : (0, $bAgd8.KnowledgeDiscoveryJiraIntentDetectionModel).GNIN_HEURISTIC;
        $[4] = intl.locale;
        $[5] = primaryProduct;
        $[6] = intentDetectionCohort;
        $[7] = t2;
    } else {
        intentDetectionCohort = $[6];
        t2 = $[7];
    }
    const modelId = t2;
    let t3;
    if ($[8] !== intl) {
        t3 = intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).allApps);
        $[8] = intl;
        $[9] = t3;
    } else t3 = $[9];
    const allAppsLabel = t3;
    let t4;
    if ($[10] !== intl) {
        t4 = intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).jiraWorkItems);
        $[10] = intl;
        $[11] = t4;
    } else t4 = $[11];
    const jiraWorkItemsLabel = t4;
    let t5;
    if ($[12] !== minQueryLength || $[13] !== query) {
        t5 = {
            query: query,
            minQueryLength: minQueryLength
        };
        $[12] = minQueryLength;
        $[13] = query;
        $[14] = t5;
    } else t5 = $[14];
    const { allAppsUrl: allAppsUrl, defaultMode: defaultMode } = (0, $5b4b660e006bbec8$export$d5bb993f77e7dea0)(t5);
    let t6;
    if ($[15] !== defaultMode) {
        t6 = {
            defaultMode: defaultMode
        };
        $[15] = defaultMode;
        $[16] = t6;
    } else t6 = $[16];
    const intentDetection = (0, $4ab2bcada25ac17b$export$c5d196f0984a6b2)(t6);
    let t7;
    if ($[17] !== defaultMode || $[18] !== intentDetection || $[19] !== minQueryLength || $[20] !== query) {
        t7 = {
            query: query,
            debounceMs: 250,
            intentDetection: intentDetection,
            initialPrimaryMode: defaultMode,
            minQueryLength: minQueryLength
        };
        $[17] = defaultMode;
        $[18] = intentDetection;
        $[19] = minQueryLength;
        $[20] = query;
        $[21] = t7;
    } else t7 = $[21];
    const { primaryMode: primaryMode, patternType: patternType, isPaused: disabled } = (0, $b995e1f2175cfd57$export$227eeed9835398d5)(t7);
    let t8;
    if ($[22] !== isLoading || $[23] !== patternType || $[24] !== query || $[25] !== showMatchingWorkItem) {
        t8 = {
            query: query,
            showMatchingWorkItem: showMatchingWorkItem,
            isLoading: isLoading,
            patternType: patternType
        };
        $[22] = isLoading;
        $[23] = patternType;
        $[24] = query;
        $[25] = showMatchingWorkItem;
        $[26] = t8;
    } else t8 = $[26];
    const { jiraWorkItemsUrl: jiraWorkItemsUrl } = (0, $5b4b660e006bbec8$export$f0f4ca1fb8eb9f3e)(t8);
    const t9 = !!matchingItem;
    let t10;
    if ($[27] !== isLoading || $[28] !== primaryMode || $[29] !== query || $[30] !== showMatchingWorkItem || $[31] !== t9) {
        t10 = {
            primaryMode: primaryMode,
            query: query,
            showMatchingWorkItem: showMatchingWorkItem,
            hasMatchingWorkItem: t9,
            isLoadingWorkItem: isLoading
        };
        $[27] = isLoading;
        $[28] = primaryMode;
        $[29] = query;
        $[30] = showMatchingWorkItem;
        $[31] = t9;
        $[32] = t10;
    } else t10 = $[32];
    (0, $60e53d874e754083$export$351560332f190b8f)(t10);
    let t11;
    if ($[33] !== clearAllFilters || $[34] !== commonAttributes || $[35] !== fireAnalyticsEvent || $[36] !== intentDetectionCohort || $[37] !== isTaskActive || $[38] !== modelId || $[39] !== nonPrivacySafeAttributes || $[40] !== patternType || $[41] !== primaryMode || $[42] !== primaryProduct || $[43] !== query || $[44] !== searchSessionId || $[45] !== setQuickFindOpen || $[46] !== updateRecentQueries || $[47] !== user) {
        t11 = (event, selectedMode, buttonPosition)=>{
            const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event);
            if (!newTab) {
                setQuickFindOpen(false);
                clearAllFilters();
            }
            const trimmedQuery = query.trim();
            if (trimmedQuery !== "" && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)({
                    value: {
                        query: trimmedQuery,
                        metadata: {
                            intentMode: selectedMode
                        }
                    },
                    userId: user.id,
                    productId: primaryProduct,
                    key: (0, $1SV4e.RECENT_SEARCH_KEY)
                });
                updateRecentQueries?.();
            }
            const queryHash = (0, $731W9.sha256Hash)(query);
            const wordCount = (0, $inrbX.getWordCount)(query);
            fireAnalyticsEvent((0, $7e10cef09d2fc3c1$export$c13db7c4cba50c39)({
                attributes: {
                    searchSessionId: searchSessionId || "",
                    selectedMode: selectedMode,
                    queryClassification: primaryMode,
                    queryHash: queryHash,
                    buttonPosition: buttonPosition,
                    queryLength: query.length,
                    wordCount: wordCount,
                    networkResponded: !isTaskActive(),
                    modelId: modelId,
                    cohort: intentDetectionCohort,
                    patternType: patternType
                }
            }));
            fireAnalyticsEvent((0, $b2e1078ac279219a$export$50f1b1860bee88e0)({
                actionSubjectId: "jiraAdvancedSearchLink",
                attributes: {
                    ...commonAttributes,
                    newTab: newTab,
                    isLoading: isTaskActive(),
                    selectedMode: selectedMode,
                    buttonPosition: buttonPosition,
                    queryClassification: primaryMode,
                    modelId: modelId,
                    wordCount: wordCount,
                    cohort: intentDetectionCohort,
                    patternType: patternType
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        $[33] = clearAllFilters;
        $[34] = commonAttributes;
        $[35] = fireAnalyticsEvent;
        $[36] = intentDetectionCohort;
        $[37] = isTaskActive;
        $[38] = modelId;
        $[39] = nonPrivacySafeAttributes;
        $[40] = patternType;
        $[41] = primaryMode;
        $[42] = primaryProduct;
        $[43] = query;
        $[44] = searchSessionId;
        $[45] = setQuickFindOpen;
        $[46] = updateRecentQueries;
        $[47] = user;
        $[48] = t11;
    } else t11 = $[48];
    const handleResultClicked = t11;
    (0, $4tgkZ.INTENT_DETECTION).update({
        mode: primaryMode,
        route: primaryMode === (0, $4tgkZ.IntentMode).FPS ? allAppsUrl : jiraWorkItemsUrl,
        query: query,
        modelId: modelId,
        patternType: patternType
    });
    let t12;
    if ($[49] !== primaryMode) {
        t12 = primaryMode === (0, $4tgkZ.IntentMode).GNIN ? [
            (0, $4tgkZ.IntentMode).GNIN,
            (0, $4tgkZ.IntentMode).FPS
        ] : [
            (0, $4tgkZ.IntentMode).FPS,
            (0, $4tgkZ.IntentMode).GNIN
        ];
        $[49] = primaryMode;
        $[50] = t12;
    } else t12 = $[50];
    const orderedModes = t12;
    let t13;
    if ($[51] !== allAppsLabel) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymXE))), {
            label: allAppsLabel
        }));
        $[51] = allAppsLabel;
        $[52] = t13;
    } else t13 = $[52];
    let t14;
    if ($[53] !== intl || $[54] !== query) {
        t14 = query || intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).searchForAllApps);
        $[53] = intl;
        $[54] = query;
        $[55] = t14;
    } else t14 = $[55];
    let t15;
    if ($[56] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $23cd74b8ba084de6$var$styles.intentRouterQuery
        }, t14);
        $[56] = t14;
        $[57] = t15;
    } else t15 = $[57];
    let t16;
    if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, "\u2013\u2013");
        $[58] = t16;
    } else t16 = $[58];
    let t17;
    if ($[59] !== intl) {
        t17 = intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).allApps);
        $[59] = intl;
        $[60] = t17;
    } else t17 = $[60];
    let t18;
    if ($[61] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, t17);
        $[61] = t17;
        $[62] = t18;
    } else t18 = $[62];
    let t19;
    if ($[63] !== remainingAppCount || $[64] !== showGitHubIntentIcon) {
        t19 = showGitHubIntentIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd769c125e18159$export$cc2dff6cea6c5d2c), {
            appCount: remainingAppCount
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1aa88845bd0865d7$export$a9ec35d044cf4cf), {
            appCount: remainingAppCount,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3KrAM.AllAppsIcon), null)
        });
        $[63] = remainingAppCount;
        $[64] = showGitHubIntentIcon;
        $[65] = t19;
    } else t19 = $[65];
    let t20;
    if ($[66] !== t15 || $[67] !== t18 || $[68] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "row",
            alignItems: "center",
            gap: "space.100"
        }, t15, t16, t18, t19);
        $[66] = t15;
        $[67] = t18;
        $[68] = t19;
        $[69] = t20;
    } else t20 = $[69];
    let t21;
    if ($[70] !== handleResultClicked || $[71] !== primaryMode) {
        t21 = (event_0)=>handleResultClicked(event_0, (0, $4tgkZ.IntentMode).FPS, primaryMode === (0, $4tgkZ.IntentMode).FPS ? 0 : 1);
        $[70] = handleResultClicked;
        $[71] = primaryMode;
        $[72] = t21;
    } else t21 = $[72];
    let t22;
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null);
        $[73] = t22;
    } else t22 = $[73];
    let t23;
    if ($[74] !== allAppsUrl || $[75] !== primarySubProduct || $[76] !== t13 || $[77] !== t20 || $[78] !== t21) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            key: "intent-all-apps",
            id: "intent-all-apps",
            resultType: "intentRouter",
            primarySubProduct: primarySubProduct,
            icon: t13,
            title: t20,
            url: allAppsUrl,
            onResultClicked: t21,
            highlightedRightMetadata: t22
        });
        $[74] = allAppsUrl;
        $[75] = primarySubProduct;
        $[76] = t13;
        $[77] = t20;
        $[78] = t21;
        $[79] = t23;
    } else t23 = $[79];
    let t24;
    if ($[80] !== jiraWorkItemsLabel) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
            label: jiraWorkItemsLabel
        }));
        $[80] = jiraWorkItemsLabel;
        $[81] = t24;
    } else t24 = $[81];
    let t25;
    if ($[82] !== intl || $[83] !== query) {
        t25 = query || intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).searchForJiraWorkItems);
        $[82] = intl;
        $[83] = query;
        $[84] = t25;
    } else t25 = $[84];
    let t26;
    if ($[85] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $23cd74b8ba084de6$var$styles.intentRouterQuery
        }, t25);
        $[85] = t25;
        $[86] = t26;
    } else t26 = $[86];
    let t27;
    if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, "\u2013\u2013");
        $[87] = t27;
    } else t27 = $[87];
    let t28;
    if ($[88] !== intl) {
        t28 = intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).jiraWorkItems);
        $[88] = intl;
        $[89] = t28;
    } else t28 = $[89];
    let t29;
    if ($[90] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, t28);
        $[90] = t28;
        $[91] = t29;
    } else t29 = $[91];
    let t30;
    if ($[92] !== t26 || $[93] !== t29) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "row",
            gap: "space.100"
        }, t26, t27, t29);
        $[92] = t26;
        $[93] = t29;
        $[94] = t30;
    } else t30 = $[94];
    let t31;
    if ($[95] !== handleResultClicked || $[96] !== primaryMode) {
        t31 = (event_1)=>handleResultClicked(event_1, (0, $4tgkZ.IntentMode).GNIN, primaryMode === (0, $4tgkZ.IntentMode).GNIN ? 0 : 1);
        $[95] = handleResultClicked;
        $[96] = primaryMode;
        $[97] = t31;
    } else t31 = $[97];
    let t32;
    if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null);
        $[98] = t32;
    } else t32 = $[98];
    let t33;
    if ($[99] !== jiraWorkItemsUrl || $[100] !== primarySubProduct || $[101] !== t24 || $[102] !== t30 || $[103] !== t31) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            key: "intent-jira-work-items",
            id: "intent-jira-work-items",
            resultType: "intentRouter",
            primarySubProduct: primarySubProduct,
            icon: t24,
            title: t30,
            url: jiraWorkItemsUrl,
            onResultClicked: t31,
            highlightedRightMetadata: t32
        });
        $[99] = jiraWorkItemsUrl;
        $[100] = primarySubProduct;
        $[101] = t24;
        $[102] = t30;
        $[103] = t31;
        $[104] = t33;
    } else t33 = $[104];
    let t34;
    if ($[105] !== t23 || $[106] !== t33) {
        t34 = {
            [(0, $4tgkZ.IntentMode).FPS]: t23,
            [(0, $4tgkZ.IntentMode).GNIN]: t33
        };
        $[105] = t23;
        $[106] = t33;
        $[107] = t34;
    } else t34 = $[107];
    const rowsByMode = t34;
    let t35;
    if ($[108] !== orderedModes) {
        t35 = orderedModes.map($23cd74b8ba084de6$var$_temp);
        $[108] = orderedModes;
        $[109] = t35;
    } else t35 = $[109];
    const order = t35;
    let t36;
    if ($[110] !== isLoading || $[111] !== matchingItem || $[112] !== query || $[113] !== showMatchingWorkItem) {
        t36 = showMatchingWorkItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $814392873146e4c1$export$2e2bcd8739ae039), {
            matchingItem: matchingItem,
            query: query,
            isLoading: isLoading
        });
        $[110] = isLoading;
        $[111] = matchingItem;
        $[112] = query;
        $[113] = showMatchingWorkItem;
        $[114] = t36;
    } else t36 = $[114];
    let t37;
    if ($[115] !== intl) {
        t37 = intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).searchResultsHeading);
        $[115] = intl;
        $[116] = t37;
    } else t37 = $[116];
    let t38;
    if ($[117] !== t37) {
        t38 = {
            role: "listbox",
            "aria-label": t37
        };
        $[117] = t37;
        $[118] = t38;
    } else t38 = $[118];
    let t39;
    if ($[119] !== rowsByMode) {
        t39 = (key)=>key === "intent-all-apps" ? rowsByMode[(0, $4tgkZ.IntentMode).FPS] : rowsByMode[(0, $4tgkZ.IntentMode).GNIN];
        $[119] = rowsByMode;
        $[120] = t39;
    } else t39 = $[120];
    let t40;
    if ($[121] !== disabled || $[122] !== order || $[123] !== t38 || $[124] !== t39) {
        t40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8fd72204c218acd$export$3d1498497a812571), {
            order: order,
            disabled: disabled,
            containerAs: "div",
            containerProps: t38,
            itemAs: "div",
            renderItem: t39,
            xcss: $23cd74b8ba084de6$var$styles.root
        });
        $[121] = disabled;
        $[122] = order;
        $[123] = t38;
        $[124] = t39;
        $[125] = t40;
    } else t40 = $[125];
    let t41;
    if ($[126] !== t36 || $[127] !== t40) {
        t41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t36, t40);
        $[126] = t36;
        $[127] = t40;
        $[128] = t41;
    } else t41 = $[128];
    return t41;
} : ({ query: query, minQueryLength: minQueryLength, matchingItem: matchingItem, isLoading: isLoading, showMatchingWorkItem: showMatchingWorkItem })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [primarySubProduct] = (0, $j4ply.usePrimarySubProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { isTaskActive: isTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)(); // Show the GitHub icon variant in the All Apps row for Jira brand awareness.
    // No GitHub connection check is needed here. The dropdown app-selector separately gates on
    // connection status since it is a functional feature that requires GitHub to be connected.
    const showGitHubIntentIcon = primaryProduct === 'jira';
    const remainingAppCount = (0, $42omo.useMemo)(()=>(0, $af90b002ca1d8064$export$f9fde84c1bef3da9)(availableProducts, thirdPartyConfigs, productConfigs, (0, $gGFxq.isUserOAuthed)), [
        availableProducts,
        thirdPartyConfigs,
        productConfigs
    ]);
    const intentDetectionExperiment = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: intl.locale
    });
    const intentDetectionModelId = intentDetectionExperiment?.modelId;
    const intentDetectionCohort = intentDetectionExperiment?.cohort;
    const modelId = (0, $f09a3b1faa1fe617$export$9fbbf51870efdf63)(intentDetectionModelId) ? intentDetectionModelId : (0, $bAgd8.KnowledgeDiscoveryJiraIntentDetectionModel).GNIN_HEURISTIC;
    const allAppsLabel = intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).allApps);
    const jiraWorkItemsLabel = intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).jiraWorkItems);
    const { allAppsUrl: allAppsUrl, defaultMode: defaultMode } = (0, $5b4b660e006bbec8$export$d5bb993f77e7dea0)({
        query: query,
        minQueryLength: minQueryLength
    }); // Use the initial primary mode as the default mode for intent detection
    const intentDetection = (0, $4ab2bcada25ac17b$export$c5d196f0984a6b2)({
        defaultMode: defaultMode
    }); // Omitting pauseAndResume from the result as it is not needed for intent router.
    // If we need it in the future, we can add it back to the result.
    const { primaryMode: primaryMode, patternType: patternType, isPaused: disabled } = (0, $b995e1f2175cfd57$export$227eeed9835398d5)({
        query: query,
        debounceMs: 250,
        intentDetection: intentDetection,
        initialPrimaryMode: defaultMode,
        minQueryLength: minQueryLength
    });
    const { jiraWorkItemsUrl: jiraWorkItemsUrl } = (0, $5b4b660e006bbec8$export$f0f4ca1fb8eb9f3e)({
        query: query,
        showMatchingWorkItem: showMatchingWorkItem,
        isLoading: isLoading,
        patternType: patternType
    }); // Keep keyboard selection in sync with the active intent mode and query.
    (0, $60e53d874e754083$export$351560332f190b8f)({
        primaryMode: primaryMode,
        query: query,
        showMatchingWorkItem: showMatchingWorkItem,
        hasMatchingWorkItem: !!matchingItem,
        isLoadingWorkItem: isLoading
    });
    const handleResultClicked = (0, $42omo.useCallback)((event, selectedMode, buttonPosition)=>{
        const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event);
        if (!newTab) {
            setQuickFindOpen(false); // Keep parity with "Enter on input" behaviour: reset QF filters as FPS is the source of truth.
            clearAllFilters();
        }
        const trimmedQuery = query.trim();
        if (trimmedQuery !== '' && user && user.id && primaryProduct) {
            (0, $1SV4e.addRecentSearch)({
                value: {
                    query: trimmedQuery,
                    metadata: {
                        intentMode: selectedMode
                    }
                },
                userId: user.id,
                productId: primaryProduct,
                key: (0, $1SV4e.RECENT_SEARCH_KEY)
            });
            updateRecentQueries?.();
        }
        const queryHash = (0, $731W9.sha256Hash)(query);
        const wordCount = (0, $inrbX.getWordCount)(query);
        fireAnalyticsEvent((0, $7e10cef09d2fc3c1$export$c13db7c4cba50c39)({
            attributes: {
                searchSessionId: searchSessionId || '',
                selectedMode: selectedMode,
                queryClassification: primaryMode,
                queryHash: queryHash,
                buttonPosition: buttonPosition,
                queryLength: query.length,
                wordCount: wordCount,
                networkResponded: !isTaskActive(),
                modelId: modelId,
                cohort: intentDetectionCohort,
                patternType: patternType
            }
        }));
        fireAnalyticsEvent((0, $b2e1078ac279219a$export$50f1b1860bee88e0)({
            actionSubjectId: 'jiraAdvancedSearchLink',
            attributes: {
                ...commonAttributes,
                newTab: newTab,
                isLoading: isTaskActive(),
                selectedMode: selectedMode,
                buttonPosition: buttonPosition,
                queryClassification: primaryMode,
                modelId: modelId,
                wordCount: wordCount,
                cohort: intentDetectionCohort,
                patternType: patternType
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        clearAllFilters,
        commonAttributes,
        fireAnalyticsEvent,
        modelId,
        nonPrivacySafeAttributes,
        primaryMode,
        patternType,
        primaryProduct,
        query,
        searchSessionId,
        setQuickFindOpen,
        updateRecentQueries,
        user,
        isTaskActive,
        intentDetectionCohort
    ]);
    // Update the global intent detection result
    (0, $4tgkZ.INTENT_DETECTION).update({
        mode: primaryMode,
        route: primaryMode === (0, $4tgkZ.IntentMode).FPS ? allAppsUrl : jiraWorkItemsUrl,
        query: query,
        modelId: // store the query to aid hydration
        modelId,
        patternType: patternType
    });
    const orderedModes = primaryMode === (0, $4tgkZ.IntentMode).GNIN ? [
        (0, $4tgkZ.IntentMode).GNIN,
        (0, $4tgkZ.IntentMode).FPS
    ] : [
        (0, $4tgkZ.IntentMode).FPS,
        (0, $4tgkZ.IntentMode).GNIN
    ];
    const rowsByMode = {
        [(0, $4tgkZ.IntentMode).FPS]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            key: "intent-all-apps",
            id: "intent-all-apps",
            resultType: "intentRouter",
            primarySubProduct: primarySubProduct,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
                label: "",
                size: "small"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymXE))), {
                label: allAppsLabel
            })),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                direction: "row",
                alignItems: "center",
                gap: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $23cd74b8ba084de6$var$styles.intentRouterQuery
            }, query || intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).searchForAllApps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest"
            }, "\u2013\u2013"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest"
            }, intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).allApps)), showGitHubIntentIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bcd769c125e18159$export$cc2dff6cea6c5d2c), {
                appCount: remainingAppCount
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1aa88845bd0865d7$export$a9ec35d044cf4cf), {
                appCount: remainingAppCount,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3KrAM.AllAppsIcon), null)
            })),
            url: allAppsUrl,
            onResultClicked: (event_0)=>handleResultClicked(event_0, (0, $4tgkZ.IntentMode).FPS, primaryMode === (0, $4tgkZ.IntentMode).FPS ? 0 : 1),
            highlightedRightMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null)
        }),
        [(0, $4tgkZ.IntentMode).GNIN]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            key: "intent-jira-work-items",
            id: "intent-jira-work-items",
            resultType: "intentRouter",
            primarySubProduct: primarySubProduct,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
                label: "",
                size: "small"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
                label: jiraWorkItemsLabel
            })),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                direction: "row",
                gap: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $23cd74b8ba084de6$var$styles.intentRouterQuery
            }, query || intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).searchForJiraWorkItems)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest"
            }, "\u2013\u2013"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest"
            }, intl.formatMessage((0, $627c5d243ba159b8$export$defe85febe8b728c).jiraWorkItems))),
            url: jiraWorkItemsUrl,
            onResultClicked: (event_1)=>handleResultClicked(event_1, (0, $4tgkZ.IntentMode).GNIN, primaryMode === (0, $4tgkZ.IntentMode).GNIN ? 0 : 1),
            highlightedRightMetadata: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null)
        })
    };
    const order = orderedModes.map((mode)=>mode === (0, $4tgkZ.IntentMode).FPS ? 'intent-all-apps' : 'intent-jira-work-items');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, showMatchingWorkItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $814392873146e4c1$export$2e2bcd8739ae039), {
        matchingItem: matchingItem,
        query: query,
        isLoading: isLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8fd72204c218acd$export$3d1498497a812571), {
        order: order,
        disabled: disabled,
        containerAs: "div",
        containerProps: {
            role: 'listbox',
            'aria-label': intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).searchResultsHeading)
        },
        itemAs: "div",
        renderItem: (key)=>{
            return key === 'intent-all-apps' ? rowsByMode[(0, $4tgkZ.IntentMode).FPS] : rowsByMode[(0, $4tgkZ.IntentMode).GNIN];
        },
        xcss: $23cd74b8ba084de6$var$styles.root
    }));
};
function $23cd74b8ba084de6$var$_temp(mode) {
    return mode === (0, $4tgkZ.IntentMode).FPS ? "intent-all-apps" : "intent-jira-work-items";
}








parcelRequire("42omo");














const $c10614ba7bac14be$var$DEBOUNCE_MS = 250;
const $c10614ba7bac14be$export$65df0c58ae3a76fd = ({ query: query, minQueryLength: minQueryLength })=>{
    const intentDetection = (0, $4ab2bcada25ac17b$export$c5d196f0984a6b2)({
        defaultMode: (0, $4tgkZ.IntentMode).GNIN
    });
    const latestQueryRef = (0, $42omo.useRef)(query);
    latestQueryRef.current = query;
    // Track the last query we triggered detection for to avoid duplicate calls
    const lastDetectedQueryRef = (0, $42omo.useRef)(null);
    const runDetection = (0, $42omo.useCallback)(async ()=>{
        const q = latestQueryRef.current;
        if (q.length < minQueryLength) return;
        const result = await intentDetection(q);
        (0, $4tgkZ.INTENT_DETECTION).update({
            mode: result.mode,
            route: '',
            query: q,
            modelId: result.modelId ?? (0, $bAgd8.KnowledgeDiscoveryJiraIntentDetectionModel).GNIN_HEURISTIC,
            patternType: result.patternType
        });
    }, [
        intentDetection,
        minQueryLength
    ]);
    const debouncedDetect = (0, $JQd0k.useDebouncedCallback)(runDetection, $c10614ba7bac14be$var$DEBOUNCE_MS);
    const shouldRun = query.length >= minQueryLength;
    (0, $42omo.useEffect)(()=>{
        if (!shouldRun) return;
        // Skip if we already triggered detection for this exact query
        if (lastDetectedQueryRef.current === query) return;
        lastDetectedQueryRef.current = query;
        debouncedDetect();
        return ()=>{
            debouncedDetect.cancel();
        };
    }, [
        debouncedDetect,
        shouldRun,
        query
    ]);
};


const $2ccfd5a35e0b69bb$export$cc3a06c46f6a3d2b = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { query: query, minQueryLength: minQueryLength } = t0;
    let t1;
    if ($[0] !== minQueryLength || $[1] !== query) {
        t1 = {
            query: query,
            minQueryLength: minQueryLength
        };
        $[0] = minQueryLength;
        $[1] = query;
        $[2] = t1;
    } else t1 = $[2];
    (0, $c10614ba7bac14be$export$65df0c58ae3a76fd)(t1);
    return null;
} : ({ query: query, minQueryLength: minQueryLength })=>{
    (0, $c10614ba7bac14be$export$65df0c58ae3a76fd)({
        query: query,
        minQueryLength: minQueryLength
    });
    return null;
};
































const $738ebcb5194247d5$export$76bfbab5e3f9a6a3 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "20",
            height: "20",
            rx: "3",
            fill: "var(--ds-background-neutral, #0515240F)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M7.89453 8.89551H6.88965C5.80957 8.89551 4.93457 8.04785 4.93457 6.96094C4.93457 5.87402 5.80957 4.99902 6.88965 4.99902C7.96973 4.99902 8.84473 5.87402 8.84473 6.96094V7.95898H11.1553V6.96094C11.1553 5.87402 12.0303 4.99902 13.1104 4.99902C14.1904 4.99902 15.0654 5.87402 15.0654 6.96094C15.0654 8.04785 14.1904 8.89551 13.1104 8.89551H12.1123V11.2402H13.1104C14.1904 11.2402 15.0654 12.0879 15.0654 13.1748C15.0654 14.2617 14.1904 15.1367 13.1104 15.1367C12.0303 15.1367 11.1553 14.2617 11.1553 13.1748V12.1768H8.84473V13.1748C8.84473 14.2617 7.96973 15.1367 6.88965 15.1367C5.80957 15.1367 4.93457 14.2617 4.93457 13.1748C4.93457 12.0879 5.80957 11.2402 6.88965 11.2402H7.89453V8.89551ZM6.88965 7.97266H7.89453V6.96094C7.89453 6.40723 7.43652 5.95605 6.88965 5.95605C6.34277 5.95605 5.88477 6.40723 5.88477 6.96094C5.88477 7.51465 6.34277 7.97266 6.88965 7.97266ZM13.1104 7.97266C13.6572 7.97266 14.1152 7.51465 14.1152 6.96094C14.1152 6.40723 13.6572 5.95605 13.1104 5.95605C12.5635 5.95605 12.1123 6.40723 12.1123 6.96094V7.97266H13.1104ZM8.84473 11.2539H11.1553V8.88184H8.84473V11.2539ZM6.88965 12.1562C6.34277 12.1562 5.88477 12.6143 5.88477 13.168C5.88477 13.7217 6.34277 14.1729 6.88965 14.1729C7.43652 14.1729 7.89453 13.7217 7.89453 13.168V12.1562H6.88965ZM13.1104 12.1562H12.1123V13.168C12.1123 13.7217 12.5635 14.1729 13.1104 14.1729C13.6572 14.1729 14.1152 13.7217 14.1152 13.168C14.1152 12.6143 13.6572 12.1562 13.1104 12.1562Z",
            fill: "var(--ds-icon-subtle, #505258)"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "20",
        height: "20",
        rx: "3",
        fill: "var(--ds-background-neutral, #0515240F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.89453 8.89551H6.88965C5.80957 8.89551 4.93457 8.04785 4.93457 6.96094C4.93457 5.87402 5.80957 4.99902 6.88965 4.99902C7.96973 4.99902 8.84473 5.87402 8.84473 6.96094V7.95898H11.1553V6.96094C11.1553 5.87402 12.0303 4.99902 13.1104 4.99902C14.1904 4.99902 15.0654 5.87402 15.0654 6.96094C15.0654 8.04785 14.1904 8.89551 13.1104 8.89551H12.1123V11.2402H13.1104C14.1904 11.2402 15.0654 12.0879 15.0654 13.1748C15.0654 14.2617 14.1904 15.1367 13.1104 15.1367C12.0303 15.1367 11.1553 14.2617 11.1553 13.1748V12.1768H8.84473V13.1748C8.84473 14.2617 7.96973 15.1367 6.88965 15.1367C5.80957 15.1367 4.93457 14.2617 4.93457 13.1748C4.93457 12.0879 5.80957 11.2402 6.88965 11.2402H7.89453V8.89551ZM6.88965 7.97266H7.89453V6.96094C7.89453 6.40723 7.43652 5.95605 6.88965 5.95605C6.34277 5.95605 5.88477 6.40723 5.88477 6.96094C5.88477 7.51465 6.34277 7.97266 6.88965 7.97266ZM13.1104 7.97266C13.6572 7.97266 14.1152 7.51465 14.1152 6.96094C14.1152 6.40723 13.6572 5.95605 13.1104 5.95605C12.5635 5.95605 12.1123 6.40723 12.1123 6.96094V7.97266H13.1104ZM8.84473 11.2539H11.1553V8.88184H8.84473V11.2539ZM6.88965 12.1562C6.34277 12.1562 5.88477 12.6143 5.88477 13.168C5.88477 13.7217 6.34277 14.1729 6.88965 14.1729C7.43652 14.1729 7.89453 13.7217 7.89453 13.168V12.1562H6.88965ZM13.1104 12.1562H12.1123V13.168C12.1123 13.7217 12.5635 14.1729 13.1104 14.1729C13.6572 14.1729 14.1152 13.7217 14.1152 13.168C14.1152 12.6143 13.6572 12.1562 13.1104 12.1562Z",
        fill: "var(--ds-icon-subtle, #505258)"
    }));






































const $02caee92bec6b3d2$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.100',
    paddingInlineStart: 'space.200',
    paddingInlineEnd: 'space.200',
    display: 'flex',
    alignItems: 'center'
});
const $02caee92bec6b3d2$var$resultHoveredStlyes = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $02caee92bec6b3d2$var$keyboardHighlightedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $02caee92bec6b3d2$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $02caee92bec6b3d2$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $02caee92bec6b3d2$var$titleStyles = (0, $ecnYn.xcss)({
    overflow: 'clip',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $02caee92bec6b3d2$var$textOverflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $02caee92bec6b3d2$var$rightSectionStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'space.150'
});
const $02caee92bec6b3d2$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
    ':focus-visible': {
        outlineStyle: 'solid',
        outlineColor: 'color.border.accent.blue',
        outlineWidth: 'border.width.focused',
        // @ts-ignore
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $02caee92bec6b3d2$export$64ded8b71dfcba9e = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { icon: icon, title: title, rightMetadata: rightMetadata, url: url, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu } = t0;
    const ref = (0, $42omo.useRef)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            onKeydownCallback: ()=>{
                ref.current?.click();
            },
            onHighlightedCallback: $02caee92bec6b3d2$var$_temp
        };
        $[0] = t1;
    } else t1 = $[0];
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)(t1);
    let t2;
    if ($[1] !== onResultClicked) {
        t2 = (event)=>{
            onResultClicked?.(event);
        };
        $[1] = onResultClicked;
        $[2] = t2;
    } else t2 = $[2];
    const onClick = t2;
    let t3;
    if ($[3] !== onResultContextMenu) {
        t3 = (event_0)=>{
            onResultContextMenu?.(event_0);
        };
        $[3] = onResultContextMenu;
        $[4] = t3;
    } else t3 = $[4];
    const onContextMenu = t3;
    let t4;
    if ($[5] !== icon || $[6] !== isHovered || $[7] !== isKeyboardHighlighted || $[8] !== onClick || $[9] !== onContextMenu || $[10] !== rightMetadata || $[11] !== setRef || $[12] !== title || $[13] !== url) {
        t4 = (0, $dh538.fg)("custom-interactive-elements-not-keyboard-focusable") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            padding: "space.0",
            backgroundColor: "color.background.neutral.subtle",
            onClick: onClick,
            onContextMenu: onContextMenu,
            testId: "search-dialog-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
            xcss: [
                $02caee92bec6b3d2$var$linkStyles
            ],
            href: url,
            testId: "search-dialog-footer-link"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $02caee92bec6b3d2$var$resultStyles,
                isHovered && $02caee92bec6b3d2$var$resultHoveredStlyes,
                isKeyboardHighlighted && $02caee92bec6b3d2$var$keyboardHighlightedStyles
            ],
            ref: (node)=>{
                ref.current = node;
                setRef(node);
            },
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $02caee92bec6b3d2$var$iconAreaStyles
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $02caee92bec6b3d2$var$middleAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $02caee92bec6b3d2$var$titleStyles,
                $02caee92bec6b3d2$var$textOverflowStyles
            ]
        }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $02caee92bec6b3d2$var$rightSectionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26eSY.Show), {
            above: "xs"
        }, rightMetadata))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            onClick: onClick,
            onContextMenu: onContextMenu,
            testId: "search-dialog-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
            xcss: [
                $02caee92bec6b3d2$var$linkStyles
            ],
            href: url,
            testId: "search-dialog-footer-link"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $02caee92bec6b3d2$var$resultStyles,
                isHovered && $02caee92bec6b3d2$var$resultHoveredStlyes,
                isKeyboardHighlighted && $02caee92bec6b3d2$var$keyboardHighlightedStyles
            ],
            ref: (node_0)=>{
                ref.current = node_0;
                setRef(node_0);
            },
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $02caee92bec6b3d2$var$iconAreaStyles
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $02caee92bec6b3d2$var$middleAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $02caee92bec6b3d2$var$titleStyles,
                $02caee92bec6b3d2$var$textOverflowStyles
            ]
        }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $02caee92bec6b3d2$var$rightSectionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26eSY.Show), {
            above: "xs"
        }, rightMetadata)))));
        $[5] = icon;
        $[6] = isHovered;
        $[7] = isKeyboardHighlighted;
        $[8] = onClick;
        $[9] = onContextMenu;
        $[10] = rightMetadata;
        $[11] = setRef;
        $[12] = title;
        $[13] = url;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ icon: icon, title: title, rightMetadata: rightMetadata, url: url, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu })=>{
    const ref = (0, $42omo.useRef)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: ()=>{
            ref.current?.click();
        },
        onHighlightedCallback: ()=>{}
    });
    const onClick = (0, $42omo.useCallback)((event)=>{
        onResultClicked?.(event);
    }, [
        onResultClicked
    ]);
    const onContextMenu = (0, $42omo.useCallback)((event_0)=>{
        onResultContextMenu?.(event_0);
    }, [
        onResultContextMenu
    ]);
    return (0, $dh538.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        // Reset the native <button> default padding so the Pressable variant
        // renders with the same inset as the <Box> (div) variant below.
        padding: "space.0",
        backgroundColor: "color.background.neutral.subtle",
        onClick: onClick,
        onContextMenu: onContextMenu,
        testId: "search-dialog-footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
        xcss: [
            $02caee92bec6b3d2$var$linkStyles
        ],
        href: url,
        testId: "search-dialog-footer-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $02caee92bec6b3d2$var$resultStyles,
            isHovered && $02caee92bec6b3d2$var$resultHoveredStlyes,
            isKeyboardHighlighted && $02caee92bec6b3d2$var$keyboardHighlightedStyles
        ],
        ref: (node)=>{
            ref.current = node;
            setRef(node);
        },
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $02caee92bec6b3d2$var$iconAreaStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $02caee92bec6b3d2$var$middleAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $02caee92bec6b3d2$var$titleStyles,
            $02caee92bec6b3d2$var$textOverflowStyles
        ]
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $02caee92bec6b3d2$var$rightSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26eSY.Show), {
        above: "xs"
    }, rightMetadata))))) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        onClick: onClick,
        onContextMenu: onContextMenu,
        testId: "search-dialog-footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
        xcss: [
            $02caee92bec6b3d2$var$linkStyles
        ],
        href: url,
        testId: "search-dialog-footer-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $02caee92bec6b3d2$var$resultStyles,
            isHovered && $02caee92bec6b3d2$var$resultHoveredStlyes,
            isKeyboardHighlighted && $02caee92bec6b3d2$var$keyboardHighlightedStyles
        ],
        ref: (node_0)=>{
            ref.current = node_0;
            setRef(node_0);
        },
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $02caee92bec6b3d2$var$iconAreaStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $02caee92bec6b3d2$var$middleAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $02caee92bec6b3d2$var$titleStyles,
            $02caee92bec6b3d2$var$textOverflowStyles
        ]
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $02caee92bec6b3d2$var$rightSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $26eSY.Show), {
        above: "xs"
    }, rightMetadata)))));
};
function $02caee92bec6b3d2$var$_temp() {}





















const $cb4c307b2668c972$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    jiraSearchWorkItems: {
        id: "jira_advanced_search",
        defaultMessage: "Search Jira for work items"
    }
});


const $e02869b185b9e3c4$var$ACTION_SUBJECT_ID = 'jiraAdvancedIssueSearch';
const $e02869b185b9e3c4$export$104db48ac99dc257 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { state: state, onClick: onClick } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const { selectedFilters: t2 } = (0, $4VkIo.useSelectedFilters)(t1);
    const { jiraFilters: jiraFilters } = t2;
    let t3;
    if ($[1] !== primaryProduct) {
        t3 = (0, $3a090af578c3c72f$export$1a414fdf8e9c6492)() && primaryProduct && primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)("jira_search_fps_cta_swap");
        $[1] = primaryProduct;
        $[2] = t3;
    } else t3 = $[2];
    const swapQuickFindCTAs = t3;
    let t4;
    if ($[3] !== intl) {
        t4 = (0, $dh538.fg)("ai-a11y-111-19638-35211") ? "" : intl.formatMessage((0, $cb4c307b2668c972$export$defe85febe8b728c).jiraSearchWorkItems);
        $[3] = intl;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: t4,
            color: "currentColor"
        });
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const icon = t5;
    let t6;
    if ($[7] !== swapQuickFindCTAs) {
        t6 = swapQuickFindCTAs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $738ebcb5194247d5$export$76bfbab5e3f9a6a3), null);
        $[7] = swapQuickFindCTAs;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null);
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, t6, t7);
        $[10] = t6;
        $[11] = t8;
    } else t8 = $[11];
    const rightMetadata = t8;
    let t9;
    try {
        let t11;
        if ($[12] !== generateSearchUrl || $[13] !== jiraFilters || $[14] !== queryParams || $[15] !== quickFindQuery) {
            t11 = (0, $3fzmz.getWorkItemPageUrl)({
                query: quickFindQuery,
                jiraFilters: jiraFilters,
                generateSearchUrl: generateSearchUrl,
                queryParams: queryParams,
                isQueryJql: (0, $4tgkZ.isJqlQueryDetected)(quickFindQuery)
            });
            $[12] = generateSearchUrl;
            $[13] = jiraFilters;
            $[14] = queryParams;
            $[15] = quickFindQuery;
            $[16] = t11;
        } else t11 = $[16];
        t9 = t11;
    } catch (t10) {
        t9 = (0, $88b96a73873e73ff$export$da00a8e161805bdf);
    }
    const workItemPageUrl = t9;
    let t11;
    if ($[17] !== onClick || $[18] !== state) {
        t11 = (event)=>{
            onClick({
                state: state,
                event: event,
                actionSubjectId: $e02869b185b9e3c4$var$ACTION_SUBJECT_ID
            });
        };
        $[17] = onClick;
        $[18] = state;
        $[19] = t11;
    } else t11 = $[19];
    const onResultClicked = t11;
    let t12;
    if ($[20] !== intl) {
        t12 = intl.formatMessage((0, $cb4c307b2668c972$export$defe85febe8b728c).jiraSearchWorkItems);
        $[20] = intl;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== icon || $[23] !== onResultClicked || $[24] !== rightMetadata || $[25] !== t12 || $[26] !== workItemPageUrl) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02caee92bec6b3d2$export$64ded8b71dfcba9e), {
            icon: icon,
            title: t12,
            rightMetadata: rightMetadata,
            url: workItemPageUrl,
            onResultClicked: onResultClicked
        });
        $[22] = icon;
        $[23] = onResultClicked;
        $[24] = rightMetadata;
        $[25] = t12;
        $[26] = workItemPageUrl;
        $[27] = t13;
    } else t13 = $[27];
    return t13;
} : ({ state: state, onClick: onClick })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { selectedFilters: { jiraFilters: jiraFilters } } = (0, $4VkIo.useSelectedFilters)({});
    const swapQuickFindCTAs = (0, $3a090af578c3c72f$export$1a414fdf8e9c6492)() && primaryProduct && primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_search_fps_cta_swap');
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: (0, $dh538.fg)('ai-a11y-111-19638-35211') ? '' : intl.formatMessage((0, $cb4c307b2668c972$export$defe85febe8b728c).jiraSearchWorkItems),
        color: "currentColor"
    });
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, swapQuickFindCTAs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $738ebcb5194247d5$export$76bfbab5e3f9a6a3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const workItemPageUrl = (0, $42omo.useMemo)(()=>{
        try {
            return (0, $3fzmz.getWorkItemPageUrl)({
                query: quickFindQuery,
                jiraFilters: jiraFilters,
                generateSearchUrl: generateSearchUrl,
                queryParams: queryParams,
                isQueryJql: (0, $4tgkZ.isJqlQueryDetected)(quickFindQuery)
            });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            return 0, $88b96a73873e73ff$export$da00a8e161805bdf;
        }
    }, [
        queryParams,
        generateSearchUrl,
        quickFindQuery,
        jiraFilters
    ]);
    const onResultClicked = (0, $42omo.useCallback)((event)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: $e02869b185b9e3c4$var$ACTION_SUBJECT_ID
        });
    }, [
        onClick,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02caee92bec6b3d2$export$64ded8b71dfcba9e), {
        icon: icon,
        title: intl.formatMessage((0, $cb4c307b2668c972$export$defe85febe8b728c).jiraSearchWorkItems),
        rightMetadata: rightMetadata,
        url: workItemPageUrl,
        onResultClicked: onResultClicked
    });
};















var $1Ajko = parcelRequire("1Ajko");




























const $2edb72d725c5d8f9$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    jira_quick_find_single_site_label: {
        id: "jira_single_site_label",
        defaultMessage: "Go to all:"
    },
    jira_quick_find_projects: {
        id: "jira_single_site_projects",
        defaultMessage: "Projects"
    },
    jira_quick_find_spaces: {
        id: "jira_single_site_spaces",
        defaultMessage: "Spaces"
    },
    jira_quick_find_boards: {
        id: "jira_single_site_boards",
        defaultMessage: "Boards"
    },
    jira_quick_find_filters: {
        id: "jira_single_site_filters",
        defaultMessage: "Filters"
    },
    jira_quick_find_plans: {
        id: "jira_single_site_plans",
        defaultMessage: "Plans"
    },
    jira_quick_find_people: {
        id: "jira_single_site_people",
        defaultMessage: "Teams"
    },
    jira_quick_find_work_items: {
        id: "jira_single_site_work_items_jql",
        defaultMessage: "Work items (JQL)"
    }
});


const $ad3c6b6b491bd60c$var$styles = (0, $ecnYn.xcss)({
    height: '100%',
    display: 'inline-block'
});
const $ad3c6b6b491bd60c$var$singleSiteContainer = (0, $ecnYn.xcss)({
    padding: 'space.100'
});
const $ad3c6b6b491bd60c$var$iconContainer = (0, $ecnYn.xcss)({
    marginLeft: 'space.150',
    marginRight: 'space.200'
});
const $ad3c6b6b491bd60c$var$styleLink = (0, $ecnYn.xcss)({
    WebkitBoxAlign: 'baseline',
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'inline-flex',
    justifyContent: 'center',
    fontWeight: 'font.weight.medium',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    marginRight: 'space.100',
    color: 'color.text.subtle',
    textDecoration: 'none',
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    ':hover': {
        color: 'color.text.subtle',
        backgroundColor: 'color.background.neutral.hovered',
        textDecoration: 'none',
        transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
    },
    ':visited': {
        color: 'color.text.subtle'
    },
    ':focus-visible': {
        color: 'color.text.subtle'
    },
    ':focus': {
        color: 'color.text.subtle'
    }
});
var $ad3c6b6b491bd60c$var$JiraFooterLinkActionSubjectId = /*#__PURE__*/ function(JiraFooterLinkActionSubjectId) {
    JiraFooterLinkActionSubjectId["JIRA_BOARDS"] = "jiraBoardsSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_FILTERS"] = "jiraFiltersSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PROJECTS"] = "jiraProjectsSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PLANS"] = "jiraPlansSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PEOPLE"] = "jiraPeopleSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_WORK_ITEMS"] = "jiraWorkItemsSearchLink";
    return JiraFooterLinkActionSubjectId;
}($ad3c6b6b491bd60c$var$JiraFooterLinkActionSubjectId || {});
const $ad3c6b6b491bd60c$export$4c85ccfa2dce935c = (query)=>{
    const allLinks = {
        board: {
            href: `/secure/ManageRapidViews.jspa?contains=${query}`,
            message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_boards,
            actionSubjectId: "jiraBoardsSearchLink"
        },
        project: {
            href: `/projects?contains=${query}`,
            message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_spaces,
            actionSubjectId: "jiraProjectsSearchLink"
        },
        filters: {
            href: `/secure/ManageFilters.jspa?Search=Search&filterView=search&name=${query}`,
            message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_filters,
            actionSubjectId: "jiraFiltersSearchLink"
        },
        plans: {
            href: `/jira/plans`,
            message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_plans,
            actionSubjectId: "jiraPlansSearchLink"
        },
        people: {
            href: `/jira/people/search?q=${query}`,
            message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_people,
            actionSubjectId: "jiraPeopleSearchLink"
        }
    };
    return allLinks;
};
const $ad3c6b6b491bd60c$export$72bf2a5ecf09330e = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { state: state, onClick: onClick } = t0;
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    let t1;
    if ($[0] !== quickFindQuery) {
        t1 = $ad3c6b6b491bd60c$export$4c85ccfa2dce935c(quickFindQuery);
        $[0] = quickFindQuery;
        $[1] = t1;
    } else t1 = $[1];
    const searchConfiguration = t1;
    const intl = (0, $aXWIB.useIntl)();
    const intentRouterEnabled = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: (0, $6Gsan.PrimaryProductKeys).Jira,
        fireLayerExposure: false,
        locale: intl.locale
    })?.cohort === "test";
    let t2;
    bb0: {
        if (!intentRouterEnabled) {
            t2 = undefined;
            break bb0;
        }
        try {
            let t3;
            if ($[2] !== generateSearchUrl || $[3] !== queryParams || $[4] !== quickFindQuery) {
                t3 = generateSearchUrl({
                    ...queryParams,
                    text: quickFindQuery,
                    referrer: (0, $9rRKJ.SearchExperience).QUICK_FIND
                }, true, undefined, undefined, false);
                $[2] = generateSearchUrl;
                $[3] = queryParams;
                $[4] = quickFindQuery;
                $[5] = t3;
            } else t3 = $[5];
            t2 = t3;
        } catch  {
            t2 = (0, $88b96a73873e73ff$export$da00a8e161805bdf);
        }
    }
    const workItemsUrl = t2;
    let t3;
    bb1: {
        if (workItemsUrl) {
            let t4;
            if ($[6] !== workItemsUrl) {
                t4 = {
                    href: workItemsUrl,
                    message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_work_items,
                    actionSubjectId: "jiraWorkItemsSearchLink"
                };
                $[6] = workItemsUrl;
                $[7] = t4;
            } else t4 = $[7];
            let t5;
            if ($[8] !== searchConfiguration || $[9] !== t4) {
                t5 = {
                    workItems: t4,
                    ...searchConfiguration
                };
                $[8] = searchConfiguration;
                $[9] = t4;
                $[10] = t5;
            } else t5 = $[10];
            t3 = t5;
            break bb1;
        }
        t3 = searchConfiguration;
    }
    const allLinks = t3;
    let t4;
    if ($[11] !== onClick || $[12] !== state) {
        t4 = (event, actionSubjectId)=>{
            onClick({
                state: state,
                event: event,
                actionSubjectId: actionSubjectId
            });
        };
        $[11] = onClick;
        $[12] = state;
        $[13] = t4;
    } else t4 = $[13];
    const onFilterClick = t4;
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "span",
            xcss: $ad3c6b6b491bd60c$var$iconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Ajko))), {
            label: "navigate-single-site-icon"
        }));
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== allLinks) {
        t6 = Object.keys(allLinks);
        $[15] = allLinks;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== allLinks || $[18] !== onFilterClick || $[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $ad3c6b6b491bd60c$var$singleSiteContainer
        }, t5, t6.map((key)=>{
            const { href: href, message: message, actionSubjectId: actionSubjectId_0 } = allLinks[key];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                key: `single_site_${key}`,
                role: "none",
                xcss: $ad3c6b6b491bd60c$var$styles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
                xcss: $ad3c6b6b491bd60c$var$styleLink,
                href: href,
                onClick: (event_0)=>onFilterClick(event_0, actionSubjectId_0)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), message)));
        }));
        $[17] = allLinks;
        $[18] = onFilterClick;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : ({ state: state, onClick: onClick })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const searchConfiguration = $ad3c6b6b491bd60c$export$4c85ccfa2dce935c(quickFindQuery);
    const intl = (0, $aXWIB.useIntl)();
    const intentRouterEnabled = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: (0, $6Gsan.PrimaryProductKeys).Jira,
        fireLayerExposure: false,
        // Exposure is fired when a user calls the intent detection API
        locale: intl.locale
    })?.cohort === 'test';
    const workItemsUrl = (0, $42omo.useMemo)(()=>{
        if (!intentRouterEnabled) return;
        try {
            return generateSearchUrl({
                ...queryParams,
                text: quickFindQuery,
                referrer: (0, $9rRKJ.SearchExperience).QUICK_FIND
            }, true, undefined, undefined, false);
        } catch  {
            return 0, $88b96a73873e73ff$export$da00a8e161805bdf;
        }
    }, [
        generateSearchUrl,
        intentRouterEnabled,
        queryParams,
        quickFindQuery
    ]);
    // Build final configuration including Work Items first if enabled
    const allLinks = (0, $42omo.useMemo)(()=>{
        if (workItemsUrl) return {
            workItems: {
                href: workItemsUrl,
                message: (0, $2edb72d725c5d8f9$export$defe85febe8b728c).jira_quick_find_work_items,
                actionSubjectId: "jiraWorkItemsSearchLink"
            },
            ...searchConfiguration
        };
        return searchConfiguration;
    }, [
        searchConfiguration,
        workItemsUrl
    ]);
    const onFilterClick = (0, $42omo.useCallback)((event, actionSubjectId)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: actionSubjectId
        });
    }, [
        onClick,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ad3c6b6b491bd60c$var$singleSiteContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "span",
        xcss: $ad3c6b6b491bd60c$var$iconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Ajko))), {
        label: "navigate-single-site-icon"
    })), Object.keys(allLinks).map((key)=>{
        const { href: href, message: message, actionSubjectId: actionSubjectId_0 } = allLinks[key];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            key: `single_site_${key}`,
            role: "none",
            xcss: $ad3c6b6b491bd60c$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
            xcss: $ad3c6b6b491bd60c$var$styleLink,
            href: href,
            onClick: (event_0)=>onFilterClick(event_0, actionSubjectId_0)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), message)));
    }));
};


































const $678282c0e0260f8c$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    quickFindNoContentHeading: {
        id: "search_dialog_no_content_heading",
        defaultMessage: "Seek and you shall find"
    },
    quickFindNoContentBodyWithRovo: {
        id: "search_dialog_no_content_body_with_rovo",
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and integrated apps"
    },
    quickFindNoContentBodyWithAtlassianIntelligence: {
        id: "search_dialog_no_content_body_with_atlassian_intelligence",
        defaultMessage: "Search or ask anything across your Atlassian apps"
    },
    quickFindNoContentBodyDefault: {
        id: "search_dialog_no_content_body_default",
        defaultMessage: "Search for anything across your Atlassian apps"
    },
    quickFindNoContentBody: {
        id: "search_dialog_no_content_body",
        defaultMessage: "Search for what you're looking for in your Atlassian and integrated apps"
    },
    quickFindNoContentBodyWithAI: {
        id: "search_dialog_no_content_body_with_ai",
        defaultMessage: "Search or ask what you're looking for in your Atlassian and integrated apps"
    }
});



const $9ebd3fccc7b29e09$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("8PWzv")));
const $9ebd3fccc7b29e09$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $9ebd3fccc7b29e09$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $9ebd3fccc7b29e09$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $9ebd3fccc7b29e09$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $9ebd3fccc7b29e09$export$144e5acf8752ad4a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const bodyCopy = applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyWithRovo : isAdminHubAIEnabled ? (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyWithAtlassianIntelligence : (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyDefault;
    const newBodyCopy = applicationMode === (0, $9vOy1.ApplicationModes).Rovo && isRovoLLMEnabled || isAdminHubAIEnabled ? (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyWithAI : (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBody;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $9ebd3fccc7b29e09$var$imageFallbackStyles
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ebd3fccc7b29e09$var$Image, null));
        $[0] = t0;
    } else t0 = $[0];
    const t1 = (0, $dh538.fg)("rovo_search_updated_entitlement_checks_for_team_25") ? newBodyCopy : bodyCopy;
    let t2;
    if ($[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9ebd3fccc7b29e09$var$headingStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), t1));
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9ebd3fccc7b29e09$var$bodyStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentHeading));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9ebd3fccc7b29e09$var$containerStyles
        }, t0, t2, t3);
        $[4] = t2;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ()=>{
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const bodyCopy = applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyWithRovo : isAdminHubAIEnabled ? (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyWithAtlassianIntelligence : (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyDefault;
    const newBodyCopy = applicationMode === (0, $9vOy1.ApplicationModes).Rovo && isRovoLLMEnabled || isAdminHubAIEnabled ? (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBodyWithAI : (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentBody;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $9ebd3fccc7b29e09$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $9ebd3fccc7b29e09$var$imageFallbackStyles
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ebd3fccc7b29e09$var$Image, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $9ebd3fccc7b29e09$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25') ? newBodyCopy : bodyCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $9ebd3fccc7b29e09$var$bodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $678282c0e0260f8c$export$defe85febe8b728c).quickFindNoContentHeading)));
};


































const $bc6e38173da21e1a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noResultsHeading: {
        id: "search_dialog_no_results_heading",
        defaultMessage: "We couldn't find any results with that title"
    },
    noResultsBody: {
        id: "search_dialog_no_results_search_body",
        defaultMessage: "<link>Search all content across your organization</link> or try again with a different term."
    }
});



const $c5e5408b5df96d67$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("ejJrc")));
const $c5e5408b5df96d67$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $c5e5408b5df96d67$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $c5e5408b5df96d67$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $c5e5408b5df96d67$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $c5e5408b5df96d67$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    font: 'font.body',
    color: 'color.link',
    padding: 'space.0',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $c5e5408b5df96d67$export$373c6a9b01d625eb = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { onRetry: onRetry } = t0;
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $c5e5408b5df96d67$var$imageFallbackStyles
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5e5408b5df96d67$var$Image, null));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onRetry) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "h2",
            xcss: $c5e5408b5df96d67$var$headingStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $bc6e38173da21e1a$export$defe85febe8b728c).noResultsHeading,
            values: {
                button: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                        xcss: $c5e5408b5df96d67$var$pressableStyles,
                        onClick: onRetry
                    }, s)
            }
        }));
        $[1] = onRetry;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== generateSearchUrl || $[4] !== queryParams || $[5] !== quickFindQuery) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $c5e5408b5df96d67$var$bodyStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $bc6e38173da21e1a$export$defe85febe8b728c).noResultsBody,
            values: {
                link: (s_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
                        xcss: $c5e5408b5df96d67$var$pressableStyles,
                        href: generateSearchUrl({
                            ...queryParams,
                            text: quickFindQuery
                        })
                    }, s_0)
            }
        }));
        $[3] = generateSearchUrl;
        $[4] = queryParams;
        $[5] = quickFindQuery;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $c5e5408b5df96d67$var$containerStyles
        }, t1, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ onRetry: onRetry })=>{
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c5e5408b5df96d67$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $c5e5408b5df96d67$var$imageFallbackStyles
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5e5408b5df96d67$var$Image, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "h2",
        xcss: $c5e5408b5df96d67$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $bc6e38173da21e1a$export$defe85febe8b728c).noResultsHeading,
        values: {
            button: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                    xcss: $c5e5408b5df96d67$var$pressableStyles,
                    onClick: onRetry
                }, s)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c5e5408b5df96d67$var$bodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $bc6e38173da21e1a$export$defe85febe8b728c).noResultsBody,
        values: {
            link: (s_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAenQ.Link), {
                    xcss: $c5e5408b5df96d67$var$pressableStyles,
                    href: generateSearchUrl({
                        ...queryParams,
                        text: quickFindQuery
                    })
                }, s_0)
        }
    })));
};









var $esRft = parcelRequire("esRft");





var $c5JjN = parcelRequire("c5JjN");


var $hbEOA = parcelRequire("hbEOA");


var $ay6Zz = parcelRequire("ay6Zz");








var $5e5BE = parcelRequire("5e5BE");

var $ipWWT = parcelRequire("ipWWT");



















const $d0b52bf4302d81ca$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    team: {
        id: "search_dialog_team",
        defaultMessage: "Team"
    }
});


const $18e1948c3888bb1b$export$c84e51771b9ba67c = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [orgId] = (0, $j4ply.useOrgId)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [primarySubProduct] = (0, $j4ply.usePrimarySubProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const { generateTeamUrl: generateTeamUrl, generateUserUrl: generateUserUrl } = (0, $7WbA8.useAppContext)();
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const id = result.id;
    const userTitle = result.name;
    const teamTitle = result.displayName;
    const title = result.entityType === (0, $c5JjN.EntityType).USER ? userTitle : teamTitle;
    const highlightedTitle = title && quickFindQuery ? (0, $bloXB.highlightMatchedText)(title, quickFindQuery.split(' ')).highlightedTitle : undefined;
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: result.entityType === (0, $c5JjN.EntityType).USER ? 'circle' : 'square',
        borderColor: "transparent",
        name: title,
        size: 'small',
        src: result.avatarUrl || result.smallAvatarImageUrl
    });
    const userMetadata = [
        'user-metadata',
        result.title
    ];
    const teamMetadata = [
        'team-metadata',
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $d0b52bf4302d81ca$export$defe85febe8b728c).team)
    ];
    const metadata = result.entityType === (0, $c5JjN.EntityType).USER ? [
        userMetadata
    ] : [
        teamMetadata
    ];
    // Avoiding typeguards
    const hostProductForTeamsApp = primaryProduct === 'jira' ? 'jira' : primaryProduct === 'confluence' ? 'confluence' : undefined;
    let url;
    let onNavigate;
    if ((0, $hbEOA.isTeamsAppEnabled)({
        hostProduct: hostProductForTeamsApp
    })) {
        const { href: href, onNavigate: onNavigateTeamsApp } = (0, $ay6Zz.navigateToTeamsApp)(result.entityType === (0, $c5JjN.EntityType).USER ? {
            type: 'USER',
            payload: {
                userId: result.id
            },
            cloudId: cloudId || '',
            orgId: orgId
        } : {
            type: 'TEAM',
            payload: {
                teamId: result.id
            },
            cloudId: cloudId || '',
            orgId: orgId
        });
        url = href;
        onNavigate = onNavigateTeamsApp;
    } else {
        let path;
        // TODO remove this statement once all products have specified their own generateUserUrl and generateTeamUrl props
        if (primaryProduct && orgId && cloudId) path = result.entityType === (0, $c5JjN.EntityType).USER ? (0, $ipWWT.getUserPath)(result.id, primaryProduct, orgId, cloudId) : (0, $5e5BE.getTeamPath)(result.id, primaryProduct, orgId, cloudId);
        if (generateUserUrl && result.entityType === (0, $c5JjN.EntityType).USER) path = generateUserUrl(result.id);
        else if (generateTeamUrl && result.entityType !== (0, $c5JjN.EntityType).USER) path = generateTeamUrl(result.id);
        url = path && new URL(path, window.location.origin).href;
    }
    const analyticsMetadata = (0, $42omo.useMemo)(()=>({
            contentId: id,
            contentType: 'user'
        }), [
        id
    ]);
    const onResultClicked = (0, $42omo.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
        if (onNavigate && (0, $hbEOA.isTeamsAppEnabled)({
            hostProduct: hostProductForTeamsApp
        })) // Handles opening the link in a new tab
        onNavigate(event);
    }, [
        analyticsMetadata,
        onClick,
        onNavigate,
        state,
        hostProductForTeamsApp
    ]);
    const onResultContextMenu = (0, $42omo.useCallback)((event_0, data_0)=>{
        onContextMenu?.({
            event: event_0,
            data: data_0,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
    }, [
        analyticsMetadata,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $42omo.useCallback)((data_1)=>{
        onHighlighted?.({
            data: data_1,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
    }, [
        analyticsMetadata,
        onHighlighted,
        state
    ]);
    if (!title || !metadata || !url) {
        invalidateItem(result.id);
        return null;
    }
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: url,
        searchSessionId: searchSessionId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
        id: id,
        icon: icon,
        resultType: "peopleAndTeams",
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: urlWithAnalyticsQueryParams,
        product: (0, $b4tvS.ProductKeys1PForAnalytics).AtlasTeams,
        primaryProduct: primaryProduct,
        primarySubProduct: primarySubProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted
    });
};































var $k4HRJ = parcelRequire("k4HRJ");


var $2BDjU = parcelRequire("2BDjU");


var $a5RR2 = parcelRequire("a5RR2");


var $l3paI = parcelRequire("l3paI");


var $7jIfa = parcelRequire("7jIfa");











var $HOiSI = parcelRequire("HOiSI");


var $fhFN4 = parcelRequire("fhFN4");


var $7ZetK = parcelRequire("7ZetK");





























var $aKt88 = parcelRequire("aKt88");













var $cWRpe = parcelRequire("cWRpe");


var $1BldJ = parcelRequire("1BldJ");


var $7loel = parcelRequire("7loel");








var $Y34Hw = parcelRequire("Y34Hw");


var $92zSJ = parcelRequire("92zSJ");



















const $0559f7291a65cc73$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    statusUpdateTitle: {
        id: "quick-find.mercury.focus-area-status-update.title",
        defaultMessage: "Update for {focusAreaName}"
    },
    issue: {
        id: "issue_type",
        defaultMessage: "Work item"
    },
    talentExternalPositionKey: {
        id: "quick-find.talent.position.external-position-key",
        defaultMessage: "External key {positionKey}"
    },
    talentPositionTitle: {
        id: "quick-find.talent.position.title",
        defaultMessage: "{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}"
    },
    code: {
        id: "quick-find.github.code.type",
        defaultMessage: "Code"
    }
});



const $0e1f91acee299cdf$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("i71YS")).then((mod)=>({
            default: mod.HoverCard
        })));
const $0e1f91acee299cdf$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $0e1f91acee299cdf$var$mapLatestUserActionToActivityEventType = (latestUserAction)=>{
    switch(latestUserAction?.toLowerCase()){
        case 'viewed':
            return (0, $3E8x9.VIEWED_EVENT).VIEWED;
        case 'commented':
            return (0, $3E8x9.WORKED_EVENT).COMMENTED;
        case 'edited':
            return (0, $3E8x9.WORKED_EVENT).EDITED;
        case 'shared':
            return (0, $3E8x9.WORKED_EVENT).SHARED;
        default:
            return (0, $3E8x9.WORKED_EVENT).UPDATED;
    }
};
const $0e1f91acee299cdf$var$mapConfluenceSearchResult = (result, query, searchSessionId)=>{
    const id = result.id;
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const space = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.space?.name ? result.space.name : null;
    const spaceId = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.space?.id;
    const isLiveDoc = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.confluenceEntity?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    const icon = (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: result.iconUrl,
        type: result.type,
        isLiveDoc: isLiveDoc
    });
    const resultType = isLiveDoc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $0559f7291a65cc73$export$defe85febe8b728c).liveDoc) : result.type;
    const metadata = [
        'Confluence',
        [
            'type',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                type: result.type,
                defaultMessage: resultType,
                subtype: (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) ? result.confluenceEntity?.subtype : undefined
            }))
        ],
        space
    ];
    // Use user action data if available, otherwise fall back to lastModified
    const timestamp = result.latestUserActionTs || result.lastModified || '';
    const eventType = result.latestUserAction ? $0e1f91acee299cdf$var$mapLatestUserActionToActivityEventType(result.latestUserAction) : (0, $3E8x9.WORKED_EVENT).UPDATED;
    const rightMetadata = timestamp ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const url = (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
        url: result.url,
        query: query,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `${(0, $1yEFx.ProductKeys).Confluence} ${result.type}`,
        product: (0, $1yEFx.ProductKeys).Confluence
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapAtlasSearchResult = (result, query, searchSessionId)=>{
    const id = result.id;
    const icon = (0, $2waBy.getAtlasEntityIcon)({
        iconUrl: result.iconUrl,
        type: result.type
    });
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const metadata = [
        'Atlas',
        [
            'type',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                type: result.type,
                defaultMessage: result.type
            }))
        ]
    ];
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    let product = (0, $1yEFx.ProductKeys).Atlas;
    if ((0, $dh538.fg)('rovo_search_cross_product_url_wrapping')) {
        if (result.type === 'goal') product = (0, $b4tvS.ProductKeys1PForAnalytics).AtlasGoals;
        else if (result.type === 'project') product = (0, $b4tvS.ProductKeys1PForAnalytics).AtlasProjects;
    }
    const analyticsMetadata = {
        contentId: id,
        contentType: `${(0, $1yEFx.ProductKeys).Atlas} ${result.type}`,
        product: product
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapMercurySearchResult = (result, query, searchSessionId)=>{
    const { id: id } = result;
    let icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Focus
    });
    let resultType, title, highlightedTitle, metadata;
    if ((0, $HOiSI.isSearchResultMercuryFocusAreaPartial)(result)) {
        const { focusArea: focusArea } = result;
        icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2BDjU.default), {
            status: focusArea?.status?.key,
            health: focusArea?.health?.key
        });
        title = result.title;
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Focus area';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: resultType
                }))
            ],
            result.focusArea ? [
                'focusAreaType',
                result.focusArea?.focusAreaType.name
            ] : null
        ];
    }
    if ((0, $HOiSI.isSearchResultMercuryFocusAreaStatusUpdatePartial)(result)) {
        title = (0, $92zSJ.getSummarizedAdfContent)(result.description, query);
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Focus area update';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: resultType
                }))
            ]
        ];
    }
    if ((0, $HOiSI.isSearchResultSpfAskPartial)(result)) {
        title = result.title;
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Ask';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: resultType
                }))
            ]
        ];
    }
    if ((0, $HOiSI.isSearchResultMercuryOrganizationPartial)(result)) {
        title = result.title;
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Organization';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: resultType
                }))
            ],
            result.organization?.organizationType?.name ? [
                'organizationType',
                result.organization.organizationType.name
            ] : null
        ];
    }
    if ((0, $HOiSI.isSearchResultMercuryOrganizationStatusUpdatePartial)(result)) {
        title = (0, $92zSJ.getSummarizedAdfContent)(result.description, query) || result.title;
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Organization update';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: resultType
                }))
            ]
        ];
    }
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${(0, $1yEFx.ProductKeys).Focus} ${result.type}`,
        product: (0, $1yEFx.ProductKeys).Focus
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapTalentSearchResult = (result, query, searchSessionId)=>{
    const { id: id } = result;
    let icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small"
    });
    let resultType, title, highlightedTitle, metadata;
    const querySplit = query.split(' ');
    if ((0, $fhFN4.isSearchTalentPartial)(result)) {
        const { position: position } = result;
        let jobTitle = '';
        let externalPositionKey = '';
        let positionKey = '';
        const preferredName = position?.worker?.preferredName || '';
        icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cWRpe.TalentUserAvatar), {
            isQuickFind: true,
            src: position?.worker?.user?.picture
        });
        for (const field of position?.fieldValues ?? [])switch(field.fieldId){
            case 'positionKey':
                if ('stringValue' in field.fieldValue) positionKey = field.fieldValue.stringValue || '';
                break;
            case 'positionPositionTitle':
                if ('stringValue' in field.fieldValue) jobTitle = field.fieldValue.stringValue || '';
                break;
            case 'positionExternalPositionKey':
                if ('stringValue' in field.fieldValue) externalPositionKey = field.fieldValue.stringValue || '';
                break;
            default:
                break;
        }
        title = preferredName ? `${positionKey}: ${preferredName}` : positionKey;
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, querySplit).highlightedTitle : undefined;
        resultType = 'Position';
        metadata = [
            'Talent',
            [
                'type',
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                    type: result.type,
                    defaultMessage: resultType
                }))
            ],
            [
                'jobTitle',
                jobTitle
            ],
            [
                'externalPositionKey',
                externalPositionKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...(0, $0559f7291a65cc73$export$defe85febe8b728c).talentExternalPositionKey,
                    values: {
                        positionKey: externalPositionKey
                    }
                }) : null
            ]
        ];
    }
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${(0, $1yEFx.ProductKeys).Talent} ${result.type}`,
        product: (0, $1yEFx.ProductKeys).Talent
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapThirdPartySearchResult = (result, query, searchSessionId, thirdPartyConfigs)=>{
    const { id: id, providerId: providerId, integrationId: integrationId, subtype: subtype, lastModifiedDate: lastModifiedDate, title: title } = result;
    const product = (0, $Y34Hw.get3PProductFromProviderIdOrIntegrationId)({
        thirdPartyConfigs: thirdPartyConfigs,
        providerId: providerId,
        integrationId: integrationId
    });
    if (!(0, $b4tvS.isProductKey)(product)) return;
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(id);
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const typeLabel = (0, $9kYXz.getSubtypeLabel)({
        product: product,
        subtype: subtype,
        resourceType: resourceType
    });
    const parentName = (0, $7ZetK.isDocumentEntity)(result) ? result.entity?.parent?.displayName : null;
    /**
   * Use constant config as fallback
   * Loom is not included in thirdPartyConfigs from API
   */ const productDisplayName = thirdPartyConfigs[product]?.displayName || (0, $a5RR2.ThirdPartyConfigsSync).get(product)?.displayName;
    const metadata = [
        [
            'product',
            productDisplayName
        ],
        [
            'type',
            typeLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), typeLabel)) : subtype ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer
            }, subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()) : null
        ],
        parentName ?? null
    ];
    const timestamp = lastModifiedDate || '';
    const eventType = (0, $3E8x9.WORKED_EVENT).UPDATED;
    const rightMetadata = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product
    };
    // Build title metadata parts (e.g. PR status lozenge)
    const titleMetadataParts = [];
    if ((0, $7ZetK.isPullRequestEntity)(result)) {
        const prStatus = result.entity?.pullRequestStatus;
        if (prStatus) titleMetadataParts.push([
            'status',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
                appearance: (0, $2vU0F.getPullRequestStatusAppearance)(prStatus),
                testId: "pull-request-status-lozenge"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2vU0F.getPullRequestStatusMessage)(prStatus)))
        ]);
    }
    if ((0, $7ZetK.isWorkItemEntity)(result)) {
        const workItemStatus = result.entity?.status;
        if (workItemStatus) titleMetadataParts.push([
            'status',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i6Ooe.GraphWorkItemStatusLozenge), {
                status: workItemStatus
            })
        ]);
    }
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata,
        ...titleMetadataParts.length > 0 ? {
            titleMetadataParts: titleMetadataParts
        } : {}
    };
};
const $0e1f91acee299cdf$var$mapJiraSearchResult = (result, query, searchSessionId, isStatusLoading, primaryProduct)=>{
    const id = result.id;
    const analyticsMetadata = {
        contentId: id,
        contentType: `${(0, $1yEFx.ProductKeys).Jira} ${result.type}`,
        product: (0, $1yEFx.ProductKeys).Jira
    };
    const isIssue = (0, $8LSUr.isSearchResultJiraIssue)(result);
    const title = isIssue ? [
        result.issue?.key,
        result.title
    ].filter(Boolean).join(': ') : result.title;
    const issueIconUrl = isIssue ? result.issue?.issueTypeAvatarUrl : undefined;
    const boardIconUrl = (0, $8LSUr.isSearchResultJiraBoard)(result) ? result.board?.iconUrl : undefined;
    const iconUrl = boardIconUrl || issueIconUrl || result.iconUrl;
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: iconUrl,
        type: result.type,
        isIssue: isIssue
    });
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const status = (0, $8LSUr.isSearchResultJiraIssue)(result) ? (0, $aKt88.getStatus)(result.status?.name, {
        color: result.status?.colorName
    }, isStatusLoading) : null;
    const metadata = [];
    metadata.push('Jira');
    if ((0, $8LSUr.isSearchResultJiraIssue)(result)) {
        const issueType = result.issue?.issueTypeField?.issueType;
        issueType && metadata.push(issueType.name);
        const project = result.issue?.fieldsById.edges[0]?.node.project.name;
        project && metadata.push(project);
    } else if ((0, $8LSUr.isSearchResultJiraBoard)(result)) {
        metadata.push([
            'type',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                type: result.type,
                defaultMessage: result.type
            }))
        ]);
        const containerProjectName = result.container && 'projectName' in result.container && result.container.projectName;
        const containerUserName = result.container && 'userName' in result.container && result.container.userName;
        const containerName = containerProjectName || containerUserName || undefined;
        if (containerName) metadata.push(containerName);
    } else {
        const resultType = (0, $1BldJ.getJiraSearchResultTypeMetadata)(result.type);
        metadata.push([
            'type',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                type: resultType,
                defaultMessage: result.type
            }))
        ]);
    }
    const rightMetadata = (0, $8LSUr.isSearchResultJiraIssue)(result) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: result.lastModifiedDate || '',
        eventType: (0, $3E8x9.WORKED_EVENT).UPDATED,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    let jiraResultUrl;
    if ((0, $8LSUr.isSearchResultJiraIssue)(result)) jiraResultUrl = result.issue?.webUrl || result.url;
    else if ((0, $8LSUr.isSearchResultJiraBoard)(result)) {
        const notDummyUrl = (0, $7loel.isDummyBoardUrl)(result.url) ? undefined : result.url;
        jiraResultUrl = jiraResultUrl = result.board?.boardFrontendUrl || notDummyUrl;
        if (!jiraResultUrl) // We don't want the board with no url to be displayed. Returning null prevents rendering
        return null;
    } else jiraResultUrl = result.url;
    const customParams = primaryProduct?.includes((0, $1yEFx.ProductKeys).Jira) ? new Map([
        [
            'referrer',
            (0, $9rRKJ.SearchExperience).QUICK_FIND
        ]
    ]) : new Map();
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: jiraResultUrl,
        searchSessionId: searchSessionId,
        customParams: customParams
    });
    return {
        id: id,
        title: title,
        highlightedTitle: highlightedTitle,
        icon: icon,
        status: status,
        analyticsMetadata: analyticsMetadata,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        rightMetadata: rightMetadata,
        url: url
    };
};
const $0e1f91acee299cdf$var$mapAssetsSearchResult = (result, query, searchSessionId)=>{
    const id = result.id;
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const metadata = (0, $l3paI.isSearchResultAssetsObjectSchema)(result) ? [
        'Assets',
        [
            'type',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                type: result.type,
                defaultMessage: result.type
            }))
        ]
    ] : [
        'Assets',
        [
            'type',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer
            }, (0, $l3paI.isSearchResultAssetsObjectType)(result) ? `Object ${result.type}` : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXlQy.SearchResultType), {
                type: result.type,
                defaultMessage: result.type
            }))
        ],
        [
            'schema',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer
            }, result.objectSchemaEntity.name)
        ]
    ];
    const timestamp = result.lastModifiedDate || '';
    const eventType = (0, $3E8x9.WORKED_EVENT).UPDATED;
    const rightMetadata = result.lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const getAssetsUrl = (result)=>{
        if ((0, $l3paI.isSearchResultAssetsObjectSchema)(result)) return result.objectSchemaEntity.links.web;
        else if ((0, $l3paI.isSearchResultAssetsObjectType)(result)) return result.objectTypeEntity.links.web;
        else return result.objectEntity.links.web;
    };
    let iconUrl = null;
    if ((0, $l3paI.isSearchResultAssetsObjectSchema)(result)) iconUrl = null;
    else if ((0, $l3paI.isSearchResultAssetsObjectType)(result)) iconUrl = result.objectTypeEntity.icon.url48;
    else if ((0, $l3paI.isSearchResultAssetsObject)(result)) iconUrl = result.objectEntity.avatar.url48;
    const icon = (0, $2waBy.getAssetsEntityIcon)({
        iconUrl: iconUrl,
        type: result.type,
        size: 'small'
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: getAssetsUrl(result),
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `assets ${result.type}`,
        // Normalise to the canonical 1P key ('cmdb') so analytics pipelines
        // see a single identifier for Assets.
        product: (0, $1yEFx.ProductKeys).Assets
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$CODE_PATH_MAX_LENGTH = 60;
const $0e1f91acee299cdf$var$ELLIPSIS = "\u2026";
const $0e1f91acee299cdf$var$MIDDLE_ELLIPSIS = '/.../';
/**
 * Middle-truncates a filename so the start and end (including the extension)
 * stay visible. e.g. `aReallyLongFilename.ts` -> `aReallyLong…me.ts`.
 */ const $0e1f91acee299cdf$var$truncateFilename = (name, maxLength)=>{
    if (name.length <= maxLength) return name;
    const keep = maxLength - $0e1f91acee299cdf$var$ELLIPSIS.length;
    // Bias slightly toward the tail so the file extension is preserved.
    const head = Math.floor(keep / 2);
    const tail = keep - head;
    return `${name.slice(0, head)}${$0e1f91acee299cdf$var$ELLIPSIS}${name.slice(name.length - tail)}`;
};
/**
 * Truncates a forward-slash separated path so it fits within `maxLength`.
 *
 * - Short paths pass through unchanged.
 * - Long multi-segment paths are middle-truncated by segment:
 *   `packages/foo/bar/baz/qux/test.js` -> `packages/.../qux/test.js`.
 * - If the leading segment alone is too large to be a useful prefix, it is
 *   dropped and the path is rebuilt from the right:
 *   `super-long-pkg-name-.../src/auth.ts` -> `.../src/auth.ts`.
 * - If a single segment (or the leaf filename) still overflows after segment
 *   truncation, the offending name is middle-truncated character-by-character
 *   with `truncateFilename`, preserving the start and the extension.
 */ const $0e1f91acee299cdf$var$truncatePath = (fullPath, maxLength = $0e1f91acee299cdf$var$CODE_PATH_MAX_LENGTH)=>{
    if (fullPath.length <= maxLength) return fullPath;
    const segments = fullPath.split('/');
    // Case: no slashes — just a long filename. Middle-truncate the filename.
    if (segments.length === 1) return $0e1f91acee299cdf$var$truncateFilename(fullPath, maxLength);
    const leaf = segments[segments.length - 1];
    const first = segments[0];
    // Fit as many trailing segments as possible after `${prefix}/.../`.
    // `segments[0]` is intentionally excluded from `kept` in both modes:
    //   - prefix === first: already at the start, would duplicate
    //   - prefix === '':    first segment was deliberately dropped (too long)
    const buildFromRight = (prefix)=>{
        // When prefix is empty we emit `MIDDLE_ELLIPSIS.slice(1)` (no leading slash),
        // so account for the shorter prefix in the budget.
        const renderedMiddle = prefix ? $0e1f91acee299cdf$var$MIDDLE_ELLIPSIS : $0e1f91acee299cdf$var$MIDDLE_ELLIPSIS.slice(1);
        const prefixCost = prefix.length + renderedMiddle.length;
        const kept = [
            leaf
        ];
        let length = prefixCost + leaf.length;
        for(let i = segments.length - 2; i > 0; i--){
            const next = segments[i];
            if (length + next.length + 1 > maxLength) break;
            kept.unshift(next);
            length += next.length + 1;
        }
        return `${prefix}${renderedMiddle}${kept.join('/')}`;
    };
    // Case: first segment is too long to be a useful prefix — drop it.
    const minLeafBudget = leaf.length + $0e1f91acee299cdf$var$MIDDLE_ELLIPSIS.length;
    if (first.length + minLeafBudget > maxLength) {
        // Use a leading "..." with no first segment, e.g. `.../src/auth.ts`.
        let result = `${$0e1f91acee299cdf$var$MIDDLE_ELLIPSIS.slice(1)}${segments.slice(1).join('/')}`;
        if (result.length <= maxLength) return result;
        // Build from the right with an empty prefix; if even that overflows
        // (leaf itself is too long), middle-truncate the leaf.
        result = buildFromRight('');
        if (result.length > maxLength) {
            // `MIDDLE_ELLIPSIS.slice(1)` is what we actually emit (no leading "/").
            const leadingEllipsis = $0e1f91acee299cdf$var$MIDDLE_ELLIPSIS.slice(1);
            const truncatedLeaf = $0e1f91acee299cdf$var$truncateFilename(leaf, maxLength - leadingEllipsis.length);
            result = `${leadingEllipsis}${truncatedLeaf}`;
        }
        return result;
    }
    let result = buildFromRight(first);
    // Final safety net: if the leaf itself is too long, truncate it.
    if (result.length > maxLength) {
        const remaining = maxLength - first.length - $0e1f91acee299cdf$var$MIDDLE_ELLIPSIS.length;
        const truncatedLeaf = $0e1f91acee299cdf$var$truncateFilename(leaf, Math.max(remaining, $0e1f91acee299cdf$var$ELLIPSIS.length + 2));
        result = `${first}${$0e1f91acee299cdf$var$MIDDLE_ELLIPSIS}${truncatedLeaf}`;
    }
    return result;
};
const $0e1f91acee299cdf$var$mapCodeSearchResult = (result, query, searchSessionId, thirdPartyConfigs)=>{
    const { id: id, title: title, url: url, lastModifiedDate: lastModifiedDate, path: path, repository: repository } = result;
    const product = 'github';
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    // Code results show the file path (e.g. `src/auth/auth.ts`) as the title, falling
    // back to the filename (`title`) when the path is missing. Long paths are middle-
    // truncated (e.g. `packages/.../test-dir/test.js`) so the row stays single-line.
    const displayTitle = (path ? $0e1f91acee299cdf$var$truncatePath(path) : title) ?? '';
    const highlightedTitle = displayTitle && query ? (0, $bloXB.highlightMatchedText)(displayTitle, query.split(' ')).highlightedTitle : undefined;
    const productDisplayName = thirdPartyConfigs[product]?.displayName || (0, $a5RR2.ThirdPartyConfigsSync).get(product)?.displayName;
    const metadata = [
        [
            'product',
            productDisplayName
        ],
        [
            'type',
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $0559f7291a65cc73$export$defe85febe8b728c).code))
        ],
        repository?.name ?? null
    ];
    const timestamp = lastModifiedDate || '';
    const eventType = (0, $3E8x9.WORKED_EVENT).UPDATED;
    const rightMetadata = lastModifiedDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const finalUrl = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: 'github code',
        product: product
    };
    return {
        id: id,
        icon: icon,
        title: displayTitle,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: finalUrl,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapSearchResult = (result, query, searchSessionId, thirdPartyConfigs, isStatusLoading, primaryProduct)=>{
    if ((0, $4TTdD.isSearchConfluencePartial)(result)) return $0e1f91acee299cdf$var$mapConfluenceSearchResult(result, query, searchSessionId);
    else if ((0, $7jIfa.isSearchAtlasPartial)(result)) return $0e1f91acee299cdf$var$mapAtlasSearchResult(result, query, searchSessionId);
    else if ((0, $HOiSI.isSearchMercuryPartial)(result)) return $0e1f91acee299cdf$var$mapMercurySearchResult(result, query, searchSessionId);
    else if ((0, $fhFN4.isSearchTalentPartial)(result) && (0, $dh538.fg)('talent_global_search')) return $0e1f91acee299cdf$var$mapTalentSearchResult(result, query, searchSessionId);
    else if ((0, $7ZetK.isCodeResult)(result) && (0, $dh538.fg)('rovo_github_code_search')) return $0e1f91acee299cdf$var$mapCodeSearchResult(result, query, searchSessionId, thirdPartyConfigs);
    else if ((0, $7ZetK.isSearchResultGraphEntity)(result)) return $0e1f91acee299cdf$var$mapThirdPartySearchResult(result, query, searchSessionId, thirdPartyConfigs);
    else if ((0, $8LSUr.isSearchJiraPartial)(result)) return $0e1f91acee299cdf$var$mapJiraSearchResult(result, query, searchSessionId, isStatusLoading, primaryProduct);
    else if ((0, $l3paI.isSearchAssetsPartial)(result) && (0, $dh538.fg)('assets_rovo_search_all')) return $0e1f91acee299cdf$var$mapAssetsSearchResult(result, query, searchSessionId);
    else return null;
};
const $0e1f91acee299cdf$export$c9f98fed0b66ba21 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(58);
    const { result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted, resultType: t1 } = t0;
    const resultType = t1 === undefined ? "searchResults" : t1;
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { setHoverCardOpen: setHoverCardOpen } = (0, $4VmlX.useQuickFindActions)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [primarySubProduct] = (0, $j4ply.usePrimarySubProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [t2] = (0, $j4ply.useBootstrap)();
    const { thirdPartyConfigs: thirdPartyConfigs } = t2;
    const isHydrationLoading = (0, $djVCD.useIsJiraHydrationLoading)();
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    let mappedResult;
    let t3;
    if ($[0] !== isHydrationLoading || $[1] !== primaryProduct || $[2] !== quickFindQuery || $[3] !== result || $[4] !== searchSessionId || $[5] !== thirdPartyConfigs) {
        mappedResult = $0e1f91acee299cdf$var$mapSearchResult(result, quickFindQuery, searchSessionId, thirdPartyConfigs, isHydrationLoading, primaryProduct);
        t3 = (0, $gRvZB.isProductImpersonated)(mappedResult?.analyticsMetadata.product, thirdPartyConfigs);
        $[0] = isHydrationLoading;
        $[1] = primaryProduct;
        $[2] = quickFindQuery;
        $[3] = result;
        $[4] = searchSessionId;
        $[5] = thirdPartyConfigs;
        $[6] = mappedResult;
        $[7] = t3;
    } else {
        mappedResult = $[6];
        t3 = $[7];
    }
    const isImpersonated = t3;
    const t4 = mappedResult?.analyticsMetadata;
    const t5 = mappedResult?.analyticsMetadata.product;
    let t6;
    if ($[8] !== result.connectorType || $[9] !== result.id || $[10] !== t5 || $[11] !== thirdPartyConfigs) {
        t6 = (0, $kQT7c.getResultConnectorSource)({
            connectorType: result.connectorType,
            resultNodeId: result.id,
            thirdPartyConfigs: thirdPartyConfigs,
            productKey: t5
        });
        $[8] = result.connectorType;
        $[9] = result.id;
        $[10] = t5;
        $[11] = thirdPartyConfigs;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t4 || $[14] !== t6) {
        t7 = {
            ...t4,
            connectorType: t6
        };
        $[13] = t4;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    const t8 = mappedResult?.analyticsMetadata.product;
    let t9;
    if ($[16] !== t8) {
        t9 = (0, $fuGkE.is3pProductKeyForAnalytics)(t8);
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    const t10 = mappedResult?.analyticsMetadata.product;
    let t11;
    if ($[18] !== result.connectorType || $[19] !== result.id || $[20] !== t10 || $[21] !== thirdPartyConfigs) {
        t11 = (0, $kQT7c.isResultSmartLink)({
            resultAri: result.id,
            thirdPartyConfigs: thirdPartyConfigs,
            productKey: t10,
            connectorType: result.connectorType
        });
        $[18] = result.connectorType;
        $[19] = result.id;
        $[20] = t10;
        $[21] = thirdPartyConfigs;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t11 || $[24] !== t7 || $[25] !== t9) {
        t12 = {
            metadata: t7,
            is3pLink: t9,
            is3pSmartLink: t11
        };
        $[23] = t11;
        $[24] = t7;
        $[25] = t9;
        $[26] = t12;
    } else t12 = $[26];
    const additionalAnalyticsAttributes = t12;
    let t13;
    if ($[27] !== result.id || $[28] !== setHoverCardOpen) {
        t13 = (isOpen)=>{
            setHoverCardOpen(result.id, isOpen);
        };
        $[27] = result.id;
        $[28] = setHoverCardOpen;
        $[29] = t13;
    } else t13 = $[29];
    const onHoverCardVisibilityChange = t13;
    let t14;
    if ($[30] !== additionalAnalyticsAttributes || $[31] !== isImpersonated || $[32] !== onClick || $[33] !== onHoverCardVisibilityChange || $[34] !== state) {
        t14 = (event, data)=>{
            onClick?.({
                event: event,
                data: data,
                state: state,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                isImpersonated: isImpersonated
            });
            onHoverCardVisibilityChange(false);
        };
        $[30] = additionalAnalyticsAttributes;
        $[31] = isImpersonated;
        $[32] = onClick;
        $[33] = onHoverCardVisibilityChange;
        $[34] = state;
        $[35] = t14;
    } else t14 = $[35];
    const onResultClicked = t14;
    let t15;
    if ($[36] !== additionalAnalyticsAttributes || $[37] !== isImpersonated || $[38] !== onContextMenu || $[39] !== state) {
        t15 = (event_0, data_0)=>{
            onContextMenu?.({
                event: event_0,
                data: data_0,
                state: state,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                isImpersonated: isImpersonated
            });
        };
        $[36] = additionalAnalyticsAttributes;
        $[37] = isImpersonated;
        $[38] = onContextMenu;
        $[39] = state;
        $[40] = t15;
    } else t15 = $[40];
    const onResultContextMenu = t15;
    let t16;
    if ($[41] !== additionalAnalyticsAttributes || $[42] !== onHighlighted || $[43] !== state) {
        t16 = (data_1)=>{
            onHighlighted?.({
                data: data_1,
                state: state,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes
            });
        };
        $[41] = additionalAnalyticsAttributes;
        $[42] = onHighlighted;
        $[43] = state;
        $[44] = t16;
    } else t16 = $[44];
    const onResultHighlighted = t16;
    if (!mappedResult) {
        invalidateItem(result.id);
        return null;
    }
    let t17;
    if ($[45] !== additionalAnalyticsAttributes.metadata.connectorType || $[46] !== mappedResult || $[47] !== onResultClicked || $[48] !== onResultContextMenu || $[49] !== onResultHighlighted || $[50] !== primarySubProduct || $[51] !== resultType) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            ...mappedResult,
            resultType: resultType,
            primarySubProduct: primarySubProduct,
            product: mappedResult.analyticsMetadata.product,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultContextMenu,
            onResultHighlighted: onResultHighlighted,
            connectorType: additionalAnalyticsAttributes.metadata.connectorType
        });
        $[45] = additionalAnalyticsAttributes.metadata.connectorType;
        $[46] = mappedResult;
        $[47] = onResultClicked;
        $[48] = onResultContextMenu;
        $[49] = onResultHighlighted;
        $[50] = primarySubProduct;
        $[51] = resultType;
        $[52] = t17;
    } else t17 = $[52];
    const content = t17;
    let t18;
    if ($[53] !== content || $[54] !== mappedResult || $[55] !== onHoverCardVisibilityChange || $[56] !== result) {
        t18 = (0, $8LSUr.isSearchResultJiraIssue)(result) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f91acee299cdf$var$JiraResult, {
            result: result,
            content: content,
            mappedResult: mappedResult,
            onHoverCardVisibilityChange: onHoverCardVisibilityChange
        }) : content;
        $[53] = content;
        $[54] = mappedResult;
        $[55] = onHoverCardVisibilityChange;
        $[56] = result;
        $[57] = t18;
    } else t18 = $[57];
    return t18;
} : ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted, resultType: resultType = 'searchResults' })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { setHoverCardOpen: setHoverCardOpen } = (0, $4VmlX.useQuickFindActions)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [primarySubProduct] = (0, $j4ply.usePrimarySubProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const isHydrationLoading = (0, $djVCD.useIsJiraHydrationLoading)();
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const mappedResult = $0e1f91acee299cdf$var$mapSearchResult(result, quickFindQuery, searchSessionId, thirdPartyConfigs, isHydrationLoading, primaryProduct);
    const isImpersonated = (0, $gRvZB.isProductImpersonated)(mappedResult?.analyticsMetadata.product, thirdPartyConfigs);
    const additionalAnalyticsAttributes = (0, $42omo.useMemo)(()=>({
            metadata: {
                ...mappedResult?.analyticsMetadata,
                connectorType: (0, $kQT7c.getResultConnectorSource)({
                    connectorType: result.connectorType,
                    resultNodeId: result.id,
                    thirdPartyConfigs: thirdPartyConfigs,
                    productKey: mappedResult?.analyticsMetadata.product
                })
            },
            is3pLink: (0, $fuGkE.is3pProductKeyForAnalytics)(mappedResult?.analyticsMetadata.product),
            is3pSmartLink: (0, $kQT7c.isResultSmartLink)({
                resultAri: result.id,
                thirdPartyConfigs: thirdPartyConfigs,
                productKey: mappedResult?.analyticsMetadata.product,
                connectorType: result.connectorType
            })
        }), [
        mappedResult,
        result.id,
        thirdPartyConfigs,
        result.connectorType
    ]);
    const onHoverCardVisibilityChange = (0, $42omo.useCallback)((isOpen)=>{
        setHoverCardOpen(result.id, isOpen);
    }, [
        setHoverCardOpen,
        result.id
    ]);
    const onResultClicked = (0, $42omo.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes,
            isImpersonated: isImpersonated
        });
        onHoverCardVisibilityChange(false);
    }, [
        additionalAnalyticsAttributes,
        isImpersonated,
        onClick,
        state,
        onHoverCardVisibilityChange
    ]);
    const onResultContextMenu = (0, $42omo.useCallback)((event_0, data_0)=>{
        onContextMenu?.({
            event: event_0,
            data: data_0,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes,
            isImpersonated: isImpersonated
        });
    }, [
        additionalAnalyticsAttributes,
        isImpersonated,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $42omo.useCallback)((data_1)=>{
        onHighlighted?.({
            data: data_1,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) {
        invalidateItem(result.id);
        return null;
    }
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
        ...mappedResult,
        resultType: resultType,
        primarySubProduct: primarySubProduct,
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted,
        connectorType: additionalAnalyticsAttributes.metadata.connectorType
    });
    return (0, $8LSUr.isSearchResultJiraIssue)(result) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f91acee299cdf$var$JiraResult, {
        result: result,
        content: content,
        mappedResult: mappedResult,
        onHoverCardVisibilityChange: onHoverCardVisibilityChange
    }) : content;
};
const $0e1f91acee299cdf$var$JiraResult = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { result: result, content: content, mappedResult: mappedResult, onHoverCardVisibilityChange: onHoverCardVisibilityChange } = t0;
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    let t1;
    if ($[0] !== primaryProduct) {
        t1 = primaryProduct === (0, $1yEFx.ProductKeys).Jira && (0, $dh538.fg)("enable_hover_card_jira_issues_quick_find");
        $[0] = primaryProduct;
        $[1] = t1;
    } else t1 = $[1];
    const enableJiraIssueHoverCard = t1;
    if (!mappedResult) {
        invalidateItem(result.id);
        return null;
    }
    let t2;
    if ($[2] !== content || $[3] !== enableJiraIssueHoverCard || $[4] !== mappedResult || $[5] !== onHoverCardVisibilityChange) {
        t2 = enableJiraIssueHoverCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1nJM3.ErrorBoundary), {
            fallback: content,
            section: "result-hover-card"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: content
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f91acee299cdf$var$HoverCard, {
            url: mappedResult.url,
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $5TXU5.CardAction).PreviewAction
                ]
            },
            role: "dialog",
            titleId: mappedResult.title,
            label: "quick-find-smart-hover-card",
            onVisibilityChange: onHoverCardVisibilityChange,
            shouldRenderToParent: true
        }, content))) : content;
        $[2] = content;
        $[3] = enableJiraIssueHoverCard;
        $[4] = mappedResult;
        $[5] = onHoverCardVisibilityChange;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ result: result, content: content, mappedResult: mappedResult, onHoverCardVisibilityChange: onHoverCardVisibilityChange })=>{
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const enableJiraIssueHoverCard = primaryProduct === (0, $1yEFx.ProductKeys).Jira && (0, $dh538.fg)('enable_hover_card_jira_issues_quick_find');
    if (!mappedResult) {
        invalidateItem(result.id);
        return null;
    }
    return enableJiraIssueHoverCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1nJM3.ErrorBoundary), {
        fallback: content,
        section: "result-hover-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f91acee299cdf$var$HoverCard, {
        url: mappedResult.url,
        actionOptions: {
            hide: false,
            exclude: [
                (0, $5TXU5.CardAction).PreviewAction
            ]
        },
        role: "dialog",
        titleId: mappedResult.title,
        label: "quick-find-smart-hover-card",
        onVisibilityChange: onHoverCardVisibilityChange,
        shouldRenderToParent: true
    }, content))) : content;
};
















































const $e6d2962f130fd57e$export$724848965240e03c = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'queryFilter',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





/**
 * Given a query, a filter keyword, and a display text, return a query with
 * the display text populated correct.
 *
 * e.g "test @Jeff" -> "test @Jeffrey Quach"
 */ const $573c8bfe15d4c6dc$export$53fd39a93e83286f = (inputQuery, keyword, displayText)=>{
    // Find the last occurrence of the keyword
    const keywordIndex = inputQuery.lastIndexOf(keyword);
    return inputQuery.substring(0, keywordIndex) + keyword + displayText;
};








const $becbf29994847995$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    filterIconLabel: {
        id: "filter",
        defaultMessage: "Filter icon"
    }
});


const $9dcebcedad235590$export$36d18380658d5d20 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { title: title, option: option, setOption: setOption, localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    const { addSelectedQueryFilter: addSelectedQueryFilter } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $becbf29994847995$export$defe85febe8b728c).filterIconLabel);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
            label: t1
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const icon = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
        $[4] = t3;
    } else t3 = $[4];
    const highlightedRightMetadata = t3;
    let t4;
    if ($[5] !== addSelectedQueryFilter || $[6] !== commonAttributes || $[7] !== currentQueryFilter || $[8] !== fireAnalyticsEvent || $[9] !== inputRef || $[10] !== localQuery || $[11] !== nonPrivacySafeAttributes || $[12] !== option || $[13] !== setLocalQuery || $[14] !== setOption) {
        t4 = ()=>{
            if (!currentQueryFilter) return;
            setOption({
                ...option,
                isSelected: false
            });
            const newLocalQuery = (0, $573c8bfe15d4c6dc$export$53fd39a93e83286f)(localQuery, currentQueryFilter?.keyword, option.label);
            setLocalQuery(newLocalQuery);
            addSelectedQueryFilter({
                filterId: currentQueryFilter.filterId,
                keyword: currentQueryFilter.keyword,
                displayText: currentQueryFilter.keyword + option.label,
                option: option
            });
            fireAnalyticsEvent((0, $e6d2962f130fd57e$export$724848965240e03c)({
                actionSubjectId: currentQueryFilter.filterId,
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            inputRef?.current?.focus();
        };
        $[5] = addSelectedQueryFilter;
        $[6] = commonAttributes;
        $[7] = currentQueryFilter;
        $[8] = fireAnalyticsEvent;
        $[9] = inputRef;
        $[10] = localQuery;
        $[11] = nonPrivacySafeAttributes;
        $[12] = option;
        $[13] = setLocalQuery;
        $[14] = setOption;
        $[15] = t4;
    } else t4 = $[15];
    const onResultClicked = t4;
    let t5;
    if ($[16] !== icon || $[17] !== onResultClicked || $[18] !== option.value || $[19] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            id: option.value,
            icon: icon,
            title: title,
            resultType: "queryFilters",
            onResultClicked: onResultClicked,
            highlightedRightMetadata: highlightedRightMetadata
        });
        $[16] = icon;
        $[17] = onResultClicked;
        $[18] = option.value;
        $[19] = title;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : ({ title: title, option: option, setOption: setOption, localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const intl = (0, $aXWIB.useIntl)();
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    const { addSelectedQueryFilter: addSelectedQueryFilter } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
        label: intl.formatMessage((0, $becbf29994847995$export$defe85febe8b728c).filterIconLabel)
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const onResultClicked = (0, $42omo.useCallback)(()=>{
        if (!currentQueryFilter) return;
        // Set the filter
        setOption({
            ...option,
            isSelected: false
        });
        // Update the query shown in the input
        const newLocalQuery = (0, $573c8bfe15d4c6dc$export$53fd39a93e83286f)(localQuery, currentQueryFilter?.keyword, option.label);
        setLocalQuery(newLocalQuery);
        // Update the selected query filters
        addSelectedQueryFilter({
            filterId: currentQueryFilter.filterId,
            keyword: currentQueryFilter.keyword,
            displayText: currentQueryFilter.keyword + option.label,
            option: option
        });
        // Fire analytics event
        fireAnalyticsEvent((0, $e6d2962f130fd57e$export$724848965240e03c)({
            actionSubjectId: currentQueryFilter.filterId,
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        inputRef?.current?.focus();
    }, [
        addSelectedQueryFilter,
        commonAttributes,
        currentQueryFilter,
        fireAnalyticsEvent,
        inputRef,
        localQuery,
        nonPrivacySafeAttributes,
        option,
        setLocalQuery,
        setOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
        id: option.value,
        icon: icon,
        title: title,
        resultType: 'queryFilters',
        onResultClicked: onResultClicked,
        highlightedRightMetadata: highlightedRightMetadata
    });
};
















const $51a381ed95ba126a$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $51a381ed95ba126a$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'radius.large',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none'
});
const $51a381ed95ba126a$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $51a381ed95ba126a$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small'
});
const $51a381ed95ba126a$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $51a381ed95ba126a$var$titleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small',
    height: '16px',
    width: '40%'
});
const $51a381ed95ba126a$export$1983fc89ea4805f2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            $51a381ed95ba126a$var$resultStyles
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $51a381ed95ba126a$var$iconAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $51a381ed95ba126a$var$iconStyles
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $51a381ed95ba126a$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t0
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $51a381ed95ba126a$var$middleAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $51a381ed95ba126a$var$titleStyles
            ]
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $51a381ed95ba126a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $51a381ed95ba126a$var$resultStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $51a381ed95ba126a$var$iconAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $51a381ed95ba126a$var$iconStyles
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $51a381ed95ba126a$var$middleAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $51a381ed95ba126a$var$titleStyles
        ]
    }))));
};
const $51a381ed95ba126a$export$cc8f1bc150ee9d84 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($51a381ed95ba126a$export$1983fc89ea4805f2, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($51a381ed95ba126a$export$1983fc89ea4805f2, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($51a381ed95ba126a$export$1983fc89ea4805f2, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($51a381ed95ba126a$export$1983fc89ea4805f2, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($51a381ed95ba126a$export$1983fc89ea4805f2, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($51a381ed95ba126a$export$1983fc89ea4805f2, null));
};






















const $5fda3f2bb8e62542$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noOptions: {
        id: "noOptions",
        defaultMessage: "No options"
    }
});


const $b44fb3788556f802$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 'space.200'
});
const $b44fb3788556f802$export$eac7c78123119abb = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage((0, $5fda3f2bb8e62542$export$defe85febe8b728c).noOptions);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $b44fb3788556f802$var$containerStyles
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b44fb3788556f802$var$containerStyles
    }, intl.formatMessage((0, $5fda3f2bb8e62542$export$defe85febe8b728c).noOptions));
};


const $8215af3ea39f4647$var$titleContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $8215af3ea39f4647$var$iconStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $8215af3ea39f4647$var$titleStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $8215af3ea39f4647$var$ContributorQueryFilterOptions = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            filterId: (0, $ehGUC.contributorFilter).id
        };
        $[0] = t1;
    } else t1 = $[0];
    const [filterData, t2] = (0, $5cssW.useSelectFilter)(t1);
    const { setOption: setOption } = t2;
    if (filterData?.isLoading) {
        let t3;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $51a381ed95ba126a$export$cc8f1bc150ee9d84), null);
            $[1] = t3;
        } else t3 = $[1];
        return t3;
    }
    if (!filterData || filterData.options.length === 0) {
        let t3;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b44fb3788556f802$export$eac7c78123119abb), null);
            $[2] = t3;
        } else t3 = $[2];
        return t3;
    }
    let t3;
    if ($[3] !== filterData.options || $[4] !== inputRef || $[5] !== localQuery || $[6] !== setLocalQuery || $[7] !== setOption) {
        let t4;
        if ($[9] !== inputRef || $[10] !== localQuery || $[11] !== setLocalQuery || $[12] !== setOption) {
            t4 = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9dcebcedad235590$export$36d18380658d5d20), {
                    key: option.value,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: $8215af3ea39f4647$var$titleContainerStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: $8215af3ea39f4647$var$iconStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                        src: option.avatarUrl,
                        size: "small",
                        borderColor: "transparent",
                        appearance: "circle",
                        name: option.label
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: $8215af3ea39f4647$var$titleStyles,
                        as: "span"
                    }, option.label)),
                    option: option,
                    setOption: setOption,
                    localQuery: localQuery,
                    setLocalQuery: setLocalQuery,
                    inputRef: inputRef
                });
            $[9] = inputRef;
            $[10] = localQuery;
            $[11] = setLocalQuery;
            $[12] = setOption;
            $[13] = t4;
        } else t4 = $[13];
        t3 = filterData.options.map(t4);
        $[3] = filterData.options;
        $[4] = inputRef;
        $[5] = localQuery;
        $[6] = setLocalQuery;
        $[7] = setOption;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[14] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3);
        $[14] = t3;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
} : ({ localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const [filterData, { setOption: setOption }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $ehGUC.contributorFilter).id
    });
    if (filterData?.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $51a381ed95ba126a$export$cc8f1bc150ee9d84), null);
    if (!filterData || filterData.options.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b44fb3788556f802$export$eac7c78123119abb), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, // @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
    filterData.options.map((option)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9dcebcedad235590$export$36d18380658d5d20), {
            key: option.value,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8215af3ea39f4647$var$titleContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8215af3ea39f4647$var$iconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                src: option.avatarUrl,
                size: "small",
                borderColor: "transparent",
                appearance: "circle",
                name: option.label
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8215af3ea39f4647$var$titleStyles,
                as: "span"
            }, option.label)),
            option: option,
            setOption: setOption,
            localQuery: localQuery,
            setLocalQuery: setLocalQuery,
            inputRef: inputRef
        });
    }));
};
const $8215af3ea39f4647$export$385c746fbc3d50c5 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef } = t0;
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    if (!currentQueryFilter) return null;
    if (currentQueryFilter.filterId === "contributor") {
        let t1;
        if ($[0] !== inputRef || $[1] !== localQuery || $[2] !== setLocalQuery) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8215af3ea39f4647$var$ContributorQueryFilterOptions, {
                localQuery: localQuery,
                setLocalQuery: setLocalQuery,
                inputRef: inputRef
            });
            $[0] = inputRef;
            $[1] = localQuery;
            $[2] = setLocalQuery;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    return null;
} : ({ localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    if (!currentQueryFilter) return null;
    if (currentQueryFilter.filterId === 'contributor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8215af3ea39f4647$var$ContributorQueryFilterOptions, {
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        inputRef: inputRef
    });
    return null;
};



















var $kevJM = parcelRequire("kevJM");























const $7ce255b0a50b97ee$export$18593f729c2ce860 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'recentQuery',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });




















const $59ce0bd6e733cc83$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    recentSearch: {
        id: "search_dialog_recent_search",
        defaultMessage: "Recent search"
    },
    removeRecentSearch: {
        id: "search_dialog_remove_recent_search_label",
        defaultMessage: "Remove recent search"
    }
});


const $8aeaf6643ef42bf9$export$de317f365b3e4c5c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { result: result, state: state } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    let t1;
    if ($[0] !== commonAttributes || $[1] !== fireAnalyticsEvent || $[2] !== nonPrivacySafeAttributes || $[3] !== primaryProduct || $[4] !== result || $[5] !== setQuickFindOpen || $[6] !== state || $[7] !== updateRecentQueries || $[8] !== user) {
        t1 = (event)=>{
            const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event);
            if (!newTab) setQuickFindOpen(false);
            if (result && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)({
                    value: result,
                    userId: user.id,
                    productId: primaryProduct,
                    key: (0, $1SV4e.RECENT_SEARCH_KEY)
                });
                updateRecentQueries?.();
            }
            fireAnalyticsEvent((0, $7ce255b0a50b97ee$export$18593f729c2ce860)({
                actionSubjectId: (0, $idEgG.getActionSubjectId)(state),
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        $[0] = commonAttributes;
        $[1] = fireAnalyticsEvent;
        $[2] = nonPrivacySafeAttributes;
        $[3] = primaryProduct;
        $[4] = result;
        $[5] = setQuickFindOpen;
        $[6] = state;
        $[7] = updateRecentQueries;
        $[8] = user;
        $[9] = t1;
    } else t1 = $[9];
    const onResultClicked = t1;
    let t2;
    if ($[10] !== generateSearchUrl || $[11] !== intl || $[12] !== primaryProduct || $[13] !== queryParams || $[14] !== searchSessionId || $[15] !== updateRecentQueries || $[16] !== user.id) {
        t2 = (recentSearch)=>{
            const id = recentSearch.query;
            const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
                label: "",
                size: "small"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                label: intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch),
                color: "currentColor"
            }));
            const title = recentSearch.query;
            const onClick = (event_0)=>{
                event_0.preventDefault();
                event_0.stopPropagation();
                if (user.id && primaryProduct) {
                    (0, $1SV4e.removeRecentSearch)({
                        value: recentSearch,
                        userId: user.id,
                        productId: primaryProduct,
                        key: (0, $1SV4e.RECENT_SEARCH_KEY)
                    });
                    updateRecentQueries?.();
                }
            };
            const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch));
            const hoveredRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                icon: $8aeaf6643ef42bf9$var$_temp,
                spacing: "compact",
                onClick: onClick,
                label: intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch),
                appearance: "subtle"
            }));
            const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
            const url = generateSearchUrl({
                ...queryParams,
                text: recentSearch.query,
                search_id: searchSessionId
            }, recentSearch?.metadata?.intentMode === (0, $4tgkZ.IntentMode).GNIN);
            return {
                id: id,
                icon: icon,
                title: title,
                url: url,
                rightMetadata: rightMetadata,
                hoveredRightMetadata: hoveredRightMetadata,
                highlightedRightMetadata: highlightedRightMetadata
            };
        };
        $[10] = generateSearchUrl;
        $[11] = intl;
        $[12] = primaryProduct;
        $[13] = queryParams;
        $[14] = searchSessionId;
        $[15] = updateRecentQueries;
        $[16] = user.id;
        $[17] = t2;
    } else t2 = $[17];
    const mapRecentQueryToSearchResult = t2;
    let t3;
    if ($[18] !== mapRecentQueryToSearchResult || $[19] !== result) {
        t3 = mapRecentQueryToSearchResult(result);
        $[18] = mapRecentQueryToSearchResult;
        $[19] = result;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] !== onResultClicked || $[22] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            resultType: "recentQueries",
            ...t3,
            onResultClicked: onResultClicked
        });
        $[21] = onResultClicked;
        $[22] = t3;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ({ result: result, state: state })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const onResultClicked = (0, $42omo.useCallback)((event)=>{
        const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event);
        if (!newTab) setQuickFindOpen(false);
        // Move this recent query to the top of the list
        if (result && user && user.id && primaryProduct) {
            (0, $1SV4e.addRecentSearch)({
                value: result,
                userId: user.id,
                productId: primaryProduct,
                key: (0, $1SV4e.RECENT_SEARCH_KEY)
            });
            updateRecentQueries?.();
        }
        fireAnalyticsEvent((0, $7ce255b0a50b97ee$export$18593f729c2ce860)({
            actionSubjectId: (0, $idEgG.getActionSubjectId)(state),
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        primaryProduct,
        result,
        setQuickFindOpen,
        state,
        updateRecentQueries,
        user
    ]);
    const mapRecentQueryToSearchResult = (0, $42omo.useCallback)((recentSearch)=>{
        const id = recentSearch.query;
        const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch),
            color: "currentColor"
        }));
        const title = recentSearch.query;
        const onClick = (event_0)=>{
            event_0.preventDefault();
            event_0.stopPropagation();
            if (user.id && primaryProduct) {
                (0, $1SV4e.removeRecentSearch)({
                    value: recentSearch,
                    userId: user.id,
                    productId: primaryProduct,
                    key: (0, $1SV4e.RECENT_SEARCH_KEY)
                });
                updateRecentQueries?.();
            }
        };
        const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch));
        const hoveredRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                    ...iconProps,
                    size: "medium"
                }),
            spacing: 'compact',
            onClick: onClick,
            label: intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch),
            appearance: 'subtle'
        }));
        const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $59ce0bd6e733cc83$export$defe85febe8b728c).recentSearch)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
        const url = generateSearchUrl({
            ...queryParams,
            text: recentSearch.query,
            search_id: searchSessionId
        }, recentSearch?.metadata?.intentMode === (0, $4tgkZ.IntentMode).GNIN);
        return {
            id: id,
            icon: icon,
            title: title,
            url: url,
            rightMetadata: rightMetadata,
            hoveredRightMetadata: hoveredRightMetadata,
            highlightedRightMetadata: highlightedRightMetadata
        };
    }, [
        intl,
        generateSearchUrl,
        queryParams,
        searchSessionId,
        user.id,
        primaryProduct,
        updateRecentQueries
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
        resultType: "recentQueries",
        ...mapRecentQueryToSearchResult(result),
        onResultClicked: onResultClicked
    });
};
function $8aeaf6643ef42bf9$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        ...iconProps,
        size: "medium"
    });
}






















var $eoZFI = parcelRequire("eoZFI");



























































var $5mJ0F = parcelRequire("5mJ0F");







const $dc7736858c485175$export$d74b14d68b6116c1 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "{actor, select, you {You clicked on {absoluteTime}} collaborator {Collaborator clicked on {absoluteTime}} other {{username} clicked on {absoluteTime}}}",
        id: "recommended.eventTypeMessage.icu.absolute.clicked"
    },
    relative: {
        defaultMessage: "{actor, select, you {You clicked {relativeTime}} collaborator {Collaborator clicked {relativeTime}} other {{username} clicked {relativeTime}}}",
        id: "recommended.eventTypeMessage.icu.relative.clicked"
    },
    standalone: {
        defaultMessage: "{actor, select, you {You clicked} collaborator {Collaborator clicked} other {{username} clicked}}",
        id: "recommended.eventTypeMessage.icu.clicked"
    }
});
const $dc7736858c485175$export$4f9f02790bdb3acc = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "{actor, select, you {You commented on {absoluteTime}} collaborator {Collaborator commented on {absoluteTime}} other {{username} commented on {absoluteTime}}}",
        id: "recommended.eventTypeMessage.icu.absolute.commented"
    },
    relative: {
        defaultMessage: "{actor, select, you {You commented {relativeTime}} collaborator {Collaborator commented {relativeTime}} other {{username} commented {relativeTime}}}",
        id: "recommended.eventTypeMessage.icu.relative.commented"
    },
    standalone: {
        defaultMessage: "{actor, select, you {You commented} collaborator {Collaborator commented} other {{username} commented}}",
        id: "recommended.eventTypeMessage.icu.commented"
    }
});
const $dc7736858c485175$export$3aeb55721c4136a9 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "{actor, select, you {You edited on {absoluteTime}} collaborator {Collaborator edited on {absoluteTime}} other {{username} edited on {absoluteTime}}}",
        id: "recommended.eventTypeMessage.icu.absolute.edited"
    },
    relative: {
        defaultMessage: "{actor, select, you {You edited {relativeTime}} collaborator {Collaborator edited {relativeTime}} other {{username} edited {relativeTime}}}",
        id: "recommended.eventTypeMessage.icu.relative.edited"
    },
    standalone: {
        defaultMessage: "{actor, select, you {You edited} collaborator {Collaborator edited} other {{username} edited}}",
        id: "recommended.eventTypeMessage.icu.edited"
    }
});
const $dc7736858c485175$export$3a68954b642505b2 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "{actor, select, you {You viewed on {absoluteTime}} collaborator {Collaborator viewed on {absoluteTime}} other {{username} viewed on {absoluteTime}}}",
        id: "recommended.eventTypeMessage.icu.absolute.viewed"
    },
    relative: {
        defaultMessage: "{actor, select, you {You viewed {relativeTime}} collaborator {Collaborator viewed {relativeTime}} other {{username} viewed {relativeTime}}}",
        id: "recommended.eventTypeMessage.icu.relative.viewed"
    },
    standalone: {
        defaultMessage: "{actor, select, you {You viewed} collaborator {Collaborator viewed} other {{username} viewed}}",
        id: "recommended.eventTypeMessage.icu.viewed"
    }
});
const $dc7736858c485175$export$1a494e42b49a8a7c = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "{actor, select, you {You were mentioned on {absoluteTime}} collaborator {Collaborator was mentioned on {absoluteTime}} other {{username} was mentioned on {absoluteTime}}}",
        id: "recommended.eventTypeMessage.icu.absolute.mentioned"
    },
    relative: {
        defaultMessage: "{actor, select, you {You were mentioned {relativeTime}} collaborator {Collaborator was mentioned {relativeTime}} other {{username} was mentioned {relativeTime}}}",
        id: "recommended.eventTypeMessage.icu.relative.mentioned"
    },
    standalone: {
        defaultMessage: "{actor, select, you {You were mentioned} collaborator {Collaborator was mentioned} other {{username} was mentioned}}",
        id: "recommended.eventTypeMessage.icu.mentioned"
    }
});
const $dc7736858c485175$export$ee020a24f0132a87 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "{actor, select, you {You shared on {absoluteTime}} collaborator {Collaborator shared on {absoluteTime}} other {{username} shared on {absoluteTime}}}",
        id: "recommended.eventTypeMessage.icu.absolute.shared"
    },
    relative: {
        defaultMessage: "{actor, select, you {You shared {relativeTime}} collaborator {Collaborator shared {relativeTime}} other {{username} shared {relativeTime}}}",
        id: "recommended.eventTypeMessage.icu.relative.shared"
    },
    standalone: {
        defaultMessage: "{actor, select, you {You shared} collaborator {Collaborator shared} other {{username} shared}}",
        id: "recommended.eventTypeMessage.icu.shared"
    }
});
const $dc7736858c485175$export$98f426081d28dbab = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "{actor, select, you {You reacted on {absoluteTime}} collaborator {Collaborator reacted on {absoluteTime}} other {{username} reacted on {absoluteTime}}}",
        id: "recommended.eventTypeMessage.icu.absolute.reacted"
    },
    relative: {
        defaultMessage: "{actor, select, you {You reacted {relativeTime}} collaborator {Collaborator reacted {relativeTime}} other {{username} reacted {relativeTime}}}",
        id: "recommended.eventTypeMessage.icu.relative.reacted"
    },
    standalone: {
        defaultMessage: "{actor, select, you {You reacted} collaborator {Collaborator reacted} other {{username} reacted}}",
        id: "recommended.eventTypeMessage.icu.reacted"
    }
});
const $dc7736858c485175$export$db54201f0196ae9c = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "{actor, select, you {You read on {absoluteTime}} collaborator {Collaborator read on {absoluteTime}} other {{username} read on {absoluteTime}}}",
        id: "recommended.eventTypeMessage.icu.absolute.read"
    },
    relative: {
        defaultMessage: "{actor, select, you {You read {relativeTime}} collaborator {Collaborator read {relativeTime}} other {{username} read {relativeTime}}}",
        id: "recommended.eventTypeMessage.icu.relative.read"
    },
    standalone: {
        defaultMessage: "{actor, select, you {You read} collaborator {Collaborator read} other {{username} read}}",
        id: "recommended.eventTypeMessage.icu.read"
    }
});
const $dc7736858c485175$export$7cddd03e6eae6379 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "{actor, select, you {You created on {absoluteTime}} collaborator {Collaborator created on {absoluteTime}} other {{username} created on {absoluteTime}}}",
        id: "recommended.eventTypeMessage.icu.absolute.created"
    },
    relative: {
        defaultMessage: "{actor, select, you {You created {relativeTime}} collaborator {Collaborator created {relativeTime}} other {{username} created {relativeTime}}}",
        id: "recommended.eventTypeMessage.icu.relative.created"
    },
    standalone: {
        defaultMessage: "{actor, select, you {You created} collaborator {Collaborator created} other {{username} created}}",
        id: "recommended.eventTypeMessage.icu.created"
    }
});
const $dc7736858c485175$export$b2634e3b7604b9c4 = (0, $aXWIB.defineMessages)({
    absolute: {
        defaultMessage: "{actor, select, you {You interacted on {absoluteTime}} collaborator {Collaborator interacted on {absoluteTime}} other {{username} interacted on {absoluteTime}}}",
        id: "recommended.eventTypeMessage.icu.absolute.interacted"
    },
    relative: {
        defaultMessage: "{actor, select, you {You interacted {relativeTime}} collaborator {Collaborator interacted {relativeTime}} other {{username} interacted {relativeTime}}}",
        id: "recommended.eventTypeMessage.icu.relative.interacted"
    },
    standalone: {
        defaultMessage: "{actor, select, you {You interacted} collaborator {Collaborator interacted} other {{username} interacted}}",
        id: "recommended.eventTypeMessage.icu.interacted"
    }
});



var $jLeRZ = parcelRequire("jLeRZ");

var $ca6579bc2b696aed$export$1c85aff485fe04bb = /*#__PURE__*/ function(RecommendedEventType) {
    RecommendedEventType["CLICKED"] = "clicked";
    RecommendedEventType["COMMENTED"] = "commented";
    RecommendedEventType["CREATED"] = "created";
    RecommendedEventType["EDITED"] = "edited";
    RecommendedEventType["INTERACTED"] = "interacted";
    RecommendedEventType["MENTIONED"] = "mentioned";
    RecommendedEventType["REACTED"] = "reacted";
    RecommendedEventType["READ"] = "read";
    RecommendedEventType["SHARED"] = "shared";
    RecommendedEventType["VIEWED"] = "viewed";
    return RecommendedEventType;
}({});
var $ca6579bc2b696aed$export$b5d717e83484188d = /*#__PURE__*/ function(RecommendedType) {
    RecommendedType["COLLABORATOR"] = "collaborator";
    RecommendedType["NO_COLLABORATOR"] = "no_collaborator";
    return RecommendedType;
}({});
const $ca6579bc2b696aed$var$RecommendedReasonSchema = (0, $jLeRZ.z).object({
    type: (0, $jLeRZ.z).nativeEnum($ca6579bc2b696aed$export$b5d717e83484188d),
    timestamp: (0, $jLeRZ.z).string().datetime(),
    text: (0, $jLeRZ.z).string(),
    feature: (0, $jLeRZ.z).string().optional()
});
const $ca6579bc2b696aed$export$601e371df44595e1 = (reason, logException)=>{
    try {
        const result = $ca6579bc2b696aed$var$RecommendedReasonSchema.safeParse(JSON.parse(reason || '{}'));
        if (result.success) return result.data;
        logException(result.error);
        return null;
    } catch (error) {
        logException(error);
        return null;
    }
};



var $dlSEv = parcelRequire("dlSEv");


const $3935927ce81c9302$export$ccb93df388e9ef3b = (recommendedType, recommendedEventType, recommendedTimestamp, activityEnrichment)=>{
    if (activityEnrichment && recommendedType === (0, $ca6579bc2b696aed$export$b5d717e83484188d).NO_COLLABORATOR && recommendedEventType === activityEnrichment.eventType) {
        if (!recommendedTimestamp || (0, $dlSEv.default)(new Date(recommendedTimestamp), new Date(activityEnrichment.timestamp))) return activityEnrichment.timestamp;
    }
    return recommendedTimestamp;
};


const $1de35442986369c2$var$ICU_EVENT_TYPE_MESSAGES = {
    // `clicked` corresponds to the backend `sl-clicked` (search-link clicked) signal.
    // For consistency with the recent behaviour applied elsewhere in quick-find — where
    // `sl-clicked` events are surfaced to users as "viewed" — we intentionally map the
    // `clicked` event type to the ICU `viewed` messages here. This avoids exposing an
    // internal click-tracking signal as a user-facing "clicked" action and keeps the
    // wording aligned with the rest of the recommended/recent activity UX.
    clicked: (0, $dc7736858c485175$export$3a68954b642505b2),
    commented: (0, $dc7736858c485175$export$4f9f02790bdb3acc),
    created: (0, $dc7736858c485175$export$7cddd03e6eae6379),
    edited: (0, $dc7736858c485175$export$3aeb55721c4136a9),
    interacted: (0, $dc7736858c485175$export$b2634e3b7604b9c4),
    mentioned: (0, $dc7736858c485175$export$1a494e42b49a8a7c),
    reacted: (0, $dc7736858c485175$export$98f426081d28dbab),
    read: (0, $dc7736858c485175$export$db54201f0196ae9c),
    shared: (0, $dc7736858c485175$export$ee020a24f0132a87),
    viewed: (0, $dc7736858c485175$export$3a68954b642505b2)
};
/**
 * Returns the appropriate message descriptor for a given event type.
 * @param eventType - The type of the event.
 * @param options - Options to configure the message.
 * @returns The message descriptor for the event type.
 */ const $1de35442986369c2$var$messageForEventType = (eventType, options = {})=>{
    const { isAbsolute: isAbsolute = true } = options;
    const eventTypeMessage = $1de35442986369c2$var$ICU_EVENT_TYPE_MESSAGES.hasOwnProperty(eventType) ? $1de35442986369c2$var$ICU_EVENT_TYPE_MESSAGES[eventType] : (0, $dc7736858c485175$export$3a68954b642505b2);
    return isAbsolute ? eventTypeMessage.absolute : eventTypeMessage.relative;
};
// Sort enum values by length descending to avoid substring false positives,
const $1de35442986369c2$var$sortedRecommendedEventTypes = Object.values((0, $ca6579bc2b696aed$export$1c85aff485fe04bb)).sort((a, b)=>b.length - a.length);
const $1de35442986369c2$export$827da8e415d25030 = (feature)=>{
    if (!feature) return null;
    const lowerFeature = feature.toLowerCase();
    if ($1de35442986369c2$var$ICU_EVENT_TYPE_MESSAGES.hasOwnProperty(lowerFeature)) return lowerFeature;
    return null;
};
const $1de35442986369c2$export$b1f293818f14b659 = (text)=>{
    const lowerText = text.toLowerCase();
    for (const eventType of $1de35442986369c2$var$sortedRecommendedEventTypes){
        if (lowerText.includes(eventType)) return eventType;
    }
    return (0, $ca6579bc2b696aed$export$1c85aff485fe04bb).VIEWED;
};
const $1de35442986369c2$export$5a872b663741445e = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { reason: reason, activityEnrichment: activityEnrichment, logException: logException } = t0;
    let isAbsolute;
    let message;
    let t1;
    let t2;
    let timestamp;
    let type;
    if ($[0] !== activityEnrichment || $[1] !== logException || $[2] !== reason) {
        t2 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const parsedReason = (0, $ca6579bc2b696aed$export$601e371df44595e1)(reason, logException);
            if (!parsedReason) {
                t2 = null;
                break bb0;
            }
            const eventType = $1de35442986369c2$export$827da8e415d25030(parsedReason.feature) ?? $1de35442986369c2$export$b1f293818f14b659(parsedReason.text);
            ({ type: type } = parsedReason);
            timestamp = (0, $3935927ce81c9302$export$ccb93df388e9ef3b)(type, eventType, parsedReason.timestamp, activityEnrichment);
            isAbsolute = (0, $3E8x9.isMoreThanOneWeekAgo)(timestamp);
            message = $1de35442986369c2$var$messageForEventType(eventType, {
                isAbsolute: isAbsolute
            });
            t1 = (0, $5mJ0F.selectUnit)(new Date(timestamp).getTime(), new Date(), {
                day: 7
            });
        }
        $[0] = activityEnrichment;
        $[1] = logException;
        $[2] = reason;
        $[3] = isAbsolute;
        $[4] = message;
        $[5] = t1;
        $[6] = t2;
        $[7] = timestamp;
        $[8] = type;
    } else {
        isAbsolute = $[3];
        message = $[4];
        t1 = $[5];
        t2 = $[6];
        timestamp = $[7];
        type = $[8];
    }
    if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    const { value: value, unit: unit } = t1;
    let t3;
    if ($[9] !== isAbsolute || $[10] !== timestamp || $[11] !== unit || $[12] !== value) {
        t3 = isAbsolute ? {
            absoluteTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedDate), {
                value: timestamp,
                month: "short",
                day: "2-digit",
                year: "numeric"
            })
        } : {
            relativeTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedRelativeTime), {
                value: value,
                unit: unit
            })
        };
        $[9] = isAbsolute;
        $[10] = timestamp;
        $[11] = unit;
        $[12] = value;
        $[13] = t3;
    } else t3 = $[13];
    const values = t3;
    const actor = type === (0, $ca6579bc2b696aed$export$b5d717e83484188d).NO_COLLABORATOR ? "you" : "collaborator";
    let t4;
    if ($[14] !== actor || $[15] !== values) {
        t4 = {
            ...values,
            actor: actor,
            username: ""
        };
        $[14] = actor;
        $[15] = values;
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== message || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...message,
            values: t4
        });
        $[17] = message;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
} : ({ reason: reason, activityEnrichment: activityEnrichment, logException: logException })=>{
    const parsedReason = (0, $ca6579bc2b696aed$export$601e371df44595e1)(reason, logException);
    if (!parsedReason) return null;
    const eventType = $1de35442986369c2$export$827da8e415d25030(parsedReason.feature) ?? $1de35442986369c2$export$b1f293818f14b659(parsedReason.text);
    const { type: type } = parsedReason;
    const timestamp = (0, $3935927ce81c9302$export$ccb93df388e9ef3b)(type, eventType, parsedReason.timestamp, activityEnrichment);
    const isAbsolute = (0, $3E8x9.isMoreThanOneWeekAgo)(timestamp);
    const message = $1de35442986369c2$var$messageForEventType(eventType, {
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $5mJ0F.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedRelativeTime), {
            value: value,
            unit: unit
        })
    };
    // Use ICU select so translators get full sentence context and verb conjugation is correct.
    // `actor` is 'you' or 'collaborator'; `username` is the `other` branch for real names in future.
    const actor = type === (0, $ca6579bc2b696aed$export$b5d717e83484188d).NO_COLLABORATOR ? 'you' : 'collaborator';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...message,
        values: {
            ...values,
            actor: actor,
            username: ''
        }
    });
};


const $dafa83c8d1a2ebc0$export$699a0880b9ff7f2d = (result)=>{
    return result?.object?.__typename === 'ConfluencePage' || result?.object?.__typename === 'ConfluenceBlogPost';
};


const $08c020ac92badf5e$export$1186a9d7109952b1 = (result)=>{
    return result?.object?.__typename === 'ExternalDocument';
};





const $4ec2fbc731186dd0$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    attachment: {
        id: "attachment_type",
        defaultMessage: "Attachment"
    },
    blogpost: {
        id: "blogpost_type",
        defaultMessage: "Blogpost"
    },
    comment: {
        id: "comment_type",
        defaultMessage: "Comment"
    },
    page: {
        id: "page_type",
        defaultMessage: "Page"
    },
    whiteboard: {
        id: "whiteboard_type",
        defaultMessage: "Whiteboard"
    }
});


const $07406509c730b963$var$styles = {
    titleContainer: "_zulp12x7 _1e0c116y _4cvr1h6o _p12f1osq",
    textOverflow: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
    rightSection: "_11c8wadc _zulp12x7 _syaz1rpy _1e0c1txw _4cvr1h6o _1bahesu3"
};
const $07406509c730b963$var$TitleWithRightMetadata = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(7);
    const { title: title, rightMetadata: rightMetadata } = props;
    let t0;
    if ($[0] !== title) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $07406509c730b963$var$styles.textOverflow
        }, title);
        $[0] = title;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== rightMetadata) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $07406509c730b963$var$styles.rightSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eoZFI.Show), {
            above: "xs"
        }, rightMetadata));
        $[2] = rightMetadata;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $07406509c730b963$var$styles.titleContainer
        }, t0, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const { title: title, rightMetadata: rightMetadata } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $07406509c730b963$var$styles.titleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $07406509c730b963$var$styles.textOverflow
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $07406509c730b963$var$styles.rightSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eoZFI.Show), {
        above: "xs"
    }, rightMetadata)));
};
const $07406509c730b963$var$mapConfluenceSearchResult = (result, query, searchSessionId, logException, serveNewUI)=>{
    const id = result.id;
    const title = result?.object?.title;
    if (!title) return null;
    const space = result?.object?.space?.name ? result.object.space.name : null;
    const spaceId = result?.object?.space?.id;
    if (!space || !spaceId) return null;
    const rawUrl = result?.object?.links?.base && result.object.links?.webUi ? result?.object?.links?.base + result.object.links?.webUi : undefined;
    if (!rawUrl) return null;
    const url = (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
        url: rawUrl,
        query: query,
        searchSessionId: searchSessionId
    });
    const rightMetadata = result.reason ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1de35442986369c2$export$5a872b663741445e), {
        reason: result.reason,
        activityEnrichment: result.activityEnrichment,
        logException: logException
    }) : null;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const isLiveDoc = result?.object?.__typename === 'ConfluencePage' && result.object.subtype === 'LIVE';
    const icon = (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: undefined,
        type: result.object?.type?.replace('_', '').toLowerCase() || '',
        isLiveDoc: isLiveDoc
    });
    const metadata = [
        [
            'type',
            isLiveDoc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $4ec2fbc731186dd0$export$defe85febe8b728c).liveDoc) : result?.object?.type === 'ATTACHMENT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $4ec2fbc731186dd0$export$defe85febe8b728c).attachment) : result?.object?.type === 'BLOG_POST' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $4ec2fbc731186dd0$export$defe85febe8b728c).blogpost) : result?.object?.type === 'COMMENT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $4ec2fbc731186dd0$export$defe85febe8b728c).comment) : result?.object?.type === 'PAGE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $4ec2fbc731186dd0$export$defe85febe8b728c).page) : result?.object?.type === 'WHITEBOARD' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $4ec2fbc731186dd0$export$defe85febe8b728c).whiteboard) : null
        ],
        space
    ];
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `${(0, $1yEFx.ProductKeys).Confluence} ${result?.object?.type}`,
        product: (0, $1yEFx.ProductKeys).Confluence
    };
    if (serveNewUI) {
        const titleWithRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07406509c730b963$var$TitleWithRightMetadata, {
            title: title,
            rightMetadata: rightMetadata
        });
        return {
            id: id,
            icon: icon,
            title: titleWithRightMetadata,
            highlightedTitle: highlightedTitle,
            highlightedRightMetadata: highlightedRightMetadata,
            url: url,
            analyticsMetadata: analyticsMetadata
        };
    }
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $07406509c730b963$var$mapExternalDocumentSearchResult = (result, query, searchSessionId, thirdPartyConfigs, logException, serveNewUI)=>{
    const id = result.id;
    const object = result.object;
    if (!object) return null;
    const { displayName: displayName, url: url, documentType: documentType, parent: parent, provider: provider } = object;
    const providerId = provider?.providerId;
    const product = (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, providerId) || (0, $6QzpZ.getProductFromThirdPartyId)({
        thirdPartyId: id
    });
    if (!product || !displayName || !url) return null;
    const subtype = documentType?.category?.toLowerCase();
    const label = (0, $9kYXz.getDocumentSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const highlightedTitle = displayName && query ? (0, $bloXB.highlightMatchedText)(displayName, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), label) : subtype ? subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase() : null
    ];
    const parentName = parent?.displayName ?? null;
    const metadata = [
        typeLabel,
        parentName
    ];
    const rightMetadata = result.reason ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1de35442986369c2$export$5a872b663741445e), {
        reason: result.reason,
        activityEnrichment: result.activityEnrichment,
        logException: logException
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, rightMetadata, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const urlWithAnalytics = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype ?? 'document'}`,
        product: product
    };
    if (serveNewUI) {
        const titleWithRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($07406509c730b963$var$TitleWithRightMetadata, {
            title: displayName,
            rightMetadata: rightMetadata
        });
        return {
            id: id,
            icon: icon,
            title: titleWithRightMetadata,
            highlightedTitle: highlightedTitle,
            highlightedRightMetadata: highlightedRightMetadata,
            url: url,
            analyticsMetadata: analyticsMetadata
        };
    }
    return {
        id: id,
        icon: icon,
        title: displayName,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: rightMetadata,
        url: urlWithAnalytics,
        analyticsMetadata: analyticsMetadata
    };
};
const $07406509c730b963$var$mapSearchResult = (result, query, searchSessionId, logException, serveNewUI, thirdPartyConfigs)=>{
    if ((0, $dafa83c8d1a2ebc0$export$699a0880b9ff7f2d)(result)) return $07406509c730b963$var$mapConfluenceSearchResult(result, query, searchSessionId, logException, serveNewUI);
    if ((0, $08c020ac92badf5e$export$1186a9d7109952b1)(result)) return $07406509c730b963$var$mapExternalDocumentSearchResult(result, query, searchSessionId, thirdPartyConfigs, logException, serveNewUI);
    return null;
};
const $07406509c730b963$export$1c25f2e531135fae = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted } = t0;
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const logException = (0, $f8oYd.useLogException)();
    let mappedResult;
    let t1;
    if ($[0] !== logException || $[1] !== quickFindQuery || $[2] !== result || $[3] !== searchSessionId || $[4] !== state || $[5] !== thirdPartyConfigs) {
        const serveNewUI = state === "PREQUERY_RESULTS" && (0, $dh538.fg)("quick_find_recommendations_new_ui");
        mappedResult = $07406509c730b963$var$mapSearchResult(result, quickFindQuery, searchSessionId, logException, serveNewUI, thirdPartyConfigs);
        t1 = (0, $gRvZB.isProductImpersonated)(mappedResult?.analyticsMetadata.product, thirdPartyConfigs);
        $[0] = logException;
        $[1] = quickFindQuery;
        $[2] = result;
        $[3] = searchSessionId;
        $[4] = state;
        $[5] = thirdPartyConfigs;
        $[6] = mappedResult;
        $[7] = t1;
    } else {
        mappedResult = $[6];
        t1 = $[7];
    }
    const isImpersonated = t1;
    const t2 = mappedResult?.analyticsMetadata;
    const t3 = mappedResult?.analyticsMetadata.product;
    let t4;
    if ($[8] !== result.id || $[9] !== t3 || $[10] !== thirdPartyConfigs) {
        t4 = (0, $kQT7c.getResultConnectorSource)({
            resultNodeId: result.id,
            thirdPartyConfigs: thirdPartyConfigs,
            productKey: t3
        });
        $[8] = result.id;
        $[9] = t3;
        $[10] = thirdPartyConfigs;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t2 || $[13] !== t4) {
        t5 = {
            ...t2,
            connectorType: t4
        };
        $[12] = t2;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    const t6 = mappedResult?.analyticsMetadata.product;
    let t7;
    if ($[15] !== t6) {
        t7 = (0, $fuGkE.is3pProductKeyForAnalytics)(t6);
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = mappedResult?.analyticsMetadata.product;
    let t9;
    if ($[17] !== result.id || $[18] !== t8 || $[19] !== thirdPartyConfigs) {
        t9 = (0, $kQT7c.isResultSmartLink)({
            resultAri: result.id,
            thirdPartyConfigs: thirdPartyConfigs,
            productKey: t8
        });
        $[17] = result.id;
        $[18] = t8;
        $[19] = thirdPartyConfigs;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t5 || $[22] !== t7 || $[23] !== t9) {
        t10 = {
            metadata: t5,
            is3pLink: t7,
            is3pSmartLink: t9
        };
        $[21] = t5;
        $[22] = t7;
        $[23] = t9;
        $[24] = t10;
    } else t10 = $[24];
    const additionalAnalyticsAttributes = t10;
    let t11;
    if ($[25] !== additionalAnalyticsAttributes || $[26] !== isImpersonated || $[27] !== onClick || $[28] !== state) {
        t11 = (event, data)=>{
            onClick?.({
                event: event,
                data: data,
                state: state,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                isImpersonated: isImpersonated
            });
        };
        $[25] = additionalAnalyticsAttributes;
        $[26] = isImpersonated;
        $[27] = onClick;
        $[28] = state;
        $[29] = t11;
    } else t11 = $[29];
    const onResultClicked = t11;
    let t12;
    if ($[30] !== additionalAnalyticsAttributes || $[31] !== isImpersonated || $[32] !== onContextMenu || $[33] !== state) {
        t12 = (event_0, data_0)=>{
            onContextMenu?.({
                event: event_0,
                data: data_0,
                state: state,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                isImpersonated: isImpersonated
            });
        };
        $[30] = additionalAnalyticsAttributes;
        $[31] = isImpersonated;
        $[32] = onContextMenu;
        $[33] = state;
        $[34] = t12;
    } else t12 = $[34];
    const onResultContextMenu = t12;
    let t13;
    if ($[35] !== additionalAnalyticsAttributes || $[36] !== onHighlighted || $[37] !== state) {
        t13 = (data_1)=>{
            onHighlighted?.({
                data: data_1,
                state: state,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes
            });
        };
        $[35] = additionalAnalyticsAttributes;
        $[36] = onHighlighted;
        $[37] = state;
        $[38] = t13;
    } else t13 = $[38];
    const onResultHighlighted = t13;
    if (!mappedResult) {
        invalidateItem(result.id);
        return null;
    }
    let t14;
    if ($[39] !== mappedResult || $[40] !== onResultClicked || $[41] !== onResultContextMenu || $[42] !== onResultHighlighted) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
            ...mappedResult,
            resultType: "recommendations",
            product: mappedResult.analyticsMetadata.product,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultContextMenu,
            onResultHighlighted: onResultHighlighted
        });
        $[39] = mappedResult;
        $[40] = onResultClicked;
        $[41] = onResultContextMenu;
        $[42] = onResultHighlighted;
        $[43] = t14;
    } else t14 = $[43];
    return t14;
} : ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const { invalidateItem: invalidateItem } = (0, $39181c35e6b4cafd$export$a511f36416966245)();
    const logException = (0, $f8oYd.useLogException)();
    const serveNewUI = state === 'PREQUERY_RESULTS' && (0, $dh538.fg)('quick_find_recommendations_new_ui');
    const mappedResult = $07406509c730b963$var$mapSearchResult(result, quickFindQuery, searchSessionId, logException, serveNewUI, thirdPartyConfigs);
    const isImpersonated = (0, $gRvZB.isProductImpersonated)(mappedResult?.analyticsMetadata.product, thirdPartyConfigs);
    const additionalAnalyticsAttributes = (0, $42omo.useMemo)(()=>({
            metadata: {
                ...mappedResult?.analyticsMetadata,
                connectorType: (0, $kQT7c.getResultConnectorSource)({
                    // We cannot provide a value for connectorType here because the user relevant documents API
                    // does not return a connectorType for a given entity.
                    resultNodeId: result.id,
                    thirdPartyConfigs: thirdPartyConfigs,
                    productKey: mappedResult?.analyticsMetadata.product
                })
            },
            is3pLink: (0, $fuGkE.is3pProductKeyForAnalytics)(mappedResult?.analyticsMetadata.product),
            is3pSmartLink: (0, $kQT7c.isResultSmartLink)({
                resultAri: result.id,
                thirdPartyConfigs: thirdPartyConfigs,
                productKey: mappedResult?.analyticsMetadata.product
            })
        }), [
        mappedResult,
        result.id,
        thirdPartyConfigs
    ]);
    const onResultClicked = (0, $42omo.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes,
            isImpersonated: isImpersonated
        });
    }, [
        additionalAnalyticsAttributes,
        isImpersonated,
        onClick,
        state
    ]);
    const onResultContextMenu = (0, $42omo.useCallback)((event_0, data_0)=>{
        onContextMenu?.({
            event: event_0,
            data: data_0,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes,
            isImpersonated: isImpersonated
        });
    }, [
        additionalAnalyticsAttributes,
        isImpersonated,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $42omo.useCallback)((data_1)=>{
        onHighlighted?.({
            data: data_1,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) {
        invalidateItem(result.id);
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
        ...mappedResult,
        resultType: "recommendations",
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted
    });
};


const $d55e301b7ec82134$export$45fde34c61c061c6 = (recommendations, recentActivities)=>{
    if (recommendations.length === 0 || recentActivities.length === 0) return recommendations;
    // Build a lookup map: thirdPartyAri → activity enrichment data
    const activityEnrichmentMap = new Map();
    for (const activity of recentActivities){
        const activityObject = activity.data.node.object;
        // object.id is a thirdPartyAri (e.g, "ari:third-party:microsoft.sharepoint::document/driveId/..."),
        const thirdPartyAri = activityObject.id;
        if (!thirdPartyAri) continue;
        const event = activity.data.node.event;
        const enrichment = {
            timestamp: event.timestamp,
            eventType: event.eventType
        };
        // Use the first matching activity for each document
        if (!activityEnrichmentMap.has(thirdPartyAri)) activityEnrichmentMap.set(thirdPartyAri, enrichment);
    }
    return recommendations.map((recommendation)=>{
        const activityEnrichment = activityEnrichmentMap.get(recommendation.id);
        if (!activityEnrichment) return recommendation;
        return {
            ...recommendation,
            data: {
                ...recommendation.data,
                activityEnrichment: activityEnrichment
            }
        };
    });
};































































const $fbb70dd8ca3729b4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    searchAcrossProducts: {
        id: "search_dialog_search_across_products",
        defaultMessage: "Search all apps"
    },
    more: {
        id: "search_dialog_search_across_products.more",
        defaultMessage: "more"
    },
    moreApps: {
        id: "search_dialog_search_across_products.more-apps",
        defaultMessage: "+ {more}"
    },
    moreAppsCount: {
        id: "search_dialog_search_across_products.more-apps-count",
        defaultMessage: "+{count}"
    }
});


const $130bb7db5dbd93df$var$styles = {
    moreButtonStyles: "_2rko12b0 _4cvr1h6o _bfhki8nm _1e0c1txw _18u01b66 _19bv1b66 _u5f31b66"
};
const $130bb7db5dbd93df$export$2bea3e9ad1fa13ae = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { product: product } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    let t1;
    if ($[0] !== availableProducts || $[1] !== formatMessage || $[2] !== productConfigs || $[3] !== thirdPartyConfigs) {
        const remainingAppCount = (0, $af90b002ca1d8064$export$f9fde84c1bef3da9)(availableProducts, thirdPartyConfigs, productConfigs, (0, $gGFxq.isUserOAuthed));
        t1 = remainingAppCount > 0 ? formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).moreAppsCount, {
            count: remainingAppCount
        }) : formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).moreApps, {
            more: formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).more)
        });
        $[0] = availableProducts;
        $[1] = formatMessage;
        $[2] = productConfigs;
        $[3] = thirdPartyConfigs;
        $[4] = t1;
    } else t1 = $[4];
    const countLabel = t1;
    let t2;
    if ($[5] !== product) {
        t2 = product === (0, $6Gsan.PrimaryProductKeys).Jira ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLkRZ.JiraAppSelectorIconWithGithub), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3KrAM.AllAppsIcon), null);
        $[5] = product;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== countLabel) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $130bb7db5dbd93df$var$styles.moreButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            size: "small",
            align: "center",
            color: "color.text.subtle"
        }, countLabel));
        $[7] = countLabel;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            role: "presentation"
        }, t2, t3);
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ product: product })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const remainingAppCount = (0, $af90b002ca1d8064$export$f9fde84c1bef3da9)(availableProducts, thirdPartyConfigs, productConfigs, (0, $gGFxq.isUserOAuthed));
    const countLabel = remainingAppCount > 0 ? formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).moreAppsCount, {
        count: remainingAppCount
    }) : formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).moreApps, {
        more: formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).more)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        role: "presentation"
    }, product === (0, $6Gsan.PrimaryProductKeys).Jira ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLkRZ.JiraAppSelectorIconWithGithub), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3KrAM.AllAppsIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $130bb7db5dbd93df$var$styles.moreButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        align: "center",
        color: "color.text.subtle"
    }, countLabel)));
};
const $130bb7db5dbd93df$export$bf6cf7fe2100de5c = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(32);
    const { state: state, onClick: onClick } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    let t1;
    if ($[0] !== clearAllFilters || $[1] !== onClick || $[2] !== primaryProduct || $[3] !== state) {
        t1 = (event)=>{
            onClick({
                state: state,
                event: event,
                actionSubjectId: `${primaryProduct?.toLowerCase() || ""}AdvancedSearchLink`
            });
            clearAllFilters();
        };
        $[0] = clearAllFilters;
        $[1] = onClick;
        $[2] = primaryProduct;
        $[3] = state;
        $[4] = t1;
    } else t1 = $[4];
    const onResultClicked = t1;
    let t2;
    if ($[5] !== primaryProduct) {
        t2 = (0, $3a090af578c3c72f$export$1a414fdf8e9c6492)() && primaryProduct && primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)("jira_search_fps_cta_swap");
        $[5] = primaryProduct;
        $[6] = t2;
    } else t2 = $[6];
    const swapQuickFindCTAs = t2;
    let t3;
    if ($[7] !== intl) {
        t3 = (0, $dh538.fg)("ai-a11y-111-19638-35211") ? "" : intl.formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).searchAcrossProducts);
        $[7] = intl;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: t3,
            color: "currentColor"
        });
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const icon = t4;
    let t5;
    if ($[11] !== intl) {
        t5 = intl.formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).searchAcrossProducts);
        $[11] = intl;
        $[12] = t5;
    } else t5 = $[12];
    const title = t5;
    let t6;
    if ($[13] !== primaryProduct) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($130bb7db5dbd93df$export$2bea3e9ad1fa13ae, {
            product: primaryProduct
        });
        $[13] = primaryProduct;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== primaryProduct || $[16] !== swapQuickFindCTAs) {
        t7 = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && !swapQuickFindCTAs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $738ebcb5194247d5$export$76bfbab5e3f9a6a3), null);
        $[15] = primaryProduct;
        $[16] = swapQuickFindCTAs;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null);
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t6 || $[20] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.100"
        }, t6, t7, t8);
        $[19] = t6;
        $[20] = t7;
        $[21] = t9;
    } else t9 = $[21];
    const rightMetadata = t9;
    let t10;
    if ($[22] !== generateSearchUrl || $[23] !== queryParams || $[24] !== quickFindQuery) {
        t10 = generateSearchUrl({
            ...queryParams,
            text: quickFindQuery
        });
        $[22] = generateSearchUrl;
        $[23] = queryParams;
        $[24] = quickFindQuery;
        $[25] = t10;
    } else t10 = $[25];
    const url = t10;
    let t11;
    if ($[26] !== icon || $[27] !== onResultClicked || $[28] !== rightMetadata || $[29] !== title || $[30] !== url) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02caee92bec6b3d2$export$64ded8b71dfcba9e), {
            icon: icon,
            title: title,
            rightMetadata: rightMetadata,
            url: url,
            onResultClicked: onResultClicked
        });
        $[26] = icon;
        $[27] = onResultClicked;
        $[28] = rightMetadata;
        $[29] = title;
        $[30] = url;
        $[31] = t11;
    } else t11 = $[31];
    return t11;
} : ({ state: state, onClick: onClick })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const onResultClicked = (0, $42omo.useCallback)((event)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: `${primaryProduct?.toLowerCase() || ''}AdvancedSearchLink`
        }); // Executing a search query on FPS search will always clear the filters in QF as FPS filters
        // is the source of truth for filter state.
        clearAllFilters();
    }, [
        onClick,
        state,
        primaryProduct,
        clearAllFilters
    ]);
    const swapQuickFindCTAs = (0, $3a090af578c3c72f$export$1a414fdf8e9c6492)() && primaryProduct && primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_search_fps_cta_swap');
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: (0, $dh538.fg)('ai-a11y-111-19638-35211') ? '' : intl.formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).searchAcrossProducts),
        color: "currentColor"
    });
    const title = intl.formatMessage((0, $fbb70dd8ca3729b4$export$defe85febe8b728c).searchAcrossProducts);
    const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($130bb7db5dbd93df$export$2bea3e9ad1fa13ae, {
        product: primaryProduct
    }), primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && !swapQuickFindCTAs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $738ebcb5194247d5$export$76bfbab5e3f9a6a3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
    const url = generateSearchUrl({
        ...queryParams,
        text: quickFindQuery
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02caee92bec6b3d2$export$64ded8b71dfcba9e), {
        icon: icon,
        title: title,
        rightMetadata: rightMetadata,
        url: url,
        onResultClicked: onResultClicked
    });
};


const $65bfe5bd0ff37bd4$export$180aeaf62c6751c6 = (activity)=>{
    if (activity?.data.node.object.type === 'issue' && activity?.data.node.object.product === 'jira' && activity?.data.node.object.data && 'key' in activity?.data.node.object.data) return activity?.data.node.object.data.key;
    return undefined;
};





const $9c9aa173e8807d95$export$79a202b0ea95cc8f = (result)=>{
    if ((0, $8LSUr.isSearchResultJiraIssue)(result.data)) return result.data.issue?.key;
    return undefined;
};





const $8de93e58797c140f$var$MIN_QUERY_LENGTH = 2;
const $8de93e58797c140f$export$7daacdf8b47e48e1 = (query, item)=>{
    const itemKey = (0, $65bfe5bd0ff37bd4$export$180aeaf62c6751c6)(item);
    if (query.length >= $8de93e58797c140f$var$MIN_QUERY_LENGTH && itemKey) {
        const itemKeyFromQuery = (0, $lsW5D.normalizeWorkItemKey)(query.trim());
        if (itemKeyFromQuery === itemKey?.toLowerCase()) return item;
    }
    return undefined;
};
const $8de93e58797c140f$export$6e5b6a45f7960503 = (query, item)=>{
    const itemKey = (0, $9c9aa173e8807d95$export$79a202b0ea95cc8f)(item);
    if (query.length >= $8de93e58797c140f$var$MIN_QUERY_LENGTH && itemKey) {
        const itemKeyFromQuery = (0, $lsW5D.normalizeWorkItemKey)(query.trim());
        if (itemKeyFromQuery === itemKey?.toLowerCase()) return item;
    }
    return undefined;
};


















var $8DN9t = parcelRequire("8DN9t");

























var $epS7s = parcelRequire("epS7s");








const $0d238640504f0d5e$export$cb9bbb5e417d074a = {
    PRE_QUERY_QF_SUGGESTION: 'pre-query-qf-suggestion'
};












const $342b4005aadcc963$export$41d82c6d8a0a3ca8 = ({ success: success, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'operational',
        action: success ? 'taskSuccess' : 'taskFail',
        actionSubject: 'suggestedQuery',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $875f1f3e3260f408$export$746fc217b00b3d82 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'suggestedQuery',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $80931b93956c3e1c$export$a78be3e217bbe92c = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'suggestedQuery',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

























const $8dfecd1d0bfad5c1$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    zero_query: {
        id: "search_dialog_zero_query",
        defaultMessage: "Suggestion"
    },
    zero_query_icon_label: {
        id: "search_dialog_zero_query_icon_label",
        defaultMessage: "Suggestion search"
    }
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $lAFHW = parcelRequire("lAFHW");
















const $dbf0ba150e688e75$export$e16bd899bb4eebf9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2230_19249)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M1.20962 12.5701L1.91523 13.8205C2.06186 14.0838 2.27262 14.2906 2.52005 14.441L5.04009 9.96582H0C0 10.2573 0.0733104 10.5487 0.219931 10.812L1.20962 12.5701Z",
            fill: "#0066DA"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M8 4.70084L5.47995 0.225632C5.23253 0.376059 5.02176 0.582897 4.87514 0.846144L0.219931 9.11965C0.076007 9.37722 0.000191627 9.66891 0 9.9658H5.04009L8 4.70084Z",
            fill: "#00AC47"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M13.4801 14.441C13.7275 14.2906 13.9383 14.0838 14.0849 13.8205L14.3781 13.3034L15.7802 10.812C15.9268 10.5487 16.0001 10.2573 16.0001 9.96582H10.9597L12.0322 12.1282L13.4801 14.441Z",
            fill: "#EA4335"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M8.00009 4.70085L10.5201 0.225641C10.2727 0.0752137 9.98863 0 9.69539 0H6.30478C6.01154 0 5.72746 0.0846154 5.48004 0.225641L8.00009 4.70085Z",
            fill: "#00832D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M10.9598 9.96582H5.04L2.51996 14.441C2.76738 14.5915 3.05146 14.6667 3.3447 14.6667H12.6551C12.9484 14.6667 13.2324 14.5821 13.4799 14.441L10.9598 9.96582Z",
            fill: "#2684FC"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M13.4525 4.9829L11.1249 0.846144C10.9782 0.582897 10.7675 0.376059 10.52 0.225632L8 4.70084L10.9599 9.9658H15.9908C15.9908 9.67435 15.9175 9.3829 15.7709 9.11965L13.4525 4.9829Z",
            fill: "#FFBA00"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 16 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2230_19249"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "16",
            height: "14.6667",
            fill: "white"
        }))));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19249)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M1.20962 12.5701L1.91523 13.8205C2.06186 14.0838 2.27262 14.2906 2.52005 14.441L5.04009 9.96582H0C0 10.2573 0.0733104 10.5487 0.219931 10.812L1.20962 12.5701Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 4.70084L5.47995 0.225632C5.23253 0.376059 5.02176 0.582897 4.87514 0.846144L0.219931 9.11965C0.076007 9.37722 0.000191627 9.66891 0 9.9658H5.04009L8 4.70084Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4801 14.441C13.7275 14.2906 13.9383 14.0838 14.0849 13.8205L14.3781 13.3034L15.7802 10.812C15.9268 10.5487 16.0001 10.2573 16.0001 9.96582H10.9597L12.0322 12.1282L13.4801 14.441Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.00009 4.70085L10.5201 0.225641C10.2727 0.0752137 9.98863 0 9.69539 0H6.30478C6.01154 0 5.72746 0.0846154 5.48004 0.225641L8.00009 4.70085Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.9598 9.96582H5.04L2.51996 14.441C2.76738 14.5915 3.05146 14.6667 3.3447 14.6667H12.6551C12.9484 14.6667 13.2324 14.5821 13.4799 14.441L10.9598 9.96582Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.4525 4.9829L11.1249 0.846144C10.9782 0.582897 10.7675 0.376059 10.52 0.225632L8 4.70084L10.9599 9.9658H15.9908C15.9908 9.67435 15.9175 9.3829 15.7709 9.11965L13.4525 4.9829Z",
        fill: "#FFBA00"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19249"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "14.6667",
        fill: "white"
    }))));











const $df006fe490c0a4db$export$1c773608dea5140 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2230_19237)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M8.18613 9.14286C10.6521 9.14286 12.6512 7.09616 12.6512 4.57143C12.6512 2.0467 10.6521 0 8.18613 0C5.72011 0 3.72101 2.0467 3.72101 4.57143C3.72101 7.09616 5.72011 9.14286 8.18613 9.14286Z",
            fill: "#036C70"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M11.9068 12.9524C14.1673 12.9524 15.9998 11.0763 15.9998 8.76193C15.9998 6.44759 14.1673 4.57145 11.9068 4.57145C9.64629 4.57145 7.81378 6.44759 7.81378 8.76193C7.81378 11.0763 9.64629 12.9524 11.9068 12.9524Z",
            fill: "#1A9BA1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M8.74415 16C10.4909 16 11.9069 14.5502 11.9069 12.7619C11.9069 10.9735 10.4909 9.5238 8.74415 9.5238C6.99739 9.5238 5.58136 10.9735 5.58136 12.7619C5.58136 14.5502 6.99739 16 8.74415 16Z",
            fill: "#37C6D0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            opacity: "0.1",
            d: "M8.93036 4.12569V12.2552C8.92851 12.5377 8.76131 12.7915 8.50617 12.899C8.42493 12.9342 8.33763 12.9523 8.24943 12.9524H5.58524C5.58152 12.8876 5.58152 12.8266 5.58152 12.7619C5.58028 12.6983 5.58277 12.6347 5.58897 12.5714C5.65707 11.3537 6.3898 10.2793 7.48292 9.79426V9.08568C5.05014 8.69099 3.3905 6.35191 3.77602 3.86121C3.77869 3.84396 3.78145 3.82672 3.78432 3.8095C3.80284 3.68102 3.82894 3.5538 3.86246 3.42855H8.24944C8.6249 3.43001 8.92893 3.74128 8.93036 4.12569Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            opacity: "0.2",
            d: "M7.87705 3.80953H3.78403C3.37055 6.29575 5.00397 8.65439 7.43236 9.07771C7.50589 9.09053 7.57972 9.10145 7.65379 9.11048C6.5003 9.67048 5.65975 11.261 5.5883 12.5714C5.58211 12.6347 5.57962 12.6983 5.58086 12.7619C5.58086 12.8267 5.58086 12.8876 5.58458 12.9524C5.59129 13.0804 5.60747 13.2078 5.63295 13.3333H7.87667C8.15258 13.3314 8.40045 13.1603 8.5055 12.8991C8.53987 12.8159 8.55758 12.7265 8.5576 12.6362V4.50667C8.55619 4.12241 8.25238 3.81121 7.87705 3.80953Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            opacity: "0.2",
            d: "M7.87739 3.80953H3.78436C3.37098 6.29598 5.00464 8.65473 7.43326 9.07796C7.48294 9.08662 7.53275 9.09442 7.58269 9.10135C6.46641 9.70173 5.65897 11.2884 5.58901 12.5714H7.87739C8.25227 12.5685 8.55548 12.2581 8.55832 11.8743V4.50667C8.55689 4.12226 8.25286 3.811 7.87739 3.80953Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            opacity: "0.2",
            d: "M7.50517 3.80953H3.78424C3.39389 6.15676 4.83048 8.41717 7.08471 9.00268C6.23115 10.0011 5.70762 11.2502 5.58889 12.5714H7.50517C7.88065 12.57 8.18467 12.2587 8.1861 11.8743V4.50667C8.1859 4.12175 7.88115 3.80975 7.50517 3.80953Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M0.682047 3.80953H7.504C7.88068 3.80953 8.18605 4.12217 8.18605 4.50782V11.4922C8.18605 11.8778 7.88068 12.1905 7.504 12.1905H0.682047C0.305363 12.1905 0 11.8778 0 11.4922V4.50782C0 4.12217 0.305363 3.80953 0.682047 3.80953Z",
            fill: "url(#paint0_linear_2230_19237)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M3.04621 7.91468C2.88638 7.80614 2.75286 7.66163 2.65588 7.4922C2.56192 7.31509 2.51508 7.11579 2.52007 6.9143C2.5117 6.64148 2.60162 6.37505 2.77272 6.16572C2.95251 5.95615 3.1849 5.80095 3.44472 5.71696C3.74082 5.61718 4.05096 5.56801 4.36267 5.57144C4.77258 5.55611 5.18193 5.61479 5.57197 5.74478V6.62097C5.40249 6.51586 5.21791 6.43872 5.02499 6.3924C4.81567 6.33984 4.60088 6.31349 4.38536 6.31392C4.15809 6.30538 3.93227 6.35431 3.72787 6.4564C3.57007 6.52608 3.46774 6.68503 3.46741 6.86097C3.46677 6.9677 3.50682 7.07047 3.57904 7.14745C3.66434 7.23819 3.76525 7.31206 3.87672 7.36536C4.00074 7.42859 4.18679 7.51266 4.43485 7.61755C4.46217 7.62639 4.48879 7.63734 4.51448 7.65031C4.75862 7.748 4.99415 7.86691 5.21848 8.00574C5.38837 8.11298 5.53095 8.26 5.63449 8.43469C5.74064 8.63272 5.79209 8.8566 5.78332 9.08231C5.79544 9.3624 5.71174 9.63805 5.54667 9.86174C5.38213 10.0674 5.16216 10.219 4.91411 10.2975C4.62236 10.3912 4.31786 10.4364 4.01215 10.4316C3.73787 10.4329 3.46399 10.41 3.19355 10.3631C2.96521 10.3248 2.74237 10.2578 2.53011 10.1634V9.23964C2.733 9.38799 2.95967 9.49887 3.19988 9.56726C3.43928 9.64364 3.68814 9.68443 3.93886 9.68841C4.17091 9.70345 4.40255 9.65312 4.60863 9.54288C4.75299 9.45948 4.84079 9.3015 4.83709 9.13183C4.83806 9.01377 4.79244 8.90032 4.71058 8.81717C4.60879 8.71486 4.49093 8.63077 4.36194 8.56841C4.2131 8.49221 3.99393 8.39177 3.70445 8.26707C3.47415 8.17228 3.25365 8.05423 3.04621 7.91468Z",
            fill: "white"
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
            id: "paint0_linear_2230_19237",
            x1: "1.42208",
            y1: "3.26391",
            x2: "6.95471",
            y2: "12.6234",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            stopColor: "#058F92"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "0.5",
            stopColor: "#038489"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
            offset: "1",
            stopColor: "#026D71"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2230_19237"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "16",
            height: "16",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_19237)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.18613 9.14286C10.6521 9.14286 12.6512 7.09616 12.6512 4.57143C12.6512 2.0467 10.6521 0 8.18613 0C5.72011 0 3.72101 2.0467 3.72101 4.57143C3.72101 7.09616 5.72011 9.14286 8.18613 9.14286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.9068 12.9524C14.1673 12.9524 15.9998 11.0763 15.9998 8.76193C15.9998 6.44759 14.1673 4.57145 11.9068 4.57145C9.64629 4.57145 7.81378 6.44759 7.81378 8.76193C7.81378 11.0763 9.64629 12.9524 11.9068 12.9524Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.74415 16C10.4909 16 11.9069 14.5502 11.9069 12.7619C11.9069 10.9735 10.4909 9.5238 8.74415 9.5238C6.99739 9.5238 5.58136 10.9735 5.58136 12.7619C5.58136 14.5502 6.99739 16 8.74415 16Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M8.93036 4.12569V12.2552C8.92851 12.5377 8.76131 12.7915 8.50617 12.899C8.42493 12.9342 8.33763 12.9523 8.24943 12.9524H5.58524C5.58152 12.8876 5.58152 12.8266 5.58152 12.7619C5.58028 12.6983 5.58277 12.6347 5.58897 12.5714C5.65707 11.3537 6.3898 10.2793 7.48292 9.79426V9.08568C5.05014 8.69099 3.3905 6.35191 3.77602 3.86121C3.77869 3.84396 3.78145 3.82672 3.78432 3.8095C3.80284 3.68102 3.82894 3.5538 3.86246 3.42855H8.24944C8.6249 3.43001 8.92893 3.74128 8.93036 4.12569Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87705 3.80953H3.78403C3.37055 6.29575 5.00397 8.65439 7.43236 9.07771C7.50589 9.09053 7.57972 9.10145 7.65379 9.11048C6.5003 9.67048 5.65975 11.261 5.5883 12.5714C5.58211 12.6347 5.57962 12.6983 5.58086 12.7619C5.58086 12.8267 5.58086 12.8876 5.58458 12.9524C5.59129 13.0804 5.60747 13.2078 5.63295 13.3333H7.87667C8.15258 13.3314 8.40045 13.1603 8.5055 12.8991C8.53987 12.8159 8.55758 12.7265 8.5576 12.6362V4.50667C8.55619 4.12241 8.25238 3.81121 7.87705 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.87739 3.80953H3.78436C3.37098 6.29598 5.00464 8.65473 7.43326 9.07796C7.48294 9.08662 7.53275 9.09442 7.58269 9.10135C6.46641 9.70173 5.65897 11.2884 5.58901 12.5714H7.87739C8.25227 12.5685 8.55548 12.2581 8.55832 11.8743V4.50667C8.55689 4.12226 8.25286 3.811 7.87739 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M7.50517 3.80953H3.78424C3.39389 6.15676 4.83048 8.41717 7.08471 9.00268C6.23115 10.0011 5.70762 11.2502 5.58889 12.5714H7.50517C7.88065 12.57 8.18467 12.2587 8.1861 11.8743V4.50667C8.1859 4.12175 7.88115 3.80975 7.50517 3.80953Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0.682047 3.80953H7.504C7.88068 3.80953 8.18605 4.12217 8.18605 4.50782V11.4922C8.18605 11.8778 7.88068 12.1905 7.504 12.1905H0.682047C0.305363 12.1905 0 11.8778 0 11.4922V4.50782C0 4.12217 0.305363 3.80953 0.682047 3.80953Z",
        fill: "url(#paint0_linear_2230_19237)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M3.04621 7.91468C2.88638 7.80614 2.75286 7.66163 2.65588 7.4922C2.56192 7.31509 2.51508 7.11579 2.52007 6.9143C2.5117 6.64148 2.60162 6.37505 2.77272 6.16572C2.95251 5.95615 3.1849 5.80095 3.44472 5.71696C3.74082 5.61718 4.05096 5.56801 4.36267 5.57144C4.77258 5.55611 5.18193 5.61479 5.57197 5.74478V6.62097C5.40249 6.51586 5.21791 6.43872 5.02499 6.3924C4.81567 6.33984 4.60088 6.31349 4.38536 6.31392C4.15809 6.30538 3.93227 6.35431 3.72787 6.4564C3.57007 6.52608 3.46774 6.68503 3.46741 6.86097C3.46677 6.9677 3.50682 7.07047 3.57904 7.14745C3.66434 7.23819 3.76525 7.31206 3.87672 7.36536C4.00074 7.42859 4.18679 7.51266 4.43485 7.61755C4.46217 7.62639 4.48879 7.63734 4.51448 7.65031C4.75862 7.748 4.99415 7.86691 5.21848 8.00574C5.38837 8.11298 5.53095 8.26 5.63449 8.43469C5.74064 8.63272 5.79209 8.8566 5.78332 9.08231C5.79544 9.3624 5.71174 9.63805 5.54667 9.86174C5.38213 10.0674 5.16216 10.219 4.91411 10.2975C4.62236 10.3912 4.31786 10.4364 4.01215 10.4316C3.73787 10.4329 3.46399 10.41 3.19355 10.3631C2.96521 10.3248 2.74237 10.2578 2.53011 10.1634V9.23964C2.733 9.38799 2.95967 9.49887 3.19988 9.56726C3.43928 9.64364 3.68814 9.68443 3.93886 9.68841C4.17091 9.70345 4.40255 9.65312 4.60863 9.54288C4.75299 9.45948 4.84079 9.3015 4.83709 9.13183C4.83806 9.01377 4.79244 8.90032 4.71058 8.81717C4.60879 8.71486 4.49093 8.63077 4.36194 8.56841C4.2131 8.49221 3.99393 8.39177 3.70445 8.26707C3.47415 8.17228 3.25365 8.05423 3.04621 7.91468Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_2230_19237",
        x1: "1.42208",
        y1: "3.26391",
        x2: "6.95471",
        y2: "12.6234",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#058F92"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.5",
        stopColor: "#038489"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#026D71"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_19237"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    }))));











const $faf0963e4257f812$export$b33fb54b08bb6422 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.86632 0C4.98186 0.000652395 4.26606 0.716982 4.26671 1.59967C4.26606 2.48236 4.98251 3.19869 5.86697 3.19935H7.46723V1.60033C7.46789 0.717635 6.75143 0.00130479 5.86632 0C5.86697 0 5.86697 0 5.86632 0V0ZM5.86632 4.26667H1.60026C0.715805 4.26732 -0.000651915 4.98365 1.78649e-06 5.86634C-0.00130562 6.74903 0.715151 7.46536 1.59961 7.46666H5.86632C6.75078 7.46601 7.46723 6.74968 7.46658 5.86699C7.46723 4.98365 6.75078 4.26732 5.86632 4.26667Z",
            fill: "#36C5F0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.9999 5.86634C16.0005 4.98365 15.2841 4.26732 14.3996 4.26667C13.5151 4.26732 12.7987 4.98365 12.7993 5.86634V7.46667H14.3996C15.2841 7.46601 16.0005 6.74968 15.9999 5.86634ZM11.7331 5.86634V1.59967C11.7338 0.717635 11.018 0.00130479 10.1335 0C9.24907 0.000652395 8.53261 0.716983 8.53327 1.59967V5.86634C8.53196 6.74903 9.24842 7.46536 10.1329 7.46667C11.0173 7.46601 11.7338 6.74968 11.7331 5.86634Z",
            fill: "#2EB67D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.133 15.9998C11.0174 15.9992 11.7339 15.2829 11.7333 14.4002C11.7339 13.5175 11.0174 12.8011 10.133 12.8005H8.53272V14.4002C8.53206 15.2822 9.24852 15.9985 10.133 15.9998ZM10.133 11.7325H14.3997C15.2842 11.7319 16.0006 11.0155 16 10.1328C16.0013 9.25014 15.2848 8.53381 14.4004 8.5325H10.1336C9.24917 8.53315 8.53272 9.24949 8.53337 10.1322C8.53272 11.0155 9.24852 11.7319 10.133 11.7325Z",
            fill: "#ECB22E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.000122517 10.1334C-0.000531185 11.0161 0.715927 11.7325 1.60039 11.7331C2.48485 11.7325 3.2013 11.0161 3.20065 10.1334V8.53375H1.60039C0.715927 8.5344 -0.000531185 9.25074 0.000122517 10.1334ZM4.26684 10.1334V14.4001C4.26553 15.2828 4.98199 15.9991 5.86645 16.0004C6.75091 15.9998 7.46737 15.2835 7.46672 14.4008V10.1347C7.46802 9.25204 6.75156 8.53571 5.86711 8.5344C4.98199 8.5344 4.26619 9.25074 4.26684 10.1334C4.26684 10.1341 4.26684 10.1334 4.26684 10.1334Z",
            fill: "#E01E5A"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.86632 0C4.98186 0.000652395 4.26606 0.716982 4.26671 1.59967C4.26606 2.48236 4.98251 3.19869 5.86697 3.19935H7.46723V1.60033C7.46789 0.717635 6.75143 0.00130479 5.86632 0C5.86697 0 5.86697 0 5.86632 0V0ZM5.86632 4.26667H1.60026C0.715805 4.26732 -0.000651915 4.98365 1.78649e-06 5.86634C-0.00130562 6.74903 0.715151 7.46536 1.59961 7.46666H5.86632C6.75078 7.46601 7.46723 6.74968 7.46658 5.86699C7.46723 4.98365 6.75078 4.26732 5.86632 4.26667Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.9999 5.86634C16.0005 4.98365 15.2841 4.26732 14.3996 4.26667C13.5151 4.26732 12.7987 4.98365 12.7993 5.86634V7.46667H14.3996C15.2841 7.46601 16.0005 6.74968 15.9999 5.86634ZM11.7331 5.86634V1.59967C11.7338 0.717635 11.018 0.00130479 10.1335 0C9.24907 0.000652395 8.53261 0.716983 8.53327 1.59967V5.86634C8.53196 6.74903 9.24842 7.46536 10.1329 7.46667C11.0173 7.46601 11.7338 6.74968 11.7331 5.86634Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.133 15.9998C11.0174 15.9992 11.7339 15.2829 11.7333 14.4002C11.7339 13.5175 11.0174 12.8011 10.133 12.8005H8.53272V14.4002C8.53206 15.2822 9.24852 15.9985 10.133 15.9998ZM10.133 11.7325H14.3997C15.2842 11.7319 16.0006 11.0155 16 10.1328C16.0013 9.25014 15.2848 8.53381 14.4004 8.5325H10.1336C9.24917 8.53315 8.53272 9.24949 8.53337 10.1322C8.53272 11.0155 9.24852 11.7319 10.133 11.7325Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.000122517 10.1334C-0.000531185 11.0161 0.715927 11.7325 1.60039 11.7331C2.48485 11.7325 3.2013 11.0161 3.20065 10.1334V8.53375H1.60039C0.715927 8.5344 -0.000531185 9.25074 0.000122517 10.1334ZM4.26684 10.1334V14.4001C4.26553 15.2828 4.98199 15.9991 5.86645 16.0004C6.75091 15.9998 7.46737 15.2835 7.46672 14.4008V10.1347C7.46802 9.25204 6.75156 8.53571 5.86711 8.5344C4.98199 8.5344 4.26619 9.25074 4.26684 10.1334C4.26684 10.1341 4.26684 10.1334 4.26684 10.1334Z",
        fill: "#E01E5A"
    }));





const $e12b9f2b99596e0f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    zero_query_collaborator_profile_suggestion: {
        id: "search_dialog_zero_query_collaborator_profile_suggestion",
        defaultMessage: "{personAvatar} {name}'s profile"
    },
    zero_query_confluence_pages_created_30_days_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_30_days_suggestion",
        defaultMessage: "{productIcon} Confluence pages I created in the {dateIcon} last 30 days"
    },
    zero_query_confluence_pages_created_7_days_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_7_days_suggestion",
        defaultMessage: "{productIcon} Confluence pages I created in the {dateIcon} last 7 days"
    },
    zero_query_confluence_pages_created_collaborator_7_days_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_collaborator_7_days_suggestion",
        defaultMessage: "{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 7 days"
    },
    zero_query_confluence_pages_created_collaborator_last_30_days_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_collaborator_last_30_days_suggestion",
        defaultMessage: "{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 30 days"
    },
    zero_query_confluence_pages_created_collaborator_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_collaborator_suggestion",
        defaultMessage: "{productIcon} Confluence pages created by {personAvatar} {name}"
    },
    zero_query_confluence_pages_created_suggestion: {
        id: "search_dialog_zero_query_confluence_pages_created_suggestion",
        defaultMessage: "{productIcon} Confluence pages I created"
    },
    zero_query_jira_my_work_items_suggestion: {
        id: "search_dialog_zero_query_jira_my_work_items_suggestion",
        defaultMessage: "Show my {productIcon} work items"
    },
    zero_query_jira_nlq_collaborator_suggestion: {
        id: "search_dialog_zero_query_jira_nlq_collaborator_suggestion",
        defaultMessage: "Recent open items assigned to {name}"
    },
    zero_query_jira_nlq_issues_assigned_to_me_in_the_past_7_days_suggestion: {
        id: "search_dialog_zero_query_issues_assigned_to_me_in_the_past_7_days_suggestion",
        defaultMessage: "Issues assigned to me in the past 7 days"
    },
    zero_query_jira_nlq_issues_i_created_in_the_last_month_suggestion: {
        id: "search_dialog_zero_query_issues_i_created_in_the_last_month_suggestion",
        defaultMessage: "Issues I created in the last month"
    },
    zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion: {
        id: "search_dialog_zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion",
        defaultMessage: "Progress for epics created by me"
    },
    zero_query_jira_nlq_recent_tickets_created_by_me_suggestion: {
        id: "search_dialog_zero_query_recent_tickets_created_by_me_suggestion",
        defaultMessage: "Recent tickets created by me"
    },
    zero_query_jira_nlq_show_all_the_bugs_assigned_to_me_suggestion: {
        id: "search_dialog_zero_query_show_all_the_bugs_assigned_to_me_suggestion",
        defaultMessage: "Show all the bugs assigned to me"
    },
    zero_query_jira_nlq_show_high_priority_tickets_assigned_to_me_suggestion: {
        id: "search_dialog_zero_query_show_high_priority_tickets_assigned_to_me_suggestion",
        defaultMessage: "Show high priority tickets assigned to me"
    },
    zero_query_jira_nlq_show_me_all_of_my_in_progress_work_items_suggestion: {
        id: "search_dialog_zero_query_show_me_all_of_my_in_progress_work_items_suggestion",
        defaultMessage: "Show me all of my in-progress work items"
    },
    zero_query_jira_nlq_show_tickets_due_this_week_suggestion: {
        id: "search_dialog_zero_query_show_tickets_due_this_week_suggestion",
        defaultMessage: "Show tickets due this week"
    },
    zero_query_jira_nlq_what_are_my_open_tickets_suggestion: {
        id: "search_dialog_zero_query_what_are_my_open_tickets_suggestion",
        defaultMessage: "What are my open tickets?"
    },
    zero_query_jira_tickets_assigned_suggestion: {
        id: "search_dialog_zero_query_jira_tickets_assigned_suggestion",
        defaultMessage: "{productIcon} Jira tickets assigned to me"
    },
    zero_query_jira_tickets_assigned_collaborator_suggestion: {
        id: "search_dialog_zero_query_jira_tickets_assigned_collaborator_suggestion",
        defaultMessage: "{productIcon} tickets assigned to {personAvatar} {name}"
    },
    zero_query_jira_tickets_created_collaborator_suggestion: {
        id: "search_dialog_zero_query_jira_tickets_created_collaborator_suggestion",
        defaultMessage: "{productIcon} Jira tickets created by {personAvatar} {name}"
    },
    zero_query_jira_tickets_created_suggestion: {
        id: "search_dialog_zero_query_jira_tickets_created_suggestion",
        defaultMessage: "{productIcon} Jira tickets I created"
    },
    zero_query_third_party_google_collaborator_docs_suggestion: {
        id: "search_dialog_zero_query_third_party_google_collaborator_docs_suggestion",
        defaultMessage: "{productIcon} Google docs from {personAvatar} {name}"
    },
    zero_query_third_party_google_my_docs_suggestion: {
        id: "search_dialog_zero_query_third_party_google_my_docs_suggestion",
        defaultMessage: "My {productIcon} Google Drive docs"
    },
    zero_query_third_party_sharepoint_collaborator_docs_suggestion: {
        id: "search_dialog_zero_query_third_party_sharepoint_collaborator_docs_suggestion",
        defaultMessage: "{productIcon} SharePoint docs from {personAvatar} {name}"
    },
    zero_query_third_party_sharepoint_my_docs_suggestion: {
        id: "search_dialog_zero_query_third_party_sharepoint_my_docs_suggestion",
        defaultMessage: "My {productIcon} SharePoint documents"
    },
    zero_query_third_party_slack_collaborator_messages_suggestion: {
        id: "search_dialog_zero_query_third_party_slack_collaborator_messages_suggestion",
        defaultMessage: "{productIcon} Slack messages from {personAvatar} {name}"
    },
    zero_query_third_party_slack_my_messages_suggestion: {
        id: "search_dialog_zero_query_third_party_slack_my_messages_suggestion",
        defaultMessage: "My {productIcon} Slack messages"
    },
    zero_query_who_is_suggestion: {
        id: "search_dialog_zero_query_who_is_suggestion",
        defaultMessage: "Who is {name}?"
    }
});


const $679323a0f3b8af5f$var$styles = {
    icon3PContainer: "_1e0c116y"
};
const $679323a0f3b8af5f$var$get1PIcon = (product)=>()=>{
        let Icon = null;
        switch(product){
            case (0, $6FG5J.ZeroQueryProduct).CONFLUENCE:
                Icon = (0, $lAFHW.ConfluenceIcon);
                break;
            case (0, $6FG5J.ZeroQueryProduct).JIRA:
                Icon = (0, $lAFHW.JiraIcon);
                break;
            default:
                return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            key: product,
            label: "",
            size: "xsmall",
            shouldUseNewLogoDesign: true
        });
    };
const $679323a0f3b8af5f$var$get3PIcon = (product)=>()=>{
        let Icon = null;
        switch(product){
            case (0, $6FG5J.ZeroQueryProduct).GOOGLE:
                Icon = (0, $dbf0ba150e688e75$export$e16bd899bb4eebf9);
                break;
            case (0, $6FG5J.ZeroQueryProduct).SHAREPOINT:
                Icon = (0, $df006fe490c0a4db$export$1c773608dea5140);
                break;
            case (0, $6FG5J.ZeroQueryProduct).SLACK:
                Icon = (0, $faf0963e4257f812$export$b33fb54b08bb6422);
                break;
            default:
                return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            "aria-hidden": true,
            key: `${product.toLowerCase()}-icon`,
            testId: `${product.toLowerCase()}-icon`,
            xcss: $679323a0f3b8af5f$var$styles.icon3PContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, null));
    };
const $679323a0f3b8af5f$var$app1PIcons = {
    [(0, $6FG5J.ZeroQueryProduct).CONFLUENCE]: $679323a0f3b8af5f$var$get1PIcon((0, $6FG5J.ZeroQueryProduct).CONFLUENCE),
    [(0, $6FG5J.ZeroQueryProduct).JIRA]: $679323a0f3b8af5f$var$get1PIcon((0, $6FG5J.ZeroQueryProduct).JIRA)
}; // Note on non-null assertion operators: not all 3P configs have an `iconBorderless` property, but these are guaranteed
const $679323a0f3b8af5f$var$app3PIcons = {
    [(0, $6FG5J.ZeroQueryProduct).GOOGLE]: $679323a0f3b8af5f$var$get3PIcon((0, $6FG5J.ZeroQueryProduct).GOOGLE),
    [(0, $6FG5J.ZeroQueryProduct).SLACK]: $679323a0f3b8af5f$var$get3PIcon((0, $6FG5J.ZeroQueryProduct).SLACK),
    [(0, $6FG5J.ZeroQueryProduct).SHAREPOINT]: $679323a0f3b8af5f$var$get3PIcon((0, $6FG5J.ZeroQueryProduct).SHAREPOINT)
};
const $679323a0f3b8af5f$export$c80d9e8e7dfc062e = {
    ...$679323a0f3b8af5f$var$app1PIcons,
    ...$679323a0f3b8af5f$var$app3PIcons
}; // TODO: Remove this once BE sends purely structured data instead of a full result string
const $679323a0f3b8af5f$export$eb2fcf5da41deb74 = [
    {
        type: (0, $6FG5J.ZeroQueryType).COLLABORATOR_PROFILE,
        pattern: /:person: ([A-Za-z ]+)'s profile$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_collaborator_profile_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED,
        pattern: /:product: Confluence pages I created$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_30_DAYS,
        pattern: /:product: Confluence pages I created in the :date: last 30 days$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_30_days_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_7_DAYS,
        pattern: /:product: Confluence pages I created in the :date: last 7 days$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_7_days_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR,
        pattern: /:product: Confluence pages created by :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_collaborator_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS,
        pattern: /:product: Confluence pages created by :person: ([A-Za-z ]+) in the :date: last 30 days$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_collaborator_last_30_days_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS,
        pattern: /:product: Confluence pages created by :person: ([A-Za-z ]+) in the :date: last 7 days$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_confluence_pages_created_collaborator_7_days_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_MY_WORK_ITEMS,
        pattern: /Show my :product: work items$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_my_work_items_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Recent tickets created by me$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_recent_tickets_created_by_me_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /What are my open tickets\?$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_what_are_my_open_tickets_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Show tickets due this week$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_show_tickets_due_this_week_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Issues I created in the last month$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_issues_i_created_in_the_last_month_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Show high priority tickets assigned to me$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_show_high_priority_tickets_assigned_to_me_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Show me all of my in-progress work items$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_show_me_all_of_my_in_progress_work_items_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Issues assigned to me in the past 7 days$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_issues_assigned_to_me_in_the_past_7_days_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Show all the bugs assigned to me$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_show_all_the_bugs_assigned_to_me_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ,
        pattern: /Progress for epics created by me$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_NLQ_COLLABORATOR,
        pattern: /Recent open items assigned to ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_nlq_collaborator_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_ASSIGNED,
        pattern: /:product: Jira tickets assigned to me$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_tickets_assigned_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_ASSIGNED_COLLABORATOR,
        pattern: /:product: tickets assigned to :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_tickets_assigned_collaborator_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_CREATED,
        pattern: /:product: Jira tickets I created$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_tickets_created_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).JIRA_TICKETS_CREATED_COLLABORATOR,
        pattern: /:product: Jira tickets created by :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_jira_tickets_created_collaborator_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS,
        pattern: /:product: Google docs from :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_google_collaborator_docs_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_GOOGLE_MY_DOCS,
        pattern: /My :product: Google Drive docs$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_google_my_docs_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS,
        pattern: /:product: SharePoint docs from :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_sharepoint_collaborator_docs_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SHAREPOINT_MY_DOCS,
        pattern: /My :product: SharePoint documents$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_sharepoint_my_docs_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES,
        pattern: /:product: Slack messages from :person: ([A-Za-z ]+)$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_slack_collaborator_messages_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).THIRD_PARTY_SLACK_MY_MESSAGES,
        pattern: /My :product: Slack messages$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_third_party_slack_my_messages_suggestion
    },
    {
        type: (0, $6FG5J.ZeroQueryType).WHO_IS,
        pattern: /Who is ([A-Za-z ]+)\?$/,
        message: (0, $e12b9f2b99596e0f$export$defe85febe8b728c).zero_query_who_is_suggestion
    }
];
const $679323a0f3b8af5f$export$4e6c5ddb3a43998e = (text)=>text // Replace :placeholder: with single space, handling surrounding whitespace
    .replace(/\s*:\w+:\s*/g, ' ') // Normalize multiple consecutive spaces
    .replace(/\s+/g, ' ') // Trim leading and trailing whitespace
    .replace(/^\s+|\s+$/g, '') // Remove spaces before punctuation
    .replace(/\s+([.,!?])/g, '$1');
const $679323a0f3b8af5f$var$productParamMap = {
    [(0, $6FG5J.ZeroQueryProduct).CONFLUENCE]: 'confluence',
    [(0, $6FG5J.ZeroQueryProduct).JIRA]: 'jira',
    [(0, $6FG5J.ZeroQueryProduct).GOOGLE]: 'google',
    [(0, $6FG5J.ZeroQueryProduct).SLACK]: 'slack',
    [(0, $6FG5J.ZeroQueryProduct).SHAREPOINT]: 'sharepoint'
};
const $679323a0f3b8af5f$var$dateRangeParamMap = {
    [(0, $6FG5J.ZeroQueryDateRange).TODAY]: 'today',
    [(0, $6FG5J.ZeroQueryDateRange).YESTERDAY]: 'yesterday',
    [(0, $6FG5J.ZeroQueryDateRange).PAST_7_DAYS]: 'past7Days',
    [(0, $6FG5J.ZeroQueryDateRange).PAST_30_DAYS]: 'past30Days'
};
const $679323a0f3b8af5f$export$8eefcdc4efd41f87 = (product, accountId, dateRange)=>({
        product: product ? $679323a0f3b8af5f$var$productParamMap[product] : undefined,
        contributors: accountId ? accountId : undefined,
        lastModified: dateRange ? $679323a0f3b8af5f$var$dateRangeParamMap[dateRange] : undefined
    });


const $50393a6d169f1c0b$var$HydratedZeroQueryTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { result: result, product: product, avatarUrl: avatarUrl, zeroQueryType: zeroQueryType } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [operationalEventFired, setOperationalEventFired] = (0, $42omo.useState)(false);
    const ProductIcon = (0, $679323a0f3b8af5f$export$c80d9e8e7dfc062e)?.[product];
    let t1;
    let t2;
    if ($[0] !== ProductIcon || $[1] !== avatarUrl || $[2] !== commonAttributes || $[3] !== fireAnalyticsEvent || $[4] !== intl || $[5] !== nonPrivacySafeAttributes || $[6] !== operationalEventFired || $[7] !== result || $[8] !== zeroQueryType) {
        t2 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let t3;
            if ($[11] !== result) {
                t3 = (template)=>result.match(template.pattern);
                $[11] = result;
                $[12] = t3;
            } else t3 = $[12];
            const templateMatch = (0, $679323a0f3b8af5f$export$eb2fcf5da41deb74).find(t3);
            if (templateMatch) {
                if (!operationalEventFired) {
                    fireAnalyticsEvent((0, $342b4005aadcc963$export$41d82c6d8a0a3ca8)({
                        success: true,
                        attributes: {
                            ...commonAttributes,
                            zeroQueryType: zeroQueryType
                        },
                        nonPrivacySafeAttributes: nonPrivacySafeAttributes
                    }));
                    setOperationalEventFired(true);
                }
            } else {
                if (!operationalEventFired) {
                    fireAnalyticsEvent((0, $342b4005aadcc963$export$41d82c6d8a0a3ca8)({
                        success: false,
                        attributes: {
                            ...commonAttributes,
                            zeroQueryType: zeroQueryType,
                            reason: "Pre-query hydration failed: No matching template"
                        },
                        nonPrivacySafeAttributes: nonPrivacySafeAttributes
                    }));
                    setOperationalEventFired(true);
                }
                let t4;
                if ($[13] !== result) {
                    t4 = (0, $679323a0f3b8af5f$export$4e6c5ddb3a43998e)(result);
                    $[13] = result;
                    $[14] = t4;
                } else t4 = $[14];
                let t5;
                if ($[15] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.050"
                    }, t4);
                    $[15] = t4;
                    $[16] = t5;
                } else t5 = $[16];
                t2 = t5;
                break bb0;
            }
            const name = templateMatch.pattern.exec(result)?.[1];
            let t4;
            if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                    label: ""
                });
                $[17] = t4;
            } else t4 = $[17];
            let t5;
            if ($[18] !== avatarUrl) {
                t5 = avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                    label: "",
                    size: "small",
                    src: avatarUrl
                }) : undefined;
                $[18] = avatarUrl;
                $[19] = t5;
            } else t5 = $[19];
            let t6;
            if ($[20] !== ProductIcon) {
                t6 = ProductIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ProductIcon, null) : undefined;
                $[20] = ProductIcon;
                $[21] = t6;
            } else t6 = $[21];
            t1 = intl.formatMessage(templateMatch.message, {
                dateIcon: t4,
                name: name,
                personAvatar: t5,
                productIcon: t6
            });
        }
        $[0] = ProductIcon;
        $[1] = avatarUrl;
        $[2] = commonAttributes;
        $[3] = fireAnalyticsEvent;
        $[4] = intl;
        $[5] = nonPrivacySafeAttributes;
        $[6] = operationalEventFired;
        $[7] = result;
        $[8] = zeroQueryType;
        $[9] = t1;
        $[10] = t2;
    } else {
        t1 = $[9];
        t2 = $[10];
    }
    if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    const hydratedResult = t1;
    let t3;
    if ($[22] !== hydratedResult) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050"
        }, hydratedResult);
        $[22] = hydratedResult;
        $[23] = t3;
    } else t3 = $[23];
    return t3;
} : ({ result: result, product: product, avatarUrl: avatarUrl, zeroQueryType: zeroQueryType })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [operationalEventFired, setOperationalEventFired] = (0, $42omo.useState)(false);
    const ProductIcon = (0, $679323a0f3b8af5f$export$c80d9e8e7dfc062e)?.[product];
    const templateMatch = (0, $679323a0f3b8af5f$export$eb2fcf5da41deb74).find((template)=>result.match(template.pattern));
    if (templateMatch) {
        if (!operationalEventFired) {
            fireAnalyticsEvent((0, $342b4005aadcc963$export$41d82c6d8a0a3ca8)({
                success: true,
                attributes: {
                    ...commonAttributes,
                    zeroQueryType: zeroQueryType
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            setOperationalEventFired(true);
        }
    } else {
        if (!operationalEventFired) {
            fireAnalyticsEvent((0, $342b4005aadcc963$export$41d82c6d8a0a3ca8)({
                success: false,
                attributes: {
                    ...commonAttributes,
                    zeroQueryType: zeroQueryType,
                    reason: 'Pre-query hydration failed: No matching template'
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            setOperationalEventFired(true);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050"
        }, (0, $679323a0f3b8af5f$export$4e6c5ddb3a43998e)(result));
    }
    const name = templateMatch.pattern.exec(result)?.[1];
    const hydratedResult = intl.formatMessage(templateMatch.message, {
        dateIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
            label: ""
        }),
        name: name,
        personAvatar: avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            label: "",
            size: "small",
            src: avatarUrl
        }) : undefined,
        productIcon: ProductIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ProductIcon, null) : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, hydratedResult);
});
const $50393a6d169f1c0b$export$598f770f0380f1f5 = ({ result: result, product: product, avatarUrl: avatarUrl, state: state, zeroQueryType: zeroQueryType, zeroQueryPosition: zeroQueryPosition })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [primarySubProduct] = (0, $j4ply.usePrimarySubProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const updateZeroQueries = (0, $4VmlX.useUpdateZeroQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const zeroQueryIs3P = (0, $1d2671f5d43d8750$export$6da79ec281e5bbf3)(zeroQueryType);
    const zeroQueryVersion = (0, $1d2671f5d43d8750$export$2378e9e94d0e91e3)(zeroQueryType);
    const intentRouterEnabled = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        // Exposure is fired when a user calls the intent detection API
        locale: intl.locale
    })?.cohort === 'test';
    const logException = (0, $f8oYd.useLogException)();
    const analyticsEventActionSubjectId = (0, $idEgG.getActionSubjectId)(state);
    const workspaceId = primaryProduct && cloudId && analyticsAttributes?.activationId ? `ari:cloud:${primaryProduct}:${cloudId}:workspace/${analyticsAttributes.activationId}` : '';
    const atlAttributionHeaderValue = (0, $dh538.fg)('kd_zero_query_agg_atl_attribution_header') ? (0, $jwO5V.createAtlAttributionHeaderValue)({
        atlWorkspaceId: workspaceId,
        tenantId: cloudId || '',
        product: primaryProduct || ''
    }) : undefined;
    const onResultClicked = (0, $42omo.useCallback)((event)=>{
        const newTab = (0, $8wHiG.isOpenInNewTabInteraction)(event);
        if (!newTab) setQuickFindOpen(false);
        // Set the dialog referrer in sessionStorage
        // This will be used to identify when SearchAIDialog is rendered as a result of this click
        (0, $epS7s.setSessionItem)((0, $3R0ts.SEARCH_DIALOG_AI_DIALOG_REFERER_KEY), 'zeroQuery');
        // Move this zero query to the top of the recent list
        if (result && user && user.id && primaryProduct) {
            const zeroQueryResultText = (0, $679323a0f3b8af5f$export$4e6c5ddb3a43998e)(result);
            (0, $1SV4e.addRecentSearch)({
                value: zeroQueryResultText,
                userId: user.id,
                productId: primaryProduct,
                key: (0, $1SV4e.RECENT_SEARCH_KEY)
            });
            updateRecentQueries?.();
        }
        fireAnalyticsEvent((0, $875f1f3e3260f408$export$746fc217b00b3d82)({
            actionSubjectId: analyticsEventActionSubjectId,
            attributes: {
                ...commonAttributes,
                zeroQueryType: zeroQueryType,
                zeroQueryPosition: zeroQueryPosition,
                ...(0, $59vy4.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(primaryProduct) ? {
                    zeroQueryVersion: zeroQueryVersion,
                    is3PZeroQuery: zeroQueryIs3P
                } : {}
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        const mutateFn = (0, $59vy4.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(primaryProduct) ? (0, $3e8764e0c86280c1$export$5ceed206e02a9ef) : (0, $3e8764e0c86280c1$export$123c86f509cbd0ab);
        mutateFn({
            input: {
                cloudId: cloudId || '',
                query: result,
                product: (0, $3fAff.getUppercasePrimaryProductKey)(primaryProduct)
            }
        }, atlAttributionHeaderValue ? {
            'atl-attribution': atlAttributionHeaderValue
        } : {}).then((success)=>{
            if (success) updateZeroQueries?.();
        }).catch((error)=>{
            logException(error);
        });
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        primaryProduct,
        result,
        setQuickFindOpen,
        analyticsEventActionSubjectId,
        user,
        cloudId,
        updateRecentQueries,
        updateZeroQueries,
        logException,
        zeroQueryType,
        zeroQueryPosition,
        zeroQueryVersion,
        zeroQueryIs3P,
        atlAttributionHeaderValue
    ]);
    const mapZeroQueryToSearchResult = (0, $42omo.useCallback)((query)=>{
        const strippedQuery = (0, $679323a0f3b8af5f$export$4e6c5ddb3a43998e)(query);
        const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query_icon_label),
            color: "currentColor"
        }));
        const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query));
        const highlightedRightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5), null));
        const url = generateSearchUrl({
            ...queryParams,
            text: strippedQuery,
            search_id: searchSessionId,
            ...strippedQuery !== queryParams?.text ? {
                referrer: (0, $0d238640504f0d5e$export$cb9bbb5e417d074a).PRE_QUERY_QF_SUGGESTION
            } : {}
        });
        return {
            id: query,
            icon: icon,
            title: strippedQuery,
            url: url,
            rightMetadata: rightMetadata,
            highlightedRightMetadata: highlightedRightMetadata
        };
    }, [
        intl,
        generateSearchUrl,
        queryParams,
        searchSessionId
    ]);
    const mapHydratedZeroQueryToSearchResult = (0, $42omo.useCallback)(({ result: result, product: product, avatarUrl: avatarUrl })=>{
        const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "",
            size: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query_icon_label),
            color: "currentColor"
        }));
        const rightMetadata = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, intl.formatMessage((0, $8dfecd1d0bfad5c1$export$defe85febe8b728c).zero_query));
        // TODO: Uncomment once search quality improves with applied filters and structured queries
        // const zeroQueryParams = getZeroQueryParams(product, accountId, dateRange);
        const text = (0, $679323a0f3b8af5f$export$4e6c5ddb3a43998e)(result);
        const url = generateSearchUrl({
            text: // ...zeroQueryParams,
            text,
            ...text !== queryParams?.text ? {
                referrer: (0, $0d238640504f0d5e$export$cb9bbb5e417d074a).PRE_QUERY_QF_SUGGESTION
            } : {}
        });
        const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($50393a6d169f1c0b$var$HydratedZeroQueryTitle, {
            avatarUrl: avatarUrl,
            product: product,
            result: result,
            zeroQueryType: zeroQueryType
        });
        return {
            icon: icon,
            title: title,
            url: url,
            rightMetadata: rightMetadata,
            isThirdParty: zeroQueryIs3P
        };
    }, [
        generateSearchUrl,
        intl,
        queryParams?.text,
        zeroQueryIs3P,
        zeroQueryType
    ]);
    if ((0, $59vy4.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(primaryProduct) || (0, $dh538.fg)('kd_v0_zero_query_shown_event')) // layer and fg checks are stable between renders and won't cause issues with hook calls
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useEffect)(()=>{
        if (quickFindOpen) fireAnalyticsEvent((0, $80931b93956c3e1c$export$a78be3e217bbe92c)({
            actionSubjectId: analyticsEventActionSubjectId,
            attributes: {
                ...commonAttributes,
                zeroQueryType: zeroQueryType,
                zeroQueryPosition: zeroQueryPosition,
                zeroQueryVersion: zeroQueryVersion,
                is3PZeroQuery: zeroQueryIs3P,
                ...intentRouterEnabled ? {
                    queryClassification: (0, $4tgkZ.INTENT_DETECTION).value()?.mode,
                    modelId: (0, $4tgkZ.INTENT_DETECTION).value()?.modelId,
                    patternType: (0, $4tgkZ.INTENT_DETECTION).value()?.patternType
                } : {}
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only need to run when quickFindOpen changes
    }, [
        quickFindOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2944de3e13791145$export$a2def421b23768aa), {
        resultType: "zeroQueries",
        primarySubProduct: primarySubProduct,
        ...(0, $59vy4.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(primaryProduct) ? mapHydratedZeroQueryToSearchResult({
            result: result,
            product: product,
            avatarUrl: avatarUrl
        }) : mapZeroQueryToSearchResult(result),
        onResultClicked: onResultClicked
    });
};


// Minimum query length for intent detection
const $71af45ffeeb47c72$var$MIN_QUERY_LENGTH = 2;
const $71af45ffeeb47c72$var$searchDialogStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    width: '100%'
});
const $71af45ffeeb47c72$var$searchDialogDefaultStyles = (0, $ecnYn.xcss)({
    borderRadius: "var(--ds-radius-small, 4px)",
    marginTop: 'space.100'
});
const $71af45ffeeb47c72$var$searchDialogRefreshStyles = (0, $ecnYn.xcss)({
    borderRadius: "var(--ds-radius-large, 8px)",
    marginTop: 'space.050'
});
const $71af45ffeeb47c72$var$searchDialogWithIntentRouter = (0, $ecnYn.xcss)({
    top: 'space.0',
    marginTop: 'space.075',
    paddingTop: 'space.500',
    borderRadius: "var(--ds-radius-large, 8px)"
});
const $71af45ffeeb47c72$var$searchResultsSectionStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.100',
    gap: 'space.025',
    overflowY: 'auto'
});
const $71af45ffeeb47c72$var$intentRouterBodyStyles = (0, $ecnYn.xcss)({
    paddingBlockEnd: 'space.100'
});
const $71af45ffeeb47c72$var$footerStyles = (0, $ecnYn.xcss)({
    flexGrow: 1
});
const $71af45ffeeb47c72$var$footerContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    [(0, $bWLcG.media).above.lg]: {
        flexDirection: 'row'
    }
});
const $71af45ffeeb47c72$var$footerSpotlightTargetContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end'
});
const $71af45ffeeb47c72$var$bodyWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.025',
    flexDirection: 'column',
    width: '100%'
});
const $71af45ffeeb47c72$var$footerSpotlightTargetContainerPaddingStyles = (0, $ecnYn.xcss)({
    marginInlineEnd: 'space.400',
    [(0, $bWLcG.media).above.lg]: {
        marginInlineEnd: 'unset',
        paddingBlockStart: 'space.1000'
    }
});
const $71af45ffeeb47c72$var$footerSpotlightTargetStyles = (0, $ecnYn.xcss)({
    marginBlockStart: 'space.negative.400',
    [(0, $bWLcG.media).above.lg]: {
        marginBlockStart: 'unset'
    }
});
const $71af45ffeeb47c72$var$defaultSearchResultsSectionHeightStyles = (0, $ecnYn.xcss)({
    // 86px for the QF footer + 48px for the page header + 86px bottom gap
    maxHeight: 'calc(100vh - 220px)'
});
const $71af45ffeeb47c72$var$jiraSearchResultsSectionHeightStyles = (0, $ecnYn.xcss)({
    // 167px for QF footer + 48px for the page header + 15% gap at the bottom
    maxHeight: 'calc(85vh - 215px)'
});
const $71af45ffeeb47c72$var$SearchResultsSectionWrapper = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, primaryProduct: primaryProduct } = t0;
    const useDefaultHeight = primaryProduct !== (0, $6Gsan.PrimaryProductKeys).Jira;
    const t1 = useDefaultHeight ? $71af45ffeeb47c72$var$defaultSearchResultsSectionHeightStyles : $71af45ffeeb47c72$var$jiraSearchResultsSectionHeightStyles;
    let t2;
    if ($[0] !== t1) {
        t2 = [
            $71af45ffeeb47c72$var$searchResultsSectionStyles,
            t1
        ];
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, primaryProduct: primaryProduct })=>{
    const useDefaultHeight = primaryProduct !== (0, $6Gsan.PrimaryProductKeys).Jira;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $71af45ffeeb47c72$var$searchResultsSectionStyles,
            useDefaultHeight ? $71af45ffeeb47c72$var$defaultSearchResultsSectionHeightStyles : $71af45ffeeb47c72$var$jiraSearchResultsSectionHeightStyles
        ]
    }, children);
};
const $71af45ffeeb47c72$export$2aadebb53f6015f6 = ({ dialogId: dialogId, dialogRef: dialogRef, localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef, PlacementPO: PlacementPO, showFilters: showFilters = true, searchRefreshStyling: searchRefreshStyling = false, beforeContent: beforeContent, preQueryContent: preQueryContent })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { retrySearch: retrySearch } = (0, $djVCD.useSearchActions)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const bannerEligibleProductsOrder = (0, $eO6NY.useBannerEligibleProductsOrder)({
        isOnSearchDialog: true,
        thirdPartyConfigs: thirdPartyConfigs,
        availableProducts: availableProducts
    });
    const content = (0, $4VmlX.useContent)();
    const hasFiredExperimentExposure = (0, $42omo.useRef)(false);
    const serveZeroQuery = (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence || primaryProduct === (0, $6Gsan.PrimaryProductKeys).Atlas || primaryProduct === (0, $6Gsan.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension')) && (0, $dh538.fg)('kd_zero_query_in_qf_fg') || primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira;
    const { intentRouterEnabled: intentRouterEnabled, hideFilterSuggestions: hideFilterSuggestions, maxRecentQueryCountWhenNoSuggestions: maxRecentQueryCountWhenNoSuggestions_0, showMatchingWorkItem: showMatchingWorkItem, intentDetectionControlAnalyticsEnabled: intentDetectionControlAnalyticsEnabled } = (0, $42omo.useMemo)(()=>{
        const serveJiraNINFpsNLQNavigationExp = (0, $26jni.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false,
            // Exposure is fired when a user calls the intent detection API
            locale: intl.locale
        });
        const maxRecentQueryCountWhenNoSuggestions = serveJiraNINFpsNLQNavigationExp?.uiFeatures.maxRecentQueryCountWhenNoSuggestions ?? (0, $3R0ts.DEFAULT_RECENT_AND_SUGGESTED_QUERY_LIMIT);
        return {
            intentRouterEnabled: serveJiraNINFpsNLQNavigationExp?.cohort === 'test',
            intentDetectionControlAnalyticsEnabled: serveJiraNINFpsNLQNavigationExp?.cohort === 'control' && (serveJiraNINFpsNLQNavigationExp?.uiFeatures.enableControlIntentDetectionAnalytics ?? false),
            hideFilterSuggestions: serveJiraNINFpsNLQNavigationExp?.uiFeatures.hideFilterSuggestions ?? false,
            maxRecentQueryCountWhenNoSuggestions: maxRecentQueryCountWhenNoSuggestions,
            showMatchingWorkItem: serveJiraNINFpsNLQNavigationExp?.uiFeatures.showMatchingWorkItem ?? false
        };
    }, [
        primaryProduct,
        intl.locale
    ]);
    const serveZeroQuery3PRecs = (0, $2OtFZ.serveQFZeroQuery3PRecsExperiment)({
        fireExperimentExposure: false
    });
    const allItems = $71af45ffeeb47c72$export$d88c04dcf9cd911b(content, serveZeroQuery, maxRecentQueryCountWhenNoSuggestions_0, hideFilterSuggestions, primaryProduct, serveZeroQuery3PRecs);
    $71af45ffeeb47c72$var$useResetSessionAnalytics();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    $71af45ffeeb47c72$var$useAnalyticsEvents(fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes);
    const resultOnClick = (0, $6926da8980239f02$export$8a7aec9b1f72e063)();
    const resultOnContextMenu = (0, $6926da8980239f02$export$bc76edbc675e4404)();
    const resultOnHighlighted = (0, $6926da8980239f02$export$3f21dcaf9a5530d9)();
    const footerOnClick = (0, $6926da8980239f02$export$eb0ecd911360e8d4)();
    const queryFiltersBody = (0, $8215af3ea39f4647$export$385c746fbc3d50c5)({
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        inputRef: inputRef
    });
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const localDialogRef = (0, $42omo.useRef)(null);
    (0, $86ob4.useWidthObserverRegistration)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID), localDialogRef);
    // Fire exposure for qf_loom_recents experiment when the dialog mounts,
    // but only for users who have Loom access. Jira primary is excluded from
    // the experiment target audience in Statsig, so skip exposure there to
    // keep cohort assignments aligned with where the feature actually ships.
    const hasLoomAccess = availableProducts.includes((0, $1yEFx.ProductKeys).Loom);
    const isJiraPrimary = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira;
    (0, $42omo.useEffect)(()=>{
        if (hasLoomAccess && !isJiraPrimary) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $c6GJD.default).getExperimentValue('qf_loom_recents', 'cohort', 'not-enrolled', {
            fireExperimentExposure: true
        });
    }, [
        hasLoomAccess,
        isJiraPrimary
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isJiraPrimary) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $c6GJD.default).getExperimentValue('qf_jira_recents_exclude_confluence', 'cohort', 'control', {
            fireExperimentExposure: true
        });
    }, [
        isJiraPrimary
    ]);
    // Fire exposure for both GitHub-in-recents experiments when the dialog mounts,
    // but only for users who have the GitHub full-link connector connected (not needing OAuth)
    const hasGithubConnectorAccess = !!(thirdPartyConfigs?.[(0, $b4tvS.ProductKeys3P).Github] && !thirdPartyConfigs[(0, $b4tvS.ProductKeys3P).Github]?.userNeedsOAuth);
    (0, $42omo.useEffect)(()=>{
        if (hasGithubConnectorAccess) {
            (0, $2OtFZ.serveGithubRecentsExperiment)({
                fireExperimentExposure: true
            });
            (0, $2OtFZ.serveGithubWorkItemsRecentsExperiment)({
                fireExperimentExposure: true
            });
        }
    }, [
        hasGithubConnectorAccess
    ]);
    const isEligibleForGithubTipBanner = isJiraPrimary && !(0, $dh538.fg)('rovo_search_3p_banner_opt_out') && !!thirdPartyConfigs?.[(0, $b4tvS.ProductKeys3P).Github] && thirdPartyConfigs[(0, $b4tvS.ProductKeys3P).Github]?.userNeedsOAuth === true;
    (0, $42omo.useEffect)(()=>{
        if (isEligibleForGithubTipBanner) (0, $2OtFZ.serveQfGithubTipBannerExperiment)({
            fireExperimentExposure: true
        });
    }, [
        isEligibleForGithubTipBanner
    ]);
    const githubTipBannerCohort = isEligibleForGithubTipBanner ? (0, $2OtFZ.serveQfGithubTipBannerExperiment)() : 'control';
    const showGithubTipBanner = isEligibleForGithubTipBanner && githubTipBannerCohort !== 'control';
    const disableGninTriggerForGithubTipBanner = githubTipBannerCohort === 'test-keyword-only';
    // Only expose users who can actually be affected by the experiment, i.e.
    // those with at least one authorised smart-link connector. Mirrors the
    // allocation guard in `getFilteredEventTypes`.
    const hasSlConnectorAccess = (0, $def8z.hasAuthorisedSmartLinkConnector)(thirdPartyConfigs);
    (0, $42omo.useEffect)(()=>{
        if (hasSlConnectorAccess) (0, $2OtFZ.serveSlClickedOnlyInRecentsExperiment)({
            fireExperimentExposure: true
        });
    }, [
        hasSlConnectorAccess
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!hasFiredExperimentExposure.current && localQuery.length >= $71af45ffeeb47c72$var$MIN_QUERY_LENGTH && primaryProduct) {
            const exposureResult = (0, $26jni.serveJiraNINFpsNLQNavigation)({
                primaryProduct: primaryProduct,
                fireLayerExposure: true,
                locale: intl.locale
            });
            if (exposureResult?.cohort) fireAnalyticsEvent((0, $da0a8f0656f9d4ba$export$d20fe15ea6549dcc)({
                attributes: {
                    ...commonAttributes,
                    searchSessionId: commonAttributes.searchSessionId || '',
                    cohort: exposureResult.cohort,
                    modelId: exposureResult.modelId,
                    queryLength: localQuery.length,
                    wordCount: (0, $inrbX.getWordCount)(localQuery)
                }
            }));
            hasFiredExperimentExposure.current = true;
        }
    }, [
        primaryProduct,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        localQuery,
        intl.locale
    ]);
    const serveGithubLinksHydration = (0, $b46a7e00048d637e$export$777e9d6bae4c913e)();
    if (!content) return null;
    const swapQuickFindCTAs = (0, $3a090af578c3c72f$export$1a414fdf8e9c6492)() && primaryProduct && primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_search_fps_cta_swap');
    const { state: state } = content;
    const body = [];
    const intentRouterBody = [];
    let workItemKeyMatch;
    for (const content_0 of allItems){
        if ((0, $c778002e02670657$export$6500cdbd153f3497)(content_0)) body.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5e4b8c366d6ef407$export$42f84e610f279c31), {
            key: content_0.id,
            onRetry: retrySearch
        }));
        if ((0, $c778002e02670657$export$6dc914a1cb2e7113)(content_0)) body.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ebd3fccc7b29e09$export$144e5acf8752ad4a), {
            key: content_0.id
        }));
        if ((0, $c778002e02670657$export$993e95eb6704a94c)(content_0)) body.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5e5408b5df96d67$export$373c6a9b01d625eb), {
            key: content_0.id,
            onRetry: retrySearch
        }));
        if ((0, $c778002e02670657$export$9050e45a166250f)(content_0)) body.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5cfb43da7e344c6a$export$a8a3e93435678ff9), {
            key: content_0.id,
            id: content_0.id,
            includeInAnalytics: content_0.includeInAnalytics
        }, content_0.data));
        if ((0, $c778002e02670657$export$d680994c1f15882e)(content_0)) body.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $addf1cb001f831f5$export$dd3282b157ef6f7a), {
            key: content_0.id
        }));
        if ((0, $c778002e02670657$export$871ba967042323cb)(content_0)) (intentRouterEnabled ? intentRouterBody : body).push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8aeaf6643ef42bf9$export$de317f365b3e4c5c), {
            key: content_0.id,
            result: content_0.data,
            state: state
        }));
        if ((0, $c778002e02670657$export$57fb632bdb82e6e6)(content_0)) (intentRouterEnabled ? intentRouterBody : body).push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d88ba3c49726615e$export$f919aeefffeb339a), {
            key: content_0.id,
            result: content_0.data,
            state: state
        }));
        if ((0, $c778002e02670657$export$329ac1434313f6b2)(content_0)) {
            const activityProps = {
                key: content_0.id,
                result: content_0.data,
                state: state,
                onClick: resultOnClick,
                onContextMenu: resultOnContextMenu,
                onHighlighted: resultOnHighlighted,
                serveGithubLinksHydration: serveGithubLinksHydration
            };
            const activity = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfef7c7cb8b104c2$export$8d9137fcb112aeab), activityProps);
            if (intentRouterEnabled && showMatchingWorkItem && (0, $8de93e58797c140f$export$7daacdf8b47e48e1)(localQuery, content_0)) workItemKeyMatch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfef7c7cb8b104c2$export$8d9137fcb112aeab), {
                ...activityProps,
                key: "intent-router-matching-work-item",
                resultType: "intentRouterWorkItem"
            });
            body.push(activity);
        }
        if ((0, $c778002e02670657$export$579664463eebdcd8)(content_0)) body.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $07406509c730b963$export$1c25f2e531135fae), {
            key: content_0.id,
            result: content_0.data,
            state: state,
            onClick: resultOnClick,
            onContextMenu: resultOnContextMenu,
            onHighlighted: resultOnHighlighted
        }));
        if ((0, $c778002e02670657$export$99edcb23f38a2d86)(content_0) && serveZeroQuery) (intentRouterEnabled ? intentRouterBody : body).push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $50393a6d169f1c0b$export$598f770f0380f1f5), {
            key: content_0.id,
            result: content_0.data,
            product: content_0.product,
            avatarUrl: content_0.avatarUrl,
            state: state,
            zeroQueryType: content_0.zeroQueryType,
            zeroQueryPosition: allItems.indexOf(content_0)
        }));
        if ((0, $c778002e02670657$export$35bb43147cd35a68)(content_0)) body.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aac51a5e41e61c0e$export$1ba589c44bc43c28), {
            key: content_0.id,
            result: content_0.data,
            state: state
        }));
        if ((0, $c778002e02670657$export$746233dd1618793c)(content_0)) {
            const productEntityProps = {
                key: content_0.id,
                result: content_0.data,
                state: state,
                onClick: resultOnClick,
                onContextMenu: resultOnContextMenu,
                onHighlighted: resultOnHighlighted
            };
            const productEntity = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0e1f91acee299cdf$export$c9f98fed0b66ba21), productEntityProps);
            if (intentRouterEnabled && showMatchingWorkItem && (0, $8de93e58797c140f$export$6e5b6a45f7960503)(localQuery, content_0)) workItemKeyMatch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0e1f91acee299cdf$export$c9f98fed0b66ba21), {
                ...productEntityProps,
                resultType: "intentRouterWorkItem",
                key: "intent-router-matching-work-item"
            });
            body.push(productEntity);
        }
        if ((0, $c778002e02670657$export$bc8d42212d76a15c)(content_0)) body.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18e1948c3888bb1b$export$c84e51771b9ba67c), {
            key: content_0.id,
            result: content_0.data,
            state: state,
            onClick: resultOnClick,
            onContextMenu: resultOnContextMenu,
            onHighlighted: resultOnHighlighted
        }));
    }
    const footer = (()=>{
        // Post-query state with Confluence, Focus, or RovoExtension
        if ((primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence || primaryProduct === (0, $6Gsan.PrimaryProductKeys).Focus || primaryProduct === (0, $6Gsan.PrimaryProductKeys).RovoExtension && (0, $dh538.fg)('quickfind-rovo-extension')) && (0, $aE5mL.isPostQueryState)(state)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c33ab075ce0a02db$export$2e2bcd8739ae039), {
            requiredMode: (0, $9vOy1.ApplicationModes).Rovo
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $130bb7db5dbd93df$export$bf6cf7fe2100de5c), {
            state: state,
            onClick: footerOnClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67539e0ab092f04e$export$e7b87342306a8337), null));
        if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ad3c6b6b491bd60c$export$72bf2a5ecf09330e), {
            state: state,
            onClick: footerOnClick
        }), !intentRouterEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, swapQuickFindCTAs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $130bb7db5dbd93df$export$bf6cf7fe2100de5c), {
            state: state,
            onClick: footerOnClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e02869b185b9e3c4$export$104db48ac99dc257), {
            state: state,
            onClick: footerOnClick
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e02869b185b9e3c4$export$104db48ac99dc257), {
            state: state,
            onClick: footerOnClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $130bb7db5dbd93df$export$bf6cf7fe2100de5c), {
            state: state,
            onClick: footerOnClick
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67539e0ab092f04e$export$e7b87342306a8337), null));
        // Pre-query footer
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c33ab075ce0a02db$export$2e2bcd8739ae039), {
            requiredMode: (0, $9vOy1.ApplicationModes).Rovo
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $130bb7db5dbd93df$export$bf6cf7fe2100de5c), {
            state: state,
            onClick: footerOnClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67539e0ab092f04e$export$e7b87342306a8337), null));
    })();
    const isAIEnabled = isRovoLLMEnabled || isAdminHubAIEnabled;
    const displayFilters = (0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct);
    const nonResultsBody = (0, $aE5mL.isNotResultsState)(state);
    const localQueryEmpty = localQuery.trim().length === 0;
    const isLoading = (0, $aE5mL.isLoadingState)(state);
    // The banner's eligibility (`showGithubTipBanner`) is independent of the intent
    // router, so render it in both the intent-router and standard layouts. The
    // banner owns its own outer spacing and (optionally) its trailing divider, so
    // when it self-hides nothing is left behind.
    // `withTrailingDivider` is only used by the standard layout: the intent-router
    // layout renders its own always-present `Divider` after the banner.
    const renderGithubTipBanner = (withTrailingDivider, useNegativeMarginTop = false)=>showGithubTipBanner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c33ab075ce0a02db$export$2e2bcd8739ae039), {
            requiredMode: (0, $9vOy1.ApplicationModes).Rovo
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eb13c81035a309c0$export$a23697b7e0c0413b), {
            query: localQuery,
            disableGninTrigger: disableGninTriggerForGithubTipBanner,
            withTrailingDivider: withTrailingDivider,
            useNegativeMarginTop: useNegativeMarginTop
        })) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $71af45ffeeb47c72$var$searchDialogStyles,
            // remove searchDialogRefreshStyles and searchDialogDefaultStyles when cleaning up intentRouterEnabled as it overrides them
            searchRefreshStyling ? $71af45ffeeb47c72$var$searchDialogRefreshStyles : $71af45ffeeb47c72$var$searchDialogDefaultStyles,
            intentRouterEnabled && $71af45ffeeb47c72$var$searchDialogWithIntentRouter
        ],
        "aria-label": intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).searchDialogAriaLabel),
        testId: 'search-dialog',
        ref: (0, $kIdP4.mergeRefs)(dialogRef, localDialogRef),
        id: dialogId
    }, beforeContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39181c35e6b4cafd$export$5643dbed0288c870), {
        allItems: allItems
    }, intentRouterEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !localQueryEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $23cd74b8ba084de6$export$86cb87a743ba47f8), {
        isLoading: isLoading,
        showMatchingWorkItem: showMatchingWorkItem,
        matchingItem: workItemKeyMatch,
        minQueryLength: $71af45ffeeb47c72$var$MIN_QUERY_LENGTH,
        query: localQuery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $71af45ffeeb47c72$var$bodyWrapperStyles,
            $71af45ffeeb47c72$var$intentRouterBodyStyles
        ],
        ...!nonResultsBody && intentRouterBody.length > 0 && {
            role: 'listbox',
            'aria-label': intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).searchResultsHeading)
        }
    }, intentRouterBody), renderGithubTipBanner(false, true), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92cb390251785e80$export$2e0a83ec2e27ecbb), null)), !intentRouterEnabled && renderGithubTipBanner(true), intentDetectionControlAnalyticsEnabled && !localQueryEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ccfd5a35e0b69bb$export$cc3a06c46f6a3d2b), {
        query: localQuery,
        minQueryLength: $71af45ffeeb47c72$var$MIN_QUERY_LENGTH
    }), queryFiltersBody ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($71af45ffeeb47c72$var$SearchResultsSectionWrapper, {
        primaryProduct: primaryProduct
    }, queryFiltersBody) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($71af45ffeeb47c72$var$SearchResultsSectionWrapper, {
        primaryProduct: primaryProduct
    }, primaryProduct === (0, $6Gsan.PrimaryProductKeys).Assets && !(0, $dh538.fg)('assets_rovo_search_all') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0028c77a13fa2c26$export$d2e895abf2051d81), null), primaryProduct === (0, $6Gsan.PrimaryProductKeys).Assets && (0, $dh538.fg)('cdm_display_name_search') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd656b8a135ccf83$export$42247bfb32635492), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c33ab075ce0a02db$export$2e2bcd8739ae039), {
        requiredMode: (0, $9vOy1.ApplicationModes).Rovo
    }, (0, $aE5mL.isPreQueryState)(state) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1nJM3.ErrorBoundary), {
        section: "QuickFindSearchDialogOAuthContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a5OFf.OAuthContainer), {
        isOnSearchDialog: true,
        headlessVisiblePlacement: (0, $4fb011b1c09bb25d$export$10bc17e539691718),
        thirdPartyConfigs: thirdPartyConfigs,
        eligibleProducts: bannerEligibleProductsOrder,
        useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
        fireAnalyticsEvent: fireAnalyticsEvent
    })), $71af45ffeeb47c72$export$50d89b0bfbd161a1(state, isAIEnabled) && !serveZeroQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $238c7f3a77e6e665$export$4d99a070549a9300), null), PlacementPO && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PlacementPO, null), (displayFilters || (0, $aE5mL.isPostQueryState)(state)) && showFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b21d47feb05d9034$export$cc5615a202a2ea8c), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingInlineStart: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        id: "spotlight-multi-step-on-trigger-step-1"
    }))), (0, $aE5mL.isPreQueryState)(state) && preQueryContent && preQueryContent(state === (0, $aE5mL.State).PREQUERY_RESULTS)), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: (0, $3R0ts.QUICK_FIND_LOADING_HOLD)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $71af45ffeeb47c72$var$bodyWrapperStyles,
        ...!nonResultsBody && {
            role: 'listbox',
            'aria-label': intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).searchResultsHeading)
        }
    }, body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $71af45ffeeb47c72$var$footerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $71af45ffeeb47c72$var$footerStyles
    }, footer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $71af45ffeeb47c72$var$footerSpotlightTargetContainerStyles,
            !intentRouterEnabled && $71af45ffeeb47c72$var$footerSpotlightTargetContainerPaddingStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $71af45ffeeb47c72$var$footerSpotlightTargetStyles,
        id: "spotlight-multi-step-on-trigger-step-2"
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7186c8e2b9110674$export$41f905bcc65a859f), {
        isLoading: isLoading
    }));
};
const $71af45ffeeb47c72$export$2d03bbb77733f094 = (recentActivities, recommendations)=>{
    return recentActivities.filter((activity)=>activity?.data?.node?.object?.data !== null).filter((activity)=>{
        const thirdPartyAri = activity?.data?.node?.object?.id;
        return !recommendations.some((recommendation)=>recommendation.id === thirdPartyAri);
    });
};
const $71af45ffeeb47c72$var$setRecentActivityCount = (filteredActivities)=>{
    if ((0, $dh538.fg)('kd_recent_activity_intent')) (0, $6CITI.localStore).setString('recent-activity-count', filteredActivities.length.toString());
};
const $71af45ffeeb47c72$var$getJiraSuggestionsAndRecentQueries = ({ recentQueries: inputRecentQueries, zeroQueries: inputZeroQueries, maxRecentQueryCountWhenNoSuggestions: maxRecentQueryCountWhenNoSuggestions })=>{
    const suggestionsAndRecentQueries = [];
    const zeroQueries = inputZeroQueries.slice(0, 1);
    const dedupedRecentQueries = inputRecentQueries.filter((recentQuery)=>!zeroQueries.map((q)=>q.data).includes((0, $1SV4e.getRecentQueryObject)(recentQuery.data).query)).slice(0, 1);
    if (zeroQueries.length > 0 && dedupedRecentQueries.length > 0) {
        suggestionsAndRecentQueries.push(...zeroQueries);
        suggestionsAndRecentQueries.push(...dedupedRecentQueries);
    } else if (zeroQueries.length > 0) // show up to 2 zero queries if no deduped recent queries
    suggestionsAndRecentQueries.push(...inputZeroQueries.slice(0, 2));
    else if (dedupedRecentQueries.length > 0) {
        // When no zero queries, use maxRecentQueryCountWhenNoSuggestions if provided
        // Otherwise show up to 2 recent queries (default behavior)
        const recentQueryLimit = maxRecentQueryCountWhenNoSuggestions ?? 2;
        suggestionsAndRecentQueries.push(...inputRecentQueries.slice(0, recentQueryLimit));
    }
    return suggestionsAndRecentQueries;
};
const $71af45ffeeb47c72$export$2e2bbbf93cfc2287 = (serveUserDocument)=>{
    if (serveUserDocument) return {
        maxRecommendationsCount: 3,
        totalSlots: 8
    };
    return {
        maxRecommendationsCount: 0,
        totalSlots: 7
    };
};
const $71af45ffeeb47c72$export$d88c04dcf9cd911b = (0, $4pOgL.isReactCompilerActivePlatform)() ? (content, serveZeroQuery, maxRecentQueryCountWhenNoSuggestions, hideFilterSuggestions, primaryProduct, serveZeroQuery3PRecs)=>{
    const $ = (0, $frIzR.c)(23);
    const intl = (0, $aXWIB.useIntl)();
    const { onSearchResultsShown: onSearchResultsShown, handleRecentActivitiesCallback: handleRecentActivitiesCallback } = (0, $64cc6bbe82568b51$export$dfe8038ae9bc34d2)();
    let t0;
    if ($[0] !== primaryProduct) {
        t0 = (0, $2OtFZ.serveQFFilterSuggestionExperiment)(primaryProduct, {
            fireLayerExposure: false
        });
        $[0] = primaryProduct;
        $[1] = t0;
    } else t0 = $[1];
    const serveFilterSuggestion = t0;
    const userRelevantDocumentsEnabled = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence;
    let t1;
    if ($[2] !== userRelevantDocumentsEnabled) {
        t1 = userRelevantDocumentsEnabled && (0, $2OtFZ.serveQuickFind3PBoostingExperiment)({
            fireExperimentExposure: true
        });
        $[2] = userRelevantDocumentsEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const serve3PBoosting = t1;
    let t2;
    bb0: {
        if (!content) {
            let t3;
            if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = [];
                $[4] = t3;
            } else t3 = $[4];
            t2 = t3;
            break bb0;
        }
        const { state: state } = content;
        let items;
        if ($[5] !== content || $[6] !== handleRecentActivitiesCallback || $[7] !== hideFilterSuggestions || $[8] !== intl || $[9] !== maxRecentQueryCountWhenNoSuggestions || $[10] !== onSearchResultsShown || $[11] !== primaryProduct || $[12] !== serve3PBoosting || $[13] !== serveFilterSuggestion || $[14] !== serveZeroQuery || $[15] !== serveZeroQuery3PRecs || $[16] !== state || $[17] !== userRelevantDocumentsEnabled) {
            items = [];
            const recentsHeadingItem = {
                id: "recent-activities",
                type: "heading",
                data: intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).recentsHeading)
            };
            let t3;
            if ($[19] !== intl) {
                t3 = intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).recommendationsHeading);
                $[19] = intl;
                $[20] = t3;
            } else t3 = $[20];
            let t4;
            if ($[21] !== t3) {
                t4 = {
                    id: "recent-activities",
                    type: "heading",
                    data: t3
                };
                $[21] = t3;
                $[22] = t4;
            } else t4 = $[22];
            const recommendationsHeadingItem = t4;
            const recommendedHeadingItem = {
                id: "recommended",
                type: "heading",
                data: intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).recommendedHeading)
            };
            const headingItem = userRelevantDocumentsEnabled ? recommendationsHeadingItem : recentsHeadingItem;
            const searchResultsHeadingItem = {
                id: "search-results",
                type: "heading",
                data: intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).searchResultsHeading)
            };
            let filteredRecentActivities = [];
            if (state === (0, $aE5mL.State).PREQUERY_ERROR) items.push({
                id: "error",
                type: "error"
            });
            if (state === (0, $aE5mL.State).PREQUERY_LOADING) {
                items.push(...content.recentQueries.slice(0, 3));
                items.push(headingItem);
                for(let i = 0; i < 7; i++)items.push({
                    id: `skeleton-${i}`,
                    type: "skeleton"
                });
            }
            if (state === (0, $aE5mL.State).PREQUERY_NO_RESULTS) items.push({
                id: "landing",
                type: "landing"
            });
            if (state === (0, $aE5mL.State).PREQUERY_RESULTS) {
                let zeroQueriesCount = Number(maxRecentQueryCountWhenNoSuggestions);
                if (serveFilterSuggestion && !hideFilterSuggestions && content.filterSuggestions.length > 0) {
                    zeroQueriesCount = Math.max(0, maxRecentQueryCountWhenNoSuggestions - 1);
                    items.push(...content.filterSuggestions);
                }
                if (serveZeroQuery) {
                    const visibleZeroQueries = content.zeroQueries.slice(0, zeroQueriesCount);
                    let dedupedVisibleRecentQueries = [];
                    if (maxRecentQueryCountWhenNoSuggestions > 0) dedupedVisibleRecentQueries = content.recentQueries.filter((recentSearch)=>!visibleZeroQueries.some((zeroQuery)=>zeroQuery.data === recentSearch.data.query)).slice(0, 1);
                    items.push(...visibleZeroQueries);
                    items.push(...dedupedVisibleRecentQueries);
                } else {
                    const recentQueryLimit = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && maxRecentQueryCountWhenNoSuggestions !== (0, $3R0ts.DEFAULT_RECENT_AND_SUGGESTED_QUERY_LIMIT) ? maxRecentQueryCountWhenNoSuggestions : 3;
                    items.push(...content.recentQueries.slice(0, recentQueryLimit));
                }
                if (userRelevantDocumentsEnabled) {
                    const { maxRecommendationsCount: maxRecommendationsCount, totalSlots: totalSlots } = $71af45ffeeb47c72$export$2e2bbbf93cfc2287(userRelevantDocumentsEnabled);
                    const recommendations = serveZeroQuery3PRecs ? content.recommendedDocuments : content.userDocuments;
                    if (recommendations.length + content.recentActivities.length > 0) {
                        const enrichedRecommendations = (0, $d55e301b7ec82134$export$45fde34c61c061c6)(recommendations, content.recentActivities);
                        const filteredRecommendedDocuments = enrichedRecommendations.slice(0, maxRecommendationsCount);
                        const remainingSlots = totalSlots - filteredRecommendedDocuments.length;
                        const dedupedRecentActivities = $71af45ffeeb47c72$export$2d03bbb77733f094(content.recentActivities, filteredRecommendedDocuments);
                        if (serve3PBoosting) filteredRecentActivities = (0, $2d65b64d3d4cb16d$export$dca164322a50872a)(dedupedRecentActivities, remainingSlots);
                        else filteredRecentActivities = dedupedRecentActivities.slice(0, remainingSlots);
                        if (filteredRecommendedDocuments.length > 0) items.push(recommendedHeadingItem, ...filteredRecommendedDocuments);
                        if (filteredRecentActivities.length > 0) items.push(recentsHeadingItem, ...filteredRecentActivities);
                    }
                } else if (content.recentActivities.length > 0) {
                    items.push(recentsHeadingItem);
                    filteredRecentActivities = content.recentActivities.filter($71af45ffeeb47c72$var$_temp).slice(0, 7);
                    items.push(...filteredRecentActivities);
                }
                $71af45ffeeb47c72$var$setRecentActivityCount(filteredRecentActivities);
            }
            if (state === (0, $aE5mL.State).POSTQUERY_ERROR) items.push({
                id: "error",
                type: "error"
            });
            if (state === (0, $aE5mL.State).POSTQUERY_LOADING) {
                if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) items.push(...$71af45ffeeb47c72$var$getJiraSuggestionsAndRecentQueries({
                    recentQueries: content.recentQueries,
                    zeroQueries: content.zeroQueries,
                    maxRecentQueryCountWhenNoSuggestions: maxRecentQueryCountWhenNoSuggestions
                }));
                if (userRelevantDocumentsEnabled) {
                    const recommendations_0 = serveZeroQuery3PRecs ? content.recommendedDocuments : content.userDocuments;
                    if (recommendations_0.length + content.recentActivities.length > 0) {
                        items.push(recentsHeadingItem);
                        const enrichedRecommendedDocuments = (0, $d55e301b7ec82134$export$45fde34c61c061c6)(recommendations_0, content.recentActivities);
                        const filteredRecommendedDocuments_0 = enrichedRecommendedDocuments.slice(0, 5);
                        filteredRecentActivities = $71af45ffeeb47c72$export$2d03bbb77733f094(content.recentActivities, filteredRecommendedDocuments_0).slice(0, 5 - filteredRecommendedDocuments_0.length);
                        items.push(...filteredRecommendedDocuments_0);
                        items.push(...filteredRecentActivities);
                    }
                } else if (content.recentActivities.length > 0) {
                    items.push(recentsHeadingItem);
                    filteredRecentActivities = content.recentActivities.filter($71af45ffeeb47c72$var$_temp2).slice(0, 5);
                    items.push(...filteredRecentActivities);
                }
                $71af45ffeeb47c72$var$setRecentActivityCount(filteredRecentActivities);
                items.push({
                    ...searchResultsHeadingItem,
                    includeInAnalytics: false
                });
                const numberOfSkeletons = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira ? 10 : 5;
                for(let i_0 = 0; i_0 < numberOfSkeletons; i_0++)items.push({
                    id: `skeleton-${i_0}`,
                    type: "skeleton"
                });
            }
            if (state === (0, $aE5mL.State).POSTQUERY_NO_RESULTS) items.push({
                id: "no-results",
                type: "no-results"
            });
            if (state === (0, $aE5mL.State).POSTQUERY_RESULTS) {
                if ("autocompleteSuggestions" in content && Array.isArray(content.autocompleteSuggestions) && (0, $dh538.fg)("fe_quickfind_autocomplete_suggestions")) {
                    const autocompleteSuggestions = content.autocompleteSuggestions;
                    if (autocompleteSuggestions.length > 0) {
                        const autocompleteSuggestionsHeadingItem = {
                            id: "autocomplete-suggestions",
                            type: "heading",
                            data: "Autocomplete suggestions",
                            includeInAnalytics: false
                        };
                        items.push(autocompleteSuggestionsHeadingItem);
                        autocompleteSuggestions.slice(0, 3).forEach((suggestion, index)=>{
                            items.push({
                                id: `autocomplete-suggestion-${index}`,
                                type: "autocomplete-suggestion",
                                data: suggestion.data
                            });
                        });
                    }
                }
                if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) items.push(...$71af45ffeeb47c72$var$getJiraSuggestionsAndRecentQueries({
                    recentQueries: content.recentQueries,
                    zeroQueries: content.zeroQueries,
                    maxRecentQueryCountWhenNoSuggestions: maxRecentQueryCountWhenNoSuggestions
                }));
                filteredRecentActivities = content.recentActivities.filter($71af45ffeeb47c72$var$_temp3).slice(0, 5);
                const enrichedRecommendedDocuments_0 = (0, $d55e301b7ec82134$export$45fde34c61c061c6)(serveZeroQuery3PRecs ? content.recommendedDocuments : content.userDocuments, content.recentActivities);
                const filteredRecommendedDocuments_1 = enrichedRecommendedDocuments_0.slice(0, 5);
                if (userRelevantDocumentsEnabled) {
                    if (filteredRecommendedDocuments_1.length + content.recentActivities.length > 0) {
                        items.push(recentsHeadingItem);
                        filteredRecentActivities = $71af45ffeeb47c72$export$2d03bbb77733f094(content.recentActivities, filteredRecommendedDocuments_1).slice(0, 5 - filteredRecommendedDocuments_1.length);
                        items.push(...filteredRecommendedDocuments_1);
                        items.push(...filteredRecentActivities);
                    }
                } else if (filteredRecentActivities.length > 0) {
                    items.push(recentsHeadingItem);
                    items.push(...filteredRecentActivities);
                }
                $71af45ffeeb47c72$var$setRecentActivityCount(filteredRecentActivities);
                const seenIds = new Set();
                const dedupedSearchResults = content.searchResults.filter((searchResult)=>{
                    const isInRecentActivities = filteredRecentActivities.some((recentlyViewedResult)=>{
                        const activityObject = recentlyViewedResult.data.node.object;
                        const id = (0, $hWR4v.isGraphActivity)(activityObject) ? activityObject.data?.id : recentlyViewedResult.id;
                        return id === searchResult.id;
                    });
                    const isInRecommendedDocuments = filteredRecommendedDocuments_1.some((recommendation)=>recommendation.id === searchResult.id);
                    const isDuplicateResult = seenIds.has(searchResult.id);
                    if (!isDuplicateResult) seenIds.add(searchResult.id);
                    return searchResult.id && !isInRecentActivities && !isDuplicateResult && !isInRecommendedDocuments;
                });
                onSearchResultsShown(dedupedSearchResults);
                if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence) {
                    const confluenceSpaceResult = dedupedSearchResults.find($71af45ffeeb47c72$var$_temp4);
                    const showSearchResultsSection = Boolean(dedupedSearchResults.length + content.peopleAndTeams.length);
                    if (showSearchResultsSection) {
                        items.push(searchResultsHeadingItem);
                        const filteredSearchResults = dedupedSearchResults.filter($71af45ffeeb47c72$var$_temp5);
                        items.push(...filteredSearchResults.slice(0, confluenceSpaceResult ? 5 : 6));
                        confluenceSpaceResult && items.push(confluenceSpaceResult);
                        items.push(...content.peopleAndTeams.slice(0, 2));
                        items.push(...content.recentQueries.slice(0, 1));
                    }
                } else if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) {
                    const showSearchResultsSection_0 = Boolean(dedupedSearchResults.length);
                    if (showSearchResultsSection_0) {
                        const issueResults = dedupedSearchResults.filter($71af45ffeeb47c72$var$_temp6);
                        const nonIssueResults = dedupedSearchResults.filter($71af45ffeeb47c72$var$_temp7);
                        items.push(searchResultsHeadingItem);
                        items.push(...issueResults.slice(0, 10));
                        items.push(...nonIssueResults.slice(0, 3));
                    }
                } else {
                    const showSearchResultsSection_1 = Boolean(dedupedSearchResults.length + content.peopleAndTeams.length);
                    if (showSearchResultsSection_1) {
                        items.push(searchResultsHeadingItem);
                        items.push(...dedupedSearchResults.slice(0, 6));
                        items.push(...content.peopleAndTeams.slice(0, 2));
                        items.push(...content.recentQueries.slice(0, 1));
                    }
                }
            }
            if (state !== (0, $aE5mL.State).POSTQUERY_RESULTS) handleRecentActivitiesCallback(state, filteredRecentActivities);
            $[5] = content;
            $[6] = handleRecentActivitiesCallback;
            $[7] = hideFilterSuggestions;
            $[8] = intl;
            $[9] = maxRecentQueryCountWhenNoSuggestions;
            $[10] = onSearchResultsShown;
            $[11] = primaryProduct;
            $[12] = serve3PBoosting;
            $[13] = serveFilterSuggestion;
            $[14] = serveZeroQuery;
            $[15] = serveZeroQuery3PRecs;
            $[16] = state;
            $[17] = userRelevantDocumentsEnabled;
            $[18] = items;
        } else items = $[18];
        t2 = items;
    }
    return t2;
} : (content, serveZeroQuery, maxRecentQueryCountWhenNoSuggestions, hideFilterSuggestions, primaryProduct, serveZeroQuery3PRecs)=>{
    const intl = (0, $aXWIB.useIntl)();
    const { onSearchResultsShown: onSearchResultsShown, handleRecentActivitiesCallback: handleRecentActivitiesCallback } = (0, $64cc6bbe82568b51$export$dfe8038ae9bc34d2)();
    const serveFilterSuggestion = (0, $2OtFZ.serveQFFilterSuggestionExperiment)(primaryProduct, {
        fireLayerExposure: false
    });
    const userRelevantDocumentsEnabled = (0, $42omo.useMemo)(()=>{
        return primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence;
    }, [
        primaryProduct
    ]);
    const serve3PBoosting = (0, $42omo.useMemo)(()=>{
        return userRelevantDocumentsEnabled && (0, $2OtFZ.serveQuickFind3PBoostingExperiment)({
            fireExperimentExposure: true
        });
    }, [
        userRelevantDocumentsEnabled
    ]);
    return (0, $42omo.useMemo)(()=>{
        if (!content) return [];
        const { state: state } = content;
        const items = [];
        const recentsHeadingItem = {
            id: 'recent-activities',
            type: 'heading',
            data: intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).recentsHeading)
        };
        const recommendationsHeadingItem = {
            id: 'recent-activities',
            type: 'heading',
            data: intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).recommendationsHeading)
        };
        const recommendedHeadingItem = {
            id: 'recommended',
            type: 'heading',
            data: intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).recommendedHeading)
        };
        const headingItem = userRelevantDocumentsEnabled ? recommendationsHeadingItem : recentsHeadingItem;
        const searchResultsHeadingItem = {
            id: 'search-results',
            type: 'heading',
            data: intl.formatMessage((0, $3f03f084e86b29e6$export$defe85febe8b728c).searchResultsHeading)
        };
        let filteredRecentActivities = [];
        if (state === (0, $aE5mL.State).PREQUERY_ERROR) items.push({
            id: 'error',
            type: 'error'
        });
        if (state === (0, $aE5mL.State).PREQUERY_LOADING) {
            items.push(...content.recentQueries.slice(0, 3));
            items.push(headingItem);
            for(let i = 0; i < 7; i++)items.push({
                id: `skeleton-${i}`,
                type: 'skeleton'
            });
        }
        if (state === (0, $aE5mL.State).PREQUERY_NO_RESULTS) items.push({
            id: 'landing',
            type: 'landing'
        });
        if (state === (0, $aE5mL.State).PREQUERY_RESULTS) {
            let zeroQueriesCount = Number(maxRecentQueryCountWhenNoSuggestions);
            if (serveFilterSuggestion && !hideFilterSuggestions && content.filterSuggestions.length > 0) {
                // filter suggestion replaces one of the zero queries
                zeroQueriesCount = Math.max(0, maxRecentQueryCountWhenNoSuggestions - 1);
                items.push(...content.filterSuggestions);
            }
            if (serveZeroQuery) {
                const visibleZeroQueries = content.zeroQueries.slice(0, zeroQueriesCount);
                // Only show recent queries if maxRecentQueryCountWhenNoSuggestions > 0
                let dedupedVisibleRecentQueries = [];
                if (maxRecentQueryCountWhenNoSuggestions > 0) dedupedVisibleRecentQueries = content.recentQueries.filter((recentSearch)=>!visibleZeroQueries.some((zeroQuery)=>zeroQuery.data === recentSearch.data.query)).slice(0, 1); // Always show up to 1 recent query when zero queries are shown
                items.push(...visibleZeroQueries);
                items.push(...dedupedVisibleRecentQueries);
            } else {
                // When zero queries are not served, use maxRecentQueryCountWhenNoSuggestions; otherwise show 3
                // NOTE: This only applies to Jira within the serveJiraNINFpsNLQNavigation intent detection experiment
                const recentQueryLimit = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && maxRecentQueryCountWhenNoSuggestions !== (0, $3R0ts.DEFAULT_RECENT_AND_SUGGESTED_QUERY_LIMIT) ? maxRecentQueryCountWhenNoSuggestions : 3;
                items.push(...content.recentQueries.slice(0, recentQueryLimit));
            }
            if (userRelevantDocumentsEnabled) {
                const { maxRecommendationsCount: maxRecommendationsCount, totalSlots: totalSlots } = $71af45ffeeb47c72$export$2e2bbbf93cfc2287(userRelevantDocumentsEnabled);
                const recommendations = serveZeroQuery3PRecs ? content.recommendedDocuments : content.userDocuments;
                if (recommendations.length + content.recentActivities.length > 0) {
                    const enrichedRecommendations = (0, $d55e301b7ec82134$export$45fde34c61c061c6)(recommendations, content.recentActivities);
                    const filteredRecommendedDocuments = enrichedRecommendations.slice(0, maxRecommendationsCount);
                    const remainingSlots = totalSlots - filteredRecommendedDocuments.length;
                    const dedupedRecentActivities = $71af45ffeeb47c72$export$2d03bbb77733f094(content.recentActivities, filteredRecommendedDocuments);
                    if (serve3PBoosting) filteredRecentActivities = (0, $2d65b64d3d4cb16d$export$dca164322a50872a)(dedupedRecentActivities, remainingSlots);
                    else filteredRecentActivities = dedupedRecentActivities.slice(0, remainingSlots);
                    // Separate heading between recommendations and recent
                    if (filteredRecommendedDocuments.length > 0) items.push(recommendedHeadingItem, ...filteredRecommendedDocuments);
                    if (filteredRecentActivities.length > 0) items.push(recentsHeadingItem, ...filteredRecentActivities);
                }
            } else if (content.recentActivities.length > 0) {
                items.push(recentsHeadingItem);
                filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 7);
                items.push(...filteredRecentActivities);
            }
            $71af45ffeeb47c72$var$setRecentActivityCount(filteredRecentActivities);
        }
        if (state === (0, $aE5mL.State).POSTQUERY_ERROR) items.push({
            id: 'error',
            type: 'error'
        });
        if (state === (0, $aE5mL.State).POSTQUERY_LOADING) {
            if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) items.push(...$71af45ffeeb47c72$var$getJiraSuggestionsAndRecentQueries({
                recentQueries: content.recentQueries,
                zeroQueries: content.zeroQueries,
                maxRecentQueryCountWhenNoSuggestions: maxRecentQueryCountWhenNoSuggestions
            }));
            if (userRelevantDocumentsEnabled) {
                const recommendations_0 = serveZeroQuery3PRecs ? content.recommendedDocuments : content.userDocuments;
                if (recommendations_0.length + content.recentActivities.length > 0) {
                    items.push(recentsHeadingItem);
                    const enrichedRecommendedDocuments = (0, $d55e301b7ec82134$export$45fde34c61c061c6)(recommendations_0, content.recentActivities);
                    const filteredRecommendedDocuments_0 = enrichedRecommendedDocuments.slice(0, 5);
                    filteredRecentActivities = $71af45ffeeb47c72$export$2d03bbb77733f094(content.recentActivities, filteredRecommendedDocuments_0).slice(0, 5 - filteredRecommendedDocuments_0.length);
                    items.push(...filteredRecommendedDocuments_0);
                    items.push(...filteredRecentActivities);
                }
            } else if (content.recentActivities.length > 0) {
                items.push(recentsHeadingItem);
                filteredRecentActivities = content.recentActivities.filter((activity_0)=>activity_0.data.node.object.data !== null).slice(0, 5);
                items.push(...filteredRecentActivities);
            }
            $71af45ffeeb47c72$var$setRecentActivityCount(filteredRecentActivities);
            items.push({
                ...searchResultsHeadingItem,
                includeInAnalytics: false
            });
            const numberOfSkeletons = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira ? 10 : 5;
            for(let i_0 = 0; i_0 < numberOfSkeletons; i_0++)items.push({
                id: `skeleton-${i_0}`,
                type: 'skeleton'
            });
        }
        if (state === (0, $aE5mL.State).POSTQUERY_NO_RESULTS) items.push({
            id: 'no-results',
            type: 'no-results'
        });
        if (state === (0, $aE5mL.State).POSTQUERY_RESULTS) {
            if ('autocompleteSuggestions' in content && Array.isArray(content.autocompleteSuggestions) && (0, $dh538.fg)('fe_quickfind_autocomplete_suggestions')) {
                const autocompleteSuggestions = content.autocompleteSuggestions;
                if (autocompleteSuggestions.length > 0) {
                    const autocompleteSuggestionsHeadingItem = {
                        id: 'autocomplete-suggestions',
                        type: 'heading',
                        data: 'Autocomplete suggestions',
                        includeInAnalytics: false
                    };
                    items.push(autocompleteSuggestionsHeadingItem);
                    autocompleteSuggestions.slice(0, 3).forEach((suggestion, index)=>{
                        items.push({
                            id: `autocomplete-suggestion-${index}`,
                            type: 'autocomplete-suggestion',
                            data: suggestion.data
                        });
                    });
                }
            }
            if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) items.push(...$71af45ffeeb47c72$var$getJiraSuggestionsAndRecentQueries({
                recentQueries: content.recentQueries,
                zeroQueries: content.zeroQueries,
                maxRecentQueryCountWhenNoSuggestions: maxRecentQueryCountWhenNoSuggestions
            }));
            filteredRecentActivities = content.recentActivities.filter((activity_1)=>activity_1.data.node.object.data !== null).slice(0, 5);
            const enrichedRecommendedDocuments_0 = (0, $d55e301b7ec82134$export$45fde34c61c061c6)(serveZeroQuery3PRecs ? content.recommendedDocuments : content.userDocuments, content.recentActivities);
            const filteredRecommendedDocuments_1 = enrichedRecommendedDocuments_0.slice(0, 5);
            if (userRelevantDocumentsEnabled) {
                if (filteredRecommendedDocuments_1.length + content.recentActivities.length > 0) {
                    items.push(recentsHeadingItem);
                    filteredRecentActivities = $71af45ffeeb47c72$export$2d03bbb77733f094(content.recentActivities, filteredRecommendedDocuments_1).slice(0, 5 - filteredRecommendedDocuments_1.length);
                    items.push(...filteredRecommendedDocuments_1);
                    items.push(...filteredRecentActivities);
                }
            } else if (filteredRecentActivities.length > 0) {
                items.push(recentsHeadingItem);
                items.push(...filteredRecentActivities);
            }
            $71af45ffeeb47c72$var$setRecentActivityCount(filteredRecentActivities);
            const seenIds = new Set();
            const dedupedSearchResults = content.searchResults.filter((searchResult)=>{
                const isInRecentActivities = filteredRecentActivities.some((recentlyViewedResult)=>{
                    const activityObject = recentlyViewedResult.data.node.object;
                    const id = (0, $hWR4v.isGraphActivity)(activityObject) ? activityObject.data?.id : recentlyViewedResult.id;
                    return id === searchResult.id;
                });
                const isInRecommendedDocuments = filteredRecommendedDocuments_1.some((recommendation)=>recommendation.id === searchResult.id);
                const isDuplicateResult = seenIds.has(searchResult.id);
                if (!isDuplicateResult) seenIds.add(searchResult.id);
                return searchResult.id && !isInRecentActivities && !isDuplicateResult && !isInRecommendedDocuments;
            });
            onSearchResultsShown(dedupedSearchResults);
            // The way product entities are shown depend on the primary product
            if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence) {
                const confluenceSpaceResult = dedupedSearchResults.find((result)=>(0, $4TTdD.isSearchConfluenceSpace)(result.data));
                const showSearchResultsSection = Boolean(dedupedSearchResults.length + content.peopleAndTeams.length);
                if (showSearchResultsSection) {
                    items.push(searchResultsHeadingItem);
                    const filteredSearchResults = dedupedSearchResults.filter((result_0)=>!(0, $4TTdD.isSearchConfluenceSpace)(result_0.data));
                    items.push(...filteredSearchResults.slice(0, confluenceSpaceResult ? 5 : 6));
                    confluenceSpaceResult && items.push(confluenceSpaceResult);
                    items.push(...content.peopleAndTeams.slice(0, 2));
                    items.push(...content.recentQueries.slice(0, 1));
                }
            } else if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) {
                const showSearchResultsSection_0 = Boolean(dedupedSearchResults.length);
                if (showSearchResultsSection_0) {
                    const issueResults = dedupedSearchResults.filter((result_1)=>(0, $8LSUr.isSearchResultJiraIssue)(result_1.data));
                    const nonIssueResults = dedupedSearchResults.filter((result_2)=>!(0, $8LSUr.isSearchResultJiraIssue)(result_2.data));
                    const numberOfJiraIssues = 10;
                    items.push(searchResultsHeadingItem);
                    items.push(...issueResults.slice(0, numberOfJiraIssues));
                    items.push(...nonIssueResults.slice(0, 3));
                }
            } else {
                const showSearchResultsSection_1 = Boolean(dedupedSearchResults.length + content.peopleAndTeams.length);
                if (showSearchResultsSection_1) {
                    items.push(searchResultsHeadingItem);
                    items.push(...dedupedSearchResults.slice(0, 6));
                    items.push(...content.peopleAndTeams.slice(0, 2));
                    items.push(...content.recentQueries.slice(0, 1));
                }
            }
        }
        /* We don't want to interrupt the handleRecentActivitiesCallback with POSTQUERY_RESULTS
     * as it's already handled in POSTQUERY_LOADING'
     */ if (state !== (0, $aE5mL.State).POSTQUERY_RESULTS) handleRecentActivitiesCallback(state, filteredRecentActivities);
        return items;
    }, [
        content,
        intl,
        userRelevantDocumentsEnabled,
        maxRecentQueryCountWhenNoSuggestions,
        hideFilterSuggestions,
        serveFilterSuggestion,
        serveZeroQuery,
        serve3PBoosting,
        primaryProduct,
        onSearchResultsShown,
        handleRecentActivitiesCallback,
        serveZeroQuery3PRecs
    ]);
};
const $71af45ffeeb47c72$var$useAnalyticsEvents = (fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes)=>{
    const { abortTask: abortTask, isTaskActive: isTaskActive } = (0, $269ee6c4b9937e56$export$5b6291bff520e069)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $de62c0fb6467b42a$export$39e1d377a6a3de5d)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        return ()=>{
            fireAnalyticsEvent((0, $57230a101297e6c3$export$bcff6baaecbbc96)({
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            // Fire VitalStats taskAbort if a task is active when dialog is dismissed
            // Note: abortTask handles deferring the analytics event internally
            if (isTaskActive()) abortTask('dialog_closed_during_network');
        };
    // Only want these events to fire when the dialog opens and closes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const $71af45ffeeb47c72$var$useResetSessionAnalytics = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    const refreshSearchSessionId = (0, $j4ply.useRefreshSearchSessionId)();
    const { resetQueryVersion: resetQueryVersion } = (0, $djVCD.useSearchActions)();
    let t0;
    let t1;
    if ($[0] !== refreshSearchSessionId || $[1] !== resetQueryVersion) {
        t0 = ()=>{
            refreshSearchSessionId();
            resetQueryVersion();
        };
        t1 = [
            refreshSearchSessionId,
            resetQueryVersion
        ];
        $[0] = refreshSearchSessionId;
        $[1] = resetQueryVersion;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
} : ()=>{
    const refreshSearchSessionId = (0, $j4ply.useRefreshSearchSessionId)();
    const { resetQueryVersion: resetQueryVersion } = (0, $djVCD.useSearchActions)();
    (0, $42omo.useEffect)(()=>{
        refreshSearchSessionId();
        resetQueryVersion();
    }, [
        refreshSearchSessionId,
        resetQueryVersion
    ]);
};
const $71af45ffeeb47c72$export$50d89b0bfbd161a1 = (state, isAIEnabled = false)=>{
    const isCorrectState = (0, $aE5mL.isPreQueryState)(state) || (0, $aE5mL.isPostQueryLoadingOrResults)(state);
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return isCorrectState && isAIEnabled;
    return isCorrectState;
};
function $71af45ffeeb47c72$var$_temp(activity) {
    return activity.data.node.object.data !== null;
}
function $71af45ffeeb47c72$var$_temp2(activity_0) {
    return activity_0.data.node.object.data !== null;
}
function $71af45ffeeb47c72$var$_temp3(activity_1) {
    return activity_1.data.node.object.data !== null;
}
function $71af45ffeeb47c72$var$_temp4(result) {
    return (0, $4TTdD.isSearchConfluenceSpace)(result.data);
}
function $71af45ffeeb47c72$var$_temp5(result_0) {
    return !(0, $4TTdD.isSearchConfluenceSpace)(result_0.data);
}
function $71af45ffeeb47c72$var$_temp6(result_1) {
    return (0, $8LSUr.isSearchResultJiraIssue)(result_1.data);
}
function $71af45ffeeb47c72$var$_temp7(result_2) {
    return !(0, $8LSUr.isSearchResultJiraIssue)(result_2.data);
}














const $ea5066efa7331a88$export$9310e79b116dbbca = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $42omo.useEffect)($ea5066efa7331a88$var$_temp2, t0);
} : ()=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            (0, $4tgkZ.INTENT_DETECTION).dispose();
        };
    }, []);
};
function $ea5066efa7331a88$var$_temp() {
    (0, $4tgkZ.INTENT_DETECTION).dispose();
}
function $ea5066efa7331a88$var$_temp2() {
    return $ea5066efa7331a88$var$_temp;
}















var $chO1Z = parcelRequire("chO1Z");





var $6767u = parcelRequire("6767u");






var $fVUfS = parcelRequire("fVUfS");



















































var $jQ2up = parcelRequire("jQ2up");











var $aGXLL = parcelRequire("aGXLL");




const $42590f29eedf8f8c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    contributor: {
        id: "quick-find.filters.names.contributor",
        defaultMessage: "Contributor"
    },
    confluenceFilterContributorPlaceholder: {
        id: "quick-find.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterLabelSelected: {
        id: "quick-find.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "quick-find.confluence.filter.label.unselected",
        defaultMessage: "Suggested"
    }
});


const $23012254e2ce6f81$export$fcbf8a9904746204 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(54);
    const { iconBefore: iconBefore, iconAfter: iconAfter, onFilterClose: onFilterClose } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            filterId: (0, $aGXLL.filter).id
        };
        $[0] = t1;
    } else t1 = $[0];
    const [filterData, t2] = (0, $5cssW.useSelectFilter)(t1);
    const { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOptionForContributorFilter, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t2;
    const confluenceProductConfig = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Confluence);
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, badgeLabel: badgeLabel, firstSelectedOptionLabel: firstSelectedOptionLabel } = filterData;
    let t3;
    if ($[1] !== formatMessage) {
        t3 = formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).confluenceFilterLabelSelected);
        $[1] = formatMessage;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== selectedOptions || $[4] !== t3) {
        t4 = {
            label: t3,
            options: selectedOptions
        };
        $[3] = selectedOptions;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== formatMessage) {
        t5 = formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected);
        $[6] = formatMessage;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== suggestedOptions || $[9] !== t5) {
        t6 = {
            label: t5,
            options: suggestedOptions
        };
        $[8] = suggestedOptions;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t4 || $[12] !== t6) {
        t7 = [
            t4,
            t6
        ];
        $[11] = t4;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    const groupedOptions = t7;
    const ConfluenceIcon = confluenceProductConfig.Icon;
    let t8;
    if ($[14] !== ConfluenceIcon || $[15] !== formatMessage || $[16] !== iconBefore) {
        t8 = ()=>{
            if (iconBefore) return iconBefore;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConfluenceIcon, {
                size: "xxsmall"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                label: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).contributor)
            }));
        };
        $[14] = ConfluenceIcon;
        $[15] = formatMessage;
        $[16] = iconBefore;
        $[17] = t8;
    } else t8 = $[17];
    const getIconBefore = t8;
    let t9;
    if ($[18] !== badgeLabel || $[19] !== iconAfter || $[20] !== selectedOptions.length) {
        t9 = ()=>selectedOptions.length === 0 ? iconAfter ? iconAfter : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                size: "small"
            }) : badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                appearance: "information"
            }, badgeLabel);
        $[18] = badgeLabel;
        $[19] = iconAfter;
        $[20] = selectedOptions.length;
        $[21] = t9;
    } else t9 = $[21];
    const getIconAfter = t9;
    let t10;
    if ($[22] !== setOptionForContributorFilter) {
        t10 = (option)=>{
            setOptionForContributorFilter(option, undefined, (0, $1yEFx.ProductKeys).Confluence);
        };
        $[22] = setOptionForContributorFilter;
        $[23] = t10;
    } else t10 = $[23];
    const setOption = t10;
    let t11;
    if ($[24] !== clearLookupInput || $[25] !== onFilterClose || $[26] !== options || $[27] !== selectedOptions) {
        t11 = ()=>{
            clearLookupInput();
            if (onFilterClose) onFilterClose(options, selectedOptions);
        };
        $[24] = clearLookupInput;
        $[25] = onFilterClose;
        $[26] = options;
        $[27] = selectedOptions;
        $[28] = t11;
    } else t11 = $[28];
    const onDropdownClose = t11;
    const t12 = isLookupActive ? options : groupedOptions;
    let t13;
    if ($[29] !== formatMessage) {
        t13 = formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).contributor);
        $[29] = formatMessage;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== formatMessage) {
        t14 = formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).confluenceFilterContributorPlaceholder);
        $[31] = formatMessage;
        $[32] = t14;
    } else t14 = $[32];
    let t15;
    if ($[33] !== firstSelectedOptionLabel || $[34] !== formatMessage || $[35] !== getIconAfter || $[36] !== getIconBefore || $[37] !== selectedOptions.length) {
        t15 = (t16)=>{
            const { isOpen: isOpen, ...targetProps } = t16;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                testId: "search-dialog-contributor-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                minWidthZero: true
            }, firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).contributor));
        };
        $[33] = firstSelectedOptionLabel;
        $[34] = formatMessage;
        $[35] = getIconAfter;
        $[36] = getIconBefore;
        $[37] = selectedOptions.length;
        $[38] = t15;
    } else t15 = $[38];
    let t16;
    if ($[39] !== clearOptions || $[40] !== isFiltersDiscoverability2Enabled || $[41] !== isLoading || $[42] !== isLookupDefined || $[43] !== loadInitialOptions || $[44] !== lookupInput || $[45] !== onDropdownClose || $[46] !== selectedOptions || $[47] !== setLookupInput || $[48] !== setOption || $[49] !== t12 || $[50] !== t13 || $[51] !== t14 || $[52] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
            filterId: (0, $aGXLL.filter).id,
            canClearFilter: true,
            checkboxIndicators: true,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: onDropdownClose,
            onSearchInputChange: setLookupInput,
            onSelectChange: setOption,
            options: t12,
            selectedOptions: selectedOptions,
            label: t13,
            placeholder: t14,
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
            onClearOptions: clearOptions,
            target: t15,
            isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
        });
        $[39] = clearOptions;
        $[40] = isFiltersDiscoverability2Enabled;
        $[41] = isLoading;
        $[42] = isLookupDefined;
        $[43] = loadInitialOptions;
        $[44] = lookupInput;
        $[45] = onDropdownClose;
        $[46] = selectedOptions;
        $[47] = setLookupInput;
        $[48] = setOption;
        $[49] = t12;
        $[50] = t13;
        $[51] = t14;
        $[52] = t15;
        $[53] = t16;
    } else t16 = $[53];
    return t16;
} : ({ iconBefore: iconBefore, iconAfter: iconAfter, onFilterClose: onFilterClose })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOptionForContributorFilter, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $aGXLL.filter).id
    });
    const confluenceProductConfig = (0, $1yEFx.useProductConfig)((0, $1yEFx.ProductKeys).Confluence);
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, badgeLabel: badgeLabel, firstSelectedOptionLabel: firstSelectedOptionLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const ConfluenceIcon = confluenceProductConfig.Icon;
    const getIconBefore = ()=>{
        if (iconBefore) return iconBefore;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConfluenceIcon, {
            size: "xxsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).contributor)
        }));
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? iconAfter ? iconAfter : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
            appearance: "information"
        }, badgeLabel);
    };
    const setOption = (option)=>{
        setOptionForContributorFilter(option, undefined, (0, $1yEFx.ProductKeys).Confluence);
    };
    const onDropdownClose = ()=>{
        clearLookupInput();
        if (onFilterClose) onFilterClose(options, selectedOptions);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        filterId: (0, $aGXLL.filter).id,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: onDropdownClose,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).contributor),
        placeholder: formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).confluenceFilterContributorPlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: clearOptions,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                testId: "search-dialog-contributor-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                minWidthZero: true
            }, firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $42590f29eedf8f8c$export$a7357cdd1f0b0168).contributor)),
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};





















var $gXn1S = parcelRequire("gXn1S");


var $5iakG = parcelRequire("5iakG");





var $3dgQu = parcelRequire("3dgQu");





var $1xk5k = parcelRequire("1xk5k");











var $3JX0d = parcelRequire("3JX0d");




const $b6d7a903a92ed23b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    type: {
        id: "quick-find.filters.names.type",
        defaultMessage: "Type"
    },
    filterTypePlaceholder: {
        id: "quick-find.filter.type.placeholder",
        defaultMessage: "Find type"
    },
    filterLabelSelected: {
        id: "quick-find.filter.type.label.selected",
        defaultMessage: "Selected"
    },
    filterLabelUnselected: {
        id: "quick-find.filter.type.label.unselected",
        defaultMessage: "Available"
    }
});


const $a2107b05e31d2daf$var$getOptionsToProducts = (typeMapping)=>{
    const optionsToProducts = {};
    (0, $3JX0d.getAllTypeFilterKeysForSearch)().forEach((type)=>{
        optionsToProducts[type] = typeMapping[type].products || [];
    });
    return optionsToProducts;
};
const $a2107b05e31d2daf$export$409b84e60ce4841e = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(38);
    const { iconBefore: iconBefore, iconAfter: iconAfter, showPrimaryProductIcon: showPrimaryProductIcon } = t0;
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        const typeMapping = (0, $1xk5k.getTypeMapping)();
        t1 = $a2107b05e31d2daf$var$getOptionsToProducts(typeMapping);
        $[0] = t1;
    } else t1 = $[0];
    const optionsToProducts = t1;
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            filterId: (0, $5iakG.universalTypeFilterId),
            optionsToProducts: optionsToProducts
        };
        $[1] = t2;
    } else t2 = $[1];
    const [filterData, t3] = (0, $5cssW.useUniversalSelectFilter)(t2);
    const { setOption: setOption, loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, clearLookupInput: clearLookupInput, clearOptions: clearOptions } = t3;
    if (!filterData) return null;
    if (productSelected === (0, $1yEFx.ProductKeys).Atlas) return null;
    const { options: options, lookupInput: lookupInput, selectedOptions: selectedOptions, isLoading: isLoading, isLookupDefined: isLookupDefined } = filterData;
    const selectedOptionsCount = selectedOptions.length;
    const badgeLabel = selectedOptionsCount > 1 ? `+${selectedOptionsCount - 1}` : undefined;
    const firstSelectedOptionLabel = selectedOptions[0]?.label;
    let t4;
    if ($[2] !== formatMessage || $[3] !== iconBefore || $[4] !== primaryProduct || $[5] !== showPrimaryProductIcon) {
        t4 = ()=>{
            if (iconBefore) return iconBefore;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), null, showPrimaryProductIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
                showPrimaryProductIcon: showPrimaryProductIcon,
                primaryProduct: primaryProduct
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
                label: formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type)
            }));
        };
        $[2] = formatMessage;
        $[3] = iconBefore;
        $[4] = primaryProduct;
        $[5] = showPrimaryProductIcon;
        $[6] = t4;
    } else t4 = $[6];
    const getIconBefore = t4;
    let t5;
    if ($[7] !== badgeLabel || $[8] !== iconAfter || $[9] !== selectedOptions.length) {
        t5 = ()=>selectedOptions.length === 0 ? iconAfter ? iconAfter : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                size: "small"
            }) : badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                appearance: "information"
            }, badgeLabel);
        $[7] = badgeLabel;
        $[8] = iconAfter;
        $[9] = selectedOptions.length;
        $[10] = t5;
    } else t5 = $[10];
    const getIconAfter = t5;
    let t6;
    if ($[11] !== setOption) {
        t6 = (option)=>{
            setOption(option);
        };
        $[11] = setOption;
        $[12] = t6;
    } else t6 = $[12];
    const handleSetOption = t6;
    let t7;
    if ($[13] !== formatMessage) {
        t7 = formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type);
        $[13] = formatMessage;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== formatMessage) {
        t8 = formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).filterTypePlaceholder);
        $[15] = formatMessage;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== firstSelectedOptionLabel || $[18] !== formatMessage || $[19] !== getIconAfter || $[20] !== getIconBefore || $[21] !== selectedOptions.length) {
        t9 = (t10)=>{
            const { isOpen: isOpen, ...targetProps } = t10;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                testId: "quick-find-universal-type-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                minWidthZero: true
            }, firstSelectedOptionLabel ? `${formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type)}: ${firstSelectedOptionLabel}` : formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type));
        };
        $[17] = firstSelectedOptionLabel;
        $[18] = formatMessage;
        $[19] = getIconAfter;
        $[20] = getIconBefore;
        $[21] = selectedOptions.length;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== clearLookupInput || $[24] !== clearOptions || $[25] !== handleSetOption || $[26] !== isFiltersDiscoverability2Enabled || $[27] !== isLoading || $[28] !== isLookupDefined || $[29] !== loadInitialOptions || $[30] !== lookupInput || $[31] !== options || $[32] !== selectedOptions || $[33] !== setLookupInput || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
            filterId: (0, $5iakG.universalTypeFilterId),
            canClearFilter: true,
            checkboxIndicators: false,
            onDropdownOpen: loadInitialOptions,
            onDropdownClose: clearLookupInput,
            onSearchInputChange: setLookupInput,
            onSelectChange: handleSetOption,
            options: options,
            selectedOptions: selectedOptions,
            label: t7,
            placeholder: t8,
            isLoading: isLoading,
            isSearchable: isLookupDefined,
            searchInput: lookupInput,
            onClearOptions: clearOptions,
            target: t9,
            isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
        });
        $[23] = clearLookupInput;
        $[24] = clearOptions;
        $[25] = handleSetOption;
        $[26] = isFiltersDiscoverability2Enabled;
        $[27] = isLoading;
        $[28] = isLookupDefined;
        $[29] = loadInitialOptions;
        $[30] = lookupInput;
        $[31] = options;
        $[32] = selectedOptions;
        $[33] = setLookupInput;
        $[34] = t7;
        $[35] = t8;
        $[36] = t9;
        $[37] = t10;
    } else t10 = $[37];
    return t10;
} : ({ iconBefore: iconBefore, iconAfter: iconAfter, showPrimaryProductIcon: showPrimaryProductIcon })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    const optionsToProducts = $a2107b05e31d2daf$var$getOptionsToProducts(typeMapping);
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useUniversalSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId),
        optionsToProducts: optionsToProducts
    });
    if (!filterData) return null;
    // Do not show TypeFilter for Atlas since that is handled by Noun filters
    if (productSelected === (0, $1yEFx.ProductKeys).Atlas) return null;
    const { options: options, lookupInput: lookupInput, selectedOptions: selectedOptions, isLoading: isLoading, isLookupDefined: isLookupDefined } = filterData;
    // Compute the label and badge values since useUniversalSelectFilter doesn't provide them
    const selectedOptionsCount = selectedOptions.length;
    const badgeLabel = selectedOptionsCount > 1 ? `+${selectedOptionsCount - 1}` : undefined;
    const firstSelectedOptionLabel = selectedOptions[0]?.label;
    const getIconBefore = ()=>{
        if (iconBefore) return iconBefore;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d11e9fb73f3c65ea$export$68a752ca64f3cf84), null, showPrimaryProductIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
            label: formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type)
        }));
    };
    const getIconAfter = ()=>{
        return selectedOptions.length === 0 ? iconAfter ? iconAfter : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            size: "small"
        }) : badgeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
            appearance: "information"
        }, badgeLabel);
    };
    const handleSetOption = (option)=>{
        setOption(option);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40387639b8effd2d$export$381eb977a1d9bc81), {
        filterId: (0, $5iakG.universalTypeFilterId),
        canClearFilter: true,
        checkboxIndicators: false,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: handleSetOption,
        options: options,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type),
        placeholder: formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).filterTypePlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: clearOptions,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
                testId: "quick-find-universal-type-filter-button",
                ...targetProps,
                isSelected: !!selectedOptions.length || isOpen,
                iconBefore: getIconBefore(),
                iconAfter: getIconAfter(),
                minWidthZero: true
            }, firstSelectedOptionLabel ? `${formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type)}: ${firstSelectedOptionLabel}` : formatMessage((0, $b6d7a903a92ed23b$export$a7357cdd1f0b0168).type)),
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};












const $b9b0457c9911360b$export$767d38fff643cac6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { productConfig: productConfig, onAppFilterSelected: onAppFilterSelected, productKey: productKey } = t0;
    const Icon = productConfig.IconBorderless ?? productConfig.Icon;
    let t1;
    if ($[0] !== Icon) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            size: "xsmall"
        });
        $[0] = Icon;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onAppFilterSelected || $[3] !== productKey) {
        t2 = (event)=>{
            onAppFilterSelected(productKey, {
                redirectToFPS: true,
                isPostAuthAction: false
            }, event);
        };
        $[2] = onAppFilterSelected;
        $[3] = productKey;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== productConfig.displayName || $[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
            iconBefore: t1,
            contentFit: "default",
            isSelected: false,
            spacing: "default",
            onClick: t2
        }, productConfig.displayName);
        $[5] = productConfig.displayName;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ productConfig: productConfig, onAppFilterSelected: onAppFilterSelected, productKey: productKey })=>{
    const Icon = productConfig.IconBorderless ?? productConfig.Icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            size: 'xsmall'
        }),
        contentFit: 'default',
        isSelected: false,
        spacing: 'default',
        onClick: (event)=>{
            onAppFilterSelected(productKey, {
                redirectToFPS: true,
                isPostAuthAction: false
            }, event);
        }
    }, productConfig.displayName);
};












const $2d50858696eaf28c$export$42a563ec5acc14f9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { productConfig: productConfig, userNeedsAuth: userNeedsAuth, triggerProps: triggerProps, onAppFilterSelected: onAppFilterSelected, productKey: productKey } = t0;
    const Icon = productConfig.IconBorderless ?? productConfig.Icon;
    let t1;
    if ($[0] !== Icon) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            size: "xsmall"
        });
        $[0] = Icon;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onAppFilterSelected || $[3] !== productKey || $[4] !== userNeedsAuth) {
        t2 = (event)=>{
            if (!userNeedsAuth) onAppFilterSelected(productKey, {
                redirectToFPS: true,
                isPostAuthAction: false
            }, event);
        };
        $[2] = onAppFilterSelected;
        $[3] = productKey;
        $[4] = userNeedsAuth;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== productConfig.displayName || $[7] !== t1 || $[8] !== t2 || $[9] !== triggerProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
            ...triggerProps,
            iconBefore: t1,
            contentFit: "default",
            isSelected: false,
            spacing: "default",
            gap: "comfortable",
            onClick: t2
        }, productConfig.displayName);
        $[6] = productConfig.displayName;
        $[7] = t1;
        $[8] = t2;
        $[9] = triggerProps;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ productConfig: productConfig, userNeedsAuth: userNeedsAuth, triggerProps: triggerProps, onAppFilterSelected: onAppFilterSelected, productKey: productKey })=>{
    const Icon = productConfig.IconBorderless ?? productConfig.Icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
        ...triggerProps,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            size: 'xsmall'
        }),
        contentFit: 'default',
        isSelected: false,
        spacing: 'default',
        gap: 'comfortable',
        onClick: (event)=>{
            if (!userNeedsAuth) onAppFilterSelected(productKey, {
                redirectToFPS: true,
                isPostAuthAction: false
            }, event);
        }
    }, productConfig.displayName);
};


























const $dff2b050324c4738$export$cca86f2b29004207 = ({ productKey: productKey, redirectToFPSWithProductSelected: redirectToFPSWithProductSelected, trigger: trigger })=>{
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const isSmartlink = (0, $def8z.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.useIsUserOAuthed)(productKey);
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    if (userNeedsOAuth) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1nJM3.ErrorBoundary), {
        section: "FiltersRowAppButtonFor3PAppsOAuthWrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eoZmS.OAuthWarningWrapper), {
        key: productKey,
        product: productKey,
        postAuthAction: ()=>{
            redirectToFPSWithProductSelected();
        },
        trigger: (triggerProps)=>trigger({
                ...triggerProps,
                userNeedsAuth: true
            }),
        isOnSearchDialog: false,
        isInline: true,
        useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
        useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
        isSmartlink: isSmartlink,
        searchQuery: quickFindQuery,
        oAuthSource: (0, $ckkm9.OAuthSource).quickFindFilter,
        thirdPartyConfigs: thirdPartyConfigs
    }));
    return trigger({
        userNeedsAuth: false
    });
};





const $e2c0e536b7fb0238$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    filterByIcon: {
        id: "search-filters.filter-by-icon",
        defaultMessage: "Filter by icon"
    },
    more: {
        id: "search_filters.more",
        defaultMessage: "more"
    },
    moreAppsSearchTooltip: {
        id: "search_filters.more-apps-search",
        defaultMessage: "Open full page search for this term searching all apps"
    },
    contributor: {
        id: "search-filters.names.contributor",
        defaultMessage: "Contributor"
    },
    type: {
        id: "search-filters.names.type",
        defaultMessage: "Type"
    }
});




















// TODO: Render dynamic 1P products, hardcoded for now for Team 25
// This should be synced with the FilterRowLoading component that hard codes filter buttons
const $be53cd525abd320f$var$supported1PApps = (primaryProduct)=>{
    if (!primaryProduct) return [];
    return [
        {
            productKey: (0, $1yEFx.ProductKeys).Confluence,
            redirectToFPS: false
        }
    ];
};
// TODO: Render dynamic 3P products, hardcoded for now for Team 25
// This should be synced with the FilterRowLoading component that hard codes filter buttons
const $be53cd525abd320f$var$supported3PApps = [
    (0, $1yEFx.ProductKeys).GoogleDrive,
    (0, $1yEFx.ProductKeys).Teams
];
const $be53cd525abd320f$export$6889317edccadd84 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(26);
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    let t0;
    if ($[0] !== availableProducts || $[1] !== productConfigs || $[2] !== selectedProduct) {
        let t1;
        if ($[4] !== availableProducts) {
            t1 = (supported3PApp)=>availableProducts.includes(supported3PApp);
            $[4] = availableProducts;
            $[5] = t1;
        } else t1 = $[5];
        let t2;
        if ($[6] !== selectedProduct) {
            t2 = (_)=>!selectedProduct;
            $[6] = selectedProduct;
            $[7] = t2;
        } else t2 = $[7];
        let t3;
        if ($[8] !== productConfigs) {
            t3 = (productKey)=>({
                    productKey: productKey,
                    productConfig: productConfigs[productKey]
                });
            $[8] = productConfigs;
            $[9] = t3;
        } else t3 = $[9];
        t0 = $be53cd525abd320f$var$supported3PApps.filter(t1).filter(t2).map(t3);
        $[0] = availableProducts;
        $[1] = productConfigs;
        $[2] = selectedProduct;
        $[3] = t0;
    } else t0 = $[3];
    const apps3PToDisplay = t0;
    let t1;
    if ($[10] !== availableProducts || $[11] !== primaryProduct || $[12] !== productConfigs || $[13] !== selectedProduct) {
        let t2;
        if ($[15] !== availableProducts) {
            t2 = (supported1PApp)=>availableProducts.includes(supported1PApp.productKey);
            $[15] = availableProducts;
            $[16] = t2;
        } else t2 = $[16];
        let t3;
        if ($[17] !== selectedProduct) {
            t3 = (supported1PApp_0)=>!selectedProduct || supported1PApp_0.productKey === selectedProduct;
            $[17] = selectedProduct;
            $[18] = t3;
        } else t3 = $[18];
        let t4;
        if ($[19] !== productConfigs) {
            t4 = (supportedApp)=>({
                    ...supportedApp,
                    productConfig: productConfigs[supportedApp.productKey]
                });
            $[19] = productConfigs;
            $[20] = t4;
        } else t4 = $[20];
        t1 = $be53cd525abd320f$var$supported1PApps(primaryProduct).filter(t2).filter(t3).map(t4);
        $[10] = availableProducts;
        $[11] = primaryProduct;
        $[12] = productConfigs;
        $[13] = selectedProduct;
        $[14] = t1;
    } else t1 = $[14];
    const apps1PToDisplay = t1;
    let t2;
    if ($[21] !== apps1PToDisplay || $[22] !== apps3PToDisplay || $[23] !== primaryProduct || $[24] !== selectedProduct) {
        t2 = {
            apps1PToDisplay: apps1PToDisplay,
            apps3PToDisplay: apps3PToDisplay,
            primaryProduct: primaryProduct,
            selectedProduct: selectedProduct
        };
        $[21] = apps1PToDisplay;
        $[22] = apps3PToDisplay;
        $[23] = primaryProduct;
        $[24] = selectedProduct;
        $[25] = t2;
    } else t2 = $[25];
    return t2;
} : ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const apps3PToDisplay = (0, $42omo.useMemo)(()=>$be53cd525abd320f$var$supported3PApps.filter((supported3PApp)=>availableProducts.includes(supported3PApp)).filter((_)=>!selectedProduct).map((productKey)=>({
                productKey: productKey,
                productConfig: productConfigs[productKey]
            })), [
        availableProducts,
        productConfigs,
        selectedProduct
    ]);
    const apps1PToDisplay = (0, $42omo.useMemo)(()=>$be53cd525abd320f$var$supported1PApps(primaryProduct).filter((supported1PApp)=>availableProducts.includes(supported1PApp.productKey)).filter((supported1PApp_0)=>!selectedProduct || supported1PApp_0.productKey === selectedProduct).map((supportedApp)=>({
                ...supportedApp,
                productConfig: productConfigs[supportedApp.productKey]
            })), [
        availableProducts,
        primaryProduct,
        productConfigs,
        selectedProduct
    ]);
    return {
        apps1PToDisplay: apps1PToDisplay,
        apps3PToDisplay: apps3PToDisplay,
        primaryProduct: primaryProduct,
        selectedProduct: selectedProduct
    };
};


const $b3d2eb85abd87b7a$var$styles = {
    container: "_1mou1ejb _195g1wug _18zr1ejb _1bsb1osq _p12f1rc7 _1n261g80 _zkhy1q9c",
    icon: "_syaz1rpy _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    defaultFilterButton: "_zulp12x7 _2rko12b0 _19itia51 _11c8fhey _18zrutpp _1rjc1b66 _1e0c1txw _4cvr1h6o _syazazsu _1bsb1ris _1tkezwfg _p12f182l _bfhksm61 _o5721q9c _k48p1wq8",
    filterButtonContent: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
};
const $b3d2eb85abd87b7a$export$876f25caa2b82f74 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(22);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { selectProductFilter: selectProductFilter, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { selectedProduct: selectedProduct } = (0, $be53cd525abd320f$export$6889317edccadd84)();
    let t0;
    if ($[0] !== clearAllFilters || $[1] !== commonAttributes || $[2] !== fireAnalyticsEvent || $[3] !== generateSearchUrl || $[4] !== nonPrivacySafeAttributes || $[5] !== onNavigate || $[6] !== queryParams || $[7] !== quickFindQuery || $[8] !== selectProductFilter || $[9] !== selectedProduct || $[10] !== setQuickFindOpen) {
        t0 = (productKey, options, event)=>{
            const newSelectedProduct = selectedProduct === productKey ? undefined : productKey;
            fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
                actionSubjectId: productKey,
                action: newSelectedProduct === undefined ? "unselected" : "selected",
                attributes: {
                    ...commonAttributes,
                    isPostAuthAction: options.isPostAuthAction,
                    isRedirectedToFPS: options.redirectToFPS,
                    source: "inline"
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            if (!options.redirectToFPS) {
                selectProductFilter(newSelectedProduct);
                return;
            }
            const onNavigateCallback = typeof onNavigate === "function" ? onNavigate : onNavigate.callback;
            onNavigateCallback(generateSearchUrl({
                ...queryParams,
                product: productKey,
                text: quickFindQuery
            }), "push", event);
            clearAllFilters();
            setQuickFindOpen(false);
        };
        $[0] = clearAllFilters;
        $[1] = commonAttributes;
        $[2] = fireAnalyticsEvent;
        $[3] = generateSearchUrl;
        $[4] = nonPrivacySafeAttributes;
        $[5] = onNavigate;
        $[6] = queryParams;
        $[7] = quickFindQuery;
        $[8] = selectProductFilter;
        $[9] = selectedProduct;
        $[10] = setQuickFindOpen;
        $[11] = t0;
    } else t0 = $[11];
    const onAppFilterSelected = t0;
    let t1;
    if ($[12] !== formatMessage) {
        t1 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).filterByIcon);
        $[12] = formatMessage;
        $[13] = t1;
    } else t1 = $[13];
    let t2;
    if ($[14] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b3d2eb85abd87b7a$var$styles.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
            label: t1
        }));
        $[14] = t1;
        $[15] = t2;
    } else t2 = $[15];
    let t3;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$FilterSelects, null);
        $[16] = t3;
    } else t3 = $[16];
    let t4;
    if ($[17] !== onAppFilterSelected) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$FilterApps, {
            onAppFilterSelected: onAppFilterSelected
        });
        $[17] = onAppFilterSelected;
        $[18] = t4;
    } else t4 = $[18];
    let t5;
    if ($[19] !== t2 || $[20] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.150",
            alignBlock: "center",
            alignInline: "center",
            xcss: $b3d2eb85abd87b7a$var$styles.container
        }, t2, t3, t4);
        $[19] = t2;
        $[20] = t4;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { selectProductFilter: selectProductFilter, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { selectedProduct: selectedProduct } = (0, $be53cd525abd320f$export$6889317edccadd84)();
    const onAppFilterSelected = (productKey, options, event)=>{
        const newSelectedProduct = selectedProduct === productKey ? undefined : productKey;
        fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
            actionSubjectId: productKey,
            action: newSelectedProduct === undefined ? 'unselected' : 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: options.isPostAuthAction,
                isRedirectedToFPS: options.redirectToFPS,
                source: 'inline'
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        if (!options.redirectToFPS) {
            selectProductFilter(newSelectedProduct);
            return;
        }
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push', event);
        clearAllFilters();
        setQuickFindOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center",
        alignInline: "center",
        xcss: $b3d2eb85abd87b7a$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
        label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).filterByIcon)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$FilterSelects, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$FilterApps, {
        onAppFilterSelected: onAppFilterSelected
    }));
};
const $b3d2eb85abd87b7a$var$FilterSelects = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(20);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { unselectProductFilter: unselectProductFilter } = (0, $djVCD.useSearchActions)();
    let t0;
    if ($[0] !== unselectProductFilter) {
        t0 = (options, selectedOptions)=>{
            if (selectedOptions.length === 0) unselectProductFilter();
        };
        $[0] = unselectProductFilter;
        $[1] = t0;
    } else t0 = $[1];
    const onFilterClose = t0;
    let t1;
    if ($[2] !== formatMessage) {
        t1 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).contributor);
        $[2] = formatMessage;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: t1
        });
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== onFilterClose || $[8] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $23012254e2ce6f81$export$fcbf8a9904746204), {
            iconBefore: t2,
            iconAfter: t3,
            onFilterClose: onFilterClose
        });
        $[7] = onFilterClose;
        $[8] = t2;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== formatMessage) {
        t5 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).type);
        $[10] = formatMessage;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
            label: t5
        });
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a2107b05e31d2daf$export$409b84e60ce4841e), {
            iconBefore: t6,
            iconAfter: t7
        });
        $[15] = t6;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== t4 || $[18] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t4, t8);
        $[17] = t4;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { unselectProductFilter: unselectProductFilter } = (0, $djVCD.useSearchActions)(); // Deselect 'Confluence' when closing the contributor filter with no options selected
    // This should restore any 3P filters that were hidden while this filter was active
    const onFilterClose = (options, selectedOptions)=>{
        if (selectedOptions.length === 0) unselectProductFilter();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $23012254e2ce6f81$export$fcbf8a9904746204), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).contributor)
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        onFilterClose: onFilterClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a2107b05e31d2daf$export$409b84e60ce4841e), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
            label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).type)
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
    }));
};
const $b3d2eb85abd87b7a$var$FilterApps = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { onAppFilterSelected: onAppFilterSelected } = t0;
    const { apps3PToDisplay: apps3PToDisplay, apps1PToDisplay: apps1PToDisplay } = (0, $be53cd525abd320f$export$6889317edccadd84)();
    let t1;
    if ($[0] !== apps1PToDisplay || $[1] !== onAppFilterSelected) {
        let t2;
        if ($[3] !== onAppFilterSelected) {
            t2 = (app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                    key: app.productKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9b0457c9911360b$export$767d38fff643cac6), {
                    productConfig: app.productConfig,
                    onAppFilterSelected: onAppFilterSelected,
                    productKey: app.productKey
                }));
            $[3] = onAppFilterSelected;
            $[4] = t2;
        } else t2 = $[4];
        t1 = apps1PToDisplay.map(t2);
        $[0] = apps1PToDisplay;
        $[1] = onAppFilterSelected;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== apps3PToDisplay || $[6] !== onAppFilterSelected) {
        let t3;
        if ($[8] !== onAppFilterSelected) {
            t3 = (app_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                    key: app_0.productKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dff2b050324c4738$export$cca86f2b29004207), {
                    productKey: app_0.productKey,
                    redirectToFPSWithProductSelected: ()=>onAppFilterSelected(app_0.productKey, {
                            redirectToFPS: true,
                            isPostAuthAction: true
                        }),
                    trigger: (t4)=>{
                        const { triggerProps: triggerProps, userNeedsAuth: userNeedsAuth } = t4;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2d50858696eaf28c$export$42a563ec5acc14f9), {
                            productConfig: app_0.productConfig,
                            userNeedsAuth: userNeedsAuth,
                            triggerProps: triggerProps,
                            onAppFilterSelected: onAppFilterSelected,
                            productKey: app_0.productKey
                        });
                    }
                }));
            $[8] = onAppFilterSelected;
            $[9] = t3;
        } else t3 = $[9];
        t2 = apps3PToDisplay.map(t3);
        $[5] = apps3PToDisplay;
        $[6] = onAppFilterSelected;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$AdditionalAppsButton, null);
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== t1 || $[12] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2, t3);
        $[11] = t1;
        $[12] = t2;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ onAppFilterSelected: onAppFilterSelected })=>{
    const { apps3PToDisplay: apps3PToDisplay, apps1PToDisplay: apps1PToDisplay } = (0, $be53cd525abd320f$export$6889317edccadd84)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, apps1PToDisplay.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            key: app.productKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9b0457c9911360b$export$767d38fff643cac6), {
            productConfig: app.productConfig,
            onAppFilterSelected: onAppFilterSelected,
            productKey: app.productKey
        }))), apps3PToDisplay.map((app_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            key: app_0.productKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dff2b050324c4738$export$cca86f2b29004207), {
            productKey: app_0.productKey,
            redirectToFPSWithProductSelected: ()=>onAppFilterSelected(app_0.productKey, {
                    redirectToFPS: true,
                    isPostAuthAction: true
                }),
            trigger: ({ triggerProps: triggerProps, userNeedsAuth: userNeedsAuth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2d50858696eaf28c$export$42a563ec5acc14f9), {
                    productConfig: app_0.productConfig,
                    userNeedsAuth: userNeedsAuth,
                    triggerProps: triggerProps,
                    onAppFilterSelected: onAppFilterSelected,
                    productKey: app_0.productKey
                })
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$AdditionalAppsButton, null));
};
const $b3d2eb85abd87b7a$var$AdditionalAppsButton = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(19);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    let t0;
    if ($[0] !== clearAllFilters || $[1] !== commonAttributes || $[2] !== fireAnalyticsEvent || $[3] !== generateSearchUrl || $[4] !== nonPrivacySafeAttributes || $[5] !== onNavigate || $[6] !== queryParams || $[7] !== quickFindQuery || $[8] !== setQuickFindOpen) {
        t0 = (event)=>{
            fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
                actionSubjectId: "more-apps-search",
                action: "selected",
                attributes: {
                    ...commonAttributes,
                    isPostAuthAction: false,
                    isRedirectedToFPS: true,
                    source: "inline"
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            const onNavigateCallback = typeof onNavigate === "function" ? onNavigate : onNavigate.callback;
            onNavigateCallback(generateSearchUrl({
                ...queryParams,
                text: quickFindQuery
            }), "push", event);
            clearAllFilters();
            setQuickFindOpen(false);
        };
        $[0] = clearAllFilters;
        $[1] = commonAttributes;
        $[2] = fireAnalyticsEvent;
        $[3] = generateSearchUrl;
        $[4] = nonPrivacySafeAttributes;
        $[5] = onNavigate;
        $[6] = queryParams;
        $[7] = quickFindQuery;
        $[8] = setQuickFindOpen;
        $[9] = t0;
    } else t0 = $[9];
    const onClick = t0;
    let t1;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3KrAM.AllAppsIcon), null);
        $[10] = t1;
    } else t1 = $[10];
    let t2;
    if ($[11] !== formatMessage) {
        t2 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).moreAppsSearchTooltip);
        $[11] = formatMessage;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] !== formatMessage) {
        t3 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).more);
        $[13] = formatMessage;
        $[14] = t3;
    } else t3 = $[14];
    const t4 = `+${t3}`;
    let t5;
    if ($[15] !== onClick || $[16] !== t2 || $[17] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
            iconBefore: t1,
            contentFit: "default",
            isSelected: false,
            spacing: "default",
            tooltip: t2,
            onClick: onClick
        }, t4);
        $[15] = onClick;
        $[16] = t2;
        $[17] = t4;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const onClick = (event)=>{
        fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
            actionSubjectId: 'more-apps-search',
            action: 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: false,
                isRedirectedToFPS: true,
                source: 'inline'
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            text: quickFindQuery
        }), 'push', event);
        clearAllFilters();
        setQuickFindOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c4269204833e8a1$export$fb46dd9777cc6db0), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3KrAM.AllAppsIcon), null),
        contentFit: 'default',
        isSelected: false,
        spacing: 'default',
        tooltip: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).moreAppsSearchTooltip),
        onClick: onClick
    }, `+${formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).more)}`);
};
const $b3d2eb85abd87b7a$export$28e86b995fe6c793 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(12);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).filterByIcon);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b3d2eb85abd87b7a$var$styles.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
            label: t0
        }));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$ContributorFilterLoading, null);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$UniversalTypeFilterLoading, null);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$ProductFilterLoading, {
            productKey: "confluence"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$ProductFilterLoading, {
            productKey: "drive"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$ProductFilterLoading, {
            productKey: "teams"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$ProductMoreAppsButtonLoading, null);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
        $[9] = t7;
    } else {
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
        t5 = $[7];
        t6 = $[8];
        t7 = $[9];
    }
    let t8;
    if ($[10] !== t1) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.150",
            alignBlock: "center",
            alignInline: "center",
            xcss: $b3d2eb85abd87b7a$var$styles.container
        }, t1, t2, t3, t4, t5, t6, t7);
        $[10] = t1;
        $[11] = t8;
    } else t8 = $[11];
    return t8;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center",
        alignInline: "center",
        xcss: $b3d2eb85abd87b7a$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
        label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).filterByIcon)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$ContributorFilterLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$UniversalTypeFilterLoading, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$ProductFilterLoading, {
        productKey: "confluence"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$ProductFilterLoading, {
        productKey: "drive"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$ProductFilterLoading, {
        productKey: "teams"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3d2eb85abd87b7a$var$ProductMoreAppsButtonLoading, null));
};
const $b3d2eb85abd87b7a$var$ContributorFilterLoading = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).contributor);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).contributor);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent
        }, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton
        }, t1, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
        label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).contributor)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent
    }, formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).contributor)));
};
const $b3d2eb85abd87b7a$var$UniversalTypeFilterLoading = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).type);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
            label: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).type);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent
        }, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton
        }, t1, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
        label: formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).type)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent
    }, formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).type)));
};
const $b3d2eb85abd87b7a$var$ProductFilterLoading = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { productKey: productKey } = t0;
    const config1P = (0, $1yEFx.products1P)[productKey];
    let t1;
    if ($[0] !== productKey) {
        t1 = (0, $a5RR2.ThirdPartyConfigsSync).get(productKey);
        $[0] = productKey;
        $[1] = t1;
    } else t1 = $[1];
    const config3P = t1;
    let displayName;
    let displayNameString;
    let IconComponent;
    if (config1P) {
        IconComponent = config1P.IconBorderless ?? config1P.Icon;
        displayName = config1P.displayName;
        displayNameString = String(displayName);
    } else {
        if (config3P) {
            IconComponent = config3P.iconBorderless ?? config3P.icon;
            displayName = config3P.displayName;
            displayNameString = String(displayName);
        } else return null;
    }
    let t2;
    if ($[2] !== IconComponent || $[3] !== displayNameString) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconComponent, {
            size: "xsmall",
            label: displayNameString
        });
        $[2] = IconComponent;
        $[3] = displayNameString;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== displayName) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent
        }, displayName);
        $[5] = displayName;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton
        }, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ productKey: productKey })=>{
    const config1P = (0, $1yEFx.products1P)[productKey];
    const config3P = (0, $a5RR2.ThirdPartyConfigsSync).get(productKey);
    let displayName = '';
    let displayNameString = ''; // 1P configs use config.Icon/IconBorderless, 3P configs use config.icon/iconBorderless
    let IconComponent;
    if (config1P) {
        // ProductConfig from products1P
        IconComponent = config1P.IconBorderless ?? config1P.Icon;
        displayName = config1P.displayName;
        displayNameString = String(displayName);
    } else if (config3P) {
        // ThirdPartyConfig from ThirdPartyConfigs
        IconComponent = config3P.iconBorderless ?? config3P.icon;
        displayName = config3P.displayName;
        displayNameString = String(displayName);
    } else return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconComponent, {
        size: "xsmall",
        label: displayNameString
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent
    }, displayName));
};
const $b3d2eb85abd87b7a$var$ProductMoreAppsButtonLoading = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3KrAM.AllAppsIcon), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== formatMessage) {
        t1 = formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).more);
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = `+${t1}`;
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent
        }, t2));
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.defaultFilterButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3KrAM.AllAppsIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b3d2eb85abd87b7a$var$styles.filterButtonContent
    }, `+${formatMessage((0, $e2c0e536b7fb0238$export$defe85febe8b728c).more)}`));
};















var $hTKp4 = parcelRequire("hTKp4");





var $cbc8g = parcelRequire("cbc8g");























var $hr2Qv = parcelRequire("hr2Qv");











var $6CCa2 = parcelRequire("6CCa2");

const $123705605745917c$export$d41d96cbdaac172b = ({ thirdPartyConfigs: thirdPartyConfigs })=>{
    const isEligible3PUser = Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
    if (!isEligible3PUser) return false;
    return (0, $c6GJD.default).getExperimentValue('confluence_quick_find_ghost_text_3p_experiment', 'cohort', (0, $6CCa2.GhostTextExperimentCohort).CONTROL) === (0, $6CCa2.GhostTextExperimentCohort).THREE_P;
};










const $fbbe843703a5fd8b$export$494a88615cfa0dd3 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}QuickFindClearButton`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





const $095f50e31f589f5a$export$d56b70a75f0c16 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}QuickFindConnectAppsPill`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $936b3cff3811e499$export$f86bcd23f07f7d76 = ({ attributes: attributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `ghostText`,
        actionSubjectId: 'customGhostText',
        attributes: attributes
    });


const $df50e1184d0554ef$export$5633d029795394f8 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'searchDialogInput',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });




















const $b62359973626d8df$export$f0a1ecf34ab38b2d = (inputQuery, selectedQueryFilters)=>{
    let filteredQuery = inputQuery;
    for (const selectedQueryFilter of selectedQueryFilters)filteredQuery = filteredQuery.replace(selectedQueryFilter.displayText, '');
    return filteredQuery;
};





















const $fbd0f9156abc48d4$export$766d74f7dcab3339 = (0, $aXWIB.defineMessages)({
    controlPlaceholder: {
        id: "quick-find.ghost-text.control",
        defaultMessage: "Search"
    },
    default3PPlaceholder: {
        id: "quick-find.ghost-text.default-3p",
        defaultMessage: "Search across all your apps"
    },
    sainPlaceholder: {
        id: "quick-find.ghost-text.sain",
        defaultMessage: "Ask me anything or search..."
    },
    multipleThirdPartyPlaceholder: {
        id: "quick-find.ghost-text.3p-multiple",
        defaultMessage: "Search {firstPartyApp}, {thirdPartyApp1}, {thirdPartyApp2} and other apps"
    },
    twoAppPlaceholder: {
        id: "quick-find.ghost-text.two-apps",
        defaultMessage: "Search {firstPartyApp}, {thirdPartyApp1} and other apps"
    },
    mixedAppsPlaceholder: {
        id: "quick-find.ghost-text.mixed-apps",
        defaultMessage: "Search {currentApp}, {otherFirstPartyApp}, {thirdPartyApp} and other apps"
    },
    // Third-party product specific messages
    googleDrivePlaceholder: {
        id: "quick-find.ghost-text.3p.google-drive",
        defaultMessage: "Search your Google Drive Docs, Sheets and Slides"
    },
    sharepointPlaceholder: {
        id: "quick-find.ghost-text.3p.sharepoint",
        defaultMessage: "Search your SharePoint documents and files"
    },
    onedrivePlaceholder: {
        id: "quick-find.ghost-text.3p.onedrive",
        defaultMessage: "Search your OneDrive documents and files"
    },
    teamsPlaceholder: {
        id: "quick-find.ghost-text.3p.teams",
        defaultMessage: "Search your Microsoft Teams chats and messages"
    },
    slackPlaceholder: {
        id: "quick-find.ghost-text.3p.slack",
        defaultMessage: "Search your Slack DMs and messages"
    },
    githubPlaceholder: {
        id: "quick-find.ghost-text.3p.github",
        defaultMessage: "Search your GitHub repos, commits and PRs"
    },
    // SAIN cohort question suggestions
    sainQuestionTimeOff: {
        id: "quick-find.ghost-text.sain.time-off",
        defaultMessage: "Try any question, like \"How do I request time off?\""
    },
    sainQuestionResetPassword: {
        id: "quick-find.ghost-text.sain.reset-password",
        defaultMessage: "Try any question, like \"How do I reset my password?\""
    },
    sainQuestionNotifications: {
        id: "quick-find.ghost-text.sain.notifications",
        defaultMessage: "Try any question, like \"How do I change my notification settings?\""
    },
    sainQuestionITSupport: {
        id: "quick-find.ghost-text.sain.it-support",
        defaultMessage: "Try any question, like \"How do I contact IT support?\""
    },
    sainQuestionMeetingRoom: {
        id: "quick-find.ghost-text.sain.meeting-room",
        defaultMessage: "Try any question, like \"How do I book a meeting room?\""
    },
    sainQuestionBenefits: {
        id: "quick-find.ghost-text.sain.benefits",
        defaultMessage: "Try any question, like \"Where can I see my benefits?\""
    }
});



var $3M2Ci = parcelRequire("3M2Ci");

// TODO: to be used in second experiment https://hello.atlassian.net/wiki/pages/resumedraft.action?draftId=6192988799
/**
 * Generate ghost text rotations for SAIN cohort (AI-powered question suggestions)
 */ // const calculateSainGhostTextRotations = (
// 	formatMessage: (message: any, values?: any) => string,
// ): string[] => {
// 	return [
// 		formatMessage(ghostTextMessages.sainQuestionTimeOff),
// 		formatMessage(ghostTextMessages.sainQuestionResetPassword),
// 		formatMessage(ghostTextMessages.sainQuestionNotifications),
// 		formatMessage(ghostTextMessages.sainQuestionITSupport),
// 		formatMessage(ghostTextMessages.sainQuestionMeetingRoom),
// 		formatMessage(ghostTextMessages.sainQuestionBenefits),
// 	];
// };
/**
 * Generate ghost text rotations for 3P cohort (based on available products)
 * Returns ordered list: combined texts -> 3P specific texts (sorted by hash)
 */ const $224a05be048f4a29$var$calculate3PGhostTextRotations = ({ products: products, thirdPartyConfigs: thirdPartyConfigs, primaryProduct: primaryProduct, formatMessage: formatMessage })=>{
    const SUPPORTED_3P_MESSAGES = new Map([
        [
            (0, $b4tvS.ProductKeys3P).GoogleDrive,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).googleDrivePlaceholder
        ],
        [
            (0, $b4tvS.ProductKeys3P).Sharepoint,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).sharepointPlaceholder
        ],
        [
            (0, $b4tvS.ProductKeys3P).OneDrive,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).onedrivePlaceholder
        ],
        [
            (0, $b4tvS.ProductKeys3P).Teams,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).teamsPlaceholder
        ],
        [
            (0, $b4tvS.ProductKeys3P).Slack,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).slackPlaceholder
        ],
        [
            (0, $b4tvS.ProductKeys3P).Github,
            (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).githubPlaceholder
        ]
    ]);
    const currentAppName = primaryProduct && (0, $b4tvS.is1pProductKey)(primaryProduct) ? (0, $1yEFx.products1P)[primaryProduct]?.displayName : undefined;
    const available1PExcludePrimary = Array.from(new Set(products.filter((0, $b4tvS.is1pProductKey)).map((productKey)=>{
        // Consolidate Jira variants to base Jira for ghost text
        if (productKey === (0, $1yEFx.ProductKeys).JiraProductDiscovery || productKey === (0, $1yEFx.ProductKeys).JiraServiceManagement) return (0, $1yEFx.ProductKeys).Jira;
        return productKey;
    }))).filter((productKey)=>productKey !== primaryProduct);
    const available3PProducts = Object.keys(thirdPartyConfigs || {}).filter((key)=>thirdPartyConfigs?.[key] !== undefined && !thirdPartyConfigs?.[key]?.userNeedsOAuth && !key.toLowerCase().startsWith('forge-connector-') && !key.toLowerCase().includes((0, $b4tvS.ProductKeys3P).AtlassianWebCrawler) && !key.toLowerCase().endsWith('-dc'));
    const textRotations = [];
    if (currentAppName) {
        if (available3PProducts.length >= 1 && available1PExcludePrimary.length >= 1) {
            const top1P = (0, $1yEFx.products1P)[available1PExcludePrimary[0]].displayName;
            const top3P = thirdPartyConfigs?.[available3PProducts[0]]?.displayName;
            textRotations.push({
                id: (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).mixedAppsPlaceholder.id,
                text: formatMessage((0, $fbd0f9156abc48d4$export$766d74f7dcab3339).mixedAppsPlaceholder, {
                    currentApp: currentAppName,
                    otherFirstPartyApp: top1P,
                    thirdPartyApp: top3P
                })
            });
        }
        if (available3PProducts.length >= 2) {
            const top3P1 = thirdPartyConfigs?.[available3PProducts[0]]?.displayName;
            const top3P2 = thirdPartyConfigs?.[available3PProducts[1]]?.displayName;
            textRotations.push({
                id: (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).multipleThirdPartyPlaceholder.id,
                text: formatMessage((0, $fbd0f9156abc48d4$export$766d74f7dcab3339).multipleThirdPartyPlaceholder, {
                    firstPartyApp: currentAppName,
                    thirdPartyApp1: top3P1,
                    thirdPartyApp2: top3P2
                })
            });
        }
        if (available3PProducts.length === 1 && available1PExcludePrimary.length === 0) {
            const top3P = thirdPartyConfigs?.[available3PProducts[0]]?.displayName;
            textRotations.push({
                id: (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).twoAppPlaceholder.id,
                text: formatMessage((0, $fbd0f9156abc48d4$export$766d74f7dcab3339).twoAppPlaceholder, {
                    firstPartyApp: currentAppName,
                    thirdPartyApp1: top3P
                })
            });
        }
    }
    for (const productKey of available3PProducts){
        const message = SUPPORTED_3P_MESSAGES.get(productKey);
        if (message) textRotations.push({
            id: message.id,
            text: formatMessage(message)
        });
    }
    return textRotations;
};
const $224a05be048f4a29$export$1933af4a353afb6d = ({ products: products, thirdPartyConfigs: thirdPartyConfigs, primaryProduct: primaryProduct, formatMessage: formatMessage })=>{
    const rotations = $224a05be048f4a29$var$calculate3PGhostTextRotations({
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        primaryProduct: primaryProduct,
        formatMessage: formatMessage
    }).filter((r)=>r.text.length <= 85);
    rotations.push({
        id: (0, $fbd0f9156abc48d4$export$766d74f7dcab3339).default3PPlaceholder.id,
        text: formatMessage((0, $fbd0f9156abc48d4$export$766d74f7dcab3339).default3PPlaceholder)
    });
    return rotations;
};
const $224a05be048f4a29$export$6d85a15223337a49 = ({ products: products, thirdPartyConfigs: thirdPartyConfigs, locale: locale, primaryProduct: primaryProduct, formatMessage: formatMessage, existingGhostTextData: existingGhostTextData })=>{
    // Get all text rotations
    const rotations = $224a05be048f4a29$export$1933af4a353afb6d({
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        primaryProduct: primaryProduct,
        formatMessage: formatMessage
    });
    // Select appropriate text based on current state
    const { id: id, text: text, occurrence: occurrence } = (0, $3M2Ci.selectGhostText)(rotations, locale, existingGhostTextData);
    return {
        id: id,
        locale: locale,
        text: text,
        occurrence: occurrence
    };
};
/**
 * Check if a serialized ghost text value is considered "empty"
 */ const $224a05be048f4a29$var$isEmptyGhostText = (value)=>{
    return value === '{}' || value === '' || value === null || value === undefined;
};
const $224a05be048f4a29$export$e1cd992f057eb389 = ({ serve3PGhostText: serve3PGhostText, lastPersisted: lastPersisted, products: products, thirdPartyConfigs: thirdPartyConfigs, locale: locale, primaryProduct: primaryProduct, formatMessage: formatMessage, existingGhostTextData: existingGhostTextData })=>{
    const newGhostTextData = serve3PGhostText ? $224a05be048f4a29$export$6d85a15223337a49({
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        locale: locale,
        primaryProduct: primaryProduct,
        formatMessage: formatMessage,
        existingGhostTextData: existingGhostTextData
    }) : {};
    const serialized = JSON.stringify(newGhostTextData);
    // Reject transition from non-empty to empty (don't overwrite valid data)
    // Accept transition from empty to non-empty (allow valid data to be set)
    const isNewEmpty = $224a05be048f4a29$var$isEmptyGhostText(serialized);
    const wasLastEmpty = $224a05be048f4a29$var$isEmptyGhostText(lastPersisted);
    if (!wasLastEmpty && isNewEmpty) // Don't overwrite valid ghost text with empty
    return null;
    return serialized;
};

















/**
 * Given a query and a list of filter keywords, determine if the user is using
 * a query filter. If so, return the filter keyword they are using.
 * @param query
 * @param filterKeywords
 * @returns
 */ const $d9b673a251b22a41$export$a47046b35fa42e2d = (query, filterKeywords)=>{
    for (const keyword of filterKeywords){
        if (query.includes(keyword)) return keyword;
    }
};


/**
 * Given a query and a filter keyword, return the query text after the filter keyword.
 * @param query
 * @param inQueryFiltersKey
 * @returns
 */ const $227cd3f86459a089$export$3141a593bcb9212f = (query, filterKeyword)=>{
    if (!query.includes(filterKeyword)) return;
    const lookupQueryIndexStart = query.lastIndexOf(filterKeyword) + filterKeyword.length;
    const lookupQuery = query.substring(lookupQueryIndexStart);
    return lookupQuery;
};












const $7bb4ea745ef14625$export$170a7ded78a9d477 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return (0, $42omo.useMemo)(()=>{
        return {};
    }, []);
};











const $7bee4fe2094cdfdf$export$c37f199dbeef0d2c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return (0, $42omo.useMemo)(()=>{
        return {};
    }, []);
};





const $908389ef2c25a547$export$d3538183feb90c1a = (0, $4pOgL.isReactCompilerActivePlatform)() ? (localQuery, postQueryDisabled)=>{
    const $ = (0, $frIzR.c)(20);
    const filterKeywordToFilterId = (0, $7bee4fe2094cdfdf$export$c37f199dbeef0d2c)();
    const filterKeywordToFilterActions = (0, $7bb4ea745ef14625$export$170a7ded78a9d477)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const { setQuickFindQuery: setQuickFindQuery, deleteSelectedQueryFilter: deleteSelectedQueryFilter, setCurrentQueryFilter: setCurrentQueryFilter } = (0, $4VmlX.useQuickFindActions)();
    const [debouncedSetLookupInput, cancelDebouncedSetLookupInput] = (0, $lvsjl.default)($908389ef2c25a547$var$_temp, 300);
    let t0;
    let t1;
    if ($[0] !== localQuery || $[1] !== setQuickFindQuery) {
        t0 = ()=>{
            if ((0, $dh538.fg)("keep_filter_values_in_quick_find_input")) {
                const trimmedQuery = localQuery.trim();
                setQuickFindQuery(trimmedQuery);
            }
        };
        t1 = [
            localQuery,
            setQuickFindQuery
        ];
        $[0] = localQuery;
        $[1] = setQuickFindQuery;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    let t3;
    if ($[4] !== localQuery || $[5] !== selectedQueryFilters || $[6] !== setQuickFindQuery) {
        t2 = ()=>{
            if ((0, $dh538.fg)("keep_filter_values_in_quick_find_input")) return;
            const queryWithoutSelectedQueryFilters = (0, $b62359973626d8df$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
            const trimmedQuery_0 = queryWithoutSelectedQueryFilters.trim();
            setQuickFindQuery(trimmedQuery_0);
        };
        t3 = [
            localQuery,
            selectedQueryFilters,
            setQuickFindQuery
        ];
        $[4] = localQuery;
        $[5] = selectedQueryFilters;
        $[6] = setQuickFindQuery;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[9] !== cancelDebouncedSetLookupInput || $[10] !== debouncedSetLookupInput || $[11] !== deleteSelectedQueryFilter || $[12] !== filterKeywordToFilterActions || $[13] !== filterKeywordToFilterId || $[14] !== localQuery || $[15] !== postQueryDisabled || $[16] !== selectedQueryFilters || $[17] !== setCurrentQueryFilter) {
        t4 = ()=>{
            if (postQueryDisabled) return;
            for (const selectedQueryFilter of selectedQueryFilters)if (!localQuery.includes(selectedQueryFilter.displayText)) {
                const filterActions = filterKeywordToFilterActions[selectedQueryFilter.keyword];
                if (filterActions && selectedQueryFilter.option) {
                    filterActions.setOption({
                        ...selectedQueryFilter.option,
                        isSelected: true
                    });
                    deleteSelectedQueryFilter(selectedQueryFilter);
                }
            }
            const queryWithoutSelectedQueryFilters_0 = (0, $b62359973626d8df$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
            const filterKeywords = Object.keys(filterKeywordToFilterId);
            const keyword = (0, $d9b673a251b22a41$export$a47046b35fa42e2d)(queryWithoutSelectedQueryFilters_0, filterKeywords);
            if (!keyword) {
                cancelDebouncedSetLookupInput();
                setCurrentQueryFilter(undefined);
                return;
            }
            const filterId = filterKeywordToFilterId[keyword];
            const filterActions_0 = filterKeywordToFilterActions[keyword];
            const filterLookupQuery = (0, $227cd3f86459a089$export$3141a593bcb9212f)(queryWithoutSelectedQueryFilters_0, keyword);
            if (filterId && filterActions_0 && filterLookupQuery !== undefined) {
                setCurrentQueryFilter({
                    filterId: filterId,
                    keyword: keyword
                });
                cancelDebouncedSetLookupInput();
                if (filterLookupQuery === "") {
                    filterActions_0.loadInitialOptions();
                    filterActions_0.setLookupInput("");
                } else debouncedSetLookupInput(filterLookupQuery, filterActions_0.setLookupInput);
            }
        };
        t5 = [
            selectedQueryFilters,
            filterKeywordToFilterId,
            filterKeywordToFilterActions,
            deleteSelectedQueryFilter,
            setCurrentQueryFilter,
            localQuery,
            cancelDebouncedSetLookupInput,
            debouncedSetLookupInput,
            postQueryDisabled
        ];
        $[9] = cancelDebouncedSetLookupInput;
        $[10] = debouncedSetLookupInput;
        $[11] = deleteSelectedQueryFilter;
        $[12] = filterKeywordToFilterActions;
        $[13] = filterKeywordToFilterId;
        $[14] = localQuery;
        $[15] = postQueryDisabled;
        $[16] = selectedQueryFilters;
        $[17] = setCurrentQueryFilter;
        $[18] = t4;
        $[19] = t5;
    } else {
        t4 = $[18];
        t5 = $[19];
    }
    (0, $42omo.useEffect)(t4, t5);
} : (localQuery, postQueryDisabled)=>{
    const filterKeywordToFilterId = (0, $7bee4fe2094cdfdf$export$c37f199dbeef0d2c)();
    const filterKeywordToFilterActions = (0, $7bb4ea745ef14625$export$170a7ded78a9d477)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const { setQuickFindQuery: setQuickFindQuery, deleteSelectedQueryFilter: deleteSelectedQueryFilter, setCurrentQueryFilter: setCurrentQueryFilter } = (0, $4VmlX.useQuickFindActions)();
    const [debouncedSetLookupInput, cancelDebouncedSetLookupInput] = (0, $lvsjl.default)((lookupInput, setLookupInput)=>{
        setLookupInput(lookupInput);
    }, 300);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('keep_filter_values_in_quick_find_input')) {
            const trimmedQuery = localQuery.trim();
            setQuickFindQuery(trimmedQuery);
        }
    }, [
        localQuery,
        setQuickFindQuery
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('keep_filter_values_in_quick_find_input')) return;
        const queryWithoutSelectedQueryFilters = (0, $b62359973626d8df$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
        const trimmedQuery_0 = queryWithoutSelectedQueryFilters.trim();
        setQuickFindQuery(trimmedQuery_0);
    }, [
        localQuery,
        selectedQueryFilters,
        setQuickFindQuery
    ]);
    (0, $42omo.useEffect)(()=>{
        if (postQueryDisabled) return;
        // Deselect select query filters if their display text is no longer in the query
        for (const selectedQueryFilter of selectedQueryFilters)if (!localQuery.includes(selectedQueryFilter.displayText)) {
            const filterActions = filterKeywordToFilterActions[selectedQueryFilter.keyword];
            if (filterActions && selectedQueryFilter.option) {
                filterActions.setOption({
                    ...selectedQueryFilter.option,
                    isSelected: true
                });
                deleteSelectedQueryFilter(selectedQueryFilter);
            }
        }
        // To determine if a user is accessing a query filter, we use the query without
        // selected query filters to allow for multiple query filters to be used at once
        const queryWithoutSelectedQueryFilters_0 = (0, $b62359973626d8df$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
        // Determine if the user is using a query filter
        const filterKeywords = Object.keys(filterKeywordToFilterId);
        const keyword = (0, $d9b673a251b22a41$export$a47046b35fa42e2d)(queryWithoutSelectedQueryFilters_0, filterKeywords);
        // Reset current query filter if keyword is not found
        if (!keyword) {
            cancelDebouncedSetLookupInput();
            setCurrentQueryFilter(undefined);
            return;
        }
        // Get the filter id and actioins for the filter corresponding to the keyword
        const filterId = filterKeywordToFilterId[keyword];
        const filterActions_0 = filterKeywordToFilterActions[keyword];
        const filterLookupQuery = (0, $227cd3f86459a089$export$3141a593bcb9212f)(queryWithoutSelectedQueryFilters_0, keyword);
        // Load the options for the filter
        if (filterId && filterActions_0 && filterLookupQuery !== undefined) {
            setCurrentQueryFilter({
                filterId: filterId,
                keyword: keyword
            });
            cancelDebouncedSetLookupInput();
            if (filterLookupQuery === '') {
                filterActions_0.loadInitialOptions();
                filterActions_0.setLookupInput('');
            } else debouncedSetLookupInput(filterLookupQuery, filterActions_0.setLookupInput);
        }
    }, [
        selectedQueryFilters,
        filterKeywordToFilterId,
        filterKeywordToFilterActions,
        deleteSelectedQueryFilter,
        setCurrentQueryFilter,
        localQuery,
        cancelDebouncedSetLookupInput,
        debouncedSetLookupInput,
        postQueryDisabled
    ]);
};
function $908389ef2c25a547$var$_temp(lookupInput, setLookupInput) {
    setLookupInput(lookupInput);
}

















const $4af3204510a58241$export$db28d8e16fb16e80 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'entered',
        actionSubject: 'text',
        actionSubjectId: 'searchDialogTextField',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });











const $9fa79de2eb008d7c$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME = 300;
const $9fa79de2eb008d7c$export$fe11394d33dcb3dd = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    let t0;
    if ($[0] !== commonAttributes || $[1] !== fireAnalyticsEvent || $[2] !== nonPrivacySafeAttributes || $[3] !== quickFindOpen) {
        t0 = ()=>{
            if (!quickFindOpen) return;
            fireAnalyticsEvent((0, $4af3204510a58241$export$db28d8e16fb16e80)({
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        $[0] = commonAttributes;
        $[1] = fireAnalyticsEvent;
        $[2] = nonPrivacySafeAttributes;
        $[3] = quickFindOpen;
        $[4] = t0;
    } else t0 = $[4];
    const fireOnTextEnteredAnalyticsCallback = t0;
    return (0, $JQd0k.useDebouncedCallback)(fireOnTextEnteredAnalyticsCallback, $9fa79de2eb008d7c$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME);
} : ()=>{
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const fireOnTextEnteredAnalyticsCallback = (0, $42omo.useCallback)(()=>{
        if (!quickFindOpen) return;
        fireAnalyticsEvent((0, $4af3204510a58241$export$db28d8e16fb16e80)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        quickFindOpen
    ]);
    return (0, $JQd0k.useDebouncedCallback)(fireOnTextEnteredAnalyticsCallback, $9fa79de2eb008d7c$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME);
};
// Matches `<Link prefetch="hover">` PREFETCH_DELAY in react-resource-router.
const $9fa79de2eb008d7c$var$PREFETCH_DEBOUNCE_TIME = 225;
const $9fa79de2eb008d7c$var$PREFETCH_MIN_QUERY_LENGTH = 2;
const $9fa79de2eb008d7c$export$79486f10508cab81 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { onPrefetch: onPrefetch, getQuery: getQuery, getUrls: getUrls } = t0;
    let t1;
    if ($[0] !== getQuery || $[1] !== getUrls || $[2] !== onPrefetch) {
        t1 = ()=>{
            if (!onPrefetch || !(0, $dh538.fg)("quick_find_typing_debounce_prefetch")) return;
            const trimmed = getQuery().trim();
            if (trimmed.length < $9fa79de2eb008d7c$var$PREFETCH_MIN_QUERY_LENGTH) return;
            for (const url of getUrls(trimmed))if (url) onPrefetch(url);
        };
        $[0] = getQuery;
        $[1] = getUrls;
        $[2] = onPrefetch;
        $[3] = t1;
    } else t1 = $[3];
    const fire = t1;
    const [debouncedPrefetch, cancelDebouncedPrefetch] = (0, $lvsjl.default)(fire, $9fa79de2eb008d7c$var$PREFETCH_DEBOUNCE_TIME);
    let t2;
    if ($[4] !== cancelDebouncedPrefetch || $[5] !== debouncedPrefetch) {
        t2 = [
            debouncedPrefetch,
            cancelDebouncedPrefetch
        ];
        $[4] = cancelDebouncedPrefetch;
        $[5] = debouncedPrefetch;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ onPrefetch: onPrefetch, getQuery: getQuery, getUrls: getUrls })=>{
    const fire = (0, $42omo.useCallback)(()=>{
        if (!onPrefetch || !(0, $dh538.fg)('quick_find_typing_debounce_prefetch')) return;
        const trimmed = getQuery().trim();
        if (trimmed.length < $9fa79de2eb008d7c$var$PREFETCH_MIN_QUERY_LENGTH) return;
        for (const url of getUrls(trimmed))if (url) onPrefetch(url);
    }, [
        onPrefetch,
        getQuery,
        getUrls
    ]);
    // Uses `use-debounce` rather than the package's lodash `useDebouncedCallback`
    // (used above for analytics) because it auto-cancels on unmount and is
    // controllable by jest fake timers; we expose its callback + cancel.
    const [debouncedPrefetch, cancelDebouncedPrefetch] = (0, $lvsjl.default)(fire, $9fa79de2eb008d7c$var$PREFETCH_DEBOUNCE_TIME);
    return [
        debouncedPrefetch,
        cancelDebouncedPrefetch
    ];
};


const $33671f0d02952dbc$export$fb8d8fbc0c4c1705 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(139);
    const { dialogId: dialogId, inputRef: inputRef, localQuery: localQuery, setLocalQuery: setLocalQuery, textfieldComponent: textfieldComponent, postQueryDisabled: postQueryDisabled, customPlaceholder: customPlaceholder, onGhostTextGenerated: onGhostTextGenerated, intentRouterEnabled: intentRouterEnabled, onPrefetch: onPrefetch } = t0;
    const previousTextQueryParam = (0, $42omo.useRef)();
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams, isNav4Enabled: isNav4Enabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $7WbA8.useAppContext)();
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [user] = (0, $j4ply.useUser)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const products = (0, $j4ply.useAvailableProducts)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const keyboardHighlight = (0, $icqFF.useKeyboardHighlightProvider)();
    const getSelectedIndex = keyboardHighlight?.getSelectedIndex;
    const keyboardNavComponents = keyboardHighlight?.keyboardNavComponents;
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    let t1;
    if ($[0] !== getSelectedIndex) {
        t1 = getSelectedIndex?.();
        $[0] = getSelectedIndex;
        $[1] = t1;
    } else t1 = $[1];
    const [selectedIndex, setSelectedIndex] = (0, $42omo.useState)(t1);
    let t2;
    bb0: {
        if (selectedIndex === undefined || !keyboardNavComponents) {
            t2 = undefined;
            break bb0;
        }
        const selectedComponent = keyboardNavComponents[selectedIndex];
        t2 = selectedComponent?.navigationTrackingId || undefined;
    }
    const activeDescendantId = t2;
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {};
        $[2] = t3;
    } else t3 = $[2];
    const { selectedFilters: t4 } = (0, $4VkIo.useSelectedFilters)(t3);
    const { jiraFilters: jiraFilters } = t4;
    const { setQuickFindOpen: setQuickFindOpen, resetSelectedQueryFilters: resetSelectedQueryFilters } = (0, $4VmlX.useQuickFindActions)();
    const { setQueryUpdatedTime: setQueryUpdatedTime, clearAllFilters: clearAllFilters, setInputQuery: setInputQuery } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const debouncedOnTextEnteredAnalyticsCallback = (0, $9fa79de2eb008d7c$export$fe11394d33dcb3dd)();
    let t5;
    if ($[3] !== inputRef) {
        t5 = ()=>inputRef?.current?.value ?? "";
        $[3] = inputRef;
        $[4] = t5;
    } else t5 = $[4];
    const t6 = t5;
    let t7;
    if ($[5] !== generateSearchUrl || $[6] !== jiraFilters || $[7] !== queryParams) {
        t7 = (query)=>{
            try {
                return (0, $3fzmz.getWorkItemPrefetchUrls)({
                    query: query,
                    jiraFilters: jiraFilters,
                    generateSearchUrl: generateSearchUrl,
                    queryParams: queryParams,
                    isQueryJql: (0, $4tgkZ.isJqlQueryDetected)(query)
                });
            } catch  {
                return [];
            }
        };
        $[5] = generateSearchUrl;
        $[6] = jiraFilters;
        $[7] = queryParams;
        $[8] = t7;
    } else t7 = $[8];
    const t8 = t7;
    let t9;
    if ($[9] !== onPrefetch || $[10] !== t6 || $[11] !== t8) {
        t9 = {
            onPrefetch: onPrefetch,
            getQuery: t6,
            getUrls: t8
        };
        $[9] = onPrefetch;
        $[10] = t6;
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    const [debouncedPrefetchCallback, cancelDebouncedPrefetchCallback] = (0, $9fa79de2eb008d7c$export$79486f10508cab81)(t9);
    const logException = (0, $f8oYd.useLogException)();
    const { abortTask: abortTask, isTaskActive: isTaskActive } = (0, $269ee6c4b9937e56$export$5b6291bff520e069)();
    const { abortTask: abortIntentDetectionTask, isTaskActive: isIntentDetectionTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    const isConfigLoaded = (0, $j4ply.useIsConfigLoaded)();
    let t10;
    if ($[13] !== locale || $[14] !== primaryProduct) {
        t10 = (0, $26jni.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false,
            locale: locale
        });
        $[13] = locale;
        $[14] = primaryProduct;
        $[15] = t10;
    } else t10 = $[15];
    const intentDetectionExperiment = t10;
    const intentDetectionCohort = intentDetectionExperiment?.cohort;
    let t11;
    if ($[16] !== inputRef || $[17] !== localQuery) {
        t11 = {
            localQuery: localQuery,
            inputRef: inputRef
        };
        $[16] = inputRef;
        $[17] = localQuery;
        $[18] = t11;
    } else t11 = $[18];
    (0, $2ok43.useInputSkeleton)(t11);
    const isConfluence = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence;
    let t12;
    if ($[19] !== isConfluence || $[20] !== thirdPartyConfigs) {
        t12 = isConfluence && (0, $123705605745917c$export$d41d96cbdaac172b)({
            thirdPartyConfigs: thirdPartyConfigs
        });
        $[19] = isConfluence;
        $[20] = thirdPartyConfigs;
        $[21] = t12;
    } else t12 = $[21];
    const serve3PGhostText = t12;
    let t13;
    if ($[22] !== customPlaceholder || $[23] !== isConfluence) {
        t13 = isConfluence ? (0, $6CCa2.parseGhostTextData)(customPlaceholder) : undefined;
        $[22] = customPlaceholder;
        $[23] = isConfluence;
        $[24] = t13;
    } else t13 = $[24];
    const existingGhostTextData = t13;
    const lastPersistedGhostTextRef = (0, $42omo.useRef)("{}");
    let t14;
    let t15;
    if ($[25] !== existingGhostTextData || $[26] !== formatMessage || $[27] !== isConfigLoaded || $[28] !== locale || $[29] !== onGhostTextGenerated || $[30] !== primaryProduct || $[31] !== products || $[32] !== serve3PGhostText || $[33] !== thirdPartyConfigs) {
        t14 = ()=>{
            if (!onGhostTextGenerated || !isConfigLoaded) return;
            const serialized = (0, $224a05be048f4a29$export$e1cd992f057eb389)({
                serve3PGhostText: serve3PGhostText,
                lastPersisted: lastPersistedGhostTextRef.current,
                products: products,
                thirdPartyConfigs: thirdPartyConfigs,
                locale: locale,
                primaryProduct: primaryProduct,
                formatMessage: formatMessage,
                existingGhostTextData: existingGhostTextData
            });
            if (serialized === null) return;
            lastPersistedGhostTextRef.current = serialized;
            onGhostTextGenerated(serialized);
        };
        t15 = [
            serve3PGhostText,
            products,
            thirdPartyConfigs,
            primaryProduct,
            formatMessage,
            existingGhostTextData,
            onGhostTextGenerated,
            isConfigLoaded,
            locale
        ];
        $[25] = existingGhostTextData;
        $[26] = formatMessage;
        $[27] = isConfigLoaded;
        $[28] = locale;
        $[29] = onGhostTextGenerated;
        $[30] = primaryProduct;
        $[31] = products;
        $[32] = serve3PGhostText;
        $[33] = thirdPartyConfigs;
        $[34] = t14;
        $[35] = t15;
    } else {
        t14 = $[34];
        t15 = $[35];
    }
    (0, $42omo.useEffect)(t14, t15);
    let t16;
    let t17;
    if ($[36] !== existingGhostTextData || $[37] !== fireAnalyticsEvent || $[38] !== serve3PGhostText) {
        t16 = ()=>{
            if (serve3PGhostText && existingGhostTextData) fireAnalyticsEvent((0, $936b3cff3811e499$export$f86bcd23f07f7d76)({
                attributes: {
                    id: existingGhostTextData.id,
                    locale: existingGhostTextData.locale,
                    customGhostText: existingGhostTextData.text
                }
            }));
        };
        t17 = [
            serve3PGhostText,
            existingGhostTextData,
            fireAnalyticsEvent
        ];
        $[36] = existingGhostTextData;
        $[37] = fireAnalyticsEvent;
        $[38] = serve3PGhostText;
        $[39] = t16;
        $[40] = t17;
    } else {
        t16 = $[39];
        t17 = $[40];
    }
    (0, $42omo.useEffect)(t16, t17);
    let t18;
    let t19;
    if ($[41] !== inputRef || $[42] !== setLocalQuery) {
        t18 = ()=>{
            if (inputRef?.current) {
                setLocalQuery(inputRef.current.value);
                const document = (0, $hTKp4.getDocument)();
                const isFocused = document && document.activeElement === inputRef.current;
                const selectionStart = isFocused ? inputRef.current.selectionStart : null;
                const selectionEnd = isFocused ? inputRef.current.selectionEnd : null;
                if (isFocused) requestAnimationFrame(()=>{
                    inputRef?.current?.focus();
                    if (selectionStart !== null && selectionEnd !== null) inputRef?.current?.setSelectionRange(selectionStart, selectionEnd);
                });
            }
        };
        t19 = [
            inputRef,
            setLocalQuery
        ];
        $[41] = inputRef;
        $[42] = setLocalQuery;
        $[43] = t18;
        $[44] = t19;
    } else {
        t18 = $[43];
        t19 = $[44];
    }
    (0, $42omo.useLayoutEffect)(t18, t19);
    (0, $908389ef2c25a547$export$d3538183feb90c1a)(localQuery, postQueryDisabled);
    let t20;
    let t21;
    if ($[45] !== clearAllFilters || $[46] !== localQuery || $[47] !== queryParams.text || $[48] !== resetSelectedQueryFilters || $[49] !== selectedQueryFilters || $[50] !== setInputQuery || $[51] !== setLocalQuery) {
        t20 = ()=>{
            const textParam = typeof queryParams.text === "string" ? queryParams.text : undefined;
            if (textParam === previousTextQueryParam.current) return;
            previousTextQueryParam.current = textParam;
            const localQueryWithoutSelectedQueryFilters = (0, $b62359973626d8df$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
            const newLocalQuery = typeof queryParams.text === "string" ? queryParams.text : "";
            if (localQueryWithoutSelectedQueryFilters !== newLocalQuery) {
                setInputQuery(newLocalQuery);
                setLocalQuery(newLocalQuery);
                clearAllFilters();
                resetSelectedQueryFilters();
            }
        };
        t21 = [
            clearAllFilters,
            queryParams.text,
            resetSelectedQueryFilters,
            selectedQueryFilters,
            setLocalQuery,
            localQuery,
            setInputQuery
        ];
        $[45] = clearAllFilters;
        $[46] = localQuery;
        $[47] = queryParams.text;
        $[48] = resetSelectedQueryFilters;
        $[49] = selectedQueryFilters;
        $[50] = setInputQuery;
        $[51] = setLocalQuery;
        $[52] = t20;
        $[53] = t21;
    } else {
        t20 = $[52];
        t21 = $[53];
    }
    (0, $42omo.useEffect)(t20, t21);
    let t22;
    if ($[54] !== setQueryUpdatedTime) {
        t22 = ()=>{
            setQueryUpdatedTime();
        };
        $[54] = setQueryUpdatedTime;
        $[55] = t22;
    } else t22 = $[55];
    let t23;
    if ($[56] !== localQuery || $[57] !== setQueryUpdatedTime) {
        t23 = [
            setQueryUpdatedTime,
            localQuery
        ];
        $[56] = localQuery;
        $[57] = setQueryUpdatedTime;
        $[58] = t23;
    } else t23 = $[58];
    (0, $42omo.useEffect)(t22, t23);
    let t24;
    let t25;
    if ($[59] !== inputRef || $[60] !== quickFindOpen) {
        t24 = ()=>{
            if (quickFindOpen) inputRef?.current?.focus();
            else inputRef?.current?.blur();
        };
        t25 = [
            inputRef,
            quickFindOpen
        ];
        $[59] = inputRef;
        $[60] = quickFindOpen;
        $[61] = t24;
        $[62] = t25;
    } else {
        t24 = $[61];
        t25 = $[62];
    }
    (0, $42omo.useEffect)(t24, t25);
    let t26;
    if ($[63] !== commonAttributes || $[64] !== fireAnalyticsEvent || $[65] !== localQuery.length || $[66] !== nonPrivacySafeAttributes || $[67] !== primaryProduct || $[68] !== quickFindOpen || $[69] !== setQuickFindOpen) {
        t26 = (event)=>{
            if (!quickFindOpen) {
                setQuickFindOpen(true);
                (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_OPEN_INTERACTION), event.timeStamp);
                (0, $cbc8g.addUFOCustomData)({
                    queryLength: localQuery.length
                });
                if (event.type === "click") fireAnalyticsEvent((0, $df50e1184d0554ef$export$5633d029795394f8)({
                    attributes: {
                        ...commonAttributes,
                        productKey: primaryProduct
                    },
                    nonPrivacySafeAttributes: nonPrivacySafeAttributes
                }));
            }
        };
        $[63] = commonAttributes;
        $[64] = fireAnalyticsEvent;
        $[65] = localQuery.length;
        $[66] = nonPrivacySafeAttributes;
        $[67] = primaryProduct;
        $[68] = quickFindOpen;
        $[69] = setQuickFindOpen;
        $[70] = t26;
    } else t26 = $[70];
    const openQuickFind = t26;
    let t27;
    if ($[71] !== abortIntentDetectionTask || $[72] !== applicationMode || $[73] !== clearAllFilters || $[74] !== commonAttributes || $[75] !== content?.state || $[76] !== fireAnalyticsEvent || $[77] !== generateSearchUrl || $[78] !== getSelectedIndex || $[79] !== intentDetectionCohort || $[80] !== intentRouterEnabled || $[81] !== isIntentDetectionTaskActive || $[82] !== jiraFilters || $[83] !== localQuery || $[84] !== logException || $[85] !== nonPrivacySafeAttributes || $[86] !== onNavigate || $[87] !== openQuickFind || $[88] !== primaryProduct || $[89] !== queryParams || $[90] !== quickFindOpen || $[91] !== quickFindQuery || $[92] !== selectedProduct || $[93] !== setQuickFindOpen || $[94] !== updateRecentQueries || $[95] !== user) {
        t27 = async (event_0)=>{
            if ((event_0.key === "ArrowDown" || event_0.key === "Enter") && !quickFindOpen) {
                openQuickFind(event_0);
                return;
            }
            const resultHighlighted = getSelectedIndex && getSelectedIndex() !== undefined;
            if (event_0.key === "Enter" && !resultHighlighted) {
                if (event_0.nativeEvent.isComposing) {
                    event_0.preventDefault();
                    return;
                }
                if (!primaryProduct) return;
                const submitQuery = (0, $dh538.fg)("quick_find_fix_query_desync") ? localQuery : quickFindQuery;
                event_0.stopPropagation();
                if (submitQuery.trim() !== "" && user && user.id && primaryProduct) {
                    (0, $1SV4e.addRecentSearch)({
                        value: quickFindQuery.trim(),
                        userId: user.id,
                        productId: primaryProduct,
                        key: (0, $1SV4e.RECENT_SEARCH_KEY)
                    });
                    updateRecentQueries?.();
                }
                event_0.currentTarget.blur();
                setQuickFindOpen(false);
                fireAnalyticsEvent((0, $b2e1078ac279219a$export$50f1b1860bee88e0)({
                    actionSubjectId: primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira ? "jiraAdvancedIssueSearch" : `${primaryProduct.toLowerCase()}AdvancedSearchLink`,
                    attributes: {
                        ...commonAttributes,
                        trigger: "return",
                        returnModified: event_0.metaKey || event_0.ctrlKey,
                        newTab: false,
                        isLoading: content?.state === (0, $aE5mL.State).PREQUERY_LOADING || content?.state === (0, $aE5mL.State).POSTQUERY_LOADING,
                        queryClassification: (0, $4tgkZ.INTENT_DETECTION).value()?.mode,
                        modelId: (0, $4tgkZ.INTENT_DETECTION).value()?.modelId,
                        wordCount: (0, $inrbX.getWordCount)(submitQuery),
                        cohort: intentDetectionCohort,
                        patternType: (0, $4tgkZ.INTENT_DETECTION).value()?.patternType
                    },
                    nonPrivacySafeAttributes: nonPrivacySafeAttributes
                }));
                clearAllFilters();
                (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event_0.timeStamp);
                const onNavigateCallback = typeof onNavigate === "function" ? onNavigate : onNavigate.callback;
                if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) {
                    const ctrlKey = event_0.metaKey || event_0.ctrlKey;
                    if (intentRouterEnabled) {
                        if (isIntentDetectionTaskActive()) abortIntentDetectionTask("search_submitted");
                        const intentDetection = (0, $4tgkZ.INTENT_DETECTION).value();
                        const url = intentDetection?.route || (0, $3fzmz.getWorkItemPageUrl)({
                            query: submitQuery,
                            jiraFilters: jiraFilters,
                            generateSearchUrl: generateSearchUrl,
                            queryParams: queryParams,
                            isQueryJql: (0, $4tgkZ.isJqlQueryDetected)(submitQuery)
                        });
                        onNavigateCallback(url, "push", event_0);
                        return;
                    }
                    const swapQuickFindCTAs = (0, $3a090af578c3c72f$export$1a414fdf8e9c6492)() && primaryProduct && primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)("jira_search_fps_cta_swap");
                    if (ctrlKey && !swapQuickFindCTAs || !ctrlKey && swapQuickFindCTAs) {
                        onNavigateCallback(generateSearchUrl({
                            ...queryParams,
                            text: submitQuery
                        }, false), "push", event_0);
                        return;
                    }
                    try {
                        const url_0 = (0, $3fzmz.getWorkItemPageUrl)({
                            query: submitQuery,
                            jiraFilters: jiraFilters,
                            generateSearchUrl: generateSearchUrl,
                            queryParams: queryParams,
                            isQueryJql: (0, $4tgkZ.isJqlQueryDetected)(submitQuery)
                        });
                        onNavigateCallback(url_0, "push", event_0);
                        return;
                    } catch (t28) {
                        const error = t28;
                        logException(error);
                    }
                }
                const searchForPrimaryProduct = !selectedProduct && (applicationMode === (0, $9vOy1.ApplicationModes).Rovo && (event_0.metaKey || event_0.ctrlKey) || applicationMode !== (0, $9vOy1.ApplicationModes).Rovo && !(event_0.metaKey || event_0.ctrlKey));
                onNavigateCallback(generateSearchUrl({
                    ...queryParams,
                    ...searchForPrimaryProduct ? {
                        product: primaryProduct
                    } : {},
                    text: submitQuery,
                    cql: undefined
                }, false), "push");
            }
            if (event_0.key === "Escape") {
                if (event_0.nativeEvent.isComposing) {
                    event_0.preventDefault();
                    return;
                }
                event_0.currentTarget.blur();
                setQuickFindOpen(false);
                (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event_0.timeStamp);
            }
            if (event_0.key === "ArrowDown" || event_0.key === "ArrowUp") setSelectedIndex(getSelectedIndex?.());
        };
        $[71] = abortIntentDetectionTask;
        $[72] = applicationMode;
        $[73] = clearAllFilters;
        $[74] = commonAttributes;
        $[75] = content?.state;
        $[76] = fireAnalyticsEvent;
        $[77] = generateSearchUrl;
        $[78] = getSelectedIndex;
        $[79] = intentDetectionCohort;
        $[80] = intentRouterEnabled;
        $[81] = isIntentDetectionTaskActive;
        $[82] = jiraFilters;
        $[83] = localQuery;
        $[84] = logException;
        $[85] = nonPrivacySafeAttributes;
        $[86] = onNavigate;
        $[87] = openQuickFind;
        $[88] = primaryProduct;
        $[89] = queryParams;
        $[90] = quickFindOpen;
        $[91] = quickFindQuery;
        $[92] = selectedProduct;
        $[93] = setQuickFindOpen;
        $[94] = updateRecentQueries;
        $[95] = user;
        $[96] = t27;
    } else t27 = $[96];
    content?.state;
    const onKeyDown = t27;
    let t28;
    if ($[97] !== debouncedOnTextEnteredAnalyticsCallback || $[98] !== debouncedPrefetchCallback || $[99] !== openQuickFind || $[100] !== quickFindOpen || $[101] !== setLocalQuery) {
        t28 = (event_1)=>{
            const newQuery = event_1.currentTarget.value;
            setLocalQuery(newQuery);
            debouncedOnTextEnteredAnalyticsCallback();
            debouncedPrefetchCallback();
            if (!quickFindOpen) openQuickFind(event_1);
        };
        $[97] = debouncedOnTextEnteredAnalyticsCallback;
        $[98] = debouncedPrefetchCallback;
        $[99] = openQuickFind;
        $[100] = quickFindOpen;
        $[101] = setLocalQuery;
        $[102] = t28;
    } else t28 = $[102];
    const onChange = t28;
    const onFocus = $33671f0d02952dbc$var$_temp;
    const Textfield = textfieldComponent || (0, $hr2Qv.Textfield);
    const [cloudId] = (0, $j4ply.useCloudId)();
    const smartLinkUsage = (0, $j4ply.useSmartLinkUsage)();
    let t29;
    if ($[103] !== abortIntentDetectionTask || $[104] !== abortTask || $[105] !== cancelDebouncedPrefetchCallback || $[106] !== commonAttributes || $[107] !== debouncedOnTextEnteredAnalyticsCallback || $[108] !== fireAnalyticsEvent || $[109] !== inputRef || $[110] !== isIntentDetectionTaskActive || $[111] !== isTaskActive || $[112] !== nonPrivacySafeAttributes || $[113] !== setLocalQuery) {
        t29 = ()=>{
            fireAnalyticsEvent((0, $fbbe843703a5fd8b$export$494a88615cfa0dd3)({
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            debouncedOnTextEnteredAnalyticsCallback.cancel();
            cancelDebouncedPrefetchCallback();
            if (isTaskActive()) abortTask("text_cleared");
            if (isIntentDetectionTaskActive()) abortIntentDetectionTask("text_cleared");
            setLocalQuery("");
            inputRef?.current?.focus();
        };
        $[103] = abortIntentDetectionTask;
        $[104] = abortTask;
        $[105] = cancelDebouncedPrefetchCallback;
        $[106] = commonAttributes;
        $[107] = debouncedOnTextEnteredAnalyticsCallback;
        $[108] = fireAnalyticsEvent;
        $[109] = inputRef;
        $[110] = isIntentDetectionTaskActive;
        $[111] = isTaskActive;
        $[112] = nonPrivacySafeAttributes;
        $[113] = setLocalQuery;
        $[114] = t29;
    } else t29 = $[114];
    let t30;
    if ($[115] !== commonAttributes || $[116] !== fireAnalyticsEvent || $[117] !== nonPrivacySafeAttributes) {
        t30 = ()=>{
            fireAnalyticsEvent((0, $095f50e31f589f5a$export$d56b70a75f0c16)({
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
        $[115] = commonAttributes;
        $[116] = fireAnalyticsEvent;
        $[117] = nonPrivacySafeAttributes;
        $[118] = t30;
    } else t30 = $[118];
    const t31 = existingGhostTextData?.text;
    let t32;
    if ($[119] !== Textfield || $[120] !== activeDescendantId || $[121] !== cloudId || $[122] !== dialogId || $[123] !== inputRef || $[124] !== intentRouterEnabled || $[125] !== isAdminHubAIEnabled || $[126] !== isNav4Enabled || $[127] !== localQuery || $[128] !== onChange || $[129] !== onKeyDown || $[130] !== openQuickFind || $[131] !== primaryProduct || $[132] !== quickFindOpen || $[133] !== smartLinkUsage || $[134] !== t29 || $[135] !== t30 || $[136] !== t31 || $[137] !== thirdPartyConfigs) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Textfield, {
            value: localQuery,
            dialogId: dialogId,
            inputRef: inputRef,
            quickFindOpen: quickFindOpen,
            isNav4Enabled: isNav4Enabled,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            intentRouterEnabled: intentRouterEnabled,
            activeDescendantId: activeDescendantId,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            onChange: onChange,
            onClick: openQuickFind,
            onClear: t29,
            onAppsClick: t30,
            placeholder: t31,
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            smartLinkUsage: smartLinkUsage,
            thirdPartyConfigs: thirdPartyConfigs
        });
        $[119] = Textfield;
        $[120] = activeDescendantId;
        $[121] = cloudId;
        $[122] = dialogId;
        $[123] = inputRef;
        $[124] = intentRouterEnabled;
        $[125] = isAdminHubAIEnabled;
        $[126] = isNav4Enabled;
        $[127] = localQuery;
        $[128] = onChange;
        $[129] = onKeyDown;
        $[130] = openQuickFind;
        $[131] = primaryProduct;
        $[132] = quickFindOpen;
        $[133] = smartLinkUsage;
        $[134] = t29;
        $[135] = t30;
        $[136] = t31;
        $[137] = thirdPartyConfigs;
        $[138] = t32;
    } else t32 = $[138];
    return t32;
} : ({ dialogId: dialogId, inputRef: inputRef, localQuery: localQuery, setLocalQuery: setLocalQuery, textfieldComponent: textfieldComponent, postQueryDisabled: postQueryDisabled, customPlaceholder: customPlaceholder, onGhostTextGenerated: onGhostTextGenerated, intentRouterEnabled: intentRouterEnabled, onPrefetch: onPrefetch })=>{
    const previousTextQueryParam = (0, $42omo.useRef)();
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams, isNav4Enabled: isNav4Enabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $7WbA8.useAppContext)();
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [user] = (0, $j4ply.useUser)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const products = (0, $j4ply.useAvailableProducts)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    // Do not deconstruct useKeyboardHighlightProvider as it causes the SSR to fail
    const keyboardHighlight = (0, $icqFF.useKeyboardHighlightProvider)();
    const getSelectedIndex = keyboardHighlight?.getSelectedIndex;
    const keyboardNavComponents = keyboardHighlight?.keyboardNavComponents;
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const [selectedIndex, setSelectedIndex] = (0, $42omo.useState)(getSelectedIndex?.());
    // Compute the activeDescendantId for aria-activedescendant
    const activeDescendantId = (0, $42omo.useMemo)(()=>{
        if (selectedIndex === undefined || !keyboardNavComponents) return undefined;
        const selectedComponent = keyboardNavComponents[selectedIndex];
        return selectedComponent?.navigationTrackingId || undefined;
    }, [
        selectedIndex,
        keyboardNavComponents
    ]);
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { selectedFilters: { jiraFilters: jiraFilters } } = (0, $4VkIo.useSelectedFilters)({});
    const { setQuickFindOpen: setQuickFindOpen, resetSelectedQueryFilters: resetSelectedQueryFilters } = (0, $4VmlX.useQuickFindActions)();
    const { setQueryUpdatedTime: setQueryUpdatedTime, clearAllFilters: clearAllFilters, setInputQuery: setInputQuery } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const debouncedOnTextEnteredAnalyticsCallback = (0, $9fa79de2eb008d7c$export$fe11394d33dcb3dd)();
    const [debouncedPrefetchCallback, cancelDebouncedPrefetchCallback] = (0, $9fa79de2eb008d7c$export$79486f10508cab81)({
        onPrefetch: onPrefetch,
        getQuery: (0, $42omo.useCallback)(()=>inputRef?.current?.value ?? '', [
            inputRef
        ]),
        getUrls: (0, $42omo.useCallback)((query)=>{
            try {
                return (0, $3fzmz.getWorkItemPrefetchUrls)({
                    query: query,
                    jiraFilters: jiraFilters,
                    generateSearchUrl: generateSearchUrl,
                    queryParams: queryParams,
                    isQueryJql: (0, $4tgkZ.isJqlQueryDetected)(query)
                });
            } catch  {
                return [];
            }
        }, [
            jiraFilters,
            generateSearchUrl,
            queryParams
        ])
    });
    const logException = (0, $f8oYd.useLogException)();
    const { abortTask: abortTask, isTaskActive: isTaskActive } = (0, $269ee6c4b9937e56$export$5b6291bff520e069)();
    const { abortTask: abortIntentDetectionTask, isTaskActive: isIntentDetectionTaskActive } = (0, $531c3f35638ca54a$export$8edca358485a7f22)();
    const isConfigLoaded = (0, $j4ply.useIsConfigLoaded)();
    const intentDetectionExperiment = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: locale
    });
    const intentDetectionCohort = intentDetectionExperiment?.cohort;
    (0, $2ok43.useInputSkeleton)({
        localQuery: localQuery,
        inputRef: inputRef
    });
    // Ghost text is scoped to Confluence only. This replaces the `quickfind-ghosttext` feature gate,
    // which was only ever enabled for Confluence.
    const isConfluence = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence;
    const serve3PGhostText = (0, $42omo.useMemo)(()=>isConfluence && (0, $123705605745917c$export$d41d96cbdaac172b)({
            thirdPartyConfigs: thirdPartyConfigs
        }), [
        isConfluence,
        thirdPartyConfigs
    ]);
    const existingGhostTextData = (0, $42omo.useMemo)(()=>isConfluence ? (0, $6CCa2.parseGhostTextData)(customPlaceholder) : undefined, [
        isConfluence,
        customPlaceholder
    ]);
    // Track last persisted ghost text to prevent overwriting valid data with empty
    const lastPersistedGhostTextRef = (0, $42omo.useRef)('{}');
    (0, $42omo.useEffect)(()=>{
        if (!onGhostTextGenerated || !isConfigLoaded) return;
        const serialized = (0, $224a05be048f4a29$export$e1cd992f057eb389)({
            serve3PGhostText: serve3PGhostText,
            lastPersisted: lastPersistedGhostTextRef.current,
            products: products,
            thirdPartyConfigs: thirdPartyConfigs,
            locale: locale,
            primaryProduct: primaryProduct,
            formatMessage: formatMessage,
            existingGhostTextData: existingGhostTextData
        });
        if (serialized === null) return;
        lastPersistedGhostTextRef.current = serialized;
        onGhostTextGenerated(serialized);
    }, [
        serve3PGhostText,
        products,
        thirdPartyConfigs,
        primaryProduct,
        formatMessage,
        existingGhostTextData,
        onGhostTextGenerated,
        isConfigLoaded,
        locale
    ]);
    (0, $42omo.useEffect)(()=>{
        if (serve3PGhostText && existingGhostTextData) fireAnalyticsEvent((0, $936b3cff3811e499$export$f86bcd23f07f7d76)({
            attributes: {
                id: existingGhostTextData.id,
                locale: existingGhostTextData.locale,
                customGhostText: existingGhostTextData.text
            }
        }));
    }, [
        serve3PGhostText,
        existingGhostTextData,
        fireAnalyticsEvent
    ]);
    /**
   * When Quick Find is SSR'd, users may type into the input before the
   * React component is mounted. Given that useLayoutEffect is called before
   * the first browser paint but after the input ref is set, this essentially
   * initialises the React component with the input's state prior to hydration.
   * - Input in the DOM element is reflected in localQuery
   * - Focus state is preserved as hydration causes the input to lose focus
   *
   * It should be noted that re-renders caused state by updates in useLayoutEffect
   * are synchronous, i.e. occurs before the paint, hence this is TTVC friendly.
   *
   * When this component is not SSR'd, this effectively does nothing.
   */ (0, $42omo.useLayoutEffect)(()=>{
        if (inputRef?.current) {
            setLocalQuery(inputRef.current.value);
            const document = (0, $hTKp4.getDocument)();
            const isFocused = document && document.activeElement === inputRef.current;
            const selectionStart = isFocused ? inputRef.current.selectionStart : null;
            const selectionEnd = isFocused ? inputRef.current.selectionEnd : null;
            if (isFocused) requestAnimationFrame(()=>{
                inputRef?.current?.focus();
                if (selectionStart !== null && selectionEnd !== null) inputRef?.current?.setSelectionRange(selectionStart, selectionEnd);
            });
        }
    }, [
        inputRef,
        setLocalQuery
    ]);
    (0, $908389ef2c25a547$export$d3538183feb90c1a)(localQuery, postQueryDisabled);
    // Only when the text query param changes, update the local query. If the
    // local query without selected query filters is the same as text query param,
    // do nothing.
    (0, $42omo.useEffect)(()=>{
        const textParam = typeof queryParams.text === 'string' ? queryParams.text : undefined;
        if (textParam === previousTextQueryParam.current) return;
        previousTextQueryParam.current = textParam;
        const localQueryWithoutSelectedQueryFilters = (0, $b62359973626d8df$export$f0a1ecf34ab38b2d)(localQuery, selectedQueryFilters);
        const newLocalQuery = typeof queryParams.text === 'string' ? queryParams.text : '';
        if (localQueryWithoutSelectedQueryFilters !== newLocalQuery) {
            setInputQuery(newLocalQuery);
            setLocalQuery(newLocalQuery);
            clearAllFilters();
            resetSelectedQueryFilters();
        }
    }, [
        clearAllFilters,
        queryParams.text,
        resetSelectedQueryFilters,
        selectedQueryFilters,
        setLocalQuery,
        localQuery,
        setInputQuery
    ]);
    // Update query time when query changes
    (0, $42omo.useEffect)(()=>{
        setQueryUpdatedTime();
    }, [
        setQueryUpdatedTime,
        localQuery
    ]);
    (0, $42omo.useEffect)(()=>{
        if (quickFindOpen) inputRef?.current?.focus();
        else inputRef?.current?.blur();
    }, [
        inputRef,
        quickFindOpen
    ]);
    const openQuickFind = (0, $42omo.useCallback)((event)=>{
        if (!quickFindOpen) {
            setQuickFindOpen(true);
            (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_OPEN_INTERACTION), event.timeStamp);
            (0, $cbc8g.addUFOCustomData)({
                queryLength: localQuery.length
            });
            if (event.type === 'click') fireAnalyticsEvent((0, $df50e1184d0554ef$export$5633d029795394f8)({
                attributes: {
                    ...commonAttributes,
                    productKey: primaryProduct
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        }
    }, [
        localQuery.length,
        setQuickFindOpen,
        quickFindOpen,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        primaryProduct
    ]);
    const onKeyDown = (0, $42omo.useCallback)(async (event_0)=>{
        // ArrowDown, Enter and Space keys on input should open the dialog so keyboard users can access results.
        if ((event_0.key === 'ArrowDown' || event_0.key === 'Enter') && !quickFindOpen) {
            openQuickFind(event_0);
            return;
        }
        /**
     * Ignore enter key press if a search result is highlighted as we let
     * the keyboard highlight provider handle the event in this case.
     */ const resultHighlighted = getSelectedIndex && getSelectedIndex() !== undefined;
        if (event_0.key === 'Enter' && !resultHighlighted) {
            /**
       * Prevent IME composition from submitting the search
       */ if (event_0.nativeEvent.isComposing) {
                event_0.preventDefault();
                return;
            }
            if (!primaryProduct) return;
            /**
       * Use localQuery instead of quickFind query for keydown events
       * to prevent desync between what's shown in the input and what's
       * actually used in the callback here.
       */ const submitQuery = (0, $dh538.fg)('quick_find_fix_query_desync') ? localQuery : quickFindQuery;
            /**
       * Stop the event from propagating to prevent UFO
       * VC90 metric from being cancelled on route change.
       */ event_0.stopPropagation();
            // Store search in recent searches
            if (submitQuery.trim() !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)({
                    value: quickFindQuery.trim(),
                    userId: user.id,
                    productId: primaryProduct,
                    key: (0, $1SV4e.RECENT_SEARCH_KEY)
                });
                updateRecentQueries?.();
            }
            event_0.currentTarget.blur();
            setQuickFindOpen(false);
            fireAnalyticsEvent((0, $b2e1078ac279219a$export$50f1b1860bee88e0)({
                actionSubjectId: primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira ? 'jiraAdvancedIssueSearch' : `${primaryProduct.toLowerCase()}AdvancedSearchLink`,
                attributes: {
                    ...commonAttributes,
                    trigger: 'return',
                    returnModified: event_0.metaKey || event_0.ctrlKey,
                    newTab: false,
                    isLoading: content?.state === (0, $aE5mL.State).PREQUERY_LOADING || content?.state === (0, $aE5mL.State).POSTQUERY_LOADING,
                    queryClassification: (0, $4tgkZ.INTENT_DETECTION).value()?.mode,
                    modelId: (0, $4tgkZ.INTENT_DETECTION).value()?.modelId,
                    wordCount: (0, $inrbX.getWordCount)(submitQuery),
                    cohort: intentDetectionCohort,
                    patternType: (0, $4tgkZ.INTENT_DETECTION).value()?.patternType
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            // Executing a search query on FPS search will always clear the filters in QF as FPS filters
            // is the source of truth for filter state.
            clearAllFilters();
            (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event_0.timeStamp);
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) {
                const ctrlKey = event_0.metaKey || event_0.ctrlKey;
                // Intent detection is ongitly enabled if the experiment is enabled
                if (intentRouterEnabled) {
                    // VitalStats: Abort intent detection UX task if user submits search
                    if (isIntentDetectionTaskActive()) abortIntentDetectionTask('search_submitted');
                    const intentDetection = (0, $4tgkZ.INTENT_DETECTION).value();
                    const url = intentDetection?.route || (0, $3fzmz.getWorkItemPageUrl)({
                        query: submitQuery,
                        jiraFilters: jiraFilters,
                        generateSearchUrl: generateSearchUrl,
                        queryParams: queryParams,
                        isQueryJql: (0, $4tgkZ.isJqlQueryDetected)(submitQuery)
                    });
                    onNavigateCallback(url, 'push', event_0);
                    return;
                }
                // Ctrl + Enter
                // On Jira Full Page Search, Ctrl + Enter = Go to NIN
                // On other products, Ctrl + Enter = Go to FPS
                const swapQuickFindCTAs = (0, $3a090af578c3c72f$export$1a414fdf8e9c6492)() && primaryProduct && primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_search_fps_cta_swap');
                if (ctrlKey && !swapQuickFindCTAs || !ctrlKey && swapQuickFindCTAs) {
                    onNavigateCallback(generateSearchUrl({
                        ...queryParams,
                        text: submitQuery
                    }, false // This is still Confluence, so won't be a secondary link
                    ), 'push', event_0);
                    return;
                }
                try {
                    const url_0 = (0, $3fzmz.getWorkItemPageUrl)({
                        query: submitQuery,
                        jiraFilters: jiraFilters,
                        generateSearchUrl: generateSearchUrl,
                        queryParams: queryParams,
                        isQueryJql: (0, $4tgkZ.isJqlQueryDetected)(submitQuery)
                    });
                    onNavigateCallback(url_0, 'push', event_0);
                    return;
                } catch (error) {
                    // If network or runtime errors occcur, follow the default redirection behaviour.
                    logException(error);
                }
            }
            const searchForPrimaryProduct = !selectedProduct && (applicationMode === (0, $9vOy1.ApplicationModes).Rovo && (event_0.metaKey || event_0.ctrlKey) || applicationMode !== (0, $9vOy1.ApplicationModes).Rovo && !(event_0.metaKey || event_0.ctrlKey));
            onNavigateCallback(generateSearchUrl({
                ...queryParams,
                ...searchForPrimaryProduct ? {
                    product: primaryProduct
                } : {},
                text: submitQuery,
                cql: undefined // Clear CQL parameter when performing a regular search
            }, false), 'push');
        }
        if (event_0.key === 'Escape') {
            /**
       * Prevent IME composition from closing the quick find
       */ if (event_0.nativeEvent.isComposing) {
                event_0.preventDefault();
                return;
            }
            event_0.currentTarget.blur();
            setQuickFindOpen(false);
            (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event_0.timeStamp);
        }
        // if arrow keys, then update the selected index
        if (event_0.key === 'ArrowDown' || event_0.key === 'ArrowUp') setSelectedIndex(getSelectedIndex?.());
    }, [
        getSelectedIndex,
        primaryProduct,
        quickFindQuery,
        localQuery,
        user,
        setQuickFindOpen,
        fireAnalyticsEvent,
        commonAttributes,
        content?.state,
        nonPrivacySafeAttributes,
        selectedProduct,
        applicationMode,
        clearAllFilters,
        onNavigate,
        generateSearchUrl,
        queryParams,
        updateRecentQueries,
        jiraFilters,
        logException,
        intentRouterEnabled,
        isIntentDetectionTaskActive,
        abortIntentDetectionTask,
        quickFindOpen,
        openQuickFind,
        intentDetectionCohort
    ]);
    const onChange = (0, $42omo.useCallback)((event_1)=>{
        const newQuery = event_1.currentTarget.value;
        setLocalQuery(newQuery);
        debouncedOnTextEnteredAnalyticsCallback();
        debouncedPrefetchCallback();
        if (!quickFindOpen) // open quick find when input is focused by quick find is not opened
        openQuickFind(event_1);
    }, [
        debouncedOnTextEnteredAnalyticsCallback,
        debouncedPrefetchCallback,
        setLocalQuery,
        quickFindOpen,
        openQuickFind
    ]);
    const onFocus = (0, $42omo.useCallback)((_event)=>{
    // Don't do anything on focus
    }, []);
    const Textfield = textfieldComponent || (0, $hr2Qv.Textfield);
    const [cloudId] = (0, $j4ply.useCloudId)();
    const smartLinkUsage = (0, $j4ply.useSmartLinkUsage)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Textfield, {
        value: localQuery,
        dialogId: dialogId,
        inputRef: inputRef,
        quickFindOpen: quickFindOpen,
        isNav4Enabled: isNav4Enabled,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        intentRouterEnabled: intentRouterEnabled,
        activeDescendantId: activeDescendantId,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onChange: onChange,
        onClick: openQuickFind,
        onClear: ()=>{
            fireAnalyticsEvent((0, $fbbe843703a5fd8b$export$494a88615cfa0dd3)({
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            // Cancel pending debounced callbacks
            debouncedOnTextEnteredAnalyticsCallback.cancel();
            cancelDebouncedPrefetchCallback();
            // Abort task if active when user clicks clear button
            // Note: We don't wrap in startTransition here because abortTask needs to
            // update state synchronously to prevent race conditions with new queries
            if (isTaskActive()) abortTask('text_cleared');
            // VitalStats: Abort intent detection UX task if user clears text
            if (isIntentDetectionTaskActive()) abortIntentDetectionTask('text_cleared');
            setLocalQuery('');
            inputRef?.current?.focus();
        },
        onAppsClick: ()=>{
            fireAnalyticsEvent((0, $095f50e31f589f5a$export$d56b70a75f0c16)({
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        },
        placeholder: existingGhostTextData?.text,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        smartLinkUsage: smartLinkUsage,
        thirdPartyConfigs: thirdPartyConfigs
    });
};
function $33671f0d02952dbc$var$_temp(_event) {}












/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 












var $4cq9O = parcelRequire("4cq9O");





var $7yVTH = parcelRequire("7yVTH");

/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/right-panel/__generated__/rightPanelAsyncQuery.graphql.ts
 */ const $032df212fe100589$export$b93f8325f362c8e2 = '544db1c2c21fb97d410a3ea7a4f85a8695606636eb356dba2c43c66119e3b686';
const $032df212fe100589$export$d879c693c9d5dd1d = 'rightPanelAsyncQuery';


/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/search-results/__generated__/searchResultsAsyncQuery.graphql.ts
 */ const $34fbce75abc033a7$export$d2f5eaa391338206 = '039845b689db09a284535ba401da3fa482af2c543a0917e768c256c4aefd9050';
const $34fbce75abc033a7$export$ba2c557d27f18b1d = 'searchResultsAsyncQuery';






var $gbTNF = parcelRequire("gbTNF");





var $5w7WU = parcelRequire("5w7WU");

/*
 * Not required: all callbacks happen after the fetch.
 */ const $c347e097eb83249d$var$noopCallbacks = {
    setIntentData: ()=>{},
    setQueryIntent: ()=>{},
    setTransformedQuery: ()=>{},
    setRequestId: ()=>{},
    setTraceId: ()=>{}
};
const $c347e097eb83249d$export$840abf07587d206 = (args)=>{
    (0, $5w7WU.getQueryIntent)({
        ...args,
        ...$c347e097eb83249d$var$noopCallbacks
    });
};





const $576e5b0ff900a391$export$d1be7f2304606f8e = ({ persistedId: persistedId, operationName: operationName, queryVariables: queryVariables, edgeRegionHint: edgeRegionHint, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return fetch(`${aggAbsoluteUrl}/pq/${persistedId}?operation=${operationName}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...edgeRegionHint ? {
                [(0, $chwej.EDGE_REGION_HINT_HEADER)]: edgeRegionHint
            } : {}
        },
        body: JSON.stringify({
            operationName: operationName,
            variables: queryVariables
        })
    }).then(()=>undefined).catch(()=>{
    // Swallow — warm-up is best-effort.
    });
};


const $48a95f6d40be797b$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $48a95f6d40be797b$export$fde16a5fe64932bd = ()=>{
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [aggAbsoluteUrl] = (0, $j4ply.useAggAbsoluteUrl)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const [productDataRegions] = (0, $j4ply.useProductDataRegions)();
    const [isJiraIssueIndexed] = (0, $j4ply.useIsJiraIssueIndexed)();
    const [experimentLayers] = (0, $j4ply.useExperimentLayers)();
    const [features] = (0, $j4ply.useFeatures)();
    const products = (0, $j4ply.useAvailableProducts)();
    const [productEdition] = (0, $j4ply.useProductEdition)();
    const logError = (0, $f8oYd.useLogException)();
    // SAIN intent-detection preload deps (only consumed when the FG is on at
    // invocation time).
    const [{ analyticsAttributes: analyticsAttributes, orgId: orgId }] = (0, $j4ply.useBootstrap)();
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const depsRef = (0, $42omo.useRef)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        cloudId: cloudId,
        experimentLayers: experimentLayers,
        isLiteMode: features?.lite?.enabled ?? false,
        isJiraIssueIndexed: isJiraIssueIndexed,
        logError: logError,
        primaryProduct: primaryProduct,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        products: products,
        thirdPartyConfigs: thirdPartyConfigs,
        user: user,
        activationId: analyticsAttributes?.activationId,
        orgId: orgId,
        locale: locale
    });
    (0, $42omo.useEffect)(()=>{
        depsRef.current = {
            aggAbsoluteUrl: aggAbsoluteUrl,
            cloudId: cloudId,
            experimentLayers: experimentLayers,
            isLiteMode: features?.lite?.enabled ?? false,
            isJiraIssueIndexed: isJiraIssueIndexed,
            logError: logError,
            primaryProduct: primaryProduct,
            productDataRegions: productDataRegions,
            productEdition: productEdition,
            products: products,
            thirdPartyConfigs: thirdPartyConfigs,
            user: user,
            activationId: analyticsAttributes?.activationId,
            orgId: orgId,
            locale: locale
        };
    });
    return (0, $42omo.useCallback)((url)=>{
        const deps = depsRef.current;
        // Required pieces — bail out silently if bootstrap hasn't populated them yet.
        if (!deps.primaryProduct || !deps.cloudId) return;
        const searchSessionId = crypto.randomUUID();
        const sessionId = (0, $PVo4u.getSessionIdFromLocalStorage)();
        // Parse query params from the destination URL — the URL is the source
        // of truth for what the search page will render.
        let queryParams = {};
        try {
            const parsed = new URL(url, window.location.origin);
            queryParams = Object.fromEntries(parsed.searchParams);
        } catch  {
            // Malformed URL — abort warm-up.
            return;
        }
        let searchInputs;
        try {
            searchInputs = (0, $7yVTH.generateSearchInputs)({
                backendExperimentOverrides: [],
                cloudId: deps.cloudId,
                experimentLayers: deps.experimentLayers,
                experience: (0, $4cq9O.SEARCH_PAGE),
                isJiraIssueIndexed: deps.isJiraIssueIndexed,
                jsmIncidentFilterIds: [],
                primaryProduct: deps.primaryProduct,
                productDataRegions: deps.productDataRegions || {},
                productEdition: deps.productEdition || {},
                products: deps.products,
                queryParams: queryParams,
                searchSessionId: searchSessionId,
                sessionId: sessionId,
                thirdPartyConfigs: deps.thirdPartyConfigs,
                user: deps.user,
                expectResult: false,
                onError: deps.logError
            });
        } catch  {
            // generateSearchInputs threw — abort warm-up silently.
            return;
        }
        const edgeRegionHint = deps.primaryProduct && deps.productDataRegions ? (0, $chwej.getEdgeRegionHint)(deps.primaryProduct, deps.productDataRegions) : undefined;
        const searchResultsQueryVariables = {
            ...searchInputs.searchResultsQueryVariables,
            ...searchInputs.searchResultsQueryRelayProvidedVariables
        };
        // Fire-and-forget — both fetches.
        (0, $576e5b0ff900a391$export$d1be7f2304606f8e)({
            persistedId: (0, $34fbce75abc033a7$export$d2f5eaa391338206),
            operationName: (0, $34fbce75abc033a7$export$ba2c557d27f18b1d),
            queryVariables: searchResultsQueryVariables,
            edgeRegionHint: edgeRegionHint,
            aggAbsoluteUrl: deps.aggAbsoluteUrl || $48a95f6d40be797b$var$DEFAULT_GRAPHQL_ENDPOINT
        });
        // Skip warming the right-panel query in lite mode — the lite layout never
        // renders the right panel, so the preload would be wasted.
        if (!deps.isLiteMode) (0, $576e5b0ff900a391$export$d1be7f2304606f8e)({
            persistedId: (0, $032df212fe100589$export$b93f8325f362c8e2),
            operationName: (0, $032df212fe100589$export$d879c693c9d5dd1d),
            queryVariables: searchInputs.rightPanelQueryVariables,
            edgeRegionHint: edgeRegionHint,
            aggAbsoluteUrl: deps.aggAbsoluteUrl || $48a95f6d40be797b$var$DEFAULT_GRAPHQL_ENDPOINT
        });
        // SAIN intent-detection preload
        // Fires `getQueryIntent` early from the warm-up, supported by the request cache inside search-ai
        const rawSearchText = queryParams.text;
        const searchTextFromUrl = typeof rawSearchText === 'string' ? rawSearchText : '';
        if (searchTextFromUrl && // Skip preload when `kd_recent_activity_intent` is on. The FG is being unlaunched (false path kept).
        !(0, $dh538.fg)('kd_recent_activity_intent') && (0, $dh538.fg)('rovo_fps_preload_sain_intent_from_quick_find')) (0, $c347e097eb83249d$export$840abf07587d206)({
            ...(0, $gbTNF.buildIntentDetectionVariables)({
                cloudId: deps.cloudId,
                primaryProduct: deps.primaryProduct,
                activationId: deps.activationId,
                locale: deps.locale,
                orgId: deps.orgId,
                query: searchTextFromUrl
            }),
            onError: deps.logError
        });
        const preloadData = {
            cloudId: deps.cloudId,
            config: null,
            isConfigFromCache: undefined,
            configFailReason: undefined,
            cacheFailReason: undefined,
            search: {
                queryVariables: searchResultsQueryVariables,
                generated: {
                    sessionId: sessionId,
                    searchSessionId: searchSessionId
                },
                steeringHeader: edgeRegionHint ? `${0, $chwej.EDGE_REGION_HINT_HEADER}: ${edgeRegionHint}` : undefined
            },
            rightPanel: {
                queryVariables: searchInputs.rightPanelQueryVariables,
                generated: {
                    sessionId: sessionId,
                    searchSessionId: searchSessionId
                },
                steeringHeader: edgeRegionHint ? `${0, $chwej.EDGE_REGION_HINT_HEADER}: ${edgeRegionHint}` : undefined
            },
            source: 'quick-find'
        };
        try {
            window.__PRELOADED_SEARCH__ = preloadData;
        } catch  {
        // window may be unavailable in unusual environments.
        }
    }, []);
};


const $b6323a569d1b2d97$export$86c95f2dee1a5a72 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (originalOnNavigate, generateSearchUrl)=>{
    const $ = (0, $frIzR.c)(7);
    const warmUp = (0, $48a95f6d40be797b$export$fde16a5fe64932bd)();
    let t0;
    bb0: {
        if (!originalOnNavigate) {
            t0 = originalOnNavigate;
            break bb0;
        }
        const original = originalOnNavigate;
        let t1;
        if ($[0] !== generateSearchUrl || $[1] !== original || $[2] !== warmUp) {
            t1 = (url, action, event)=>{
                if (generateSearchUrl && (0, $0cd41d31d45cf5ea$export$2811a6cefe42670b)(generateSearchUrl) === false && (0, $0cd41d31d45cf5ea$export$98262e13018313b)(url, generateSearchUrl) === true) warmUp(url);
                return typeof original === "function" ? original(url, action, event) : original.callback(url, action, event);
            };
            $[0] = generateSearchUrl;
            $[1] = original;
            $[2] = warmUp;
            $[3] = t1;
        } else t1 = $[3];
        const wrappedCallback = t1;
        let t2;
        if ($[4] !== original || $[5] !== wrappedCallback) {
            t2 = typeof original === "function" ? wrappedCallback : {
                callback: wrappedCallback,
                options: original.options
            };
            $[4] = original;
            $[5] = wrappedCallback;
            $[6] = t2;
        } else t2 = $[6];
        t0 = t2;
    }
    return t0;
} : (originalOnNavigate, generateSearchUrl)=>{
    const warmUp = (0, $48a95f6d40be797b$export$fde16a5fe64932bd)();
    return (0, $42omo.useMemo)(()=>{
        // Return original by identity when there is no navigation handler to wrap.
        if (!originalOnNavigate) return originalOnNavigate;
        const original = originalOnNavigate;
        const wrappedCallback = (url, action, event)=>{
            // Only warm up when we definitively know we're NOT already on the
            // search page AND the destination is the search page itself. For
            // `isOnSearchRoute`, both `true` (already there) and `undefined`
            // (couldn't tell) skip warm-up.
            if (generateSearchUrl && (0, $0cd41d31d45cf5ea$export$2811a6cefe42670b)(generateSearchUrl) === false && (0, $0cd41d31d45cf5ea$export$98262e13018313b)(url, generateSearchUrl) === true) warmUp(url);
            return typeof original === 'function' ? original(url, action, event) : original.callback(url, action, event);
        };
        return typeof original === 'function' ? wrappedCallback : {
            callback: wrappedCallback,
            options: original.options
        };
    }, [
        originalOnNavigate,
        generateSearchUrl,
        warmUp
    ]);
};












var $fFa3V = parcelRequire("fFa3V");

function $447d1b6cafcd352b$var$mapToInteractionType(eventType) {
    if (eventType === 'click' || eventType === 'dblclick' || eventType === 'mousedown') return 'press';
    if (eventType === 'mouseenter' || eventType === 'mouseover') return 'hover';
    return undefined;
}
var $447d1b6cafcd352b$export$2e2bcd8739ae039 = $447d1b6cafcd352b$var$mapToInteractionType;



var $fTvzg = parcelRequire("fTvzg");

/**
 * *Warning* Currently this only supports the events with the following types
 * ```ts
 * 'click' | 'dblclick' | 'mousedown' | 'mouseenter' | 'mouseover'
 * ```
 */ function $3d262149e5e5b88f$var$traceUFOInteraction(name, event) {
    if (!event || !event.isTrusted) return;
    const interactionType = (0, $447d1b6cafcd352b$export$2e2bcd8739ae039)(event.type);
    if (!interactionType) // when interactionType is falsy we do not yet support this type of event. should we blow up with throwing error instead?
    return;
    return (0, $fTvzg.default)(name, interactionType, event.timeStamp);
}
var $3d262149e5e5b88f$export$2e2bcd8739ae039 = $3d262149e5e5b88f$var$traceUFOInteraction;














const $00b97e1dc9e8581d$var$isClickInRelatedLinkModalBlanket = (targetNode)=>{
    if (!targetNode) return false;
    const relatedLinksModal = document.querySelector('[data-testid="related-links-modal"]');
    const relatedLinkModalBlanket = document.querySelector('[data-testid="related-links-modal--blanket"]');
    const isInRelatedLinksModal = relatedLinksModal ? relatedLinksModal.contains(targetNode) : false;
    const isInRelatedLinkModalBlanket = relatedLinkModalBlanket ? relatedLinkModalBlanket.contains(targetNode) : false;
    return isInRelatedLinksModal || isInRelatedLinkModalBlanket;
};
const $00b97e1dc9e8581d$export$92dae2778ae88f9d = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { dialogRef: dialogRef, inputBoxRef: inputBoxRef } = t0;
    const mouseDownInside = (0, $42omo.useRef)(false);
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const [isFeedbackModalOpen] = (0, $4VmlX.useIsFeedbackModalOpen)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    let t1;
    let t2;
    if ($[0] !== dialogRef || $[1] !== inputBoxRef || $[2] !== isFeedbackModalOpen || $[3] !== quickFindOpen || $[4] !== setQuickFindOpen) {
        t1 = ()=>{
            const onMouseDown = (event)=>{
                mouseDownInside.current = false;
                const { target: target } = event;
                const targetNode = target;
                const isClickOnPopup = dialogRef.current && dialogRef.current.contains(targetNode);
                const isClickOnTrigger = inputBoxRef.current && inputBoxRef.current.contains(targetNode);
                if (isClickOnPopup || isClickOnTrigger) mouseDownInside.current = true;
            };
            const onClick = (event_0)=>{
                const { target: target_0 } = event_0;
                const targetNode_0 = target_0;
                if (isFeedbackModalOpen) return;
                if ($00b97e1dc9e8581d$var$isClickInRelatedLinkModalBlanket(targetNode_0)) return;
                if ((0, $2OtFZ.serveSearchSettingsModalExperiment)({
                    fireExperimentExposure: false
                }) && targetNode_0 instanceof Element && (targetNode_0.closest("[data-testid=\"rovo-settings-modal\"]") || targetNode_0.closest("[data-testid=\"rovo-settings-modal--blanket\"]"))) return;
                const isClickOnPopup_0 = dialogRef.current && dialogRef.current.contains(targetNode_0);
                const isClickOnTrigger_0 = inputBoxRef.current && inputBoxRef.current.contains(targetNode_0);
                if (!isClickOnPopup_0 && !isClickOnTrigger_0 && !mouseDownInside.current) {
                    setQuickFindOpen(false);
                    if (quickFindOpen) (0, $3d262149e5e5b88f$export$2e2bcd8739ae039)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event_0);
                }
            };
            const onKeyDown = (event_1)=>{
                const { key: key } = event_1;
                if (key === "Escape" || key === "Esc") {
                    setQuickFindOpen(false);
                    if (quickFindOpen) (0, $3d262149e5e5b88f$export$2e2bcd8739ae039)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event_1);
                }
            };
            const onBlur = ()=>{
                const activeElement = document.activeElement;
                const activeElementIsIFrame = activeElement instanceof HTMLIFrameElement;
                if (activeElementIsIFrame) {
                    setQuickFindOpen(false);
                    if (quickFindOpen) (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), performance.now());
                }
            };
            const unbind = (0, $fFa3V.bindAll)(window, [
                {
                    type: "mousedown",
                    listener: onMouseDown,
                    options: {
                        capture: false
                    }
                },
                {
                    type: "click",
                    listener: onClick,
                    options: {
                        capture: true
                    }
                },
                {
                    type: "keydown",
                    listener: onKeyDown
                },
                {
                    type: "blur",
                    listener: onBlur
                }
            ]);
            return ()=>{
                unbind();
            };
        };
        t2 = [
            setQuickFindOpen,
            isFeedbackModalOpen,
            quickFindOpen,
            dialogRef,
            inputBoxRef
        ];
        $[0] = dialogRef;
        $[1] = inputBoxRef;
        $[2] = isFeedbackModalOpen;
        $[3] = quickFindOpen;
        $[4] = setQuickFindOpen;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $42omo.useEffect)(t1, t2);
} : ({ dialogRef: dialogRef, inputBoxRef: inputBoxRef })=>{
    const mouseDownInside = (0, $42omo.useRef)(false);
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const [isFeedbackModalOpen] = (0, $4VmlX.useIsFeedbackModalOpen)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    (0, $42omo.useEffect)(()=>{
        const onMouseDown = (event)=>{
            mouseDownInside.current = false;
            const { target: target } = event;
            const targetNode = target;
            const isClickOnPopup = dialogRef.current && dialogRef.current.contains(targetNode);
            const isClickOnTrigger = inputBoxRef.current && inputBoxRef.current.contains(targetNode);
            if (isClickOnPopup || isClickOnTrigger) mouseDownInside.current = true;
        };
        const onClick = (event_0)=>{
            const { target: target_0 } = event_0;
            const targetNode_0 = target_0;
            if (isFeedbackModalOpen) return;
            if ($00b97e1dc9e8581d$var$isClickInRelatedLinkModalBlanket(targetNode_0)) return;
            // Prevent QuickFind from closing when clicking inside the Rovo settings
            // modal or its blanket overlay.
            if ((0, $2OtFZ.serveSearchSettingsModalExperiment)({
                fireExperimentExposure: false
            }) && targetNode_0 instanceof Element && (targetNode_0.closest('[data-testid="rovo-settings-modal"]') || targetNode_0.closest('[data-testid="rovo-settings-modal--blanket"]'))) return;
            const isClickOnPopup_0 = dialogRef.current && dialogRef.current.contains(targetNode_0);
            const isClickOnTrigger_0 = inputBoxRef.current && inputBoxRef.current.contains(targetNode_0);
            if (!isClickOnPopup_0 && !isClickOnTrigger_0 && !mouseDownInside.current) {
                setQuickFindOpen(false);
                if (quickFindOpen) (0, $3d262149e5e5b88f$export$2e2bcd8739ae039)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event_0);
            }
        };
        const onKeyDown = (event_1)=>{
            const { key: key } = event_1;
            if (key === 'Escape' || key === 'Esc') {
                setQuickFindOpen(false);
                if (quickFindOpen) (0, $3d262149e5e5b88f$export$2e2bcd8739ae039)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), event_1);
            }
        };
        const onBlur = ()=>{
            const activeElement = document.activeElement;
            const activeElementIsIFrame = activeElement instanceof HTMLIFrameElement;
            // Close Quick Find if the new active element is an iframe, we need
            // to do this check since click events are not fired on iframes
            if (activeElementIsIFrame) {
                setQuickFindOpen(false);
                if (quickFindOpen) (0, $4TXTZ.default)((0, $3R0ts.QUICK_FIND_CLOSE_INTERACTION), performance.now());
            }
        };
        const unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'mousedown',
                listener: onMouseDown,
                options: {
                    capture: false
                }
            },
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: true // Closes the dialog before SPA transitions
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'blur',
                listener: onBlur
            }
        ]);
        return ()=>{
            unbind();
        };
    }, [
        setQuickFindOpen,
        isFeedbackModalOpen,
        quickFindOpen,
        dialogRef,
        inputBoxRef
    ]);
};

















const $b7759cf22d019191$export$24139682747f5c4 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'dwelled',
        actionSubject: 'searchResults',
        actionSubjectId: 'preQuerySearchResults',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });











const $aca2bc20d4823d2b$export$632123ff591ac565 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useTimer(t0) {
    const $ = (0, $frIzR.c)(10);
    const { onTimerEnd: onTimerEnd } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            status: "idle"
        };
        $[0] = t1;
    } else t1 = $[0];
    const [timer, setTimer] = (0, $42omo.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setTimer($aca2bc20d4823d2b$var$_temp);
        };
        $[1] = t2;
    } else t2 = $[1];
    const start = t2;
    let t3;
    if ($[2] !== onTimerEnd || $[3] !== timer.startTime) {
        t3 = ()=>{
            setTimer((state_0)=>{
                if (state_0.status !== "running") return state_0;
                const end = new Date().getTime() - (timer.startTime?.getTime() ?? 0);
                onTimerEnd?.(end);
                return {
                    ...state_0,
                    endTime: new Date(),
                    milliseconds: end,
                    status: "finished"
                };
            });
        };
        $[2] = onTimerEnd;
        $[3] = timer.startTime;
        $[4] = t3;
    } else t3 = $[4];
    const stop = t3;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setTimer($aca2bc20d4823d2b$var$_temp2);
        };
        $[5] = t4;
    } else t4 = $[5];
    const cancel = t4;
    let t5;
    if ($[6] !== stop || $[7] !== timer.milliseconds || $[8] !== timer.status) {
        t5 = {
            start: start,
            stop: stop,
            cancel: cancel,
            status: timer.status,
            milliseconds: timer.milliseconds
        };
        $[6] = stop;
        $[7] = timer.milliseconds;
        $[8] = timer.status;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : function useTimer({ onTimerEnd: onTimerEnd }) {
    const [timer, setTimer] = (0, $42omo.useState)({
        status: 'idle'
    });
    const start = (0, $42omo.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'idle') return state;
            return {
                ...state,
                startTime: new Date(),
                status: 'running'
            };
        });
    }, []);
    const stop = (0, $42omo.useCallback)(()=>{
        setTimer((state_0)=>{
            if (state_0.status !== 'running') return state_0;
            const end = new Date().getTime() - (timer.startTime?.getTime() ?? 0);
            onTimerEnd?.(end);
            return {
                ...state_0,
                endTime: new Date(),
                milliseconds: end,
                status: 'finished'
            };
        });
    }, [
        onTimerEnd,
        timer.startTime
    ]);
    const cancel = (0, $42omo.useCallback)(()=>{
        setTimer((state_1)=>{
            if (state_1.status !== 'running') return state_1;
            return {
                ...state_1,
                status: 'cancelled'
            };
        });
    }, []);
    return {
        start: start,
        stop: stop,
        cancel: cancel,
        status: timer.status,
        milliseconds: timer.milliseconds
    };
};
function $aca2bc20d4823d2b$var$_temp2(state_1) {
    if (state_1.status !== "running") return state_1;
    return {
        ...state_1,
        status: "cancelled"
    };
}
function $aca2bc20d4823d2b$var$_temp(state) {
    if (state.status !== "idle") return state;
    return {
        ...state,
        startTime: new Date(),
        status: "running"
    };
}








const $37f7a1f5b4662dd4$export$20260e4d2b6c9d50 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(13);
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    let t0;
    if ($[0] !== queryParams) {
        t0 = (0, $2ok43.getInitialQuery)() || queryParams.text;
        $[0] = queryParams;
        $[1] = t0;
    } else t0 = $[1];
    const hadInitialQuery = (0, $42omo.useRef)(Boolean(t0));
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    let t1;
    if ($[2] !== commonAttributes || $[3] !== fireAnalyticsEvent || $[4] !== nonPrivacySafeAttributes) {
        t1 = {
            onTimerEnd: (ms)=>fireAnalyticsEvent((0, $b7759cf22d019191$export$24139682747f5c4)({
                    attributes: {
                        ...commonAttributes,
                        duration: ms
                    },
                    nonPrivacySafeAttributes: nonPrivacySafeAttributes
                }))
        };
        $[2] = commonAttributes;
        $[3] = fireAnalyticsEvent;
        $[4] = nonPrivacySafeAttributes;
        $[5] = t1;
    } else t1 = $[5];
    const { start: startTimer, stop: stopTimer, cancel: cancelTimer } = (0, $aca2bc20d4823d2b$export$632123ff591ac565)(t1);
    let t2;
    let t3;
    if ($[6] !== cancelTimer || $[7] !== quickFindOpen || $[8] !== quickFindQuery || $[9] !== startTimer || $[10] !== stopTimer) {
        t2 = ()=>{
            if (hadInitialQuery.current) return;
            if (quickFindOpen) startTimer();
            if (!quickFindOpen) cancelTimer();
            if (quickFindQuery) stopTimer();
        };
        t3 = [
            cancelTimer,
            quickFindOpen,
            quickFindQuery,
            startTimer,
            stopTimer
        ];
        $[6] = cancelTimer;
        $[7] = quickFindOpen;
        $[8] = quickFindQuery;
        $[9] = startTimer;
        $[10] = stopTimer;
        $[11] = t2;
        $[12] = t3;
    } else {
        t2 = $[11];
        t3 = $[12];
    }
    (0, $42omo.useEffect)(t2, t3);
} : ()=>{
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const hadInitialQuery = (0, $42omo.useRef)(Boolean((0, $2ok43.getInitialQuery)() || queryParams.text));
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { start: startTimer, stop: stopTimer, cancel: cancelTimer } = (0, $aca2bc20d4823d2b$export$632123ff591ac565)({
        onTimerEnd: (ms)=>fireAnalyticsEvent((0, $b7759cf22d019191$export$24139682747f5c4)({
                attributes: {
                    ...commonAttributes,
                    duration: ms
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }))
    });
    // Analytics to track the first transition from pre-query to post-query
    (0, $42omo.useEffect)(()=>{
        // Do nothing if the page loaded with a query
        if (hadInitialQuery.current) return;
        // Start the timer when the dialog is opened
        if (quickFindOpen) startTimer();
        // Cancel the timer when the dialog is closed
        if (!quickFindOpen) cancelTimer(); // no-ops if the timer hasn't started or has already finished
        // Stop the timer when the user starts typing
        if (quickFindQuery) stopTimer();
    }, [
        cancelTimer,
        quickFindOpen,
        quickFindQuery,
        startTimer,
        stopTimer
    ]);
};











const $64ab60c9a8f30827$export$29d6913fc893cfe8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useSyncStates(stateA, setStateA, stateB, setStateB) {
    const $ = (0, $frIzR.c)(6);
    const prevA = (0, $42omo.useRef)();
    const prevB = (0, $42omo.useRef)();
    let t0;
    let t1;
    if ($[0] !== setStateA || $[1] !== setStateB || $[2] !== stateA || $[3] !== stateB) {
        t0 = ()=>{
            if (stateA === undefined || setStateA === undefined || stateB === undefined || setStateB === undefined) return;
            if (prevA.current === undefined && prevB.current === undefined) {
                prevA.current = stateA;
                prevB.current = stateA;
                setStateB(stateA);
                return;
            }
            if (stateA === stateB) {
                prevA.current = stateA;
                prevB.current = stateB;
                return;
            }
            if (prevA.current !== stateA) {
                prevA.current = stateA;
                prevB.current = stateA;
                setStateB(stateA);
                return;
            }
            if (prevB.current !== stateB) {
                prevA.current = stateB;
                prevB.current = stateB;
                setStateA(stateB);
            }
        };
        t1 = [
            setStateA,
            setStateB,
            stateA,
            stateB
        ];
        $[0] = setStateA;
        $[1] = setStateB;
        $[2] = stateA;
        $[3] = stateB;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $42omo.useEffect)(t0, t1);
} : function useSyncStates(stateA, setStateA, stateB, setStateB) {
    const prevA = (0, $42omo.useRef)();
    const prevB = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        // Do nothing if any of the arguments are undefined
        if (stateA === undefined || setStateA === undefined || stateB === undefined || setStateB === undefined) return;
        // On mount, use stateA as the source of truth
        if (prevA.current === undefined && prevB.current === undefined) {
            prevA.current = stateA;
            prevB.current = stateA;
            setStateB(stateA);
            return;
        }
        // If updates to both states are updated to the same value in the
        // same render cycle, ensure previous values are updated
        if (stateA === stateB) {
            prevA.current = stateA;
            prevB.current = stateB;
            return;
        }
        // If stateA has changed, update stateB to match
        if (prevA.current !== stateA) {
            prevA.current = stateA;
            prevB.current = stateA;
            setStateB(stateA);
            // Exit here as only one state should be updated, otherwise an infinite
            // loop will occur. This means that stateA takes precedence if both
            // states are changed in the same render cycle.
            return;
        }
        // If stateB has changed, update stateA to match
        if (prevB.current !== stateB) {
            prevA.current = stateB;
            prevB.current = stateB;
            setStateA(stateB);
        }
    }, [
        setStateA,
        setStateB,
        stateA,
        stateB
    ]);
};


const $c8b08557d75a416b$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    width: '100%',
    position: 'relative'
});
const $c8b08557d75a416b$var$minWidthStyles = (0, $ecnYn.xcss)({
    left: '50%',
    transform: 'translate(-50%, 0)',
    // Anchor Quick Find input and dialog to the center of the viewport
    position: 'fixed',
    maxWidth: '780px',
    // To retain the same width as Quick Search
    zIndex: 'navigation',
    [(0, $bWLcG.media).above.lg]: {
        maxWidth: 'unset',
        position: 'relative'
    }
});
const $c8b08557d75a416b$var$QuickFindComponent = ({ open: open, setOpen: setOpen, postQueryDisabled: postQueryDisabled, textfieldComponent: textfieldComponent, isSSR: isSSR, PlacementPO: PlacementPO, showFilters: showFilters = true, showFiltersRow: showFiltersRow = false, searchRefreshStyling: searchRefreshStyling = false, customPlaceholder: customPlaceholder, onGhostTextGenerated: onGhostTextGenerated, inputRef: inputRef, preQueryContent: preQueryContent, onPrefetch: onPrefetch })=>{
    const inputBoxRef = (0, $42omo.useRef)(null);
    const dialogRef = (0, $42omo.useRef)(null);
    const { isNav4Enabled: isNav4Enabled, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const internalInputRef = (0, $42omo.useRef)(null);
    const effectiveInputRef = inputRef || internalInputRef;
    const intl = (0, $aXWIB.useIntl)();
    const intentRouterEnabled = (0, $42omo.useMemo)(()=>(0, $26jni.serveJiraNINFpsNLQNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false,
            // Exposure is fired when a user calls the intent detection API
            locale: intl.locale
        })?.cohort === 'test', [
        primaryProduct,
        intl.locale
    ]);
    const [localQuery, setLocalQuery] = (0, $42omo.useState)(()=>(0, $2ok43.getInitialQuery)(typeof queryParams.text === 'string' && queryParams.text || ''));
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const dialogId = (0, $42omo.useId)();
    const setMinWidthStyles = isNav4Enabled && !textfieldComponent && // min-width styles is only supported with the default text field
    quickFindOpen;
    (0, $64ab60c9a8f30827$export$29d6913fc893cfe8)(quickFindOpen, setQuickFindOpen, open, setOpen);
    (0, $00b97e1dc9e8581d$export$92dae2778ae88f9d)({
        dialogRef: dialogRef,
        inputBoxRef: inputBoxRef
    });
    (0, $37f7a1f5b4662dd4$export$20260e4d2b6c9d50)();
    // Dispose intent detection state when QuickFind unmounts.
    (0, $ea5066efa7331a88$export$9310e79b116dbbca)();
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const handleOpenLayerObserverCloseSignal = (0, $42omo.useCallback)(()=>{
        if (!isFhsEnabled) return;
        setQuickFindOpen(false);
    }, [
        isFhsEnabled,
        setQuickFindOpen
    ]);
    /**
   * We need to notify the open layer observer when the quick find dialog is open.
   * This is required for several navigation-system features to work correctly, such as:
   * - Closing layers when the user resizes a layout slot (e.g. SideNav, Panel)
   * - Ensuring correct layer stacking order when a popup is open within the TopNav or SideNav
   *
   * Ideally, the dialog would be using the ADS Popup component instead, which handles this internally
   * among other benefits.
   */ (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: isFhsEnabled && quickFindOpen,
        type: 'popup',
        onClose: handleOpenLayerObserverCloseSignal
    });
    const isPOBannerPlacementforQFEnabled = (0, $2OtFZ.serveQF3PBannerExperimentWithoutExposure)();
    const isHeadlessQuickFindBannerEnabled = (0, $dh538.fg)('post-office_enable_search-quick-find-headless');
    // Store the trackImpression callback provided by the PostOffice placement's onMessageViewed.
    // This is called later by OAuthContainer when the banner becomes visible in search results.
    const trackImpressionRef = (0, $42omo.useRef)(null);
    const onBannerVisible = (0, $42omo.useCallback)(()=>{
        trackImpressionRef.current?.();
    }, []);
    // Create a detached DOM node for the RML quick-find placement portal.
    // The placement component is mounted early (via createPortal) so its fetch starts in parallel with search, since requests are only made on placement mount.
    // When results render, <PlacementSlot> moves this node into the relevant position in the results list.
    const bannerPortalContainerRef = (0, $42omo.useRef)(null);
    if (isPOBannerPlacementforQFEnabled && !isHeadlessQuickFindBannerEnabled && typeof document !== 'undefined' && !bannerPortalContainerRef.current) {
        bannerPortalContainerRef.current = document.createElement('div');
        bannerPortalContainerRef.current.style.display = 'none';
    }
    const onBannerMessageViewed = (0, $42omo.useCallback)((trackImpression)=>{
        trackImpressionRef.current = trackImpression;
    }, []);
    const [isInteracted, setIsInteracted] = (0, $42omo.useState)(false);
    const onMouseEnter = (0, $42omo.useCallback)(()=>setIsInteracted(true), []);
    const onFocus = (0, $42omo.useCallback)(()=>setIsInteracted(true), []);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0c35e478cf8dbc82$export$da9d0159e5272189), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $c8b08557d75a416b$var$textFieldBoxStyles,
            setMinWidthStyles && $c8b08557d75a416b$var$minWidthStyles
        ],
        ref: inputBoxRef,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $icqFF.KeyboardHighlightProvider), {
        listenerNode: effectiveInputRef?.current
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33671f0d02952dbc$export$fb8d8fbc0c4c1705), {
        dialogId: dialogId,
        inputRef: effectiveInputRef,
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        textfieldComponent: textfieldComponent,
        postQueryDisabled: postQueryDisabled,
        customPlaceholder: customPlaceholder,
        onGhostTextGenerated: onGhostTextGenerated,
        intentRouterEnabled: intentRouterEnabled,
        onPrefetch: onPrefetch
    }), !isSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, isPOBannerPlacementforQFEnabled && !isHeadlessQuickFindBannerEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9e8ae9dcabcd78a5$export$eb1f26e9ffd464b), {
        onBannerMessageViewed: onBannerMessageViewed,
        isInteracted: isInteracted
    }), quickFindOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $86ob4.WidthObserverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71af45ffeeb47c72$export$2aadebb53f6015f6), {
        dialogId: dialogId,
        dialogRef: dialogRef,
        inputRef: effectiveInputRef,
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        PlacementPO: PlacementPO,
        showFilters: showFilters,
        searchRefreshStyling: searchRefreshStyling,
        preQueryContent: preQueryContent
    }))), showFiltersRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3d2eb85abd87b7a$export$876f25caa2b82f74), null))));
    if (isPOBannerPlacementforQFEnabled) {
        const contentWithHeadlessPlacement = isHeadlessQuickFindBannerEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3d288faa8cd311c0$export$6f38235f6fa1e5b1), {
            isInteracted: isInteracted
        }, content) : content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $RWXHe.PlacementPortalContainerProvider), {
            value: bannerPortalContainerRef.current
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $RWXHe.TrackImpressionProvider), {
            value: onBannerVisible
        }, contentWithHeadlessPlacement));
    }
    return content;
};
const $c8b08557d75a416b$export$68bbc91d7879f9e4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    let actualQueryParams;
    let children;
    let onSearchCompleted;
    let props;
    let t1;
    if ($[0] !== t0) {
        const { children: t2, queryParams: t3, callbacks: callbacks, ...t4 } = t0;
        children = t2;
        actualQueryParams = t3;
        props = t4;
        let t5;
        if ($[6] !== callbacks) {
            t5 = callbacks ?? {};
            $[6] = callbacks;
            $[7] = t5;
        } else t5 = $[7];
        ({ onSearchCompleted: onSearchCompleted } = t5);
        t1 = props.primaryProduct?.includes((0, $1yEFx.ProductKeys).Jira) ? {
            [(0, $a9fb8805b1f49851$export$7640e1e223f51f1a)]: (0, $9rRKJ.SearchExperience).QUICK_FIND
        } : {};
        $[0] = t0;
        $[1] = actualQueryParams;
        $[2] = children;
        $[3] = onSearchCompleted;
        $[4] = props;
        $[5] = t1;
    } else {
        actualQueryParams = $[1];
        children = $[2];
        onSearchCompleted = $[3];
        props = $[4];
        t1 = $[5];
    }
    const customParams = t1;
    const t2 = actualQueryParams?.text;
    let t3;
    if ($[8] !== customParams || $[9] !== t2) {
        t3 = {
            text: t2,
            ...customParams
        };
        $[8] = customParams;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const [queryParams, setQueryParams] = (0, $42omo.useState)(t3);
    const previousTextQueryParam = (0, $42omo.useRef)(actualQueryParams?.text);
    let t4;
    if ($[11] !== actualQueryParams?.text || $[12] !== props.generateSearchUrl) {
        t4 = ()=>{
            if (actualQueryParams?.text === previousTextQueryParam.current) return;
            const onSearchRoute = (0, $0cd41d31d45cf5ea$export$2811a6cefe42670b)(props.generateSearchUrl) ?? true;
            if (onSearchRoute) setQueryParams((previousQueryParams)=>({
                    ...previousQueryParams,
                    text: actualQueryParams?.text
                }));
            previousTextQueryParam.current = actualQueryParams?.text;
        };
        $[11] = actualQueryParams?.text;
        $[12] = props.generateSearchUrl;
        $[13] = t4;
    } else t4 = $[13];
    const t5 = actualQueryParams?.text;
    let t6;
    if ($[14] !== props.generateSearchUrl || $[15] !== t5) {
        t6 = [
            t5,
            props.generateSearchUrl
        ];
        $[14] = props.generateSearchUrl;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    (0, $42omo.useEffect)(t4, t6);
    let t7;
    if ($[17] !== onSearchCompleted) {
        t7 = {
            onSearchCompleted: onSearchCompleted,
            updateQueryParameters: setQueryParams
        };
        $[17] = onSearchCompleted;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== children || $[20] !== props || $[21] !== queryParams) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bHLTK.SearchStoreProvider), {
            experience: (0, $9rRKJ.SearchExperience).QUICK_FIND
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f58c1f7467c49dec$export$5f60ff1bbe7f1a37), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $785f0e86c2e88315$export$40a6847b10816750), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6c80dec8a0d452c$export$7d6ff8eec92df467), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c8b08557d75a416b$var$QuickFindAppContextProvider, {
            ...props,
            queryParams: queryParams
        }, children)))));
        $[19] = children;
        $[20] = props;
        $[21] = queryParams;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== props || $[24] !== queryParams || $[25] !== t7 || $[26] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8aC7e.default), {
            ...props,
            queryParams: queryParams,
            callbacks: t7,
            statsigLayer: (0, $4OGlb.STATSIG_QUICK_FIND_LAYER),
            experience: (0, $9rRKJ.SearchExperience).QUICK_FIND
        }, t8);
        $[23] = props;
        $[24] = queryParams;
        $[25] = t7;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
} : ({ children: children, queryParams: actualQueryParams, callbacks: callbacks, ...props })=>{
    const { onSearchCompleted: onSearchCompleted } = callbacks ?? {};
    const customParams = props.primaryProduct?.includes((0, $1yEFx.ProductKeys).Jira) ? {
        [(0, $a9fb8805b1f49851$export$7640e1e223f51f1a)]: (0, $9rRKJ.SearchExperience).QUICK_FIND
    } : {};
    /**
   * Quick Find does not need to set queryParams, hence using an object
   * in a state variable as the queryParams object. Any interactions with
   * the url should be done through onNavigate in the AppContext.
   */ const [queryParams, setQueryParams] = (0, $42omo.useState)({
        text: actualQueryParams?.text,
        ...customParams
    });
    /**
   * Quick Find only reacts to changes in the text query parameter when the
   * user is on the search page.
   */ const previousTextQueryParam = (0, $42omo.useRef)(actualQueryParams?.text);
    (0, $42omo.useEffect)(()=>{
        if (actualQueryParams?.text === previousTextQueryParam.current) return;
        // If isOnSearchRoute fails and returns undefined, we default to true
        const onSearchRoute = (0, $0cd41d31d45cf5ea$export$2811a6cefe42670b)(props.generateSearchUrl) ?? true;
        if (onSearchRoute) setQueryParams((previousQueryParams)=>({
                ...previousQueryParams,
                text: actualQueryParams?.text
            }));
        previousTextQueryParam.current = actualQueryParams?.text;
    }, [
        actualQueryParams?.text,
        props.generateSearchUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8aC7e.default), {
        ...props,
        queryParams: queryParams,
        callbacks: {
            onSearchCompleted: onSearchCompleted,
            updateQueryParameters: setQueryParams
        },
        statsigLayer: (0, $4OGlb.STATSIG_QUICK_FIND_LAYER),
        experience: (0, $9rRKJ.SearchExperience).QUICK_FIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bHLTK.SearchStoreProvider), {
        experience: (0, $9rRKJ.SearchExperience).QUICK_FIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f58c1f7467c49dec$export$5f60ff1bbe7f1a37), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $785f0e86c2e88315$export$40a6847b10816750), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6c80dec8a0d452c$export$7d6ff8eec92df467), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c8b08557d75a416b$var$QuickFindAppContextProvider, {
        ...props,
        queryParams: queryParams
    }, children))))));
};
/**
 * Quick-Find–scoped `AppContextProvider`. Wraps the host-provided `onNavigate`
 * with a warm-up that primes the search-page query cache in the backend when the
 * user navigates to the search page from Quick Find.
 */ const $c8b08557d75a416b$var$QuickFindAppContextProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const wrappedOnNavigate = (0, $b6323a569d1b2d97$export$86c95f2dee1a5a72)(props.onNavigate, props.generateSearchUrl);
    let t1;
    if ($[3] !== children || $[4] !== props || $[5] !== wrappedOnNavigate) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7WbA8.AppContextProvider), {
            ...props,
            onNavigate: wrappedOnNavigate
        }, children);
        $[3] = children;
        $[4] = props;
        $[5] = wrappedOnNavigate;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ children: children, ...props })=>{
    const wrappedOnNavigate = (0, $b6323a569d1b2d97$export$86c95f2dee1a5a72)(props.onNavigate, props.generateSearchUrl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7WbA8.AppContextProvider), {
        ...props,
        onNavigate: wrappedOnNavigate
    }, children);
};
const $c8b08557d75a416b$export$7d842d92e2721710 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    let props;
    if ($[0] !== t0) {
        const { children: children, ...t1 } = t0;
        props = t1;
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c8b08557d75a416b$var$QuickFindComponent, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== props || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "quick-find"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2lmJQ.default), {
            experience: (0, $9rRKJ.SearchExperience).QUICK_FIND
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.RelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c8b08557d75a416b$export$68bbc91d7879f9e4, props, t1))));
        $[4] = props;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: // eslint-disable-next-line no-unused-vars
children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "quick-find"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2lmJQ.default), {
        experience: (0, $9rRKJ.SearchExperience).QUICK_FIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.RelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c8b08557d75a416b$export$68bbc91d7879f9e4, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c8b08557d75a416b$var$QuickFindComponent, props)))));
};



var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $56QzY = parcelRequire("56QzY");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $9wGTI = parcelRequire("9wGTI");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $e4o8D = parcelRequire("e4o8D");


var $1xpoY = parcelRequire("1xpoY");


var $6OL2O = parcelRequire("6OL2O");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $3LDzU = parcelRequire("3LDzU");


var $hSHFH = parcelRequire("hSHFH");





var $kcIQr = parcelRequire("kcIQr");

/* ConnectorEmptyStatePromo.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $cO1el = parcelRequire("cO1el");





var $auNCB = parcelRequire("auNCB");

















var $cuiaa = parcelRequire("cuiaa");


var $2u5DE = parcelRequire("2u5DE");

const $b3c608f4d4f9fbc2$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.emptyState.heading",
        defaultMessage: "Seek and you shall find"
    },
    body: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.emptyState.body",
        defaultMessage: "Search or ask Rovo to find what you need across Atlassian, and connect your other apps to unlock search across them, too."
    },
    connectMoreApps: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.emptyState.connectMoreApps",
        defaultMessage: "Connect Rovo to more apps"
    }
});
const $b3c608f4d4f9fbc2$var$styles = {
    container: "_19pkpxbi",
    body: "_p12f1y37 _y3gn1h6o",
    connectorButton: "_zulp12x7 _2rko12b0 _1rjcv77o _18zrutpp _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c116y _4cvr1h6o _bfhk1j9a _80omtlke _syazi7uo",
    connectMoreLink: "_zulp1b66 _1e0c116y _4cvr1h6o _syazazsu"
};
const $b3c608f4d4f9fbc2$var$ConnectorPressableItem = ({ connector: connector, onSetup: onSetup, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $b3c608f4d4f9fbc2$var$styles.connectorButton,
        onClick: ()=>onSetup(connector.key),
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2u5DE.ConnectorIconPlaceholder), {
        connector: connector,
        size: 20
    }), connector.displayName);
const $b3c608f4d4f9fbc2$export$d97b992766bf7dd0 = ({ recommendedConnectors: recommendedConnectors, onSetupConnector: onSetupConnector, testId: testId = 'connector-empty-state-promo' })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const adminHubLink = (0, $cuiaa.useAdminHubConnectorLink)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const handleSetupClick = (0, $42omo.useCallback)((key)=>{
        createEvent({
            type: 'sendUIEvent',
            data: {
                source: 'ConnectorEmptyStatePromo',
                action: 'clicked',
                actionSubject: 'button',
                attributes: {
                    connectorKey: key,
                    container: 'ConnectorPromoNavSearch',
                    testId: `${testId}--connector-${key}`
                }
            }
        }).fire();
        onSetupConnector(key);
    }, [
        onSetupConnector,
        createEvent,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b3c608f4d4f9fbc2$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium"
    }, formatMessage($b3c608f4d4f9fbc2$var$messages.heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b3c608f4d4f9fbc2$var$styles.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        align: "center"
    }, formatMessage($b3c608f4d4f9fbc2$var$messages.body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        shouldWrap: true,
        alignInline: "center"
    }, recommendedConnectors.slice(0, 3).map((connector)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b3c608f4d4f9fbc2$var$ConnectorPressableItem, {
            key: connector.key,
            connector: connector,
            onSetup: handleSetupClick,
            testId: `${testId}--connector-${connector.key}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: adminHubLink ?? '/admin',
        xcss: $b3c608f4d4f9fbc2$var$styles.connectMoreLink,
        testId: `${testId}--connect-more`
    }, formatMessage($b3c608f4d4f9fbc2$var$messages.connectMoreApps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: "",
        color: "currentColor"
    }))));
};

















/* ConnectorPromoCardBase.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $7p4As = parcelRequire("7p4As");






















const $fdb2b38977158029$var$messages = (0, $aXWIB.defineMessages)({
    dismissLabel: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.promo.dismissLabel",
        defaultMessage: "Dismiss"
    }
});
const $fdb2b38977158029$var$styles = {
    container: "_zulputpp _1rjcutpp _18zrpxbi _1mou12x7 _1e0c1txw _4cvr1h6o _bfhk19ip",
    actions: "_zulpu2gc _1e0c1txw _4cvr1h6o _1o9zidpf _18u01wug"
};
const $fdb2b38977158029$export$c7922e9695b63bc7 = ({ heading: heading, body: body, icon: icon, primaryCtaLabel: primaryCtaLabel, onPrimaryClick: onPrimaryClick, primaryCtaLink: primaryCtaLink, secondaryCtaLabel: secondaryCtaLabel, onSecondaryClick: onSecondaryClick, onDismiss: onDismiss, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $fdb2b38977158029$var$styles.container,
        testId: testId
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span"
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium",
        weight: "bold"
    }, heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtle"
    }, body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $fdb2b38977158029$var$styles.actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, secondaryCtaLabel && onSecondaryClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onSecondaryClick,
        testId: testId ? `${testId}--secondary-cta` : undefined
    }, secondaryCtaLabel), primaryCtaLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "primary",
        spacing: "compact",
        href: primaryCtaLink,
        target: "_blank",
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
        onClick: onPrimaryClick,
        testId: testId ? `${testId}--primary-cta` : undefined
    }, primaryCtaLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        spacing: "compact",
        onClick: onPrimaryClick,
        testId: testId ? `${testId}--primary-cta` : undefined
    }, primaryCtaLabel)), onDismiss && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($fdb2b38977158029$var$messages.dismissLabel),
        onClick: onDismiss,
        testId: testId ? `${testId}--dismiss` : undefined
    })));
};


const $5656e12bfc0fb281$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.nthPromo.heading",
        defaultMessage: "Your team\u2019s search results could be better"
    },
    body: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.nthPromo.body",
        defaultMessage: "Connect your team\u2019s most used apps so everyone can search in one place."
    },
    setupLabel: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.nthPromo.setupLabel",
        defaultMessage: "Set up"
    }
});
const $5656e12bfc0fb281$export$a0fd92de9ea67558 = ({ recommendedConnectors: recommendedConnectors, onDismissPromo: onDismissPromo, testId: testId = 'connector-nth-promo-card' })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const adminHubLink = (0, $cuiaa.useAdminHubConnectorLink)();
    const handlePrimaryClick = (0, $42omo.useCallback)(()=>{
        createEvent({
            type: 'sendUIEvent',
            data: {
                source: 'ConnectorNthPromoCard',
                action: 'clicked',
                actionSubject: 'button',
                attributes: {
                    connectorKey: recommendedConnectors[0]?.key,
                    container: 'ConnectorPromoNavSearch',
                    testId: `${testId}--primary-cta`
                }
            }
        }).fire();
    }, [
        recommendedConnectors,
        createEvent,
        testId
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createEvent({
            type: 'sendUIEvent',
            data: {
                source: 'ConnectorNthPromoCard',
                action: 'clicked',
                actionSubject: 'button',
                attributes: {
                    connectorKey: recommendedConnectors[0]?.key,
                    container: 'ConnectorPromoNavSearch',
                    testId: `${testId}--dismiss`
                }
            }
        }).fire();
        onDismissPromo();
    }, [
        recommendedConnectors,
        onDismissPromo,
        createEvent,
        testId
    ]);
    if (recommendedConnectors.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdb2b38977158029$export$c7922e9695b63bc7), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
            size: "small",
            shouldUseHexLogo: true
        }),
        heading: formatMessage($5656e12bfc0fb281$var$messages.heading),
        body: formatMessage($5656e12bfc0fb281$var$messages.body),
        primaryCtaLabel: formatMessage($5656e12bfc0fb281$var$messages.setupLabel),
        onPrimaryClick: handlePrimaryClick,
        primaryCtaLink: adminHubLink,
        onDismiss: handleDismiss,
        testId: testId
    });
};















const $4cebbcf422bcb464$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.postConnectPromo.heading",
        defaultMessage: "Your team\u2019s search results could be better"
    },
    body: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.postConnectPromo.body",
        defaultMessage: "You\u2019ve connected {connectedAppName}\u2014now search across {nextConnectorName} from Confluence."
    },
    setupLabel: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.postConnectPromo.setupLabel",
        defaultMessage: "Set up"
    }
});
const $4cebbcf422bcb464$export$4e5d60fc605801be = ({ connectedAppName: connectedAppName, nextRecommendedConnector: nextRecommendedConnector, onSetupConnector: onSetupConnector, onDismissPromo: onDismissPromo, testId: testId = 'connector-post-connect-promo-card' })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const handlePrimaryClick = (0, $42omo.useCallback)(()=>{
        if (!nextRecommendedConnector) return;
        createEvent({
            type: 'sendUIEvent',
            data: {
                source: 'ConnectorPostConnectPromoCard',
                action: 'clicked',
                actionSubject: 'button',
                attributes: {
                    connectorKey: nextRecommendedConnector.key,
                    container: 'ConnectorPromoNavSearch',
                    testId: `${testId}--primary-cta`
                }
            }
        }).fire();
        onSetupConnector(nextRecommendedConnector.key);
    }, [
        nextRecommendedConnector,
        onSetupConnector,
        createEvent,
        testId
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createEvent({
            type: 'sendUIEvent',
            data: {
                source: 'ConnectorPostConnectPromoCard',
                action: 'clicked',
                actionSubject: 'button',
                attributes: {
                    connectorKey: nextRecommendedConnector?.key,
                    container: 'ConnectorPromoNavSearch',
                    testId: `${testId}--dismiss`
                }
            }
        }).fire();
        onDismissPromo();
    }, [
        nextRecommendedConnector,
        onDismissPromo,
        createEvent,
        testId
    ]);
    if (!nextRecommendedConnector) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdb2b38977158029$export$c7922e9695b63bc7), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2u5DE.ConnectorIconPlaceholder), {
            connector: nextRecommendedConnector,
            size: 24
        }),
        heading: formatMessage($4cebbcf422bcb464$var$messages.heading),
        body: formatMessage($4cebbcf422bcb464$var$messages.body, {
            connectedAppName: connectedAppName || '',
            nextConnectorName: nextRecommendedConnector.displayName
        }),
        primaryCtaLabel: formatMessage($4cebbcf422bcb464$var$messages.setupLabel),
        onPrimaryClick: handlePrimaryClick,
        onDismiss: handleDismiss,
        testId: testId
    });
};



var $2qVTE = parcelRequire("2qVTE");

function $63678eed770dbc39$var$getNavSearchPromoVariant(shouldShowEmptyState, shouldShowPostConnectPromo, shouldShowNthPromo) {
    switch(true){
        case shouldShowEmptyState:
            return 'emptyState';
        case shouldShowPostConnectPromo:
            return 'postConnectPromo';
        case shouldShowNthPromo:
            return 'nthPromo';
        default:
            return null;
    }
}
function $63678eed770dbc39$export$df084516a74e0e8({ hasRecentItems: hasRecentItems }) {
    const config = (0, $2qVTE.useConnectorPromoConfig)({
        hasRecentItems: hasRecentItems
    });
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const promoVariant = $63678eed770dbc39$var$getNavSearchPromoVariant(config.shouldShowEmptyState, config.shouldShowPostConnectPromo, config.shouldShowNthPromo);
    (0, $42omo.useEffect)(()=>{
        if (!promoVariant) return;
        createEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'ConnectorPromoNavSearch',
                action: 'viewed',
                actionSubject: 'connectorPromo',
                attributes: {
                    promoVariant: promoVariant,
                    container: 'ConnectorPromoNavSearch'
                }
            }
        }).fire();
    }, [
        promoVariant,
        createEvent
    ]);
    if (config.shouldShowEmptyState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3c608f4d4f9fbc2$export$d97b992766bf7dd0), {
        recommendedConnectors: config.recommendedConnectors,
        onSetupConnector: config.onSetupConnector
    });
    if (config.shouldShowPostConnectPromo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4cebbcf422bcb464$export$4e5d60fc605801be), {
        connectedAppName: config.connectedAppName,
        nextRecommendedConnector: config.nextRecommendedConnector,
        onSetupConnector: config.onSetupConnector,
        onDismissPromo: ()=>config.onDismissPromo('banner')
    });
    if (config.shouldShowNthPromo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5656e12bfc0fb281$export$a0fd92de9ea67558), {
        recommendedConnectors: config.recommendedConnectors,
        onDismissPromo: ()=>config.onDismissPromo('banner')
    });
    return null;
}



var $kysoj = parcelRequire("kysoj");

const $5235a3f27f080bad$var$SEARCH_ROUTE_PRELOAD_DELAY = 500;
const $5235a3f27f080bad$var$QUICK_FIND_SEARCH_PERFORMED_EVENT_MUTATION = (0, $6a4b6bfe2e3e4030$export$2e2bcd8739ae039);
const $5235a3f27f080bad$var$generateUserUrl = (userId, orgId)=>{
    return (0, $9wGTI.fg)('confluence-adopt-teams-nav-config') ? (0, $6OL2O.getNavigateToTeamsApp)(orgId, {
        type: 'USER',
        payload: {
            userId: userId
        }
    }).href : `/wiki/people/${userId}`;
};
const $5235a3f27f080bad$var$generateTeamUrl = (teamId, orgId)=>{
    return (0, $9wGTI.fg)('confluence-adopt-teams-nav-config') ? (0, $6OL2O.getNavigateToTeamsApp)(orgId, {
        type: 'TEAM',
        payload: {
            teamId: teamId
        }
    }).href : `/wiki/people/team/${teamId}`;
};
const $5235a3f27f080bad$var$useTextParameter = (0, $dPJCf.createSingleQueryParamHook)('text');
/**
 * Component that handles the search performed event mutation.
 * Wrapped in UFOInteractionIgnore to prevent the mutation from creating UFO holds.
 */ const $5235a3f27f080bad$var$SearchPerformedEventEmitter = ({ cloudId: cloudId, setHandleSearchCompletedRef: setHandleSearchCompletedRef })=>{
    const [generateSearchPerformedEvent] = (0, $308Wd.useMutationInterop)($5235a3f27f080bad$var$QUICK_FIND_SEARCH_PERFORMED_EVENT_MUTATION, {
        __callerPackage__: "@confluence/navigation-search-dialog"
    });
    const handleSearchCompleted = (0, $42omo.useCallback)((resultCount, query)=>{
        if (!(0, $9wGTI.fg)('should_enable_confluence_search_performed_event')) return;
        generateSearchPerformedEvent({
            variables: {
                cloudId: cloudId,
                resultCount: resultCount || 0,
                query: query || '',
                timestamp: new Date().toISOString()
            }
        });
    }, [
        cloudId,
        generateSearchPerformedEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        setHandleSearchCompletedRef(handleSearchCompleted);
    }, [
        handleSearchCompleted,
        setHandleSearchCompletedRef
    ]);
    return null;
};
const $5235a3f27f080bad$export$8233bb098a93ad26 = (urlQueryParams)=>{
    const url = new URL('/wiki/search', window.location.origin);
    const searchParams = new URLSearchParams(window.location.search);
    Object.entries(urlQueryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
        else searchParams.delete(key);
    });
    url.search = searchParams.toString();
    return url.href;
};
const $5235a3f27f080bad$export$7d842d92e2721710 = ()=>{
    const [open, setOpen] = (0, $42omo.useState)(false);
    const { cloudId: cloudId, orgId: orgId, activationId: activationId, isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId, displayName: displayName, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push, preloadRoute: preloadRoute } = (0, $dPJCf.useRouteActions)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const inputRef = (0, $42omo.useRef)(null);
    const [persistedGhostText] = (0, $42omo.useState)(()=>(0, $kysoj.getPersistedGhostText)(inputRef));
    const onPersistGhostText = (0, $42omo.useCallback)((newGhostText)=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_PLATFORM_QUICKFIND_GHOSTTEXT, newGhostText);
    }, []);
    const textParameter = $5235a3f27f080bad$var$useTextParameter();
    const queryParams = (0, $42omo.useMemo)(()=>({
            text: textParameter
        }), [
        textParameter
    ]);
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            activationId: activationId,
            navdexPointType: (0, $56QzY.TOUCH)
        }), [
        activationId
    ]);
    const user = (0, $42omo.useMemo)(()=>({
            id: userId,
            name: displayName
        }), [
        userId,
        displayName
    ]);
    // We check if the experience is SearchPageLite here in order to disable
    // pre-loading the right panel query.
    const features = (0, $42omo.useMemo)(()=>({
            lite: {
                enabled: (0, $6mKj3.UNSAFE_expValNoExposure)('rovo_ui_refresh_in_confluence_search_page_exp', 'cohort', 'control') !== 'control'
            }
        }), []);
    const experimentLayers = (0, $1xpoY.default).getStringList('search_platform_layer_functions', []);
    const preloadDataProvider = (0, $3LDzU.usePreloadDataProvider)();
    const handleSearchCompletedRef = (0, $42omo.useRef)(()=>{});
    const setHandleSearchCompletedRef = (0, $42omo.useCallback)((callback)=>{
        handleSearchCompletedRef.current = callback;
    }, []);
    const onNavigate = (0, $42omo.useCallback)((url)=>push(url), [
        push
    ]);
    const universalNavigationShortcut = (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_NAVIGATION_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_NAVIGATION_SHORTCUT_WIN);
    const onGenerateUserUrl = (0, $42omo.useCallback)((userIdParam)=>$5235a3f27f080bad$var$generateUserUrl(userIdParam, orgId ?? ''), [
        orgId
    ]);
    const onGenerateTeamUrl = (0, $42omo.useCallback)((teamIdParam)=>$5235a3f27f080bad$var$generateTeamUrl(teamIdParam, orgId ?? ''), [
        orgId
    ]);
    const callbacks = (0, $42omo.useMemo)(()=>({
            onSearchCompleted: (resultCount, query)=>handleSearchCompletedRef.current(resultCount, query)
        }), []);
    const onOpenQuickFind = (0, $42omo.useCallback)(()=>setOpen(true), []);
    const { isEnabled: isConnectorOnboardingEnabled } = (0, $hSHFH.useIsConnectorOnboardingEnabled)();
    const renderConnectorPromo = (0, $42omo.useMemo)(()=>isConnectorOnboardingEnabled ? (hasRecentItems)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63678eed770dbc39$export$df084516a74e0e8), {
                hasRecentItems: hasRecentItems
            }) : undefined, [
        isConnectorOnboardingEnabled
    ]);
    const preloadedRef = (0, $42omo.useRef)(false);
    const onGenerateSearchUrlWithPreload = (0, $42omo.useCallback)((urlQueryParams)=>{
        const url = $5235a3f27f080bad$export$8233bb098a93ad26(urlQueryParams);
        if (!preloadedRef.current) setTimeout(()=>{
            const onIdle = window.requestIdleCallback || window.requestAnimationFrame || ((cb)=>setTimeout(cb, 0));
            onIdle(()=>preloadRoute(url));
        }, $5235a3f27f080bad$var$SEARCH_ROUTE_PRELOAD_DELAY);
        preloadedRef.current = true;
        return url;
    }, [
        preloadRoute
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1Jpy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5235a3f27f080bad$var$SearchPerformedEventEmitter, {
        cloudId: cloudId,
        setHandleSearchCompletedRef: setHandleSearchCompletedRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8b08557d75a416b$export$7d842d92e2721710), {
        cloudId: cloudId,
        orgId: orgId,
        primaryProduct: "confluence",
        features: features,
        analyticsAttributes: analyticsAttributes,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        isNav4Enabled: true,
        onNavigate: onNavigate,
        queryParams: queryParams,
        open: open,
        setOpen: setOpen,
        user: user,
        generateSearchUrl: onGenerateSearchUrlWithPreload,
        generateUserUrl: onGenerateUserUrl,
        generateTeamUrl: onGenerateTeamUrl,
        experimentLayers: experimentLayers,
        preloadDataProvider: preloadDataProvider,
        isRovoLLMEnabled: isRovoLLMEnabled,
        isSSR: renderServerPlaceholder,
        customPlaceholder: persistedGhostText,
        onGhostTextGenerated: onPersistGhostText,
        inputRef: inputRef,
        callbacks: callbacks,
        preQueryContent: renderConnectorPromo
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.NAVIGATION_SHORTCUT) : undefined,
        accelerator: isLiveEditMode || isOnEditRoute ? universalNavigationShortcut : [
            universalNavigationShortcut,
            (0, $gnkil.NAVIGATION_SLASH_SHORTCUT)
        ],
        listener: onOpenQuickFind,
        isAppNavigationShortcut: true
    }));
};
module.exports["generateSearchUrl"] = $5235a3f27f080bad$export$8233bb098a93ad26;
module.exports["QuickFind"] = $5235a3f27f080bad$export$7d842d92e2721710;

});

parcelRegister("2fSa3", function(module, exports) {

let $1a46fec0b89a2c42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1a46fec0b89a2c42$var$load("fMBJ8"),
    $1a46fec0b89a2c42$var$load("24X1R"),
    $1a46fec0b89a2c42$var$load("f7rhK"),
    $1a46fec0b89a2c42$var$load("1F7LX"),
    $1a46fec0b89a2c42$var$load("6XaQi")
]).then(()=>parcelRequire('hWyCW'));

});

parcelRegister("9Wtw1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fGpeA = parcelRequire("fGpeA");


var $jG8CA = parcelRequire("jG8CA");


var $bfemC = parcelRequire("bfemC");


var $c66Zr = parcelRequire("c66Zr");

const $6788b2028bdbad9b$export$92bc057879827fcf = (selector, options)=>{
    const { placementId: placementId = 'headless', messageTemplateId: messageTemplateId } = selector;
    const { match: match, validate: validate, dataSource: dataSource } = options ?? {};
    // Store match/validate in refs so inline arrow functions passed by callers don't cause
    // the useMemo to re-run on every render. The latest value is always read inside the memo.
    const matchRef = (0, $42omo.useRef)(match);
    matchRef.current = match;
    const validateRef = (0, $42omo.useRef)(validate);
    validateRef.current = validate;
    const { data: data, dismissedIds: dismissedIds, isLoading: isLoading, error: fetchError, dismissMessage: dismissMessage } = (0, $bfemC.usePlacementData)(placementId, {
        dataSource: dataSource
    });
    const { templateMessages: templateMessages, validationError: validationError } = (0, $42omo.useMemo)(()=>{
        if (!data) return {
            templateMessages: [],
            validationError: undefined
        };
        let candidates;
        try {
            const result = matchRef.current ? matchRef.current({
                data: data,
                matchBuilder: (0, $c66Zr.createMatchBuilder)()
            }) : data.messages ?? [];
            const resolved = (0, $c66Zr.isMatchBuilder)(result) ? result.match(data) : result;
            candidates = resolved;
        } catch (err) {
            if (err instanceof (0, $c66Zr.PlacementLocationError)) return {
                templateMessages: [],
                validationError: err
            };
            return {
                templateMessages: [],
                validationError: (0, $c66Zr.toHookError)(err)
            };
        }
        const templateMatches = candidates.filter((m)=>m.messageTemplateId === messageTemplateId);
        const guard = validateRef.current ?? (0, $c66Zr.isPlacementMessage);
        let failedCount;
        try {
            failedCount = templateMatches.filter((m_0)=>!guard(m_0)).length;
        } catch (err_0) {
            return {
                templateMessages: [],
                validationError: (0, $c66Zr.toHookError)(err_0)
            };
        }
        if (failedCount > 0) return {
            templateMessages: [],
            validationError: new (0, $c66Zr.PlacementValidationError)({
                placementId: placementId,
                failedCount: failedCount
            })
        };
        return {
            templateMessages: templateMatches,
            validationError: undefined
        };
    }, [
        data,
        messageTemplateId,
        placementId
    ]);
    const messages = (0, $42omo.useMemo)(()=>{
        return templateMessages.filter((m_1)=>!dismissedIds.has(m_1.messageInstanceId));
    }, [
        dismissedIds,
        templateMessages
    ]);
    // Build lookup from validated template data (not dismissed-filtered messages)
    // so dismissals and data refreshes don't change PostOfficeMessageInstance identity and remount callers.
    const messageByMessageInstanceId = (0, $42omo.useMemo)(()=>{
        const lookup = {};
        for (const message of templateMessages)lookup[message.messageInstanceId] = message;
        return lookup;
    }, [
        templateMessages
    ]);
    const messageByMessageInstanceIdRef = (0, $42omo.useRef)({});
    messageByMessageInstanceIdRef.current = messageByMessageInstanceId;
    // Single wrapper closed over placementId + messageTemplateId.
    // messageInstanceId is passed per-render by the caller.
    const PostOfficeMessageInstance = (0, $42omo.useMemo)(()=>{
        return (props)=>{
            const message_0 = messageByMessageInstanceIdRef.current[props.messageInstanceId];
            const messageCategory = message_0?.messageCategory;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fGpeA.PostOfficeMessage), {
                placementId: placementId,
                messageTemplateId: messageTemplateId,
                messageCategory: messageCategory,
                ...(0, $jG8CA.transformPlacementMessageToMessageLifecycleProps)({
                    message: message_0
                }),
                ...props
            });
        };
    }, [
        messageTemplateId,
        placementId
    ]);
    return {
        messages: messages,
        PostOfficeMessageInstance: PostOfficeMessageInstance,
        dismissedIds: dismissedIds,
        isLoading: isLoading,
        error: fetchError ?? validationError,
        dismissMessage: dismissMessage
    };
};
module.exports["useMessageInstances"] = $6788b2028bdbad9b$export$92bc057879827fcf;

});

parcelRegister("fGpeA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T9xHm = parcelRequire("T9xHm");


var $c6GJD = parcelRequire("c6GJD");


var $iX6G3 = parcelRequire("iX6G3");


var $4oTqF = parcelRequire("4oTqF");

var $GHZ06 = parcelRequire("GHZ06");

var $aCX5O = parcelRequire("aCX5O");

/**
 * Fires the Post Office "viewed" analytics events on mount.
 *
 * This is a separate inner component so that it only mounts when the choreographer
 * allows the message to render. It fires all three viewed events exactly once:
 *   - messageViewed() (legacy in-app lifecycle endpoint)
 *   - messageInstanceViewed()
 *   - messageInstanceDeliveredSuccessfully()
 *
 * Must be rendered inside a MessageContextProvider and PlacementProvider so that
 * useMessageViewed() can read the required context values.
 */ const $ec6aa4dcda46342c$var$ViewedOnMount = ()=>{
    const messageViewed = (0, $aCX5O.useMessageViewed)();
    (0, $42omo.useEffect)(()=>{
        messageViewed();
    // We intentionally omit deps — this should fire exactly once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
/**
 * Defers evaluation of the children render prop until the message is mounted.
 *
 * This ensures that any side effects in the render prop only execute when the
 * choreographer allows the message to render, not when it is blocked.
 */ const $ec6aa4dcda46342c$var$RenderedChildren = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = children();
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children());
};
const $ec6aa4dcda46342c$var$ChoreographedMessage = ({ children: children, messageId: messageId, useChoreographedRender: useChoreographedRender })=>{
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children) : null;
};
/**
 * Render-time Isolated Cloud gate.
 *
 * Returns `null` when the prop is enabled AND the tenant is in an Isolated Cloud
 * environment. Mirrors the headful behaviour wired by
 * `createBasePlacementComponentV2` (`options.hideInIsolatedCloud`).
 *
 * SSR handling is delegated to `isIsolatedCloud()` itself, which falls back to
 * `globalThis.ssrContext?.isInIC` when `document` is undefined.
 */ const $ec6aa4dcda46342c$var$IsolatedCloudGate = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children, hideInIsolatedCloud: hideInIsolatedCloud } = t0;
    if (hideInIsolatedCloud && (0, $T9xHm.isIsolatedCloud)()) return null;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children, hideInIsolatedCloud: hideInIsolatedCloud })=>{
    if (hideInIsolatedCloud && (0, $T9xHm.isIsolatedCloud)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
/**
 * Choreographer gating using the `ChoreographerContext` provided by
 * `StableChoreographerProvider` (from `@atlassian/post-office-context/choreographer`).
 *
 * When the choreographer is disabled or its factory is not yet loaded,
 * the message renders unconditionally.
 *
 * When `disableChoreographer` is `true`, the gate short-circuits and renders
 * children unconditionally — bypassing the choreographer entirely for this message.
 */ const $ec6aa4dcda46342c$var$ChoreographerGate = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, disableChoreographer: disableChoreographer } = t0;
    const { factory: choreographerFactory, choreographerEnabled: choreographerEnabled } = (0, $iX6G3.useChoreographerContext)();
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate("enable_choreographed_post_office_messages");
    if (disableChoreographer) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (choreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        const { shouldBeChoreographed: shouldBeChoreographed, useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            const useMessageTemplateIdAsChoreographerMessageId = (0, $c6GJD.default).checkGate("post-office_use_template_id_for_choreo");
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            let t1;
            if ($[2] !== children || $[3] !== choreographerMessageId || $[4] !== useChoreographedRender) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec6aa4dcda46342c$var$ChoreographedMessage, {
                    messageId: choreographerMessageId,
                    useChoreographedRender: useChoreographedRender
                }, children);
                $[2] = children;
                $[3] = choreographerMessageId;
                $[4] = useChoreographedRender;
                $[5] = t1;
            } else t1 = $[5];
            return t1;
        }
    }
    let t1;
    if ($[6] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[6] = children;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, disableChoreographer: disableChoreographer })=>{
    // Hooks must run on every render to preserve hook order — do not short-circuit
    // before calling them, even when `disableChoreographer` is set.
    const { factory: choreographerFactory, choreographerEnabled: choreographerEnabled } = (0, $iX6G3.useChoreographerContext)();
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    if (disableChoreographer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    if (choreographerFactory && choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        const { shouldBeChoreographed: shouldBeChoreographed, useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            const useMessageTemplateIdAsChoreographerMessageId = (0, $c6GJD.default).checkGate('post-office_use_template_id_for_choreo');
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec6aa4dcda46342c$var$ChoreographedMessage, {
                messageId: choreographerMessageId,
                useChoreographedRender: useChoreographedRender
            }, children);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $ec6aa4dcda46342c$export$7356a355af87a394 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, placementId: placementId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, disableChoreographer: disableChoreographer, hideInIsolatedCloud: hideInIsolatedCloud, children: children } = t0;
    let t1;
    if ($[0] !== configSetId || $[1] !== journeyId || $[2] !== journeyTriggerId || $[3] !== messageCategory || $[4] !== messageCreationType || $[5] !== messageInstanceId || $[6] !== messageTemplateId || $[7] !== triggerId) {
        t1 = {
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        };
        $[0] = configSetId;
        $[1] = journeyId;
        $[2] = journeyTriggerId;
        $[3] = messageCategory;
        $[4] = messageCreationType;
        $[5] = messageInstanceId;
        $[6] = messageTemplateId;
        $[7] = triggerId;
        $[8] = t1;
    } else t1 = $[8];
    const messageContext = t1;
    let t2;
    if ($[9] !== placementId) {
        t2 = {
            placementId: placementId
        };
        $[9] = placementId;
        $[10] = t2;
    } else t2 = $[10];
    const placementContext = t2;
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec6aa4dcda46342c$var$ViewedOnMount, null);
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec6aa4dcda46342c$var$RenderedChildren, null, children);
        $[12] = children;
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== disableChoreographer || $[15] !== messageCategory || $[16] !== messageInstanceId || $[17] !== messageTemplateId || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec6aa4dcda46342c$var$ChoreographerGate, {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            disableChoreographer: disableChoreographer
        }, t3, t4);
        $[14] = disableChoreographer;
        $[15] = messageCategory;
        $[16] = messageInstanceId;
        $[17] = messageTemplateId;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[20] !== messageContext || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4oTqF.MessageContextProvider), {
            value: messageContext
        }, t5);
        $[20] = messageContext;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== placementContext || $[24] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $GHZ06.PlacementProvider), {
            value: placementContext
        }, t6);
        $[23] = placementContext;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== hideInIsolatedCloud || $[27] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec6aa4dcda46342c$var$IsolatedCloudGate, {
            hideInIsolatedCloud: hideInIsolatedCloud
        }, t7);
        $[26] = hideInIsolatedCloud;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, placementId: placementId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, disableChoreographer: disableChoreographer, hideInIsolatedCloud: hideInIsolatedCloud, children: children })=>{
    const messageContext = (0, $42omo.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        }), [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        triggerId,
        messageCreationType,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const placementContext = (0, $42omo.useMemo)(()=>({
            placementId: placementId
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec6aa4dcda46342c$var$IsolatedCloudGate, {
        hideInIsolatedCloud: hideInIsolatedCloud
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $GHZ06.PlacementProvider), {
        value: placementContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4oTqF.MessageContextProvider), {
        value: messageContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec6aa4dcda46342c$var$ChoreographerGate, {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        disableChoreographer: disableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec6aa4dcda46342c$var$ViewedOnMount, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec6aa4dcda46342c$var$RenderedChildren, null, children)))));
};
module.exports["PostOfficeMessage"] = $ec6aa4dcda46342c$export$7356a355af87a394;

});

parcelRegister("jG8CA", function(module, exports) {
const $e00e051ebddd656d$var$transformMessageCreationTypeToPostOfficeMessageCreationType = ({ messageCreationType: messageCreationType })=>{
    if (messageCreationType === 'implicit' || messageCreationType === 'explicit') return messageCreationType;
    return undefined;
};
const $e00e051ebddd656d$export$61e95755e67323e4 = ({ message: message })=>({
        configSetId: message?.configSetId,
        journeyId: message?.journeyId,
        journeyTriggerId: message?.journeyTriggerId,
        messageCreationType: $e00e051ebddd656d$var$transformMessageCreationTypeToPostOfficeMessageCreationType({
            messageCreationType: message?.messageCreationType
        }),
        triggerId: message?.triggerId
    });
module.exports["transformPlacementMessageToMessageLifecycleProps"] = $e00e051ebddd656d$export$61e95755e67323e4;

});

parcelRegister("bfemC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $1eSke = parcelRequire("1eSke");

var $cpPWT = parcelRequire("cpPWT");

var $PAiZW = parcelRequire("PAiZW");


var $kO3gu = parcelRequire("kO3gu");


var $hy3a0 = parcelRequire("hy3a0");


var $fGpeA = parcelRequire("fGpeA");

/**
 * Foundation hook for the Post Office Headless API.
 *
 * Fetches raw Placement API data for a given `placementId` and tracks which
 * message instances have been dismissed in the current session via the Post
 * Office pub/sub system.
 *
 * All higher-level hooks (`useAllMessages`, `useMessageInstances`, `useMessageData`) compose on top
 * of this hook.
 *
 * Automatically reads the current `PostOfficeContext` (product, locale, tenantId, workspaceAri,
 * etc.) via `usePostOfficeContext` and forwards it to the Placement API request as query
 * parameters. No manual context threading is required.
 *
 * Requires `PlacementFetchingProvider` and `MessagePlacementProvider` (or
 * `PostOfficeProvider`) to be present in the React tree.
 *
 * @example
 * ```tsx
 * const { data, dismissedIds, isLoading, error, dismissMessage } = usePlacementData(
 *   'some-placement',
 * );
 *
 * const visibleMessages = data?.messages.filter(
 *   m => !dismissedIds.has(m.messageInstanceId)
 * ) ?? [];
 * ```
 *
 * @typeParam TMessage - A {@link PlacementMessageDiscriminant} or union thereof.
 *   Provide a union to model multiple template types with narrowable `context`:
 *   `usePlacementData<{ messageTemplateId: 'banner'; context: BannerCtx } | { messageTemplateId: 'flag'; context: FlagCtx }>(id)`
 * @typeParam TExtension - Additional top-level fields to expect in the `data` shape.
 * @param placementId - The ID of the placement to fetch data for. Defaults to `'headless'`.
 * @param options - Optional configuration. Pass `{ dataSource: 'DEV_SERVER' }` to point the hook
 *   at the local placement dev server (`yarn placement:v2 dev`, default port `4224`).
 * @see https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/6764207116
 */ /** Base URL used when `dataSource` is `'DEV_SERVER'`. Only included in non-production builds. */ const $00504543b217d74b$var$DEV_SERVER_BASE_URL = 'http://localhost:4224';
const $00504543b217d74b$export$a9668c1d52481a0f = (placementId = 'headless', options)=>{
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    const { onMessageDismiss: onMessageDismiss, dismissMessageFromPlacement: dismissMessageFromPlacement } = (0, $cpPWT.useMessagePlacementHooks)();
    const postOfficeContext = (0, $PAiZW.usePostOfficeContext)();
    const { dataSource: dataSource = 'PRODUCTION' } = options ?? {};
    const arePlacementsGloballyDisabled = (0, $dh538.fg)('post-office-enable-headless-disable-placement') && (0, $1eSke.isPostOfficePlacementsGloballyDisabled)(postOfficeContext);
    const placementIdToFetch = arePlacementsGloballyDisabled ? null : placementId;
    // When targeting the dev server, override the fetch so the request goes to
    // `http://localhost:4224` instead of the production gateway. The dev server
    // exposes the same URL path as production.
    let effectiveFetcher = fetcher;
    if (dataSource === 'DEV_SERVER') effectiveFetcher = {
        fetch: (url, init)=>{
            // Replace the origin with the dev server base URL, keeping the path intact.
            // Guard against SSR environments where window is not defined.
            const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
            const originalUrl = new URL(url, origin);
            const devUrl = `${$00504543b217d74b$var$DEV_SERVER_BASE_URL}${originalUrl.pathname}${originalUrl.search}`;
            return fetcher.fetch(devUrl, init);
        }
    };
    const response = (0, $hy3a0.useFetchPlacementData)(placementIdToFetch, 'headless', postOfficeContext, effectiveFetcher, undefined, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const [dismissedIds, setDismissedIds] = (0, $42omo.useState)(()=>new Set());
    // Synchronously reset dismissedIds in the render path when placementId changes.
    // A useEffect-based reset fires after paint, leaving a one-render window where
    // the new placement is painted with stale dismissed IDs from the previous one.
    // Calling setState during render causes React to discard this render and
    // immediately re-render with the new state; consumers never observe stale IDs.
    //
    // Infinite re-render safety — two independent guards prevent looping:
    //   1. prevPlacementIdRef.current is written BEFORE setDismissedIds is called.
    //      On the re-render React immediately triggers, the ref already equals
    //      placementId so the outer `if` is false — no further setState occurs.
    //   2. After the reset, dismissedIds.size === 0, so the inner size guard is
    //      also false — a second guard independent of the ref. Either alone is
    //      sufficient; both together make the loop prevention unconditional.
    // See: 'infinite re-render safety' tests in usePlacementData.test.tsx.
    const prevPlacementIdRef = (0, $42omo.useRef)(placementId);
    const placementChanged = prevPlacementIdRef.current !== placementId;
    // Return an empty set immediately on the first render with a new placementId —
    // including the discarded render that React produces when setState is called
    // during rendering. This ensures no render ever exposes stale dismissed IDs
    // from the previous placement, even transiently.
    // Reference stability: when dismissedIds is already empty we reuse the same
    // Set reference (no new object, no unnecessary re-render).
    const effectiveDismissedIds = placementChanged && dismissedIds.size > 0 ? new Set() : dismissedIds;
    if (placementChanged) {
        prevPlacementIdRef.current = placementId;
        // Only reset if the set is non-empty to avoid an unnecessary extra render.
        if (dismissedIds.size > 0) setDismissedIds(new Set());
    }
    // Subscribe to pub/sub dismiss events on mount, unsubscribe on unmount.
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = onMessageDismiss(({ messageInstanceId: messageInstanceId })=>{
            setDismissedIds((prev)=>{
                // Guard: do not create a new Set reference if the ID is already dismissed.
                if (prev.has(messageInstanceId)) return prev;
                return new Set([
                    ...prev,
                    messageInstanceId
                ]);
            });
        });
        return unsubscribe;
    }, [
        onMessageDismiss
    ]);
    const dismissMessage = (0, $42omo.useCallback)((messageInstanceId_0)=>{
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId_0
        });
    }, [
        dismissMessageFromPlacement
    ]);
    const { isLoading: isLoading, error: error } = response;
    const PostOfficePlacementMessage = (0, $42omo.useMemo)(()=>({ messageInstanceId: messageInstanceId_1, messageTemplateId: messageTemplateId, messageCategory: messageCategory, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fGpeA.PostOfficeMessage), {
                messageInstanceId: messageInstanceId_1,
                messageTemplateId: messageTemplateId,
                placementId: placementId,
                messageCategory: messageCategory,
                triggerId: triggerId,
                messageCreationType: messageCreationType,
                journeyId: journeyId,
                journeyTriggerId: journeyTriggerId,
                configSetId: configSetId
            }, children), [
        placementId
    ]);
    return {
        data: response.data?.data,
        errors: response.data?.errors ?? [],
        dismissedIds: effectiveDismissedIds,
        isLoading: isLoading,
        error: error,
        dismissMessage: dismissMessage,
        PostOfficePlacementMessage: PostOfficePlacementMessage
    };
};
module.exports["usePlacementData"] = $00504543b217d74b$export$a9668c1d52481a0f;

});

parcelRegister("c66Zr", function(module, exports) {
/** Shared utilities for post-office headless API hooks. */ class $30b840a2f1329db2$export$70abd424e1cca8c3 extends Error {
    constructor({ placementId: placementId, failedCount: failedCount }){
        super('One or more messages failed structural validation');
        this.name = 'PlacementValidationError';
        this.placementId = void 0;
        this.failedCount = void 0;
        this.placementId = placementId;
        this.failedCount = failedCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $30b840a2f1329db2$export$fc2b8b9bcb86a0d0 extends Error {
    constructor({ placementId: placementId, messageTemplateId: messageTemplateId, instanceCount: instanceCount }){
        super('Multiple message instances found; the hook is in an unexpected state and no message will be returned. Use useMessageInstances if multiple instances are expected.');
        this.name = 'MultipleMessageInstancesError';
        this.placementId = void 0;
        this.messageTemplateId = void 0;
        this.instanceCount = void 0;
        this.placementId = placementId;
        this.messageTemplateId = messageTemplateId;
        this.instanceCount = instanceCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $30b840a2f1329db2$export$17455b84f403213b extends Error {
    constructor({ locationKey: locationKey, invalidCount: invalidCount }){
        super('All items at the message location must be valid PlacementMessage objects');
        this.name = 'PlacementLocationError';
        this.locationKey = void 0;
        this.invalidCount = void 0;
        this.locationKey = locationKey;
        this.invalidCount = invalidCount;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
const $30b840a2f1329db2$export$a8ba7e6c095216ec = (item)=>{
    if (typeof item !== 'object' || item === null) return false;
    const msg = item;
    return typeof msg.messageTemplateId === 'string' && typeof msg.messageInstanceId === 'string' && typeof msg.context === 'object' && msg.context !== null;
};
const $30b840a2f1329db2$export$8364e41b11fd7d3b = (thrown, fallbackMessage = 'Hook callback threw')=>{
    if (thrown instanceof Error) return thrown;
    if (typeof thrown === 'string') return new Error(thrown);
    return new Error(fallbackMessage);
};
// Match Builder
/** @internal — used to tag match-builder objects in place of `instanceof`. */ const $30b840a2f1329db2$var$MATCH_BUILDER_TAG = Symbol('MatchBuilder');
/** @internal — creates a builder with the given accumulated state (location already resolved). */ const $30b840a2f1329db2$var$makeMatchBuilder = (locationKey, contextPredicates, dataPredicates)=>{
    const builder = {
        messageContext (predicate) {
            return $30b840a2f1329db2$var$makeMatchBuilder(locationKey, [
                ...contextPredicates,
                predicate
            ], dataPredicates);
        },
        custom (predicate) {
            return $30b840a2f1329db2$var$makeMatchBuilder(locationKey, contextPredicates, [
                ...dataPredicates,
                predicate
            ]);
        },
        match (data) {
            if (dataPredicates.some((p)=>!p(data))) return [];
            const raw = data[locationKey] ?? [];
            if (!Array.isArray(raw)) throw new $30b840a2f1329db2$export$17455b84f403213b({
                locationKey: locationKey,
                invalidCount: 1
            });
            const items = raw;
            const invalidCount = items.filter((item)=>!$30b840a2f1329db2$export$a8ba7e6c095216ec(item)).length;
            if (invalidCount > 0) throw new $30b840a2f1329db2$export$17455b84f403213b({
                locationKey: locationKey,
                invalidCount: invalidCount
            });
            const candidates = items;
            return candidates.filter((message)=>contextPredicates.every((p)=>p(message.context)));
        }
    };
    // Tag the builder with a non-enumerable symbol so isMatchBuilder can identify it without
    // relying on instanceof (which would break across module boundaries or after minification).
    Object.defineProperty(builder, $30b840a2f1329db2$var$MATCH_BUILDER_TAG, {
        value: true,
        enumerable: false
    });
    return builder;
};
/** @internal — creates the initial builder with `messageLocation` available. */ const $30b840a2f1329db2$var$makeInitialMatchBuilder = ()=>{
    const initial = {
        messageLocation (key) {
            return $30b840a2f1329db2$var$makeMatchBuilder(key, [], []);
        },
        messageContext (predicate) {
            return $30b840a2f1329db2$var$makeMatchBuilder('messages', [
                predicate
            ], []);
        },
        custom (predicate) {
            return $30b840a2f1329db2$var$makeMatchBuilder('messages', [], [
                predicate
            ]);
        },
        match (data) {
            return $30b840a2f1329db2$var$makeMatchBuilder('messages', [], []).match(data);
        }
    };
    Object.defineProperty(initial, $30b840a2f1329db2$var$MATCH_BUILDER_TAG, {
        value: true,
        enumerable: false
    });
    return initial;
};
const $30b840a2f1329db2$export$be507563b85af550 = (value)=>{
    return typeof value === 'object' && value !== null && value[$30b840a2f1329db2$var$MATCH_BUILDER_TAG] === true;
};
const $30b840a2f1329db2$export$861b204abcaa015d = ()=>$30b840a2f1329db2$var$makeInitialMatchBuilder();
module.exports["PlacementValidationError"] = $30b840a2f1329db2$export$70abd424e1cca8c3;
module.exports["PlacementLocationError"] = $30b840a2f1329db2$export$17455b84f403213b;
module.exports["isPlacementMessage"] = $30b840a2f1329db2$export$a8ba7e6c095216ec;
module.exports["toHookError"] = $30b840a2f1329db2$export$8364e41b11fd7d3b;
module.exports["isMatchBuilder"] = $30b840a2f1329db2$export$be507563b85af550;
module.exports["createMatchBuilder"] = $30b840a2f1329db2$export$861b204abcaa015d;

});

parcelRegister("6bBtb", function(module, exports) {

let $4810d5d6f8b33e29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4810d5d6f8b33e29$var$load("6XKPV").then(()=>parcelRequire('oQtlV'));

});

parcelRegister("3fAff", function(module, exports) {
// Pure product key constants imported from product-keys.ts (source of truth).
// Re-exported below so existing consumers continue to work.
const $d8789f431482b57c$export$17120d8212b6e08f = (productKey)=>productKey ? productKey.toUpperCase() : undefined;
module.exports["getUppercasePrimaryProductKey"] = $d8789f431482b57c$export$17120d8212b6e08f;

});

parcelRegister("5qcsY", function(module, exports) {
const $1df9c13587cb1baf$export$3c42ae83d2ed6731 = (event)=>{
    return {
        ...event,
        attributes: {
            ...event.attributes.additionalAttributes
        }
    };
};
module.exports["remapVitalStatsEventForQuickFind"] = $1df9c13587cb1baf$export$3c42ae83d2ed6731;

});

parcelRegister("6FG5J", function(module, exports) {
var $2408c829587bdd21$export$37f28874ca0f7950 = /*#__PURE__*/ function(ZeroQueryProduct) {
    ZeroQueryProduct["CONFLUENCE"] = "CONFLUENCE";
    ZeroQueryProduct["JIRA"] = "JIRA";
    ZeroQueryProduct["GOOGLE"] = "GOOGLE";
    ZeroQueryProduct["SLACK"] = "SLACK";
    ZeroQueryProduct["SHAREPOINT"] = "SHAREPOINT";
    return ZeroQueryProduct;
}({});
var $2408c829587bdd21$export$9573eaa7882f441b = /*#__PURE__*/ function(ZeroQueryDateRange) {
    ZeroQueryDateRange["TODAY"] = "today";
    ZeroQueryDateRange["YESTERDAY"] = "yesterday";
    ZeroQueryDateRange["PAST_7_DAYS"] = "past7days";
    ZeroQueryDateRange["PAST_30_DAYS"] = "past30days";
    return ZeroQueryDateRange;
}({});
var $2408c829587bdd21$export$32809655ff50de86 = /*#__PURE__*/ function(ZeroQueryType) {
    ZeroQueryType["COLLABORATOR_PROFILE"] = "COLLABORATOR_PROFILE";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED"] = "CONFLUENCE_PAGES_CREATED";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_30_DAYS"] = "CONFLUENCE_PAGES_CREATED_30_DAYS";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_7_DAYS"] = "CONFLUENCE_PAGES_CREATED_7_DAYS";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_COLLABORATOR"] = "CONFLUENCE_PAGES_CREATED_COLLABORATOR";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS"] = "CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS";
    ZeroQueryType["CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS"] = "CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS";
    ZeroQueryType["JIRA_MY_WORK_ITEMS"] = "JIRA_MY_WORK_ITEMS";
    ZeroQueryType["JIRA_NLQ"] = "JIRA_NLQ";
    ZeroQueryType["JIRA_NLQ_COLLABORATOR"] = "JIRA_NLQ_COLLABORATOR";
    ZeroQueryType["JIRA_TICKETS_ASSIGNED"] = "JIRA_TICKETS_ASSIGNED";
    ZeroQueryType["JIRA_TICKETS_ASSIGNED_COLLABORATOR"] = "JIRA_TICKETS_ASSIGNED_COLLABORATOR";
    ZeroQueryType["JIRA_TICKETS_CREATED"] = "JIRA_TICKETS_CREATED";
    ZeroQueryType["JIRA_TICKETS_CREATED_COLLABORATOR"] = "JIRA_TICKETS_CREATED_COLLABORATOR";
    ZeroQueryType["RECENT_WORK"] = "RECENT_WORK";
    ZeroQueryType["RELATED_QUESTION"] = "RELATED_QUESTION";
    ZeroQueryType["THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS"] = "THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS";
    ZeroQueryType["THIRD_PARTY_GOOGLE_MY_DOCS"] = "THIRD_PARTY_GOOGLE_MY_DOCS";
    ZeroQueryType["THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS"] = "THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS";
    ZeroQueryType["THIRD_PARTY_SHAREPOINT_MY_DOCS"] = "THIRD_PARTY_SHAREPOINT_MY_DOCS";
    ZeroQueryType["THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES"] = "THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES";
    ZeroQueryType["THIRD_PARTY_SLACK_MY_MESSAGES"] = "THIRD_PARTY_SLACK_MY_MESSAGES";
    ZeroQueryType["WHO_IS"] = "WHO_IS";
    return ZeroQueryType;
}({});
module.exports["ZeroQueryProduct"] = $2408c829587bdd21$export$37f28874ca0f7950;
module.exports["ZeroQueryDateRange"] = $2408c829587bdd21$export$9573eaa7882f441b;
module.exports["ZeroQueryType"] = $2408c829587bdd21$export$32809655ff50de86;

});

parcelRegister("hWR4v", function(module, exports) {
var $410f9d395e302635$export$3ca4051c67b8ec7b = /*#__PURE__*/ function(ActivityProduct) {
    ActivityProduct["JIRA"] = "jira";
    ActivityProduct["CONFLUENCE"] = "confluence";
    ActivityProduct["ATLAS"] = "townsquare";
    ActivityProduct["GRAPH"] = "graph";
    ActivityProduct["ASSETS"] = "assets";
    ActivityProduct["GITHUB"] = "github";
    ActivityProduct["LOOM"] = "loom";
    return ActivityProduct;
}({});
var $410f9d395e302635$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    return VIEWED_EVENT;
}({});
var $410f9d395e302635$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $410f9d395e302635$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory["DOCUMENT"] = "DOCUMENT";
    ExternalDocumentCategory["PRESENTATION"] = "PRESENTATION";
    ExternalDocumentCategory["SPREADSHEET"] = "SPREADSHEET";
    return ExternalDocumentCategory;
}($410f9d395e302635$var$ExternalDocumentCategory || {});
const $410f9d395e302635$export$b7d2f1faf131fc56 = (activity)=>{
    return activity.type === 'remote-link';
};
const $410f9d395e302635$export$8d4b7c5856642df3 = (activity)=>{
    return activity.type === 'document';
};
const $410f9d395e302635$export$ed71d50c78c3618b = (activity)=>{
    return activity.product === 'graph';
};
const $410f9d395e302635$export$11ceef76bf1f45cb = (activity)=>{
    return activity.product === 'github';
};
const $410f9d395e302635$export$d26e891d2764b7d7 = (activity)=>{
    return activity.product === 'confluence' || activity.product === 'jira' || activity.product === 'townsquare';
};
const $410f9d395e302635$export$3ec7f2aeaa1c6076 = (activity)=>{
    return activity.product === "assets";
};
const $410f9d395e302635$export$41687a53e611f724 = (activity)=>{
    return activity.product === "loom";
};
const $410f9d395e302635$export$91ddde0d7e8e9119 = (activity)=>{
    return activity.product === "graph" && activity.type === 'pull-request';
};
const $410f9d395e302635$export$78b71c148e882a97 = (activity)=>{
    return activity.product === "graph" && activity.type === 'work-item';
};
module.exports["ActivityProduct"] = $410f9d395e302635$export$3ca4051c67b8ec7b;
module.exports["isRemoteLinkActivity"] = $410f9d395e302635$export$b7d2f1faf131fc56;
module.exports["isDocumentActivity"] = $410f9d395e302635$export$8d4b7c5856642df3;
module.exports["isGraphActivity"] = $410f9d395e302635$export$ed71d50c78c3618b;
module.exports["isGithubActivity"] = $410f9d395e302635$export$11ceef76bf1f45cb;
module.exports["is1PActivity"] = $410f9d395e302635$export$d26e891d2764b7d7;
module.exports["isAssetsActivity"] = $410f9d395e302635$export$3ec7f2aeaa1c6076;
module.exports["isLoomActivity"] = $410f9d395e302635$export$41687a53e611f724;
module.exports["isGraphPullRequestActivity"] = $410f9d395e302635$export$91ddde0d7e8e9119;
module.exports["isGraphWorkItemActivity"] = $410f9d395e302635$export$78b71c148e882a97;

});

parcelRegister("bbJes", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9ae989161e32c463035303e756b6dca8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8253cef9e63cbd0e$var$_react = $8253cef9e63cbd0e$var$_interopRequireDefault((parcelRequire("42omo")));

var $8253cef9e63cbd0e$var$_baseNew = $8253cef9e63cbd0e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8253cef9e63cbd0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Return".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for submitting text fields without dedicated button, mainly AI prompts
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8253cef9e63cbd0e$var$ReturnIcon = (props)=>/*#__PURE__*/ $8253cef9e63cbd0e$var$_react.default.createElement($8253cef9e63cbd0e$var$_baseNew.default, Object.assign({
        name: "ReturnIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 8V3H14v5.438c0 .586-.476 1.062-1.062 1.062H4.56l2.72 2.72-1.061 1.06-4-4a.75.75 0 0 1 0-1.06l4-4 1.06 1.06L4.56 8z" clip-rule="evenodd"/>`
    }, props));
$8253cef9e63cbd0e$var$ReturnIcon.displayName = 'ReturnIcon';
var $8253cef9e63cbd0e$var$_default = module.exports.default = $8253cef9e63cbd0e$var$ReturnIcon;

});

parcelRegister("26eSY", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");


var $j3O94 = parcelRequire("j3O94");


var $gjFIy = parcelRequire("gjFIy");

function $81e208d7c03fb2bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $81e208d7c03fb2bd$var$showAboveQueries = (0, $j3O94.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $81e208d7c03fb2bd$var$showBelowQueries = (0, $gjFIy.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $81e208d7c03fb2bd$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $81e208d7c03fb2bd$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $81e208d7c03fb2bd$var$defaultHiddenStyles,
            above && $81e208d7c03fb2bd$var$showAboveQueries[above],
            below && $81e208d7c03fb2bd$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Show"] = $81e208d7c03fb2bd$export$f6a3d19be20f5819;

});

parcelRegister("j3O94", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $9K4OG = parcelRequire("9K4OG");


var $1LBzd = parcelRequire("1LBzd");


var $dhECE = parcelRequire("dhECE");

const $0e33cce764fb92cd$export$918f8818cfbbeb2c = (input)=>{
    return (0, $1LBzd.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $dhECE.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
module.exports["UNSAFE_buildAboveMediaQueryCSS"] = $0e33cce764fb92cd$export$918f8818cfbbeb2c;

});

parcelRegister("1LBzd", function(module, exports) {
const $a161739fae125cf6$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $a161739fae125cf6$export$2d293d9871c38e91 = Object.keys($a161739fae125cf6$export$e5ee4fe8b989fd09);
const $a161739fae125cf6$export$b7ed752a57b4177b = $a161739fae125cf6$export$2d293d9871c38e91[0];
module.exports["UNSAFE_BREAKPOINTS_ORDERED_LIST"] = $a161739fae125cf6$export$2d293d9871c38e91;

});

parcelRegister("gjFIy", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $9K4OG = parcelRequire("9K4OG");


var $1LBzd = parcelRequire("1LBzd");


var $bWLcG = parcelRequire("bWLcG");

const $2c6e513510594637$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $1LBzd.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $bWLcG.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};
module.exports["UNSAFE_buildBelowMediaQueryCSS"] = $2c6e513510594637$export$b2a4e2b0c6417297;

});

parcelRegister("c49EN", function(module, exports) {
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ parcelRequire("42omo");

const $3120f67f4a099988$export$eed5b9b4caf40e24 = (thirdPartyConfigs, providerId)=>{
    if (!providerId) return undefined;
    const [_id, config] = Object.entries(thirdPartyConfigs).find(([, config])=>config?.providerId === providerId) || [];
    if (!config) return undefined;
    return config.displayName;
};
module.exports["getProductDisplayNameFromProviderId"] = $3120f67f4a099988$export$eed5b9b4caf40e24;

});

parcelRegister("6QzpZ", function(module, exports) {

var $6h3V2 = parcelRequire("6h3V2");


var $b4tvS = parcelRequire("b4tvS");

const $88d201103aa15863$export$f2c90bb8548eb326 = ({ thirdPartyId: thirdPartyId })=>{
    try {
        if (thirdPartyId) {
            const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(thirdPartyId);
            const resourceType = resourceOwner.split('.')[1];
            const productKey = resourceType === 'google-drive' || resourceType === 'google-drive-lite' ? 'drive' : resourceType || '';
            if ((0, $b4tvS.is3pProductKey)(productKey)) return productKey;
        }
        return undefined;
    } catch (e) {
        // If parsing fails, we default to undefined
        return undefined;
    }
};
module.exports["getProductFromThirdPartyId"] = $88d201103aa15863$export$f2c90bb8548eb326;

});

parcelRegister("6h3V2", function(module, exports) {

var $7MEO5 = parcelRequire("7MEO5");

const $1c92067bef9e66d6$export$d8a746fe35b1c95d = (ari)=>{
    const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $1c92067bef9e66d6$export$fccbae65febb6fd4(ari) ? $1c92067bef9e66d6$export$2f432ca99e30467e(ari) : (0, $7MEO5.parse)(ari);
    return [
        resourceOwner,
        cloudId,
        resourceType,
        resourceId
    ];
};
const $1c92067bef9e66d6$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $1c92067bef9e66d6$export$2f432ca99e30467e = (ari)=>{
    const result = $1c92067bef9e66d6$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$1c92067bef9e66d6$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner, resourceType, resourceId] = result;
    return {
        resourceId: resourceId,
        resourceOwner: resourceOwner,
        resourceType: resourceType,
        cloudId: resourceId
    };
};
const $1c92067bef9e66d6$export$fccbae65febb6fd4 = (ari)=>$1c92067bef9e66d6$var$thirdPartyRegex.test(ari);
module.exports["getProductAndIDFromARI"] = $1c92067bef9e66d6$export$d8a746fe35b1c95d;
module.exports["parseThirdPartyARI"] = $1c92067bef9e66d6$export$2f432ca99e30467e;

});

parcelRegister("i71YS", function(module, exports) {

let $d2fa6ad3ed3d9d5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2fa6ad3ed3d9d5b$var$load("3VIZM"),
    $d2fa6ad3ed3d9d5b$var$load("gyh6H"),
    $d2fa6ad3ed3d9d5b$var$load("9q75n"),
    $d2fa6ad3ed3d9d5b$var$load("iYHbd"),
    $d2fa6ad3ed3d9d5b$var$load("cHb2G"),
    $d2fa6ad3ed3d9d5b$var$load("hhss7"),
    $d2fa6ad3ed3d9d5b$var$load("Wowvf"),
    $d2fa6ad3ed3d9d5b$var$load("3GuOt"),
    $d2fa6ad3ed3d9d5b$var$load("dYtBN"),
    $d2fa6ad3ed3d9d5b$var$load("kNV5Y"),
    $d2fa6ad3ed3d9d5b$var$load("6wr18"),
    $d2fa6ad3ed3d9d5b$var$load("gT8XU"),
    $d2fa6ad3ed3d9d5b$var$load("lE8tR"),
    $d2fa6ad3ed3d9d5b$var$load("alA4m"),
    $d2fa6ad3ed3d9d5b$var$load("ffEVr"),
    $d2fa6ad3ed3d9d5b$var$load("oTA4y"),
    $d2fa6ad3ed3d9d5b$var$load("fPbCp"),
    $d2fa6ad3ed3d9d5b$var$load("kuFG2"),
    $d2fa6ad3ed3d9d5b$var$load("EfTik")
]).then(()=>parcelRequire('1JhVb'));

});

parcelRegister("abk4V", function(module, exports) {

var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $bq5dG = parcelRequire("bq5dG");

const $24d5352d830b0390$var$accountsByAaIdCache = (0, $jnPv4.promiseCache)({
    name: 'accounts-by-aaid-cache',
    expiration: 1800000 // 30 minutes
});
const $24d5352d830b0390$export$75264ee4f9af0fe1 = async ({ aaid: aaid, onlyRefreshIfExpired: onlyRefreshIfExpired = true, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired = false })=>{
    const supplier = ()=>{
        const accountsPromise = (0, $bq5dG.fetchAccountsByAaIdInternal)(aaid);
        const degrader = new (0, $3Tbc2.DegradablePromise)(accountsPromise, degradationCallback);
        return degrader.promise();
    };
    const cacheKey = aaid;
    return $24d5352d830b0390$var$accountsByAaIdCache.refreshOnAccessDecorator({
        key: cacheKey,
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback
    });
};
module.exports["fetchAccountsByAaId"] = $24d5352d830b0390$export$75264ee4f9af0fe1;

});

parcelRegister("bq5dG", function(module, exports) {

var $5JS4G = parcelRequire("5JS4G");

const $1f53484aa42645a4$export$8fc8913ba4f36c51 = async (aaid)=>{
    const url = `/gateway/api/outbound-auth/aaId/${aaid}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new (0, $5JS4G.OutboundAuthApiError)('Failed to fetch accounts by aaId');
    return await response.json();
};
module.exports["fetchAccountsByAaIdInternal"] = $1f53484aa42645a4$export$8fc8913ba4f36c51;

});

parcelRegister("5JS4G", function(module, exports) {
/**
 * Type definitions for Outbound Auth service responses
 *
 * These types mirror the response models from the outbound-auth service.
 * Source of truth: https://bitbucket.org/atlassian/outbound-auth/
 * Reference implementation: /src/service/accountManagement.ts
 * API Spec: /docs/content/platform/outbound-auth/swagger.yaml
 */ /**
 * Include fields for controlling what data is returned in account responses
 * Mirrors AtlassianAuthAccount.IncludeFields from outbound-auth service
 */ var $f5db1b1a2bd17d33$export$9e1d8c9863da0d81 = /*#__PURE__*/ function(IncludeFields) {
    IncludeFields["AccessToken"] = "accessToken";
    IncludeFields["DisplayName"] = "displayName";
    IncludeFields["AaId"] = "aaId";
    IncludeFields["AvatarUrl"] = "avatarUrl";
    IncludeFields["ExternalAccountId"] = "externalAccountId";
    IncludeFields["Expiry"] = "expiry";
    return IncludeFields;
}({});
class $f5db1b1a2bd17d33$export$7f02dcf7cf9277d8 extends Error {
    constructor(message){
        super(message);
        this.name = 'OutboundAuthApiError';
    }
}
module.exports["OutboundAuthApiError"] = $f5db1b1a2bd17d33$export$7f02dcf7cf9277d8;

});

parcelRegister("7ULiR", function(module, exports) {

var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $ef802 = parcelRequire("ef802");

const $1201c3527525730b$var$outboundAuthCache = (0, $jnPv4.promiseCache)({
    name: 'outbound-auth-cache',
    expiration: 300000 // 5 minutes
});
const $1201c3527525730b$export$d4802be6b6981d7f = async ({ aaid: aaid, containerId: containerId, serviceKey: serviceKey, onlyRefreshIfExpired: onlyRefreshIfExpired = true, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired = false })=>{
    const supplier = ()=>{
        const outboundAuthPromise = (0, $ef802.fetchOutboundAuthDataInternal)(aaid, containerId, serviceKey);
        const degrader = new (0, $3Tbc2.DegradablePromise)(outboundAuthPromise, degradationCallback);
        return degrader.promise();
    };
    const cacheKey = `${aaid}-${containerId}-${serviceKey}`;
    return $1201c3527525730b$var$outboundAuthCache.refreshOnAccessDecorator({
        key: cacheKey,
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback
    });
};
module.exports["fetchOutboundAuthData"] = $1201c3527525730b$export$d4802be6b6981d7f;

});

parcelRegister("kJsRi", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

function $e6b26cca3d43530b$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $4u5NT.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}
module.exports["setInteractionError"] = $e6b26cca3d43530b$export$5b689ca7b019e89f;

});

parcelRegister("3paC4", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $jppmC = parcelRequire("jppmC");

const $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY = 3;
const $6b372c322d10f06f$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY);
};
class $6b372c322d10f06f$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $6b372c322d10f06f$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $jppmC.timed)(this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $6b372c322d10f06f$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $6b372c322d10f06f$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $6b372c322d10f06f$export$5d730b7aed1a3eb0;

});

parcelRegister("jppmC", function(module, exports) {
const $e3bb250125deb745$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $e3bb250125deb745$export$d35186a762cd39c8;

});

parcelRegister("iUYhn", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $4cce666965dd4176$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $4cce666965dd4176$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $4cce666965dd4176$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $4cce666965dd4176$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $4cce666965dd4176$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $4cce666965dd4176$export$775b6bb06e53a214;

});

parcelRegister("efKMM", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $dh538 = parcelRequire("dh538");


var $lzcvT = parcelRequire("lzcvT");

const $04156c9e070ba3df$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $dh538.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            return (0, $5spQU.isFeatureEnabled)('confluence', featureKeyMap[contentType]);
        }
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $04156c9e070ba3df$export$dd376e644565eb89;

});

parcelRegister("hm6w9", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $6yCpa = parcelRequire("6yCpa");


var $dbl1i = parcelRequire("dbl1i");


var $4OGlb = parcelRequire("4OGlb");


var $2hfy2 = parcelRequire("2hfy2");

const $f62b6f09dac42d3d$export$2f6c9ab85be44d1a = (onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    if (shouldNotGetBackendExperiment) return;
    return $f62b6f09dac42d3d$var$getParallelBackendExperimentsConfig(onErrorFn, getLayerValuesFn ?? $f62b6f09dac42d3d$export$3178593b0bf95121);
};
const $f62b6f09dac42d3d$export$3178593b0bf95121 = (layerName, options)=>{
    const layer = (0, $c6GJD.default).getLayer(layerName, {
        ...options?.fireLayerExposure === false ? {
            fireLayerExposure: false
        } : {}
    });
    const layerNameWithoutSuffix = layerName.replace('_standard', '').replace('_premium', '');
    return {
        name: layerNameWithoutSuffix,
        layerId: layer.get('layerId', 'default'),
        shadowId: layer.get('shadowId', null),
        // The below values might not be sent to the backend but we can still track them in the frontend
        controlId: layer.get('controlId', null),
        abTestId: layer.get('abTestId', 'no_ab_test_id'),
        ...(0, $c6GJD.default).checkGate('search-experiment-overrides-backend') && {
            testId: layer.get('testId', null)
        }
    };
};
const $f62b6f09dac42d3d$export$f0d0c69a221c32ee = (onError, fireLayerExposure = true, getLayerValuesFn)=>{
    try {
        const layer = (0, $c6GJD.default).getLayer((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), fireLayerExposure ? {} : {
            fireLayerExposure: false
        });
        let abTestId;
        let rawLayerFunctions;
        if (getLayerValuesFn) {
            const layerResult = getLayerValuesFn((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), fireLayerExposure ? {} : {
                fireLayerExposure: false
            });
            abTestId = layerResult.abTestId ?? 'no_ab_test_id';
            rawLayerFunctions = layerResult.layerFunctions ?? [];
        } else {
            abTestId = layer.get('abTestId', 'no_ab_test_id');
            rawLayerFunctions = layer.get('layerFunctions', []);
        }
        const layerFunctions = (0, $dbl1i.mutuallyExclusiveBackendSearchLogicParametersSchema).safeParse(rawLayerFunctions).data;
        return {
            layerFunctions: layerFunctions || [],
            abTestId: abTestId,
            // The get 'mutualExclusion' is breaking in Jira when retrieving a boolean value from layer,
            // so for the compatibility, we use the abTestId to determine if it's a mutually exclusive experiment
            mutualExclusion: abTestId !== 'no_ab_test_id'
        };
    } catch (error) {
        onError?.(error);
    }
};
const $f62b6f09dac42d3d$export$ad31a6212fa2b02c = (layerName, onError)=>{
    try {
        const layer = (0, $c6GJD.default).getLayer(layerName);
        const layerValues = {
            l1Id: layer.get('l1Id', 'default'),
            l1Entity: layer.get('l1Entity', '*'),
            l2Id: layer.get('l2Id', 'default'),
            l2Entity: layer.get('l2Entity', '*'),
            l3Id: layer.get('l3Id', 'default'),
            qrId: layer.get('qrId', 'default'),
            abTestId: layer.get('abTestId', 'no_ab_test_id'),
            /**
       * This is a map of UI features that are enabled for the combined experiment.
       * for example:
       * {
       * 	uiFeature1: true,
       * 	uiFeature2: false,
       * }
       */ uiFeatures: layer.get('uiFeatures', {}),
            controlId: layer.get('controlId', 'default'),
            enabled: layer.get('enabled', false)
        };
        return layerValues;
    } catch (error) {
        onError?.(error);
    }
};
const $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues = (featureGateName, standardLayerName, premiumLayerName, resolveLayerValues = $f62b6f09dac42d3d$export$3178593b0bf95121)=>{
    const isPremium = (0, $c6GJD.default).checkGate(featureGateName);
    if (isPremium) return resolveLayerValues(premiumLayerName);
    return resolveLayerValues(standardLayerName);
};
const $f62b6f09dac42d3d$var$getParallelBackendExperimentsConfig = (onErrorFn, resolveLayerValues = $f62b6f09dac42d3d$export$3178593b0bf95121)=>{
    try {
        const allLayers = [];
        const layer1 = $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM), resolveLayerValues);
        allLayers.push(layer1);
        const layer2 = $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM), resolveLayerValues);
        allLayers.push(layer2);
        const layer2Blending = resolveLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER));
        allLayers.push(layer2Blending);
        const isLayer3Enabled = (0, $c6GJD.default).checkGate((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED));
        if (isLayer3Enabled) {
            const layer3 = resolveLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_L3_LAYER));
            allLayers.push(layer3);
        }
        const isQueryExpansionLayerEnabled = (0, $c6GJD.default).checkGate((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED));
        if (isQueryExpansionLayerEnabled) {
            const layerQueryExpansion = resolveLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER));
            allLayers.push(layerQueryExpansion);
        }
        const concatenatedExperimentId = allLayers.map((l)=>l?.layerId).join('_');
        const concatenatedShadowExperimentId = allLayers.map((l)=>l?.shadowId).join('_');
        return {
            experimentId: concatenatedExperimentId,
            shadowExperimentId: concatenatedShadowExperimentId,
            experimentLayers: allLayers
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return 0, $4OGlb.DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG;
};
const $f62b6f09dac42d3d$var$isEnrolledInMutuallyExclusiveUIExperiment = (experience)=>{
    const isEnrolledInQuickFindUIExperiment = (0, $c6GJD.default).getLayerValue((0, $4OGlb.STATSIG_QUICK_FIND_LAYER), 'frontendExperimentName', '', {
        fireLayerExposure: false
    }) !== '';
    const isEnrolledInSearchPageUIExperiment = (0, $c6GJD.default).getLayerValue((0, $4OGlb.STATSIG_FULL_PAGE_SEARCH_LAYER), 'frontendExperimentName', '', {
        fireLayerExposure: false
    }) !== '';
    return experience === 'quick-find' && isEnrolledInQuickFindUIExperiment || experience === 'search-page' && isEnrolledInSearchPageUIExperiment;
};
const $f62b6f09dac42d3d$var$applyBackendExperimentOverrides = (backendExperiment, backendExperimentOverrides)=>{
    // Handle undefined backendExperiment by creating a minimal experiment with empty layers
    const experiment = backendExperiment || {
        experimentLayers: []
    };
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const shouldApplyOverrides = enableRovoSearchOverrides && Boolean(backendExperimentOverrides?.length);
    if (!shouldApplyOverrides) return backendExperiment;
    return {
        ...experiment,
        experimentLayers: (0, $2hfy2.mergeBackendExperimentLayerOverrides)(experiment.experimentLayers ?? [], backendExperimentOverrides ?? [])
    };
};
/**
 * Helper function to apply overrides when normal experiment flow is not applicable.
 * Returns undefined if no overrides are provided, otherwise applies overrides to the backend experiment.
 */ const $f62b6f09dac42d3d$var$applyOverridesOrReturnUndefined = (experimentConfig, backendExperimentOverrides)=>{
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const shouldApplyOverrides = enableRovoSearchOverrides && Boolean(backendExperimentOverrides?.length);
    if (!shouldApplyOverrides) return undefined;
    return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides(experimentConfig.backendExperiment, backendExperimentOverrides);
};
const $f62b6f09dac42d3d$export$9009723727c24828 = ({ experimentConfig: experimentConfig, entities: entities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters, backendExperimentOverrides: backendExperimentOverrides, getLayerValuesFn: getLayerValuesFn })=>{
    if (experimentConfig.combinedExperiment?.enabled) return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides((0, $2hfy2.mapCombinedLayerExperiment)({
        combinedExperiment: experimentConfig.combinedExperiment
    }), backendExperimentOverrides);
    if (!experimentConfig.dynamicExperiments) return $f62b6f09dac42d3d$var$applyOverridesOrReturnUndefined(experimentConfig, backendExperimentOverrides);
    if ($f62b6f09dac42d3d$var$isEnrolledInMutuallyExclusiveUIExperiment(experience)) return $f62b6f09dac42d3d$var$applyOverridesOrReturnUndefined(experimentConfig, backendExperimentOverrides);
    const requestedEntities = entities.flatMap((entity)=>{
        try {
            const { resourceOwner: resourceOwner, resourceType: resourceType } = (0, $6yCpa.Ati).parse(entity);
            return [
                {
                    entity: resourceOwner,
                    subEntity: resourceType.toUpperCase()
                }
            ];
        } catch  {
            return [];
        }
    });
    // Skip layer exposure when overrides are enabled and there are overrides.
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const skipLayerExposure = enableRovoSearchOverrides && Boolean(backendExperimentOverrides?.length);
    const fireLayerExposure = !skipLayerExposure;
    const experimentParams = $f62b6f09dac42d3d$export$f0d0c69a221c32ee(undefined, fireLayerExposure, getLayerValuesFn);
    if (experimentParams?.mutualExclusion) return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides((0, $2hfy2.mapMutuallyExclusiveExperiment)({
        experimentParams: experimentParams,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    }), backendExperimentOverrides);
    return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides((0, $2hfy2.mapDynamicExperiments)({
        dynamicExperiments: experimentConfig.dynamicExperiments,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters,
        fireLayerExposure: fireLayerExposure,
        getLayerValuesFn: getLayerValuesFn
    }), backendExperimentOverrides);
};
module.exports["getBackendExperimentConfig"] = $f62b6f09dac42d3d$export$2f6c9ab85be44d1a;
module.exports["getLayerValues"] = $f62b6f09dac42d3d$export$3178593b0bf95121;
module.exports["getCombinedLayerValues"] = $f62b6f09dac42d3d$export$ad31a6212fa2b02c;
module.exports["getBackendExperiment"] = $f62b6f09dac42d3d$export$9009723727c24828;

});

parcelRegister("dbl1i", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $de7a36fee3572948$var$experimentExperienceEnum = (0, $jLeRZ.z).enum([
    'search-page',
    'quick-find',
    'search-page-space-filter',
    'quick-search',
    'advanced-search',
    'sain'
]);
const $de7a36fee3572948$var$linkedEntityGranularityEnum = (0, $jLeRZ.z).enum([
    'ALL_MATCHING_MESSAGES',
    'DEFAULT',
    'FULL_THREAD',
    'ONLY_LINKED_ENTITIES'
]);
const $de7a36fee3572948$var$layerFunctionBaseSchema = {
    layerType: (0, $jLeRZ.z).string().startsWith('search_platform_layer_').optional(),
    entity: (0, $jLeRZ.z).string().optional(),
    subEntity: (0, $jLeRZ.z).string().optional(),
    hello: (0, $jLeRZ.z).boolean().optional(),
    isJiraIssueIndexed: (0, $jLeRZ.z).boolean().optional(),
    linkedEntityGranularity: $de7a36fee3572948$var$linkedEntityGranularityEnum.optional(),
    confluenceTier: (0, $jLeRZ.z).string().array().optional(),
    productDataRegions: (0, $jLeRZ.z).record((0, $jLeRZ.z).string(), (0, $jLeRZ.z).string().array()).optional(),
    experiences: $de7a36fee3572948$var$experimentExperienceEnum.array().optional(),
    tenantIds: (0, $jLeRZ.z).string().array().optional(),
    targetingGateId: (0, $jLeRZ.z).string().optional(),
    providerId: (0, $jLeRZ.z).string().optional(),
    connectorSources: (0, $jLeRZ.z).array((0, $jLeRZ.z).string()).optional(),
    integrationAri: (0, $jLeRZ.z).string().optional()
};
const $de7a36fee3572948$var$layerFunction = (0, $jLeRZ.z).object($de7a36fee3572948$var$layerFunctionBaseSchema);
const $de7a36fee3572948$var$dynamicConfigSchema = (0, $jLeRZ.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $jLeRZ.z).NEVER;
    }
}).pipe((0, $jLeRZ.z).object({
    ...$de7a36fee3572948$var$layerFunctionBaseSchema,
    statsigLayerId: (0, $jLeRZ.z).string().startsWith('search_platform_')
}));
const $de7a36fee3572948$var$mutuallyExclusiveDynamicConfigSchema = (0, $jLeRZ.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $jLeRZ.z).NEVER;
    }
}).pipe((0, $jLeRZ.z).object({
    ...$de7a36fee3572948$var$layerFunctionBaseSchema,
    layerId: (0, $jLeRZ.z).string(),
    controlId: (0, $jLeRZ.z).string().optional()
}));
const $de7a36fee3572948$export$4b5312b6cfd0d20a = (0, $jLeRZ.z).array((0, $jLeRZ.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$de7a36fee3572948$var$dynamicConfigSchema.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid
const $de7a36fee3572948$export$e1f2182538b46e4b = (0, $jLeRZ.z).array((0, $jLeRZ.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$de7a36fee3572948$var$mutuallyExclusiveDynamicConfigSchema.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid
module.exports["dynamicExperimentsSchema"] = $de7a36fee3572948$export$4b5312b6cfd0d20a;
module.exports["mutuallyExclusiveBackendSearchLogicParametersSchema"] = $de7a36fee3572948$export$e1f2182538b46e4b;

});

parcelRegister("2hfy2", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $4OGlb = parcelRequire("4OGlb");


var $hm6w9 = parcelRequire("hm6w9");

const $c517901dc1a94583$var$WILDCARD = '*';
const $c517901dc1a94583$var$JIRA_ENTITY = 'jira';
const $c517901dc1a94583$var$mapExperimentsToSearchMatchingLayerExperimentsMetadata = (experiments)=>{
    const matchingLayers = experiments.reduce((metadata, { layerType: layerType, statsigLayerId: statsigLayerId })=>{
        if (!layerType) return metadata;
        if (metadata.some((metadataEntry)=>metadataEntry.layerType === layerType)) return metadata;
        return [
            ...metadata,
            {
                layerType: layerType,
                layerName: statsigLayerId
            }
        ];
    }, []);
    return matchingLayers.length ? {
        matchingLayers: matchingLayers
    } : undefined;
};
const $c517901dc1a94583$export$8dc0dcff4d3bde7a = ({ combinedExperiment: combinedExperiment })=>{
    if (combinedExperiment) {
        const experimentLayers = [
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_NAME),
                combinedExperiment.l1Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_NAME),
                combinedExperiment.l2Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L3_LAYER_NAME),
                combinedExperiment.l3Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME),
                combinedExperiment.qrId
            ]
        ];
        return {
            experimentLayers: experimentLayers.map(([layerType, layerId])=>{
                let entity = $c517901dc1a94583$var$WILDCARD;
                if (layerType === (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_NAME)) entity = combinedExperiment.l1Entity ?? $c517901dc1a94583$var$WILDCARD;
                if (layerType === (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_NAME)) entity = combinedExperiment.l2Entity ?? $c517901dc1a94583$var$WILDCARD;
                return {
                    name: layerType,
                    layerId: null,
                    shadowId: null,
                    definitions: [
                        {
                            layerId: layerId,
                            shadowId: null,
                            entity: entity,
                            subEntity: $c517901dc1a94583$var$WILDCARD,
                            abTestId: combinedExperiment.abTestId ?? null
                        }
                    ],
                    analyticsDefinitions: [
                        {
                            layerId: layerId,
                            shadowId: null,
                            entity: entity,
                            subEntity: $c517901dc1a94583$var$WILDCARD,
                            abTestId: combinedExperiment.abTestId ?? null,
                            controlId: combinedExperiment.controlId ?? null
                        }
                    ]
                };
            })
        };
    }
    return {
        experimentLayers: []
    };
};
const $c517901dc1a94583$var$getLayersRelevantToSearchRequest = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters })=>{
    return dynamicExperiments.filter($c517901dc1a94583$var$containsTenantId(tenantId)).filter($c517901dc1a94583$export$647cb61786ce5ae0(productEdition)).filter($c517901dc1a94583$var$containsExperience(experience)).filter($c517901dc1a94583$var$isHelloTenant(isHello)).filter($c517901dc1a94583$var$containsRequestedEntities(requestedEntities)).filter($c517901dc1a94583$var$containsRequestedSubEntities(requestedEntities)).filter($c517901dc1a94583$export$273a58382ea22085(thirdPartyFilters)).filter($c517901dc1a94583$var$isJiraIssueIndexedConditionSatisfied(isJiraIssueIndexed)).filter($c517901dc1a94583$var$isLinkedEntityGranularityConditionSatisfied(linkedEntityGranularity)).filter($c517901dc1a94583$var$passesTargetingGate()).filter($c517901dc1a94583$var$satisfiesProductDataRegions(productDataRegions)).reduce((layerFunctions, currentLayerFunction)=>{
        // IF there are more than one definitions with the same definition
        // THEN only add the first one defined, (do not add this one)
        const containsCollision = layerFunctions.find((layerFunction)=>{
            /**
       * This isn't perfect either because there can be some edge cases where
       * an experiment definition is included, but not used. e.g.
       * - Defitions we have are:
       * 			[entity: confluence, subEntity: page],
       * 			[entity: confluence, subEntity: *]
       * - The request is for entity: confluence, subEntity: page
       *
       * Both definitions would be included in the final list, but only the
       * first would ever be used, but we fire exposures for both.
       *
       * To fix this, we would need to do one of the following:
       * - Replicate all of the fan out logic here (ugly and hard to maintain),
       *   so we know exactly which experiment definitions will get used
       * - Fire experiment exposures in the backend
       */ return layerFunction.layerType === currentLayerFunction.layerType && layerFunction.entity === currentLayerFunction.entity && layerFunction.subEntity === currentLayerFunction.subEntity && layerFunction.integrationAri === currentLayerFunction.integrationAri && layerFunction.providerId === currentLayerFunction.providerId && JSON.stringify(layerFunction.connectorSources?.sort()) === JSON.stringify(currentLayerFunction.connectorSources?.sort());
        });
        return containsCollision ? layerFunctions : [
            ...layerFunctions,
            currentLayerFunction
        ];
    }, []);
};
const $c517901dc1a94583$var$mapExperimentsToExperimentDefinitions = (experiments)=>{
    return experiments.reduce((experimentLayers, definitionWithLayerType)=>{
        const existingLayer = experimentLayers.find((layer)=>layer.name === definitionWithLayerType.layerType);
        const { controlId: _controlId, statsigLayerId: statsigLayerId, ...baseDefinition } = definitionWithLayerType.definition;
        const definition = (0, $dh538.fg)('search_send_statsig_layer_id') ? {
            ...baseDefinition,
            statsigLayerId: statsigLayerId
        } : baseDefinition;
        const analyticsDefinition = {
            ...definitionWithLayerType.definition
        };
        if (!existingLayer) {
            experimentLayers.push({
                name: definitionWithLayerType.layerType,
                layerId: null,
                // TODO QS-6283: Remove this once scalable statsig layers are rolled out
                shadowId: null,
                // TODO QS-6283: Remove this once scalable statsig layers are rolled out
                definitions: [
                    definition
                ],
                analyticsDefinitions: [
                    analyticsDefinition
                ]
            });
            return experimentLayers;
        }
        existingLayer.definitions?.push(definition);
        existingLayer.analyticsDefinitions?.push(analyticsDefinition);
        return experimentLayers;
    }, []);
};
const $c517901dc1a94583$export$10532bc904a76c69 = ({ experimentParams: experimentParams, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters })=>{
    const dynamicExperiments = experimentParams?.layerFunctions || [];
    const { abTestId: abTestId } = experimentParams || {
        abTestId: null
    };
    const relevantExperiments = $c517901dc1a94583$var$getLayersRelevantToSearchRequest({
        dynamicExperiments: dynamicExperiments,
        requestedEntities: requestedEntities,
        productEdition: productEdition,
        isHello: isHello,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    });
    const experiments = relevantExperiments.map((dynamicExp)=>{
        return {
            definition: {
                layerId: dynamicExp.layerId,
                shadowId: null,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                controlId: dynamicExp.controlId ?? null,
                statsigLayerId: null,
                providerId: dynamicExp.providerId,
                integrationARI: dynamicExp.integrationAri,
                connectorSources: dynamicExp.connectorSources
            },
            layerType: dynamicExp.layerType
        };
    });
    return {
        experimentLayers: $c517901dc1a94583$var$mapExperimentsToExperimentDefinitions(experiments)
    };
};
const $c517901dc1a94583$export$b9a99705ca4e42b9 = (experimentLayers, overrides)=>{
    const mergedLayers = experimentLayers.map((l)=>({
            ...l,
            // ensure that definitions and analyticsDefinitions have an array
            definitions: l.definitions ? [
                ...l.definitions
            ] : [],
            analyticsDefinitions: l.analyticsDefinitions ? [
                ...l.analyticsDefinitions
            ] : []
        }));
    for (const override of overrides){
        const overrideDefinitions = override.analyticsDefinitions ?? [];
        if (overrideDefinitions.length === 0) continue;
        const layer = mergedLayers.find((l)=>l.name === override.name);
        if (!layer) {
            // Remove controlId from definitions since they're for request payloads
            const requestDefinitions = overrideDefinitions.map(({ controlId: _controlId, ...def })=>def);
            mergedLayers.push({
                name: override.name,
                layerId: null,
                shadowId: null,
                definitions: requestDefinitions,
                analyticsDefinitions: [
                    ...overrideDefinitions
                ]
            });
            continue;
        }
        for (const overrideDef of overrideDefinitions){
            const keyEntity = overrideDef.entity ?? null;
            const keySubEntity = overrideDef.subEntity ?? null;
            const analyticsIndex = layer.analyticsDefinitions.findIndex((d)=>(d.entity ?? null) === keyEntity && (d.subEntity ?? null) === keySubEntity);
            if (analyticsIndex >= 0) layer.analyticsDefinitions[analyticsIndex] = overrideDef;
            else layer.analyticsDefinitions.push(overrideDef);
            const { controlId: _controlId, ...requestDef } = overrideDef;
            const requestIndex = layer.definitions.findIndex((d)=>(d.entity ?? null) === keyEntity && (d.subEntity ?? null) === keySubEntity);
            if (requestIndex >= 0) layer.definitions[requestIndex] = requestDef;
            else layer.definitions.push(requestDef);
        }
    }
    return mergedLayers;
};
const $c517901dc1a94583$export$37bc8313287bf4ea = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters, fireLayerExposure: fireLayerExposure = true, getLayerValuesFn: getLayerValuesFn = (0, $hm6w9.getLayerValues) })=>{
    const relevantExperiments = $c517901dc1a94583$var$getLayersRelevantToSearchRequest({
        dynamicExperiments: dynamicExperiments,
        requestedEntities: requestedEntities,
        productEdition: productEdition,
        isHello: isHello,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    });
    const experiments = relevantExperiments.map((dynamicExp)=>{
        const { layerId: layerId, shadowId: shadowId, abTestId: abTestId, controlId: controlId } = getLayerValuesFn(dynamicExp.statsigLayerId, fireLayerExposure ? undefined : {
            fireLayerExposure: false
        });
        return {
            definition: {
                layerId: layerId,
                shadowId: shadowId,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                controlId: controlId,
                statsigLayerId: dynamicExp.statsigLayerId,
                providerId: dynamicExp.providerId,
                integrationARI: dynamicExp.integrationAri,
                connectorSources: dynamicExp.connectorSources
            },
            layerType: dynamicExp.layerType
        };
    });
    return {
        experimentLayers: $c517901dc1a94583$var$mapExperimentsToExperimentDefinitions(experiments),
        matchingLayerExperimentsMetadata: $c517901dc1a94583$var$mapExperimentsToSearchMatchingLayerExperimentsMetadata(relevantExperiments)
    };
};
const $c517901dc1a94583$export$647cb61786ce5ae0 = (productEdition)=>(dynamicExp)=>{
        // Opt for specificity. Does not filter out values that do not have the confluenceTier attribute
        if (!dynamicExp.confluenceTier || dynamicExp.confluenceTier.length === 0) return true;
        return !!dynamicExp.confluenceTier?.find((experimentTier)=>productEdition?.['confluence'] === experimentTier);
    };
const $c517901dc1a94583$var$isHelloTenant = (isHello)=>(dynamicExp)=>{
        if (dynamicExp.hello === undefined || dynamicExp.hello === null) return true;
        return dynamicExp.hello === isHello;
    };
const $c517901dc1a94583$var$passesTargetingGate = ()=>(dynamicExp)=>{
        if (dynamicExp.targetingGateId === undefined || dynamicExp.targetingGateId === null) return true;
        // eslint-disable-next-line @atlaskit/platform/static-feature-flags
        return (0, $dh538.fg)(dynamicExp.targetingGateId);
    };
/**
 * This is specifically used for targeting based on indexing status of the tenant.
 * This might NOT be needed once Jira indexed and ROVO in Jira is shipped to 100%
 */ const $c517901dc1a94583$var$isJiraIssueIndexedConditionSatisfied = (isJiraIssueIndexed)=>(dynamicExp)=>{
        if (isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === null || dynamicExp?.entity !== $c517901dc1a94583$var$JIRA_ENTITY) return true;
        return dynamicExp.isJiraIssueIndexed === isJiraIssueIndexed;
    };
const $c517901dc1a94583$var$isLinkedEntityGranularityConditionSatisfied = (linkedEntityGranularity)=>(dynamicExp)=>{
        if (linkedEntityGranularity === undefined || dynamicExp.linkedEntityGranularity === undefined || dynamicExp.linkedEntityGranularity === null) return true;
        return dynamicExp.linkedEntityGranularity === linkedEntityGranularity;
    };
const $c517901dc1a94583$var$containsRequestedEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.entity || dynamicExp.entity === $c517901dc1a94583$var$WILDCARD) return true;
        const isFilteredEntity = entityFilter.find((filteredEntity)=>dynamicExp.entity === filteredEntity.entity);
        return isFilteredEntity ?? false;
    };
const $c517901dc1a94583$var$containsRequestedSubEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.subEntity || dynamicExp.subEntity === $c517901dc1a94583$var$WILDCARD) return true;
        const isFilteredSubEntity = entityFilter.find((filteredEntity)=>dynamicExp.subEntity === filteredEntity.subEntity);
        return isFilteredSubEntity ?? false;
    };
/**
 * Determines whether the provided data regions (dataRegions) are defined in
 * the dynamic configuration (dynamicExp). Every data region for a given product
 * in the dynamic configuration must be specified  in order for the given
 * experiment layer to be eligible.
 *
 * @param dataRegions Represents where the data comes from comes from for
 * each product.
 * ```
 * { 'confluence': ["us-west-2"], 'compass': ["us-east-1"] }`
 * ```
 *
 * @returns a boolean that indicates whether or not the provided data regions
 * (dataRegions) are specified in the dynamic configuration (dynamicExp).
 */ const $c517901dc1a94583$var$satisfiesProductDataRegions = (dataRegions)=>(dynamicExp)=>{
        if (!dynamicExp.productDataRegions) return true;
        return Object.keys(dynamicExp.productDataRegions).map((product)=>{
            const productDataRegions = dynamicExp.productDataRegions?.[product];
            const isProductEligible = dataRegions?.[product]?.every((dataRegion)=>{
                return productDataRegions?.includes(dataRegion);
            });
            return !!isProductEligible;
        }).reduce((prev, curr)=>prev && curr);
    };
const $c517901dc1a94583$var$containsExperience = (experience)=>(dynamicExp)=>{
        if (!dynamicExp.experiences || dynamicExp.experiences.length === 0) return true;
        return dynamicExp.experiences?.find((dynamicExpExperience)=>experience === dynamicExpExperience);
    };
const $c517901dc1a94583$var$containsTenantId = (tenantId)=>(dynamicExp)=>{
        if (!dynamicExp.tenantIds || dynamicExp.tenantIds.length === 0) return true;
        return dynamicExp.tenantIds?.find((dynamicExpTenantId)=>tenantId === dynamicExpTenantId);
    };
const $c517901dc1a94583$export$273a58382ea22085 = (thirdPartyFilters)=>(dynamicExp)=>{
        if (!dynamicExp.connectorSources?.length && !dynamicExp.providerId && !dynamicExp.integrationAri) return true;
        if (!thirdPartyFilters?.thirdPartyProducts) return false;
        const providerIdExp = dynamicExp.providerId ?? $c517901dc1a94583$var$WILDCARD;
        const integrationAriExp = dynamicExp.integrationAri ?? $c517901dc1a94583$var$WILDCARD;
        const connectorSourceExp = dynamicExp.connectorSources;
        const matches3pTarget = thirdPartyFilters.thirdPartyProducts.find((thirdPartyProduct)=>{
            // https://atlassian.slack.com/archives/C08CGNZTMC2/p1756690283247959
            const containsConnectorSource = thirdPartyProduct.connectorSources?.find((connectorSourceFromConfig)=>connectorSourceExp?.find((connectorSourceFromExp)=>connectorSourceFromExp === connectorSourceFromConfig));
            const matchesProviderId = providerIdExp === $c517901dc1a94583$var$WILDCARD || providerIdExp === thirdPartyProduct.providerId;
            const matchesIntegrationAri = integrationAriExp === $c517901dc1a94583$var$WILDCARD || integrationAriExp === thirdPartyProduct.integrationId;
            return(// !connectorSources = wildcard
            matchesProviderId && matchesIntegrationAri && (!connectorSourceExp || Boolean(containsConnectorSource)));
        });
        return Boolean(matches3pTarget);
    };
module.exports["mapCombinedLayerExperiment"] = $c517901dc1a94583$export$8dc0dcff4d3bde7a;
module.exports["mapMutuallyExclusiveExperiment"] = $c517901dc1a94583$export$10532bc904a76c69;
module.exports["mergeBackendExperimentLayerOverrides"] = $c517901dc1a94583$export$b9a99705ca4e42b9;
module.exports["mapDynamicExperiments"] = $c517901dc1a94583$export$37bc8313287bf4ea;

});

parcelRegister("i6s7M", function(module, exports) {
const $162ae7fe4b241de7$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI"] = $162ae7fe4b241de7$export$3268f1527392e5ac;

});

parcelRegister("e2CiB", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $eixur = parcelRequire("eixur");

const $36619dc24acabf11$var$QUICK_FIND_RECOMMENDED_DOCUMENTS_CACHE_KEY = 'quick-find-recommended-documents';
const $36619dc24acabf11$var$FAILURE_EXPIRATION_MS = 5000; // 5 seconds for failure
const $36619dc24acabf11$var$SUCCESS_EXPIRATION_MS = 300000; // 5 minutes for success
const $36619dc24acabf11$export$90883b912e6e9555 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $eixur.quickFindRecommendedDocumentsQuery),
        operationName: $eixur.operationName,
        headers: headers
    });
};
const { refreshOnAccessDecorator: $36619dc24acabf11$var$refreshOnAccessDecoratorRecommendedDocuments, clear: $36619dc24acabf11$var$clearRecommendedDocumentsCache } = (0, $jnPv4.promiseCache)({
    name: $36619dc24acabf11$var$QUICK_FIND_RECOMMENDED_DOCUMENTS_CACHE_KEY
});
const $36619dc24acabf11$export$a4d862e87b221514 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, expiration: expiration, onlyRefreshIfExpired: onlyRefreshIfExpired, returnExpired: returnExpired, headers: headers })=>{
    const cacheKey = (0, $2qzBQ.generateHash)(`${$36619dc24acabf11$var$QUICK_FIND_RECOMMENDED_DOCUMENTS_CACHE_KEY}|${JSON.stringify(variables)}`).toString();
    const writeBackWithTTL = (value, ttl)=>{
        $36619dc24acabf11$var$refreshOnAccessDecoratorRecommendedDocuments({
            key: cacheKey,
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $36619dc24acabf11$var$refreshOnAccessDecoratorRecommendedDocuments({
        key: cacheKey,
        supplier: async ()=>{
            try {
                const result = await $36619dc24acabf11$export$90883b912e6e9555({
                    variables: variables,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    headers: headers
                });
                writeBackWithTTL(result, $36619dc24acabf11$var$SUCCESS_EXPIRATION_MS);
                return result;
            } catch (error) {
                // On failure, cache the rejected promise with a short TTL to avoid hammering the service
                // This ensures the error is still thrown when accessed, but prevents immediate retries
                writeBackWithTTL(Promise.reject(error), $36619dc24acabf11$var$FAILURE_EXPIRATION_MS);
                // Re-throw the error so the caller knows the request failed
                throw error;
            }
        },
        expiration: expiration,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        returnExpired: returnExpired
    });
};
const $36619dc24acabf11$export$d67c52a60a23cc67 = (key)=>$36619dc24acabf11$var$clearRecommendedDocumentsCache(key);
module.exports["cachedRecommendedDocumentsQuery"] = $36619dc24acabf11$export$a4d862e87b221514;

});

parcelRegister("eixur", function(module, exports) {
const $52410f8eccfbace9$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    id
    title
    type
    subtype
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $52410f8eccfbace9$var$ExternalDocumentFragment = `
  fragment ExternalDocumentFragment on ExternalDocument {
    __typename
    id
    displayName
    url
    documentType: type {
      category
    }
    parent @optIn(to: "ExternalDataDepotQueryV2") {
      ... on ExternalDocument {
        displayName
      }
    }
    provider {
      providerId
    }
  }
`;
const $52410f8eccfbace9$export$5db520940cf00715 = 'QuickFindRecommendedDocumentsQuery';
const $52410f8eccfbace9$export$53b4eb4fc8d1360f = `
  query ${$52410f8eccfbace9$export$5db520940cf00715} (
    $userId: String!,
    $tenantId: String!,
    $caller: String!,
    $maxNumberOfResults: Int!,
    $featureServiceModel: String
  ) {
    contextService {
      quickfindUserRecommendations(
        recommendationsQuery: {
          context: {
            userId: $userId
            tenantId: $tenantId
          }, modelRequestParams: {
            caller: $caller
            experience: "recommendedExternalDocument"
            featureServiceModel: $featureServiceModel
          },
          requestingUserId: $userId
          maxNumberOfResults: $maxNumberOfResults
        }
      ) {
        id
        score
        reason
        object {
          ...ConfluencePageFragment
          ...ExternalDocumentFragment
        }
      }
    }
  }
  ${$52410f8eccfbace9$var$ConfluencePageFragment}
  ${$52410f8eccfbace9$var$ExternalDocumentFragment}
`;
module.exports["operationName"] = $52410f8eccfbace9$export$5db520940cf00715;
module.exports["quickFindRecommendedDocumentsQuery"] = $52410f8eccfbace9$export$53b4eb4fc8d1360f;

});

parcelRegister("2Kn8h", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");

const $791b0854bf4c25c7$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    id
    title
    type
    subtype
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $791b0854bf4c25c7$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    id
    title
    type
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $791b0854bf4c25c7$export$5db520940cf00715 = 'QuickFindUserDocumentsQuery';
const $791b0854bf4c25c7$export$d55cf2ce517f0208 = `
  query ${$791b0854bf4c25c7$export$5db520940cf00715} (
    $userId: String!,
    $tenantId: String!,
    $caller: String!,
    $maxNumberOfResults: Int!
  ) {
    smarts {
      recommendedObject(
        recommendationsQuery: {
          context: {
            userId: $userId
            tenantId: $tenantId
          }, modelRequestParams: {
            caller: $caller
            experience: "ConfUserPages"
          }, 
          requestingUserId: $userId 
          maxNumberOfResults: $maxNumberOfResults
        }
      ) {
        id
        score
        reason
        object {
          ...ConfluencePageFragment
          ...ConfluenceBlogPostFragment
        }
      }
    }
  }
  ${$791b0854bf4c25c7$var$ConfluencePageFragment}
  ${$791b0854bf4c25c7$var$ConfluenceBlogPostFragment}
`;


const $faa27dea184f5d3b$var$QUICK_FIND_USER_DOCUMENTS_CACHE_KEY = 'quick-find-user-documents';
const $faa27dea184f5d3b$var$FAILURE_EXPIRATION_MS = 5000; // 5 seconds for failure
const $faa27dea184f5d3b$var$SUCCESS_EXPIRATION_MS = 300000; // 5 minutes for success
const $faa27dea184f5d3b$export$f17eccb8f0d1390 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $791b0854bf4c25c7$export$d55cf2ce517f0208),
        operationName: $791b0854bf4c25c7$export$5db520940cf00715,
        headers: headers
    });
};
const { refreshOnAccessDecorator: $faa27dea184f5d3b$var$refreshOnAccessDecoratorUserDocuments, clear: $faa27dea184f5d3b$var$clearUserDocumentsCache } = (0, $jnPv4.promiseCache)({
    name: $faa27dea184f5d3b$var$QUICK_FIND_USER_DOCUMENTS_CACHE_KEY
});
const $faa27dea184f5d3b$export$d5cc5053cec68715 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, expiration: expiration, onlyRefreshIfExpired: onlyRefreshIfExpired, returnExpired: returnExpired, headers: headers })=>{
    const cacheKey = (0, $2qzBQ.generateHash)(`${$faa27dea184f5d3b$var$QUICK_FIND_USER_DOCUMENTS_CACHE_KEY}|${JSON.stringify(variables)}`).toString();
    const writeBackWithTTL = (value, ttl)=>{
        $faa27dea184f5d3b$var$refreshOnAccessDecoratorUserDocuments({
            key: cacheKey,
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $faa27dea184f5d3b$var$refreshOnAccessDecoratorUserDocuments({
        key: cacheKey,
        supplier: async ()=>{
            try {
                const result = await $faa27dea184f5d3b$export$f17eccb8f0d1390({
                    variables: variables,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    headers: headers
                });
                writeBackWithTTL(result, $faa27dea184f5d3b$var$SUCCESS_EXPIRATION_MS);
                return result;
            } catch (error) {
                // On failure, cache the rejected promise with a short TTL to avoid hammering the service
                // This ensures the error is still thrown when accessed, but prevents immediate retries
                writeBackWithTTL(Promise.reject(error), $faa27dea184f5d3b$var$FAILURE_EXPIRATION_MS);
                // Re-throw the error so the caller knows the request failed
                throw error;
            }
        },
        expiration: expiration,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        returnExpired: returnExpired
    });
};
const $faa27dea184f5d3b$export$24831cfcdf1e0a31 = (key)=>$faa27dea184f5d3b$var$clearUserDocumentsCache(key);
module.exports["cachedUserDocumentsQuery"] = $faa27dea184f5d3b$export$d5cc5053cec68715;

});

parcelRegister("bz34M", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");

const $77131a80a267b232$export$5db520940cf00715 = 'KnowledgeDiscoveryZeroQueries';
const $77131a80a267b232$export$c6209ded7eb543e2 = `
  query ${$77131a80a267b232$export$5db520940cf00715}($cloudId: String!, $product: KnowledgeDiscoveryProduct) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries") {
			zeroQueries(cloudId: $cloudId, product: $product) {
                __typename
                ... on KnowledgeDiscoveryZeroQueries {
                    zeroQueries {
                        query
                        type
						product
						accountId
						avatarUrl
						dateRange
					}
                }
            }
		}
	}
`;
const $77131a80a267b232$export$7a489cc87c267c4 = 'MarkZeroQueryInteracted';
const $77131a80a267b232$export$e15ac8a4356bed82 = `
	mutation ${$77131a80a267b232$export$7a489cc87c267c4}($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted") {
			markZeroQueryInteracted(input: $input) {
				success
				errors {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;
const $77131a80a267b232$export$c279dc9ea93aad98 = 'KnowledgeDiscoveryZeroQueriesV1';
const $77131a80a267b232$export$cca6d12b1794e42a = `
  query ${$77131a80a267b232$export$c279dc9ea93aad98}($cloudId: String!, $product: KnowledgeDiscoveryProduct) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries V1") {
			zeroQueriesV1(cloudId: $cloudId, product: $product) {
                __typename
                ... on KnowledgeDiscoveryZeroQueries {
                    zeroQueries {
                        query
                        type
						product
						accountId
						avatarUrl
						dateRange
					}
                }
            }
		}
	}
`;
const $77131a80a267b232$export$2650522d8a738e7e = 'MarkZeroQueryInteractedV1';
const $77131a80a267b232$export$93c9ddb071659b5e = `
	mutation ${$77131a80a267b232$export$2650522d8a738e7e}($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted V1") {
			markZeroQueryInteractedV1(input: $input) {
				success
				errors {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;


const $8001a232370fdb69$export$4e6f8f14fd5cfc8c = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $77131a80a267b232$export$c6209ded7eb543e2),
        variables: variables,
        operationName: $77131a80a267b232$export$5db520940cf00715,
        headers: headers
    });
};
const $8001a232370fdb69$export$2338c914f7e7b6c6 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $77131a80a267b232$export$cca6d12b1794e42a),
        variables: variables,
        operationName: (0, $77131a80a267b232$export$c279dc9ea93aad98),
        headers: headers
    });
};
const $8001a232370fdb69$export$8cd0dd2078791744 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $77131a80a267b232$export$e15ac8a4356bed82),
        variables: variables,
        operationName: (0, $77131a80a267b232$export$7a489cc87c267c4),
        headers: headers
    });
};
const $8001a232370fdb69$export$2ffea0896a0ec5f = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $77131a80a267b232$export$93c9ddb071659b5e),
        variables: variables,
        operationName: (0, $77131a80a267b232$export$2650522d8a738e7e),
        headers: headers
    });
};
module.exports["zeroQueriesQuery"] = $8001a232370fdb69$export$4e6f8f14fd5cfc8c;
module.exports["zeroQueriesQueryV1"] = $8001a232370fdb69$export$2338c914f7e7b6c6;
module.exports["zeroQueriesMutation"] = $8001a232370fdb69$export$8cd0dd2078791744;
module.exports["zeroQueriesMutationV1"] = $8001a232370fdb69$export$2ffea0896a0ec5f;

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("5tPRL", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");


var $46Fuk = parcelRequire("46Fuk");


var $cStGJ = parcelRequire("cStGJ");



var $amDKJ = parcelRequire("amDKJ");



var $7YnKE = parcelRequire("7YnKE");













var $bjANz = parcelRequire("bjANz");



function $d4baf0504b42b38c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d4baf0504b42b38c$export$87a308048e18f5d7 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv4"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $2azjJ.grid).multiple(props.isCollapsed ? 5 : 4).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $2azjJ.grid).twice().px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $46Fuk.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $46Fuk.itemHighlightColor)
        }
    }));
const $d4baf0504b42b38c$export$e10965f6350456f8 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv3"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-radius-medium, 6px)",
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $46Fuk.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $46Fuk.itemHighlightColor)
        }
    }));
const $d4baf0504b42b38c$export$b7244afbfdf4cb9a = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv2"
})((props)=>({
        borderRadius: "var(--ds-radius-small, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: (0, $2azjJ.grid).half().px,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $2azjJ.grid).multiple(3).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $2azjJ.grid).twice().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: (0, $2azjJ.grid).multiple(1.5).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: props.isCollapsed ? (0, $2azjJ.grid).px : (0, $2azjJ.grid).half().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isKeyboardHighlighted ? 1 : 0
    }));
const $d4baf0504b42b38c$export$cc248e72bc9d7b85 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e8crcwv1"
})({
    name: "qrg2ys",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-left:var(--ds-space-150, 12px)"
});
const $d4baf0504b42b38c$export$d84276b3ae03593f = /*#__PURE__*/ (0, $cStGJ.default)($d4baf0504b42b38c$export$b7244afbfdf4cb9a, {
    target: "e8crcwv0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).multiple(2.5).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $2azjJ.grid).multiple(2.5).px,
    opacity: 1
});
module.exports["ResultContentWrapper"] = $d4baf0504b42b38c$export$87a308048e18f5d7;
module.exports["ReturnIconContainer"] = $d4baf0504b42b38c$export$b7244afbfdf4cb9a;
module.exports["EnlargedReturnIconContainer"] = $d4baf0504b42b38c$export$cc248e72bc9d7b85;

});

parcelRegister("46Fuk", function(module, exports) {
const $fea27d8e6cec66f4$export$4ac85ff259fe4fce = "var(--ds-background-neutral-subtle-hovered, #0515240F)";
module.exports["itemHighlightColor"] = $fea27d8e6cec66f4$export$4ac85ff259fe4fce;

});

parcelRegister("amDKJ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");


var $cStGJ = parcelRequire("cStGJ");

const $5a407a893f29b543$export$8f314e512d92575f = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "eymydq50"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $2azjJ.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flex: `0 0 ${(0, $2azjJ.grid).twice().px}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $2azjJ.grid).twice().px,
    display: 'flex',
    alignItems: 'center'
});
module.exports["IconContainer"] = $5a407a893f29b543$export$8f314e512d92575f;

});

parcelRegister("7YnKE", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");


var $kRuQk = parcelRequire("kRuQk");


var $gCIyK = parcelRequire("gCIyK");


var $cStGJ = parcelRequire("cStGJ");

const $96ec405b2484ebdf$export$9c613d6c52df949a = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "eiapvw30"
})((0, $gCIyK.nowrapEllipsis), " width:", (props)=>props.isCollapsed ? 'initial' : (0, $2azjJ.grid).multiple(47).px, ";line-height:16px;flex:1 0 auto;color:", (0, $kRuQk.primaryTextColour), ";@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;}");
module.exports["ResultTitleContainer"] = $96ec405b2484ebdf$export$9c613d6c52df949a;

});

parcelRegister("kRuQk", function(module, exports) {
const $6b632a219e8b946a$export$eeb0307e2964e28d = "var(--ds-text, #292A2E)";
module.exports["primaryTextColour"] = $6b632a219e8b946a$export$eeb0307e2964e28d;

});

parcelRegister("gCIyK", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $88ac1e075dfa894c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $88ac1e075dfa894c$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
module.exports["nowrapEllipsis"] = $88ac1e075dfa894c$export$b6b16ffe83ef4b56;

});

parcelRegister("bjANz", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $cStGJ = parcelRequire("cStGJ");

function $c262e6a568a40462$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c262e6a568a40462$export$ee32d1086c278cfc = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1oz9dht0"
})({
    name: "1ls843y",
    styles: "display:block;min-width:0;flex-grow:1"
});
module.exports["CollapsedResultContentWrapper"] = $c262e6a568a40462$export$ee32d1086c278cfc;

});

parcelRegister("k0e2P", function(module, exports) {

let $e8feb3b4f826d88d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8feb3b4f826d88d$var$load("4KiYL").then(()=>parcelRequire('9Wb1k'));

});

parcelRegister("4AkKf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b83e18362be7337c33091ec68bfbcb2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $356a9dc0786a9256$var$_react = $356a9dc0786a9256$var$_interopRequireDefault((parcelRequire("42omo")));

var $356a9dc0786a9256$var$_baseNew = $356a9dc0786a9256$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $356a9dc0786a9256$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $356a9dc0786a9256$var$FilterIcon = (props)=>/*#__PURE__*/ $356a9dc0786a9256$var$_react.default.createElement($356a9dc0786a9256$var$_baseNew.default, Object.assign({
        name: "FilterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 12v1.5H5V12zm2-4.75v1.5H3v-1.5zm2-4.75V4H1V2.5z"/>`
    }, props));
$356a9dc0786a9256$var$FilterIcon.displayName = 'FilterIcon';
var $356a9dc0786a9256$var$_default = module.exports.default = $356a9dc0786a9256$var$FilterIcon;

});

parcelRegister("226KS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46a94e1addf026bfebe08b8e272a8c2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17b1021e2b775282$var$_react = $17b1021e2b775282$var$_interopRequireDefault((parcelRequire("42omo")));

var $17b1021e2b775282$var$_baseNew = $17b1021e2b775282$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $17b1021e2b775282$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17b1021e2b775282$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $17b1021e2b775282$var$_react.default.createElement($17b1021e2b775282$var$_baseNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$17b1021e2b775282$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $17b1021e2b775282$var$_default = module.exports.default = $17b1021e2b775282$var$AssetsSchemaIcon;

});

parcelRegister("bbypI", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6lY6Z = parcelRequire("6lY6Z");

const $4804f2e382a4a42f$var$svgStyles = null;
const $4804f2e382a4a42f$var$CheckboxIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(9);
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    let t0;
    if ($[0] !== primaryColor || $[1] !== secondaryColor) {
        t0 = {
            color: primaryColor,
            fill: secondaryColor
        };
        $[0] = primaryColor;
        $[1] = secondaryColor;
        $[2] = t0;
    } else t0 = $[2];
    const t1 = label ? label : undefined;
    const t2 = label ? "img" : "presentation";
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]);
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ $42omo.createElement("g", {
            fillRule: "evenodd"
        }, /*#__PURE__*/ $42omo.createElement("rect", {
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        }), /*#__PURE__*/ $42omo.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        }));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
        t5 = /*#__PURE__*/ $42omo.createElement("svg", {
            viewBox: "0 0 24 24",
            style: t0,
            "aria-label": t1,
            role: t2,
            className: t3
        }, t4);
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ $42omo.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $42omo.createElement("rect", {
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })));
};
const $4804f2e382a4a42f$export$d40cc97ecda916f9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $42omo.createElement((0, $6lY6Z.ControlOption), {
            Icon: $4804f2e382a4a42f$var$CheckboxIcon,
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ $42omo.createElement((0, $6lY6Z.ControlOption), {
        Icon: $4804f2e382a4a42f$var$CheckboxIcon,
        ...props
    });
module.exports["CheckboxOption"] = $4804f2e382a4a42f$export$d40cc97ecda916f9;

});

parcelRegister("6lY6Z", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $bd4024c8312e5300$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    disabled: "_syaz1gmx"
}; // state of the parent option
const $bd4024c8312e5300$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #0515240F)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
}; // the secondary color represents the radio dot or checkmark
const $bd4024c8312e5300$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $bd4024c8312e5300$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $bd4024c8312e5300$var$baseIconStyles = null;
const $bd4024c8312e5300$var$baseOptionStyles = null;
const $bd4024c8312e5300$export$e41f7c07e51665da = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(32);
    const [isActive, setIsActive] = (0, $42omo.useState)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>setIsActive(true);
        $[0] = t0;
    } else t0 = $[0];
    const onMouseDown = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsActive(false);
        $[1] = t1;
    } else t1 = $[1];
    const onMouseUp = t1;
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    let t2;
    if ($[2] !== className || $[3] !== cx || $[4] !== isDisabled || $[5] !== isFocused || $[6] !== isSelected) {
        t2 = cx({
            option: true,
            "option--is-disabled": isDisabled,
            "option--is-focused": isFocused,
            "option--is-selected": isSelected
        }, className);
        $[2] = className;
        $[3] = cx;
        $[4] = isDisabled;
        $[5] = isFocused;
        $[6] = isSelected;
        $[7] = t2;
    } else t2 = $[7];
    const classNames = t2;
    const t3 = isFocused && $bd4024c8312e5300$var$optionStyles.focused;
    const t4 = isDisabled && $bd4024c8312e5300$var$optionStyles.disabled;
    let t5;
    if ($[8] !== classNames || $[9] !== t3 || $[10] !== t4) {
        t5 = (0, $gMc0m.default)([
            $bd4024c8312e5300$var$optionStyles.default,
            t3,
            t4,
            classNames
        ]);
        $[8] = classNames;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const t6 = isSelected || isActive || isDisabled ? $bd4024c8312e5300$var$iconStyles.inherit : $bd4024c8312e5300$var$iconStyles.default;
    let t7;
    if ($[12] !== t6) {
        t7 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
            t6
        ]);
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== Icon || $[15] !== isActive || $[16] !== isDisabled || $[17] !== isFocused || $[18] !== isSelected) {
        t8 = !!Icon ? /*#__PURE__*/ $42omo.createElement(Icon, {
            label: "",
            primaryColor: $bd4024c8312e5300$var$getPrimaryColor({
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFocused: isFocused,
                isActive: isActive
            }),
            secondaryColor: $bd4024c8312e5300$var$getSecondaryColor({
                isDisabled: isDisabled,
                isSelected: isSelected
            }),
            isFacadeDisabled: true
        }) : null;
        $[14] = Icon;
        $[15] = isActive;
        $[16] = isDisabled;
        $[17] = isFocused;
        $[18] = isSelected;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== t7 || $[21] !== t8) {
        t9 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t7
        }, t8);
        $[20] = t7;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $gMc0m.default)([
            "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
        ]);
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== children) {
        t11 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t10
        }, children);
        $[24] = children;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== innerProps || $[27] !== innerRef || $[28] !== t11 || $[29] !== t5 || $[30] !== t9) {
        t12 = /*#__PURE__*/ $42omo.createElement("div", {
            className: t5,
            ref: innerRef,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseLeave: onMouseUp,
            ...innerProps
        }, t9, t11);
        $[26] = innerProps;
        $[27] = innerRef;
        $[28] = t11;
        $[29] = t5;
        $[30] = t9;
        $[31] = t12;
    } else t12 = $[31];
    return t12;
} : (props)=>{
    const [isActive, setIsActive] = (0, $42omo.useState)(false);
    const onMouseDown = (0, $42omo.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $42omo.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $42omo.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            $bd4024c8312e5300$var$optionStyles.default,
            isFocused && $bd4024c8312e5300$var$optionStyles.focused,
            isDisabled && $bd4024c8312e5300$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
            isSelected || isActive || isDisabled ? $bd4024c8312e5300$var$iconStyles.inherit : $bd4024c8312e5300$var$iconStyles.default
        ])
    }, !!Icon ? /*#__PURE__*/ $42omo.createElement(Icon, {
        label: "",
        primaryColor: $bd4024c8312e5300$var$getPrimaryColor({
            isDisabled: isDisabled,
            isSelected: isSelected,
            isFocused: isFocused,
            isActive: isActive
        }),
        secondaryColor: $bd4024c8312e5300$var$getSecondaryColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        isFacadeDisabled: true
    }) : null), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
module.exports["ControlOption"] = $bd4024c8312e5300$export$e41f7c07e51665da;

});

parcelRegister("lwHnO", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3R0ts = parcelRequire("3R0ts");


var $j4ply = parcelRequire("j4ply");


var $4VmlX = parcelRequire("4VmlX");


var $djVCD = parcelRequire("djVCD");

const $bb22e0ff16ebda44$export$4def8a3173f48590 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { isEnabled: t2 } = t1;
    const isEnabled = t2 === undefined ? true : t2;
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { unselectProductFilter: unselectProductFilter } = (0, $djVCD.useSearchActions)();
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            includeSelectedProduct: false
        };
        $[2] = t3;
    } else t3 = $[2];
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)(t3);
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    let t4;
    let t5;
    if ($[3] !== isAnyFilterSelected || $[4] !== isEnabled || $[5] !== primaryProduct || $[6] !== selectedQueryFilters.length || $[7] !== unselectProductFilter) {
        t4 = ()=>{
            if (!(0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct) || !isEnabled) return;
            if (!isAnyFilterSelected && selectedQueryFilters.length === 0) unselectProductFilter();
        };
        t5 = [
            isAnyFilterSelected,
            primaryProduct,
            unselectProductFilter,
            selectedQueryFilters.length,
            isEnabled
        ];
        $[3] = isAnyFilterSelected;
        $[4] = isEnabled;
        $[5] = primaryProduct;
        $[6] = selectedQueryFilters.length;
        $[7] = unselectProductFilter;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    (0, $42omo.useEffect)(t4, t5);
} : ({ isEnabled: isEnabled = true } = {})=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { unselectProductFilter: unselectProductFilter } = (0, $djVCD.useSearchActions)();
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)({
        includeSelectedProduct: false
    });
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    (0, $42omo.useEffect)(()=>{
        if (!(0, $3R0ts.PRODUCTS_WITH_INLINE_FILTERS).includes(primaryProduct) || !isEnabled) return;
        // TODO: Make this smarter. Ideally, we should only unselect the product filter,
        // when that product filter is enabled and those product filters are empty. However
        // the isEmpty within useSelectedProduct is very very hard coded at the moment.
        if (!isAnyFilterSelected && selectedQueryFilters.length === 0) unselectProductFilter();
    }, [
        isAnyFilterSelected,
        primaryProduct,
        unselectProductFilter,
        selectedQueryFilters.length,
        isEnabled
    ]);
};
module.exports["useUnselectProductFilter"] = $bb22e0ff16ebda44$export$4def8a3173f48590;

});

parcelRegister("bAgd8", function(module, exports) {
const $ed5310e656bff040$export$190afca79c4d2b21 = {
    GNIN_HEURISTIC: 'GNIN_HEURISTIC',
    FPS_HEURISTIC: 'FPS_HEURISTIC'
};
module.exports["KnowledgeDiscoveryJiraIntentDetectionModel"] = $ed5310e656bff040$export$190afca79c4d2b21;

});

parcelRegister("4jvDJ", function(module, exports) {
function $9a81f9c5320fe052$export$5f50223bd877b041(result) {
    return result?.__typename === 'KnowledgeDiscoveryJiraIntentDetection';
}
module.exports["isIntentDetectionSuccess"] = $9a81f9c5320fe052$export$5f50223bd877b041;

});

parcelRegister("lh6Pw", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $5L4ws = parcelRequire("5L4ws");


var $3wZIu = parcelRequire("3wZIu");


var $4jvDJ = parcelRequire("4jvDJ");


const $0ccc59682dfec4cc$var$GQL_KNOWLEDGE_DISCOVERY_INTENT_OPERATION_NAME = 'KnowledgeDiscoveryJiraIntentDetectionQuery';
/**
 * GraphQL query string for Jira intent detection.
 */ const $0ccc59682dfec4cc$var$jiraIntentDetectionQueryString = `query ${$0ccc59682dfec4cc$var$GQL_KNOWLEDGE_DISCOVERY_INTENT_OPERATION_NAME}(
	$siteId: String!
	$orgId: String!
	$query: String!
	$experience: KnowledgeDiscoveryJiraSearchExperience!
	$model: KnowledgeDiscoveryJiraIntentDetectionModel!
	$sessionId: String
	$includePatternType: Boolean!
) {
	knowledgeDiscovery {
		jiraIntentDetection(
			siteId: $siteId
			orgId: $orgId
			query: $query
			experience: $experience
			model: $model
			sessionId: $sessionId
		) @optIn(to: "KnowledgeDiscovery Jira Intent Detection") {
			__typename
			... on KnowledgeDiscoveryJiraIntentDetection {
				searchClassification {
					type
					pattern @include(if: $includePatternType)
				}
			}
			... on QueryError {
				message
			}
		}
	}
}`;
const $0ccc59682dfec4cc$export$9e4d70b1495bfcd7 = async (variables, headers)=>{
    const cacheKey = (0, $5L4ws.createCacheKey)(variables);
    return (0, $3wZIu.intentDetectionCache).inMemoryDecorator(cacheKey, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $0ccc59682dfec4cc$var$jiraIntentDetectionQueryString,
            variables: variables,
            operationName: $0ccc59682dfec4cc$var$GQL_KNOWLEDGE_DISCOVERY_INTENT_OPERATION_NAME,
            headers: {
                'X-ExperimentalApi': 'KnowledgeDiscovery',
                ...headers
            }
        });
        const hasGraphQLErrors = response.errors?.some((error)=>error);
        if (hasGraphQLErrors) return Promise.reject(response);
        const result = response.data?.knowledgeDiscovery.jiraIntentDetection;
        if (result?.__typename === 'QueryError') return Promise.reject(response);
        return response;
    });
};
module.exports["jiraIntentDetectionQuery"] = $0ccc59682dfec4cc$export$9e4d70b1495bfcd7;

});

parcelRegister("k2lGv", function(module, exports) {
const $302fb312c45249fd$export$2bc60b2a116fbfaf = {
    QUICK_FIND: 'QUICK_FIND'
};
module.exports["KnowledgeDiscoveryJiraSearchExperience"] = $302fb312c45249fd$export$2bc60b2a116fbfaf;

});

parcelRegister("8PWzv", function(module, exports) {

let $66f08542dbbb37a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66f08542dbbb37a4$var$load("4KiYL").then(()=>parcelRequire('iTSW4'));

});

parcelRegister("ejJrc", function(module, exports) {

let $a6c61608bfd4511e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a6c61608bfd4511e$var$load("4KiYL").then(()=>parcelRequire('6r800'));

});

parcelRegister("2BDjU", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lFkSe = parcelRequire("lFkSe");


var $ncxs7 = parcelRequire("ncxs7");


var $9Phth = parcelRequire("9Phth");

const $b9ff1b999d67869c$export$ba912c88d6fa0f00 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { status: status, health: health, customColor: customColor, spacing: spacing, testId: testId, label: label } = t0;
    let t1;
    if ($[0] !== customColor || $[1] !== health || $[2] !== status) {
        t1 = status === "on_track" || status === "at_risk" || status === "off_track" ? (0, $ncxs7.getFocusAreaIconColor)({
            customColor: customColor,
            status: (0, $9Phth.FOCUS_AREA_STATUS_KEYS).IN_PROGRESS,
            health: status
        }) : (0, $ncxs7.getFocusAreaIconColor)({
            customColor: customColor,
            status: status,
            health: health
        });
        $[0] = customColor;
        $[1] = health;
        $[2] = status;
        $[3] = t1;
    } else t1 = $[3];
    const color = t1;
    const t2 = spacing || "none";
    const t3 = label || "";
    let t4;
    if ($[4] !== color || $[5] !== t2 || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
            color: color,
            spacing: t2,
            label: t3,
            testId: testId
        });
        $[4] = color;
        $[5] = t2;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ status: status, health: health, customColor: customColor, spacing: spacing, testId: testId, label: label })=>{
    const color = status === 'on_track' || status === 'at_risk' || status === 'off_track' ? (0, $ncxs7.getFocusAreaIconColor)({
        customColor: customColor,
        status: (0, $9Phth.FOCUS_AREA_STATUS_KEYS).IN_PROGRESS,
        health: status
    }) : (0, $ncxs7.getFocusAreaIconColor)({
        customColor: customColor,
        status: status,
        health: health
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
        color: color,
        spacing: spacing || 'none',
        label: label || '',
        testId: testId
    });
};
const $b9ff1b999d67869c$var$FocusAreaIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? function FocusAreaIcon(t0) {
    const $ = (0, $frIzR.c)(9);
    const { status: status, health: health, customColor: customColor, spacing: spacing, testId: testId, label: label } = t0;
    let t1;
    if ($[0] !== customColor || $[1] !== health || $[2] !== status) {
        t1 = (0, $ncxs7.getFocusAreaIconColor)({
            customColor: customColor,
            status: status,
            health: health
        });
        $[0] = customColor;
        $[1] = health;
        $[2] = status;
        $[3] = t1;
    } else t1 = $[3];
    const t2 = spacing || "none";
    const t3 = label || "";
    let t4;
    if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
            color: t1,
            spacing: t2,
            label: t3,
            testId: testId
        });
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function FocusAreaIcon({ status: status, health: health, customColor: customColor, spacing: spacing, testId: testId, label: label }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
        color: (0, $ncxs7.getFocusAreaIconColor)({
            customColor: customColor,
            status: status,
            health: health
        }),
        spacing: spacing || 'none',
        label: label || '',
        testId: testId
    });
};
var $b9ff1b999d67869c$export$2e2bcd8739ae039 = $b9ff1b999d67869c$var$FocusAreaIcon;
module.exports["default"] = $b9ff1b999d67869c$export$2e2bcd8739ae039;

});

parcelRegister("lFkSe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76102cae83ff84364fe0f8b9a98fb276>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc5d9e69cae7ca27$var$_react = $fc5d9e69cae7ca27$var$_interopRequireDefault((parcelRequire("42omo")));

var $fc5d9e69cae7ca27$var$_baseNew = $fc5d9e69cae7ca27$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fc5d9e69cae7ca27$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FocusArea".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Focus Areas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc5d9e69cae7ca27$var$FocusAreaIcon = (props)=>/*#__PURE__*/ $fc5d9e69cae7ca27$var$_react.default.createElement($fc5d9e69cae7ca27$var$_baseNew.default, Object.assign({
        name: "FocusAreaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13v-3h1.5v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2m12.5 0v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5M9.75 8a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0M1 3a2 2 0 0 1 2-2h3v1.5H3a.5.5 0 0 0-.5.5v3H1zm12.5 0a.5.5 0 0 0-.5-.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5zm-2.25 5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0"/>`
    }, props));
$fc5d9e69cae7ca27$var$FocusAreaIcon.displayName = 'FocusAreaIcon';
var $fc5d9e69cae7ca27$var$_default = module.exports.default = $fc5d9e69cae7ca27$var$FocusAreaIcon;

});

parcelRegister("ncxs7", function(module, exports) {

var $9Phth = parcelRequire("9Phth");

const $dec905367716080f$export$4ee6399ea9bdb374 = ({ customColor: customColor, status: status, health: health })=>customColor || (0, $9Phth.FOCUS_AREA_DERIVED_STATUS_KEY_TO_COLOR_MAP)[$dec905367716080f$export$dc241ab7a519fd3f({
        status: status,
        health: health
    }).derivedStatusKey];
const $dec905367716080f$export$dc241ab7a519fd3f = ({ status: status, health: health })=>{
    const statusKey = $dec905367716080f$var$getValidStatus(status);
    const healthKey = $dec905367716080f$var$getValidHealth(health);
    const derivedStatusKey = statusKey === (0, $9Phth.FOCUS_AREA_STATUS_KEYS).IN_PROGRESS && healthKey ? healthKey : statusKey;
    return {
        derivedStatusKey: derivedStatusKey,
        derivedStatusLabel: (0, $9Phth.FOCUS_AREA_DERIVED_STATUS_KEY_TO_LABEL_MAP)[derivedStatusKey]
    };
};
const $dec905367716080f$var$getValidStatus = (status)=>status && (0, $9Phth.FOCUS_AREA_STATUS_KEYS_LIST).includes(status) ? status : (0, $9Phth.FOCUS_AREA_STATUS_KEYS).PENDING;
const $dec905367716080f$var$getValidHealth = (health)=>health && (0, $9Phth.FOCUS_AREA_HEALTH_KEYS_LIST).includes(health) ? health : undefined;
module.exports["getFocusAreaIconColor"] = $dec905367716080f$export$4ee6399ea9bdb374;

});

parcelRegister("9Phth", function(module, exports) {
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING = 'pending';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS = 'in_progress';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED = 'paused';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED = 'completed';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK = 'on_track';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK = 'at_risk';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK = 'off_track';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING = 'Pending';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS = 'In progress';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED = 'Paused';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED = 'Completed';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK = 'On track';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK = 'At risk';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK = 'Off track';
const $76dba10ec45af105$export$c567f03f9a52e6e = {
    PENDING: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING,
    IN_PROGRESS: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS,
    PAUSED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED,
    COMPLETED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED
};
const $76dba10ec45af105$export$18c983eb7bb605ee = {
    ON_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK,
    AT_RISK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK,
    OFF_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK
};
const $76dba10ec45af105$export$a75c07cb53bf7489 = {
    PENDING: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING,
    IN_PROGRESS: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS,
    PAUSED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED,
    COMPLETED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED
};
const $76dba10ec45af105$export$b00cb7f00f2a82c0 = {
    ON_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK,
    AT_RISK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK,
    OFF_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK
};
const $76dba10ec45af105$export$8ed017a96b82c456 = [
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED
];
const $76dba10ec45af105$export$91000048f1c8a9ff = [
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK,
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK,
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK
];
const $76dba10ec45af105$export$521c96d8ff090910 = {
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED
};
const $76dba10ec45af105$export$b4e54ea069601d19 = {
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK,
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK,
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK
};
const $76dba10ec45af105$export$357f9a743d453edd = {
    ...$76dba10ec45af105$export$521c96d8ff090910,
    ...$76dba10ec45af105$export$b4e54ea069601d19
};
const $76dba10ec45af105$export$8a9f9b723771f4eb = {
    pending: "var(--ds-icon-accent-gray, #7D818A)",
    in_progress: "var(--ds-icon-accent-gray, #7D818A)",
    on_track: "var(--ds-icon-accent-lime, #6A9A23)",
    at_risk: "var(--ds-icon-warning, #E06C00)",
    off_track: "var(--ds-icon-accent-red, #C9372C)",
    paused: "var(--ds-icon-accent-gray, #7D818A)",
    completed: "var(--ds-icon-accent-gray, #7D818A)"
};
module.exports["FOCUS_AREA_STATUS_KEYS"] = $76dba10ec45af105$export$c567f03f9a52e6e;
module.exports["FOCUS_AREA_STATUS_KEYS_LIST"] = $76dba10ec45af105$export$8ed017a96b82c456;
module.exports["FOCUS_AREA_HEALTH_KEYS_LIST"] = $76dba10ec45af105$export$91000048f1c8a9ff;
module.exports["FOCUS_AREA_DERIVED_STATUS_KEY_TO_LABEL_MAP"] = $76dba10ec45af105$export$357f9a743d453edd;
module.exports["FOCUS_AREA_DERIVED_STATUS_KEY_TO_COLOR_MAP"] = $76dba10ec45af105$export$8a9f9b723771f4eb;

});

parcelRegister("eoZFI", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $90d48fa2203af19d$var$styles = {
    default: "_1e0cglyw",
    'above.xs': "_114b19ly",
    'above.sm': "_181n19ly",
    'above.md': "_dm2519ly",
    'above.lg': "_je3o19ly",
    'above.xl': "_1uxv19ly",
    'below.xs': "_1m0a19ly",
    'below.sm': "_suga19ly",
    'below.md': "_1mjb19ly",
    'below.lg': "_liwc19ly",
    'below.xl': "_14wz19ly"
};
const $90d48fa2203af19d$export$f6a3d19be20f5819 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { above: above, below: below, children: children, as: t1, xcss: xcss } = t0;
    const AsElement = t1 === undefined ? "div" : t1;
    const t2 = above && $90d48fa2203af19d$var$styles[`above.${above}`];
    const t3 = below && $90d48fa2203af19d$var$styles[`below.${below}`];
    let t4;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== xcss) {
        t4 = (0, $gMc0m.default)([
            $90d48fa2203af19d$var$styles.default,
            t2,
            t3,
            xcss
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = xcss;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== AsElement || $[5] !== children || $[6] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(AsElement, {
            className: t4
        }, children);
        $[4] = AsElement;
        $[5] = children;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ $42omo.createElement(AsElement, {
        className: (0, $gMc0m.default)([
            $90d48fa2203af19d$var$styles.default,
            above && $90d48fa2203af19d$var$styles[`above.${above}`],
            below && $90d48fa2203af19d$var$styles[`below.${below}`],
            xcss
        ])
    }, children);
};
module.exports["Show"] = $90d48fa2203af19d$export$f6a3d19be20f5819;

});

parcelRegister("hSHFH", function(module, exports) {

var $917iu = parcelRequire("917iu");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $kKl1I = parcelRequire("kKl1I");

const $7753a4d6370fffc0$var$FIRST_THIRTY_DAYS_THRESHOLD = 30;
function $7753a4d6370fffc0$export$d19426ed5c8e7319(numberOfDays = $7753a4d6370fffc0$var$FIRST_THIRTY_DAYS_THRESHOLD) {
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const isAdmin = (0, $8Lx5S.useIsAdmin)();
    const shouldSkipForPreConditions = !isRovoEnabled || !isAdmin;
    const { onboardingState: onboardingState, loading: isOnboardingStateLoading, error: onboardingStateError } = (0, $kKl1I.useConnectorOnboardingState)({
        skip: !(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-fg') || shouldSkipForPreConditions
    });
    if (shouldSkipForPreConditions || isOnboardingStateLoading) return {
        isEnabled: false
    };
    // Unauthorized errors are already marked as handled inside useConnectorOnboardingState.
    // Non-unauthorized errors are left unhandled so they reach error monitoring.
    if (onboardingStateError) return {
        isEnabled: false
    };
    const { enrolmentDate: enrolmentDate, promoDismissed: promoDismissed } = onboardingState ?? {};
    // Skip when the user has dismissed both promo surfaces
    if (promoDismissed === 'both') return {
        isEnabled: false
    };
    // Only show to users within the first 30 days of their experiment enrolment
    const isWithinFirstThirtyDays = Boolean(enrolmentDate) && (0, $917iu.default)(new Date(), new Date(enrolmentDate)) < numberOfDays;
    if (!isWithinFirstThirtyDays) return {
        isEnabled: false
    };
    return {
        isEnabled: (0, $6mKj3.expVal)('twcg-1489-cc-3p-connector-onboarding', 'isEnabled', false)
    };
}
module.exports["useIsConnectorOnboardingEnabled"] = $7753a4d6370fffc0$export$d19426ed5c8e7319;

});

parcelRegister("kKl1I", function(module, exports) {

var $gikGR = parcelRequire("gikGR");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iQzVo = parcelRequire("iQzVo");

const $28cbb6f1931650bc$var$EMPTY_ENTRIES = [];
const $28cbb6f1931650bc$var$connectorOnboardingStateQuery = (0, $gikGR.default);
// Optimistic local overrides layered on top of the AGG query result, so dismiss
// and spotlight updates apply immediately without waiting for a refetch.
const $28cbb6f1931650bc$var$LocalOnboardingStateStore = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        updateLocalOnboardingState: ({ key: key, value: value })=>({ setState: setState })=>{
                switch(key){
                    case (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).ENROLMENT_DATE:
                        setState({
                            enrolmentDate: value
                        });
                        break;
                    case (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).SPOTLIGHT_SHOWN:
                        setState({
                            spotlightShown: value === 'true'
                        });
                        break;
                    case (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED:
                        setState({
                            promoDismissed: value
                        });
                        break;
                }
            }
    },
    name: 'Twcg1489LocalOnboardingStateStore'
});
const $28cbb6f1931650bc$var$useLocalOnboardingState = (0, $9zUhf.createStateHook)($28cbb6f1931650bc$var$LocalOnboardingStateStore);
const $28cbb6f1931650bc$var$useLocalOnboardingStateActions = (0, $9zUhf.createActionsHook)($28cbb6f1931650bc$var$LocalOnboardingStateStore);
function $28cbb6f1931650bc$export$f605414f82afac1e({ skip: skip } = {}) {
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($28cbb6f1931650bc$var$connectorOnboardingStateQuery, {
        variables: {},
        skip: skip || !isLicensed,
        interopApolloAggClient: true,
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/experiment-twcg-1489-cc-3p-connector-onboarding"
    });
    const entries = data?.userPreferences?.onboardingState ?? $28cbb6f1931650bc$var$EMPTY_ENTRIES;
    const localOnboardingStateSnapshot = $28cbb6f1931650bc$var$useLocalOnboardingState();
    const { updateLocalOnboardingState: updateOnboardingState } = $28cbb6f1931650bc$var$useLocalOnboardingStateActions();
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            onboardingState: undefined,
            loading: false,
            error: error,
            updateOnboardingState: updateOnboardingState
        };
    }
    if (loading) return {
        onboardingState: undefined,
        loading: true,
        updateOnboardingState: updateOnboardingState
    };
    const findValue = (key)=>entries.find((e)=>e.key === key)?.value ?? undefined;
    const queryOnboardingState = {
        enrolmentDate: findValue((0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).ENROLMENT_DATE),
        spotlightShown: findValue((0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).SPOTLIGHT_SHOWN) === 'true',
        promoDismissed: findValue((0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED)
    };
    return {
        onboardingState: {
            ...queryOnboardingState,
            ...localOnboardingStateSnapshot
        },
        loading: false,
        updateOnboardingState: updateOnboardingState
    };
}
module.exports["useConnectorOnboardingState"] = $28cbb6f1931650bc$export$f605414f82afac1e;

});

parcelRegister("cuiaa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");

const $b8b1413048b56524$var$getAdminHubConnectorLink = ({ orgId: orgId, siteId: siteId, environment: environment })=>{
    if (!orgId || !siteId || !environment) return undefined;
    if (environment === 'PRODUCTION') return `https://admin.atlassian.com/o/${orgId}/connectors?site-id=${siteId}`;
    else if (environment === 'STAGING') return `https://admin.stg.atlassian.com/o/${orgId}/connectors?site-id=${siteId}`;
    return undefined;
};
const $b8b1413048b56524$export$af0691a8da0ce060 = ()=>{
    const { orgId: orgId, cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useMemo)(()=>$b8b1413048b56524$var$getAdminHubConnectorLink({
            orgId: orgId,
            siteId: cloudId,
            environment: environment
        }), [
        orgId,
        cloudId,
        environment
    ]);
};
module.exports["useAdminHubConnectorLink"] = $b8b1413048b56524$export$af0691a8da0ce060;

});

parcelRegister("2u5DE", function(module, exports) {
/* ConnectorIconPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $iXCQx = parcelRequire("iXCQx");


var $4m1Oz = parcelRequire("4m1Oz");

const $d17daeda8c6eb45a$var$styles = {
    base: "_2rkolb4i _1e0c1txw _4cvr1h6o _1bah1h6o",
    16: "_1bsb7vkz _4t3i7vkz",
    20: "_1bsbgktf _4t3igktf",
    24: "_1bsb1tcg _4t3i1tcg"
};
const $d17daeda8c6eb45a$export$9e3ad3aeb0d31482 = ({ connector: connector, size: size = 24 })=>{
    const { key: key, displayName: displayName } = connector;
    const LogoComponent = (0, $4m1Oz.getDataSourceLogo)(key);
    if (LogoComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($d17daeda8c6eb45a$var$styles.base, $d17daeda8c6eb45a$var$styles[size]),
        role: "img",
        "aria-label": displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LogoComponent, {
        size: size
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($d17daeda8c6eb45a$var$styles.base, $d17daeda8c6eb45a$var$styles[size]),
        role: "img",
        "aria-label": displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        weight: "semibold",
        color: "color.text.subtle"
    }, displayName.charAt(0).toUpperCase()));
};
module.exports["ConnectorIconPlaceholder"] = $d17daeda8c6eb45a$export$9e3ad3aeb0d31482;

});

parcelRegister("4m1Oz", function(module, exports) {
/**
 * Minimal entry point for connector display utilities.
 *
 * Exports only what is needed to resolve connector display names and logos
 * for UI surfaces that do not require the full form-builder UI. This imports
 * from `connector-display-data` which contains only display name messages and
 * SVG icon references, completely avoiding the heavy form-builder configs,
 * feature-gate side effects, URL constants, and connector-specific UI
 * components bundled by `/ui`.
 */ 
var $7Ahyw = parcelRequire("7Ahyw");

const $3cf416eed42ff920$export$b105eabd53e3db4d = (connectorType)=>{
    if (connectorType in (0, $7Ahyw.connectorDisplayDataMap)) return (0, $7Ahyw.connectorDisplayDataMap)[connectorType].icon;
    return undefined;
};
const $3cf416eed42ff920$export$aa607b28e60073a4 = (connectorType, _datasource)=>{
    if (connectorType in (0, $7Ahyw.connectorDisplayDataMap)) return (0, $7Ahyw.connectorDisplayDataMap)[connectorType].displayName;
    return '';
};
module.exports["getDataSourceLogo"] = $3cf416eed42ff920$export$b105eabd53e3db4d;
module.exports["getDataSourceTitle"] = $3cf416eed42ff920$export$aa607b28e60073a4;

});

parcelRegister("7Ahyw", function(module, exports) {
/**
 * Lightweight connector display data: display names and icon components only.
 *
 * This module is the single source of truth for connector display metadata
 * (name + icon). It deliberately avoids importing the full form-builder
 * connector configs, feature-gate logic, URL constants, and heavy UI
 * components so that consumers who only need display information (e.g. the
 * `/connector-display-utils` entry point) do not pull in the entire
 * form-builder dependency graph.
 *
 * The full `configsMap` in `displayed-third-party-products.tsx` references
 * this data via each connector config's `connectorDisplayName` and `icon`
 * fields, which remain the canonical values defined in each config file.
 * This module duplicates only the display name message descriptors so it can
 * stand alone without importing those config files.
 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1C4E7 = parcelRequire("1C4E7");


var $k2ZWs = parcelRequire("k2ZWs");

// ---------------------------------------------------------------------------
// Display name messages
// ---------------------------------------------------------------------------
// These mirror the `connectorDisplayName` message descriptors defined in each
// connector config file. The message IDs MUST stay in sync with the originals.
const $f3a07f6d44a4a605$var$displayMessages = (0, $aXWIB.defineMessages)({
    adobeSign: {
        id: "adobe-sign-connector.connector-display-name",
        defaultMessage: "Adobe Sign"
    },
    aha: {
        id: "aha-connector.connector-display-name",
        defaultMessage: "Aha!"
    },
    airtable: {
        id: "airtable-connector.connector-display-name",
        defaultMessage: "Airtable"
    },
    asana: {
        id: "asana-connector.connector-display-name",
        defaultMessage: "Asana"
    },
    azureDevops: {
        id: "azure-devops-connector.connector-display-name",
        defaultMessage: "Azure DevOps"
    },
    box: {
        id: "box-connector.connector-display-name",
        defaultMessage: "Box"
    },
    canva: {
        id: "canva-connector.connector-display-name",
        defaultMessage: "Canva"
    },
    confluenceDC: {
        id: "confluence-dc-connector.connector-display-name",
        defaultMessage: "Confluence Data Center"
    },
    databricks: {
        id: "databricks-connector.connector-display-name",
        defaultMessage: "Databricks"
    },
    datadog: {
        id: "datadog-connector.connector-display-name",
        defaultMessage: "Datadog"
    },
    demoConnector: {
        id: "demo-connector.connector-display-name.nonfinal",
        defaultMessage: "Demo Connector"
    },
    docusign: {
        id: "docusign-connector.connector-display-name",
        defaultMessage: "Docusign"
    },
    dropbox: {
        id: "dropbox-connector.connector-display-name",
        defaultMessage: "Dropbox"
    },
    dynatrace: {
        id: "dynatrace-connector.connector-display-name.nonfinal",
        defaultMessage: "Dynatrace"
    },
    exampleConnector: {
        id: "example-connector-config.connector-display-name.nonfinal",
        defaultMessage: "Example Connector"
    },
    exampleConnectorOAuth: {
        id: "example-connector-config.oauth-connector-display-name.nonfinal",
        defaultMessage: "Example Connector OAuth"
    },
    github: {
        id: "github-connector.connector-display-name",
        defaultMessage: "GitHub"
    },
    gitlab: {
        id: "gitlab-connector.connector-display-name",
        defaultMessage: "GitLab"
    },
    gmail: {
        id: "gmail-connector",
        defaultMessage: "Gmail"
    },
    googleCalendar: {
        id: "google-calendar-connector",
        defaultMessage: "Google Calendar"
    },
    googleDrive: {
        id: "google-drive-connector.display-name",
        defaultMessage: "Google Drive"
    },
    hris: {
        id: "hris-s3-connector.connector-display-name",
        defaultMessage: "HRIS S3"
    },
    hubspot: {
        id: "hubspot-connector.connector-display-name",
        defaultMessage: "HubSpot"
    },
    jiraDC: {
        id: "jira-dc-connector.connector-display-name",
        defaultMessage: "Jira Data Center"
    },
    lucid: {
        id: "lucid-connector.connector-display-name",
        defaultMessage: "Lucid"
    },
    microsoftTeams: {
        id: "teams-connector.connector-display-name",
        defaultMessage: "Microsoft Teams"
    },
    miro: {
        id: "miro-connector.connector-display-name",
        defaultMessage: "Miro"
    },
    monday: {
        id: "monday-connector.connector-display-name",
        defaultMessage: "Monday"
    },
    newrelic: {
        id: "newrelic-connector.connector-display-name",
        defaultMessage: "NewRelic"
    },
    notion: {
        id: "notion-connector.connector-display-name",
        defaultMessage: "Notion"
    },
    outlookCalendar: {
        id: "outlook-calendar-connector.connector-display-name",
        defaultMessage: "Microsoft Outlook Calendar"
    },
    outlookMail: {
        id: "outlook-mail-connector.connector-display-name",
        defaultMessage: "Microsoft Outlook Mail"
    },
    platformSharepoint: {
        id: "sharepoint-connector.platform-connector-display-name",
        defaultMessage: "Microsoft SharePoint and OneDrive"
    },
    salesforce: {
        id: "salesforce-connector.connector-display-name",
        defaultMessage: "Salesforce"
    },
    servicenow: {
        id: "servicenow-connector.connector-display-name",
        defaultMessage: "ServiceNow"
    },
    slack: {
        id: "slack-connector.connector-display-name",
        defaultMessage: "Slack"
    },
    smartsheet: {
        id: "smartsheet-connector.connector-display-name",
        defaultMessage: "Smartsheet"
    },
    spinnaker: {
        id: "spinnaker-connector.connector-display-name",
        defaultMessage: "Spinnaker"
    },
    webCrawler: {
        id: "web-crawler-connector.connector-display-name",
        defaultMessage: "Custom website"
    },
    workday: {
        id: "workday-connector.connector-display-name",
        defaultMessage: "Workday"
    },
    workdayV2: {
        id: "workday-v2-connector.connector-display-name",
        defaultMessage: "Workday"
    },
    zendesk: {
        id: "zendesk-connector.connector-display-name",
        defaultMessage: "Zendesk"
    }
});
const $f3a07f6d44a4a605$export$fc76a4fd8a4832c4 = {
    'test-connector-config-local': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.exampleConnector,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: ""
            })
    },
    'test-connector-config-local-oauth': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.exampleConnectorOAuth,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: ""
            })
    },
    'demo-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.demoConnector,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.rocketImage)
            })
    },
    'github-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.github,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.githubIcon)
            })
    },
    'microsoft-teams-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.microsoftTeams,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.microsoftTeamsIcon)
            })
    },
    'gmail-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.gmail,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.gmailIcon)
            })
    },
    'google-calendar-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.googleCalendar,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.googleCalendarIcon)
            })
    },
    'dropbox-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.dropbox,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.dropboxIcon)
            })
    },
    'salesforce-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.salesforce,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.salesforceIcon)
            })
    },
    'outlook-mail-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.outlookMail,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.microsoftOutlookMailIcon)
            })
    },
    'airtable-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.airtable,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.airtableIcon)
            })
    },
    'asana-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.asana,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.asanaIcon)
            })
    },
    'smartsheet-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.smartsheet,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.smartsheetIcon)
            })
    },
    'outlook-calendar-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.outlookCalendar,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.microsoftOutlookCalendarIcon)
            })
    },
    'notion-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.notion,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.notionIcon)
            })
    },
    'zendesk-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.zendesk,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.zendeskIcon)
            })
    },
    'docusign-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.docusign,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.docusignIcon)
            })
    },
    'servicenow-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.servicenow,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.serviceNowIcon)
            })
    },
    'miro-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.miro,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.miroIcon)
            })
    },
    'gitlab-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.gitlab,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.gitlabIcon)
            })
    },
    'lucid-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.lucid,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.lucidIcon)
            })
    },
    'box-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.box,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.boxIcon)
            })
    },
    'canva-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.canva,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.canvaIcon)
            })
    },
    'azure-devops-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.azureDevops,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.azureDevopsIcon)
            })
    },
    'adobe-sign-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.adobeSign,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.adobeSignIcon)
            })
    },
    'confluence-dc-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.confluenceDC,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.confluenceDcIcon)
            })
    },
    'platform-sharepoint-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.platformSharepoint,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.microsoftSharepointIcon)
            })
    },
    'jira-dc-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.jiraDC,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.jiraDcIcon)
            })
    },
    'monday-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.monday,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.mondayIcon)
            })
    },
    'aha-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.aha,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.ahaIcon)
            })
    },
    'workday-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.workday,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.workdayIcon)
            })
    },
    'workday-v2-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.workdayV2,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.workdayIcon)
            })
    },
    'platform-google-calendar-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.googleCalendar,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.googleCalendarIcon)
            })
    },
    'platform-google-drive-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.googleDrive,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.googleDriveIcon)
            })
    },
    'spinnaker-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.spinnaker,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.spinnakerIcon)
            })
    },
    'slack-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.slack,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.slackIcon)
            })
    },
    'hubspot-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.hubspot,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.hubspotIcon)
            })
    },
    'datadog-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.datadog,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.datadogIcon)
            })
    },
    'newrelic-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.newrelic,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.newrelicIcon)
            })
    },
    'dynatrace-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.dynatrace,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.dynatraceIcon)
            })
    },
    'databricks-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.databricks,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.databricksIcon)
            })
    },
    'hris-s3-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.hris,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.hrisIcon)
            })
    },
    'webcrawler-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.webCrawler,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.globeIcon)
            })
    },
    'platform-webcrawler-connector': {
        displayName: $f3a07f6d44a4a605$var$displayMessages.webCrawler,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k2ZWs.ConnectorLogo), {
                logo: (0, $1C4E7.globeIcon)
            })
    }
};
module.exports["connectorDisplayDataMap"] = $f3a07f6d44a4a605$export$fc76a4fd8a4832c4;

});

parcelRegister("1C4E7", function(module, exports) {
// Third-party connector icon images — copied from @adminhub/images for platform compatibility.
// These are referenced by connector-config files in src/ui/third-party-connector-form-builder/connector-configs/
// SVGs are resolved as URLs by atlaspack's asset pipeline at build time.
// In test environments, .svg files are mapped to empty strings via jest moduleNameMapper.
/* eslint-disable @typescript-eslint/no-require-imports */ 
const $a9d38aa48a30a78c$export$c86730c131d2f3cc = (parcelRequire("9Jkbc"));

const $a9d38aa48a30a78c$export$f0f6f4f6bb6e9349 = (parcelRequire("1s5z9"));

const $a9d38aa48a30a78c$export$46ea6dc302d0f0a = (parcelRequire("54rnf"));

const $a9d38aa48a30a78c$export$b22823518e36334e = (parcelRequire("1cfs3"));

const $a9d38aa48a30a78c$export$2744b5ea74dc03ff = (parcelRequire("crIKC"));

const $a9d38aa48a30a78c$export$c488fbe6d7288f7d = (parcelRequire("aiiQ5"));

const $a9d38aa48a30a78c$export$686a733b02d2a3e = (parcelRequire("7r931"));

const $a9d38aa48a30a78c$export$758e097a8df4eec4 = (parcelRequire("1CLIe"));

const $a9d38aa48a30a78c$export$d9b15434df571009 = (parcelRequire("35tSi"));

const $a9d38aa48a30a78c$export$eb65756916d57281 = (parcelRequire("6F6sw"));

const $a9d38aa48a30a78c$export$de98edae74bf0df = (parcelRequire("cV21T"));

const $a9d38aa48a30a78c$export$af9abbc3feb8b359 = (parcelRequire("jzI04"));

const $a9d38aa48a30a78c$export$9e9f02e91729add5 = (parcelRequire("dwAeX"));

const $a9d38aa48a30a78c$export$d99a65d9b146633e = (parcelRequire("iZFr3"));

const $a9d38aa48a30a78c$export$a524e8376f899930 = (parcelRequire("4l9jV"));

const $a9d38aa48a30a78c$export$6b7d25f37a70befe = (parcelRequire("ldpBC"));

const $a9d38aa48a30a78c$export$2034a2589eecaa5c = (parcelRequire("9G8nc"));

const $a9d38aa48a30a78c$export$57ef8b8f5869157d = (parcelRequire("4Zls6"));

const $a9d38aa48a30a78c$export$2bf34d2a9056d77c = (parcelRequire("hsQay"));

const $a9d38aa48a30a78c$export$f3ca26e75060de80 = (parcelRequire("kwwfI"));

const $a9d38aa48a30a78c$export$4af9e0a4b175bc2a = (parcelRequire("b91Ta"));

const $a9d38aa48a30a78c$export$c7a4f6dcbe93e7b1 = (parcelRequire("i4w5M"));

const $a9d38aa48a30a78c$export$8ac79c7d53d84b69 = (parcelRequire("hbkdt"));

const $a9d38aa48a30a78c$export$1f8ab749a431e4c8 = (parcelRequire("9LFSE"));

const $a9d38aa48a30a78c$export$c9aabe3d67a5b770 = (parcelRequire("9NjXW"));

const $a9d38aa48a30a78c$export$b116e5c081b8445d = (parcelRequire("4NS8e"));

const $a9d38aa48a30a78c$export$906740f52524a876 = (parcelRequire("6ijeX"));

const $a9d38aa48a30a78c$export$17de4181f07cf7b5 = (parcelRequire("2s32V"));

const $a9d38aa48a30a78c$export$f42a37f560d03e51 = (parcelRequire("9RN6T"));

const $a9d38aa48a30a78c$export$f3db4cbfb1bf51ac = (parcelRequire("77dr4"));

const $a9d38aa48a30a78c$export$1e2bfcf9dbd71008 = (parcelRequire("7dyYu"));

const $a9d38aa48a30a78c$export$49ad4fc00eb9dc4e = (parcelRequire("jV4Cu"));

const $a9d38aa48a30a78c$export$75e811a5a676c5fa = (parcelRequire("d6Ap9"));

const $a9d38aa48a30a78c$export$69bc00f5da821a9b = (parcelRequire("95zan"));

const $a9d38aa48a30a78c$export$a73eefa8f520e6fc = (parcelRequire("lfEYO"));

const $a9d38aa48a30a78c$export$1c1f7c7878a8dd49 = (parcelRequire("9zfsd"));

const $a9d38aa48a30a78c$export$fb1302f32e7ee148 = (parcelRequire("3DNiZ"));

const $a9d38aa48a30a78c$export$3e8ee1c719d41455 = (parcelRequire("9QAB5"));

const $a9d38aa48a30a78c$export$3513e1b10dfd8814 = (parcelRequire("6mvCq"));

const $a9d38aa48a30a78c$export$a7a1183e4d683be7 = (parcelRequire("bffTB"));

const $a9d38aa48a30a78c$export$9879212c14c14243 = (parcelRequire("leVwK"));

const $a9d38aa48a30a78c$export$d682797c8090fb84 = (parcelRequire("eAG3X"));

const $a9d38aa48a30a78c$export$a2c286fab745934a = (parcelRequire("9O7Z1"));

const $a9d38aa48a30a78c$export$fe6835ee3fb12229 = (parcelRequire("33tCi"));
module.exports["adobeSignIcon"] = $a9d38aa48a30a78c$export$c86730c131d2f3cc;
module.exports["ahaIcon"] = $a9d38aa48a30a78c$export$f0f6f4f6bb6e9349;
module.exports["airtableIcon"] = $a9d38aa48a30a78c$export$46ea6dc302d0f0a;
module.exports["asanaIcon"] = $a9d38aa48a30a78c$export$b22823518e36334e;
module.exports["azureDevopsIcon"] = $a9d38aa48a30a78c$export$2744b5ea74dc03ff;
module.exports["boxIcon"] = $a9d38aa48a30a78c$export$c488fbe6d7288f7d;
module.exports["canvaIcon"] = $a9d38aa48a30a78c$export$686a733b02d2a3e;
module.exports["confluenceDcDefaultSpaceIcon"] = $a9d38aa48a30a78c$export$758e097a8df4eec4;
module.exports["confluenceDcIcon"] = $a9d38aa48a30a78c$export$d9b15434df571009;
module.exports["databricksIcon"] = $a9d38aa48a30a78c$export$eb65756916d57281;
module.exports["datadogIcon"] = $a9d38aa48a30a78c$export$de98edae74bf0df;
module.exports["docusignIcon"] = $a9d38aa48a30a78c$export$af9abbc3feb8b359;
module.exports["dropboxIcon"] = $a9d38aa48a30a78c$export$9e9f02e91729add5;
module.exports["dynatraceIcon"] = $a9d38aa48a30a78c$export$d99a65d9b146633e;
module.exports["githubIcon"] = $a9d38aa48a30a78c$export$a524e8376f899930;
module.exports["gitlabIcon"] = $a9d38aa48a30a78c$export$6b7d25f37a70befe;
module.exports["globeIcon"] = $a9d38aa48a30a78c$export$2034a2589eecaa5c;
module.exports["globeIconBrand"] = $a9d38aa48a30a78c$export$57ef8b8f5869157d;
module.exports["gmailIcon"] = $a9d38aa48a30a78c$export$2bf34d2a9056d77c;
module.exports["googleCalendarIcon"] = $a9d38aa48a30a78c$export$f3ca26e75060de80;
module.exports["googleDriveIcon"] = $a9d38aa48a30a78c$export$4af9e0a4b175bc2a;
module.exports["hrisIcon"] = $a9d38aa48a30a78c$export$c7a4f6dcbe93e7b1;
module.exports["hubspotIcon"] = $a9d38aa48a30a78c$export$8ac79c7d53d84b69;
module.exports["jiraDcIcon"] = $a9d38aa48a30a78c$export$1f8ab749a431e4c8;
module.exports["jiraDefaultProjectIcon"] = $a9d38aa48a30a78c$export$c9aabe3d67a5b770;
module.exports["lucidIcon"] = $a9d38aa48a30a78c$export$b116e5c081b8445d;
module.exports["microsoftOutlookCalendarIcon"] = $a9d38aa48a30a78c$export$906740f52524a876;
module.exports["microsoftOutlookMailIcon"] = $a9d38aa48a30a78c$export$17de4181f07cf7b5;
module.exports["microsoftSharepointIcon"] = $a9d38aa48a30a78c$export$f42a37f560d03e51;
module.exports["microsoftTeamsIcon"] = $a9d38aa48a30a78c$export$f3db4cbfb1bf51ac;
module.exports["miroIcon"] = $a9d38aa48a30a78c$export$1e2bfcf9dbd71008;
module.exports["mondayIcon"] = $a9d38aa48a30a78c$export$49ad4fc00eb9dc4e;
module.exports["newrelicIcon"] = $a9d38aa48a30a78c$export$75e811a5a676c5fa;
module.exports["notionIcon"] = $a9d38aa48a30a78c$export$69bc00f5da821a9b;
module.exports["rocketImage"] = $a9d38aa48a30a78c$export$a73eefa8f520e6fc;
module.exports["salesforceIcon"] = $a9d38aa48a30a78c$export$1c1f7c7878a8dd49;
module.exports["scheduleImage"] = $a9d38aa48a30a78c$export$fb1302f32e7ee148;
module.exports["serviceNowIcon"] = $a9d38aa48a30a78c$export$3e8ee1c719d41455;
module.exports["shieldFlameBrand"] = $a9d38aa48a30a78c$export$3513e1b10dfd8814;
module.exports["slackIcon"] = $a9d38aa48a30a78c$export$a7a1183e4d683be7;
module.exports["smartsheetIcon"] = $a9d38aa48a30a78c$export$9879212c14c14243;
module.exports["spinnakerIcon"] = $a9d38aa48a30a78c$export$d682797c8090fb84;
module.exports["workdayIcon"] = $a9d38aa48a30a78c$export$a2c286fab745934a;
module.exports["zendeskIcon"] = $a9d38aa48a30a78c$export$fe6835ee3fb12229;

});

parcelRegister("9Jkbc", function(module, exports) {
module.exports = new URL("adobe-sign-logo.28e1e9ad.svg", import.meta.url).toString();

});

parcelRegister("1s5z9", function(module, exports) {
module.exports = new URL("aha-logo.590960c6.svg", import.meta.url).toString();

});

parcelRegister("54rnf", function(module, exports) {
module.exports = new URL("airtable-logo.f9e1893a.svg", import.meta.url).toString();

});

parcelRegister("1cfs3", function(module, exports) {
module.exports = new URL("asana-logo.e05607f7.svg", import.meta.url).toString();

});

parcelRegister("crIKC", function(module, exports) {
module.exports = new URL("azure-devops-logo.6002895d.svg", import.meta.url).toString();

});

parcelRegister("aiiQ5", function(module, exports) {
module.exports = new URL("box-logo.610ff573.svg", import.meta.url).toString();

});

parcelRegister("7r931", function(module, exports) {
module.exports = new URL("canva-logo.6899f641.svg", import.meta.url).toString();

});

parcelRegister("1CLIe", function(module, exports) {
module.exports = new URL("confluence-dc-default-space-icon.39f0aa7f.svg", import.meta.url).toString();

});

parcelRegister("35tSi", function(module, exports) {
module.exports = new URL("confluence-dc-logo.b10cb38f.svg", import.meta.url).toString();

});

parcelRegister("6F6sw", function(module, exports) {
module.exports = new URL("databricks-logo.96b32447.svg", import.meta.url).toString();

});

parcelRegister("cV21T", function(module, exports) {
module.exports = new URL("datadog-logo.5a89fb9b.svg", import.meta.url).toString();

});

parcelRegister("jzI04", function(module, exports) {
module.exports = new URL("docusign-logo.ea9fc6a9.svg", import.meta.url).toString();

});

parcelRegister("dwAeX", function(module, exports) {
module.exports = new URL("dropbox-logo.600027e1.svg", import.meta.url).toString();

});

parcelRegister("iZFr3", function(module, exports) {
module.exports = new URL("dynatrace-logo.ca47f644.svg", import.meta.url).toString();

});

parcelRegister("4l9jV", function(module, exports) {
module.exports = new URL("github-logo.d4462750.svg", import.meta.url).toString();

});

parcelRegister("ldpBC", function(module, exports) {
module.exports = new URL("gitlab-logo.e0785d21.svg", import.meta.url).toString();

});

parcelRegister("9G8nc", function(module, exports) {
module.exports = new URL("globe-icon.31512b59.svg", import.meta.url).toString();

});

parcelRegister("4Zls6", function(module, exports) {
module.exports = new URL("globe-icon-brand.3f523b02.svg", import.meta.url).toString();

});

parcelRegister("hsQay", function(module, exports) {
module.exports = new URL("gmail-logo.b55db635.svg", import.meta.url).toString();

});

parcelRegister("kwwfI", function(module, exports) {
module.exports = new URL("google-calendar-logo.f69f119d.svg", import.meta.url).toString();

});

parcelRegister("b91Ta", function(module, exports) {
module.exports = new URL("google-drive-logo.2ea63ded.svg", import.meta.url).toString();

});

parcelRegister("i4w5M", function(module, exports) {
module.exports = new URL("hris-logo.4b0ebbaf.svg", import.meta.url).toString();

});

parcelRegister("hbkdt", function(module, exports) {
module.exports = new URL("hubspot-logo.c924ed84.svg", import.meta.url).toString();

});

parcelRegister("9LFSE", function(module, exports) {
module.exports = new URL("jira-dc-logo.4b478844.svg", import.meta.url).toString();

});

parcelRegister("9NjXW", function(module, exports) {
module.exports = new URL("jira-default-project-icon.d116674f.svg", import.meta.url).toString();

});

parcelRegister("4NS8e", function(module, exports) {
module.exports = new URL("lucid-logo.b62e1c3c.svg", import.meta.url).toString();

});

parcelRegister("6ijeX", function(module, exports) {
module.exports = new URL("outlook-calendar-logo.5be856ed.svg", import.meta.url).toString();

});

parcelRegister("2s32V", function(module, exports) {
module.exports = new URL("outlook-mail-logo.5be856ed.svg", import.meta.url).toString();

});

parcelRegister("9RN6T", function(module, exports) {
module.exports = new URL("sharepoint-logo.59c761c5.svg", import.meta.url).toString();

});

parcelRegister("77dr4", function(module, exports) {
module.exports = new URL("microsoft-teams-logo.ff264c80.svg", import.meta.url).toString();

});

parcelRegister("7dyYu", function(module, exports) {
module.exports = new URL("miro-logo.0d92c15d.svg", import.meta.url).toString();

});

parcelRegister("jV4Cu", function(module, exports) {
module.exports = new URL("monday-logo.8980b98e.svg", import.meta.url).toString();

});

parcelRegister("d6Ap9", function(module, exports) {
module.exports = new URL("newrelic-logo.6951f756.svg", import.meta.url).toString();

});

parcelRegister("95zan", function(module, exports) {
module.exports = new URL("notion-logo.e7938963.svg", import.meta.url).toString();

});

parcelRegister("lfEYO", function(module, exports) {
module.exports = new URL("rocket.60e7dc71.svg", import.meta.url).toString();

});

parcelRegister("9zfsd", function(module, exports) {
module.exports = new URL("salesforce-logo.d87d71fd.svg", import.meta.url).toString();

});

parcelRegister("3DNiZ", function(module, exports) {
module.exports = new URL("schedule.16daa73e.svg", import.meta.url).toString();

});

parcelRegister("9QAB5", function(module, exports) {
module.exports = new URL("servicenow-logo.3c7d7694.svg", import.meta.url).toString();

});

parcelRegister("6mvCq", function(module, exports) {
module.exports = new URL("shield-flame-brand.35525706.svg", import.meta.url).toString();

});

parcelRegister("bffTB", function(module, exports) {
module.exports = new URL("slack-logo.7e58056b.svg", import.meta.url).toString();

});

parcelRegister("leVwK", function(module, exports) {
module.exports = new URL("smartsheet-logo.346b41de.svg", import.meta.url).toString();

});

parcelRegister("eAG3X", function(module, exports) {
module.exports = new URL("spinnaker-logo.8c302838.svg", import.meta.url).toString();

});

parcelRegister("9O7Z1", function(module, exports) {
module.exports = new URL("workday-logo.889b1d49.svg", import.meta.url).toString();

});

parcelRegister("33tCi", function(module, exports) {
module.exports = new URL("zendesk-logo.3a4d2b17.svg", import.meta.url).toString();

});

parcelRegister("k2ZWs", function(module, exports) {
/* styles.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable -- disabled during migration, will be re-enabled in a follow-up PR */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $f3db50c26e2042b0$var$ConnectorLogoStyle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { logo: logo, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1q6a3zf": (0, $7sObp.default)(__cmplp.logo, ")", "url(")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1itk1389 _12vemgnk _ouxl16gx _1lrw1f51 _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $f3db50c26e2042b0$export$275b0a61dbfc424a = ({ logo: logo, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f3db50c26e2042b0$var$ConnectorLogoStyle, {
        logo: logo,
        ...props
    });
module.exports["ConnectorLogo"] = $f3db50c26e2042b0$export$275b0a61dbfc424a;

});

parcelRegister("2qVTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ivb8S = parcelRequire("ivb8S");


var $iQzVo = parcelRequire("iQzVo");


var $bQm3c = parcelRequire("bQm3c");


var $7N8s0 = parcelRequire("7N8s0");


var $3rBp8 = parcelRequire("3rBp8");


var $kKl1I = parcelRequire("kKl1I");


var $iA3UT = parcelRequire("iA3UT");


var $f7K4n = parcelRequire("f7K4n");


var $fzrJO = parcelRequire("fzrJO");

/**
 * Computes the next PromoDismissed value when a surface is dismissed.
 * Merges with the existing state so sidebar and banner can be dismissed independently.
 */ function $a557bf5109e4692d$var$getNextPromoDismissed(current, surface) {
    // Not set or current is invalid
    if (!current || ![
        'sidebar',
        'banner'
    ].includes(current)) return surface;
    if (current === surface) return surface;
    return 'both';
}
const $a557bf5109e4692d$var$DISABLED_CONFIG = {
    recommendedConnectors: [],
    spotlightShown: false,
    enrolmentDate: null,
    shouldShowEmptyState: false,
    shouldShowNthPromo: false,
    shouldShowNthPagePromo: false,
    shouldShowPostConnectPromo: false,
    shouldShowPostConnectPagePromo: false,
    shouldShowSidebarItem: false,
    shouldShowSpotlight: false,
    onSetupConnector: ()=>{},
    onDismissPromo: ()=>{},
    onMaybeLater: ()=>{},
    onDismissSpotlight: ()=>{}
};
function $a557bf5109e4692d$export$a3a7ec612e040e85({ hasRecentItems: hasRecentItems = false } = {}) {
    // No experiment check here. Surface components gate rendering via
    // useIsConnectorOnboardingEnabled() before calling this hook.
    const intl = (0, $aXWIB.useIntl)();
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    const debugConnectorKey = environment !== 'PRODUCTION' ? (0, $6mKj3.UNSAFE_expValNoExposure)('twcg-1489-cc-3p-connector-onboarding', 'debugConnectors', '') || undefined : undefined;
    const { teamType: teamType } = (0, $iA3UT.useConnectorOnboardingTeamType)({
        skip: !(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-fg')
    });
    const { connectorStates: connectorStates, connectedCount: connectedCount, loading: connectorStatesLoading, error: connectorStatesError } = (0, $f7K4n.useConnectorStates)({
        skip: !(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-fg')
    });
    // Actions-only subscription: avoids re-rendering surfaces on modal open/close.
    const { openSetupModal: openSetupModal } = (0, $fzrJO.useSetupConnectorActions)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    // Connectors connected during this session. Merged into connectorStates below
    // so a just-connected connector drops out of the recommended list immediately,
    // without waiting for useConnectorStates (admin_getAllDataSources) to refetch.
    const connectedConnectorKeys = (0, $fzrJO.useConnectedConnectorKeys)();
    const effectiveConnectorStates = (0, $42omo.useMemo)(()=>{
        if (connectedConnectorKeys.length === 0) return connectorStates;
        const merged = {
            ...connectorStates
        };
        for (const key of connectedConnectorKeys)merged[key] = {
            ...merged[key],
            hasEnabledDataSource: true
        };
        return merged;
    }, [
        connectorStates,
        connectedConnectorKeys
    ]);
    // Carries the latest promoDismissed value into callbacks without violating rules-of-hooks.
    // Updated on every render after the loading/error early returns.
    const promoDismissedRef = (0, $42omo.useRef)(undefined);
    const { onboardingState: connectorOnboardingState, loading: onboardingStateLoading, error: onboardingStateError, updateOnboardingState: updateOnboardingState } = (0, $kKl1I.useConnectorOnboardingState)({
        skip: !(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-fg')
    });
    // Stable callback refs — must be declared before any early returns to satisfy rules-of-hooks
    const onSetupConnector = (0, $42omo.useCallback)((connectorKey)=>openSetupModal(connectorKey), [
        openSetupModal
    ]);
    const onDismissPromo = (0, $42omo.useCallback)((surface)=>{
        const next = $a557bf5109e4692d$var$getNextPromoDismissed(promoDismissedRef.current, surface);
        if (next === promoDismissedRef.current) return;
        const update = {
            key: (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED,
            value: next
        };
        setOnboardingState(update);
        updateOnboardingState(update);
        promoDismissedRef.current = next;
    }, [
        setOnboardingState,
        updateOnboardingState
    ]);
    const onMaybeLater = (0, $42omo.useCallback)(()=>{}, []);
    const onDismissSpotlight = (0, $42omo.useCallback)(()=>{
        const update = {
            key: (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).SPOTLIGHT_SHOWN,
            value: 'true'
        };
        setOnboardingState(update);
        updateOnboardingState(update);
    }, [
        setOnboardingState,
        updateOnboardingState
    ]);
    if (onboardingStateError) {
        if ((0, $1uFM6.isUnauthorizedError)(onboardingStateError)) (0, $7Sm4c.markErrorAsHandled)(onboardingStateError);
        return $a557bf5109e4692d$var$DISABLED_CONFIG;
    }
    if (connectorStatesError) {
        if ((0, $1uFM6.isUnauthorizedError)(connectorStatesError)) (0, $7Sm4c.markErrorAsHandled)(connectorStatesError);
        return $a557bf5109e4692d$var$DISABLED_CONFIG;
    }
    if (onboardingStateLoading || connectorStatesLoading) return $a557bf5109e4692d$var$DISABLED_CONFIG;
    // If 2+ connectors are already configured org-wide at load, the site is not a
    // good onboarding target; hide the entire experiment. Uses the query's
    // connectedCount (not in-session connections) so connecting a 2nd connector
    // mid-session keeps the surfaces while recommendations remain.
    if (connectedCount >= 2) return $a557bf5109e4692d$var$DISABLED_CONFIG;
    const { recommendedConnectors: recommendedConnectors, connectedAppName: connectedAppName } = (0, $3rBp8.getRecommendedConnectors)(teamType, effectiveConnectorStates, intl, debugConnectorKey);
    const hasConnectedAny = connectedAppName !== undefined;
    const nextRecommendedConnector = recommendedConnectors[recommendedConnectors.length - 1];
    const promoDismissed = connectorOnboardingState?.promoDismissed;
    // Keep the ref in sync so dismiss callbacks always close over the latest value.
    promoDismissedRef.current = promoDismissed;
    const spotlightShown = !!connectorOnboardingState?.spotlightShown;
    const enrolmentDateStr = connectorOnboardingState?.enrolmentDate;
    const enrolmentDate = enrolmentDateStr ? new Date(enrolmentDateStr) : null;
    const daysSinceEnrolment = (0, $7N8s0.getDaysSinceEnrolment)(enrolmentDateStr);
    const sidebarDismissed = promoDismissed === 'sidebar' || promoDismissed === 'both';
    const bannerDismissed = promoDismissed === 'banner' || promoDismissed === 'both';
    return {
        recommendedConnectors: recommendedConnectors,
        connectedAppName: connectedAppName,
        nextRecommendedConnector: nextRecommendedConnector,
        spotlightShown: spotlightShown,
        enrolmentDate: enrolmentDate,
        promoDismissed: promoDismissed,
        shouldShowEmptyState: !hasConnectedAny && !hasRecentItems,
        shouldShowNthPromo: hasRecentItems && !hasConnectedAny && !bannerDismissed,
        shouldShowNthPagePromo: hasRecentItems && !hasConnectedAny && !bannerDismissed,
        shouldShowPostConnectPromo: hasConnectedAny && !bannerDismissed,
        shouldShowPostConnectPagePromo: hasConnectedAny && !bannerDismissed,
        shouldShowSidebarItem: !sidebarDismissed,
        shouldShowSpotlight: !!enrolmentDate && daysSinceEnrolment >= 3 && !spotlightShown,
        onSetupConnector: onSetupConnector,
        onDismissPromo: onDismissPromo,
        onMaybeLater: onMaybeLater,
        onDismissSpotlight: onDismissSpotlight
    };
}
module.exports["useConnectorPromoConfig"] = $a557bf5109e4692d$export$a3a7ec612e040e85;

});

parcelRegister("7N8s0", function(module, exports) {
const $8757e52306056bac$var$MS_PER_DAY = 86400000;
const $8757e52306056bac$export$3ea4f037284b04bc = 30;
function $8757e52306056bac$export$be44dc7b069e47e9(enrolmentDateStr) {
    if (!enrolmentDateStr) return 0;
    return Math.floor((Date.now() - new Date(enrolmentDateStr).getTime()) / $8757e52306056bac$var$MS_PER_DAY);
}
function $8757e52306056bac$export$224893a904971d5d(enrolmentDateStr, windowDays = $8757e52306056bac$export$3ea4f037284b04bc) {
    if (!enrolmentDateStr) return false;
    return $8757e52306056bac$export$be44dc7b069e47e9(enrolmentDateStr) <= windowDays;
}
module.exports["getDaysSinceEnrolment"] = $8757e52306056bac$export$be44dc7b069e47e9;
module.exports["isWithinEnrolmentWindow"] = $8757e52306056bac$export$224893a904971d5d;

});

parcelRegister("3rBp8", function(module, exports) {

var $4m1Oz = parcelRequire("4m1Oz");

const $74d16154f462178f$export$79b5cd6c0e5e498b = {
    'SOFTWARE DEVELOPMENT': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'github-connector'
    ],
    DEFAULT: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    'PROJECT MANAGEMENT': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    OPERATIONS: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'servicenow-connector'
    ],
    'PRODUCT MANAGEMENT': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    DESIGN: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    'IT SUPPORT': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'servicenow-connector'
    ],
    MARKETING: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'hubspot-connector'
    ],
    SALES: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'salesforce-connector'
    ],
    FINANCE: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    'HUMAN RESOURCES': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'workday-v2-connector'
    ],
    LEGAL: [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'slack-connector'
    ],
    'DATA SCIENCE': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'databricks-connector'
    ],
    'CUSTOMER SERVICE': [
        'platform-google-drive-connector',
        'platform-sharepoint-connector',
        'zendesk-connector'
    ]
};
function $74d16154f462178f$export$21ab61aa81d09012(teamType, connectorStates, intl, debugConnectorKey) {
    const connectorKeys = teamType && $74d16154f462178f$export$79b5cd6c0e5e498b[teamType] ? $74d16154f462178f$export$79b5cd6c0e5e498b[teamType] : $74d16154f462178f$export$79b5cd6c0e5e498b.DEFAULT;
    const recommendedConnectors = [];
    let connectedAppName;
    for (const connectorKey of connectorKeys){
        const state = connectorStates[connectorKey];
        const isSetUp = state?.hasEnabledDataSource === true;
        const title = (0, $4m1Oz.getDataSourceTitle)(connectorKey, undefined);
        const displayName = typeof title === 'string' ? title || connectorKey : intl.formatMessage(title);
        if (isSetUp) {
            if (connectedAppName === undefined) connectedAppName = displayName;
        } else recommendedConnectors.push({
            key: connectorKey,
            displayName: displayName
        });
    }
    if (debugConnectorKey) {
        const debugTitle = (0, $4m1Oz.getDataSourceTitle)(debugConnectorKey, undefined);
        const debugDisplayName = typeof debugTitle === 'string' ? debugTitle || debugConnectorKey : intl.formatMessage(debugTitle);
        recommendedConnectors.unshift({
            key: debugConnectorKey,
            displayName: debugDisplayName
        });
    }
    return {
        recommendedConnectors: recommendedConnectors,
        connectedAppName: connectedAppName
    };
}
module.exports["TEAM_CONNECTOR_MAP"] = $74d16154f462178f$export$79b5cd6c0e5e498b;
module.exports["getRecommendedConnectors"] = $74d16154f462178f$export$21ab61aa81d09012;

});

parcelRegister("iA3UT", function(module, exports) {

var $ljH80 = parcelRequire("ljH80");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $3rBp8 = parcelRequire("3rBp8");

const $79de3473932085bf$var$VALID_TEAM_TYPES = Object.keys((0, $3rBp8.TEAM_CONNECTOR_MAP));
const $79de3473932085bf$var$userTeamTypeQuery = (0, $ljH80.default);
const $79de3473932085bf$var$sanitizeTeamType = (teamType)=>{
    if (teamType && $79de3473932085bf$var$VALID_TEAM_TYPES.includes(teamType)) return teamType;
    return undefined;
};
const $79de3473932085bf$export$94dea13b9b35c280 = ({ skip: skip } = {})=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($79de3473932085bf$var$userTeamTypeQuery, {
        variables: {
            userId: userId ?? ''
        },
        skip: skip || !isLicensed || !userId,
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/experiment-twcg-1489-cc-3p-connector-onboarding"
    });
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'useConnectorOnboardingTeamTypeQuery',
                source: 'twcg1489ConnectorOnboarding',
                attributes: {
                    message: error.message
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent
    ]);
    if (loading) return {
        teamType: undefined,
        loading: true
    };
    if (error) return {
        teamType: undefined,
        loading: false,
        error: error
    };
    if (data?.user?.__typename === 'AtlassianAccountUser') return {
        teamType: $79de3473932085bf$var$sanitizeTeamType(data.user.extendedProfile?.teamType?.toUpperCase()),
        loading: false
    };
    return {
        teamType: undefined,
        loading: false
    };
};
module.exports["useConnectorOnboardingTeamType"] = $79de3473932085bf$export$94dea13b9b35c280;

});

parcelRegister("ljH80", function(module, exports) {
/**
 * @generated SignedSource<<def63672abb49c009b08c3310289a240>>
 * @relayHash 3645f14258aaf6df779f3874a7b10083
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 794380e9c61483adc5407aecc7ee4f9434dbddfd1b24827095cb41bca86c6bd6
const $761d928d522d0b4f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "userId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "teamType"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConnectorOnboardingTeamTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConnectorOnboardingTeamTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3645f14258aaf6df779f3874a7b10083",
            "id": "794380e9c61483adc5407aecc7ee4f9434dbddfd1b24827095cb41bca86c6bd6",
            "metadata": {},
            "name": "useConnectorOnboardingTeamTypeQuery",
            "operationKind": "query",
            "text": "query useConnectorOnboardingTeamTypeQuery($userId:ID!){user(accountId:$userId){__typename,...on AtlassianAccountUser{extendedProfile{teamType}},id}}"
        }
    };
}();
$761d928d522d0b4f$var$node.hash = "a2ab021a37664174ea5177e550544833";
var $761d928d522d0b4f$export$2e2bcd8739ae039 = $761d928d522d0b4f$var$node;
module.exports["default"] = $761d928d522d0b4f$export$2e2bcd8739ae039;

});

parcelRegister("f7K4n", function(module, exports) {

var $iGpO4 = parcelRequire("iGpO4");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");

const $aad293923f85f3d0$var$connectorStatesQuery = (0, $iGpO4.default);
function $aad293923f85f3d0$export$6b0d2f38f604a837({ skip: skip } = {}) {
    const { orgId: orgId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = Boolean(skip || !orgId || !cloudId);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($aad293923f85f3d0$var$connectorStatesQuery, {
        variables: {
            orgId: orgId ?? '',
            resourceId: cloudId ?? '',
            first: 75
        },
        skip: shouldSkip,
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/experiment-twcg-1489-cc-3p-connector-onboarding"
    });
    const { connectorStates: connectorStates, connectedCount: connectedCount } = (0, $42omo.useMemo)(()=>{
        const edges = data?.admin_getAllDataSources?.edges;
        if (!edges) return {
            connectorStates: {},
            connectedCount: 0
        };
        const result = {};
        let count = 0;
        for (const edge of edges){
            const node = edge?.node;
            if (!node?.type) continue;
            // .find() is used instead of .some() because the perf-linting/no-quadratic-complexity
            // rule tracks 'some' as a nested iterator and fires when called inside an outer
            // for-of loop; 'find' is not in its ITERATOR_METHODS set.
            const hasEnabledDataSource = Boolean(node.datasources?.find((ds)=>ds.enabled));
            result[node.type] = {
                hasEnabledDataSource: hasEnabledDataSource
            };
            if (hasEnabledDataSource) count += 1;
        }
        return {
            connectorStates: result,
            connectedCount: count
        };
    }, [
        data
    ]);
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            connectorStates: {},
            connectedCount: 0,
            loading: false,
            error: error
        };
    }
    if (loading) return {
        connectorStates: {},
        connectedCount: 0,
        loading: true
    };
    return {
        connectorStates: connectorStates,
        connectedCount: connectedCount,
        loading: false
    };
}
module.exports["useConnectorStates"] = $aad293923f85f3d0$export$6b0d2f38f604a837;

});

parcelRegister("iGpO4", function(module, exports) {
/**
 * @generated SignedSource<<583af0bf5d1397e9bb81877c0829a09c>>
 * @relayHash ed1c7ead1865251e45173593feb0b728
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b96b68ccc999039ea351e31941246e5bb0c0400a30e73f61b5c8a6ce57245ae1
const $dba60705293b2bec$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceId"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orgId",
                    "variableName": "orgId"
                },
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "concreteType": "AdminConnectorConnection",
            "kind": "LinkedField",
            "name": "admin_getAllDataSources",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AdminConnectorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "AdminConnector",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "concreteType": "AdminDataSource",
                                    "kind": "LinkedField",
                                    "name": "datasources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useConnectorStatesQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useConnectorStatesQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ed1c7ead1865251e45173593feb0b728",
            "id": "b96b68ccc999039ea351e31941246e5bb0c0400a30e73f61b5c8a6ce57245ae1",
            "metadata": {},
            "name": "useConnectorStatesQuery",
            "operationKind": "query",
            "text": "query useConnectorStatesQuery($orgId:ID!,$resourceId:ID!,$first:Int){admin_getAllDataSources(orgId:$orgId,resourceId:$resourceId,first:$first){edges{node{type,datasources{enabled}}}}}"
        }
    };
}();
$dba60705293b2bec$var$node.hash = "c1e906a9d592c8090d7d5864937f0dbe";
var $dba60705293b2bec$export$2e2bcd8739ae039 = $dba60705293b2bec$var$node;
module.exports["default"] = $dba60705293b2bec$export$2e2bcd8739ae039;

});

parcelRegister("fzrJO", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9639879ef0d0f478$var$initialState = {
    activeConnectorKey: null,
    connectedConnectorKeys: []
};
const $9639879ef0d0f478$var$actions = {
    openSetupModal: (connectorKey)=>({ setState: setState })=>{
            setState({
                activeConnectorKey: connectorKey
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                activeConnectorKey: null
            });
        },
    markConnectorConnected: (connectorKey)=>({ getState: getState, setState: setState })=>{
            const { connectedConnectorKeys: connectedConnectorKeys } = getState();
            if (connectedConnectorKeys.includes(connectorKey)) return;
            setState({
                connectedConnectorKeys: [
                    ...connectedConnectorKeys,
                    connectorKey
                ]
            });
        }
};
const $9639879ef0d0f478$var$SetupConnectorStore = (0, $1P1Tu.createStore)({
    initialState: $9639879ef0d0f478$var$initialState,
    actions: $9639879ef0d0f478$var$actions,
    name: 'Twcg1489SetupConnectorStore'
});
const $9639879ef0d0f478$export$86bfee7a4a335f62 = (0, $9zUhf.createActionsHook)($9639879ef0d0f478$var$SetupConnectorStore);
const $9639879ef0d0f478$var$useActiveConnectorKey = (0, $9zUhf.createStateHook)($9639879ef0d0f478$var$SetupConnectorStore, {
    selector: (state)=>state.activeConnectorKey
});
const $9639879ef0d0f478$export$c3af49e60e4baf22 = (0, $9zUhf.createStateHook)($9639879ef0d0f478$var$SetupConnectorStore, {
    selector: (state)=>state.connectedConnectorKeys
});
function $9639879ef0d0f478$export$3ccb24b32789bc60() {
    const activeConnectorKey = $9639879ef0d0f478$var$useActiveConnectorKey();
    const { openSetupModal: openSetupModal, closeModal: closeModal } = $9639879ef0d0f478$export$86bfee7a4a335f62();
    return {
        openSetupModal: openSetupModal,
        activeConnectorKey: activeConnectorKey,
        closeModal: closeModal
    };
}
module.exports["useSetupConnectorActions"] = $9639879ef0d0f478$export$86bfee7a4a335f62;
module.exports["useConnectedConnectorKeys"] = $9639879ef0d0f478$export$c3af49e60e4baf22;
module.exports["useSetupConnector"] = $9639879ef0d0f478$export$3ccb24b32789bc60;

});

parcelRegister("gHaxX", function(module, exports) {

var $973aB = parcelRequire("973aB");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/user/manifest.ts
var $c278d7dccfa97a86$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $973aB.IdentityUserAriResourceOwner),
    resourceType: (0, $973aB.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $c278d7dccfa97a86$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3NXcb.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $c278d7dccfa97a86$export$1e9d09c2be53e55e;

});

parcelRegister("973aB", function(module, exports) {
// src/identity/user/types.ts
var $6a2739fa6e7a2528$export$b4c14c54282a779d = "identity", $6a2739fa6e7a2528$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $6a2739fa6e7a2528$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $6a2739fa6e7a2528$export$e9b50e20f4fbfb71;

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("4ayWZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0eaf91608b1fc1f9ea14632557d8241d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30933503c57ef329$var$_react = $30933503c57ef329$var$_interopRequireDefault((parcelRequire("42omo")));

var $30933503c57ef329$var$_baseNew = $30933503c57ef329$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $30933503c57ef329$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30933503c57ef329$var$DashboardIcon = (props)=>/*#__PURE__*/ $30933503c57ef329$var$_react.default.createElement($30933503c57ef329$var$_baseNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$30933503c57ef329$var$DashboardIcon.displayName = 'DashboardIcon';
var $30933503c57ef329$var$_default = module.exports.default = $30933503c57ef329$var$DashboardIcon;

});

parcelRegister("7642E", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $XOZYy = parcelRequire("XOZYy");


const $52ac3a8ba658d4f5$var$_inlined0 = (()=>{
    const module1 = {
        exports: {}
    };
    const exports = module1.exports;
    (function() {
        /**
 * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
 *
 * This provides a lightweight replacement for the legacy Icon component that
 * was removed in DSP-24550. Instead of wrapping the glyph in a span with
 * complex styling, it simply renders the glyph component directly, passing
 * through relevant props.
 *
 * This is NOT a public API — it exists solely to unblock the removal of
 * deprecated icon APIs from @atlaskit/icon.
 */ const React = (parcelRequire("42omo"));
        function Icon(props) {
            const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor, testId: testId, label: label } = props;
            if (Glyph) return React.createElement(Glyph, {
                role: label ? 'img' : 'presentation',
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                fill: primaryColor || 'currentColor'
            });
            if (dangerouslySetGlyph) return React.createElement('span', {
                dangerouslySetInnerHTML: {
                    __html: dangerouslySetGlyph
                },
                role: label ? 'img' : undefined,
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                style: {
                    display: 'inline-block',
                    lineHeight: 1,
                    color: primaryColor || 'currentColor'
                }
            });
            return null;
        }
        Icon.displayName = 'Icon';
        module1.exports = Icon;
    })();
    return module1.exports;
})();
module.exports = Object.assign({}, $XOZYy, {
    default: $52ac3a8ba658d4f5$var$_inlined0
});
if ($XOZYy.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("kXb3C", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

/**
 * __Object base__
 *
 * An object represents an Atlassian-specific content type.
 *
 */ const $5412502140f64e3a$var$ObjectBase = (0, $4pOgL.isReactCompilerActivePlatform)() ? function ObjectBase(t0) {
    const $ = (0, $frIzR.c)(6);
    const { label: t1, size: t2, testId: testId, color: color, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const t3 = size === "medium" ? "medium" : "small";
    let t4;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== t3 || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            size: t3,
            color: color,
            testId: testId
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = t3;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function ObjectBase({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
};
var $5412502140f64e3a$export$2e2bcd8739ae039 = $5412502140f64e3a$var$ObjectBase;
module.exports["default"] = $5412502140f64e3a$export$2e2bcd8739ae039;

});

parcelRegister("66dpz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

const $893c7e3925139b9a$var$PageLiveDocObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $893c7e3925139b9a$export$2e2bcd8739ae039 = $893c7e3925139b9a$var$PageLiveDocObject;
module.exports["default"] = $893c7e3925139b9a$export$2e2bcd8739ae039;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("7gpC4", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");


var $9wgn8 = parcelRequire("9wgn8");


var $cVrnQ = parcelRequire("cVrnQ");


var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $frIzR.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $42omo.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $gMc0m.default)([
            $1f9fb6b4b3bc4020$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ $42omo.createElement("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ $42omo.createElement((0, $6MlG5.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ $42omo.createElement((0, $cVrnQ.default), null, label, isRequired && /*#__PURE__*/ $42omo.createElement((0, $hcDON.default), null));
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ $42omo.createElement((0, $9wgn8.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss
        }, t16, t17, t18);
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ $42omo.createElement("input" // It is necessary only for Safari. It allows to render focus styles.
    , {
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        className: (0, $gMc0m.default)([
            $1f9fb6b4b3bc4020$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ $42omo.createElement((0, $6MlG5.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $42omo.createElement((0, $cVrnQ.default), null, label, isRequired && /*#__PURE__*/ $42omo.createElement((0, $hcDON.default), null)));
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = t0;
    let t1;
    if ($[0] !== isChecked || $[1] !== isIndeterminate) {
        t1 = $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked);
        $[0] = isChecked;
        $[1] = isIndeterminate;
        $[2] = t1;
    } else t1 = $[2];
    const icon = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $42omo.createElement("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            className: (0, $gMc0m.default)([
                $71feb0a29953fded$var$svgStyles.rect
            ])
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== icon) {
        t4 = /*#__PURE__*/ $42omo.createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            role: "presentation",
            className: t2
        }, /*#__PURE__*/ $42omo.createElement("g", {
            fillRule: "evenodd"
        }, t3, icon));
        $[5] = icon;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $42omo.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $42omo.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $42omo.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.rect
        ])
    }), icon));
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null;
const $edf27753e59bf881$var$Label = (0, $4pOgL.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $frIzR.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_zulp1nu5 _yv0ey09t";
    const t2 = (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz";
    const t3 = isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2";
    const t4 = isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ $42omo.createElement("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id
        }, children);
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ $42omo.createElement("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
};
var $edf27753e59bf881$export$2e2bcd8739ae039 = $edf27753e59bf881$var$Label;
module.exports["default"] = $edf27753e59bf881$export$2e2bcd8739ae039;

});

parcelRegister("cVrnQ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
const $f0c2060f65a94bd0$var$LabelText = (0, $4pOgL.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $42omo.createElement("span", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
};
var $f0c2060f65a94bd0$export$2e2bcd8739ae039 = $f0c2060f65a94bd0$var$LabelText;
module.exports["default"] = $f0c2060f65a94bd0$export$2e2bcd8739ae039;

});

parcelRegister("hcDON", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
const $a14852587cdb2524$var$RequiredIndicator = (0, $4pOgL.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $42omo.createElement("span", {
            "aria-hidden": true,
            className: (0, $gMc0m.default)([
                "_syaz1tmw _bozgv77o"
            ])
        }, "*");
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ $42omo.createElement("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
};
var $a14852587cdb2524$export$2e2bcd8739ae039 = $a14852587cdb2524$var$RequiredIndicator;
module.exports["default"] = $a14852587cdb2524$export$2e2bcd8739ae039;

});

parcelRegister("6mn0G", function(module, exports) {
function $ef5055edddfff711$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $ef5055edddfff711$export$e88cb5bfb57ce9c4;

});

parcelRegister("kiOFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kSC7A = parcelRequire("kSC7A");


var $f8S0G = parcelRequire("f8S0G");


var $hBNGD = parcelRequire("hBNGD");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $bZKB2 = parcelRequire("bZKB2");


var $6fCTI = parcelRequire("6fCTI");

const $78f887db99bd3113$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH = '/gateway/api/v2/accessible-products';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/v2/accessible-products';
const $78f887db99bd3113$var$defaultProducts = [
    (0, $kSC7A.AvailableSitesProductType).WHITEBOARD,
    (0, $kSC7A.AvailableSitesProductType).BEACON,
    (0, $kSC7A.AvailableSitesProductType).COMPASS,
    (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
    (0, $kSC7A.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $kSC7A.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $kSC7A.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $kSC7A.AvailableSitesProductType).MERCURY,
    (0, $kSC7A.AvailableSitesProductType).OPSGENIE,
    (0, $kSC7A.AvailableSitesProductType).STATUS_PAGE,
    (0, $kSC7A.AvailableSitesProductType).ATLAS,
    (0, $kSC7A.AvailableSitesProductType).LOOM
];
const $78f887db99bd3113$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    // TODO As part of NAVX-5287 (FG cleanup) remove the map and go back to `data: sites`
                    // As isVertigo be removed in same PR it doesn't matter if data will be back again.
                    data: (0, $dh538.fg)('platform_lp_kill_isvertigo_and_vortexmode') ? sites.map((site)=>({
                            ...site,
                            isVertigo: undefined
                        })) : sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $f8S0G.default)('operational.getAvailableSitesResolve.failed', (0, $6fCTI.getOperationFailedAttributes)(err))).fire((0, $hBNGD.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $78f887db99bd3113$export$bd4055e8b60f8535 = (data)=>{
    const sites = [];
    data.products.forEach((product)=>{
        product.workspaces.forEach((workspace)=>{
            const currentSite = sites.find((site)=>site.cloudId === workspace.cloudId);
            if (currentSite) {
                currentSite.products.push(product.productId);
                return currentSite;
            }
            sites.push({
                avatarUrl: workspace.workspaceAvatarUrl,
                cloudId: workspace.cloudId,
                displayName: workspace.workspaceDisplayName,
                isVertigo: (0, $dh538.fg)('platform_lp_kill_isvertigo_and_vortexmode') ? undefined : workspace.vortexMode === 'ENABLED',
                products: [
                    product.productId
                ],
                url: workspace.cloudUrl
            });
        });
    });
    return sites;
};
const $78f887db99bd3113$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isMounted = (0, $bZKB2.useIsMounted)();
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const response = await $78f887db99bd3113$var$getAccessibleProducts({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: $78f887db99bd3113$export$bd4055e8b60f8535(response.data),
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $78f887db99bd3113$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const availableSitesPath = (0, $dh538.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$AVAILABLE_SITES_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${availableSitesPath}` : availableSitesPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
async function $78f887db99bd3113$var$getAccessibleProducts({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const accessibleProductsPath = (0, $dh538.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            productIds: products,
            permissionIds: []
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${accessibleProductsPath}` : accessibleProductsPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
module.exports["useAvailableSites"] = $78f887db99bd3113$export$3738ff0cbe469211;
module.exports["mapAccessibleProductsToAvailableSites"] = $78f887db99bd3113$export$bd4055e8b60f8535;
module.exports["useAvailableSitesV2"] = $78f887db99bd3113$export$3f59b707a86875c4;

});

parcelRegister("kSC7A", function(module, exports) {
var $2f440bf1e6112d68$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $2f440bf1e6112d68$export$16bdf84263b17cf0;

});

parcelRegister("f8S0G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::bf8c5828b0e062cbddf6092143efece2>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $4a22b51dcbeecd57$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $4a22b51dcbeecd57$export$2e2bcd8739ae039 = $4a22b51dcbeecd57$var$createEventPayload;
module.exports["default"] = $4a22b51dcbeecd57$export$2e2bcd8739ae039;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("bZKB2", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d79b64f48ff0234f$export$80c2a3957bcb42ea() {
    const isMounted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $42omo.useCallback)(()=>isMounted.current, []);
}
module.exports["useIsMounted"] = $d79b64f48ff0234f$export$80c2a3957bcb42ea;

});

parcelRegister("6fCTI", function(module, exports) {

var $6mn0G = parcelRequire("6mn0G");

const $9cbe6bde573cd7a4$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $9cbe6bde573cd7a4$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $6mn0G.getTraceId)(error),
        status: error.status,
        path: $9cbe6bde573cd7a4$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $9cbe6bde573cd7a4$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9cbe6bde573cd7a4$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$9cbe6bde573cd7a4$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $9cbe6bde573cd7a4$export$b2d107ab31565d0b;

});

parcelRegister("5TGLQ", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $aw01o = parcelRequire("aw01o");


var $a6FC8 = parcelRequire("a6FC8");

const $0aa0cd7558ee373c$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $aw01o.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $0aa0cd7558ee373c$export$ea56ca58f08ffa52;

});

parcelRegister("gL6du", function(module, exports) {
const $21e9301be8cff986$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $21e9301be8cff986$export$dca0327c9b9c6498;

});

parcelRegister("aw01o", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $3nGJd = parcelRequire("3nGJd");


var $4eigd = parcelRequire("4eigd");


var $2iEso = parcelRequire("2iEso");

const $734802129a3b7f4d$var$INVALID_DATE = new Date(NaN);
const $734802129a3b7f4d$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $734802129a3b7f4d$var$INVARIANT_DATE = (0, $2iEso.toDate)($734802129a3b7f4d$var$INVARIANT);
const $734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $734802129a3b7f4d$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $734802129a3b7f4d$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $734802129a3b7f4d$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $734802129a3b7f4d$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($734802129a3b7f4d$var$INVARIANT_DATE);
    const shortDate = $734802129a3b7f4d$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $734802129a3b7f4d$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $734802129a3b7f4d$var$stripExtras(date).match($734802129a3b7f4d$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $734802129a3b7f4d$var$INVALID_DATE;
        const dateParts = $734802129a3b7f4d$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $4eigd.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3nGJd.isValid)(normalizedDate)) return $734802129a3b7f4d$var$INVALID_DATE;
        return (0, $2iEso.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $734802129a3b7f4d$export$cfa2ef2687faeda2;

});

parcelRegister("3nGJd", function(module, exports) {

var $7sNuF = parcelRequire("7sNuF");

const $7f0fa5875d6e9a42$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $7sNuF.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $7f0fa5875d6e9a42$export$1ea939691cdc45b8;

});

parcelRegister("7sNuF", function(module, exports) {

var $1RvqY = parcelRequire("1RvqY");

const $320ec45740b0ee24$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $1RvqY.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $320ec45740b0ee24$export$f645ddd439eb259d;

});

parcelRegister("1RvqY", function(module, exports) {
const $323f2e4da88832b7$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $323f2e4da88832b7$export$553d7fa8e3805fc0;

});

parcelRegister("4eigd", function(module, exports) {

var $aKKC5 = parcelRequire("aKKC5");

const $927e6bf7203913f7$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $aKKC5.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $927e6bf7203913f7$export$fcc71269590ba0a8;

});

parcelRegister("aKKC5", function(module, exports) {
const $00e4455f9b4cd7ae$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $00e4455f9b4cd7ae$export$abe96da78d4f59dd;

});

parcelRegister("2iEso", function(module, exports) {
const $f36e5bfee980e3d5$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $f36e5bfee980e3d5$export$e67a095c620b86fe;

});

parcelRegister("a6FC8", function(module, exports) {
const $5e4f9944cbc7c90e$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $5e4f9944cbc7c90e$export$9b7ca29af37c192;

});

parcelRegister("l8mxb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57e36493b019d12297a87aa4bfc67ec1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f62bd32daa0e4ca4$var$_react = $f62bd32daa0e4ca4$var$_interopRequireDefault((parcelRequire("42omo")));

var $f62bd32daa0e4ca4$var$_baseNew = $f62bd32daa0e4ca4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f62bd32daa0e4ca4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f62bd32daa0e4ca4$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $f62bd32daa0e4ca4$var$_react.default.createElement($f62bd32daa0e4ca4$var$_baseNew.default, Object.assign({
        name: "PersonAddedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 12.75A3.75 3.75 0 0 1 4.75 9H9v1.5H4.75a2.25 2.25 0 0 0-2.25 2.25V15H1zM9.5 4a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M11 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m4.95 6.99-3.83 4.5a.75.75 0 0 1-1.14 0l-1.92-2.25 1.14-.97 1.35 1.58 3.26-3.83z"/>`
    }, props));
$f62bd32daa0e4ca4$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $f62bd32daa0e4ca4$var$_default = module.exports.default = $f62bd32daa0e4ca4$var$PersonAddedIcon;

});

parcelRegister("7dyLS", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $lEY55 = parcelRequire("lEY55");


var $iUYhn = parcelRequire("iUYhn");


var $eFiFf = parcelRequire("eFiFf");


var $3YFt4 = parcelRequire("3YFt4");

var $ff4c1fab1412a389$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $ff4c1fab1412a389$export$775b6bb06e53a214 = {
    ...(0, $lEY55.Scope),
    ...(0, $iUYhn.Scope),
    ...(0, $3YFt4.TownsquareScope),
    ...(0, $eFiFf.Scope)
};
module.exports["Scope"] = $ff4c1fab1412a389$export$775b6bb06e53a214;

});

parcelRegister("lEY55", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $31e4730094d25be0$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $31e4730094d25be0$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $31e4730094d25be0$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $31e4730094d25be0$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $31e4730094d25be0$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $31e4730094d25be0$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $31e4730094d25be0$export$80a5be864676016b = 'confluence.space';
const $31e4730094d25be0$export$70542451ad6057d2 = 'urs.user-confluence';
const $31e4730094d25be0$export$6ec00f56b27cdc1d = 'generic-container-result';
const $31e4730094d25be0$export$ca1a50bc869949e = 'person-result';
const $31e4730094d25be0$export$a99961038e9d5471 = 'confluence-object-result';
const $31e4730094d25be0$export$18c69de2b4aa679c = 'recent-confluence';
const $31e4730094d25be0$export$dc31f0db54ab1a30 = 'result-confluence';
const $31e4730094d25be0$export$cb8b6c470492bee8 = 'recent-person';
const $31e4730094d25be0$export$ebb42dafe7a39a20 = 'result-person';
const $31e4730094d25be0$export$602b44a55c824e30 = 'advanced-search-confluence';
const $31e4730094d25be0$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $31e4730094d25be0$export$bbd1709e62826142 = 'confluence-page';
const $31e4730094d25be0$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $31e4730094d25be0$export$b441f0c13fd510b9 = 'confluence-attachment';
const $31e4730094d25be0$export$8ee8726ca4e2f8bd = 'confluence-space';
const $31e4730094d25be0$export$d0e824889e01c751 = 'person';
const $31e4730094d25be0$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $31e4730094d25be0$export$775b6bb06e53a214;

});

parcelRegister("eFiFf", function(module, exports) {
var $e9e0239fba21ef53$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $e9e0239fba21ef53$export$775b6bb06e53a214;

});

parcelRegister("3YFt4", function(module, exports) {
var $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa;

});

parcelRegister("57Wda", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6B0jU = parcelRequire("6B0jU");


var $kXb3C = parcelRequire("kXb3C");

const $0a57bdd6dcbbb0a3$var$DatabaseObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function DatabaseObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Database" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function DatabaseObject({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039 = $0a57bdd6dcbbb0a3$var$DatabaseObject;
module.exports["default"] = $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039;

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

const $02745cd2b6b0665c$var$PageObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $02745cd2b6b0665c$export$2e2bcd8739ae039 = $02745cd2b6b0665c$var$PageObject;
module.exports["default"] = $02745cd2b6b0665c$export$2e2bcd8739ae039;

});

parcelRegister("eQfRp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ZDq1z = parcelRequire("ZDq1z");


var $kXb3C = parcelRequire("kXb3C");

const $26650821103220c8$var$WhiteboardObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function WhiteboardObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Whiteboard" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
            color: "var(--ds-icon-accent-teal, #2898BD)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WhiteboardObject({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
};
var $26650821103220c8$export$2e2bcd8739ae039 = $26650821103220c8$var$WhiteboardObject;
module.exports["default"] = $26650821103220c8$export$2e2bcd8739ae039;

});

parcelRegister("kQuIn", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $f2d4a2cb14cdae7d$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $f2d4a2cb14cdae7d$export$a3d7cddace4fe237;

});

parcelRegister("3vavW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $buthI = parcelRequire("buthI");


var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $e2bfY = parcelRequire("e2bfY");


var $fs7kD = parcelRequire("fs7kD");

const $04f1fb3a0c53a5f1$export$fbd198cf40195606 = {
    displayName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $fs7kD.messages)['atlassian-web-crawler']),
    id: 'atlassian-web-crawler',
    resourceType: (0, $78z3f.ProductResourceTypes3P).AtlassianWebCrawler,
    icon: (0, $fj6km.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), 'Atlassian Web Crawler'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $e2bfY.WebDomainSearchResultIcon), 'Atlassian Web Crawler', 'large'),
    integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    isEnabled: ()=>true,
    fanOutConnectorSources: true,
    displayWorkspaceNameAsProductName: true,
    getFiltersForSelectedDatasources: (datasource, existingFilters)=>({
            ...existingFilters,
            additionalTexts: [
                ...existingFilters?.additionalTexts || [],
                ...datasource?.workspaceUrl ? [
                    datasource.workspaceUrl
                ] : []
            ]
        })
};
module.exports["atlassianWebCrawlerConfig"] = $04f1fb3a0c53a5f1$export$fbd198cf40195606;

});

parcelRegister("cJRFO", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $dd0d86a6eef7eeb2$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $dd0d86a6eef7eeb2$export$d520529b4595d46c;

});

parcelRegister("dz5JF", function(module, exports) {
const $6067fc387d431c0b$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article'
};
const $6067fc387d431c0b$export$e01073b80ff953d5 = Object.values($6067fc387d431c0b$export$49f6cbb853d30562);
const $6067fc387d431c0b$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $6067fc387d431c0b$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': $6067fc387d431c0b$export$49f6cbb853d30562.Document,
    'ati:cloud:graph:message': $6067fc387d431c0b$export$49f6cbb853d30562.Message,
    'ati:cloud:graph:conversation': $6067fc387d431c0b$export$49f6cbb853d30562.Conversation,
    'ati:cloud:graph:design': $6067fc387d431c0b$export$49f6cbb853d30562.Design,
    'ati:cloud:graph:video': $6067fc387d431c0b$export$49f6cbb853d30562.Video,
    'ati:cloud:graph:space': $6067fc387d431c0b$export$49f6cbb853d30562.Space,
    'ati:cloud:graph:comment': $6067fc387d431c0b$export$49f6cbb853d30562.Comment,
    'ati:cloud:graph:repository': $6067fc387d431c0b$export$49f6cbb853d30562.Repository,
    'ati:cloud:graph:pull-request': $6067fc387d431c0b$export$49f6cbb853d30562.PullRequest,
    'ati:cloud:graph:commit': $6067fc387d431c0b$export$49f6cbb853d30562.Commit,
    'ati:cloud:graph:branch': $6067fc387d431c0b$export$49f6cbb853d30562.Branch,
    'ati:cloud:graph:calendar-event': $6067fc387d431c0b$export$49f6cbb853d30562.Calendar,
    'ati:cloud:graph:work-item': $6067fc387d431c0b$export$49f6cbb853d30562.WorkItem,
    'ati:cloud:graph:project': $6067fc387d431c0b$export$49f6cbb853d30562.Project,
    'ati:cloud:graph:deal': $6067fc387d431c0b$export$49f6cbb853d30562.Deal,
    'ati:cloud:graph:customer-org': $6067fc387d431c0b$export$49f6cbb853d30562.CustomerOrg,
    'ati:cloud:graph:customer-contact': $6067fc387d431c0b$export$49f6cbb853d30562.CustomerContact,
    'ati:cloud:graph:dashboard': $6067fc387d431c0b$export$49f6cbb853d30562.Dashboard,
    'ati:cloud:graph:data-table': $6067fc387d431c0b$export$49f6cbb853d30562.DataTable,
    'ati:cloud:graph:campaign': $6067fc387d431c0b$export$49f6cbb853d30562.Campaign,
    'ati:cloud:graph:case': $6067fc387d431c0b$export$49f6cbb853d30562.Case
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $6067fc387d431c0b$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $6067fc387d431c0b$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($6067fc387d431c0b$var$isCloudGraphAti(ati)) {
        const typeKey = $6067fc387d431c0b$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: [] // Most configs use empty subTypes3P, can be extended if needed
    });
    return typeFilterConfig;
}
module.exports["TypeFilterValueKey"] = $6067fc387d431c0b$export$49f6cbb853d30562;
module.exports["NounSubtypeKey"] = $6067fc387d431c0b$export$1f2db89e0caa00c9;
module.exports["mapAtisToTypeFilterConfig"] = $6067fc387d431c0b$export$770175465f396551;

});

parcelRegister("fj6km", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");




var $1Teld = parcelRequire("1Teld");


var $9AqRO = parcelRequire("9AqRO");


var $6Fa33 = parcelRequire("6Fa33");


var $6RZzG = parcelRequire("6RZzG");




var $ce4Ui = parcelRequire("ce4Ui");

const $6784eda2893491f1$var$svgIconContainerStyles = {
    small: "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o",
    medium: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
    large: "_1bsbzwfg _4t3izwfg _1e0c1txw _4cvr1h6o _1bah1h6o",
    xlarge: "_1bsbzwfg _4t3izwfg _1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $6784eda2893491f1$var$SVGIcon = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { glyph: SVG, label: label, size: size } = t0;
    const t1 = $6784eda2893491f1$var$svgIconContainerStyles[size];
    const t2 = label || undefined;
    const t3 = label ? "img" : "presentation";
    let t4;
    if ($[0] !== SVG) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SVG, null);
        $[0] = SVG;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t1,
            "aria-label": t2,
            role: t3
        }, t4);
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ glyph: SVG, label: label, size: size })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6784eda2893491f1$var$svgIconContainerStyles[size],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SVG, null));
};
const $6784eda2893491f1$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $6784eda2893491f1$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $6784eda2893491f1$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $6784eda2893491f1$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const mappedSize = size && $6784eda2893491f1$var$isCorrectableRovoSize(size) ? $6784eda2893491f1$var$correctedSize[size] : defaultSize;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $gMc0m.default)([
                $6784eda2893491f1$var$sizeStyles[mappedSize]
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $6784eda2893491f1$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6784eda2893491f1$var$SVGIcon, {
            label: label,
            glyph: glyph,
            size: size && $6784eda2893491f1$var$isCorrectableRovoSize(size) ? $6784eda2893491f1$var$correctedSize[size] : 'medium'
        });
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $6784eda2893491f1$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand",
            shouldUseNewLogoDesign: true
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $6784eda2893491f1$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            ...props,
            shouldUseNewLogoDesign: true
        });
}
function $6784eda2893491f1$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $6784eda2893491f1$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $6784eda2893491f1$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $6784eda2893491f1$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _5ral1f51"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $6784eda2893491f1$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $6784eda2893491f1$export$dae027fade2c6d1d($6784eda2893491f1$export$f9f7178f66750cba(iconUrl), iconLabel, size);
} // Jira-specific icons
module.exports["RovoLogoFromGlyph"] = $6784eda2893491f1$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $6784eda2893491f1$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $6784eda2893491f1$export$32db889b380fa03c;
module.exports["get3PLogo"] = $6784eda2893491f1$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $6784eda2893491f1$export$97ac28be52c9e29f;

});

parcelRegister("1Teld", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $6a4b6e784c7cb89d$var$LazyGithubIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("13zfh")).then((m)=>m.GithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/icon'
});

const $6a4b6e784c7cb89d$var$LazyGithubSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("13zfh")).then((m)=>m.GithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon'
});
const $6a4b6e784c7cb89d$export$e8e65f186ccd8749 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a4b6e784c7cb89d$var$LazyGithubIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a4b6e784c7cb89d$var$LazyGithubIconComponent, null));
const $6a4b6e784c7cb89d$export$fa0f141eb732d2d7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a4b6e784c7cb89d$var$LazyGithubSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a4b6e784c7cb89d$var$LazyGithubSearchResultIconComponent, null));
module.exports["GithubIcon"] = $6a4b6e784c7cb89d$export$e8e65f186ccd8749;
module.exports["GithubSearchResultIcon"] = $6a4b6e784c7cb89d$export$fa0f141eb732d2d7;

});

parcelRegister("dQYck", function(module, exports) {

var $apCPx = parcelRequire("apCPx");


var $56LFI = parcelRequire("56LFI");


var $kLgjN = parcelRequire("kLgjN");


var $9Fc44 = parcelRequire("9Fc44");


var $f8v34 = parcelRequire("f8v34");

var $ewDOk = parcelRequire("ewDOk");


var $4yMFN = parcelRequire("4yMFN");


var $dXi4e = parcelRequire("dXi4e");


var $1QGnA = parcelRequire("1QGnA");


var $1yW1K = parcelRequire("1yW1K");


var $lx2SU = parcelRequire("lx2SU");


var $j4Chq = parcelRequire("j4Chq");


function $39c63c9384b99784$var$noop() {}
function $39c63c9384b99784$var$deferToPhase(phase) {
    switch(phase){
        case (0, $9Fc44.PHASE).PAINT:
            return (0, $56LFI.postTask)($39c63c9384b99784$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $9Fc44.PHASE).AFTER_PAINT:
            return (0, $56LFI.postTask)($39c63c9384b99784$var$noop, {
                priority: 'user-visible'
            });
        case (0, $9Fc44.PHASE).LAZY:
            return (0, $56LFI.postTask)($39c63c9384b99784$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $39c63c9384b99784$var$lazyProxy(loader, { defer: defer = (0, $9Fc44.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $f8v34.isNodeEnvironment)();
    const dataLazyId = (0, $ewDOk.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/ban-types
    const LazyInternal = isServer ? (0, $dXi4e.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $4yMFN.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $1yW1K.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $kLgjN.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$39c63c9384b99784$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $j4Chq.retry)(deferredLoader, {
                    delay: (0, $1QGnA.RETRY_DELAY),
                    factor: (0, $1QGnA.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $f8v34.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $kLgjN.getConfig)();
        return (0, $apCPx.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $9Fc44.PHASE).PAINT ? (0, $1QGnA.PRIORITY).HIGH : (0, $1QGnA.PRIORITY).LOW);
        return (0, $lx2SU.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        moduleId: moduleId,
        preload: preload
    });
}
const $39c63c9384b99784$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $9Fc44.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $9Fc44.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $9Fc44.PHASE).LAZY
    }
};
function $39c63c9384b99784$export$c952e5f94576010e(loader, opts) {
    return $39c63c9384b99784$var$lazyProxy(loader, {
        ...$39c63c9384b99784$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $39c63c9384b99784$export$291dd592399bdafa(loader, opts) {
    return $39c63c9384b99784$var$lazyProxy(loader, {
        ...$39c63c9384b99784$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $39c63c9384b99784$export$488013bae63b21da(loader, opts) {
    return $39c63c9384b99784$var$lazyProxy(loader, {
        ...$39c63c9384b99784$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}
module.exports["lazyForPaint"] = $39c63c9384b99784$export$c952e5f94576010e;
module.exports["lazy"] = $39c63c9384b99784$export$488013bae63b21da;

});

parcelRegister("apCPx", function(module, exports) {
const $1276710975238522$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $1276710975238522$export$303f43e55cf1ef2f;

});

parcelRegister("kLgjN", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("7okWR")).MODE);

var $7okWR = parcelRequire("7okWR");

const $e504f67654901183$var$DEFAULT_CROSS_ORIGIN = undefined;
const $e504f67654901183$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $e504f67654901183$var$DEFAULT_MODE = (0, $7okWR.MODE).HYDRATE;
const $e504f67654901183$var$DEFAULT_RETRY = 2;
const $e504f67654901183$var$nullFunction = ()=>{};
const $e504f67654901183$var$config = {
    crossOrigin: $e504f67654901183$var$DEFAULT_CROSS_ORIGIN,
    manifest: $e504f67654901183$var$DEFAULT_MANIFEST,
    mode: $e504f67654901183$var$DEFAULT_MODE,
    retry: $e504f67654901183$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $e504f67654901183$var$nullFunction,
    usePostTaskPhases: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $e504f67654901183$export$44487a86467333c3 = ()=>$e504f67654901183$var$config;
const $e504f67654901183$export$940a7873bb071df8 = (nextConfig)=>{
    $e504f67654901183$var$config.crossOrigin = nextConfig.crossOrigin ?? $e504f67654901183$var$DEFAULT_CROSS_ORIGIN;
    $e504f67654901183$var$config.manifest = nextConfig.manifest ?? $e504f67654901183$var$DEFAULT_MANIFEST;
    $e504f67654901183$var$config.mode = nextConfig.mode ?? $e504f67654901183$var$DEFAULT_MODE;
    $e504f67654901183$var$config.retry = nextConfig.retry ?? $e504f67654901183$var$DEFAULT_RETRY;
    $e504f67654901183$var$config.react18 = nextConfig.react18 ?? false;
    $e504f67654901183$var$config.onChunkRender = nextConfig.onChunkRender ?? $e504f67654901183$var$nullFunction;
    $e504f67654901183$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $e504f67654901183$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $e504f67654901183$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $e504f67654901183$var$config.environment = nextConfig.environment ?? undefined;
};
module.exports["getConfig"] = $e504f67654901183$export$44487a86467333c3;

});

parcelRegister("7okWR", function(module, exports) {
const $601581d32aa16723$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $601581d32aa16723$export$e48589d9e4824227;

});

parcelRegister("9Fc44", function(module, exports) {
const $b48507ce9ad5736e$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $b48507ce9ad5736e$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $b48507ce9ad5736e$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $b48507ce9ad5736e$export$4831ef3968ea94ef;

});

parcelRegister("f8v34", function(module, exports) {

var $ewDOk = parcelRequire("ewDOk");

const $a30db2f3536f8178$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $a30db2f3536f8178$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $a30db2f3536f8178$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $a30db2f3536f8178$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $a30db2f3536f8178$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $a30db2f3536f8178$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $a30db2f3536f8178$export$283635c04a02cc36;
module.exports["attrToProp"] = $a30db2f3536f8178$export$62bf630d0de3d781;

});

parcelRegister("ewDOk", function(module, exports) {
$parcel$export(module.exports, "default", () => $24a469602f8fbe4d$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $24a469602f8fbe4d$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("4yMFN", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kLgjN = parcelRequire("kLgjN");
var $7okWR = parcelRequire("7okWR");


var $9Fc44 = parcelRequire("9Fc44");


var $kzxKD = parcelRequire("kzxKD");


var $6BYq1 = parcelRequire("6BYq1");


var $5fcqR = parcelRequire("5fcqR");


var $7ox5o = parcelRequire("7ox5o");


var $g3XHT = parcelRequire("g3XHT");


var $3slJ6 = parcelRequire("3slJ6");


var $boGZ5 = parcelRequire("boGZ5");


var $fPAF0 = parcelRequire("fPAF0");

function $c4aea8fb5847920a$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $9Fc44.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $9Fc44.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases } = (0, $kLgjN.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $42omo.useContext)((0, $7ox5o.LazySuspenseContext));
        const profiler = (0, $42omo.useContext)((0, $5fcqR.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $g3XHT.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $42omo.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $fPAF0.useSubscription)({
                context: (0, $kzxKD.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $9Fc44.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $fPAF0.useSubscription)({
                context: (0, $6BYq1.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $42omo.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $9Fc44.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $kLgjN.getConfig)().mode === (0, $7okWR.MODE).RENDER ? /*#__PURE__*/ (0, $l998X.jsx)((0, $boGZ5.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3slJ6.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases
        ]);
        (0, $42omo.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $kLgjN.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $7okWR.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(ResolvedLazy, {
            ...props
        });
    };
}
module.exports["createComponentClient"] = $c4aea8fb5847920a$export$6898b5504b58699a;

});

parcelRegister("kzxKD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jCY1s = parcelRequire("jCY1s");

const $1dab1d0aa35931a7$export$9ba3fe09d15de47b = (0, $42omo.createContext)({
    subscribe: ()=>(0, $jCY1s.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $1dab1d0aa35931a7$export$9ba3fe09d15de47b;

});

parcelRegister("jCY1s", function(module, exports) {
const $9ee2b70a231b494b$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $9ee2b70a231b494b$export$276c7dbda7675aec;

});

parcelRegister("6BYq1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9Fc44 = parcelRequire("9Fc44");


var $fIaok = parcelRequire("fIaok");


var $9gNpe = parcelRequire("9gNpe");

let $744298217eb4d9b7$var$CURRENT_PHASE = (0, $9Fc44.PHASE).PAINT;
const $744298217eb4d9b7$export$5f80f094fd31fffd = (phase)=>{
    $744298217eb4d9b7$var$CURRENT_PHASE = phase;
    (0, $fIaok.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $744298217eb4d9b7$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $9gNpe.createSubscribe)((0, $fIaok.LISTENERS)),
    currentValue: ()=>$744298217eb4d9b7$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $744298217eb4d9b7$export$5f80f094fd31fffd((0, $9Fc44.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$744298217eb4d9b7$export$5f80f094fd31fffd((0, $9Fc44.PHASE).PAINT)
    }
});
const $744298217eb4d9b7$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($744298217eb4d9b7$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["LazyPhaseContext"] = $744298217eb4d9b7$export$5a25eca35e5debcb;

});

parcelRegister("fIaok", function(module, exports) {
const $260cf0c0288f2472$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $260cf0c0288f2472$export$81b9c458a026d68f;

});

parcelRegister("9gNpe", function(module, exports) {
const $4519a9c2356c8a18$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $4519a9c2356c8a18$export$364097d812234b3f;

});

parcelRegister("5fcqR", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $01af053d839cf5fd$export$e2d53c0cbedd2710 = {
    current: null
};
const $01af053d839cf5fd$export$8146ab57a3f7a7cb = (0, $42omo.createContext)($01af053d839cf5fd$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $01af053d839cf5fd$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $01af053d839cf5fd$export$8146ab57a3f7a7cb;

});

parcelRegister("7ox5o", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kLgjN = parcelRequire("kLgjN");
var $7okWR = parcelRequire("7okWR");

const $cff3811e03675442$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
    setFallback: ()=>{
        if ((0, $kLgjN.getConfig)().mode === (0, $7okWR.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $cff3811e03675442$export$c33990e84065970c;

});

parcelRegister("g3XHT", function(module, exports) {
const $f0b861be6fd383a5$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $f0b861be6fd383a5$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$f0b861be6fd383a5$export$6aa69c1258005366]: true
    });
    return error;
};
const $f0b861be6fd383a5$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($f0b861be6fd383a5$export$6aa69c1258005366);
module.exports["createLoaderError"] = $f0b861be6fd383a5$export$c73a6a6f0bf7d425;

});

parcelRegister("3slJ6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $f8v34 = parcelRequire("f8v34");

const $d4d1572dc5458d03$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                type: "hidden",
                "data-lazy-begin": id
            }),
            content.map((el, i)=>{
                const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
                const props = Array.from(attributes).reduce((0, $f8v34.attrToProp), {
                    key: String(i)
                });
                // text node
                if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
                // childless tag
                if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
                // tag with content
                return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), {
                    ...props,
                    dangerouslySetInnerHTML: {
                        __html: ''
                    },
                    suppressHydrationWarning: true
                });
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                type: "hidden",
                "data-lazy-end": id
            })
        ]
    });
};
module.exports["PlaceholderFallbackHydrate"] = $d4d1572dc5458d03$export$ca5b8fbc835d95e4;

});

parcelRegister("boGZ5", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5fcqR = parcelRequire("5fcqR");


var $kzxKD = parcelRequire("kzxKD");


var $7ox5o = parcelRequire("7ox5o");

function $78967379450566ff$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $78967379450566ff$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    const profilerContext = (0, $42omo.useContext)((0, $5fcqR.ProfilerContext)).current;
    const waitContext = (0, $42omo.useContext)((0, $kzxKD.WaitContext));
    const suspenseContext = (0, $42omo.useContext)((0, $7ox5o.LazySuspenseContext));
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($78967379450566ff$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $78967379450566ff$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $78967379450566ff$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, $l998X.jsx)("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $78967379450566ff$export$d55db778a3e1446b;

});

parcelRegister("fPAF0", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $10addd599c71709d$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $10addd599c71709d$export$368b4214baeb914c;

});

parcelRegister("dXi4e", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $apCPx = parcelRequire("apCPx");


var $kLgjN = parcelRequire("kLgjN");
var $7okWR = parcelRequire("7okWR");


var $9Fc44 = parcelRequire("9Fc44");


var $7ox5o = parcelRequire("7ox5o");


var $f8v34 = parcelRequire("f8v34");


var $g3XHT = parcelRequire("g3XHT");

function $62b3c49a05e9a21d$var$load(moduleId, loader) {
    try {
        return (0, $f8v34.getExport)(loader());
    } catch (err) {
        throw (0, $g3XHT.createLoaderError)(err);
    }
}
function $62b3c49a05e9a21d$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $42omo.useContext)((0, $7ox5o.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $kLgjN.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $62b3c49a05e9a21d$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $7okWR.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $62b3c49a05e9a21d$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, $l998X.jsx)(Resolved, {
                ...props
            });
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("input", {
                    type: "hidden",
                    "data-lazy-begin": dataLazyId
                }),
                defer !== (0, $9Fc44.PHASE).LAZY && (0, $apCPx.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, $l998X.jsx)("link", {
                        rel: defer === (0, $9Fc44.PHASE).PAINT ? 'preload' : 'prefetch',
                        href: url,
                        crossOrigin: crossOrigin,
                        as: "script"
                    }, url)),
                Resolved ? /*#__PURE__*/ (0, $l998X.jsx)(Resolved, {
                    ...props
                }) : fallback,
                /*#__PURE__*/ (0, $l998X.jsx)("input", {
                    type: "hidden",
                    "data-lazy-end": dataLazyId
                })
            ]
        });
    };
}
class $62b3c49a05e9a21d$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = void 0;
        this.skipSsr = true;
    }
}
module.exports["createComponentServer"] = $62b3c49a05e9a21d$export$eb2e4b04351cdd9e;

});

parcelRegister("1QGnA", function(module, exports) {
const $e0f51a4da9ffcfc3$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e0f51a4da9ffcfc3$export$a339266ad71b2447 = 300;
const $e0f51a4da9ffcfc3$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e0f51a4da9ffcfc3$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e0f51a4da9ffcfc3$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e0f51a4da9ffcfc3$export$ba64c908e55507fe;

});

parcelRegister("1yW1K", function(module, exports) {
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $ecfde71ac061a273$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $ecfde71ac061a273$var$preloadIds;
const $ecfde71ac061a273$export$ac21d099cbc8d569 = (preload)=>{
    $ecfde71ac061a273$var$preloadIds = preload;
    try {
        $ecfde71ac061a273$var$preloadIds.forEach((lazyId)=>{
            const deffered = $ecfde71ac061a273$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $ecfde71ac061a273$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $ecfde71ac061a273$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($ecfde71ac061a273$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};
module.exports["createDeferred"] = $ecfde71ac061a273$export$e673efccd97e4223;

});

parcelRegister("lx2SU", function(module, exports) {

var $apCPx = parcelRequire("apCPx");


var $jCY1s = parcelRequire("jCY1s");


var $kLgjN = parcelRequire("kLgjN");


var $5fcqR = parcelRequire("5fcqR");


var $f8v34 = parcelRequire("f8v34");


var $1QGnA = parcelRequire("1QGnA");


var $gmp1c = parcelRequire("gmp1c");

function $53aa0b2a46a7822d$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $kLgjN.getConfig)();
    const assets = (0, $apCPx.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $gmp1c.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $53aa0b2a46a7822d$var$fakePromise = {
    then: ()=>$53aa0b2a46a7822d$var$fakePromise,
    catch: ()=>$53aa0b2a46a7822d$var$fakePromise,
    finally: ()=>$53aa0b2a46a7822d$var$fakePromise
};
function $53aa0b2a46a7822d$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $gmp1c.insertLinkTag)(href, rel));
        return $53aa0b2a46a7822d$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $53aa0b2a46a7822d$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jCY1s.noopCleanup;
}
function $53aa0b2a46a7822d$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $f8v34.isNodeEnvironment)()) return 0, $jCY1s.noopCleanup;
    (0, $5fcqR.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $1QGnA.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $53aa0b2a46a7822d$export$3af04dbcb01bad4d,
        $53aa0b2a46a7822d$export$1046fd6a49d5e7a,
        $53aa0b2a46a7822d$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jCY1s.noopCleanup;
}
module.exports["preloadAsset"] = $53aa0b2a46a7822d$export$25bad4aa00c45355;

});

parcelRegister("gmp1c", function(module, exports) {

var $jCY1s = parcelRequire("jCY1s");


var $kLgjN = parcelRequire("kLgjN");


var $5fcqR = parcelRequire("5fcqR");

function $7ac07eba9f17ef9a$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jCY1s.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $kLgjN.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $5fcqR.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $7ac07eba9f17ef9a$export$6610512821c8a4ce;

});

parcelRegister("j4Chq", function(module, exports) {
const $6152f1a19d36d750$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $6152f1a19d36d750$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $6152f1a19d36d750$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $6152f1a19d36d750$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $6152f1a19d36d750$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $6152f1a19d36d750$var$calculateDelay(context, policy);
        if (delay) await $6152f1a19d36d750$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $6152f1a19d36d750$export$9369b12211e1fce4;

});

parcelRegister("13zfh", function(module, exports) {

let $0c51694b0b5281d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c51694b0b5281d9$var$load("6WeF1").then(()=>parcelRequire('71Heu'));

});

parcelRegister("9AqRO", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $5c6b2d76155e66d2$var$LazyGitlabIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("iQ8bB")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon'
});

const $5c6b2d76155e66d2$var$LazyGitlabSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("iQ8bB")).then((m)=>m.GitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon'
});

const $5c6b2d76155e66d2$var$LazyGitlabIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("iQ8bB")).then((m)=>m.GitlabIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless'
});
const $5c6b2d76155e66d2$export$8b4e5326778cce0f = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabIconComponent, null));
const $5c6b2d76155e66d2$export$b828123bc19648f9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabSearchResultIconComponent, null));
const $5c6b2d76155e66d2$export$7e0d364467f49036 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c6b2d76155e66d2$var$LazyGitlabIconBorderlessComponent, null));
module.exports["GitlabIcon"] = $5c6b2d76155e66d2$export$8b4e5326778cce0f;
module.exports["GitlabSearchResultIcon"] = $5c6b2d76155e66d2$export$b828123bc19648f9;
module.exports["GitlabIconBorderless"] = $5c6b2d76155e66d2$export$7e0d364467f49036;

});

parcelRegister("iQ8bB", function(module, exports) {

let $db736ee8c78cb798$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db736ee8c78cb798$var$load("aqb5p").then(()=>parcelRequire('bEriH'));

});

parcelRegister("6Fa33", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $d90aa918544bbcee$var$LazyGitbookIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("cwkq9")).then((m)=>m.GitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/icon'
});

const $d90aa918544bbcee$var$LazyGitbookSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("cwkq9")).then((m)=>m.GitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon'
});
const $d90aa918544bbcee$export$6da1c7984975c183 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d90aa918544bbcee$var$LazyGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d90aa918544bbcee$var$LazyGitbookIconComponent, null));
const $d90aa918544bbcee$export$65b356f251826206 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d90aa918544bbcee$var$LazyGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d90aa918544bbcee$var$LazyGitbookSearchResultIconComponent, null));
module.exports["GitbookIcon"] = $d90aa918544bbcee$export$6da1c7984975c183;
module.exports["GitbookSearchResultIcon"] = $d90aa918544bbcee$export$65b356f251826206;

});

parcelRegister("cwkq9", function(module, exports) {

let $91d850555776a6c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91d850555776a6c8$var$load("5ko8Y").then(()=>parcelRequire('jXQsu'));

});

parcelRegister("6RZzG", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $a6322d6d29949407$var$LazyAzureDevopsIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9iyYo")).then((m)=>m.AzureDevopsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon'
});

const $a6322d6d29949407$var$LazyAzureDevopsSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9iyYo")).then((m)=>m.AzureDevopsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon'
});
const $a6322d6d29949407$export$2dcf704e717ca168 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6322d6d29949407$var$LazyAzureDevopsIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6322d6d29949407$var$LazyAzureDevopsIconComponent, null));
const $a6322d6d29949407$export$a64bb17da4dc2efb = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6322d6d29949407$var$LazyAzureDevopsSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6322d6d29949407$var$LazyAzureDevopsSearchResultIconComponent, null));
module.exports["AzureDevopsIcon"] = $a6322d6d29949407$export$2dcf704e717ca168;
module.exports["AzureDevopsSearchResultIcon"] = $a6322d6d29949407$export$a64bb17da4dc2efb;

});

parcelRegister("9iyYo", function(module, exports) {

let $6c50ec68f9a1653b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c50ec68f9a1653b$var$load("i0Kds").then(()=>parcelRequire('9bvJE'));

});

parcelRegister("ce4Ui", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $6e6a1954aec811f9$var$LazyGoogleDriveIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l71ry")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon'
});

const $6e6a1954aec811f9$var$LazyGoogleDriveSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l71ry")).then((m)=>m.GoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/search-result-icon'
});

const $6e6a1954aec811f9$var$LazyGoogleDriveIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l71ry")).then((m)=>m.GoogleDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon-borderless'
});

const $6e6a1954aec811f9$var$LazyGoogleDriveAppSelectorIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l71ry")).then((m)=>m.GoogleDriveAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/app-selector-icon'
});
const $6e6a1954aec811f9$export$e16bd899bb4eebf9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveIconComponent, null));
const $6e6a1954aec811f9$export$99050685a064f8e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveSearchResultIconComponent, null));
const $6e6a1954aec811f9$export$1f3b452b60b13122 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveIconBorderlessComponent, null));
const $6e6a1954aec811f9$export$e087ba40596ff085 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveAppSelectorIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e6a1954aec811f9$var$LazyGoogleDriveAppSelectorIconComponent, null));
module.exports["GoogleDriveIcon"] = $6e6a1954aec811f9$export$e16bd899bb4eebf9;
module.exports["GoogleDriveSearchResultIcon"] = $6e6a1954aec811f9$export$99050685a064f8e;
module.exports["GoogleDriveIconBorderless"] = $6e6a1954aec811f9$export$1f3b452b60b13122;
module.exports["GoogleDriveAppSelectorIcon"] = $6e6a1954aec811f9$export$e087ba40596ff085;

});

parcelRegister("l71ry", function(module, exports) {

let $f5eb5f0bb6b715c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5eb5f0bb6b715c3$var$load("ar6O2").then(()=>parcelRequire('dZv90'));

});

parcelRegister("e2bfY", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $ddfb33be9046c546$var$LazyWebDomainSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("4Qi0d")).then((m)=>m.WebDomainSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/atlassian-web-crawler/search-result-icon'
});
const $ddfb33be9046c546$export$b16288f56aa4a879 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ddfb33be9046c546$var$LazyWebDomainSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ddfb33be9046c546$var$LazyWebDomainSearchResultIconComponent, null));
module.exports["WebDomainSearchResultIcon"] = $ddfb33be9046c546$export$b16288f56aa4a879;

});

parcelRegister("4Qi0d", function(module, exports) {

let $3869fbaef27befc4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3869fbaef27befc4$var$load("bkewv").then(()=>parcelRequire('dmnni'));

});

parcelRegister("fs7kD", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $0f95e835fcdef007$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    ['atlassian-web-crawler']: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    }
});
module.exports["messages"] = $0f95e835fcdef007$export$defe85febe8b728c;

});

parcelRegister("8ghR9", function(module, exports) {

var $jgKBj = parcelRequire("jgKBj");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $ibxys = parcelRequire("ibxys");

const $9357a8078e1da143$export$e821d8af66e3adab = {
    displayName: 'Figma',
    id: 'figma',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Figma,
    icon: (0, $fj6km.get3PLogo)((0, $ibxys.FigmaIcon), 'Figma', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $ibxys.FigmaSearchResultIcon), 'Figma', 'large'),
    integrationAri: 'ari:cloud:platform::integration/figma',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $jgKBj.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["figmaConfig"] = $9357a8078e1da143$export$e821d8af66e3adab;

});

parcelRegister("jgKBj", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $15fa3f0fcc22a9d1$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
module.exports["DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI"] = $15fa3f0fcc22a9d1$export$9d37c36d8b43baee;

});

parcelRegister("71WeF", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $8b8c4a19dc45a1eb$export$1dc2d469fb044d48 = [
    'ati:cloud:graph:remote-link'
];
module.exports["DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI"] = $8b8c4a19dc45a1eb$export$1dc2d469fb044d48;

});

parcelRegister("ibxys", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $b56d8621741d13da$var$LazyFigmaIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("dO7v4")).then((m)=>m.FigmaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/figma/icon'
});

const $b56d8621741d13da$var$LazyFigmaSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("dO7v4")).then((m)=>m.FigmaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/figma/search-result-icon'
});
const $b56d8621741d13da$export$54e0f4982aa79afe = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56d8621741d13da$var$LazyFigmaIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56d8621741d13da$var$LazyFigmaIconComponent, null));
const $b56d8621741d13da$export$b31792ff95c3d83f = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56d8621741d13da$var$LazyFigmaSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56d8621741d13da$var$LazyFigmaSearchResultIconComponent, null));
module.exports["FigmaIcon"] = $b56d8621741d13da$export$54e0f4982aa79afe;
module.exports["FigmaSearchResultIcon"] = $b56d8621741d13da$export$b31792ff95c3d83f;

});

parcelRegister("dO7v4", function(module, exports) {

let $a0d5c33d730c5a8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0d5c33d730c5a8e$var$load("igJsc").then(()=>parcelRequire('4hB6b'));

});

parcelRegister("c7moJ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8akCo = parcelRequire("8akCo");


var $5InRj = parcelRequire("5InRj");


var $aWEgY = parcelRequire("aWEgY");


var $1xTLA = parcelRequire("1xTLA");


var $cJRFO = parcelRequire("cJRFO");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $1Teld = parcelRequire("1Teld");

const $a53b05c5986723b6$var$getGithubTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $dz5JF.TypeFilterValueKey).Repository, {
        entities3P: (0, $1xTLA.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $dz5JF.TypeFilterValueKey).PullRequest, {
        entities3P: (0, $aWEgY.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Branch, {
        entities3P: (0, $8akCo.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $dz5JF.TypeFilterValueKey).Commit, {
        entities3P: (0, $5InRj.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
        subTypes3P: []
    });
    config.set((0, $dz5JF.TypeFilterValueKey).DevopsWorkItem, {
        entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
        subTypes3P: []
    });
    if ((0, $dh538.fg)('rovo_github_code_search')) config.set((0, $dz5JF.TypeFilterValueKey).Document, {
        entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $a53b05c5986723b6$export$71c63cb45707eee = {
    displayName: 'GitHub',
    id: 'github',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Github,
    icon: (0, $fj6km.get3PLogo)((0, $1Teld.GithubIcon), 'Github', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $1Teld.GithubSearchResultIcon), 'Github', 'large'),
    integrationAri: 'ari:cloud:platform::integration/github',
    get typeFilterConfig () {
        return $a53b05c5986723b6$var$getGithubTypeFilterConfig();
    },
    get filters () {
        const baseFilters = [
            'lastUpdated',
            'onlyTitleMatch',
            'pullRequestStatus'
        ];
        if ((0, $dh538.fg)('rovo_fps_show_repository_filter')) baseFilters.push('repository');
        if ((0, $dh538.fg)('rovo_fps_show_github_created_by_filter')) baseFilters.push('createdBy');
        return baseFilters;
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["githubConfig"] = $a53b05c5986723b6$export$71c63cb45707eee;

});

parcelRegister("8akCo", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $03a6e2b346ada400$export$7bf025ec33e76761 = [
    'ati:cloud:graph:branch'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI"] = $03a6e2b346ada400$export$7bf025ec33e76761;

});

parcelRegister("5InRj", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $4931b703bfc44589$export$3e5409bef2addb56 = [
    'ati:cloud:graph:commit'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI"] = $4931b703bfc44589$export$3e5409bef2addb56;

});

parcelRegister("aWEgY", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $32dd7299b373890b$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI"] = $32dd7299b373890b$export$3268f1527392e5ac;

});

parcelRegister("1xTLA", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a839bb0b2176dcbd$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $a839bb0b2176dcbd$export$c28231fcae6448eb;

});

parcelRegister("kLIW5", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $406d04c9f0a71eb1$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
module.exports["DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI"] = $406d04c9f0a71eb1$export$d810eae89914369b;

});

parcelRegister("c2Gh1", function(module, exports) {

var $lAFHW = parcelRequire("lAFHW");


var $kQuIn = parcelRequire("kQuIn");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");

const $7d4c8141689061f7$export$9cb908560d4a0a78 = {
    displayName: 'Loom',
    id: 'loom',
    icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.LoomIcon), 'small'),
    searchResultIcon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.LoomIcon), 'large'),
    integrationAri: 'ari:cloud:platform::integration/loom',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Video,
            {
                entities3P: (0, $kQuIn.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["loomConfig"] = $7d4c8141689061f7$export$9cb908560d4a0a78;

});

parcelRegister("7JjDF", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $8i5xJ = parcelRequire("8i5xJ");

const $ae08ac07e67c6831$export$b3b3a7aaf94fe09 = {
    displayName: 'OneDrive',
    id: 'onedrive',
    resourceType: (0, $78z3f.ProductResourceTypes3P).OneDrive,
    icon: (0, $fj6km.get3PLogo)((0, $8i5xJ.OneDriveIcon), 'OneDrive', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $8i5xJ.OneDriveIconBorderless), 'OneDrive', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $8i5xJ.OneDriveSearchResultIcon), 'OneDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Document,
                    (0, $dz5JF.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Presentation,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["oneDriveConfig"] = $ae08ac07e67c6831$export$b3b3a7aaf94fe09;

});

parcelRegister("8i5xJ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $46a9786e4df30e6c$var$LazyOneDriveIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("jBwgu")).then((m)=>m.OneDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/onedrive/icon'
});

const $46a9786e4df30e6c$var$LazyOneDriveSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("jBwgu")).then((m)=>m.OneDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/onedrive/search-result-icon'
});

const $46a9786e4df30e6c$var$LazyOneDriveIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("jBwgu")).then((m)=>m.OneDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/onedrive/icon-borderless'
});
const $46a9786e4df30e6c$export$44884401d09e251c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46a9786e4df30e6c$var$LazyOneDriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46a9786e4df30e6c$var$LazyOneDriveIconComponent, null));
const $46a9786e4df30e6c$export$f2ab3f3a9966c07c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46a9786e4df30e6c$var$LazyOneDriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46a9786e4df30e6c$var$LazyOneDriveSearchResultIconComponent, null));
const $46a9786e4df30e6c$export$9b1a95f6ce5942a8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46a9786e4df30e6c$var$LazyOneDriveIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($46a9786e4df30e6c$var$LazyOneDriveIconBorderlessComponent, null));
module.exports["OneDriveIcon"] = $46a9786e4df30e6c$export$44884401d09e251c;
module.exports["OneDriveSearchResultIcon"] = $46a9786e4df30e6c$export$f2ab3f3a9966c07c;
module.exports["OneDriveIconBorderless"] = $46a9786e4df30e6c$export$9b1a95f6ce5942a8;

});

parcelRegister("jBwgu", function(module, exports) {

let $e45a8025fc5cc4ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e45a8025fc5cc4ea$var$load("kl3Py").then(()=>parcelRequire('2oSMA'));

});

parcelRegister("5rdfZ", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $gf4LX = parcelRequire("gf4LX");

const $38d3dbcf7579e997$export$4a63cdb15a145936 = {
    displayName: 'Dropbox',
    id: 'dropbox',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Dropbox,
    icon: (0, $fj6km.get3PLogo)((0, $gf4LX.DropboxIcon), 'Dropbox', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $gf4LX.DropboxSearchResultIcon), 'Dropbox', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dropbox',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Document,
                    (0, $dz5JF.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dropboxConfig"] = $38d3dbcf7579e997$export$4a63cdb15a145936;

});

parcelRegister("gf4LX", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $1aadec5862ca1826$var$LazyDropboxIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("62LlG")).then((m)=>m.DropboxIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dropbox/icon'
});

const $1aadec5862ca1826$var$LazyDropboxSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("62LlG")).then((m)=>m.DropboxSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dropbox/search-result-icon'
});
const $1aadec5862ca1826$export$5e2362bb78414664 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1aadec5862ca1826$var$LazyDropboxIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1aadec5862ca1826$var$LazyDropboxIconComponent, null));
const $1aadec5862ca1826$export$197780c70679b508 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1aadec5862ca1826$var$LazyDropboxSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1aadec5862ca1826$var$LazyDropboxSearchResultIconComponent, null));
module.exports["DropboxIcon"] = $1aadec5862ca1826$export$5e2362bb78414664;
module.exports["DropboxSearchResultIcon"] = $1aadec5862ca1826$export$197780c70679b508;

});

parcelRegister("62LlG", function(module, exports) {

let $4667a873e2283d00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4667a873e2283d00$var$load("27lOX").then(()=>parcelRequire('iKAdb'));

});

parcelRegister("b7iDu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $37cdb15be320b628$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
module.exports["DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI"] = $37cdb15be320b628$export$a752b216a5b9069f;

});

parcelRegister("7apDH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a6943bbde389a4af$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
module.exports["DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI"] = $a6943bbde389a4af$export$8bd7fa13a82672fe;

});

parcelRegister("7Ybf0", function(module, exports) {

var $4H1Ss = parcelRequire("4H1Ss");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $9pHOC = parcelRequire("9pHOC");

const $894d9d500e48dcd0$export$be326f2f9a08a3a4 = {
    displayName: 'Google Calendar',
    id: 'google-calendar',
    resourceType: (0, $78z3f.ProductResourceTypes3P).GoogleCalendar,
    icon: (0, $fj6km.get3PLogo)((0, $9pHOC.GoogleCalendarIcon), 'Google Calendar', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $9pHOC.GoogleCalendarIconBorderless), 'Google Calendar', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $9pHOC.GoogleCalendarSearchResultIcon), 'Google Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $4H1Ss.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    isEnabled: ()=>true
};
module.exports["googleCalendarConfig"] = $894d9d500e48dcd0$export$be326f2f9a08a3a4;

});

parcelRegister("4H1Ss", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $fbb1aa0fcec8a498$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
module.exports["DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI"] = $fbb1aa0fcec8a498$export$733c2acb2513a07a;

});

parcelRegister("9pHOC", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $34d105122ea1516a$var$LazyGoogleCalendarIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hODSO")).then((m)=>m.GoogleCalendarIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon'
});

const $34d105122ea1516a$var$LazyGoogleCalendarSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hODSO")).then((m)=>m.GoogleCalendarSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/search-result-icon'
});

const $34d105122ea1516a$var$LazyGoogleCalendarIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hODSO")).then((m)=>m.GoogleCalendarIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon-borderless'
});
const $34d105122ea1516a$export$5d128e0a6ffc0558 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34d105122ea1516a$var$LazyGoogleCalendarIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34d105122ea1516a$var$LazyGoogleCalendarIconComponent, null));
const $34d105122ea1516a$export$aed283b8fb73a449 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34d105122ea1516a$var$LazyGoogleCalendarSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34d105122ea1516a$var$LazyGoogleCalendarSearchResultIconComponent, null));
const $34d105122ea1516a$export$dc8e328f8eb98139 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34d105122ea1516a$var$LazyGoogleCalendarIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($34d105122ea1516a$var$LazyGoogleCalendarIconBorderlessComponent, null));
module.exports["GoogleCalendarIcon"] = $34d105122ea1516a$export$5d128e0a6ffc0558;
module.exports["GoogleCalendarSearchResultIcon"] = $34d105122ea1516a$export$aed283b8fb73a449;
module.exports["GoogleCalendarIconBorderless"] = $34d105122ea1516a$export$dc8e328f8eb98139;

});

parcelRegister("hODSO", function(module, exports) {

let $cf860b200bc2c0fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cf860b200bc2c0fa$var$load("gurkm").then(()=>parcelRequire('82UEu'));

});

parcelRegister("eaaHo", function(module, exports) {

var $4H1Ss = parcelRequire("4H1Ss");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $lfXfv = parcelRequire("lfXfv");

const $26efc030440244a4$export$3e5044818f2e9ef3 = {
    displayName: 'Outlook Calendar',
    id: 'outlook-calendar',
    resourceType: (0, $78z3f.ProductResourceTypes3P).OutlookCalendar,
    icon: (0, $fj6km.get3PLogo)((0, $lfXfv.OutlookCalendarIcon), 'Outlook Calendar', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $lfXfv.OutlookCalendarIconBorderless), 'Outlook Calendar', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $lfXfv.OutlookCalendarSearchResultIcon), 'Outlook Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $4H1Ss.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["outlookCalendarConfig"] = $26efc030440244a4$export$3e5044818f2e9ef3;

});

parcelRegister("lfXfv", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $8247d53ce0a02708$var$LazyOutlookCalendarIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l3E8m")).then((m)=>m.OutlookCalendarIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/icon'
});

const $8247d53ce0a02708$var$LazyOutlookCalendarSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l3E8m")).then((m)=>m.OutlookCalendarSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/search-result-icon'
});

const $8247d53ce0a02708$var$LazyOutlookCalendarIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("l3E8m")).then((m)=>m.OutlookCalendarIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/icon-borderless'
});
const $8247d53ce0a02708$export$62b570fbaf793397 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8247d53ce0a02708$var$LazyOutlookCalendarIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8247d53ce0a02708$var$LazyOutlookCalendarIconComponent, null));
const $8247d53ce0a02708$export$c93fd0887f18cc87 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8247d53ce0a02708$var$LazyOutlookCalendarSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8247d53ce0a02708$var$LazyOutlookCalendarSearchResultIconComponent, null));
const $8247d53ce0a02708$export$dd150ae24aa9e16a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8247d53ce0a02708$var$LazyOutlookCalendarIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8247d53ce0a02708$var$LazyOutlookCalendarIconBorderlessComponent, null));
module.exports["OutlookCalendarIcon"] = $8247d53ce0a02708$export$62b570fbaf793397;
module.exports["OutlookCalendarSearchResultIcon"] = $8247d53ce0a02708$export$c93fd0887f18cc87;
module.exports["OutlookCalendarIconBorderless"] = $8247d53ce0a02708$export$dd150ae24aa9e16a;

});

parcelRegister("l3E8m", function(module, exports) {

let $f5490289fadc6dca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5490289fadc6dca$var$load("xQCxQ").then(()=>parcelRequire('91eXQ'));

});

parcelRegister("eHKKm", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $9kx1T = parcelRequire("9kx1T");

const $75e1442b3fda7e3e$export$72c8845a87b8934e = {
    displayName: 'Asana',
    id: 'asana',
    icon: (0, $fj6km.get3PLogo)((0, $9kx1T.AsanaIcon), 'Asana', 'medium'),
    resourceType: (0, $78z3f.ProductResourceTypes3P).Asana,
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $9kx1T.AsanaSearchResultIcon), 'Asana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/asana',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: [
                    ...(0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Task
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["asanaConfig"] = $75e1442b3fda7e3e$export$72c8845a87b8934e;

});

parcelRegister("9kx1T", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $e31b354dd0e7e63a$var$LazyAsanaIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("i0xvx")).then((m)=>m.AsanaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/asana/icon'
});

const $e31b354dd0e7e63a$var$LazyAsanaSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("i0xvx")).then((m)=>m.AsanaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/asana/search-result-icon'
});
const $e31b354dd0e7e63a$export$671541d0c7918cd9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e31b354dd0e7e63a$var$LazyAsanaIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e31b354dd0e7e63a$var$LazyAsanaIconComponent, null));
const $e31b354dd0e7e63a$export$c3fa6bf9156b56f9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e31b354dd0e7e63a$var$LazyAsanaSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e31b354dd0e7e63a$var$LazyAsanaSearchResultIconComponent, null));
module.exports["AsanaIcon"] = $e31b354dd0e7e63a$export$671541d0c7918cd9;
module.exports["AsanaSearchResultIcon"] = $e31b354dd0e7e63a$export$c3fa6bf9156b56f9;

});

parcelRegister("i0xvx", function(module, exports) {

let $d1c238053208254b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1c238053208254b$var$load("eCJiq").then(()=>parcelRequire('8uPW2'));

});

parcelRegister("kuTad", function(module, exports) {

var $2pPu4 = parcelRequire("2pPu4");


var $cJRFO = parcelRequire("cJRFO");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $5qarH = parcelRequire("5qarH");

const $f5eaf85bfc81aa10$export$74a2db0a5eb2da3f = {
    displayName: 'Zendesk',
    id: 'zendesk',
    icon: (0, $fj6km.get3PLogo)((0, $5qarH.ZendeskIcon), 'Zendesk', 'medium'),
    resourceType: (0, $78z3f.ProductResourceTypes3P).Zendesk,
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $5qarH.ZendeskSearchResultIcon), 'Zendesk', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zendesk',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Ticket,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Post,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Post
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Article,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Article
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $2pPu4.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zendeskConfig"] = $f5eaf85bfc81aa10$export$74a2db0a5eb2da3f;

});

parcelRegister("2pPu4", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $7ea03d02d9b5f1e3$export$4e0eae9edc1a8907 = [
    'ati:cloud:graph:comment'
];
module.exports["DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI"] = $7ea03d02d9b5f1e3$export$4e0eae9edc1a8907;

});

parcelRegister("5qarH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $ec5241395fab00c7$var$LazyZendeskIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("8QeSG")).then((m)=>m.ZendeskIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zendesk/icon'
});

const $ec5241395fab00c7$var$LazyZendeskSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("8QeSG")).then((m)=>m.ZendeskSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zendesk/search-result-icon'
});
const $ec5241395fab00c7$export$9969d63eaadfddf7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec5241395fab00c7$var$LazyZendeskIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec5241395fab00c7$var$LazyZendeskIconComponent, null));
const $ec5241395fab00c7$export$439dd6b525db0f9a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec5241395fab00c7$var$LazyZendeskSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ec5241395fab00c7$var$LazyZendeskSearchResultIconComponent, null));
module.exports["ZendeskIcon"] = $ec5241395fab00c7$export$9969d63eaadfddf7;
module.exports["ZendeskSearchResultIcon"] = $ec5241395fab00c7$export$439dd6b525db0f9a;

});

parcelRegister("8QeSG", function(module, exports) {

let $66feb91712337077$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66feb91712337077$var$load("1vfDP").then(()=>parcelRequire('7h2Pq'));

});

parcelRegister("9o4in", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $EceM3 = parcelRequire("EceM3");

const $58c5a698e8d7717b$export$962b0679c5bd2c33 = {
    displayName: 'Airtable',
    id: 'airtable',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Airtable,
    icon: (0, $fj6km.get3PLogo)((0, $EceM3.AirtableIcon), 'Airtable', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $EceM3.AirtableSearchResultIcon), 'Airtable', 'large'),
    integrationAri: 'ari:cloud:platform::integration/airtable',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["airtableConfig"] = $58c5a698e8d7717b$export$962b0679c5bd2c33;

});

parcelRegister("EceM3", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $41a7c83588de3e9a$var$LazyAirtableIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hQpKb")).then((m)=>m.AirtableIcon), {
    moduleId: '@atlassian/rovo-connectors-config/airtable/icon'
});

const $41a7c83588de3e9a$var$LazyAirtableSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hQpKb")).then((m)=>m.AirtableSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/airtable/search-result-icon'
});
const $41a7c83588de3e9a$export$88b64eee273831fd = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($41a7c83588de3e9a$var$LazyAirtableIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($41a7c83588de3e9a$var$LazyAirtableIconComponent, null));
const $41a7c83588de3e9a$export$826c628c1cea041a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($41a7c83588de3e9a$var$LazyAirtableSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($41a7c83588de3e9a$var$LazyAirtableSearchResultIconComponent, null));
module.exports["AirtableIcon"] = $41a7c83588de3e9a$export$88b64eee273831fd;
module.exports["AirtableSearchResultIcon"] = $41a7c83588de3e9a$export$826c628c1cea041a;

});

parcelRegister("hQpKb", function(module, exports) {

let $cfdb432e50500d72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cfdb432e50500d72$var$load("6uykl").then(()=>parcelRequire('kf3ZL'));

});

parcelRegister("Wmb4v", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $kzhUR = parcelRequire("kzhUR");

const $9a8e4cc049ac515d$export$aad10bcf647ef696 = {
    displayName: 'Smartsheet',
    id: 'smartsheet',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Smartsheet,
    icon: (0, $fj6km.get3PLogo)((0, $kzhUR.SmartsheetIcon), 'Smartsheet', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $kzhUR.SmartsheetSearchResultIcon), 'Smartsheet', 'large'),
    integrationAri: 'ari:cloud:platform::integration/smartsheet',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["smartsheetConfig"] = $9a8e4cc049ac515d$export$aad10bcf647ef696;

});

parcelRegister("kzhUR", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $755040a95b257543$var$LazySmartsheetIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("d11Jl")).then((m)=>m.SmartsheetIcon), {
    moduleId: '@atlassian/rovo-connectors-config/smartsheet/icon'
});

const $755040a95b257543$var$LazySmartsheetSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("d11Jl")).then((m)=>m.SmartsheetSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/smartsheet/search-result-icon'
});
const $755040a95b257543$export$dd0ad7bd8a5794f4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($755040a95b257543$var$LazySmartsheetIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($755040a95b257543$var$LazySmartsheetIconComponent, null));
const $755040a95b257543$export$3b8c4380ae1ed96d = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($755040a95b257543$var$LazySmartsheetSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($755040a95b257543$var$LazySmartsheetSearchResultIconComponent, null));
module.exports["SmartsheetIcon"] = $755040a95b257543$export$dd0ad7bd8a5794f4;
module.exports["SmartsheetSearchResultIcon"] = $755040a95b257543$export$3b8c4380ae1ed96d;

});

parcelRegister("d11Jl", function(module, exports) {

let $979cb5f92031da1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $979cb5f92031da1d$var$load("3FR6D").then(()=>parcelRequire('9S5nn'));

});

parcelRegister("dTyKo", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $h6Psh = parcelRequire("h6Psh");

const $fe367962c6f55633$export$ddf7404f556e473a = {
    displayName: 'Notion',
    id: 'notion',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Notion,
    icon: (0, $fj6km.get3PLogo)((0, $h6Psh.NotionIcon), 'Notion', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $h6Psh.NotionIconBorderless), 'Notion', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $h6Psh.NotionSearchResultIcon), 'Notion', 'large'),
    integrationAri: 'ari:cloud:platform::integration/notion',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["notionConfig"] = $fe367962c6f55633$export$ddf7404f556e473a;

});

parcelRegister("h6Psh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $c5fbda1d726a181f$var$LazyNotionIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("lpKyv")).then((m)=>m.NotionIcon), {
    moduleId: '@atlassian/rovo-connectors-config/notion/icon'
});

const $c5fbda1d726a181f$var$LazyNotionSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("lpKyv")).then((m)=>m.NotionSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/notion/search-result-icon'
});

const $c5fbda1d726a181f$var$LazyNotionIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("lpKyv")).then((m)=>m.NotionIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/notion/icon-borderless'
});
const $c5fbda1d726a181f$export$694ff710b1e20299 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5fbda1d726a181f$var$LazyNotionIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5fbda1d726a181f$var$LazyNotionIconComponent, null));
const $c5fbda1d726a181f$export$7dd377a68ecb1d9f = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5fbda1d726a181f$var$LazyNotionSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5fbda1d726a181f$var$LazyNotionSearchResultIconComponent, null));
const $c5fbda1d726a181f$export$5b5388c6f4e608dd = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5fbda1d726a181f$var$LazyNotionIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5fbda1d726a181f$var$LazyNotionIconBorderlessComponent, null));
module.exports["NotionIcon"] = $c5fbda1d726a181f$export$694ff710b1e20299;
module.exports["NotionSearchResultIcon"] = $c5fbda1d726a181f$export$7dd377a68ecb1d9f;
module.exports["NotionIconBorderless"] = $c5fbda1d726a181f$export$5b5388c6f4e608dd;

});

parcelRegister("lpKyv", function(module, exports) {

let $f9700bbcb895633d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9700bbcb895633d$var$load("HhH4L").then(()=>parcelRequire('3g6lB'));

});

parcelRegister("7BCex", function(module, exports) {

var $jgKBj = parcelRequire("jgKBj");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $egFdq = parcelRequire("egFdq");

const $23a86c790f56077f$export$b11bada05d439596 = {
    displayName: 'Miro',
    id: 'miro',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Miro,
    icon: (0, $fj6km.get3PLogo)((0, $egFdq.MiroIcon), 'Miro', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $egFdq.MiroSearchResultIcon), 'Miro', 'large'),
    integrationAri: 'ari:cloud:platform::integration/miro',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $jgKBj.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["miroConfig"] = $23a86c790f56077f$export$b11bada05d439596;

});

parcelRegister("egFdq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $10c60dc1ef7c1bb9$var$LazyMiroIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("liSrg")).then((m)=>m.MiroIcon), {
    moduleId: '@atlassian/rovo-connectors-config/miro/icon'
});

const $10c60dc1ef7c1bb9$var$LazyMiroSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("liSrg")).then((m)=>m.MiroSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/miro/search-result-icon'
});
const $10c60dc1ef7c1bb9$export$38410c1d5582587e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10c60dc1ef7c1bb9$var$LazyMiroIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10c60dc1ef7c1bb9$var$LazyMiroIconComponent, null));
const $10c60dc1ef7c1bb9$export$c22696a011659024 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10c60dc1ef7c1bb9$var$LazyMiroSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10c60dc1ef7c1bb9$var$LazyMiroSearchResultIconComponent, null));
module.exports["MiroIcon"] = $10c60dc1ef7c1bb9$export$38410c1d5582587e;
module.exports["MiroSearchResultIcon"] = $10c60dc1ef7c1bb9$export$c22696a011659024;

});

parcelRegister("liSrg", function(module, exports) {

let $f82581d4221e7fd7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f82581d4221e7fd7$var$load("jy7ml").then(()=>parcelRequire('gWrF6'));

});

parcelRegister("7CU5w", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $5epZa = parcelRequire("5epZa");

const $3ef1a4f2aa48071c$export$cee55280cabc1aa1 = {
    displayName: 'Docusign',
    id: 'docusign',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Docusign,
    icon: (0, $fj6km.get3PLogo)((0, $5epZa.DocusignIcon), 'Docusign', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $5epZa.DocusignIconBorderless), 'Docusign', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $5epZa.DocusignSearchResultIcon), 'Docusign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/docusign',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["docusignConfig"] = $3ef1a4f2aa48071c$export$cee55280cabc1aa1;

});

parcelRegister("5epZa", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $b9d598d70efe7348$var$LazyDocusignIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9opws")).then((m)=>m.DocusignIcon), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/icon'
});

const $b9d598d70efe7348$var$LazyDocusignSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9opws")).then((m)=>m.DocusignSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/search-result-icon'
});

const $b9d598d70efe7348$var$LazyDocusignIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9opws")).then((m)=>m.DocusignIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/icon-borderless'
});
const $b9d598d70efe7348$export$393452da0e179bab = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9d598d70efe7348$var$LazyDocusignIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9d598d70efe7348$var$LazyDocusignIconComponent, null));
const $b9d598d70efe7348$export$4cdd065eb81c5a09 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9d598d70efe7348$var$LazyDocusignSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9d598d70efe7348$var$LazyDocusignSearchResultIconComponent, null));
const $b9d598d70efe7348$export$db2f9bd1f316d475 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9d598d70efe7348$var$LazyDocusignIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9d598d70efe7348$var$LazyDocusignIconBorderlessComponent, null));
module.exports["DocusignIcon"] = $b9d598d70efe7348$export$393452da0e179bab;
module.exports["DocusignSearchResultIcon"] = $b9d598d70efe7348$export$4cdd065eb81c5a09;
module.exports["DocusignIconBorderless"] = $b9d598d70efe7348$export$db2f9bd1f316d475;

});

parcelRegister("9opws", function(module, exports) {

let $6d6a272b9c482af5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6d6a272b9c482af5$var$load("6yRUF").then(()=>parcelRequire('fWZps'));

});

parcelRegister("59Q0u", function(module, exports) {

var $jgKBj = parcelRequire("jgKBj");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $bNslD = parcelRequire("bNslD");

const $0893df65d230b923$export$3cac442956139a7e = {
    displayName: 'Lucid',
    id: 'lucid',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Lucid,
    icon: (0, $fj6km.get3PLogo)((0, $bNslD.LucidIcon), 'Lucid', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $bNslD.LucidSearchResultIcon), 'Lucid', 'large'),
    integrationAri: 'ari:cloud:platform::integration/lucid',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $jgKBj.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["lucidConfig"] = $0893df65d230b923$export$3cac442956139a7e;

});

parcelRegister("bNslD", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $8591b9f5274558ba$var$LazyLucidIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("7cHD7")).then((m)=>m.LucidIcon), {
    moduleId: '@atlassian/rovo-connectors-config/lucid/icon'
});

const $8591b9f5274558ba$var$LazyLucidSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("7cHD7")).then((m)=>m.LucidSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/lucid/search-result-icon'
});
const $8591b9f5274558ba$export$8664694e1d7db2a0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8591b9f5274558ba$var$LazyLucidIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8591b9f5274558ba$var$LazyLucidIconComponent, null));
const $8591b9f5274558ba$export$6daa097ac5ffeb2c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8591b9f5274558ba$var$LazyLucidSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8591b9f5274558ba$var$LazyLucidSearchResultIconComponent, null));
module.exports["LucidIcon"] = $8591b9f5274558ba$export$8664694e1d7db2a0;
module.exports["LucidSearchResultIcon"] = $8591b9f5274558ba$export$6daa097ac5ffeb2c;

});

parcelRegister("7cHD7", function(module, exports) {

let $53eb7f6648c9524b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $53eb7f6648c9524b$var$load("h1wTP").then(()=>parcelRequire('gp3M4'));

});

parcelRegister("cQNOi", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $jHC7K = parcelRequire("jHC7K");

const $43f3f5d2a3723606$export$49283b8341865631 = {
    displayName: 'Monday',
    id: 'monday',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Monday,
    icon: (0, $fj6km.get3PLogo)((0, $jHC7K.MondayIcon), 'Monday', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $jHC7K.MondayIconBorderless), 'Monday', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $jHC7K.MondaySearchResultIcon), 'Monday', 'large'),
    integrationAri: 'ari:cloud:platform::integration/monday',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["mondayConfig"] = $43f3f5d2a3723606$export$49283b8341865631;

});

parcelRegister("jHC7K", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $3cc9cca217023989$var$LazyMondayIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("b7WqZ")).then((m)=>m.MondayIcon), {
    moduleId: '@atlassian/rovo-connectors-config/monday/icon'
});

const $3cc9cca217023989$var$LazyMondaySearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("b7WqZ")).then((m)=>m.MondaySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/monday/search-result-icon'
});

const $3cc9cca217023989$var$LazyMondayIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("b7WqZ")).then((m)=>m.MondayIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/monday/icon-borderless'
});
const $3cc9cca217023989$export$37b4104f63b2f4bd = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cc9cca217023989$var$LazyMondayIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cc9cca217023989$var$LazyMondayIconComponent, null));
const $3cc9cca217023989$export$bf10d2e61430fb53 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cc9cca217023989$var$LazyMondaySearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cc9cca217023989$var$LazyMondaySearchResultIconComponent, null));
const $3cc9cca217023989$export$43da0494a61d1337 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cc9cca217023989$var$LazyMondayIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3cc9cca217023989$var$LazyMondayIconBorderlessComponent, null));
module.exports["MondayIcon"] = $3cc9cca217023989$export$37b4104f63b2f4bd;
module.exports["MondaySearchResultIcon"] = $3cc9cca217023989$export$bf10d2e61430fb53;
module.exports["MondayIconBorderless"] = $3cc9cca217023989$export$43da0494a61d1337;

});

parcelRegister("b7WqZ", function(module, exports) {

let $819dacfbca0677cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $819dacfbca0677cb$var$load("3d4L1").then(()=>parcelRequire('l24nH'));

});

parcelRegister("69fjO", function(module, exports) {

var $1xTLA = parcelRequire("1xTLA");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $6RZzG = parcelRequire("6RZzG");

const $e7a648f21fd791f6$export$f324080d91cfb196 = {
    displayName: 'Azure DevOps',
    id: 'azure-devops',
    resourceType: (0, $78z3f.ProductResourceTypes3P).AzureDevops,
    icon: (0, $fj6km.get3PLogo)((0, $6RZzG.AzureDevopsIcon), 'AzureDevOps', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $6RZzG.AzureDevopsSearchResultIcon), 'AzureDevOps', 'large'),
    integrationAri: 'ari:cloud:platform::integration/azure-devops',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $1xTLA.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Repository
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["azureDevopsConfig"] = $e7a648f21fd791f6$export$f324080d91cfb196;

});

parcelRegister("bllsF", function(module, exports) {

var $1xTLA = parcelRequire("1xTLA");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $9AqRO = parcelRequire("9AqRO");

const $ce6211692e1e1116$export$72758f81cc2e21e1 = {
    displayName: 'Gitlab',
    id: 'gitlab',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Gitlab,
    icon: (0, $fj6km.get3PLogo)((0, $9AqRO.GitlabIcon), 'Gitlab', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $9AqRO.GitlabIconBorderless), 'Gitlab', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $9AqRO.GitlabSearchResultIcon), 'Gitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gitlab',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $1xTLA.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Repository,
                    (0, $dz5JF.NounSubtypeKey).Project
                ]
            }
        ]
    ]),
    filters: [
        'pullRequestStatus'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["gitlabConfig"] = $ce6211692e1e1116$export$72758f81cc2e21e1;

});

parcelRegister("1vkrr", function(module, exports) {

var $lAFHW = parcelRequire("lAFHW");


var $2pPu4 = parcelRequire("2pPu4");


var $cJRFO = parcelRequire("cJRFO");


var $4QUop = parcelRequire("4QUop");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");

const $250085dc5bf60419$export$3dab4b73b27a9d7e = {
    displayName: 'Confluence Data Center',
    id: 'confluence-dc',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ConfluenceDC,
    icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.ConfluenceIcon), 'Confluence Data Center'),
    searchResultIcon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.ConfluenceIcon), 'large'),
    integrationAri: 'ari:cloud:platform::integration/confluence-dc',
    typeFilterConfig: (()=>{
        const typeFilter = new Map([
            [
                (0, $dz5JF.TypeFilterValueKey).Space,
                {
                    entities3P: (0, $4QUop.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                    subTypes3P: [
                        (0, $dz5JF.NounSubtypeKey).Space
                    ]
                }
            ],
            [
                (0, $dz5JF.TypeFilterValueKey).Page,
                {
                    entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $dz5JF.NounSubtypeKey).Page
                    ]
                }
            ],
            [
                (0, $dz5JF.TypeFilterValueKey).Blogpost,
                {
                    entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $dz5JF.NounSubtypeKey).Blogpost
                    ]
                }
            ],
            [
                (0, $dz5JF.TypeFilterValueKey).Comment,
                {
                    entities3P: (0, $2pPu4.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                    subTypes3P: []
                }
            ],
            [
                (0, $dz5JF.TypeFilterValueKey).Attachment,
                {
                    entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    subTypes3P: [
                        (0, $dz5JF.NounSubtypeKey).Archive,
                        (0, $dz5JF.NounSubtypeKey).Audio,
                        (0, $dz5JF.NounSubtypeKey).Code,
                        (0, $dz5JF.NounSubtypeKey).Document,
                        (0, $dz5JF.NounSubtypeKey).Image,
                        (0, $dz5JF.NounSubtypeKey).Pdf,
                        (0, $dz5JF.NounSubtypeKey).Presentation,
                        (0, $dz5JF.NounSubtypeKey).Spreadsheet,
                        (0, $dz5JF.NounSubtypeKey).Video,
                        (0, $dz5JF.NounSubtypeKey).WebPage,
                        (0, $dz5JF.NounSubtypeKey).Other
                    ]
                }
            ]
        ]);
        return typeFilter;
    })(),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'createdBy',
        'content',
        'space',
        'label'
    ],
    requiresOauth: true,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["confluenceDCConfig"] = $250085dc5bf60419$export$3dab4b73b27a9d7e;

});

parcelRegister("4QUop", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $9bae9436830d46c0$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $9bae9436830d46c0$export$1e3b02869b42f77a;

});

parcelRegister("d0ffx", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $1hzI2 = parcelRequire("1hzI2");

const $c38a45484ce83fa8$export$75e56657ffc0207b = {
    displayName: 'Canva',
    id: 'canva',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Canva,
    icon: (0, $fj6km.get3PLogo)((0, $1hzI2.CanvaIcon), 'Canva', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $1hzI2.CanvaSearchResultIcon), 'Canva', 'large'),
    integrationAri: 'ari:cloud:platform::integration/canva',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Design,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["canvaConfig"] = $c38a45484ce83fa8$export$75e56657ffc0207b;

});

parcelRegister("1hzI2", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $891a8ce073beb4ad$var$LazyCanvaIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bBEqW")).then((m)=>m.CanvaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/canva/icon'
});

const $891a8ce073beb4ad$var$LazyCanvaSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bBEqW")).then((m)=>m.CanvaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/canva/search-result-icon'
});
const $891a8ce073beb4ad$export$3ad1ba1bf426d64a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($891a8ce073beb4ad$var$LazyCanvaIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($891a8ce073beb4ad$var$LazyCanvaIconComponent, null));
const $891a8ce073beb4ad$export$ac6bbd7ba99716e3 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($891a8ce073beb4ad$var$LazyCanvaSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($891a8ce073beb4ad$var$LazyCanvaSearchResultIconComponent, null));
module.exports["CanvaIcon"] = $891a8ce073beb4ad$export$3ad1ba1bf426d64a;
module.exports["CanvaSearchResultIcon"] = $891a8ce073beb4ad$export$ac6bbd7ba99716e3;

});

parcelRegister("bBEqW", function(module, exports) {

let $873283aac438199d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $873283aac438199d$var$load("20PZT").then(()=>parcelRequire('dWGdo'));

});

parcelRegister("jOAlg", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $dpYPt = parcelRequire("dpYPt");

const $a2d91f3e97b2f886$export$3e7603f097ea326e = {
    displayName: 'Box',
    id: 'box',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Box,
    icon: (0, $fj6km.get3PLogo)((0, $dpYPt.BoxIcon), 'Box', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $dpYPt.BoxSearchResultIcon), 'Box', 'large'),
    integrationAri: 'ari:cloud:platform::integration/box',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Document,
                    (0, $dz5JF.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["boxConfig"] = $a2d91f3e97b2f886$export$3e7603f097ea326e;

});

parcelRegister("dpYPt", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $0356018bace799db$var$LazyBoxIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("lkw6Y")).then((m)=>m.BoxIcon), {
    moduleId: '@atlassian/rovo-connectors-config/box/icon'
});

const $0356018bace799db$var$LazyBoxSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("lkw6Y")).then((m)=>m.BoxSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/box/search-result-icon'
});
const $0356018bace799db$export$adedf1569d7107de = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0356018bace799db$var$LazyBoxIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0356018bace799db$var$LazyBoxIconComponent, null));
const $0356018bace799db$export$f9ea3a56c013af54 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0356018bace799db$var$LazyBoxSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0356018bace799db$var$LazyBoxSearchResultIconComponent, null));
module.exports["BoxIcon"] = $0356018bace799db$export$adedf1569d7107de;
module.exports["BoxSearchResultIcon"] = $0356018bace799db$export$f9ea3a56c013af54;

});

parcelRegister("lkw6Y", function(module, exports) {

let $f8745fe69bcd1843$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f8745fe69bcd1843$var$load("8MuXj").then(()=>parcelRequire('gLPzH'));

});

parcelRegister("9t8gB", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $CzxO7 = parcelRequire("CzxO7");

const $92f957495d3d085b$export$d198c255b2b88327 = {
    displayName: 'Zeplin',
    id: 'zeplin',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Zeplin,
    icon: (0, $fj6km.get3PLogo)((0, $CzxO7.ZeplinIcon), 'Zeplin', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $CzxO7.ZeplinIconBorderless), 'Zeplin', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $CzxO7.ZeplinSearchResultIcon), 'Zeplin', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zeplin',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Design,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zeplinConfig"] = $92f957495d3d085b$export$d198c255b2b88327;

});

parcelRegister("CzxO7", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $781fe43a1dd12f7e$var$LazyZeplinIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("a7ggD")).then((m)=>m.ZeplinIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/icon'
});

const $781fe43a1dd12f7e$var$LazyZeplinSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("a7ggD")).then((m)=>m.ZeplinSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/search-result-icon'
});

const $781fe43a1dd12f7e$var$LazyZeplinIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("a7ggD")).then((m)=>m.ZeplinIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/icon-borderless'
});
const $781fe43a1dd12f7e$export$81c909fcf490b72b = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($781fe43a1dd12f7e$var$LazyZeplinIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($781fe43a1dd12f7e$var$LazyZeplinIconComponent, null));
const $781fe43a1dd12f7e$export$e3736b5ffc9fcc9e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($781fe43a1dd12f7e$var$LazyZeplinSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($781fe43a1dd12f7e$var$LazyZeplinSearchResultIconComponent, null));
const $781fe43a1dd12f7e$export$d013f8d99ccc63fb = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($781fe43a1dd12f7e$var$LazyZeplinIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($781fe43a1dd12f7e$var$LazyZeplinIconBorderlessComponent, null));
module.exports["ZeplinIcon"] = $781fe43a1dd12f7e$export$81c909fcf490b72b;
module.exports["ZeplinSearchResultIcon"] = $781fe43a1dd12f7e$export$e3736b5ffc9fcc9e;
module.exports["ZeplinIconBorderless"] = $781fe43a1dd12f7e$export$d013f8d99ccc63fb;

});

parcelRegister("a7ggD", function(module, exports) {

let $75d72d2bba1cdee0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $75d72d2bba1cdee0$var$load("cwZLu").then(()=>parcelRequire('euUb6'));

});

parcelRegister("hDzfU", function(module, exports) {

var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $2xkyh = parcelRequire("2xkyh");

const $7ac8fc6c8d29f085$export$8120804698f632ae = {
    displayName: 'Freshservice',
    id: 'freshservice',
    icon: (0, $fj6km.get3PLogo)((0, $2xkyh.FreshserviceIcon), 'Freshservice', 'medium'),
    resourceType: (0, $78z3f.ProductResourceTypes3P).Freshservice,
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $2xkyh.FreshserviceSearchResultIcon), 'Freshservice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/freshservice',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["freshserviceConfig"] = $7ac8fc6c8d29f085$export$8120804698f632ae;

});

parcelRegister("2xkyh", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $9ccea0b9ecee4e94$var$LazyFreshserviceIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("5Vupr")).then((m)=>m.FreshserviceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/freshservice/icon'
});

const $9ccea0b9ecee4e94$var$LazyFreshserviceSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("5Vupr")).then((m)=>m.FreshserviceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/freshservice/search-result-icon'
});
const $9ccea0b9ecee4e94$export$327de5bc0476c8b8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ccea0b9ecee4e94$var$LazyFreshserviceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ccea0b9ecee4e94$var$LazyFreshserviceIconComponent, null));
const $9ccea0b9ecee4e94$export$afb7a1d2b1e9186c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ccea0b9ecee4e94$var$LazyFreshserviceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ccea0b9ecee4e94$var$LazyFreshserviceSearchResultIconComponent, null));
module.exports["FreshserviceIcon"] = $9ccea0b9ecee4e94$export$327de5bc0476c8b8;
module.exports["FreshserviceSearchResultIcon"] = $9ccea0b9ecee4e94$export$afb7a1d2b1e9186c;

});

parcelRegister("5Vupr", function(module, exports) {

let $4509dd4cf726c8ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4509dd4cf726c8ff$var$load("f8kip").then(()=>parcelRequire('32NYZ'));

});

parcelRegister("65dnd", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $kSqiN = parcelRequire("kSqiN");

const $0fbb4bc7417ba4cc$export$b883b80d867cc715 = {
    displayName: 'PowerBI',
    id: 'power-bi',
    resourceType: (0, $78z3f.ProductResourceTypes3P).PowerBI,
    icon: (0, $fj6km.get3PLogo)((0, $kSqiN.PowerBIIcon), 'PowerBI', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $kSqiN.PowerBIIconBorderless), 'PowerBI', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $kSqiN.PowerBISearchResultIcon), 'PowerBI', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["powerBIConfig"] = $0fbb4bc7417ba4cc$export$b883b80d867cc715;

});

parcelRegister("kSqiN", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $db2c8e7254f68704$var$LazyPowerBIIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("kGyVh")).then((m)=>m.PowerBIIcon), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/icon'
});

const $db2c8e7254f68704$var$LazyPowerBISearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("kGyVh")).then((m)=>m.PowerBISearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/search-result-icon'
});

const $db2c8e7254f68704$var$LazyPowerBIIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("kGyVh")).then((m)=>m.PowerBIIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/icon-borderless'
});
const $db2c8e7254f68704$export$8a27e4cfebfdcb7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($db2c8e7254f68704$var$LazyPowerBIIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($db2c8e7254f68704$var$LazyPowerBIIconComponent, null));
const $db2c8e7254f68704$export$66bbf4ebbd8bb09 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($db2c8e7254f68704$var$LazyPowerBISearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($db2c8e7254f68704$var$LazyPowerBISearchResultIconComponent, null));
const $db2c8e7254f68704$export$77c3c6e8d16b3669 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($db2c8e7254f68704$var$LazyPowerBIIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($db2c8e7254f68704$var$LazyPowerBIIconBorderlessComponent, null));
module.exports["PowerBIIcon"] = $db2c8e7254f68704$export$8a27e4cfebfdcb7;
module.exports["PowerBISearchResultIcon"] = $db2c8e7254f68704$export$66bbf4ebbd8bb09;
module.exports["PowerBIIconBorderless"] = $db2c8e7254f68704$export$77c3c6e8d16b3669;

});

parcelRegister("kGyVh", function(module, exports) {

let $f0f2d1dbb13cba18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0f2d1dbb13cba18$var$load("3Yx87").then(()=>parcelRequire('aM27J'));

});

parcelRegister("bfMVn", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $5WfVv = parcelRequire("5WfVv");

const $b9f4a3107feee71c$export$7ef79ba9bf00ce19 = {
    displayName: 'ClickUp',
    id: 'clickup',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ClickUp,
    icon: (0, $fj6km.get3PLogo)((0, $5WfVv.ClickUpIcon), 'ClickUp', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $5WfVv.ClickUpIconBorderless), 'ClickUp', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $5WfVv.ClickUpSearchResultIcon), 'ClickUp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/clickup',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["clickUpConfig"] = $b9f4a3107feee71c$export$7ef79ba9bf00ce19;

});

parcelRegister("5WfVv", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $881b321825075a2a$var$LazyClickUpIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("fcnyo")).then((m)=>m.ClickUpIcon), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/icon'
});

const $881b321825075a2a$var$LazyClickUpSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("fcnyo")).then((m)=>m.ClickUpSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/search-result-icon'
});

const $881b321825075a2a$var$LazyClickUpIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("fcnyo")).then((m)=>m.ClickUpIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/icon-borderless'
});
const $881b321825075a2a$export$592b235c95c5fb2b = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($881b321825075a2a$var$LazyClickUpIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($881b321825075a2a$var$LazyClickUpIconComponent, null));
const $881b321825075a2a$export$7ca2508a62493599 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($881b321825075a2a$var$LazyClickUpSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($881b321825075a2a$var$LazyClickUpSearchResultIconComponent, null));
const $881b321825075a2a$export$d29fdfa1300ec8ae = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($881b321825075a2a$var$LazyClickUpIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($881b321825075a2a$var$LazyClickUpIconBorderlessComponent, null));
module.exports["ClickUpIcon"] = $881b321825075a2a$export$592b235c95c5fb2b;
module.exports["ClickUpSearchResultIcon"] = $881b321825075a2a$export$7ca2508a62493599;
module.exports["ClickUpIconBorderless"] = $881b321825075a2a$export$d29fdfa1300ec8ae;

});

parcelRegister("fcnyo", function(module, exports) {

let $b10a3f46f68c1ec8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b10a3f46f68c1ec8$var$load("24VRF").then(()=>parcelRequire('7U8Pk'));

});

parcelRegister("eS8nS", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $lB5Ra = parcelRequire("lB5Ra");

const $a92fdce586d632c6$export$a0702b571a9392d4 = {
    displayName: 'Amplitude',
    id: 'amplitude',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Amplitude,
    icon: (0, $fj6km.get3PLogo)((0, $lB5Ra.AmplitudeIcon), 'Amplitude', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $lB5Ra.AmplitudeSearchResultIcon), 'Amplitude', 'large'),
    integrationAri: 'ari:cloud:platform::integration/amplitude',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["amplitudeConfig"] = $a92fdce586d632c6$export$a0702b571a9392d4;

});

parcelRegister("lB5Ra", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $eefe0ae93729b9f0$var$LazyAmplitudeIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("ktjCS")).then((m)=>m.AmplitudeIcon), {
    moduleId: '@atlassian/rovo-connectors-config/amplitude/icon'
});

const $eefe0ae93729b9f0$var$LazyAmplitudeSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("ktjCS")).then((m)=>m.AmplitudeSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/amplitude/search-result-icon'
});
const $eefe0ae93729b9f0$export$5e013c7991ef7bd0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eefe0ae93729b9f0$var$LazyAmplitudeIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eefe0ae93729b9f0$var$LazyAmplitudeIconComponent, null));
const $eefe0ae93729b9f0$export$49b3130ea0e9d6dd = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eefe0ae93729b9f0$var$LazyAmplitudeSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eefe0ae93729b9f0$var$LazyAmplitudeSearchResultIconComponent, null));
module.exports["AmplitudeIcon"] = $eefe0ae93729b9f0$export$5e013c7991ef7bd0;
module.exports["AmplitudeSearchResultIcon"] = $eefe0ae93729b9f0$export$49b3130ea0e9d6dd;

});

parcelRegister("ktjCS", function(module, exports) {

let $ee75bd6b3acde27a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee75bd6b3acde27a$var$load("9FOfR").then(()=>parcelRequire('eaNOL'));

});

parcelRegister("77dhg", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $4RZuA = parcelRequire("4RZuA");

const $580fc7988ea60b4d$export$3be693d67bbce82 = {
    displayName: 'Stripe',
    id: 'stripe',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Stripe,
    icon: (0, $fj6km.get3PLogo)((0, $4RZuA.StripeIcon), 'Stripe', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $4RZuA.StripeSearchResultIcon), 'Stripe', 'large'),
    integrationAri: 'ari:cloud:platform::integration/stripe',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Invoice,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Invoice
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["stripeConfig"] = $580fc7988ea60b4d$export$3be693d67bbce82;

});

parcelRegister("4RZuA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $85d34eed5299b684$var$LazyStripeIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bMU7m")).then((m)=>m.StripeIcon), {
    moduleId: '@atlassian/rovo-connectors-config/stripe/icon'
});

const $85d34eed5299b684$var$LazyStripeSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bMU7m")).then((m)=>m.StripeSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/stripe/search-result-icon'
});
const $85d34eed5299b684$export$86ab8f6f2448222e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($85d34eed5299b684$var$LazyStripeIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($85d34eed5299b684$var$LazyStripeIconComponent, null));
const $85d34eed5299b684$export$efbbc3acb0731d93 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($85d34eed5299b684$var$LazyStripeSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($85d34eed5299b684$var$LazyStripeSearchResultIconComponent, null));
module.exports["StripeIcon"] = $85d34eed5299b684$export$86ab8f6f2448222e;
module.exports["StripeSearchResultIcon"] = $85d34eed5299b684$export$efbbc3acb0731d93;

});

parcelRegister("bMU7m", function(module, exports) {

let $0236f6890b239fbc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0236f6890b239fbc$var$load("dpvhg").then(()=>parcelRequire('eHt34'));

});

parcelRegister("bRTcz", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $cOmh8 = parcelRequire("cOmh8");

const $6697da7be5aaa929$export$e69f90b2aa757835 = {
    displayName: 'AdobeXD',
    id: 'adobexd',
    resourceType: (0, $78z3f.ProductResourceTypes3P).AdobeXD,
    icon: (0, $fj6km.get3PLogo)((0, $cOmh8.AdobeXDIcon), 'AdobeXD', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $cOmh8.AdobeXDSearchResultIcon), 'AdobeXD', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Design,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["adobeXDConfig"] = $6697da7be5aaa929$export$e69f90b2aa757835;

});

parcelRegister("cOmh8", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $862ecc0a05b2219e$var$LazyAdobeXDIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9Hem8")).then((m)=>m.AdobeXDIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-xd/icon'
});

const $862ecc0a05b2219e$var$LazyAdobeXDSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9Hem8")).then((m)=>m.AdobeXDSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-xd/search-result-icon'
});
const $862ecc0a05b2219e$export$be8cba599441db6e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($862ecc0a05b2219e$var$LazyAdobeXDIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($862ecc0a05b2219e$var$LazyAdobeXDIconComponent, null));
const $862ecc0a05b2219e$export$145a936ff16d9011 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($862ecc0a05b2219e$var$LazyAdobeXDSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($862ecc0a05b2219e$var$LazyAdobeXDSearchResultIconComponent, null));
module.exports["AdobeXDIcon"] = $862ecc0a05b2219e$export$be8cba599441db6e;
module.exports["AdobeXDSearchResultIcon"] = $862ecc0a05b2219e$export$145a936ff16d9011;

});

parcelRegister("9Hem8", function(module, exports) {

let $70f34403646f1850$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70f34403646f1850$var$load("ahENQ").then(()=>parcelRequire('d4fKG'));

});

parcelRegister("cBXDq", function(module, exports) {

var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $cikhY = parcelRequire("cikhY");

const $e98866fb5ae406ec$export$ad976bfe08240460 = {
    displayName: 'Aha',
    id: 'aha',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Aha,
    icon: (0, $fj6km.get3PLogo)((0, $cikhY.AhaIcon), 'Aha', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $cikhY.AhaSearchResultIcon), 'Aha', 'large'),
    integrationAri: 'ari:cloud:platform::integration/aha',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["ahaConfig"] = $e98866fb5ae406ec$export$ad976bfe08240460;

});

parcelRegister("cikhY", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $f41ab51bf76683b5$var$LazyAhaIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bpYED")).then((m)=>m.AhaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aha/icon'
});

const $f41ab51bf76683b5$var$LazyAhaSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bpYED")).then((m)=>m.AhaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aha/search-result-icon'
});
const $f41ab51bf76683b5$export$f28fe6c5ebff8c30 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f41ab51bf76683b5$var$LazyAhaIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f41ab51bf76683b5$var$LazyAhaIconComponent, null));
const $f41ab51bf76683b5$export$7dd76757b7d2d978 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f41ab51bf76683b5$var$LazyAhaSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f41ab51bf76683b5$var$LazyAhaSearchResultIconComponent, null));
module.exports["AhaIcon"] = $f41ab51bf76683b5$export$f28fe6c5ebff8c30;
module.exports["AhaSearchResultIcon"] = $f41ab51bf76683b5$export$7dd76757b7d2d978;

});

parcelRegister("bpYED", function(module, exports) {

let $8501142f50cb7a1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8501142f50cb7a1c$var$load("lFynN").then(()=>parcelRequire('kl7bx'));

});

parcelRegister("fWXSj", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $f7n0v = parcelRequire("f7n0v");

const $78b835bc11a3c908$export$8130889f372e8ca5 = {
    displayName: 'Adobe Sign',
    id: 'adobe-sign',
    resourceType: (0, $78z3f.ProductResourceTypes3P).AdobeSign,
    icon: (0, $fj6km.get3PLogo)((0, $f7n0v.AdobeSignIcon), 'Adobe Sign', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $f7n0v.AdobeSignSearchResultIcon), 'Adobe Sign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["adobeSignConfig"] = $78b835bc11a3c908$export$8130889f372e8ca5;

});

parcelRegister("f7n0v", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $4b5bc673679b7047$var$LazyAdobeSignIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("5ApQq")).then((m)=>m.AdobeSignIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-sign/icon'
});

const $4b5bc673679b7047$var$LazyAdobeSignSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("5ApQq")).then((m)=>m.AdobeSignSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-sign/search-result-icon'
});
const $4b5bc673679b7047$export$600af2172b0f5fb = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4b5bc673679b7047$var$LazyAdobeSignIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4b5bc673679b7047$var$LazyAdobeSignIconComponent, null));
const $4b5bc673679b7047$export$9efd1df023dc9339 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4b5bc673679b7047$var$LazyAdobeSignSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4b5bc673679b7047$var$LazyAdobeSignSearchResultIconComponent, null));
module.exports["AdobeSignIcon"] = $4b5bc673679b7047$export$600af2172b0f5fb;
module.exports["AdobeSignSearchResultIcon"] = $4b5bc673679b7047$export$9efd1df023dc9339;

});

parcelRegister("5ApQq", function(module, exports) {

let $41145cc05ce6340c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $41145cc05ce6340c$var$load("fH9Uo").then(()=>parcelRequire('2LgI6'));

});

parcelRegister("ay3nk", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $ki8Mf = parcelRequire("ki8Mf");

const $762853e64519e48a$export$8855f5ba0dd32fb9 = {
    displayName: 'Mural',
    id: 'mural',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Mural,
    icon: (0, $fj6km.get3PLogo)((0, $ki8Mf.MuralIcon), 'Mural', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $ki8Mf.MuralIconBorderless), 'Mural', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $ki8Mf.MuralSearchResultIcon), 'Mural', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mural',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Design,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["muralConfig"] = $762853e64519e48a$export$8855f5ba0dd32fb9;

});

parcelRegister("ki8Mf", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $072854c6b6eeefa2$var$LazyMuralIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bgQen")).then((m)=>m.MuralIcon), {
    moduleId: '@atlassian/rovo-connectors-config/mural/icon'
});

const $072854c6b6eeefa2$var$LazyMuralSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bgQen")).then((m)=>m.MuralSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/mural/search-result-icon'
});

const $072854c6b6eeefa2$var$LazyMuralIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bgQen")).then((m)=>m.MuralIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/mural/icon-borderless'
});
const $072854c6b6eeefa2$export$807a21e0dcf114c4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($072854c6b6eeefa2$var$LazyMuralIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($072854c6b6eeefa2$var$LazyMuralIconComponent, null));
const $072854c6b6eeefa2$export$930cc976c0fd31d6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($072854c6b6eeefa2$var$LazyMuralSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($072854c6b6eeefa2$var$LazyMuralSearchResultIconComponent, null));
const $072854c6b6eeefa2$export$f2b3c9d5e4a9191a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($072854c6b6eeefa2$var$LazyMuralIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($072854c6b6eeefa2$var$LazyMuralIconBorderlessComponent, null));
module.exports["MuralIcon"] = $072854c6b6eeefa2$export$807a21e0dcf114c4;
module.exports["MuralSearchResultIcon"] = $072854c6b6eeefa2$export$930cc976c0fd31d6;
module.exports["MuralIconBorderless"] = $072854c6b6eeefa2$export$f2b3c9d5e4a9191a;

});

parcelRegister("bgQen", function(module, exports) {

let $8349b44d8bf204e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8349b44d8bf204e2$var$load("aMukA").then(()=>parcelRequire('3XlA4'));

});

parcelRegister("kEEaa", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $lIG1B = parcelRequire("lIG1B");

const $88cb097868738757$export$57d2eef9725d4993 = {
    displayName: 'Webex',
    id: 'webex',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Webex,
    icon: (0, $fj6km.get3PLogo)((0, $lIG1B.WebexIcon), 'Webex', 'medium'),
    iconBorderless: (0, $fj6km.get3PLogo)((0, $lIG1B.WebexIconBorderless), 'Webex', 'small'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $lIG1B.WebexSearchResultIcon), 'Webex', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cisco',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Video,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["webexConfig"] = $88cb097868738757$export$57d2eef9725d4993;

});

parcelRegister("lIG1B", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $82ff035a54cf8c0e$var$LazyWebexIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("jKQh6")).then((m)=>m.WebexIcon), {
    moduleId: '@atlassian/rovo-connectors-config/webex/icon'
});

const $82ff035a54cf8c0e$var$LazyWebexSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("jKQh6")).then((m)=>m.WebexSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/webex/search-result-icon'
});

const $82ff035a54cf8c0e$var$LazyWebexIconBorderlessComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("jKQh6")).then((m)=>m.WebexIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/webex/icon-borderless'
});
const $82ff035a54cf8c0e$export$4079343fb47e7f0d = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82ff035a54cf8c0e$var$LazyWebexIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82ff035a54cf8c0e$var$LazyWebexIconComponent, null));
const $82ff035a54cf8c0e$export$37506c98e5c4eabb = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82ff035a54cf8c0e$var$LazyWebexSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82ff035a54cf8c0e$var$LazyWebexSearchResultIconComponent, null));
const $82ff035a54cf8c0e$export$92866e6fe777cbf9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82ff035a54cf8c0e$var$LazyWebexIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($82ff035a54cf8c0e$var$LazyWebexIconBorderlessComponent, null));
module.exports["WebexIcon"] = $82ff035a54cf8c0e$export$4079343fb47e7f0d;
module.exports["WebexSearchResultIcon"] = $82ff035a54cf8c0e$export$37506c98e5c4eabb;
module.exports["WebexIconBorderless"] = $82ff035a54cf8c0e$export$92866e6fe777cbf9;

});

parcelRegister("jKQh6", function(module, exports) {

let $e61adce51d860a8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e61adce51d860a8c$var$load("zuY6c").then(()=>parcelRequire('d78BK'));

});

parcelRegister("3OpIS", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $3vQuS = parcelRequire("3vQuS");

const $f8baba9657dc6ffd$export$2ece5664272d405b = {
    displayName: 'Todoist',
    id: 'todoist',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Todoist,
    icon: (0, $fj6km.get3PLogo)((0, $3vQuS.TodoistIcon), 'Todoist', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $3vQuS.TodoistSearchResultIcon), 'Todoist', 'large'),
    integrationAri: 'ari:cloud:platform::integration/todoist',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["todoistConfig"] = $f8baba9657dc6ffd$export$2ece5664272d405b;

});

parcelRegister("3vQuS", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $2dba89d5058d831f$var$LazyTodoistIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("1yovz")).then((m)=>m.TodoistIcon), {
    moduleId: '@atlassian/rovo-connectors-config/todoist/icon'
});

const $2dba89d5058d831f$var$LazyTodoistSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("1yovz")).then((m)=>m.TodoistSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/todoist/search-result-icon'
});
const $2dba89d5058d831f$export$e5f255e151507cba = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2dba89d5058d831f$var$LazyTodoistIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2dba89d5058d831f$var$LazyTodoistIconComponent, null));
const $2dba89d5058d831f$export$c7baa9df7dbe4b13 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2dba89d5058d831f$var$LazyTodoistSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2dba89d5058d831f$var$LazyTodoistSearchResultIconComponent, null));
module.exports["TodoistIcon"] = $2dba89d5058d831f$export$e5f255e151507cba;
module.exports["TodoistSearchResultIcon"] = $2dba89d5058d831f$export$c7baa9df7dbe4b13;

});

parcelRegister("1yovz", function(module, exports) {

let $121bfa3a7766bdcc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $121bfa3a7766bdcc$var$load("heav3").then(()=>parcelRequire('ipd5v'));

});

parcelRegister("ixnTR", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $1mGrl = parcelRequire("1mGrl");

const $399d917caac068ea$export$cc8a555111f14137 = {
    displayName: 'PagerDuty',
    id: 'pagerduty',
    resourceType: (0, $78z3f.ProductResourceTypes3P).PagerDuty,
    icon: (0, $fj6km.get3PLogo)((0, $1mGrl.PagerDutyIcon), 'PagerDuty', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $1mGrl.PagerDutySearchResultIcon), 'PagerDuty', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pagerduty',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["pagerDutyConfig"] = $399d917caac068ea$export$cc8a555111f14137;

});

parcelRegister("1mGrl", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $937d24ff37b6dd79$var$LazyPagerDutyIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hDrJx")).then((m)=>m.PagerDutyIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pagerduty/icon'
});

const $937d24ff37b6dd79$var$LazyPagerDutySearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hDrJx")).then((m)=>m.PagerDutySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pagerduty/search-result-icon'
});
const $937d24ff37b6dd79$export$e9a3fd43f9d4bddc = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($937d24ff37b6dd79$var$LazyPagerDutyIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($937d24ff37b6dd79$var$LazyPagerDutyIconComponent, null));
const $937d24ff37b6dd79$export$494d5ec19d75a736 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($937d24ff37b6dd79$var$LazyPagerDutySearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($937d24ff37b6dd79$var$LazyPagerDutySearchResultIconComponent, null));
module.exports["PagerDutyIcon"] = $937d24ff37b6dd79$export$e9a3fd43f9d4bddc;
module.exports["PagerDutySearchResultIcon"] = $937d24ff37b6dd79$export$494d5ec19d75a736;

});

parcelRegister("hDrJx", function(module, exports) {

let $03502fdcd8a07c09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03502fdcd8a07c09$var$load("49g6d").then(()=>parcelRequire('fWz8Q'));

});

parcelRegister("1FyJF", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $edAbJ = parcelRequire("edAbJ");

const $94f420de8207f737$export$9441b0ee1f92e710 = {
    displayName: 'Pipedrive',
    id: 'pipedrive',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Pipedrive,
    icon: (0, $fj6km.get3PLogo)((0, $edAbJ.PipedriveIcon), 'Pipedrive', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $edAbJ.PipedriveSearchResultIcon), 'Pipedrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pipedrive',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["pipedriveConfig"] = $94f420de8207f737$export$9441b0ee1f92e710;

});

parcelRegister("edAbJ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $5ba35916d082ca28$var$LazyPipedriveIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("fJpBS")).then((m)=>m.PipedriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pipedrive/icon'
});

const $5ba35916d082ca28$var$LazyPipedriveSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("fJpBS")).then((m)=>m.PipedriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pipedrive/search-result-icon'
});
const $5ba35916d082ca28$export$e66a8d6ac96d6ba1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ba35916d082ca28$var$LazyPipedriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ba35916d082ca28$var$LazyPipedriveIconComponent, null));
const $5ba35916d082ca28$export$18970dea61783916 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ba35916d082ca28$var$LazyPipedriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ba35916d082ca28$var$LazyPipedriveSearchResultIconComponent, null));
module.exports["PipedriveIcon"] = $5ba35916d082ca28$export$e66a8d6ac96d6ba1;
module.exports["PipedriveSearchResultIcon"] = $5ba35916d082ca28$export$18970dea61783916;

});

parcelRegister("fJpBS", function(module, exports) {

let $b73eec95054ccd34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b73eec95054ccd34$var$load("2kRJW").then(()=>parcelRequire('8FG4U'));

});

parcelRegister("8QURv", function(module, exports) {

var $jFuuN = parcelRequire("jFuuN");


var $j8txk = parcelRequire("j8txk");


var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $e2n32 = parcelRequire("e2n32");

const $c5eeda52c159eb28$export$ba5f4c654d743419 = {
    displayName: 'HubSpot',
    id: 'hubspot',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Hubspot,
    icon: (0, $fj6km.get3PLogo)((0, $e2n32.HubSpotFilterIcon), 'HubSpot', 'medium'),
    searchResultIcon: (0, $fj6km.RovoLogoFromGlyph)((0, $e2n32.HubSpotIcon), 'HubSpot'),
    integrationAri: 'ari:cloud:platform::integration/hubspot',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $jFuuN.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $j8txk.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'lastUpdatedBy',
        'createdBy'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["hubSpotConfig"] = $c5eeda52c159eb28$export$ba5f4c654d743419;

});

parcelRegister("jFuuN", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $6e80f623fe7c0736$export$8dd471de1c2be682 = [
    'ati:cloud:graph:customer-org'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI"] = $6e80f623fe7c0736$export$8dd471de1c2be682;

});

parcelRegister("j8txk", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $686b00cded736086$export$13c55dcee8605c46 = [
    'ati:cloud:graph:deal'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI"] = $686b00cded736086$export$13c55dcee8605c46;

});

parcelRegister("e2n32", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $626799ead3b40a65$var$LazyHubSpotFilterIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hs5KY")).then((m)=>m.HubSpotFilterIcon), {
    moduleId: '@atlassian/rovo-connectors-config/hubspot/icon'
});

const $626799ead3b40a65$var$LazyHubSpotIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hs5KY")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/hubspot/search-result-icon'
});
const $626799ead3b40a65$export$bee6964e6c60da93 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($626799ead3b40a65$var$LazyHubSpotFilterIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($626799ead3b40a65$var$LazyHubSpotFilterIconComponent, null));
const $626799ead3b40a65$export$c9a6a66ee7acc43a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($626799ead3b40a65$var$LazyHubSpotIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($626799ead3b40a65$var$LazyHubSpotIconComponent, null));
module.exports["HubSpotFilterIcon"] = $626799ead3b40a65$export$bee6964e6c60da93;
module.exports["HubSpotIcon"] = $626799ead3b40a65$export$c9a6a66ee7acc43a;

});

parcelRegister("hs5KY", function(module, exports) {

let $cb498457a5655371$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb498457a5655371$var$load("guH0W").then(()=>parcelRequire('asDHE'));

});

parcelRegister("gNXFU", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $KnRtx = parcelRequire("KnRtx");

const $874529fa12e86f99$export$74bb7abed969b4a3 = {
    displayName: 'Dovetail',
    id: 'dovetail',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Dovetail,
    icon: (0, $fj6km.get3PLogo)((0, $KnRtx.DovetailIcon), 'Dovetail', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $KnRtx.DovetailSearchResultIcon), 'Dovetail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dovetail',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dovetailConfig"] = $874529fa12e86f99$export$74bb7abed969b4a3;

});

parcelRegister("KnRtx", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $31c7000e379f74bf$var$LazyDovetailIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("ibURL")).then((m)=>m.DovetailIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dovetail/icon'
});

const $31c7000e379f74bf$var$LazyDovetailSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("ibURL")).then((m)=>m.DovetailSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dovetail/search-result-icon'
});
const $31c7000e379f74bf$export$e67ec9178da81ba8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($31c7000e379f74bf$var$LazyDovetailIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($31c7000e379f74bf$var$LazyDovetailIconComponent, null));
const $31c7000e379f74bf$export$ba101884e6c20332 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($31c7000e379f74bf$var$LazyDovetailSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($31c7000e379f74bf$var$LazyDovetailSearchResultIconComponent, null));
module.exports["DovetailIcon"] = $31c7000e379f74bf$export$e67ec9178da81ba8;
module.exports["DovetailSearchResultIcon"] = $31c7000e379f74bf$export$ba101884e6c20332;

});

parcelRegister("ibURL", function(module, exports) {

let $d3e55d7f0368f95d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d3e55d7f0368f95d$var$load("cRh0V").then(()=>parcelRequire('6KS0m'));

});

parcelRegister("eVtI3", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $1XM6O = parcelRequire("1XM6O");

const $70f4384492411f27$export$e45ddd51efe4cb0c = {
    displayName: 'LaunchDarkly',
    id: 'launchdarkly',
    resourceType: (0, $78z3f.ProductResourceTypes3P).LaunchDarkly,
    icon: (0, $fj6km.get3PLogo)((0, $1XM6O.LaunchDarklyIcon), 'LaunchDarkly', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $1XM6O.LaunchDarklySearchResultIcon), 'LaunchDarkly', 'large'),
    integrationAri: 'ari:cloud:platform::integration/launchdarkly',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["launchDarklyConfig"] = $70f4384492411f27$export$e45ddd51efe4cb0c;

});

parcelRegister("1XM6O", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $a77f2c3e09dc754d$var$LazyLaunchDarklyIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("jKY7S")).then((m)=>m.LaunchDarklyIcon), {
    moduleId: '@atlassian/rovo-connectors-config/launchdarkly/icon'
});

const $a77f2c3e09dc754d$var$LazyLaunchDarklySearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("jKY7S")).then((m)=>m.LaunchDarklySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/launchdarkly/search-result-icon'
});
const $a77f2c3e09dc754d$export$68470e68dec0bc46 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a77f2c3e09dc754d$var$LazyLaunchDarklyIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a77f2c3e09dc754d$var$LazyLaunchDarklyIconComponent, null));
const $a77f2c3e09dc754d$export$66f000bb4bcf5fcd = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a77f2c3e09dc754d$var$LazyLaunchDarklySearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a77f2c3e09dc754d$var$LazyLaunchDarklySearchResultIconComponent, null));
module.exports["LaunchDarklyIcon"] = $a77f2c3e09dc754d$export$68470e68dec0bc46;
module.exports["LaunchDarklySearchResultIcon"] = $a77f2c3e09dc754d$export$66f000bb4bcf5fcd;

});

parcelRegister("jKY7S", function(module, exports) {

let $e620f3fc55219b3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e620f3fc55219b3b$var$load("aX6AI").then(()=>parcelRequire('jGC06'));

});

parcelRegister("iQ0lV", function(module, exports) {

var $71WeF = parcelRequire("71WeF");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $dREkw = parcelRequire("dREkw");

const $eb2dd4e297ceea64$export$6c52693ff10aea16 = {
    displayName: 'Sentry',
    id: 'sentry',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Sentry,
    icon: (0, $fj6km.get3PLogo)((0, $dREkw.SentryIcon), 'Sentry', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $dREkw.SentrySearchResultIcon), 'Sentry', 'large'),
    integrationAri: 'ari:cloud:platform::integration/sentry',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $71WeF.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["sentryConfig"] = $eb2dd4e297ceea64$export$6c52693ff10aea16;

});

parcelRegister("dREkw", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $71e83087c18f65ae$var$LazySentryIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("2YqU1")).then((m)=>m.SentryIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sentry/icon'
});

const $71e83087c18f65ae$var$LazySentrySearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("2YqU1")).then((m)=>m.SentrySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sentry/search-result-icon'
});
const $71e83087c18f65ae$export$ddeafef64c08610e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($71e83087c18f65ae$var$LazySentryIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($71e83087c18f65ae$var$LazySentryIconComponent, null));
const $71e83087c18f65ae$export$18b7ca5aa35613ec = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($71e83087c18f65ae$var$LazySentrySearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($71e83087c18f65ae$var$LazySentrySearchResultIconComponent, null));
module.exports["SentryIcon"] = $71e83087c18f65ae$export$ddeafef64c08610e;
module.exports["SentrySearchResultIcon"] = $71e83087c18f65ae$export$18b7ca5aa35613ec;

});

parcelRegister("2YqU1", function(module, exports) {

let $22a60dad172c32b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $22a60dad172c32b4$var$load("ksfcb").then(()=>parcelRequire('bMIT6'));

});

parcelRegister("deCcX", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $6Fa33 = parcelRequire("6Fa33");

const $26665d8616f09f51$export$49c4b548f63d5a90 = {
    displayName: 'GitBook',
    id: 'gitbook',
    icon: (0, $fj6km.RovoLogoFromLogo)((0, $6Fa33.GitbookIcon), 'GitBook'),
    resourceType: (0, $78z3f.ProductResourceTypes3P).Gitbook,
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $6Fa33.GitbookSearchResultIcon), 'GitBook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    userNeedsOAuth: false,
    // This will only be enabled on the demo instance
    isEnabled: ()=>true
};
module.exports["gitbookConfig"] = $26665d8616f09f51$export$49c4b548f63d5a90;

});

parcelRegister("3MVdA", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $cMIAJ = parcelRequire("cMIAJ");

const $48a6447a2bcbb16a$export$7a257877f5f8c5de = {
    displayName: 'Amazon Web Services S3',
    id: 'aws-s3',
    icon: (0, $fj6km.RovoLogoFromLogo)((0, $cMIAJ.AWSS3Icon), 'Amazon Web Services S3'),
    resourceType: (0, $78z3f.ProductResourceTypes3P).AWSS3,
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $cMIAJ.AWSS3SearchResultIcon), 'Amazon Web Services S3', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    // Keeping this disabled for team demo. We only need GitBook enabled for demo.
    isEnabled: ()=>false
};
module.exports["awss3Config"] = $48a6447a2bcbb16a$export$7a257877f5f8c5de;

});

parcelRegister("cMIAJ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $f8224d14e0d2c218$var$LazyAWSS3IconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("7TjEM")).then((m)=>m.AWSS3Icon), {
    moduleId: '@atlassian/rovo-connectors-config/aws-s3/icon'
});

const $f8224d14e0d2c218$var$LazyAWSS3SearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("7TjEM")).then((m)=>m.AWSS3SearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aws-s3/search-result-icon'
});
const $f8224d14e0d2c218$export$abf71a44e930800c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8224d14e0d2c218$var$LazyAWSS3IconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8224d14e0d2c218$var$LazyAWSS3IconComponent, null));
const $f8224d14e0d2c218$export$30c777236008d219 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8224d14e0d2c218$var$LazyAWSS3SearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f8224d14e0d2c218$var$LazyAWSS3SearchResultIconComponent, null));
module.exports["AWSS3Icon"] = $f8224d14e0d2c218$export$abf71a44e930800c;
module.exports["AWSS3SearchResultIcon"] = $f8224d14e0d2c218$export$30c777236008d219;

});

parcelRegister("7TjEM", function(module, exports) {

let $5beceae479b30ea9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5beceae479b30ea9$var$load("iaSc3").then(()=>parcelRequire('6hNfS'));

});

parcelRegister("29M8h", function(module, exports) {

var $hEkrl = parcelRequire("hEkrl");


var $eiu0m = parcelRequire("eiu0m");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $dVNQT = parcelRequire("dVNQT");

const $f525cf75755683e8$export$a9b5a82aefd10fde = {
    displayName: 'Databricks',
    id: 'databricks',
    resourceType: (0, $78z3f.ProductResourceTypes3P).Databricks,
    icon: (0, $fj6km.get3PLogo)((0, $dVNQT.DatabricksIcon), 'Databricks', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $dVNQT.DatabricksSearchResultIcon), 'Databricks', 'large'),
    integrationAri: 'ari:cloud:platform::integration/databricks',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $hEkrl.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $eiu0m.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["databricksConfig"] = $f525cf75755683e8$export$a9b5a82aefd10fde;

});

parcelRegister("hEkrl", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $e725df1e1e005e82$export$5794851cbc8ee193 = [
    'ati:cloud:graph:dashboard'
];
module.exports["DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI"] = $e725df1e1e005e82$export$5794851cbc8ee193;

});

parcelRegister("eiu0m", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a6c1427b73e57501$export$f752f74515f17189 = [
    'ati:cloud:graph:data-table'
];
module.exports["DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI"] = $a6c1427b73e57501$export$f752f74515f17189;

});

parcelRegister("dVNQT", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $f11b96f51257b431$var$LazyDatabricksIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("fKGuT")).then((m)=>m.DatabricksIcon), {
    moduleId: '@atlassian/rovo-connectors-config/databricks/icon'
});

const $f11b96f51257b431$var$LazyDatabricksSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("fKGuT")).then((m)=>m.DatabricksSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/databricks/search-result-icon'
});
const $f11b96f51257b431$export$d86876f5e6aac5e0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f11b96f51257b431$var$LazyDatabricksIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f11b96f51257b431$var$LazyDatabricksIconComponent, null));
const $f11b96f51257b431$export$efd3770b613bb37b = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f11b96f51257b431$var$LazyDatabricksSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f11b96f51257b431$var$LazyDatabricksSearchResultIconComponent, null));
module.exports["DatabricksIcon"] = $f11b96f51257b431$export$d86876f5e6aac5e0;
module.exports["DatabricksSearchResultIcon"] = $f11b96f51257b431$export$efd3770b613bb37b;

});

parcelRegister("fKGuT", function(module, exports) {

let $b77c1dfde1943166$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b77c1dfde1943166$var$load("7aqAB").then(()=>parcelRequire('kWR84'));

});

parcelRegister("blmQP", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $6LgLy = parcelRequire("6LgLy");

const $7f0c66dcaa87128f$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgeAdamVitareqDev,
    icon: (0, $fj6km.get3PLogo)((0, $6LgLy.ForgeAdamVitareqIcon), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $6LgLy.ForgeAdamVitareqSearchResultIcon), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dAkghOClvWGokDftTTaIgNoD6pnNt74z',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeAdamVitareqConfig"] = $7f0c66dcaa87128f$export$208b563484d68ba9;

});

parcelRegister("6LgLy", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $11a5abe87c84e369$var$LazyForgeAdamVitareqIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("5ZYu4")).then((m)=>m.ForgeAdamVitareqIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-dev/icon'
});

const $11a5abe87c84e369$var$LazyForgeAdamVitareqSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("5ZYu4")).then((m)=>m.ForgeAdamVitareqSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-dev/search-result-icon'
});
const $11a5abe87c84e369$export$31bc4bf573db3488 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($11a5abe87c84e369$var$LazyForgeAdamVitareqIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($11a5abe87c84e369$var$LazyForgeAdamVitareqIconComponent, null));
const $11a5abe87c84e369$export$bd28886795da63ae = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($11a5abe87c84e369$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($11a5abe87c84e369$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
module.exports["ForgeAdamVitareqIcon"] = $11a5abe87c84e369$export$31bc4bf573db3488;
module.exports["ForgeAdamVitareqSearchResultIcon"] = $11a5abe87c84e369$export$bd28886795da63ae;

});

parcelRegister("5ZYu4", function(module, exports) {

let $45e191225e3e43cf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45e191225e3e43cf$var$load("hWLzx").then(()=>parcelRequire('4buHR'));

});

parcelRegister("2UKvr", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $b2YpC = parcelRequire("b2YpC");

const $55c0e8246341ee98$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgeAdamVitareqProd,
    icon: (0, $fj6km.get3PLogo)((0, $b2YpC.ForgeAdamVitareqIcon), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $b2YpC.ForgeAdamVitareqSearchResultIcon), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeAdamVitareqConfig"] = $55c0e8246341ee98$export$208b563484d68ba9;

});

parcelRegister("b2YpC", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $e5e233001054897e$var$LazyForgeAdamVitareqIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bhH1k")).then((m)=>m.ForgeAdamVitareqIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/icon'
});

const $e5e233001054897e$var$LazyForgeAdamVitareqSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bhH1k")).then((m)=>m.ForgeAdamVitareqSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/search-result-icon'
});
const $e5e233001054897e$export$31bc4bf573db3488 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e5e233001054897e$var$LazyForgeAdamVitareqIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e5e233001054897e$var$LazyForgeAdamVitareqIconComponent, null));
const $e5e233001054897e$export$bd28886795da63ae = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e5e233001054897e$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e5e233001054897e$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
module.exports["ForgeAdamVitareqIcon"] = $e5e233001054897e$export$31bc4bf573db3488;
module.exports["ForgeAdamVitareqSearchResultIcon"] = $e5e233001054897e$export$bd28886795da63ae;

});

parcelRegister("bhH1k", function(module, exports) {

let $8372a735a0efc92c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8372a735a0efc92c$var$load("kNVRr").then(()=>parcelRequire('e8tea'));

});

parcelRegister("hQVy3", function(module, exports) {

var $8akCo = parcelRequire("8akCo");


var $5InRj = parcelRequire("5InRj");


var $aWEgY = parcelRequire("aWEgY");


var $1xTLA = parcelRequire("1xTLA");


var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $bkQ4X = parcelRequire("bkQ4X");

const $e88ca667457ef65d$export$7fa480c37589b20 = {
    displayName: 'AWS by Pio',
    id: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioAwsDev,
    icon: (0, $fj6km.get3PLogo)((0, $bkQ4X.ForgePioAwsIcon), 'ForgePioAws', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $bkQ4X.ForgePioAwsSearchResultIcon), 'ForgePioAws', 'large'),
    integrationAri: 'ari:cloud:platform::integration/HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $1xTLA.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $aWEgY.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $8akCo.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $5InRj.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioAwsConfig"] = $e88ca667457ef65d$export$7fa480c37589b20;

});

parcelRegister("bkQ4X", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $6ca22321529f6757$var$LazyForgePioAwsIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("be4wz")).then((m)=>m.ForgePioAwsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-dev/icon'
});

const $6ca22321529f6757$var$LazyForgePioAwsSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("be4wz")).then((m)=>m.ForgePioAwsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-aws-dev/search-result-icon'
});
const $6ca22321529f6757$export$9a2f1d62325d249c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6ca22321529f6757$var$LazyForgePioAwsIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6ca22321529f6757$var$LazyForgePioAwsIconComponent, null));
const $6ca22321529f6757$export$e391bf4e4f614708 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6ca22321529f6757$var$LazyForgePioAwsSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6ca22321529f6757$var$LazyForgePioAwsSearchResultIconComponent, null));
module.exports["ForgePioAwsIcon"] = $6ca22321529f6757$export$9a2f1d62325d249c;
module.exports["ForgePioAwsSearchResultIcon"] = $6ca22321529f6757$export$e391bf4e4f614708;

});

parcelRegister("be4wz", function(module, exports) {

let $82c482f62d650559$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82c482f62d650559$var$load("iUY6X").then(()=>parcelRequire('9tWsm'));

});

parcelRegister("hOS5n", function(module, exports) {

var $2pPu4 = parcelRequire("2pPu4");


var $4QUop = parcelRequire("4QUop");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $4KwbY = parcelRequire("4KwbY");

const $26a58564b5989822$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioClickupDev,
    icon: (0, $fj6km.get3PLogo)((0, $4KwbY.ForgePioClickupIcon), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $4KwbY.ForgePioClickupSearchResultIcon), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $2pPu4.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Space,
            {
                entities3P: (0, $4QUop.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioClickupConfig"] = $26a58564b5989822$export$1e9db6975f6a70ae;

});

parcelRegister("4KwbY", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $33feca6450c81121$var$LazyForgePioClickupIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("aQ08c")).then((m)=>m.ForgePioClickupIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-dev/icon'
});

const $33feca6450c81121$var$LazyForgePioClickupSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("aQ08c")).then((m)=>m.ForgePioClickupSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-dev/search-result-icon'
});
const $33feca6450c81121$export$836fbefaf37221f1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($33feca6450c81121$var$LazyForgePioClickupIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($33feca6450c81121$var$LazyForgePioClickupIconComponent, null));
const $33feca6450c81121$export$83043b67e00ef5ec = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($33feca6450c81121$var$LazyForgePioClickupSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($33feca6450c81121$var$LazyForgePioClickupSearchResultIconComponent, null));
module.exports["ForgePioClickupIcon"] = $33feca6450c81121$export$836fbefaf37221f1;
module.exports["ForgePioClickupSearchResultIcon"] = $33feca6450c81121$export$83043b67e00ef5ec;

});

parcelRegister("aQ08c", function(module, exports) {

let $7e3edcc885abca56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7e3edcc885abca56$var$load("lE87W").then(()=>parcelRequire('dzPbV'));

});

parcelRegister("92bi2", function(module, exports) {

var $2pPu4 = parcelRequire("2pPu4");


var $4QUop = parcelRequire("4QUop");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $hARF2 = parcelRequire("hARF2");

const $790de390e43deabb$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioClickupProd,
    icon: (0, $fj6km.get3PLogo)((0, $hARF2.ForgePioClickupIcon), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $hARF2.ForgePioClickupSearchResultIcon), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $2pPu4.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Space,
            {
                entities3P: (0, $4QUop.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioClickupConfig"] = $790de390e43deabb$export$1e9db6975f6a70ae;

});

parcelRegister("hARF2", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $a0de4e7bed1d6a99$var$LazyForgePioClickupIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("i2XP6")).then((m)=>m.ForgePioClickupIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/icon'
});

const $a0de4e7bed1d6a99$var$LazyForgePioClickupSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("i2XP6")).then((m)=>m.ForgePioClickupSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/search-result-icon'
});
const $a0de4e7bed1d6a99$export$836fbefaf37221f1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a0de4e7bed1d6a99$var$LazyForgePioClickupIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a0de4e7bed1d6a99$var$LazyForgePioClickupIconComponent, null));
const $a0de4e7bed1d6a99$export$83043b67e00ef5ec = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a0de4e7bed1d6a99$var$LazyForgePioClickupSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a0de4e7bed1d6a99$var$LazyForgePioClickupSearchResultIconComponent, null));
module.exports["ForgePioClickupIcon"] = $a0de4e7bed1d6a99$export$836fbefaf37221f1;
module.exports["ForgePioClickupSearchResultIcon"] = $a0de4e7bed1d6a99$export$83043b67e00ef5ec;

});

parcelRegister("i2XP6", function(module, exports) {

let $d236d18c29e9730c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d236d18c29e9730c$var$load("8iatv").then(()=>parcelRequire('ci82W'));

});

parcelRegister("jxSYu", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $4QUop = parcelRequire("4QUop");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $8AM5T = parcelRequire("8AM5T");

const $2903a2bd450b1bf6$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioGitbookDev,
    icon: (0, $fj6km.get3PLogo)((0, $8AM5T.ForgePioGitbookIcon), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $8AM5T.ForgePioGitbookSearchResultIcon), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Space,
            {
                entities3P: (0, $4QUop.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitbookConfig"] = $2903a2bd450b1bf6$export$a10b5ae888bd2541;

});

parcelRegister("8AM5T", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $248833f365b80ae8$var$LazyForgePioGitbookIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("7PSdz")).then((m)=>m.ForgePioGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-dev/icon'
});

const $248833f365b80ae8$var$LazyForgePioGitbookSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("7PSdz")).then((m)=>m.ForgePioGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-dev/search-result-icon'
});
const $248833f365b80ae8$export$39f7ff8bf3e8ca0a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($248833f365b80ae8$var$LazyForgePioGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($248833f365b80ae8$var$LazyForgePioGitbookIconComponent, null));
const $248833f365b80ae8$export$6de477beffd11496 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($248833f365b80ae8$var$LazyForgePioGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($248833f365b80ae8$var$LazyForgePioGitbookSearchResultIconComponent, null));
module.exports["ForgePioGitbookIcon"] = $248833f365b80ae8$export$39f7ff8bf3e8ca0a;
module.exports["ForgePioGitbookSearchResultIcon"] = $248833f365b80ae8$export$6de477beffd11496;

});

parcelRegister("7PSdz", function(module, exports) {

let $5b475a571237d39d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5b475a571237d39d$var$load("3Dxy9").then(()=>parcelRequire('6FgjH'));

});

parcelRegister("8c1uN", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $4QUop = parcelRequire("4QUop");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $5LaWb = parcelRequire("5LaWb");

const $70fb34a254bf51f2$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioGitbookProd,
    icon: (0, $fj6km.get3PLogo)((0, $5LaWb.ForgePioGitbookIcon), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $5LaWb.ForgePioGitbookSearchResultIcon), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Space,
            {
                entities3P: (0, $4QUop.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitbookConfig"] = $70fb34a254bf51f2$export$a10b5ae888bd2541;

});

parcelRegister("5LaWb", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $23f9945c238baf79$var$LazyForgePioGitbookIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("kMhmB")).then((m)=>m.ForgePioGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/icon'
});

const $23f9945c238baf79$var$LazyForgePioGitbookSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("kMhmB")).then((m)=>m.ForgePioGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/search-result-icon'
});
const $23f9945c238baf79$export$39f7ff8bf3e8ca0a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23f9945c238baf79$var$LazyForgePioGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23f9945c238baf79$var$LazyForgePioGitbookIconComponent, null));
const $23f9945c238baf79$export$6de477beffd11496 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23f9945c238baf79$var$LazyForgePioGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23f9945c238baf79$var$LazyForgePioGitbookSearchResultIconComponent, null));
module.exports["ForgePioGitbookIcon"] = $23f9945c238baf79$export$39f7ff8bf3e8ca0a;
module.exports["ForgePioGitbookSearchResultIcon"] = $23f9945c238baf79$export$6de477beffd11496;

});

parcelRegister("kMhmB", function(module, exports) {

let $f205c2623bd5d44e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f205c2623bd5d44e$var$load("3ut9g").then(()=>parcelRequire('gNpVb'));

});

parcelRegister("ax3yU", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $kQuIn = parcelRequire("kQuIn");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $8VgKa = parcelRequire("8VgKa");

const $c7893b2bdebb95de$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioGoogleDriveDev,
    icon: (0, $fj6km.get3PLogo)((0, $8VgKa.ForgePioGoogleDriveIcon), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $8VgKa.ForgePioGoogleDriveSearchResultIcon), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Video,
            {
                entities3P: (0, $kQuIn.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGoogleDriveConfig"] = $c7893b2bdebb95de$export$7b3aebc675da1806;

});

parcelRegister("8VgKa", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $7c1a0656ac542389$var$LazyForgePioGoogleDriveIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9HiPZ")).then((m)=>m.ForgePioGoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/icon'
});

const $7c1a0656ac542389$var$LazyForgePioGoogleDriveSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9HiPZ")).then((m)=>m.ForgePioGoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/search-result-icon'
});
const $7c1a0656ac542389$export$a1f95679f652d1ae = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c1a0656ac542389$var$LazyForgePioGoogleDriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c1a0656ac542389$var$LazyForgePioGoogleDriveIconComponent, null));
const $7c1a0656ac542389$export$4bae7f77a341daa0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c1a0656ac542389$var$LazyForgePioGoogleDriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c1a0656ac542389$var$LazyForgePioGoogleDriveSearchResultIconComponent, null));
module.exports["ForgePioGoogleDriveIcon"] = $7c1a0656ac542389$export$a1f95679f652d1ae;
module.exports["ForgePioGoogleDriveSearchResultIcon"] = $7c1a0656ac542389$export$4bae7f77a341daa0;

});

parcelRegister("9HiPZ", function(module, exports) {

let $70f6bdf347b45ce4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $70f6bdf347b45ce4$var$load("5VX1d").then(()=>parcelRequire('bstHZ'));

});

parcelRegister("9pKRO", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $kQuIn = parcelRequire("kQuIn");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $1GLnz = parcelRequire("1GLnz");

const $f403457444b51179$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioGoogleDriveProd,
    icon: (0, $fj6km.get3PLogo)((0, $1GLnz.ForgePioGoogleDriveIcon), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $1GLnz.ForgePioGoogleDriveSearchResultIcon), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Video,
            {
                entities3P: (0, $kQuIn.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGoogleDriveConfig"] = $f403457444b51179$export$7b3aebc675da1806;

});

parcelRegister("1GLnz", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $9df102ce409f9a5c$var$LazyForgePioGoogleDriveIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hF8Vg")).then((m)=>m.ForgePioGoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/icon'
});

const $9df102ce409f9a5c$var$LazyForgePioGoogleDriveSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("hF8Vg")).then((m)=>m.ForgePioGoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/search-result-icon'
});
const $9df102ce409f9a5c$export$a1f95679f652d1ae = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9df102ce409f9a5c$var$LazyForgePioGoogleDriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9df102ce409f9a5c$var$LazyForgePioGoogleDriveIconComponent, null));
const $9df102ce409f9a5c$export$4bae7f77a341daa0 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9df102ce409f9a5c$var$LazyForgePioGoogleDriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9df102ce409f9a5c$var$LazyForgePioGoogleDriveSearchResultIconComponent, null));
module.exports["ForgePioGoogleDriveIcon"] = $9df102ce409f9a5c$export$a1f95679f652d1ae;
module.exports["ForgePioGoogleDriveSearchResultIcon"] = $9df102ce409f9a5c$export$4bae7f77a341daa0;

});

parcelRegister("hF8Vg", function(module, exports) {

let $cdbd2fdf4c75bfa1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cdbd2fdf4c75bfa1$var$load("kq1lL").then(()=>parcelRequire('9AOXX'));

});

parcelRegister("cwJDI", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $lHuO8 = parcelRequire("lHuO8");

const $89276ea9c7dd048b$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioGuruDev,
    icon: (0, $fj6km.get3PLogo)((0, $lHuO8.ForgePioGuruIcon), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $lHuO8.ForgePioGuruSearchResultIcon), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGuruConfig"] = $89276ea9c7dd048b$export$528a99587bc9b40e;

});

parcelRegister("lHuO8", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $0e5ea27169a60825$var$LazyForgePioGuruIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("gnF3q")).then((m)=>m.ForgePioGuruIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-dev/icon'
});

const $0e5ea27169a60825$var$LazyForgePioGuruSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("gnF3q")).then((m)=>m.ForgePioGuruSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-dev/search-result-icon'
});
const $0e5ea27169a60825$export$f1cafab080b3bd5c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e5ea27169a60825$var$LazyForgePioGuruIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e5ea27169a60825$var$LazyForgePioGuruIconComponent, null));
const $0e5ea27169a60825$export$b49ff31395265951 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e5ea27169a60825$var$LazyForgePioGuruSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e5ea27169a60825$var$LazyForgePioGuruSearchResultIconComponent, null));
module.exports["ForgePioGuruIcon"] = $0e5ea27169a60825$export$f1cafab080b3bd5c;
module.exports["ForgePioGuruSearchResultIcon"] = $0e5ea27169a60825$export$b49ff31395265951;

});

parcelRegister("gnF3q", function(module, exports) {

let $becea3dc3955f928$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $becea3dc3955f928$var$load("1p79O").then(()=>parcelRequire('eixxi'));

});

parcelRegister("4LVIl", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $8FIho = parcelRequire("8FIho");

const $1f37dfa9884c615e$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioGuruProd,
    icon: (0, $fj6km.get3PLogo)((0, $8FIho.ForgePioGuruIcon), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $8FIho.ForgePioGuruSearchResultIcon), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGuruConfig"] = $1f37dfa9884c615e$export$528a99587bc9b40e;

});

parcelRegister("8FIho", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $7155496d174abd0a$var$LazyForgePioGuruIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("isV37")).then((m)=>m.ForgePioGuruIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/icon'
});

const $7155496d174abd0a$var$LazyForgePioGuruSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("isV37")).then((m)=>m.ForgePioGuruSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/search-result-icon'
});
const $7155496d174abd0a$export$f1cafab080b3bd5c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7155496d174abd0a$var$LazyForgePioGuruIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7155496d174abd0a$var$LazyForgePioGuruIconComponent, null));
const $7155496d174abd0a$export$b49ff31395265951 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7155496d174abd0a$var$LazyForgePioGuruSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7155496d174abd0a$var$LazyForgePioGuruSearchResultIconComponent, null));
module.exports["ForgePioGuruIcon"] = $7155496d174abd0a$export$f1cafab080b3bd5c;
module.exports["ForgePioGuruSearchResultIcon"] = $7155496d174abd0a$export$b49ff31395265951;

});

parcelRegister("isV37", function(module, exports) {

let $d71718586a1c29eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d71718586a1c29eb$var$load("4jGEA").then(()=>parcelRequire('6jE2i'));

});

parcelRegister("h9iwl", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $gj6iG = parcelRequire("gj6iG");

const $779d1cec19911ccf$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioHelpjuiceDev,
    icon: (0, $fj6km.get3PLogo)((0, $gj6iG.ForgePioHelpjuiceIcon), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $gj6iG.ForgePioHelpjuiceSearchResultIcon), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHelpjuiceConfig"] = $779d1cec19911ccf$export$a612366ee7742bc4;

});

parcelRegister("gj6iG", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $36be4cd62f89ad83$var$LazyForgePioHelpjuiceIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("27Nxe")).then((m)=>m.ForgePioHelpjuiceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/icon'
});

const $36be4cd62f89ad83$var$LazyForgePioHelpjuiceSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("27Nxe")).then((m)=>m.ForgePioHelpjuiceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/search-result-icon'
});
const $36be4cd62f89ad83$export$7640ce31f2af22a2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36be4cd62f89ad83$var$LazyForgePioHelpjuiceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36be4cd62f89ad83$var$LazyForgePioHelpjuiceIconComponent, null));
const $36be4cd62f89ad83$export$2782a2dcd42b923c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36be4cd62f89ad83$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36be4cd62f89ad83$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
module.exports["ForgePioHelpjuiceIcon"] = $36be4cd62f89ad83$export$7640ce31f2af22a2;
module.exports["ForgePioHelpjuiceSearchResultIcon"] = $36be4cd62f89ad83$export$2782a2dcd42b923c;

});

parcelRegister("27Nxe", function(module, exports) {

let $18c2a8d16e5068ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18c2a8d16e5068ae$var$load("5pbTM").then(()=>parcelRequire('ctk3V'));

});

parcelRegister("5gYzJ", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $9M91Q = parcelRequire("9M91Q");

const $9cc4de8e207b9493$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioHelpjuiceProd,
    icon: (0, $fj6km.get3PLogo)((0, $9M91Q.ForgePioHelpjuiceIcon), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $9M91Q.ForgePioHelpjuiceSearchResultIcon), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHelpjuiceConfig"] = $9cc4de8e207b9493$export$a612366ee7742bc4;

});

parcelRegister("9M91Q", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $a6638c098a2784f2$var$LazyForgePioHelpjuiceIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bH5Lh")).then((m)=>m.ForgePioHelpjuiceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-prod/icon'
});

const $a6638c098a2784f2$var$LazyForgePioHelpjuiceSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bH5Lh")).then((m)=>m.ForgePioHelpjuiceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-prod/search-result-icon'
});
const $a6638c098a2784f2$export$7640ce31f2af22a2 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6638c098a2784f2$var$LazyForgePioHelpjuiceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6638c098a2784f2$var$LazyForgePioHelpjuiceIconComponent, null));
const $a6638c098a2784f2$export$2782a2dcd42b923c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6638c098a2784f2$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6638c098a2784f2$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
module.exports["ForgePioHelpjuiceIcon"] = $a6638c098a2784f2$export$7640ce31f2af22a2;
module.exports["ForgePioHelpjuiceSearchResultIcon"] = $a6638c098a2784f2$export$2782a2dcd42b923c;

});

parcelRegister("bH5Lh", function(module, exports) {

let $88382dfaf739c7a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88382dfaf739c7a7$var$load("crwjq").then(()=>parcelRequire('etYGW'));

});

parcelRegister("du9hX", function(module, exports) {

var $jFuuN = parcelRequire("jFuuN");


var $j8txk = parcelRequire("j8txk");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $2WOoC = parcelRequire("2WOoC");

const $58b8cf24e797f76f$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioHubspotDev,
    icon: (0, $fj6km.get3PLogo)((0, $2WOoC.ForgePioHubspotIcon), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $2WOoC.ForgePioHubspotSearchResultIcon), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $jFuuN.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $j8txk.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHubspotConfig"] = $58b8cf24e797f76f$export$2bb44bd2479444f9;

});

parcelRegister("2WOoC", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $755d6f8a6845bf71$var$LazyForgePioHubspotIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("1TxjG")).then((m)=>m.ForgePioHubspotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-dev/icon'
});

const $755d6f8a6845bf71$var$LazyForgePioHubspotSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("1TxjG")).then((m)=>m.ForgePioHubspotSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-dev/search-result-icon'
});
const $755d6f8a6845bf71$export$e87bb425fde16105 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($755d6f8a6845bf71$var$LazyForgePioHubspotIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($755d6f8a6845bf71$var$LazyForgePioHubspotIconComponent, null));
const $755d6f8a6845bf71$export$cc1026e3c5b549e1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($755d6f8a6845bf71$var$LazyForgePioHubspotSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($755d6f8a6845bf71$var$LazyForgePioHubspotSearchResultIconComponent, null));
module.exports["ForgePioHubspotIcon"] = $755d6f8a6845bf71$export$e87bb425fde16105;
module.exports["ForgePioHubspotSearchResultIcon"] = $755d6f8a6845bf71$export$cc1026e3c5b549e1;

});

parcelRegister("1TxjG", function(module, exports) {

let $1614c579766caa48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1614c579766caa48$var$load("iMU7p").then(()=>parcelRequire('1v9Nq'));

});

parcelRegister("do3W8", function(module, exports) {

var $jFuuN = parcelRequire("jFuuN");


var $j8txk = parcelRequire("j8txk");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $2uOaV = parcelRequire("2uOaV");

const $0105be5f83709f13$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioHubspotProd,
    icon: (0, $fj6km.get3PLogo)((0, $2uOaV.ForgePioHubspotIcon), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $2uOaV.ForgePioHubspotSearchResultIcon), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $jFuuN.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $j8txk.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHubspotConfig"] = $0105be5f83709f13$export$2bb44bd2479444f9;

});

parcelRegister("2uOaV", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $b60331cf0496569e$var$LazyForgePioHubspotIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("2gm36")).then((m)=>m.ForgePioHubspotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/icon'
});

const $b60331cf0496569e$var$LazyForgePioHubspotSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("2gm36")).then((m)=>m.ForgePioHubspotSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/search-result-icon'
});
const $b60331cf0496569e$export$e87bb425fde16105 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b60331cf0496569e$var$LazyForgePioHubspotIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b60331cf0496569e$var$LazyForgePioHubspotIconComponent, null));
const $b60331cf0496569e$export$cc1026e3c5b549e1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b60331cf0496569e$var$LazyForgePioHubspotSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b60331cf0496569e$var$LazyForgePioHubspotSearchResultIconComponent, null));
module.exports["ForgePioHubspotIcon"] = $b60331cf0496569e$export$e87bb425fde16105;
module.exports["ForgePioHubspotSearchResultIcon"] = $b60331cf0496569e$export$cc1026e3c5b549e1;

});

parcelRegister("2gm36", function(module, exports) {

let $1a5e2de5168e42f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a5e2de5168e42f0$var$load("5wAso").then(()=>parcelRequire('dscqI'));

});

parcelRegister("5Bb9f", function(module, exports) {

var $jFuuN = parcelRequire("jFuuN");


var $j8txk = parcelRequire("j8txk");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $fSjWv = parcelRequire("fSjWv");

const $ff5b05d55df74fa8$export$6ab686f8808b6986 = {
    displayName: 'Salesforce by Pio',
    id: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioSalesforceDev,
    icon: (0, $fj6km.get3PLogo)((0, $fSjWv.ForgePioSalesforceIcon), 'ForgePioSalesforce', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $fSjWv.ForgePioSalesforceSearchResultIcon), 'ForgePioSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $jFuuN.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $j8txk.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSalesforceConfig"] = $ff5b05d55df74fa8$export$6ab686f8808b6986;

});

parcelRegister("fSjWv", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $477219f1d1170e7a$var$LazyForgePioSalesforceIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("2Pc8D")).then((m)=>m.ForgePioSalesforceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-dev/icon'
});

const $477219f1d1170e7a$var$LazyForgePioSalesforceSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("2Pc8D")).then((m)=>m.ForgePioSalesforceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-dev/search-result-icon'
});
const $477219f1d1170e7a$export$fd669dbaab8ebe1e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($477219f1d1170e7a$var$LazyForgePioSalesforceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($477219f1d1170e7a$var$LazyForgePioSalesforceIconComponent, null));
const $477219f1d1170e7a$export$ebba99402341b0c4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($477219f1d1170e7a$var$LazyForgePioSalesforceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($477219f1d1170e7a$var$LazyForgePioSalesforceSearchResultIconComponent, null));
module.exports["ForgePioSalesforceIcon"] = $477219f1d1170e7a$export$fd669dbaab8ebe1e;
module.exports["ForgePioSalesforceSearchResultIcon"] = $477219f1d1170e7a$export$ebba99402341b0c4;

});

parcelRegister("2Pc8D", function(module, exports) {

let $20e9c29b243fd1bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20e9c29b243fd1bb$var$load("8lUSj").then(()=>parcelRequire('14MV1'));

});

parcelRegister("goA9n", function(module, exports) {

var $jFuuN = parcelRequire("jFuuN");


var $j8txk = parcelRequire("j8txk");


var $kLIW5 = parcelRequire("kLIW5");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $cQiqj = parcelRequire("cQiqj");

const $404108d23e7a287d$export$6ab686f8808b6986 = {
    displayName: 'Salesforce by Pio',
    id: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioSalesforceProd,
    icon: (0, $fj6km.get3PLogo)((0, $cQiqj.ForgePioSalesforceIcon), 'ForgePioSalesforce', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $cQiqj.ForgePioSalesforceSearchResultIcon), 'ForgePioSalesforce', 'large'),
    integrationAri: 'ari:cloud:platform::integration/nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kLIW5.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $jFuuN.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $j8txk.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSalesforceConfig"] = $404108d23e7a287d$export$6ab686f8808b6986;

});

parcelRegister("cQiqj", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $c170d2e5fb7b27ba$var$LazyForgePioSalesforceIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("heJIM")).then((m)=>m.ForgePioSalesforceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/icon'
});

const $c170d2e5fb7b27ba$var$LazyForgePioSalesforceSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("heJIM")).then((m)=>m.ForgePioSalesforceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/search-result-icon'
});
const $c170d2e5fb7b27ba$export$fd669dbaab8ebe1e = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c170d2e5fb7b27ba$var$LazyForgePioSalesforceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c170d2e5fb7b27ba$var$LazyForgePioSalesforceIconComponent, null));
const $c170d2e5fb7b27ba$export$ebba99402341b0c4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c170d2e5fb7b27ba$var$LazyForgePioSalesforceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c170d2e5fb7b27ba$var$LazyForgePioSalesforceSearchResultIconComponent, null));
module.exports["ForgePioSalesforceIcon"] = $c170d2e5fb7b27ba$export$fd669dbaab8ebe1e;
module.exports["ForgePioSalesforceSearchResultIcon"] = $c170d2e5fb7b27ba$export$ebba99402341b0c4;

});

parcelRegister("heJIM", function(module, exports) {

let $c8c735c5a03264f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8c735c5a03264f9$var$load("b4IO4").then(()=>parcelRequire('dbk7W'));

});

parcelRegister("73rhf", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $asxvZ = parcelRequire("asxvZ");

const $6d36f8650a7a5196$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioSharepointDev,
    icon: (0, $fj6km.get3PLogo)((0, $asxvZ.ForgePioSharepointIcon), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $asxvZ.ForgePioSharepointSearchResultIcon), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $dz5JF.NounSubtypeKey).Document,
                    (0, $dz5JF.NounSubtypeKey).Pdf
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSharepointConfig"] = $6d36f8650a7a5196$export$a62192356b6384ff;

});

parcelRegister("asxvZ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $7981e83737f12055$var$LazyForgePioSharepointIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("jv1v9")).then((m)=>m.ForgePioSharepointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/icon'
});

const $7981e83737f12055$var$LazyForgePioSharepointSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("jv1v9")).then((m)=>m.ForgePioSharepointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/search-result-icon'
});
const $7981e83737f12055$export$ecc35ba2a32c7e3f = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7981e83737f12055$var$LazyForgePioSharepointIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7981e83737f12055$var$LazyForgePioSharepointIconComponent, null));
const $7981e83737f12055$export$ff73eba88c3a5de7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7981e83737f12055$var$LazyForgePioSharepointSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7981e83737f12055$var$LazyForgePioSharepointSearchResultIconComponent, null));
module.exports["ForgePioSharepointIcon"] = $7981e83737f12055$export$ecc35ba2a32c7e3f;
module.exports["ForgePioSharepointSearchResultIcon"] = $7981e83737f12055$export$ff73eba88c3a5de7;

});

parcelRegister("jv1v9", function(module, exports) {

let $e32213baeb9b081f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e32213baeb9b081f$var$load("eppXj").then(()=>parcelRequire('f2sc3'));

});

parcelRegister("1IR6D", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $fu4tc = parcelRequire("fu4tc");

const $26c605b9c44f667c$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioSharepointProd,
    icon: (0, $fj6km.get3PLogo)((0, $fu4tc.ForgePioSharepointIcon), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $fu4tc.ForgePioSharepointSearchResultIcon), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSharepointConfig"] = $26c605b9c44f667c$export$a62192356b6384ff;

});

parcelRegister("fu4tc", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $66a101a6fb11cc88$var$LazyForgePioSharepointIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bWYXe")).then((m)=>m.ForgePioSharepointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/icon'
});

const $66a101a6fb11cc88$var$LazyForgePioSharepointSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("bWYXe")).then((m)=>m.ForgePioSharepointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/search-result-icon'
});
const $66a101a6fb11cc88$export$ecc35ba2a32c7e3f = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($66a101a6fb11cc88$var$LazyForgePioSharepointIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($66a101a6fb11cc88$var$LazyForgePioSharepointIconComponent, null));
const $66a101a6fb11cc88$export$ff73eba88c3a5de7 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($66a101a6fb11cc88$var$LazyForgePioSharepointSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($66a101a6fb11cc88$var$LazyForgePioSharepointSearchResultIconComponent, null));
module.exports["ForgePioSharepointIcon"] = $66a101a6fb11cc88$export$ecc35ba2a32c7e3f;
module.exports["ForgePioSharepointSearchResultIcon"] = $66a101a6fb11cc88$export$ff73eba88c3a5de7;

});

parcelRegister("bWYXe", function(module, exports) {

let $8b3464c75613c32e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8b3464c75613c32e$var$load("5cgcD").then(()=>parcelRequire('2Cm1j'));

});

parcelRegister("dY2MK", function(module, exports) {

var $2pPu4 = parcelRequire("2pPu4");


var $b7iDu = parcelRequire("b7iDu");


var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $2d67L = parcelRequire("2d67L");

const $5046c08cef44f976$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioStackOverflowDev,
    icon: (0, $fj6km.get3PLogo)((0, $2d67L.ForgePioStackOverflowIcon), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $2d67L.ForgePioStackOverflowSearchResultIcon), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $b7iDu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $2pPu4.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioStackOverflowConfig"] = $5046c08cef44f976$export$cc9a98fbdf14b1ba;

});

parcelRegister("2d67L", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $b46481c884b571c5$var$LazyForgePioStackOverflowIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("1jEky")).then((m)=>m.ForgePioStackOverflowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-dev/icon'
});

const $b46481c884b571c5$var$LazyForgePioStackOverflowSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("1jEky")).then((m)=>m.ForgePioStackOverflowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-dev/search-result-icon'
});
const $b46481c884b571c5$export$99bc27b78a6e71df = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b46481c884b571c5$var$LazyForgePioStackOverflowIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b46481c884b571c5$var$LazyForgePioStackOverflowIconComponent, null));
const $b46481c884b571c5$export$9a30339a9bdbd3d6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b46481c884b571c5$var$LazyForgePioStackOverflowSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b46481c884b571c5$var$LazyForgePioStackOverflowSearchResultIconComponent, null));
module.exports["ForgePioStackOverflowIcon"] = $b46481c884b571c5$export$99bc27b78a6e71df;
module.exports["ForgePioStackOverflowSearchResultIcon"] = $b46481c884b571c5$export$9a30339a9bdbd3d6;

});

parcelRegister("1jEky", function(module, exports) {

let $0f56d99419d5cc97$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f56d99419d5cc97$var$load("2jjBE").then(()=>parcelRequire('cAe90'));

});

parcelRegister("6IFfo", function(module, exports) {

var $2pPu4 = parcelRequire("2pPu4");


var $b7iDu = parcelRequire("b7iDu");


var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $iPfCJ = parcelRequire("iPfCJ");

const $cb54ece98fbc9eb0$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgePioStackOverflowProd,
    icon: (0, $fj6km.get3PLogo)((0, $iPfCJ.ForgePioStackOverflowIcon), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $iPfCJ.ForgePioStackOverflowSearchResultIcon), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $b7iDu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $dz5JF.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $2pPu4.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioStackOverflowConfig"] = $cb54ece98fbc9eb0$export$cc9a98fbdf14b1ba;

});

parcelRegister("iPfCJ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $a23c0825938fccc7$var$LazyForgePioStackOverflowIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("ht7sX")).then((m)=>m.ForgePioStackOverflowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/icon'
});

const $a23c0825938fccc7$var$LazyForgePioStackOverflowSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("ht7sX")).then((m)=>m.ForgePioStackOverflowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/search-result-icon'
});
const $a23c0825938fccc7$export$99bc27b78a6e71df = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a23c0825938fccc7$var$LazyForgePioStackOverflowIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a23c0825938fccc7$var$LazyForgePioStackOverflowIconComponent, null));
const $a23c0825938fccc7$export$9a30339a9bdbd3d6 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a23c0825938fccc7$var$LazyForgePioStackOverflowSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a23c0825938fccc7$var$LazyForgePioStackOverflowSearchResultIconComponent, null));
module.exports["ForgePioStackOverflowIcon"] = $a23c0825938fccc7$export$99bc27b78a6e71df;
module.exports["ForgePioStackOverflowSearchResultIcon"] = $a23c0825938fccc7$export$9a30339a9bdbd3d6;

});

parcelRegister("ht7sX", function(module, exports) {

let $cb7aefb3ae54e9f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb7aefb3ae54e9f3$var$load("gp3Gn").then(()=>parcelRequire('jHsl0'));

});

parcelRegister("djETu", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $f1FWc = parcelRequire("f1FWc");

const $9d8bbf7dc3b9afb0$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgeUtoolityGitbookDev,
    icon: (0, $fj6km.get3PLogo)((0, $f1FWc.ForgeUtoolityGitbookIcon), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $f1FWc.ForgeUtoolityGitbookSearchResultIcon), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUtoolityGitbookConfig"] = $9d8bbf7dc3b9afb0$export$1c8bdcf28097f33d;

});

parcelRegister("f1FWc", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $5985ce7e0ef09b5e$var$LazyForgeUtoolityGitbookIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("28R45")).then((m)=>m.ForgeUtoolityGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/icon'
});

const $5985ce7e0ef09b5e$var$LazyForgeUtoolityGitbookSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("28R45")).then((m)=>m.ForgeUtoolityGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/search-result-icon'
});
const $5985ce7e0ef09b5e$export$fc1920df99f3d560 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5985ce7e0ef09b5e$var$LazyForgeUtoolityGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5985ce7e0ef09b5e$var$LazyForgeUtoolityGitbookIconComponent, null));
const $5985ce7e0ef09b5e$export$41e46c9b83e3cfe1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5985ce7e0ef09b5e$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5985ce7e0ef09b5e$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
module.exports["ForgeUtoolityGitbookIcon"] = $5985ce7e0ef09b5e$export$fc1920df99f3d560;
module.exports["ForgeUtoolityGitbookSearchResultIcon"] = $5985ce7e0ef09b5e$export$41e46c9b83e3cfe1;

});

parcelRegister("28R45", function(module, exports) {

let $18f57db3e66dc1a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18f57db3e66dc1a7$var$load("4ZwN6").then(()=>parcelRequire('2ipVg'));

});

parcelRegister("4FjHU", function(module, exports) {

var $cJRFO = parcelRequire("cJRFO");


var $dz5JF = parcelRequire("dz5JF");


var $fj6km = parcelRequire("fj6km");


var $78z3f = parcelRequire("78z3f");


var $3D0JH = parcelRequire("3D0JH");

const $4dc1bf1bcec17c95$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    resourceType: (0, $78z3f.ProductResourceTypes3P).ForgeUtoolityGitbookProd,
    icon: (0, $fj6km.get3PLogo)((0, $3D0JH.ForgeUtoolityGitbookIcon), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $fj6km.get3PLogo)((0, $3D0JH.ForgeUtoolityGitbookSearchResultIcon), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL',
    typeFilterConfig: new Map([
        [
            (0, $dz5JF.TypeFilterValueKey).Document,
            {
                entities3P: (0, $cJRFO.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUtoolityGitbookConfig"] = $4dc1bf1bcec17c95$export$1c8bdcf28097f33d;

});

parcelRegister("3D0JH", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dQYck = parcelRequire("dQYck");


const $911ae7950a573b68$var$LazyForgeUtoolityGitbookIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9lJAx")).then((m)=>m.ForgeUtoolityGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-prod/icon'
});

const $911ae7950a573b68$var$LazyForgeUtoolityGitbookSearchResultIconComponent = (0, $dQYck.lazyForPaint)(()=>(parcelRequire("9lJAx")).then((m)=>m.ForgeUtoolityGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-prod/search-result-icon'
});
const $911ae7950a573b68$export$fc1920df99f3d560 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($911ae7950a573b68$var$LazyForgeUtoolityGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($911ae7950a573b68$var$LazyForgeUtoolityGitbookIconComponent, null));
const $911ae7950a573b68$export$41e46c9b83e3cfe1 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($911ae7950a573b68$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($911ae7950a573b68$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
module.exports["ForgeUtoolityGitbookIcon"] = $911ae7950a573b68$export$fc1920df99f3d560;
module.exports["ForgeUtoolityGitbookSearchResultIcon"] = $911ae7950a573b68$export$41e46c9b83e3cfe1;

});

parcelRegister("9lJAx", function(module, exports) {

let $6ce9701f7396637e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ce9701f7396637e$var$load("k02t9").then(()=>parcelRequire('bezcG'));

});

parcelRegister("5tnQQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8DN9t = parcelRequire("8DN9t");


var $kXb3C = parcelRequire("kXb3C");

const $a932c722f95653b7$var$CalendarObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function CalendarObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Calendar" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CalendarObject({ label: label = 'Calendar', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $a932c722f95653b7$export$2e2bcd8739ae039 = $a932c722f95653b7$var$CalendarObject;
module.exports["default"] = $a932c722f95653b7$export$2e2bcd8739ae039;

});

parcelRegister("6atSO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ci7Ox = parcelRequire("ci7Ox");


var $kXb3C = parcelRequire("kXb3C");

const $73b395c32a9c60f5$var$QuestionObject = (0, $4pOgL.isReactCompilerActivePlatform)() ? function QuestionObject(t0) {
    const $ = (0, $frIzR.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Question" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function QuestionObject({ label: label = 'Question', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $73b395c32a9c60f5$export$2e2bcd8739ae039 = $73b395c32a9c60f5$var$QuestionObject;
module.exports["default"] = $73b395c32a9c60f5$export$2e2bcd8739ae039;

});

parcelRegister("ksiqf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee44b6768ad41edb$export$2e2bcd8739ae039);

var $922yL = parcelRequire("922yL");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $ee44b6768ad41edb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $922yL.default)(dirtyDate, -amount);
}

});

parcelRegister("e1kiJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a350e81639ab5a88$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $922yL = parcelRequire("922yL");


var $b5utg = parcelRequire("b5utg");

function $a350e81639ab5a88$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $922yL.default)(dirtyDate, days);
}

});

parcelRegister("d6omw", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ebbba3827b0fa$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $989ebbba3827b0fa$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInMinute);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("6gF1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $49040fbe3dc0e481$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $e1kiJ = parcelRequire("e1kiJ");


var $b5utg = parcelRequire("b5utg");

function $49040fbe3dc0e481$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $e1kiJ.default)(dirtyDate, -amount);
}

});

parcelRegister("1NrSh", function(module, exports) {
const $49895188b0a86f3f$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $49895188b0a86f3f$export$d4fff2dfff3e2bc1;

});

parcelRegister("4bnNr", function(module, exports) {

var $hdvI3 = parcelRequire("hdvI3");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/project/manifest.ts
var $30baa5fc53208f94$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hdvI3.JiraProjectAriResourceOwner),
    resourceType: (0, $hdvI3.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $30baa5fc53208f94$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $30baa5fc53208f94$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $30baa5fc53208f94$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
};
module.exports["JiraProjectAri"] = $30baa5fc53208f94$export$75a0a0a7cb0a58ae;

});

parcelRegister("hdvI3", function(module, exports) {
// src/jira/project/types.ts
var $c88c3f6e5a62c5c4$export$99d538a3b04916b1 = "jira", $c88c3f6e5a62c5c4$export$736763838d3aa22e = "project";
module.exports["JiraProjectAriResourceOwner"] = $c88c3f6e5a62c5c4$export$99d538a3b04916b1;
module.exports["JiraProjectAriResourceType"] = $c88c3f6e5a62c5c4$export$736763838d3aa22e;

});

parcelRegister("jYxBx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $g58eM = parcelRequire("g58eM");

const $e8adb0147cc02fce$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getArtifact: null
});
function $e8adb0147cc02fce$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return new (0, $g58eM.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e8adb0147cc02fce$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $e8adb0147cc02fce$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($e8adb0147cc02fce$export$ca1b33377afa620);
function $e8adb0147cc02fce$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { getArtifact: getArtifact } = $e8adb0147cc02fce$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}
module.exports["FlightDeckProvider"] = $e8adb0147cc02fce$export$56da85ac9d40dbcd;
module.exports["useFlightDeckContext"] = $e8adb0147cc02fce$export$73c96350a5e69ec;
module.exports["useFlightDeckArtifact"] = $e8adb0147cc02fce$export$3b241cde208d2c5e;

});

parcelRegister("f6IRL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e4ce3568a939e12f8a5f474d8d813cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $affa380c4e32b374$var$_react = $affa380c4e32b374$var$_interopRequireDefault((parcelRequire("42omo")));

var $affa380c4e32b374$var$_baseNew = $affa380c4e32b374$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $affa380c4e32b374$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $affa380c4e32b374$var$RoadmapIcon = (props)=>/*#__PURE__*/ $affa380c4e32b374$var$_react.default.createElement($affa380c4e32b374$var$_baseNew.default, Object.assign({
        name: "RoadmapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$affa380c4e32b374$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $affa380c4e32b374$var$_default = module.exports.default = $affa380c4e32b374$var$RoadmapIcon;

});

parcelRegister("hbYDZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842815f2fb3ef87$var$_react = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("42omo")));

var $c842815f2fb3ef87$var$_baseNew = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c842815f2fb3ef87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c842815f2fb3ef87$var$SpacesIcon = (props)=>/*#__PURE__*/ $c842815f2fb3ef87$var$_react.default.createElement($c842815f2fb3ef87$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$c842815f2fb3ef87$var$SpacesIcon.displayName = 'SpacesIcon';
var $c842815f2fb3ef87$var$_default = module.exports.default = $c842815f2fb3ef87$var$SpacesIcon;

});

parcelRegister("eYwDk", function(module, exports) {
var $ffa07c7fa3bfd5e5$export$c90526da16c2eaaa = /*#__PURE__*/ function(SainAction) {
    SainAction["SOURCE_CLICKED"] = "sourceLinkClicked";
    SainAction["POSITIVE_FEEDBACK_PROVIDED"] = "positiveFeedbackProvided";
    SainAction["NEGATIVE_FEEDBACK_PROVIDED"] = "negativeFeedbackProvided";
    SainAction["DWELL_REACHED"] = "dwellTimeReached";
    SainAction["COPY_CLICKED"] = "copyButtonClicked";
    SainAction["FOLLOWUP_CLICKED"] = "followupLinkClicked";
    SainAction["ERROR_STATE_SUGGESTED_QUERY_CLICKED"] = "errorStateSuggestedQueryClicked";
    SainAction["OPEN_CHAT_CLICKED"] = "openChatButtonClicked";
    SainAction["EXPAND_CLICKED"] = "expandButtonClicked";
    SainAction["READ_MORE_BUTTON_CLICKED"] = "readMoreButtonClicked";
    SainAction["TOPIC_CLICKED"] = "topicClicked";
    SainAction["RECENT_WORK_CLICKED"] = "recentWorkClicked";
    SainAction["COLLABORATOR_CLICKED"] = "collaboratorClicked";
    SainAction["VIEW_PROFILE_CLICKED"] = "viewProfileClicked";
    SainAction["TEAM_MEMBER_CLICKED"] = "teamMemberClicked";
    SainAction["TEAM_LIST_CLICKED"] = "teamListClicked";
    SainAction["TEAM_LIST_ITEM_CLICKED"] = "teamListItemClicked";
    SainAction["VIEW_TEAM_PAGE_CLICKED"] = "viewTeamPageClicked";
    SainAction["REPORTING_LINES_CLICKED"] = "reportingLinesClicked";
    SainAction["PERSON_SELECTED"] = "cardClicked";
    SainAction["BOOKMARK_CLICKED"] = "bookmarkClicked";
    SainAction["CHAT_CLICKED"] = "chatClicked";
    SainAction["JIRA_ISSUE_CLICKED"] = "jiraIssueCardClicked";
    SainAction["VIEW_ALL_SOURCES"] = "viewAllSourcesClicked";
    SainAction["JIRA_NL_TO_JQL_CLICKED"] = "jiraNlToJqlCardClicked";
    SainAction["JIRA_NL_TO_JQL_VIEW_ALL"] = "viewAllButtonClicked";
    SainAction["JIRA_NL_TO_JQL_WORK_ITEM_CLICKED"] = "workItemClicked";
    SainAction["SHOW_ON_GOOGLE_MAPS_CLICKED"] = "showOnGoogleMapsClicked";
    SainAction["TOPIC_KNOWLEDGE_CARD_CLICKED"] = "topicKnowledgeCardClicked";
    SainAction["NAVIGATIONAL_SEARCH_RESULT_CARD"] = "navigationalSearchResultCardClicked";
    SainAction["FMP_DWELL_START"] = "fmpDwellStart";
    SainAction["FMP_DWELL_START_EXPANDED"] = "fmpDwellStartExpanded";
    SainAction["FMP_DWELL_REACHED"] = "fmpDwellReached";
    SainAction["FMP_RESULT_EXITED"] = "fmpDwellExited";
    SainAction["AI_MODE_FOLLOWUP_CLICKED"] = "aiModeFollowupLinkClicked";
    SainAction["SHOW_MORE_TOPICS_CLICKED"] = "showMoreTopicsClicked";
    SainAction["DEFINITION_DWELL_MARKED"] = "definitionDwellMarked";
    SainAction["BLUE_LINK_CLICKED"] = "blueLinkClicked";
    SainAction["THIRD_PARTY_MESSAGE_CLICKED"] = "thirdPartyMessageClicked";
    return SainAction;
}({});
module.exports["SainAction"] = $ffa07c7fa3bfd5e5$export$c90526da16c2eaaa;

});

parcelRegister("4jIuc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $fYQcF = parcelRequire("fYQcF");


var $cqFuK = parcelRequire("cqFuK");


var $hD9R7 = parcelRequire("hD9R7");


var $eYwDk = parcelRequire("eYwDk");

const $e3c814adee511225$export$a0cb7cf9977bca78 = 3000;
const $e3c814adee511225$export$bf85f2c6a4e29d4e = ()=>{
    const { trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)();
    // eslint-disable-next-line @atlaskit/platform/ensure-use-sync-external-store-server-snapshot
    (0, $42omo.useSyncExternalStore)((0, $hD9R7.subscribe), (0, $hD9R7.getSnapshot));
    const fireSAINUsageEvent = (0, $42omo.useCallback)(({ metCriteria: metCriteria, dwellTime: dwellTime, commonAttributes: commonAttributes, sourceProduct: sourceProduct })=>{
        const sanitizedCommonAttributes = commonAttributes ? (0, $cqFuK.filterCommonAttributes)(commonAttributes) : {};
        // Handle FMP dwell cases - fire initial event with doesNotMeetMAUCriteria = true
        if (metCriteria === (0, $eYwDk.SainAction).FMP_DWELL_START || metCriteria === (0, $eYwDk.SainAction).FMP_DWELL_START_EXPANDED) {
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    mauEligibilityCriteria: metCriteria,
                    met_fmp_criteria: false,
                    sourceProduct: sourceProduct,
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria === (0, $eYwDk.SainAction).FMP_DWELL_REACHED) {
            // If dwell time reaches threshold, fire second event (could eventually count as usage criteria)
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    dwellTime: dwellTime,
                    mauEligibilityCriteria: metCriteria,
                    met_fmp_criteria: true,
                    sourceProduct: sourceProduct,
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria === (0, $eYwDk.SainAction).DEFINITION_DWELL_MARKED) {
            // If dwell time reaches threshold, fire second event (could eventually count as usage criteria)
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    dwellTime: dwellTime,
                    sourceProduct: sourceProduct,
                    aiDwellTimeMilliSeconds: dwellTime,
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria === (0, $eYwDk.SainAction).FMP_RESULT_EXITED) {
            trackAIResultView({
                doesNotMeetMAUCriteria: true,
                attributes: {
                    action: metCriteria,
                    dwellTime: dwellTime,
                    sourceProduct: sourceProduct,
                    trackingMethod: 'fmp',
                    ...sanitizedCommonAttributes
                }
            });
            return;
        }
        if (metCriteria) {
            // If usage criteria are provided, emit a viewed event with doesNotMeetMAUCriteria set to false
            // only once per SAIN request
            const requestId = commonAttributes?.extraAttributes?.requestId;
            const doesNotMeetMAUCriteria = (0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? requestId ? (0, $hD9R7.getSnapshot)().has(requestId) : true // new behavior: need a requestId to meet MAU criteria to ensure only one MAU-met event is fired
             : false; // old behavior: always met MAU criteria
            trackAIResultView({
                doesNotMeetMAUCriteria: doesNotMeetMAUCriteria,
                attributes: {
                    dwellTime: dwellTime || 0,
                    mauEligibilityCriteria: metCriteria,
                    sourceProduct: sourceProduct,
                    ...sanitizedCommonAttributes
                }
            });
            if (!doesNotMeetMAUCriteria) (0, $hD9R7.markFired)(requestId);
            // In addition, emit an action/feedback event for the action that was met
            // (https://hello.atlassian.net/wiki/x/Vxb5DAE)
            switch(metCriteria){
                case (0, $eYwDk.SainAction).SOURCE_CLICKED:
                case (0, $eYwDk.SainAction).COPY_CLICKED:
                case (0, $eYwDk.SainAction).FOLLOWUP_CLICKED:
                case (0, $eYwDk.SainAction).TOPIC_CLICKED:
                case (0, $eYwDk.SainAction).RECENT_WORK_CLICKED:
                case (0, $eYwDk.SainAction).COLLABORATOR_CLICKED:
                case (0, $eYwDk.SainAction).VIEW_PROFILE_CLICKED:
                case (0, $eYwDk.SainAction).TEAM_MEMBER_CLICKED:
                case (0, $eYwDk.SainAction).VIEW_TEAM_PAGE_CLICKED:
                case (0, $eYwDk.SainAction).OPEN_CHAT_CLICKED:
                case (0, $eYwDk.SainAction).JIRA_NL_TO_JQL_VIEW_ALL:
                case (0, $eYwDk.SainAction).JIRA_NL_TO_JQL_WORK_ITEM_CLICKED:
                case (0, $eYwDk.SainAction).VIEW_ALL_SOURCES:
                case (0, $eYwDk.SainAction).BLUE_LINK_CLICKED:
                    trackAIResultAction(metCriteria, {
                        attributes: {
                            dwellTime: dwellTime,
                            sourceProduct: sourceProduct,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case (0, $eYwDk.SainAction).POSITIVE_FEEDBACK_PROVIDED:
                    trackAIFeedbackSubmit('up', {
                        attributes: {
                            dwellTime: dwellTime,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case (0, $eYwDk.SainAction).NEGATIVE_FEEDBACK_PROVIDED:
                    trackAIFeedbackSubmit('down', {
                        attributes: {
                            dwellTime: dwellTime,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                case (0, $eYwDk.SainAction).AI_MODE_FOLLOWUP_CLICKED:
                    trackAIResultAction(metCriteria, {
                        attributes: {
                            dwellTime: dwellTime,
                            sourceProduct: sourceProduct,
                            ...sanitizedCommonAttributes
                        }
                    });
                    break;
                default:
                    break;
            }
        } else // If no usage criteria are provided, emit a viewed event with doesNotMeetMAUCriteria set to true
        trackAIResultView({
            doesNotMeetMAUCriteria: true,
            attributes: {
                dwellTime: dwellTime || 0,
                ...sanitizedCommonAttributes
            }
        });
    }, [
        trackAIResultView,
        trackAIResultAction,
        trackAIFeedbackSubmit
    ]);
    return {
        fireSAINUsageEvent: fireSAINUsageEvent
    };
};
module.exports["SAIN_USAGE_DWELL_THRESHOLD"] = $e3c814adee511225$export$a0cb7cf9977bca78;
module.exports["useSAINUsageCriteriaMet"] = $e3c814adee511225$export$bf85f2c6a4e29d4e;

});

parcelRegister("hD9R7", function(module, exports) {
const $0da47c79169ae622$var$sainUsageEventStore = new Map();
const $0da47c79169ae622$var$MAX_EVENTS = 10;
// React listeners for useSyncExternalStore
const $0da47c79169ae622$var$listeners = new Set();
function $0da47c79169ae622$var$emitChange() {
    $0da47c79169ae622$var$listeners.forEach((listener)=>listener());
}
function $0da47c79169ae622$export$ec068583843480e7(listener) {
    $0da47c79169ae622$var$listeners.add(listener);
    return ()=>$0da47c79169ae622$var$listeners.delete(listener);
}
function $0da47c79169ae622$export$ab60d92959c37070() {
    return $0da47c79169ae622$var$sainUsageEventStore;
}
function $0da47c79169ae622$export$66247cb47ecd9c1b(requestId) {
    if (!$0da47c79169ae622$var$sainUsageEventStore.has(requestId)) {
        $0da47c79169ae622$var$sainUsageEventStore.set(requestId, true);
        if ($0da47c79169ae622$var$sainUsageEventStore.size > $0da47c79169ae622$var$MAX_EVENTS) {
            const oldestKey = $0da47c79169ae622$var$sainUsageEventStore.keys().next().value;
            if (oldestKey) $0da47c79169ae622$var$sainUsageEventStore.delete(oldestKey);
        }
        $0da47c79169ae622$var$emitChange();
    }
}
module.exports["subscribe"] = $0da47c79169ae622$export$ec068583843480e7;
module.exports["getSnapshot"] = $0da47c79169ae622$export$ab60d92959c37070;
module.exports["markFired"] = $0da47c79169ae622$export$66247cb47ecd9c1b;

});

parcelRegister("aZJLt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $bg4YX = parcelRequire("bg4YX");


var $7DA0P = parcelRequire("7DA0P");


var $9hKJg = parcelRequire("9hKJg");


var $dzXvj = parcelRequire("dzXvj");


var $4Zqgi = parcelRequire("4Zqgi");


var $f7lNm = parcelRequire("f7lNm");


var $6M0KD = parcelRequire("6M0KD");


var $6bBOi = parcelRequire("6bBOi");

const $79c55f47bdc0a8b7$var$styles = {
    root: "_zulpu2gc _1e0c1txw _2lx21bp4 _4cvr1y6m",
    readingAids: "_11c81d4k _ca0qutpp _u5f31ejb _n3tdutpp _19bv1ejb _syaz1tmo _p12fr5sb _c71luuw1 _18m91wug",
    nonReadingAids: "_11c8fhey _ca0qv47k _u5f31ejb _n3tdv47k _19bv1ejb _syaz1sqi _c71lq06n _18m91wug _1bsb1osq"
};
const $79c55f47bdc0a8b7$export$e926676385687eaf = ({ isReadingAids: isReadingAids, wrapper: wrapper, source: source, cloudId: cloudId, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const DefaultWrapper = isReadingAids ? (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dzXvj.ReadingAidsPopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hKJg.ReadingAidsContainer), null, props.children)) : (0, $7DA0P.SearchDialog);
    const Wrapper = wrapper ? wrapper : DefaultWrapper;
    const logError = (0, $42omo.useCallback)((error)=>{
        // Currently we are in between deprecating UFOv1 and adopting react-UFO  for platform packages, so this is a temporary way for us to collect error logs
        // https://atlassian.slack.com/archives/C01AY8132S3/p1716509785878689
        const errorAttributes = {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack?.split('\n').at(1),
            isHello: (0, $6M0KD.isHello)(cloudId)
        };
        createAnalyticsEvent({
            action: 'failed',
            actionSubject: 'aiAnswerDialog',
            source: source || 'unknown',
            eventType: 'track',
            attributes: errorAttributes
        }).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
        (0, $4Zqgi.logger).error({
            error: errorAttributes,
            functionName: 'ErrorBoundary: Depricated'
        });
    }, [
        source,
        createAnalyticsEvent,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bg4YX.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($79c55f47bdc0a8b7$var$styles.root, isReadingAids ? $79c55f47bdc0a8b7$var$styles.root : $79c55f47bdc0a8b7$var$styles.readingAids)
        }, formatMessage((0, $6bBOi.messages).error_boundary_fallback_text))),
        onException: logError
    }, children);
};
module.exports["ErrorBoundary"] = $79c55f47bdc0a8b7$export$e926676385687eaf;

});

parcelRegister("bg4YX", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $42omo = parcelRequire("42omo");

class $e585c5dc5dea28e7$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onException(error);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    componentWillUnmount() {
        if (this.props.setErrorBoundaryResetCb) this.props.setErrorBoundaryResetCb(undefined);
    }
    render() {
        const { renderWithErrorInfo: RenderWithErrorInfo } = this.props;
        if (RenderWithErrorInfo && this.state.error && this.state.errorInfo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RenderWithErrorInfo, {
            error: this.state.error,
            errorInfo: this.state.errorInfo
        });
        if (this.state.error) return this.props.fallback !== undefined ? this.props.fallback : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = ()=>{
            this.setState({
                error: undefined,
                errorInfo: undefined
            });
        };
        this.state = {
            error: undefined,
            errorInfo: undefined
        };
        if (this.props.setErrorBoundaryResetCb) this.props.setErrorBoundaryResetCb(this.resetErrorBoundary);
    }
}
module.exports["ErrorBoundary"] = $e585c5dc5dea28e7$export$e926676385687eaf;

});

parcelRegister("9hKJg", function(module, exports) {
/* reading-aids-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $d57aff2a14641b0a$export$a9f6f8fd5598a12e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1kw7 _kqswh2mm _c71lstmo _1bsbdgin _bfhk1bhr _1reo15vq _18m915zi _1fjgglyw _4pckglyw _1cicglyw _e808etvb",
            __cmplp.className
        ])
    });
});
module.exports["ReadingAidsContainer"] = $d57aff2a14641b0a$export$a9f6f8fd5598a12e;

});

parcelRegister("dzXvj", function(module, exports) {
/* reading-aids-popup-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $f33d2b3b12cfde60$export$f79f209cc21596d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, continueAnimation: continueAnimation, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1rywqsk": (0, $7sObp.default)(__cmplp.isLoading || __cmplp.continueAnimation ? 'rotationAnimation linear 3s infinite' : ''),
            "--_8bhvpm": (0, $7sObp.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            __cmplp.isLoading || __cmplp.continueAnimation ? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)' : "var(--ds-surface-overlay, #FFFFFF)")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1qi0 _1yt4v77o _y44v1rtw _11q71ggy _kqswh2mm _16qs130s",
            __cmplp.className
        ])
    });
});
module.exports["ReadingAidsPopupContainer"] = $f33d2b3b12cfde60$export$f79f209cc21596d;

});

parcelRegister("6M0KD", function(module, exports) {
const $ecf247dc05653696$export$8e3fc93123f96c19 = (cloudId)=>{
    return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
};
module.exports["isHello"] = $ecf247dc05653696$export$8e3fc93123f96c19;

});

parcelRegister("6bBOi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8af27037da6fd8cc$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    error_boundary_fallback_text: {
        id: "search_ai.error_boundary_fallback_text",
        defaultMessage: "Something went wrong. Try refreshing the page or trying again later."
    }
});
module.exports["messages"] = $8af27037da6fd8cc$export$defe85febe8b728c;

});

parcelRegister("14qs9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bg4YX = parcelRequire("bg4YX");


var $4Zqgi = parcelRequire("4Zqgi");

const $e837949619d119e2$var$useLogException = ()=>{
    return (0, $42omo.useCallback)(async (error)=>{
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'useLogException'
        });
    }, []);
};
const $e837949619d119e2$export$e926676385687eaf = (props)=>{
    const onException = $e837949619d119e2$var$useLogException();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bg4YX.ErrorBoundary), {
        ...props,
        onException: onException
    }, props.children);
};
module.exports["ErrorBoundary"] = $e837949619d119e2$export$e926676385687eaf;

});

parcelRegister("9QyHN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dwp40 = parcelRequire("dwp40");


var $f7lNm = parcelRequire("f7lNm");

const $47afc3154aae3c6d$var$SearchTenantContextQuery = `
  query SearchTenantContextQuery($cloudId: ID!) {
    tenantContexts(cloudIds: [$cloudId]) {
      cloudUrl
    }
	}
`;
const $47afc3154aae3c6d$var$fetchTenantContext = (variables)=>{
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $47afc3154aae3c6d$var$SearchTenantContextQuery,
                variables: variables
            })
        }
    };
    return (0, $dwp40.utils).requestService({
        url: (0, $f7lNm.DEFAULT_GRAPHQL_ENDPOINT)
    }, options);
};
const $47afc3154aae3c6d$export$28e7c557f4d454d9 = (cloudId)=>{
    const [tenantContext, setTenantContext] = (0, $42omo.useState)({});
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const fetchContext = (0, $42omo.useCallback)(async ()=>{
        try {
            const { data: data } = await $47afc3154aae3c6d$var$fetchTenantContext({
                cloudId: cloudId
            });
            if (data?.tenantContexts && data.tenantContexts.length > 0) setTenantContext(data.tenantContexts[0]);
            else setHasError(true);
        } catch (e) {
            setHasError(true);
        }
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchContext();
    }, [
        fetchContext
    ]);
    return {
        tenantContext: tenantContext,
        hasError: hasError
    };
};
module.exports["useTenantContext"] = $47afc3154aae3c6d$export$28e7c557f4d454d9;

});

parcelRegister("aK1zu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $cO1el = parcelRequire("cO1el");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $eRXI0 = parcelRequire("eRXI0");


var $eYwDk = parcelRequire("eYwDk");


var $4jIuc = parcelRequire("4jIuc");


var $cVtio = parcelRequire("cVtio");


var $14qs9 = parcelRequire("14qs9");


var $9QyHN = parcelRequire("9QyHN");


var $gt1E3 = parcelRequire("gt1E3");


var $5bWDW = parcelRequire("5bWDW");


var $9G2ji = parcelRequire("9G2ji");


var $gK4sy = parcelRequire("gK4sy");


var $bOthu = parcelRequire("bOthu");


var $bHyMQ = parcelRequire("bHyMQ");

const $f2ca90f947d8f2ff$var$AITopicsByPersonComponent = /*#__PURE__*/ (0, $42omo.memo)(({ userId: userId, userName: userName, cloudId: cloudId, sessionId: sessionId, v2styles: v2styles = false })=>{
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { aiRelatedTopics: aiRelatedTopics, fetchRelatedTopics: fetchRelatedTopics, showTopics: showTopics } = (0, $bHyMQ.useRelatedTopics)();
    const wrapperRef = (0, $42omo.useRef)(null);
    const [showMore, setShowMore] = (0, $42omo.useState)(false);
    const { breakElems: breakElems } = (0, $bOthu.useTopicBreakElems)(wrapperRef, showTopics);
    const { tenantContext: tenantContext } = (0, $9QyHN.useTenantContext)(cloudId);
    const { cloudUrl: cloudUrl } = tenantContext;
    const onBadgeClickHandler = ({ topicId: topicId, position: position, shownAfterCardBodyExpanded: shownAfterCardBodyExpanded })=>{
        fireAnalyticsEvent((0, $9G2ji.onRelatedEntityClick)({
            clickedEntityId: topicId,
            clickedEntityType: 'topic',
            principalEntityType: (0, $5bWDW.RelatedEntityType).USER,
            principalEntityId: userId,
            sessionId: sessionId,
            location: 'personCard',
            position: position,
            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $eYwDk.SainAction).TOPIC_CLICKED,
            commonAttributes: commonAttributes
        });
    };
    const onShowMoreTopicsClick = ()=>{
        fireAnalyticsEvent((0, $9G2ji.onToggleMoreRelatedEntitiesClick)({
            sessionId: sessionId,
            location: 'personCard',
            expanded: !showMore
        }));
        if (!showMore) fireSAINUsageEvent({
            metCriteria: (0, $eYwDk.SainAction).SHOW_MORE_TOPICS_CLICKED,
            commonAttributes: commonAttributes
        });
        setShowMore((s)=>!s);
    };
    (0, $42omo.useEffect)(()=>{
        fetchRelatedTopics({
            entityId: userId,
            principalEntityType: (0, $5bWDW.RelatedEntityType).USER,
            cloudId: cloudId
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (showTopics) fireAnalyticsEvent((0, $9G2ji.onSurfaceShown)({
            principalEntityId: userId,
            principalEntityType: (0, $5bWDW.RelatedEntityType).USER,
            relatedTopics: aiRelatedTopics.map((topic)=>topic.id),
            sessionId: sessionId,
            location: 'personCard'
        }));
    }, [
        showTopics,
        aiRelatedTopics,
        userId,
        fireAnalyticsEvent,
        sessionId
    ]);
    const firstName = userName.split(' ')[0];
    return showTopics ? v2styles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        ref: wrapperRef,
        space: "space.100",
        rowSpace: "space.100",
        alignBlock: "center",
        shouldWrap: true
    }, (breakElems < 0 ? aiRelatedTopics : aiRelatedTopics.slice(0, Math.max(1, breakElems))).map((topic, position)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gt1E3.KnowledgeBadge), {
            key: topic.id,
            name: topic.name,
            url: `/wiki/topics/${topic.id}`,
            onBadgeClick: ()=>onBadgeClickHandler({
                    topicId: topic.id,
                    position: position,
                    shownAfterCardBodyExpanded: false
                })
        })), breakElems < aiRelatedTopics.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        onClick: ()=>(0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? onShowMoreTopicsClick() : setShowMore((s)=>!s),
        icon: (iconProps)=>showMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                ...iconProps,
                size: "small"
            }),
        label: showMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $gK4sy.messages).ai_topics_show_fewer_topics_text) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $gK4sy.messages).ai_topics_show_more_topics_text),
        spacing: "compact"
    }) : null), showMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        shouldWrap: true
    }, aiRelatedTopics.slice(breakElems).map((topic, position)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gt1E3.KnowledgeBadge), {
            key: topic.id,
            name: topic.name,
            url: cloudUrl ? `${cloudUrl}/wiki/topics/${topic.id}` : undefined,
            onBadgeClick: ()=>onBadgeClickHandler({
                    topicId: topic.id,
                    position: breakElems + position,
                    shownAfterCardBodyExpanded: true
                })
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xxsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $gK4sy.messages).ai_topics_surface_header_person,
        values: {
            userName: firstName
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        rowSpace: "space.100",
        shouldWrap: true
    }, aiRelatedTopics.map((topic, position)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gt1E3.KnowledgeBadge), {
            key: topic.id,
            name: topic.name,
            url: cloudUrl ? `${cloudUrl}/wiki/topics/${topic.id}` : undefined,
            onBadgeClick: ()=>onBadgeClickHandler({
                    topicId: topic.id,
                    position: position,
                    shownAfterCardBodyExpanded: false
                })
        }))))) : null;
});
const $f2ca90f947d8f2ff$export$98ee922d18019998 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $14qs9.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f2ca90f947d8f2ff$var$AITopicsByPersonComponent, props));
module.exports["AITopicsByPerson"] = $f2ca90f947d8f2ff$export$98ee922d18019998;

});

parcelRegister("gt1E3", function(module, exports) {
/* knowledge-badge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $eEA8O = parcelRequire("eEA8O");


var $9D6Kx = parcelRequire("9D6Kx");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $a961c4b2c45e1091$var$styles = {
    knowledgeBadge: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _1e0c116y",
    buttonLink: "_ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _18u0v77o _2hwx1b66"
};
const $a961c4b2c45e1091$export$7e867bde3d2da523 = ({ name: name, url: url, onBadgeClick: onBadgeClick = ()=>{} })=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $a961c4b2c45e1091$var$styles.knowledgeBadge,
        backgroundColor: "color.background.input"
    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        href: url,
        appearance: "subtle",
        onClick: ()=>{
            onBadgeClick();
        },
        spacing: "none",
        target: "_blank"
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        xcss: $a961c4b2c45e1091$var$styles.buttonLink
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9D6Kx))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, name))));
module.exports["KnowledgeBadge"] = $a961c4b2c45e1091$export$7e867bde3d2da523;

});

parcelRegister("5bWDW", function(module, exports) {
var $1e62d7a55291ee0b$export$ee18e55fb2f84827 = /*#__PURE__*/ function(RelatedEntityType) {
    RelatedEntityType["KEY_PHRASE"] = "KEY_PHRASE";
    RelatedEntityType["TOPIC"] = "TOPIC";
    RelatedEntityType["USER"] = "USER";
    RelatedEntityType["CONFLUENCE_DOCUMENT"] = "CONFLUENCE_DOCUMENT";
    RelatedEntityType["CONFLUENCE_PAGE"] = "CONFLUENCE_PAGE";
    RelatedEntityType["CONFLUENCE_BLOGPOST"] = "CONFLUENCE_BLOGPOST";
    return RelatedEntityType;
}({});
module.exports["RelatedEntityType"] = $1e62d7a55291ee0b$export$ee18e55fb2f84827;

});

parcelRegister("9G2ji", function(module, exports) {

var $4Zqgi = parcelRequire("4Zqgi");

const $05b7c5f82bab1534$export$1e54b1f2535dc14e = (surfaceAttributes)=>{
    try {
        return {
            action: 'shown',
            actionSubjectId: 'aiTopic',
            actionSubject: 'surface',
            eventType: 'track',
            attributes: {
                ...surfaceAttributes
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onSurfaceShown'
        });
        return {};
    }
};
const $05b7c5f82bab1534$export$9eff5105a9d90d9e = (entityClickAttributes)=>{
    try {
        return {
            action: 'clicked',
            actionSubjectId: 'aiTopic',
            actionSubject: 'relatedEntity',
            eventType: 'ui',
            attributes: {
                ...entityClickAttributes
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onRelatedEntityClick'
        });
        return {};
    }
};
const $05b7c5f82bab1534$export$fbceb4fd6d209a9a = (showMoreRelatedEntitiesClickedAttributes)=>{
    return {
        action: 'clicked',
        actionSubjectId: 'aiTopic',
        actionSubject: 'toggleMoreRelatedEntities',
        eventType: 'ui',
        attributes: {
            ...showMoreRelatedEntitiesClickedAttributes
        }
    };
};
module.exports["onSurfaceShown"] = $05b7c5f82bab1534$export$1e54b1f2535dc14e;
module.exports["onRelatedEntityClick"] = $05b7c5f82bab1534$export$9eff5105a9d90d9e;
module.exports["onToggleMoreRelatedEntitiesClick"] = $05b7c5f82bab1534$export$fbceb4fd6d209a9a;

});

parcelRegister("gK4sy", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $35af8e7a3997192d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    ai_topics_surface_header_user: {
        id: "search_ai.ai_topics.surface.header",
        defaultMessage: "Topics this person knows about"
    },
    ai_topics_surface_header_generic: {
        id: "search_ai.ai_topics.related_topics.header",
        defaultMessage: "Related topics"
    },
    ai_topics_surface_header_person: {
        id: "search_ai.ai_topics.surface.person_header",
        defaultMessage: "Topics {userName} knows about"
    },
    ai_topics_surface_header_beta_lozenge: {
        id: "search_ai.ai_topics.related_topics.header_beta_lozenge",
        defaultMessage: "BETA"
    },
    ai_topics_surface_footer_beta_lozenge: {
        id: "search_ai.ai_topics.related_topics.footer_beta_lozenge",
        defaultMessage: "BETA"
    },
    ai_topics_surface_footer_content_may_vary: {
        id: "search_ai.ai_topics.related_topics.footer_content_may_vary",
        defaultMessage: "Content quality may vary"
    },
    ai_topics_surface_footer_powered_by_ai: {
        id: "search_ai.ai_topics.related_topics.footer_powered_by_ai",
        defaultMessage: "Powered by AI"
    },
    ai_topics_user_feedback_prompt: {
        id: "search_ai.ai_topics.feedback.prompt.user",
        defaultMessage: "Are these topics correctly associated with this user?"
    },
    ai_topics_page_feedback_prompt: {
        id: "search_ai.ai_topics.feedback.prompt.page",
        defaultMessage: "Do these topics accurately reflect the contents of this page?"
    },
    ai_topics_page_feedback_button_text: {
        id: "search_ai.ai_topics.feedback.prompt.button",
        defaultMessage: "Submit feedback"
    },
    ai_topics_profile_feedback_text: {
        id: "search_ai.ai_topics.profile.prompt",
        defaultMessage: "Do these topics look accurate for this person?"
    },
    ai_topics_card_header_text: {
        id: "search_ai.ai_topics.card.header",
        defaultMessage: "Topics related to \"{searchQuery}\""
    },
    ai_topics_card_feedback_prompt: {
        id: "search_ai.ai_topics.card.feedback_prompt",
        defaultMessage: "Are these relevant to your search?"
    },
    ai_topics_rovo_branding_text: {
        id: "search_ai.ai_topics.rovo_branding_text",
        defaultMessage: "Rovo"
    },
    ai_topics_show_more_topics_text: {
        id: "search_ai.ai_topics.show_more_topics_text",
        defaultMessage: "Show more topics"
    },
    ai_topics_show_fewer_topics_text: {
        id: "search_ai.ai_topics.show_fewer_topics_text",
        defaultMessage: "Show fewer topics"
    }
});
module.exports["messages"] = $35af8e7a3997192d$export$defe85febe8b728c;

});

parcelRegister("bOthu", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $82ce7495e580fd3f$var$BUTTON_WIDTH = 20;
const $82ce7495e580fd3f$var$PADDING_BLOCK_END = 16;
const $82ce7495e580fd3f$var$TOPIC_INLINE_SPACE = 8;
const $82ce7495e580fd3f$export$6e050707ceb5a52f = (wrapperRef, showTopics)=>{
    const [breakElems, setBreakElems] = (0, $42omo.useState)(-1);
    const [topicLengths, setTopicLengths] = (0, $42omo.useState)([]);
    (0, $42omo.useEffect)(()=>{
        const observer = new ResizeObserver((topics)=>{
            const wrapper = topics[0];
            const cwidth = wrapper.target.clientWidth;
            const tl = topicLengths;
            var runningWidth = 0;
            var elemsHold = 0;
            // on first run, all topics are displayed so we can loop through and get the lengths
            if (tl.length === 0) for (const topic of Array.from(wrapper.target.children)){
                const width = topic.scrollWidth;
                tl.push(width);
            }
            for(let i = 0; i < tl.length; i++){
                const width = topicLengths[i];
                if (runningWidth + width + $82ce7495e580fd3f$var$PADDING_BLOCK_END + $82ce7495e580fd3f$var$BUTTON_WIDTH <= cwidth) elemsHold += 1;
                runningWidth += width + $82ce7495e580fd3f$var$TOPIC_INLINE_SPACE;
            }
            setBreakElems(elemsHold);
            // on first run, save the topic lengths so we can reuse
            if (topicLengths.length === 0) setTopicLengths(tl);
        });
        if (wrapperRef.current) observer.observe(wrapperRef.current);
        return ()=>{
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showTopics
    ]);
    return {
        breakElems: breakElems
    };
};
module.exports["useTopicBreakElems"] = $82ce7495e580fd3f$export$6e050707ceb5a52f;

});

parcelRegister("bHyMQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $epS7s = parcelRequire("epS7s");


var $5NwX5 = parcelRequire("5NwX5");


var $3wRO5 = parcelRequire("3wRO5");


var $5bWDW = parcelRequire("5bWDW");

const $835a4feee30f76f5$export$b08faa9b0d12bdd8 = 'atlassian.search-dialog.ai-topics-component';
const $835a4feee30f76f5$export$977fb96428acdf48 = ()=>{
    const [aiRelatedTopics, setAIRelatedTopics] = (0, $42omo.useState)([]);
    const [error, setError] = (0, $42omo.useState)('');
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const fetchRelatedTopics = async ({ entityId: entityId, cloudId: cloudId, principalEntityType: principalEntityType })=>{
        if (!entityId) {
            setAIRelatedTopics([]);
            return;
        }
        const cache = JSON.parse((0, $epS7s.getSessionItem)($835a4feee30f76f5$export$b08faa9b0d12bdd8) || '{}');
        if (cache?.entityId === entityId) setAIRelatedTopics(cache.topics);
        else {
            setAIRelatedTopics([]);
            (0, $epS7s.deleteSessionItem)($835a4feee30f76f5$export$b08faa9b0d12bdd8);
            setIsLoading(true);
            try {
                const { data: data } = await (0, $5NwX5.fetchRelatedEntities)({
                    entityId: entityId,
                    entityType: principalEntityType,
                    relatedEntityType: (0, $5bWDW.RelatedEntityType).TOPIC,
                    cloudId: cloudId,
                    first: 5
                });
                if (data.knowledgeDiscovery.__typename === (0, $3wRO5.RelatedEntitiesResult).QueryError) setError('REQUEST_ERROR');
                else if (data.knowledgeDiscovery.relatedEntities?.nodes) {
                    const entities = data.knowledgeDiscovery.relatedEntities.nodes;
                    setAIRelatedTopics(entities);
                    (0, $epS7s.setSessionItem)($835a4feee30f76f5$export$b08faa9b0d12bdd8, JSON.stringify({
                        entityId: entityId,
                        topics: entities
                    }));
                }
            } catch  {
                setError('NETWORK_ERROR');
            } finally{
                setIsLoading(false);
            }
        }
    };
    const resetTopics = (0, $42omo.useCallback)(()=>{
        setAIRelatedTopics([]);
    }, [
        setAIRelatedTopics
    ]);
    const showTopics = !isLoading && !error && aiRelatedTopics.length > 0;
    return {
        aiRelatedTopics: aiRelatedTopics,
        fetchRelatedTopics: fetchRelatedTopics,
        showTopics: showTopics,
        resetTopics: resetTopics
    };
};
module.exports["useRelatedTopics"] = $835a4feee30f76f5$export$977fb96428acdf48;

});

parcelRegister("5NwX5", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $f7lNm = parcelRequire("f7lNm");


var $KUYQ0 = parcelRequire("KUYQ0");

const $6ad9199244d74d2a$export$a6a63d73bee8e09d = (variables)=>{
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: (0, $KUYQ0.RelatedEntitiesQuery),
                variables: variables
            })
        },
        queryParams: {
            q: 'RelatedEntities'
        }
    };
    return (0, $dwp40.utils).requestService({
        url: (0, $f7lNm.DEFAULT_GRAPHQL_ENDPOINT)
    }, options);
};
module.exports["fetchRelatedEntities"] = $6ad9199244d74d2a$export$a6a63d73bee8e09d;

});

parcelRegister("KUYQ0", function(module, exports) {
const $b2178040d9ade6ef$export$da4042a87a471c60 = `
  query RelatedEntities(
    $entityId: String!
    $entityType: KnowledgeDiscoveryEntityType!
    $relatedEntityType: KnowledgeDiscoveryEntityType!
    $cloudId: String!
    $first: Int
    $after: String
  ) {
    knowledgeDiscovery {
      relatedEntities(
        entityId: $entityId
        entityType: $entityType
        relatedEntityType: $relatedEntityType
        cloudId: $cloudId
        first: $first
        after: $after
      ) @optIn(to: "KnowledgeDiscovery Get Related Entities") {
        ... on KnowledgeDiscoveryRelatedEntityConnection {
          __typename
          nodes {
            ... on KnowledgeDiscoveryTopic {
              id
              name
              description
              documentCount
              updatedAt
              type
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
        ... on QueryError {
          message
        }
      }
    }
  }
`;
module.exports["RelatedEntitiesQuery"] = $b2178040d9ade6ef$export$da4042a87a471c60;

});

parcelRegister("3wRO5", function(module, exports) {
var $90c3319ed7ab95e7$export$e11ed46440979a9c = /*#__PURE__*/ function(RelatedEntitiesResult) {
    RelatedEntitiesResult["KnowledgeDiscoveryRelatedEntityConnection"] = "KnowledgeDiscoveryRelatedEntityConnection";
    RelatedEntitiesResult["QueryError"] = "QueryError";
    return RelatedEntitiesResult;
}({});
module.exports["RelatedEntitiesResult"] = $90c3319ed7ab95e7$export$e11ed46440979a9c;

});

parcelRegister("la4Nn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a68b338d526637a8b5aa12ee323900>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f67e406d7c5cafb0$var$_react = $f67e406d7c5cafb0$var$_interopRequireDefault((parcelRequire("42omo")));

var $f67e406d7c5cafb0$var$_baseNew = $f67e406d7c5cafb0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f67e406d7c5cafb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Hashtag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: topics in Atlas, tags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f67e406d7c5cafb0$var$HashtagIcon = (props)=>/*#__PURE__*/ $f67e406d7c5cafb0$var$_react.default.createElement($f67e406d7c5cafb0$var$_baseNew.default, Object.assign({
        name: "HashtagIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.274 5 6.012.868l1.476.264L6.798 5h3.476l.738-4.132 1.476.264L11.798 5H15v1.5h-3.47l-.536 3H14V11h-3.274l-.738 4.132-1.476-.264.69-3.868H5.726l-.738 4.132-1.476-.264.69-3.868H1V9.5h3.47l.536-3H2V5zM6.53 6.5l-.536 3H9.47l.536-3z" clip-rule="evenodd"/>`
    }, props));
$f67e406d7c5cafb0$var$HashtagIcon.displayName = 'HashtagIcon';
var $f67e406d7c5cafb0$var$_default = module.exports.default = $f67e406d7c5cafb0$var$HashtagIcon;

});

parcelRegister("d0O3C", function(module, exports) {

var $78z3f = parcelRequire("78z3f");

const $d64c569546f31d6e$export$9a80c24535b38e83 = 'confluence_3p_smartlink_connection_link_count';
const $d64c569546f31d6e$export$d02d73057c4016d5 = 'confluence_3p_smartlink_connection_link_count_by_team_type_';
const $d64c569546f31d6e$var$SUFFICIENCY_THRESHOLD = 20;
const $d64c569546f31d6e$export$545eb843b77efaec = 3;
const $d64c569546f31d6e$export$8594dab83de99a34 = [
    'google-drive',
    'slack',
    'github'
];
const $d64c569546f31d6e$export$5dbf4404d8d730eb = {
    c_suite: [
        'google-drive',
        'slack',
        'github'
    ],
    customer_service: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    data_science: [
        'google-drive',
        'github',
        'slack'
    ],
    design: [
        'google-drive',
        'figma',
        'slack'
    ],
    engineering: [
        'google-drive',
        'github',
        'slack'
    ],
    finance: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    human_resources: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    information_technology: [
        'google-drive',
        'slack',
        'github'
    ],
    legal: [
        'google-drive',
        'slack',
        'sharepoint'
    ],
    marketing: [
        'google-drive',
        'slack',
        'figma'
    ],
    // `na` is the "no signal" floor row — kept in sync with the standalone
    // `DEFAULT_FALLBACK_APPS` export above by referencing the same constant.
    na: $d64c569546f31d6e$export$8594dab83de99a34,
    operations: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    other: [
        'google-drive',
        'github',
        'slack'
    ],
    product_management: [
        'google-drive',
        'figma',
        'slack'
    ],
    program_management: [
        'google-drive',
        'onedrive',
        'sharepoint'
    ],
    sales: [
        'google-drive',
        'slack',
        'sharepoint'
    ]
};
const $d64c569546f31d6e$export$db8c8b18ca3de852 = 'na';
const $d64c569546f31d6e$var$APP_ID_TO_PRODUCT_KEY_ALIASES = {
    drive: (0, $78z3f.ProductKeys3P).GoogleDrive,
    figma: (0, $78z3f.ProductKeys3P).Figma,
    github: (0, $78z3f.ProductKeys3P).Github,
    'google-drive': (0, $78z3f.ProductKeys3P).GoogleDrive,
    onedrive: (0, $78z3f.ProductKeys3P).OneDrive,
    sharepoint: (0, $78z3f.ProductKeys3P).Sharepoint,
    slack: (0, $78z3f.ProductKeys3P).Slack
};
const $d64c569546f31d6e$export$acda930d8972381e = (raw)=>{
    if (!raw || raw.trim().length === 0) return [];
    return raw.split(',').map((entry)=>entry.trim()).filter((entry)=>entry.length > 0).map((entry)=>{
        const separatorIndex = entry.indexOf(':');
        if (separatorIndex <= 0 || separatorIndex === entry.length - 1) return undefined;
        const appId = entry.slice(0, separatorIndex).trim();
        const count = Number(entry.slice(separatorIndex + 1).trim());
        if (appId.length === 0 || !Number.isFinite(count)) return undefined;
        return {
            appId: appId,
            count: count
        };
    }).filter((entry)=>entry !== undefined);
};
const $d64c569546f31d6e$export$299a268eb011b7ef = (raw)=>{
    if (raw === undefined || raw.trim() === '') return undefined;
    const scalarCount = Number(raw);
    if (Number.isInteger(scalarCount) && scalarCount >= 0) return scalarCount;
    const appCounts = $d64c569546f31d6e$export$acda930d8972381e(raw);
    if (appCounts.length === 0) return undefined;
    // parseAppCounts only guarantees isFinite; re-filter to positive integers before summing.
    const totalCount = appCounts.reduce((total, { count: count })=>{
        if (!Number.isInteger(count) || count <= 0) return total;
        return total + count;
    }, 0);
    return totalCount > 0 ? totalCount : undefined;
};
const $d64c569546f31d6e$export$fe68bf06dd562208 = (parsed)=>parsed.map((entry, index)=>({
            ...entry,
            index: index
        })).filter((entry)=>entry.count > 0).sort((a, b)=>{
        if (b.count !== a.count) return b.count - a.count;
        return a.index - b.index;
    }).map((entry)=>entry.appId);
const $d64c569546f31d6e$export$f9f1f4a4ade7c6e2 = (appId)=>{
    return $d64c569546f31d6e$var$APP_ID_TO_PRODUCT_KEY_ALIASES[appId.toLowerCase()];
};
const $d64c569546f31d6e$export$551da10284cad191 = (apps)=>apps.map($d64c569546f31d6e$export$f9f1f4a4ade7c6e2).filter((productKey)=>productKey !== undefined);
const $d64c569546f31d6e$export$7cc148373d70b178 = (existing, incoming, max)=>{
    const result = [];
    const seen = new Set();
    for (const productKey of [
        ...existing,
        ...incoming
    ])if (!seen.has(productKey)) {
        seen.add(productKey);
        result.push(productKey);
        if (result.length >= max) return result;
    }
    return result;
};
const $d64c569546f31d6e$export$5d0c03a62d0c5b9f = ({ siteWideSmartlinkAppCounts: siteWideSmartlinkAppCounts, teamTypeSmartlinkAppCounts: teamTypeSmartlinkAppCounts, teamTypeKey: teamTypeKey } = {}, maxRecommendedApps = $d64c569546f31d6e$export$545eb843b77efaec, options = {})=>{
    let productKeys = [];
    // Tier 1 — per-team-type TAP trait, gated on sufficiency.
    //
    // The sufficiency check is intentionally performed against the raw
    // (pre-filter) sum: it reflects whether the site as a whole has enough
    // activity for this team type to trust the signal, independent of which
    // apps we happen to support today. Only positive counts contribute so a
    // malformed TAP row with negatives (`"github:50, x:-40"`) cannot drag the
    // total below the threshold.
    const teamTypeParsed = $d64c569546f31d6e$export$acda930d8972381e(teamTypeSmartlinkAppCounts);
    const teamTypePositiveSum = teamTypeParsed.reduce((sum, entry)=>sum + Math.max(0, entry.count), 0);
    if (teamTypePositiveSum >= $d64c569546f31d6e$var$SUFFICIENCY_THRESHOLD) productKeys = $d64c569546f31d6e$export$7cc148373d70b178([], $d64c569546f31d6e$export$551da10284cad191($d64c569546f31d6e$export$fe68bf06dd562208(teamTypeParsed)), maxRecommendedApps);
    // Tier 2 — site-wide TAP trait backfill.
    if (productKeys.length < maxRecommendedApps) {
        const siteWideParsed = $d64c569546f31d6e$export$acda930d8972381e(siteWideSmartlinkAppCounts);
        productKeys = $d64c569546f31d6e$export$7cc148373d70b178(productKeys, $d64c569546f31d6e$export$551da10284cad191($d64c569546f31d6e$export$fe68bf06dd562208(siteWideParsed)), maxRecommendedApps);
    }
    // Tier 3 — HARDCODED_DEFAULTS for the user's team type.
    //
    // If the caller didn't pass a teamTypeKey, or passed one we don't have
    // a curated row for, fall through to the `na` row. Because
    // HARDCODED_DEFAULTS.na references DEFAULT_FALLBACK_APPS by identity,
    // this single tier covers both the team-type-known case and the
    // "no signal at all" floor — no separate Tier 4 is needed.
    //
    // Skipped when `options.traitOnly` is set so animation callers (which
    // have their own department-based fallback) can distinguish "real signal"
    // from "cold-start defaults".
    if (!options.traitOnly && productKeys.length < maxRecommendedApps) {
        const tier3AppIds = (teamTypeKey ? $d64c569546f31d6e$export$5dbf4404d8d730eb[teamTypeKey] : undefined) ?? $d64c569546f31d6e$export$5dbf4404d8d730eb[$d64c569546f31d6e$export$db8c8b18ca3de852] ?? [];
        productKeys = $d64c569546f31d6e$export$7cc148373d70b178(productKeys, $d64c569546f31d6e$export$551da10284cad191(tier3AppIds), maxRecommendedApps);
    }
    return productKeys;
};
module.exports["SMARTLINK_CONNECTION_LINK_COUNT_TRAIT"] = $d64c569546f31d6e$export$9a80c24535b38e83;
module.exports["SMARTLINK_CONNECTION_LINK_COUNT_BY_TEAM_TYPE_TRAIT_PREFIX"] = $d64c569546f31d6e$export$d02d73057c4016d5;
module.exports["DEFAULT_FALLBACK_APPS"] = $d64c569546f31d6e$export$8594dab83de99a34;
module.exports["parseAppCounts"] = $d64c569546f31d6e$export$acda930d8972381e;
module.exports["parseSmartlinkConnectionLinkCount"] = $d64c569546f31d6e$export$299a268eb011b7ef;
module.exports["canonicalizeAppIdToProductKey"] = $d64c569546f31d6e$export$f9f1f4a4ade7c6e2;
module.exports["resolveRecommendedProductKeys"] = $d64c569546f31d6e$export$5d0c03a62d0c5b9f;

});

parcelRegister("aq5p0", function(module, exports) {
/**
 * Utilities for talking to the Atlassian outbound-auth gateway, which is the
 * canonical source of truth for whether a user has a working OAuth connection
 * to a given Smart Link connector.
 *
 * Why this exists
 * ---------------
 * Previously we relied on the CDS endpoint
 *   GET /gateway/api/third-party-configuration/connected-data-sources/{cloudId}
 * (via `get3pSearchConfig`) to determine both the OAuth start URL and whether
 * the user was already connected. That endpoint has four well-known problems
 * for the Confluence onboarding "Connect your 3P tools" experience:
 *
 *   1. Edition-gated: CDS only works on Standard+ tenants with Rovo
 *      provisioned. Free tier tenants return 403.
 *   2. Lazy-init: the registry behind CDS (ERS) does not have a
 *      `smartlinks-connector-{provider}` row until a Smart Link resolve event
 *      for that provider has fired on the tenant. Brand-new tenants are
 *      effectively empty.
 *   3. Not a definitive provider universe: CDS only enumerates what's already
 *      been touched on this tenant, not what's available to connect.
 *   4. No back-population: even after a user connects via a fallback path,
 *      CDS does not see it (until/unless ERS gets the event), so downstream
 *      surfaces like the post-office banner keep re-prompting.
 *
 * The outbound-auth gateway endpoint
 *   GET /gateway/api/outbound-auth/aaId/{aaId}
 * powers id.atlassian.com/manage-profile/apps. It is cookie-authed (no ASAP
 * needed), works cross-origin from *.atlassian.net, and returns the user's
 * full OAuth-grant list with a per-account `status` field. This is the same
 * data the Atlassian ID Manage Profile UI uses.
 *
 * Canonical container UUIDs come from
 *   ai-3p-connector/connector-service/implementation/src/main/resources/application-prod.yml
 *   ai-3p-connector/connector-service/implementation/src/main/resources/application.yml      (staging)
 * under `linking-platform.providers[]`. The `containerId` + `serviceKey`
 * tuples in the outbound-auth response match those values exactly.
 *
 * Backwards-compat / defensive design
 * -----------------------------------
 *  - All network/parse failures return `null` and let callers fall back to
 *    whatever they were doing before. This module never throws.
 *  - The container maps are `Partial<Record<...>>` and helpers return `null`
 *    when a product has no mapping. Callers are expected to filter such
 *    providers out rather than render broken Connect buttons.
 */ 
var $78z3f = parcelRequire("78z3f");


var $abk4V = parcelRequire("abk4V");

// Verified identical in prod and staging gdrive CDS URLs.
const $0de16cf0cbdeac18$var$SMARTLINK_GDRIVE_SCOPES = [
    'https://www.googleapis.com/auth/drive.readonly',
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/userinfo.email'
];
const $0de16cf0cbdeac18$export$860f54a43e361c13 = {
    [(0, $78z3f.ProductKeys3P).GoogleDrive]: {
        containerId: 'ff32b4a9-0056-4c40-bb6e-eebf3b1d82f7_c50f3d56-68fc-4c3c-8191-6717f173dc54',
        serviceKey: 'gdrive',
        defaultScopes: $0de16cf0cbdeac18$var$SMARTLINK_GDRIVE_SCOPES
    },
    [(0, $78z3f.ProductKeys3P).Slack]: {
        containerId: '25ab8ceb-e2e9-4b3a-b4ef-902049561d3a_74232f16-3f89-4bc8-9dcb-b5481bca783e',
        serviceKey: 'slack'
    },
    [(0, $78z3f.ProductKeys3P).OneDrive]: {
        containerId: '00f40f12-faac-4ac8-8d6d-310f96ac97f5_f039c3c2-7e00-41c4-b1cf-70743efbf91a',
        serviceKey: 'onedrive'
    },
    [(0, $78z3f.ProductKeys3P).Sharepoint]: {
        containerId: '7289b5af-9aa4-4977-bb8b-6876502a6466_e7e24a0a-0b03-4ef8-9a83-642e6ef97dbc',
        serviceKey: 'sharepoint'
    },
    [(0, $78z3f.ProductKeys3P).Github]: {
        containerId: 'c364f950-69f5-4812-9716-ed71a8d3d408_a57ca83d-597f-4de9-8dca-f9d3cd18d3a7',
        serviceKey: 'github'
    },
    [(0, $78z3f.ProductKeys3P).Figma]: {
        containerId: '7f89dc0c-5c1e-4b71-997f-220bf92361aa_73fbf758-c657-4f06-8edd-f721911f7f53',
        serviceKey: 'figma'
    },
    [(0, $78z3f.ProductKeys3P).Teams]: {
        containerId: 'fe8ece6c-97b6-45ac-959d-865da9a33409_61030824-303b-4751-bca5-1def33b6b0d0',
        serviceKey: 'ms-teams'
    },
    [(0, $78z3f.ProductKeys3P).Dropbox]: {
        containerId: 'd4d6a241-1008-42cf-b2d6-d0b380c096d6_b6796989-c34a-4e19-a4e1-ccc7655f8fd6',
        serviceKey: 'dropbox'
    },
    [(0, $78z3f.ProductKeys3P).Airtable]: {
        containerId: 'c5805f5a-3e9a-48a5-a8f5-7b04aac4ad16_572b2748-e9b1-4161-b36d-19f962646d1a',
        serviceKey: 'airtable'
    },
    [(0, $78z3f.ProductKeys3P).LaunchDarkly]: {
        containerId: '30ba2eba-6d3f-4124-8060-0ea9a9c9e990_d28912a6-171c-41a2-9adb-1426eccbc767',
        serviceKey: 'launchdarkly'
    },
    [(0, $78z3f.ProductKeys3P).ClickUp]: {
        containerId: '12967bc2-803e-4f8d-9e66-1aa48773a5a4_13a589a5-f514-4b63-a104-7d454b8dc676',
        serviceKey: 'clickup'
    },
    [(0, $78z3f.ProductKeys3P).Pipedrive]: {
        containerId: '1edf2d8e-c159-4ffe-8be0-165821a0ecf1_743950e9-2685-4558-a5b0-ae5d3b47853c',
        serviceKey: 'pipedrive'
    },
    [(0, $78z3f.ProductKeys3P).Gitlab]: {
        containerId: '790bd6ce-7ef8-404a-a9dc-798feb10b12b_049b63cb-90b1-4bfa-aa02-f3fdd9298b03',
        serviceKey: 'gitlab'
    },
    [(0, $78z3f.ProductKeys3P).Docusign]: {
        containerId: '35cd5415-c24c-457e-af7c-ac84df8c8628_0a7329e4-b658-41a1-89c2-419514a5ca08',
        serviceKey: 'docusign'
    },
    [(0, $78z3f.ProductKeys3P).Dovetail]: {
        containerId: 'b51f1664-8705-4938-a9a5-02a7eb3395cb_cba4f674-8eea-43aa-874f-8f16af6b75cb',
        serviceKey: 'dovetail'
    },
    [(0, $78z3f.ProductKeys3P).Box]: {
        containerId: '3a79e004-2e3e-45fe-8a21-84f53568a8ee_35421d47-ad3e-44f5-9cde-60bfa869e0b0',
        serviceKey: 'box'
    },
    [(0, $78z3f.ProductKeys3P).AdobeXD]: {
        containerId: '80c22a47-9ca7-4690-88db-65b375f402a7_ad251cf5-828d-494d-b555-4294d9654173',
        serviceKey: 'adobexd'
    },
    [(0, $78z3f.ProductKeys3P).Asana]: {
        containerId: '2487d697-ed1e-4cf5-9655-f1fb1355c341_a927cae4-3500-4386-9ac3-28e87671c2c8',
        serviceKey: 'asana'
    },
    [(0, $78z3f.ProductKeys3P).Smartsheet]: {
        containerId: '101a27da-d409-4f8c-9c75-326eec4fd5d4_fe89f892-8c94-4574-88f7-5898c05be186',
        serviceKey: 'smartsheet'
    },
    [(0, $78z3f.ProductKeys3P).Mural]: {
        containerId: 'cc21faf3-19fc-4522-af92-295866ef82e7_373f2501-6f74-4c0f-9bfa-c54cdea00066',
        serviceKey: 'mural'
    },
    [(0, $78z3f.ProductKeys3P).PowerBI]: {
        containerId: '9c59191f-63ab-44b2-a2cb-2f20adc75365_556e62ba-588b-494d-8c6c-b672e50537f6',
        serviceKey: 'power-bi'
    },
    [(0, $78z3f.ProductKeys3P).Miro]: {
        containerId: 'd01d8332-4637-4ea4-8b14-17a9d1a61504_a894175f-cb17-4e45-88fa-c348967f379c',
        serviceKey: 'miro'
    },
    [(0, $78z3f.ProductKeys3P).Hubspot]: {
        containerId: 'da0f0482-f78f-4eec-b7e6-0bc98ca5a54c_707406e8-d607-427a-b32e-e1d4710c0f2d',
        serviceKey: 'hubspot'
    },
    [(0, $78z3f.ProductKeys3P).Notion]: {
        containerId: '2bc172f6-c553-4fe1-85d4-3e2e087f84f6_be0969ca-ea7e-4685-abaa-7de142c01b36',
        serviceKey: 'notion'
    },
    [(0, $78z3f.ProductKeys3P).Sentry]: {
        containerId: '977cb3af-b6e9-4450-9ce5-bf40f9c73dff_3a8bcf5e-44ab-4f5b-b18d-340027b6a97e',
        serviceKey: 'sentry'
    },
    [(0, $78z3f.ProductKeys3P).PagerDuty]: {
        containerId: '49cdc160-0ad5-4dbf-adad-6a57fb082774_5cef1b1a-44aa-409e-97b3-b90065cbb39e',
        serviceKey: 'pagerduty'
    },
    [(0, $78z3f.ProductKeys3P).Salesforce]: {
        containerId: '2b45cadc-67a2-4902-8148-03e4de5ba747_db858b85-c098-45e7-96c8-9ccc9caf72da',
        serviceKey: 'salesforce'
    },
    [(0, $78z3f.ProductKeys3P).Amplitude]: {
        containerId: '1e30cfdf-cceb-43f4-b34a-dde94e1f9b21_939acc6f-274a-42da-acdc-8af5a14fe698',
        serviceKey: 'amplitude'
    },
    [(0, $78z3f.ProductKeys3P).Lucid]: {
        containerId: '9262005e-5c1a-49af-9ec0-4a354f581c73_80f25935-3f1f-40e1-9b2a-35db54297ebf',
        serviceKey: 'lucid'
    },
    [(0, $78z3f.ProductKeys3P).Zeplin]: {
        containerId: 'a401d4f0-b3d1-4b64-a85d-3952bd42d9a7_3da3c5e7-89db-4330-878f-dff1fe878556',
        serviceKey: 'zeplin'
    },
    [(0, $78z3f.ProductKeys3P).Todoist]: {
        containerId: '0202ace9-65df-40e3-b539-d831b446dad9_c7809c53-31e9-4fc0-8df9-8b8dcb418bb8',
        serviceKey: 'todoist'
    },
    [(0, $78z3f.ProductKeys3P).Stripe]: {
        containerId: 'bb81e8b8-7d0d-4a24-bb5b-acf31ab97bbc_f38b2a60-30a9-4abd-9086-efb78f6986ce',
        serviceKey: 'stripe'
    },
    [(0, $78z3f.ProductKeys3P).AzureDevops]: {
        // Sourced from ai-3p-connector application-prod.yml
        // (permission.linking-platform-info[container=6b34a992…]).
        containerId: '6b34a992-af2a-4a16-8a4d-89038c48a355_719d2d91-a89a-46f5-bacc-e3baf87d21c8',
        serviceKey: 'azuredevops'
    },
    [(0, $78z3f.ProductKeys3P).Webex]: {
        // Sourced from ai-3p-connector application-prod.yml
        // (permission.linking-platform-info[container=18025f11…]).
        containerId: '18025f11-aafe-49ca-ad45-d48f7005e459_19846c70-0c88-44f6-a7c1-d5bdd77c606c',
        serviceKey: 'webex'
    }
};
const $0de16cf0cbdeac18$export$e25d6f2386134a66 = {
    [(0, $78z3f.ProductKeys3P).GoogleDrive]: {
        containerId: '2357cbb7-bf5c-4fe4-a9c6-c8e172ccb5b1_3b53863d-a6bb-4818-91da-4de04f975f48',
        serviceKey: 'gdrive',
        defaultScopes: $0de16cf0cbdeac18$var$SMARTLINK_GDRIVE_SCOPES
    },
    [(0, $78z3f.ProductKeys3P).Slack]: {
        containerId: '32a368b4-220e-45a9-b65f-df104dc2e559_7ab21f60-b89a-44c1-bed3-00282c3e7b9e',
        serviceKey: 'slack'
    },
    [(0, $78z3f.ProductKeys3P).OneDrive]: {
        containerId: '6b74c0f8-ce5e-43b0-a68e-eba0fed27cea_4254f605-625b-4026-904a-bdf8ee6de413',
        serviceKey: 'onedrive'
    },
    [(0, $78z3f.ProductKeys3P).Sharepoint]: {
        containerId: '03d0881e-f10f-4751-ab11-27592812060e_b269c883-58b9-463a-9b77-50b6cd8da5fc',
        serviceKey: 'sharepoint'
    },
    [(0, $78z3f.ProductKeys3P).Github]: {
        containerId: '9bb160f8-1abb-4dc8-9780-ca5327e7ccc8_91300e36-3710-4f7b-aba2-95f43be1ac6f',
        serviceKey: 'github'
    },
    [(0, $78z3f.ProductKeys3P).Figma]: {
        containerId: '652e701c-09ac-4e05-bd96-4c95b5c8cac5_ccaebdc1-68e5-406a-b1f4-efcc5962aa40',
        serviceKey: 'figma'
    },
    [(0, $78z3f.ProductKeys3P).Teams]: {
        containerId: 'd27ee9f8-f60b-4076-910b-f16da23b7df4_b3763282-4b2e-4b4b-b924-3c8ba8f6e218',
        serviceKey: 'ms-teams'
    },
    [(0, $78z3f.ProductKeys3P).Dropbox]: {
        containerId: 'd7a3169c-13c8-4b76-96b6-e8f9f849313d_d73e8370-9035-494d-ae16-20854375cb6f',
        serviceKey: 'dropbox'
    },
    [(0, $78z3f.ProductKeys3P).Airtable]: {
        containerId: '070278f6-260c-420f-be4f-a7942a712c23_c2fe283b-51d2-4a0a-8e7f-4ce1199e0a10',
        serviceKey: 'airtable'
    },
    [(0, $78z3f.ProductKeys3P).LaunchDarkly]: {
        containerId: 'd63e3423-0a85-461f-9650-7f26342c62bf_49e197a6-c428-442e-a5ca-f9d4889c82d8',
        serviceKey: 'launchdarkly'
    },
    [(0, $78z3f.ProductKeys3P).ClickUp]: {
        containerId: 'fe20ccd3-b054-4139-aacb-8d98e086c16d_0b40b3c7-4c18-40e3-a030-101c94347723',
        serviceKey: 'clickup'
    },
    [(0, $78z3f.ProductKeys3P).Pipedrive]: {
        containerId: '6012b82a-da48-44ff-af6e-da1c73b279f6_e6a2cefa-c9fe-4d50-b8ea-36391a2d41e6',
        serviceKey: 'pipedrive'
    },
    [(0, $78z3f.ProductKeys3P).Gitlab]: {
        containerId: 'a7b83eeb-482d-402d-b87d-21ede67e73ed_3082dfec-249f-45d9-b84d-b49d256874e9',
        serviceKey: 'gitlab'
    },
    [(0, $78z3f.ProductKeys3P).Docusign]: {
        containerId: 'ec9d65b4-72ee-4030-8dd1-e393026cf335_f4f50986-99a8-4f96-8b52-917d4c6bbbb7',
        serviceKey: 'docusign'
    },
    [(0, $78z3f.ProductKeys3P).Dovetail]: {
        containerId: 'f9a3bf31-88d5-4b5a-80c2-cc32670259a2_c0c8e23b-ec93-45bb-928c-91b9671f0041',
        serviceKey: 'dovetail'
    },
    [(0, $78z3f.ProductKeys3P).Box]: {
        containerId: '43cd20d8-11a7-4910-8789-06523fb2e6db_957783c9-4448-4d91-93dc-0ad7b24a327a',
        serviceKey: 'box'
    },
    [(0, $78z3f.ProductKeys3P).AdobeXD]: {
        containerId: 'c1225a08-acd6-4908-84a7-d5b573f14cc1_e701a1e0-b819-4077-99ac-0b3525510c66',
        serviceKey: 'adobexd'
    },
    [(0, $78z3f.ProductKeys3P).Asana]: {
        containerId: '35462eee-abe5-4873-ba7a-610d4c85f640_cb8525b3-26b3-467d-b42c-cb944e912311',
        serviceKey: 'asana'
    },
    [(0, $78z3f.ProductKeys3P).Smartsheet]: {
        containerId: '48cb55a0-db03-4ce4-8f76-1f986f734652_e6b58d0f-fa9f-4543-9b67-5957b73dee6f',
        serviceKey: 'smartsheet'
    },
    [(0, $78z3f.ProductKeys3P).Mural]: {
        containerId: '95d1bad0-96d7-40a8-996f-b8226dfd8fa1_d6095215-c4a5-4be1-bdd9-7065ed65ae37',
        serviceKey: 'mural'
    },
    [(0, $78z3f.ProductKeys3P).PowerBI]: {
        containerId: 'ea3c5a46-228c-47ea-8c4b-f18e0f17fe8c_abc5ee35-a08c-4481-aa26-0439ce58b4c4',
        serviceKey: 'power-bi'
    },
    [(0, $78z3f.ProductKeys3P).Miro]: {
        containerId: 'e37bcd89-df89-4e65-90f9-98a92fa2dbd0_7c1ec941-d9e7-40be-96fb-69fae6b6bfd2',
        serviceKey: 'miro'
    },
    [(0, $78z3f.ProductKeys3P).Hubspot]: {
        containerId: 'aca58c62-2fb0-4abc-93f0-08bc704ab82a_c39eff84-66f8-4fa9-bb75-768ac83b5f6d',
        serviceKey: 'hubspot'
    },
    [(0, $78z3f.ProductKeys3P).Notion]: {
        containerId: '60913f14-f7e5-465a-9df7-a5f7974caad6_80617f98-fa46-4b5e-9c8e-a54bc42b7c3e',
        serviceKey: 'notion'
    },
    [(0, $78z3f.ProductKeys3P).Sentry]: {
        containerId: '59ec4558-3649-433e-a6b9-7964ae040b78_39660d3a-f2c9-446a-9a53-db433bbc7c2d',
        serviceKey: 'sentry'
    },
    [(0, $78z3f.ProductKeys3P).PagerDuty]: {
        containerId: '2db77a65-0037-45ea-9f57-642051d86ff5_dd18e9a6-e52a-4b80-9a2f-1aa487c9f747',
        serviceKey: 'pagerduty'
    },
    [(0, $78z3f.ProductKeys3P).Salesforce]: {
        containerId: 'd62184e4-87e4-41b2-9321-8b3c1dede9d7_433a0c54-84d5-41ee-9c21-684887b34330',
        serviceKey: 'salesforce'
    },
    [(0, $78z3f.ProductKeys3P).Amplitude]: {
        containerId: '953d4aed-a528-4a5e-9f84-fe42741063f5_eed898af-fb54-4a76-ba73-8d6261639a1a',
        serviceKey: 'amplitude'
    },
    [(0, $78z3f.ProductKeys3P).Lucid]: {
        containerId: 'd188e82f-311c-429d-a17f-bde97037890e_937a3756-c797-4f04-bde1-3eba582b91cf',
        serviceKey: 'lucid'
    },
    [(0, $78z3f.ProductKeys3P).Zeplin]: {
        containerId: '2e14b294-385f-4d3c-a0a0-3e29e1f3a30b_f156da1b-5880-4fc1-ae67-2581ab8fda87',
        serviceKey: 'zeplin'
    },
    [(0, $78z3f.ProductKeys3P).Todoist]: {
        containerId: '6ff1e497-21ac-4f8e-ac74-b869e2c3f274_0f5c1a58-fdae-41ae-841d-2bc5a2875c38',
        serviceKey: 'todoist'
    },
    [(0, $78z3f.ProductKeys3P).Stripe]: {
        containerId: '48824814-f7d3-465a-9535-f589940c8e5a_8a330cd4-3af2-4c32-8c8e-8e751a3fad8a',
        serviceKey: 'stripe'
    },
    [(0, $78z3f.ProductKeys3P).AzureDevops]: {
        // containerId sourced from the canonical Confluence page
        // (page id 6649924469). serviceKey assumed identical to prod —
        // ai-3p-connector's application-staging.yml does NOT declare a
        // per-provider serviceKey for Azure DevOps, but every other
        // provider in this file uses the same serviceKey across both
        // environments, so the prod value is the safe assumption.
        containerId: '784f3542-1a1d-4f49-8769-f3c2cb1e83b3_b91efd28-4d10-43d4-bcae-a5b0fef72bb1',
        serviceKey: 'azuredevops'
    },
    [(0, $78z3f.ProductKeys3P).Webex]: {
        // containerId sourced from the canonical Confluence page
        // (page id 6649924469). serviceKey assumed identical to prod
        // (see note on AzureDevops above).
        containerId: 'ead13644-c3c5-4f8d-8d31-58be86dc7c8e_cedff546-1b81-4f3c-b65d-30c4cb2d8c61',
        serviceKey: 'webex'
    }
};
const $0de16cf0cbdeac18$var$ATLASSIAN_ID_BASE_URLS = {
    prod: 'https://id.atlassian.com',
    staging: 'https://id.stg.internal.atlassian.com'
};
const $0de16cf0cbdeac18$var$CONTAINER_MAPS = {
    prod: $0de16cf0cbdeac18$export$860f54a43e361c13,
    staging: $0de16cf0cbdeac18$export$e25d6f2386134a66
};
const $0de16cf0cbdeac18$var$isProdHostname = ()=>{
    if (typeof window === 'undefined' || !window.location) return true;
    return window.location.hostname.endsWith('.atlassian.net');
};
const $0de16cf0cbdeac18$var$getEnvFromHostname = ()=>$0de16cf0cbdeac18$var$isProdHostname() ? 'prod' : 'staging';
const $0de16cf0cbdeac18$export$d73c6d475285293 = (payload)=>{
    if (!payload || !Array.isArray(payload.containers) || payload.containers.length === 0) return null;
    const prodUuids = new Set(Object.values($0de16cf0cbdeac18$export$860f54a43e361c13).map((m)=>m?.containerId));
    const stagingUuids = new Set(Object.values($0de16cf0cbdeac18$export$e25d6f2386134a66).map((m)=>m?.containerId));
    let prodHits = 0;
    let stagingHits = 0;
    for (const c of payload.containers){
        const id = c.container?.containerId;
        if (!id) continue;
        if (prodUuids.has(id)) prodHits++;
        if (stagingUuids.has(id)) stagingHits++;
    }
    if (prodHits === 0 && stagingHits === 0) return null;
    return prodHits >= stagingHits ? 'prod' : 'staging';
};
const $0de16cf0cbdeac18$var$getAtlassianIdBaseUrl = (env)=>$0de16cf0cbdeac18$var$ATLASSIAN_ID_BASE_URLS[env];
const $0de16cf0cbdeac18$var$getContainerMap = (env)=>$0de16cf0cbdeac18$var$CONTAINER_MAPS[env];
const $0de16cf0cbdeac18$export$50ff30f26c11fe5f = async (aaId, { forceRefresh: forceRefresh = false } = {})=>{
    if (!aaId) return null;
    try {
        const response = await (0, $abk4V.fetchAccountsByAaId)({
            aaid: aaId,
            // When `forceRefresh` is true, bypass the cache (always hit the
            // gateway). Otherwise, prefer cached values over the network when
            // they are still warm — the post-office banner re-mounts on most
            // navigation events and we don't want to thrash the gateway.
            onlyRefreshIfExpired: !forceRefresh,
            returnExpired: true
        });
        if (!response || !Array.isArray(response.containers)) return null;
        return response;
    } catch  {
        return null;
    }
};
const $0de16cf0cbdeac18$export$6d3a2e8837b79055 = (payload, productKey, env)=>{
    if (!payload || !Array.isArray(payload.containers) || payload.containers.length === 0) return false;
    // Prefer the env we detect from the payload itself (deterministic — the
    // gateway can only return UUIDs from one env at a time). Fall back to
    // hostname-based detection only if the payload contains no recognised
    // UUIDs in either map (defensive — should be unreachable since the
    // gateway always returns at least the user's atlassian-token-service-key
    // container, plus any Smart Link grants).
    const resolvedEnv = env ?? $0de16cf0cbdeac18$export$d73c6d475285293(payload) ?? $0de16cf0cbdeac18$var$getEnvFromHostname();
    const mapping = $0de16cf0cbdeac18$var$getContainerMap(resolvedEnv)[productKey];
    if (!mapping) return false;
    const matchingContainer = payload.containers.find((c)=>c.container?.containerId === mapping.containerId);
    if (!matchingContainer) return false;
    const services = Array.isArray(matchingContainer.services) ? matchingContainer.services : [];
    // Filter services by the expected serviceKey. For unique-container
    // providers this is a no-op (one service per container). For shared
    // containers it ensures we only look at accounts owned by the right
    // service.
    const matchingServices = services.filter((s)=>s.service?.serviceKey === mapping.serviceKey);
    return matchingServices.some((s)=>(Array.isArray(s.accounts) ? s.accounts : []).some((account)=>account.status === 'available'));
};
const $0de16cf0cbdeac18$export$8acaf25597d6f4b9 = (productKey, env)=>{
    const resolvedEnv = env ?? $0de16cf0cbdeac18$var$getEnvFromHostname();
    const mapping = $0de16cf0cbdeac18$var$getContainerMap(resolvedEnv)[productKey];
    if (!mapping) return null;
    const baseUrl = $0de16cf0cbdeac18$var$getAtlassianIdBaseUrl(resolvedEnv);
    const params = new URLSearchParams({
        serviceKey: mapping.serviceKey,
        containerId: mapping.containerId
    });
    if (mapping.defaultScopes?.length) params.set('scopes', mapping.defaultScopes.join(' '));
    // URLSearchParams encodes spaces as '+'; gateway expects RFC 3986 '%20'.
    return `${baseUrl}/outboundAuth/start?${params.toString().replace(/\+/g, '%20')}`;
};
const $0de16cf0cbdeac18$export$27e6019a895f8241 = (productKey, env)=>{
    const resolvedEnv = env ?? $0de16cf0cbdeac18$var$getEnvFromHostname();
    return Boolean($0de16cf0cbdeac18$var$getContainerMap(resolvedEnv)[productKey]);
};
module.exports["detectEnvFromPayload"] = $0de16cf0cbdeac18$export$d73c6d475285293;
module.exports["fetchOutboundAuthAccounts"] = $0de16cf0cbdeac18$export$50ff30f26c11fe5f;
module.exports["isAuthenticatedForProduct"] = $0de16cf0cbdeac18$export$6d3a2e8837b79055;
module.exports["buildSmartLinkAuthUrl"] = $0de16cf0cbdeac18$export$8acaf25597d6f4b9;
module.exports["hasSmartLinkContainerMapping"] = $0de16cf0cbdeac18$export$27e6019a895f8241;

});

parcelRegister("bHjhd", function(module, exports) {

var $kiOFr = parcelRequire("kiOFr");

const $89598f5ca555d4d3$export$7fa7ed95afa3407a = (cloudId, gatewayBaseUrl)=>{
    const { data: data, loading: loading, error: error } = (0, $kiOFr.useAvailableSites)({
        gatewayBaseUrl: gatewayBaseUrl
    });
    const filterData = data.filter((site)=>site.cloudId === cloudId);
    if (filterData.length > 0) return {
        data: filterData[0].url,
        loading: loading,
        error: error
    };
    return {
        data: undefined,
        loading: loading,
        error: error
    };
};
module.exports["useCloudIdToUrl"] = $89598f5ca555d4d3$export$7fa7ed95afa3407a;

});

parcelRegister("idEgG", function(module, exports) {

var $aE5mL = parcelRequire("aE5mL");

function $b1b404c2594d42b3$export$b6f8db3ad0711b02(state) {
    switch(state){
        case (0, $aE5mL.State).PREQUERY_RESULTS:
            return 'preQuerySearchResults';
        case (0, $aE5mL.State).PREQUERY_LOADING:
            return 'preQueryLoadingSearchResults';
        case (0, $aE5mL.State).POSTQUERY_LOADING:
            return 'cachedResults';
        case (0, $aE5mL.State).POSTQUERY_RESULTS:
            return 'postQuerySearchResults';
        default:
            return '';
    }
}
module.exports["getActionSubjectId"] = $b1b404c2594d42b3$export$b6f8db3ad0711b02;

});

parcelRegister("8wHiG", function(module, exports) {
const $509ad88fe26d8e96$export$b2c60dba9a3fd739 = (event, data)=>{
    if (!event) return false;
    // cmd/ctrl/shift click typically indicates the user intends to open in a new tab/window.
    const isModifiedClick = event.ctrlKey || event.metaKey || event.shiftKey;
    // Middle click (f.e. scroll-wheel) is a common "open in new tab" interaction.
    const isAuxClick = event.type === 'auxclick' || data?.isAuxClick === true;
    return isModifiedClick || isAuxClick;
};
module.exports["isOpenInNewTabInteraction"] = $509ad88fe26d8e96$export$b2c60dba9a3fd739;

});

parcelRegister("1tkBc", function(module, exports) {
/**
 * Returns pathname for reliable comparisons (excluding query params).
 * @param urlOrPath URL string
 * @returns pathname
 */ const $aa66f375dc0c6970$export$b829272b1dcc6798 = (urlOrPath)=>{
    const url = new URL(urlOrPath, window.location.origin);
    return url.pathname;
};
module.exports["getPathname"] = $aa66f375dc0c6970$export$b829272b1dcc6798;

});

parcelRegister("1Ajko", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::432ea26d62f26515b4626718ca47f05c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1278255a56286459$var$_react = $1278255a56286459$var$_interopRequireDefault((parcelRequire("42omo")));

var $1278255a56286459$var$_baseNew = $1278255a56286459$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1278255a56286459$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cursor".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Selecting the cursor in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1278255a56286459$var$CursorIcon = (props)=>/*#__PURE__*/ $1278255a56286459$var$_react.default.createElement($1278255a56286459$var$_baseNew.default, Object.assign({
        name: "CursorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.827 2.827 6.914 13.23l1.272-4.134c.134-.436.474-.776.91-.91l4.134-1.272zm-1.5.282C.886 1.99 1.99.887 3.108 1.326L14.11 5.648c1.21.476 1.145 2.212-.099 2.594L9.6 9.6l-1.358 4.412c-.382 1.244-2.118 1.31-2.594.099z" clip-rule="evenodd"/>`
    }, props));
$1278255a56286459$var$CursorIcon.displayName = 'CursorIcon';
var $1278255a56286459$var$_default = module.exports.default = $1278255a56286459$var$CursorIcon;

});

parcelRegister("3M2Ci", function(module, exports) {

var $6CCa2 = parcelRequire("6CCa2");

const $3f60566858983282$export$d2ecfcb20099e313 = (rotations, locale, existingGhostTextData)=>{
    if (rotations.length === 0) return {
        id: '',
        locale: locale,
        text: '',
        occurrence: 0
    };
    // Find current position by id
    let currentIndex = 0;
    let currentOccurrence = 0;
    if (existingGhostTextData) {
        const foundIndex = rotations.findIndex((r)=>r.id === existingGhostTextData.id);
        if (foundIndex >= 0) {
            currentIndex = foundIndex;
            currentOccurrence = existingGhostTextData.occurrence ?? 0;
        }
    }
    // Check if we need to rotate to next text
    const newOccurrence = currentOccurrence + 1;
    if (newOccurrence >= (0, $6CCa2.ROTATION_THRESHOLD)) {
        // Move to next text, reset occurrence
        const nextIndex = (currentIndex + 1) % rotations.length;
        return {
            id: rotations[nextIndex].id,
            locale: locale,
            text: rotations[nextIndex].text,
            occurrence: 0
        };
    }
    // Keep current text, increment occurrence
    return {
        id: rotations[currentIndex].id,
        locale: locale,
        text: rotations[currentIndex].text,
        occurrence: newOccurrence
    };
};
module.exports["selectGhostText"] = $3f60566858983282$export$d2ecfcb20099e313;

});

parcelRegister("ef802", function(module, exports) {

var $5JS4G = parcelRequire("5JS4G");

const $1cdbdbc60364a70d$export$782ebc7c03980a9a = async (aaid, containerId, serviceKey)=>{
    const queryParams = new URLSearchParams();
    if (serviceKey) {
        queryParams.append('serviceKey', serviceKey);
        // include=aaId - This bypasses token refresh and profile fetching operations. Adding include=accessToken can trigger token refresh from external providers, and omitting this include query parameter would result in displayName and avatarUrl being added by default to includeFields, which can trigger external API calls for profile data.
        queryParams.append('include', 'aaid');
    }
    const queryString = queryParams.toString();
    const url = `/gateway/api/outbound-auth/aaId/${aaid}/container/${containerId}${queryString ? `?${queryString}` : ''}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new (0, $5JS4G.OutboundAuthApiError)('Failed to fetch outbound auth by aaid and container id');
    return await response.json();
};
module.exports["fetchOutboundAuthDataInternal"] = $1cdbdbc60364a70d$export$782ebc7c03980a9a;

});

parcelRegister("5L4ws", function(module, exports) {
const $7d2f8846d610de2b$export$aa68fd26e593cc7e = (variables)=>{
    const { siteId: siteId, orgId: orgId, query: query, experience: experience, model: model, includePatternType: includePatternType } = variables;
    const parts = [
        siteId,
        orgId,
        query,
        experience
    ];
    if (model) parts.push(model);
    parts.push(`includePatternType=${includePatternType}`);
    return parts.join(':');
};
module.exports["createCacheKey"] = $7d2f8846d610de2b$export$aa68fd26e593cc7e;

});

parcelRegister("3wZIu", function(module, exports) {

var $hw4j5 = parcelRequire("hw4j5");

const $c415799b89930844$export$56db430dd07e9e8c = (0, $hw4j5.inMemoryCache)();
module.exports["intentDetectionCache"] = $c415799b89930844$export$56db430dd07e9e8c;

});

parcelRegister("aE5mL", function(module, exports) {
const $7c0d6974c60a6f80$export$7254cc27399e90bd = {
    PREQUERY_ERROR: 'PREQUERY_ERROR',
    PREQUERY_LOADING: 'PREQUERY_LOADING',
    PREQUERY_NO_RESULTS: 'PREQUERY_NO_RESULTS',
    PREQUERY_RESULTS: 'PREQUERY_RESULTS',
    POSTQUERY_ERROR: 'POSTQUERY_ERROR',
    POSTQUERY_LOADING: 'POSTQUERY_LOADING',
    POSTQUERY_NO_RESULTS: 'POSTQUERY_NO_RESULTS',
    POSTQUERY_RESULTS: 'POSTQUERY_RESULTS'
};
const $7c0d6974c60a6f80$export$bbc0e9ab60a7c746 = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_ERROR || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$f33d0292f2f7a82a = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_ERROR || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$3d387094581134ab = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$de6adf92470c6d4 = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING;
};
const $7c0d6974c60a6f80$export$8984dd36dcb68400 = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_ERROR || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_ERROR;
};
module.exports["State"] = $7c0d6974c60a6f80$export$7254cc27399e90bd;
module.exports["isPreQueryState"] = $7c0d6974c60a6f80$export$bbc0e9ab60a7c746;
module.exports["isPostQueryState"] = $7c0d6974c60a6f80$export$f33d0292f2f7a82a;
module.exports["isPostQueryLoadingOrResults"] = $7c0d6974c60a6f80$export$3d387094581134ab;
module.exports["isLoadingState"] = $7c0d6974c60a6f80$export$de6adf92470c6d4;
module.exports["isNotResultsState"] = $7c0d6974c60a6f80$export$8984dd36dcb68400;

});


//# sourceMappingURL=QuickFind.36cf63d4.js.map
